/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(11);
	
	__webpack_require__(13);
	
	__webpack_require__(17);
	
	__webpack_require__(18);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _elements = __webpack_require__(4);
	
	var _inViewport = __webpack_require__(5);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debouncedCancelMoveNav = (0, _lodash.debounce)(cancelMoveNav, 500);
	
	var lastScrollTop = 0;
	var scrolling = void 0;
	
	startAnimation();
	_windowDimensions2.default.onResize(moveNav);
	_windowDimensions2.default.onResize(setFixedInnerHeight);
	
	function onScroll() {
	    debouncedCancelMoveNav();
	
	    if (scrolling) {
	        return;
	    }
	
	    scrolling = true;
	    startAnimation();
	}
	
	function startAnimation() {
	    window.requestAnimationFrame(onTick);
	}
	
	function onTick() {
	    var scrollTop = window.pageYOffset;
	    scrollTop = scrollTop < 0 ? 0 : scrollTop;
	
	    if (scrollTop !== lastScrollTop) {
	        lastScrollTop = scrollTop;
	        moveNav();
	    }
	
	    if (!scrolling) {
	        return;
	    }
	
	    window.requestAnimationFrame(onTick);
	}
	
	function moveNav() {
	    var visible = (0, _inViewport2.default)(_elements.articles, lastScrollTop, _windowDimensions2.default.height);
	
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        var isVisible = visible.indexOf(article) !== -1,
	            offset = article.offset - lastScrollTop,
	            height = _windowDimensions2.default.height - offset,
	            clipped = offset > 0;
	
	        var css = {
	            visibility: isVisible ? 'visible' : 'hidden',
	            height: clipped ? height + 'px' : '',
	            top: clipped ? 'auto' : ''
	        };
	
	        applyCss(article, css);
	    });
	}
	
	function cancelMoveNav() {
	    scrolling = false;
	}
	
	function applyCss(article, css) {
	    if ((0, _lodash.isEqual)(article.css, css)) {
	        return;
	    }
	
	    article.css = css;
	
	    (0, _lodash.forEach)(css, function (value, property) {
	        article.fixed.style[property] = value;
	    });
	}
	
	function setFixedInnerHeight() {
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        article.fixed.children[0].style.height = _windowDimensions2.default.height + 'px';
	    });
	}
	
	window.addEventListener('scroll', onScroll);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)(module), (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reCalc = exports.backgrounds = exports.images = exports.articles = undefined;
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var articles = _lodash2.default.map(document.getElementsByTagName('article'), buildArticlesObject);
	var images = _lodash2.default.map(document.getElementsByClassName('image'), buildImageObject);
	var backgrounds = _lodash2.default.compact(_lodash2.default.map(articles, buildBackgroundObject));
	
	window.addEventListener('load', updateOffsets);
	window.addEventListener('resize', _lodash2.default.debounce(updateOffsets, 20));
	document.addEventListener('typekitLoaded', updateOffsets);
	
	exports.articles = articles;
	exports.images = images;
	exports.backgrounds = backgrounds;
	exports.reCalc = updateOffsets;
	
	
	function buildArticlesObject($article) {
	    return {
	        el: $article,
	        fixed: $article.getElementsByClassName('fixed')[0]
	    };
	}
	
	function buildImageObject($image) {
	    return {
	        el: $image,
	        path: $image.getAttribute('data-src')
	    };
	}
	
	function buildBackgroundObject(article) {
	    var $el = article.el.getElementsByClassName('fixed-inner')[0];
	    var imageObject = _lodash2.default.assign({
	        article: article,
	        background: true
	    }, buildImageObject($el));
	    return imageObject.path && imageObject;
	}
	
	function updateOffsets() {
	    updateArticlesOffsets();
	    updateImagesOffsets();
	    updateBackgroundOffsets();
	}
	
	function updateArticlesOffsets() {
	    _lodash2.default.forEach(articles, function (article) {
	        article.offset = article.el.offsetTop;
	    });
	}
	
	function updateImagesOffsets() {
	    _lodash2.default.forEach(images, function (image) {
	        image.hidden = !image.el.offsetParent;
	        image.offset = image.el.offsetParent && image.el.offsetParent.offsetTop + image.el.offsetTop;
	    });
	}
	
	function updateBackgroundOffsets() {
	    _lodash2.default.forEach(backgrounds, function (background) {
	        background.offset = background.article.offset;
	    });
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (elements, scrollPos, offset) {
	    var inViewport = [];
	
	    for (var i = elements.length - 1; i >= 0; i--) {
	        if (!elements[i].hidden) {
	            if (elements[i].offset < scrollPos) {
	                inViewport.push(elements[i]);
	                break;
	            }
	
	            if (elements[i].offset < scrollPos + offset) {
	                inViewport.push(elements[i]);
	            }
	        }
	    }
	
	    return inViewport;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	var _elements = __webpack_require__(4);
	
	var callbacks = [];
	
	var win = {
	    width: window.innerWidth,
	    height: window.innerHeight,
	    onResize: function onResize(callback) {
	        callbacks.push(callback);
	    },
	    reflow: resizeHandler
	};
	
	exports.default = win;
	
	
	window.addEventListener('resize', resizeHandler);
	
	function resizeHandler(event) {
	    win.width = window.innerWidth;
	    win.height = window.innerHeight;
	    (0, _elements.reCalc)();
	    (0, _lodash.forEach)(callbacks, function (callback) {
	        callback(event);
	    });
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// init
	
	setLanguage(window.localStorage.getItem('language') || (window.navigator.language.indexOf('de') !== -1 ? 'de' : 'en'));
	
	(0, _lodash.forEach)(document.getElementsByClassName('language-switch'), addListeners);
	
	function setLanguage(language) {
	    document.documentElement.setAttribute('lang', language);
	    window.localStorage.setItem('language', language);
	    _windowDimensions2.default.reflow();
	}
	
	function addListeners(element) {
	    element.addEventListener('click', function (event) {
	        setLanguage(event.target.getAttribute('data-lang'));
	    });
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _inViewport = __webpack_require__(5);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	var _loadImage = __webpack_require__(9);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_windowDimensions2.default.onResize(setPicSrc);
	window.addEventListener('scroll', setPicSrc);
	setPicSrc();
	
	function setPicSrc() {
	    _lodash2.default.forEach((0, _inViewport2.default)(_elements.backgrounds, window.pageYOffset, _windowDimensions2.default.height * 4), _loadImage2.default);
	    _lodash2.default.forEach((0, _inViewport2.default)(_elements.images, window.pageYOffset, _windowDimensions2.default.height * 2), _loadImage2.default);
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (image) {
	    var url = (0, _getImageUrl2.default)(image);
	
	    if (url === image.url) {
	        return;
	    }
	
	    image.url = url;
	
	    var loadIndicator = document.createElement('img');
	    loadIndicator.addEventListener('load', setSrc);
	    loadIndicator.src = url;
	    image.el.classList.add('is-loading');
	
	    function setSrc() {
	        image.el.style.backgroundImage = 'url(' + url + ')';
	        image.el.classList.remove('is-loading');
	        loadIndicator.removeEventListener('load', setSrc);
	    }
	};
	
	var _getImageUrl = __webpack_require__(10);
	
	var _getImageUrl2 = _interopRequireDefault(_getImageUrl);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sizes = [400, 800, 1200, 1600, 2000];
	var breakPoints = [{
	    size: 600,
	    ratio: 1
	}, {
	    size: 900,
	    ratio: 0.75
	}, {
	    ratio: 0.375
	}];
	
	exports.default = getUrl;
	
	
	function getCurrentSize(full) {
	    var width = full ? _windowDimensions2.default.width : getContentWidth() - 40;
	    return (0, _lodash.find)(sizes, function (size) {
	        return width * window.devicePixelRatio < size;
	    }) || (0, _lodash.last)(sizes);
	}
	
	function getUrl(image) {
	    var parts = image.path.split('.');
	    var name = parts[0];
	    var size = image.background ? '' : '-' + getCurrentSize(image.full);
	    var suffix = parts[1] || 'jpg';
	    return name + size + '.' + suffix;
	}
	
	function getContentWidth() {
	    var breakPoint = (0, _lodash.find)(breakPoints, function (point) {
	        return !point.size || point.size > _windowDimensions2.default.width;
	    });
	
	    return _windowDimensions2.default.width * breakPoint.ratio;
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _loadImage = __webpack_require__(9);
	
	var _loadImage2 = _interopRequireDefault(_loadImage);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _touch = __webpack_require__(12);
	
	var _touch2 = _interopRequireDefault(_touch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = _lodash2.default.isUndefined(document.body.style.transform) ? 'webkitTransform' : 'transform';
	
	var $viewer = document.createElement('div');
	var touch = (0, _touch2.default)($viewer);
	
	var current = void 0;
	var gallery = void 0;
	
	$viewer.classList.add('image-view');
	$viewer.addEventListener('click', hideImageViewer);
	document.body.appendChild($viewer);
	
	_windowDimensions2.default.onResize(initImageViewer);
	initImageViewer();
	
	touch.on('move', touchMoveHandler);
	touch.on('end', touchEndHandler);
	
	document.addEventListener('keydown', function (event) {
	    switch (event.keyCode) {
	        case 27:
	            hideImageViewer();
	            break;
	        case 37:
	            goToImage(-1);
	            break;
	        case 39:
	            goToImage(1);
	            break;
	    }
	});
	
	_lodash2.default.forEach(_elements.images, addListener);
	
	function addListener(image) {
	    image.el.addEventListener('click', function () {
	        showImage(_lodash2.default.find(gallery, 'trigger', image.el), image.url);
	        showImageViewer();
	    });
	}
	
	function touchMoveHandler(distance) {
	    $viewer.classList.remove('is-animating');
	
	    setViewerCss(convertToVw(distance));
	}
	
	function touchEndHandler(distance) {
	    $viewer.classList.add('is-animating');
	
	    var vw = convertToVw(distance);
	
	    if (vw > 20) {
	        goToImage(1);
	    } else if (vw < -20) {
	        goToImage(-1);
	    } else {
	        goToImage(0);
	    }
	}
	
	function convertToVw(distance) {
	    return distance / _windowDimensions2.default.width * 100;
	}
	
	function setViewerCss(offset) {
	    var vw = _lodash2.default.findIndex(gallery, current) * -100 - (offset ? offset : 0);
	
	    if (vw > 0 || vw < (gallery.length - 1) * -100) {
	        return;
	    }
	
	    $viewer.style[transform] = 'translateX(' + vw + 'vw)';
	}
	
	function goToImage(offset) {
	    if (!current) {
	        return;
	    }
	
	    var image = gallery[gallery.indexOf(current) + offset];
	
	    if (!image) {
	        return;
	    }
	
	    showImage(image);
	}
	
	function showImage(image, oldUrl) {
	    if (oldUrl) {
	        image.url = oldUrl;
	        image.el.style.backgroundImage = 'url(' + oldUrl + ')';
	    }
	
	    current = image;
	    (0, _loadImage2.default)(image);
	    loadAround(image);
	
	    setViewerCss();
	}
	
	function initImageViewer(event) {
	    if (event) {
	        return;
	    }
	
	    while ($viewer.firstChild) {
	        $viewer.removeChild($viewer.firstChild);
	    }
	
	    gallery = visibleImages().map(function (image) {
	        var newImage = _lodash2.default.clone(image);
	        newImage.trigger = image.el;
	        newImage.el = document.createElement('div');
	        newImage.el.classList.add('image');
	        newImage.full = true;
	        delete newImage.url;
	
	        $viewer.appendChild(newImage.el);
	
	        return newImage;
	    });
	}
	
	function showImageViewer() {
	    $viewer.classList.add('is-active');
	    document.body.classList.add('no-scroll');
	}
	
	function hideImageViewer() {
	    current = null;
	    $viewer.classList.remove('is-active', 'is-animating');
	    document.body.classList.remove('no-scroll');
	}
	
	function visibleImages() {
	    return _elements.images.filter(function (image) {
	        return !image.hidden;
	    });
	}
	
	function loadAround(image) {
	    var index = gallery.indexOf(image);
	
	    if (index === -1) {
	        return;
	    }
	
	    [index - 1, index + 1].forEach(function (i) {
	        if (!gallery[i]) {
	            return;
	        }
	
	        (0, _loadImage2.default)(gallery[i]);
	    });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(2);
	
	exports.default = touchHandler;
	
	
	function touchHandler(el) {
	    var callbacks = {};
	
	    var currentTouch = void 0;
	    var currentX = void 0;
	
	    el.addEventListener('touchstart', startHandler);
	    el.addEventListener('touchmove', moveHandler);
	    el.addEventListener('touchleave', endHandler);
	    el.addEventListener('touchend', endHandler);
	    el.addEventListener('touchcancel', endHandler);
	
	    function startHandler(event) {
	        if (currentTouch) {
	            return;
	        }
	
	        currentTouch = event.changedTouches[0];
	        currentX = currentTouch.clientX;
	    }
	
	    function moveHandler(event) {
	        event.preventDefault();
	
	        var touch = findTouch(event.touches, currentTouch);
	
	        if (!touch) {
	            return;
	        }
	
	        callback('move', currentX - touch.clientX);
	    }
	
	    function endHandler(event) {
	        var touch = findTouch(event.changedTouches, currentTouch);
	
	        if (!touch) {
	            return;
	        }
	
	        callback('end', currentX - touch.clientX);
	        currentTouch = null;
	    }
	
	    function registerHandler(type, fn) {
	        callbacks[type] = fn;
	    }
	
	    function callback(type, value) {
	        if (callbacks[type]) {
	            callbacks[type](value);
	        }
	    }
	
	    return {
	        on: registerHandler
	    };
	}
	
	function findTouch(touches, touch) {
	    return (0, _lodash.findWhere)(touches, { identifier: touch.identifier });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _d = __webpack_require__(14);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _topojsonClient = __webpack_require__(15);
	
	var topojson = _interopRequireWildcard(_topojsonClient);
	
	var _lodash = __webpack_require__(2);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _elements = __webpack_require__(4);
	
	var _mapProvider = __webpack_require__(16);
	
	var _mapProvider2 = _interopRequireDefault(_mapProvider);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapData = JSON.parse(_mapProvider2.default);
	var subMap = _elements.articles[0].fixed.getElementsByTagName('svg')[1];
	
	var map = {
	    world: mapData.map,
	    svg: _d2.default.select('#map'),
	    $stops: document.getElementsByClassName('stop'),
	    stops: {}
	};
	
	_lodash2.default.assign(map, getSize());
	
	map.projection = _d2.default.geo.mercator().translate([0, 0]).scale(1);
	
	map.path = _d2.default.geo.path().projection(map.projection);
	
	map.svg.append('path').datum(topojson.feature(map.world, map.world.objects.countries)).attr('d', map.path).attr('class', 'country');
	
	map.svg.append('path').datum(topojson.mesh(map.world, map.world.objects.countries, function (a, b) {
	    return a !== b;
	})).attr('d', map.path).attr('class', 'border');
	
	setRoute(mapData.route);
	
	function setRoute(path) {
	    var feature = topojson.feature(path, path.objects.route);
	
	    map.bounds = map.path.bounds(feature);
	
	    map.svg.append('path').datum(feature).attr('d', map.path).attr('class', 'route');
	
	    refreshMap();
	}
	
	window.addEventListener('resize', _lodash2.default.debounce(resize, 500));
	
	function setStop(el) {
	    var id = el.getAttribute('data-for');
	    if (map.stops[id]) {
	        var pos = map.projection(map.stops[id]);
	        el.style.top = pos[1] + 'px';
	        el.style.left = pos[0] + 'px';
	    }
	}
	
	function resize() {
	    _lodash2.default.assign(map, getSize());
	
	    refreshMap();
	}
	
	function getSize() {
	    var rect = subMap.getBoundingClientRect();
	
	    return {
	        width: rect.width,
	        height: rect.height
	    };
	}
	
	function refreshMap() {
	    if (!map.bounds) {
	        return;
	    }
	
	    var b = map.bounds,
	        s = 0.9 / Math.max((b[1][0] - b[0][0]) / map.width, (b[1][1] - b[0][1]) / map.height),
	        t = [(map.width - s * (b[1][0] + b[0][0])) / 2, (map.height - s * (b[1][1] + b[0][1])) / 2];
	
	    map.projection.scale(s).translate(t);
	
	    map.svg.select('.country').attr('d', map.path);
	    map.svg.select('.border').attr('d', map.path);
	    map.svg.select('.route').attr('d', map.path);
	
	    _lodash2.default.forEach(map.$stops, setStop);
	}
	
	_lodash2.default.forEach(_elements.articles, function (article) {
	    var location = article.el.dataset.location.split(',').map(parseFloat);
	    var id = article.el.id;
	    map.stops[id] = location;
	    _lodash2.default.forEach(document.querySelectorAll('[data-for="' + id + '"]'), setStop);
	});

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client v3.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.topojson = global.topojson || {}));
	}(this, function (exports) { 'use strict';
	
	function identity(x) {
	  return x;
	}
	
	function transform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2, n = input.length, output = new Array(n);
	    output[0] = (x0 += input[0]) * kx + dx;
	    output[1] = (y0 += input[1]) * ky + dy;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function bbox(topology) {
	  var t = transform(topology.transform), key,
	      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	  function bboxPoint(p) {
	    p = t(p);
	    if (p[0] < x0) x0 = p[0];
	    if (p[0] > x1) x1 = p[0];
	    if (p[1] < y0) y0 = p[1];
	    if (p[1] > y1) y1 = p[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = -1, n = arc.length, p;
	    while (++i < n) {
	      p = t(arc[i], i);
	      if (p[0] < x0) x0 = p[0];
	      if (p[0] > x1) x1 = p[0];
	      if (p[1] < y0) y0 = p[1];
	      if (p[1] > y1) y1 = p[1];
	    }
	  });
	
	  for (key in topology.objects) {
	    bboxGeometry(topology.objects[key]);
	  }
	
	  return [x0, y0, x1, y1];
	}
	
	function reverse(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	}
	
	function feature(topology, o) {
	  if (typeof o === "string") o = topology.objects[o];
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	}
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k], k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p);
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	function stitch(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	}
	
	function mesh(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	}
	
	function meshArcs(topology, object, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	function merge(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	}
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    }).filter(function(arcs) {
	      return arcs.length > 0;
	    })
	  };
	}
	
	function bisect(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	}
	
	function neighbors(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	}
	
	function untransform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2,
	        n = input.length,
	        output = new Array(n),
	        x1 = Math.round((input[0] - dx) / kx),
	        y1 = Math.round((input[1] - dy) / ky);
	    output[0] = x1 - x0, x0 = x1;
	    output[1] = y1 - y0, y0 = y1;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function quantize(topology, transform) {
	  if (topology.transform) throw new Error("already quantized");
	
	  if (!transform || !transform.scale) {
	    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
	    box = topology.bbox || bbox(topology);
	    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
	    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
	  } else {
	    box = topology.bbox;
	  }
	
	  var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
	
	  function quantizePoint(point) {
	    return t(point);
	  }
	
	  function quantizeGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
	      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
	      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function quantizeArc(input) {
	    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
	    output[0] = t(input[0], 0);
	    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
	    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
	    output.length = j;
	    return output;
	  }
	
	  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
	
	  return {
	    type: "Topology",
	    bbox: box,
	    transform: transform,
	    objects: outputs,
	    arcs: topology.arcs.map(quantizeArc)
	  };
	}
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = "{\"map\":{\"type\":\"Topology\",\"objects\":{\"countries\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"MultiPolygon\",\"arcs\":[[[0,1]],[[2,3]],[[4,5,6,7,8,9,10,11,12,13,14,15,16,17]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[18]],[[19]]]},{\"type\":\"Polygon\",\"arcs\":[[20,21]]},{\"type\":\"Polygon\",\"arcs\":[[22,23,24,25,26,27,28,29,30,31]]},{\"type\":\"Polygon\",\"arcs\":[[32,33,34,35,36,37,38]]},{\"type\":\"Polygon\",\"arcs\":[[39,40,41,42,43,44]]},{\"type\":\"Polygon\",\"arcs\":[[45,46,47,48,49]]},{\"type\":\"Polygon\",\"arcs\":[[50,51,52,53,54]]},{\"type\":\"Polygon\",\"arcs\":[[55,56,57,-29,58,-27,59,60,61,62,63]]},{\"type\":\"Polygon\",\"arcs\":[[64,65,-32,66]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-57,67]],[[68,69]],[[70]],[[71]],[[72,73,-67,-31,74,-64,75,76,-33,77,78,79]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[-80,90]]]},{\"type\":\"Polygon\",\"arcs\":[[91,92,93,94,95,96,97,98]]},{\"type\":\"Polygon\",\"arcs\":[[99,100]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108,109]],[[110,111]],[[112]],[[113]],[[114]],[[115]],[[116,-21,117,118,119,120,121,122]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[123]],[[124]],[[125]],[[126]],[[127,128]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[129]],[[130]],[[131]],[[132]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[133]],[[134]],[[135]],[[136,-76,-63,137,-61,138,139,140,141,-118,-22,-117,142,-35],[-116]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[143]],[[144]],[[145]],[[146]],[[147]],[[148]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[149]],[[150]],[[151]],[[152,153]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[163]],[[164]],[[165]],[[166]],[[167]],[[168]],[[169]],[[170]],[[171]],[[172]],[[173]],[[174]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[175]]]},{\"type\":\"Polygon\",\"arcs\":[[-120,176]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[184]],[[185]],[[186]],[[187]],[[188]],[[189]],[[190]],[[191]],[[192]],[[193]],[[194]],[[195]],[[196]],[[197]],[[198]],[[199]],[[200]],[[201]],[[202]],[[203]],[[204]],[[205]],[[206]],[[207]],[[208]],[[209]],[[210]],[[211]],[[212]],[[213,-41,214,215,-14,216,-12,217]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[218]],[[219]],[[-48,220,221]],[[222]],[[223]],[[224]],[[225]],[[226]],[[227]],[[228]],[[229,230,-50,231,232]]]},{\"type\":\"Polygon\",\"arcs\":[[233,234,235,-230,236,-24,237]]},{\"type\":\"Polygon\",\"arcs\":[[238]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[239]],[[-153,240]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[241]],[[242]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[243]],[[244]],[[245]],[[246]],[[247,248,-139,-60,-26],[249],[250]]]},{\"type\":\"Polygon\",\"arcs\":[[251]]},{\"type\":\"Polygon\",\"arcs\":[[252,-5,253,254]]},{\"type\":\"Polygon\",\"arcs\":[[-100,255,-93,256,257]]},{\"type\":\"Polygon\",\"arcs\":[[-59,-28]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[258,259]],[[-53,260,261,262,263]]]},{\"type\":\"Polygon\",\"arcs\":[[-77,-137,-34]]},{\"type\":\"Polygon\",\"arcs\":[[-54,-264,264,-128,265]]},{\"type\":\"Polygon\",\"arcs\":[[-111,266,-109,267,-98,268,269]]},{\"type\":\"Polygon\",\"arcs\":[[270,-141]]},{\"type\":\"Polygon\",\"arcs\":[[271,272,273]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-10,274]],[[-42,-214,275,-2,276,-8,277,-6,-253,278]]]},{\"type\":\"Polygon\",\"arcs\":[[279,-95,280]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[281]]]},{\"type\":\"Polygon\",\"arcs\":[[282,-254,-18,283,-3,284,-16,285,-221,-47]]},{\"type\":\"Polygon\",\"arcs\":[[286,-96,-280,287]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-37,288]],[[289]],[[290]],[[291]],[[-78,-39,292],[293]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[294]],[[295]],[[296]],[[297]],[[298]],[[299]],[[300]],[[301]],[[302]],[[303]],[[304]],[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311,312]]]},{\"type\":\"Polygon\",\"arcs\":[[313,314,315,-261,-52,316,317,-65,-74,318,-69,319]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[320]],[[321,-122]]]},{\"type\":\"Polygon\",\"arcs\":[[-44,322,-235,323,-272,324]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[-316,325,-314,326,-259,327,-262]]]},{\"type\":\"Polygon\",\"arcs\":[[-97,-287,328,-269]]},{\"type\":\"Polygon\",\"arcs\":[[-250]]},{\"type\":\"Polygon\",\"arcs\":[[-323,-43,-279,-255,-283,-46,-231,-236]]},{\"type\":\"Polygon\",\"arcs\":[[329,-238,-23,-66,-318]]},{\"type\":\"Polygon\",\"arcs\":[[-233,330,-248,-25,-237]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[331]],[[332]],[[333]],[[334]],[[335]],[[336]],[[337]],[[-312,338]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[339]],[[340]],[[-257,-92,341]]]},{\"type\":\"MultiPolygon\",\"arcs\":[[[342]],[[-215,-40,343]],[[344]],[[345]]]},{\"type\":\"Polygon\",\"arcs\":[[-273,-324,-234,-330,-317,-51,346]]},{\"type\":\"Polygon\",\"arcs\":[[-251]]}]}},\"arcs\":[[[8762,4235],[-3,5]],[[8759,4240],[3,-5]],[[8442,4576],[2,4]],[[8444,4580],[-2,-4]],[[8583,4643],[18,-13],[17,-43],[49,-22],[23,-70],[-6,-18]],[[8684,4477],[-14,-34],[6,-39],[-17,-6],[19,-36],[-12,-21],[18,-52],[13,-6]],[[8697,4283],[3,-41],[15,-2]],[[8715,4240],[44,0]],[[8759,4240],[4,-12]],[[8763,4228],[0,-1]],[[8763,4227],[0,-14]],[[8763,4213],[11,-25]],[[8774,4188],[1,-2]],[[8775,4186],[-2,-35],[-20,-22],[-15,4],[-28,-47],[-10,-47],[-43,-6],[-25,-18],[18,-42],[-24,-4],[4,-18],[-23,-23],[-37,14]],[[8570,3942],[2,42],[-31,45],[-76,41],[-38,52],[25,-23],[13,30],[-34,52],[24,50],[20,18],[-16,20],[-1,29],[14,23],[-20,38],[31,48],[4,56],[-44,9]],[[8443,4472],[1,58]],[[8444,4530],[22,-6],[-1,19],[-22,22],[7,24]],[[8450,4589],[49,73],[18,0],[3,-32],[16,-8],[47,21]],[[8590,8952],[25,-22],[-40,9],[15,13]],[[8554,9019],[72,-22],[-24,-28],[-36,23],[14,-40],[-58,-5],[-23,47],[30,8],[4,-27],[24,23],[-3,21]],[[4902,4631],[-38,-18],[-22,15],[4,27]],[[4846,4655],[8,11],[51,-8],[-3,-27]],[[7957,6130],[-18,-62],[23,-43],[35,-43]],[[7997,5982],[-22,-39],[8,-33],[-53,-9],[-56,18],[-24,-20],[40,-8],[16,-23],[-10,-22],[-41,-13],[7,-29],[-12,-18],[14,-50],[-38,2],[-39,-36]],[[7787,5702],[-23,-9],[7,-32],[-77,5],[-34,-24],[-15,6],[-65,2],[-44,-12],[-9,-20],[-48,-34],[-34,14],[-51,0],[-14,11],[-73,9]],[[7307,5618],[-44,11],[-50,-4],[-34,12],[-48,2],[-91,26],[-21,39],[-31,29],[19,23],[-53,-10],[-39,-17],[-57,9],[-58,-11],[-35,-48],[-58,7],[-9,16],[-42,0]],[[6656,5702],[-18,33],[-47,-38],[-54,23],[-2,20],[-54,10]],[[6481,5750],[7,11],[-19,40]],[[6469,5801],[24,36],[-18,25]],[[6475,5862],[32,7]],[[6507,5869],[44,-2],[30,-26],[0,-17],[26,4],[-11,-25],[30,7],[29,34],[-7,33],[38,-4],[49,-16],[23,-24],[54,0],[35,27],[29,2],[14,19],[40,-4],[23,9],[45,-3],[3,26],[51,-4],[13,-14],[54,9],[3,-28],[31,-21],[21,6],[7,41],[-36,16],[19,30],[-48,56],[22,30],[110,44],[23,51],[39,-16],[18,26],[2,35]],[[7330,6170],[35,-16],[10,-25],[54,-11],[30,22],[47,-14],[21,46],[28,-3],[8,60],[59,-5],[82,-31],[27,3],[54,-33],[55,-3],[15,16],[42,-4],[46,-14],[14,-28]],[[5762,6657],[37,-33],[3,-32],[28,-1],[8,-41],[-44,-22],[-8,-26]],[[5786,6502],[-24,13],[-22,-16],[-35,-56],[35,-59],[-19,-25]],[[5721,6359],[-68,-9],[-10,25],[-23,5],[-64,43],[-22,-3],[-14,46],[16,40],[-38,-13],[-3,-20],[-40,-17],[-66,10],[15,22],[-17,16],[15,28],[-36,24],[-72,-5],[-7,36],[-27,13],[-45,1],[-9,45],[-19,18],[-49,-20],[-60,36],[4,29],[-17,31]],[[5065,6740],[121,59],[45,12]],[[5231,6811],[10,-34],[42,13],[64,-22],[38,17],[21,24]],[[5406,6809],[8,0]],[[5414,6809],[30,-4],[-7,22],[27,9],[29,-13],[15,15],[36,-24],[20,21],[41,-53],[56,7],[10,-17],[57,-15],[-21,-61],[-20,-14],[13,-22],[62,-3]],[[9999,4524],[-16,5],[-22,-22],[-63,-7],[-19,-35],[-31,-2],[-8,-25]],[[9840,4438],[-24,9],[-31,-11],[24,-65],[-13,-21],[-47,-13],[-14,9],[-24,-10],[-31,4],[-55,-19],[-29,20],[-49,21],[-20,-14],[-35,20],[-18,32],[-43,-11],[-12,11],[-36,-22],[-30,-1],[-59,-23],[-65,7],[-19,-18],[-55,2]],[[9155,4345],[3,60],[15,34],[-25,37],[-7,33],[-64,31],[-37,45]],[[9040,4585],[35,27],[-1,23],[-18,14],[12,40],[-12,18],[28,18],[33,0],[46,55],[5,22],[-17,5],[-33,40],[-43,23],[-9,40],[-25,41],[10,46],[39,18],[2,26],[18,14]],[[9110,5055],[68,-33],[-2,-16],[-30,-14],[-2,-28],[54,-3],[39,11],[32,-2],[133,-32],[70,12],[51,-15],[42,3],[58,-11],[30,-13],[76,19],[67,66],[44,14],[56,6],[83,23],[20,-9]],[[9999,5033],[0,-509]],[[8373,5212],[31,15],[40,-11],[-9,-36],[-40,-53],[2,-53],[34,-7],[11,-21],[50,-42],[-12,-9],[-65,-7],[47,-47],[6,-48],[-31,9],[-28,-18]],[[8409,4884],[-56,-5],[30,-50],[-15,-9],[-19,19],[-44,-24],[-12,-31],[4,-25],[-31,-2],[-10,-19],[7,-41],[16,-32],[-22,-19]],[[8257,4646],[-37,12],[-79,51],[-10,23],[-32,-6]],[[8099,4726],[-14,13]],[[8085,4739],[16,13],[-44,39],[-31,37],[-3,40],[-38,11],[-52,49],[-83,85],[-37,33],[-22,82],[-45,49],[-19,-5],[-16,24],[13,90],[46,13],[41,-46],[25,-6],[10,27],[28,25],[52,-10],[27,26],[53,-34],[16,10],[59,-17],[18,12],[39,-25],[35,20],[31,-11],[13,14],[50,-25],[38,8],[23,-22],[-4,-14],[23,-20],[26,1]],[[9999,6904],[-54,-2],[-38,13],[-45,1],[-7,11],[-47,2],[-19,11],[-62,5],[-84,0],[-34,7],[-92,-17],[-67,-1],[-23,-34],[-59,-38],[-51,15],[-22,-5],[-2,-27]],[[9293,6845],[-13,18],[4,41],[23,58],[-8,23],[-37,25],[-48,11],[-9,14],[45,54],[96,39],[11,18],[-6,101],[-19,22],[-42,91],[-21,80]],[[9269,7440],[31,-10],[106,15],[42,-18],[58,27],[28,-5],[-5,29],[14,13],[35,-5],[33,28],[58,13],[3,-33],[54,-2],[5,21],[-22,22],[-23,-7],[16,54],[19,13],[-3,52],[29,39],[47,4],[41,46],[54,-6],[45,37],[-72,16],[31,57],[-1,24]],[[9892,7864],[50,12],[28,27],[29,3]],[[9999,7906],[0,-1002]],[[6401,5901],[1,-1]],[[6402,5900],[2,-4]],[[6404,5896],[59,-41],[12,7]],[[6469,5801],[-9,-50],[21,-1]],[[6656,5702],[-17,-46],[17,-13],[-2,-20],[-28,2],[-23,20],[-33,-25],[2,-23],[19,-5],[6,-37],[-25,-11],[-16,34],[-50,-3],[-7,-13],[-32,4],[-16,45],[-38,-7],[5,-38],[-36,-41],[-22,-42],[17,-17],[-12,-19],[-21,1],[-8,32],[-18,5],[13,22],[-47,14],[-36,36],[4,40],[-20,3],[-54,-47],[8,-32],[-25,-32],[-32,-19],[-57,17],[-36,-20],[-55,-6],[-13,10]],[[5968,5471],[-34,50],[-16,3],[11,33],[-9,35]],[[5920,5592],[30,3],[-68,24],[-56,-18],[-19,-39]],[[5807,5562],[7,-18],[-23,-18],[-37,-3],[0,20],[27,8],[9,28],[-16,14],[12,41],[63,43],[2,45],[45,19],[16,24],[42,31],[18,23],[-36,4],[22,32],[41,0],[13,-16],[27,3],[42,38]],[[6081,5880],[15,-11],[31,13],[54,-8],[17,13],[37,-9],[20,14],[-13,16],[39,24],[64,-36],[56,5]],[[7529,6683],[35,0],[4,40],[53,-16],[15,-43],[20,5],[103,-27],[14,-20],[54,11],[23,-16],[-5,-18],[-39,-22],[30,-13],[72,-68],[24,23],[30,10],[-21,48],[65,-12],[28,-27],[56,-2],[26,6],[-5,-22],[-26,-11],[30,-13],[22,-30],[39,9],[52,-25],[53,0],[13,-49],[30,-8],[12,-40]],[[8336,6353],[-60,-7],[-30,-35],[-50,-26],[-13,-46],[-35,-13],[-3,-15],[-69,-30],[-74,12],[-29,-28],[-16,-35]],[[7330,6170],[-43,43],[-24,-1],[-39,40],[-22,4],[-36,44],[-44,9],[-30,26],[-27,57],[-20,21],[25,38],[-10,15],[-45,18],[-14,34],[-19,14],[14,17],[25,-34],[40,50],[70,16],[19,-9],[18,22],[30,1],[15,20],[43,4],[14,23],[60,8],[13,13],[93,26],[-21,25],[16,14],[31,-5],[29,-24],[-1,-19],[39,3]],[[6402,5900],[2,-4]],[[7408,7440],[-1,-16]],[[7407,7424],[-72,-6],[42,37],[-18,16],[-38,-11],[9,38],[78,-58]],[[6816,7573],[12,-16],[-35,-2],[-27,15],[24,16],[26,-13]],[[7245,7614],[14,-18],[35,3],[-8,-40],[34,-19],[-54,0],[-15,-28],[-62,25],[28,13],[4,23],[-21,17],[40,9],[12,-23],[19,8],[-47,30],[21,0]],[[6451,7654],[28,14],[49,-27],[20,8],[24,-31],[-2,-22],[-29,-28],[49,9],[17,-22],[21,9],[83,-33],[41,17],[39,2],[-12,-50],[-54,-22],[-4,-21],[21,-11],[58,13],[22,-19],[34,-8],[7,23],[34,35],[89,8],[45,29],[35,44],[64,-5],[-28,-16],[36,-7],[30,20],[21,-40],[35,-10],[37,-27],[45,6],[22,-11],[-12,-17],[32,-23],[-18,-22],[43,-24],[47,-14]],[[7420,7381],[6,-43],[23,-63],[-13,-55],[-40,-20],[-4,-27],[104,-67],[-21,-39],[9,-32],[23,-9],[-3,-32],[15,-11],[-14,-41],[-21,-26],[27,-32],[3,-39],[35,-11],[22,-49],[-14,-51],[-28,-51]],[[6507,5869],[-45,27],[-65,23],[4,-18]],[[6081,5880],[-15,25],[14,62],[6,59],[28,40],[12,67],[56,47],[22,37],[-54,18],[-57,0],[-34,29],[-42,-11],[-87,26],[-22,-14],[-34,42],[-9,25],[-33,7]],[[5832,6339],[2,30],[27,29],[2,25],[-56,22],[-21,29],[0,28]],[[5762,6657],[13,39],[-38,14],[55,45],[-16,20],[25,28],[0,40],[-19,34],[-30,20],[-3,21],[32,18],[58,-14],[73,18],[13,18],[-27,14],[70,49],[5,32],[-15,22],[-47,0],[-8,41],[64,2],[12,56],[23,35],[0,61]],[[6002,7270],[22,21],[-56,11],[12,52],[28,19],[146,14],[43,-46],[-22,-8],[41,-22],[12,24],[-13,23],[62,-14],[-16,29],[20,50],[20,5],[44,-14],[74,8],[59,-66],[-35,58],[-27,13],[-50,1],[-35,36],[33,-2],[-9,30],[-19,-6],[-4,32],[25,14],[-57,-11],[-11,25],[76,22],[-40,55],[-23,13],[-6,39]],[[6296,7675],[33,2],[74,-14],[10,-11],[38,2]],[[6817,7689],[67,-35],[27,16],[26,-32],[-18,-24],[-63,-5],[-91,39],[22,11],[-7,29],[37,1]],[[7074,7700],[1,-11],[-46,0],[-40,-12],[37,34],[48,-11]],[[6523,7720],[33,-16],[22,-33],[-57,9],[3,24],[-34,11],[33,5]],[[6733,7685],[-21,-45],[-19,14],[11,30],[52,54],[-23,-53]],[[7545,7758],[53,-25],[-16,-34],[-78,26],[15,51],[26,-18]],[[6633,7849],[30,-14],[-14,-23],[37,9],[0,30],[28,-31],[-17,-8],[27,-23],[4,-31],[-19,-42],[-36,-8],[-67,16],[-65,39],[-14,45],[-27,13],[42,5],[91,23]],[[7082,7837],[-12,16],[18,20],[13,-24],[-19,-12]],[[7032,7977],[57,-20],[-21,-31],[18,-52],[-81,-54],[48,-30],[6,-18],[-57,-16],[-16,-21],[10,-36],[-49,4],[-5,-17],[42,-10],[16,-15],[-42,-36],[1,-30],[-20,22],[8,15],[-39,56],[34,7],[-47,50],[-81,8],[-28,30],[19,14],[-22,34],[0,32],[-29,17],[39,-4],[45,12],[23,19],[0,25],[33,0],[29,-59],[33,37],[28,-30],[-14,52],[-35,1],[80,45],[17,-1]],[[6346,8181],[-6,-37],[-46,-31],[-21,27],[21,26],[52,15]],[[6803,8272],[-33,-31],[-31,13],[15,13],[49,5]],[[6296,7675],[4,58],[-39,-16],[-3,27],[44,-9],[-10,63],[-48,22],[-27,23],[-5,-15],[-30,11],[20,61],[39,19],[-21,45],[-36,6],[6,21],[-2,91],[11,29],[33,-21],[79,-25],[1,37],[43,41],[58,-14],[-16,37],[24,24],[37,8],[28,-14],[16,17],[46,5],[-24,12],[-111,-26],[-26,14],[-82,-25],[-43,-40],[24,-41],[-14,-8],[-34,21],[-25,32],[68,73],[40,-1],[39,14],[87,1],[32,19],[42,54],[37,32],[46,2],[73,37],[-26,-44],[23,-33],[-1,-49],[-19,-13],[-36,-68],[15,-47],[-6,-29],[32,-19],[64,3],[35,-21],[-11,-28],[-33,-30],[-23,6],[-22,-17],[-3,27],[-21,5],[-36,-37],[5,-56],[-72,-20],[35,-21],[-54,-19],[12,-13],[-29,-20],[-42,-12],[43,-59],[-49,-32],[53,-31],[3,-40],[-32,24],[-31,-29]],[[6284,3266],[8,-23],[-47,-20],[5,-25],[-42,-24],[-11,-18],[37,-12],[-7,-73],[-14,-60],[2,-37],[13,-25],[3,-36],[-10,-34],[29,-31],[-23,-34],[-13,-50],[4,-32],[-7,-29],[-29,-29],[-52,-29],[-13,-41],[-27,-12],[-26,-31],[-5,-43],[15,-58],[28,-50],[12,-62],[67,-27],[42,-72],[5,-59],[8,-14],[132,-97],[5,-9],[95,-452]],[[6468,1618],[-47,-28],[28,-36],[49,-89],[32,-117],[5,-85],[-15,-127],[31,-99],[-23,-89],[-19,-52],[21,-90],[17,-19],[-3,-48],[-12,-36],[-71,-37],[-21,-46],[4,-13],[114,-176],[11,-31],[1,-102],[33,-26],[10,-38],[29,-28],[67,18],[150,-56],[20,-14],[67,-154]],[[6946,0],[-2935,0]],[[4011,0],[-223,177],[-195,155]],[[3593,332],[-141,105],[-237,172],[-278,200],[-119,86]],[[2818,895],[0,91]],[[2818,986],[0,248],[7,14],[44,29],[36,37],[43,26],[83,71],[55,-2],[40,32],[38,0],[35,-15],[17,17],[57,11],[83,4],[49,9],[7,-23],[37,0],[21,30],[31,59],[20,23],[61,50],[50,26],[51,55],[43,18],[65,10],[37,21],[-2,30],[21,29],[-14,33],[-26,24],[-18,-8],[4,45],[30,14],[3,63],[165,35],[-21,63],[85,21],[254,-12],[-11,16],[9,42],[27,23],[15,25],[-75,56],[-27,46],[12,31],[-35,45],[-2,32],[13,45],[-25,32],[15,97],[-16,52],[-13,20],[22,27],[-34,28],[21,36],[-43,29],[-4,14],[-39,21],[-5,21]],[[4114,2811],[34,-3],[58,13],[51,41],[43,17],[21,50],[31,28],[47,22],[22,-13],[32,13],[11,22],[28,10],[15,-21],[30,-7],[29,18],[18,42],[44,42],[22,5],[42,27],[41,11],[19,20],[82,21],[21,-4],[117,10],[51,14],[58,-9],[44,30],[23,24],[49,-18],[10,18],[46,-9],[38,12],[19,17],[34,5],[39,-7],[67,7],[13,-7],[53,3],[59,-28],[11,-20],[37,-14],[32,5],[26,27],[33,14],[22,-2],[66,20],[28,40],[25,7],[25,-26],[47,-9],[18,-15],[50,6],[20,22],[-16,16],[42,2],[40,-22],[35,-6],[2,-18],[27,-11],[65,27],[53,-13],[21,9]],[[9569,0],[0,1361],[-24,79],[2,32],[-14,30],[2,33],[-25,72],[44,77],[18,71],[-22,56],[-6,32],[1,58],[32,28],[26,38]],[[9603,1967],[8,-29],[40,-7],[87,26],[28,1],[80,-23],[78,-11],[75,-21],[0,-1903],[-430,0]],[[973,1020],[-22,-37],[-35,27],[21,0],[26,24],[10,-14]],[[1468,1105],[10,-33],[-2,-38],[-41,-30],[-42,28],[-6,35],[22,23],[1,22],[58,-7]],[[1108,1077],[-27,18],[6,26],[21,0],[22,-26],[-22,-18]],[[1327,1210],[-49,-50],[-14,-54],[-23,-29],[-26,-7],[-32,52],[-16,35],[67,12],[19,9],[33,32],[41,0]],[[1703,1102],[-25,-19],[-28,5],[47,26],[11,14],[14,47],[23,40],[7,31],[33,-1],[-3,-78],[-23,-41],[-23,-4],[-33,-20]],[[977,1277],[13,2],[16,-29],[-23,-68],[-34,72],[28,23]],[[1861,1352],[-5,-37],[-46,-20],[-13,-18],[-20,9],[15,42],[54,24],[13,23],[2,-23]],[[3975,2857],[-7,13]],[[3968,2870],[7,-13]],[[3487,2997],[-10,20]],[[3477,3017],[10,-20]],[[4876,3797],[9,-18],[-42,-34],[-2,-14],[-38,12],[28,47],[45,7]],[[5197,4010],[-17,-22],[20,-31],[29,5],[27,-6],[-38,-82],[-43,-36],[-22,23],[-40,9],[-3,29],[-13,9],[-38,-21],[-27,34],[43,26],[28,26],[45,23],[49,14]],[[5385,4032],[30,-18],[14,-30],[-18,-13],[-53,31],[-23,-4],[-9,30],[59,4]],[[4958,4617],[0,0]],[[4200,4848],[9,-23],[27,-11],[15,10],[27,-10],[-17,-40],[21,-13],[7,16],[74,-34],[44,-2],[40,-43],[48,17],[32,-12],[17,-24],[49,8],[25,-14],[75,7],[-2,34],[83,-16],[13,-14],[42,-2],[17,-27]],[[4902,4631],[44,-15],[11,-22],[59,19],[50,-25],[27,4],[9,18],[46,14],[49,-11]],[[5197,4613],[5,-21],[23,-4],[-11,-21],[-23,4],[-7,-24],[20,-22],[4,-30],[-17,-25],[-74,-49],[-66,-27],[-37,-21],[-27,-36],[-216,-59],[-36,-27],[-36,-41],[36,-14],[-6,-13],[-53,-18],[-46,-78],[-63,-69],[-62,-99],[-12,-29],[6,-39],[17,-35],[1,-26],[21,-34],[44,-22],[24,-27],[-50,-27],[-12,-21],[-51,-18],[-17,-25],[-19,-7],[1,-33],[-26,-14],[-3,-34],[-41,-70],[31,-22],[-45,-19],[-64,5],[-43,-21],[-6,-15],[-31,-12],[-29,-36],[-24,-60],[-33,-53],[-27,-9],[-27,23],[-47,-5],[-17,-29],[-20,-3],[-36,17],[-78,-1],[-17,-13],[-38,11],[-91,3],[-34,-9],[-42,0],[-19,-32],[-47,-22],[-31,3],[-54,-24],[-31,-65]],[[3488,3070],[-3,0]],[[3485,3070],[-14,9],[-2,-30],[-35,-12],[-37,19],[-20,22],[-28,3],[-25,29],[-15,65],[-32,16],[-10,23],[11,20],[-16,30],[-55,42],[-68,25],[-66,-4]],[[3073,3327],[-13,74],[-11,19],[21,45],[19,15],[13,42],[29,13],[20,-3],[15,41],[-31,-4],[-51,67],[16,37],[1,34],[43,29],[17,39],[-5,18],[-29,2],[-37,61],[1,31],[-39,30],[-8,22],[105,2],[31,78],[-30,31],[3,23],[27,9],[17,23],[-13,21],[9,57],[-5,41],[-21,43],[25,9],[35,52],[30,7],[35,29],[23,39],[-76,41],[12,32],[-9,18],[-97,0],[-21,10],[-19,-29],[-74,-8],[-20,17],[-29,-12],[-8,14],[-29,-23],[-26,-1],[-10,23],[27,28],[-22,12],[-3,20],[-25,-12],[-60,-15],[-21,-18]],[[2805,4500],[-23,-19],[-6,57],[54,45],[-49,-12],[41,41],[-41,-2],[0,20],[23,40],[-17,6],[-35,-37],[-12,16],[29,50],[-37,-8],[-4,37],[-32,0],[3,32],[28,36],[36,8],[-6,13],[32,15],[27,-13],[38,9],[35,20],[26,-20],[5,22],[-32,14],[50,45],[5,13],[36,13],[3,-17],[40,20],[60,-24],[13,-19],[29,-10],[101,5],[28,-8],[121,9],[21,17],[20,-21],[57,-1],[42,-17],[55,-5],[41,-14],[109,-4],[73,23],[14,-5],[41,11],[35,-24],[58,-14],[37,18],[29,4],[78,-34],[49,-6],[67,23]],[[9099,8582],[52,8],[72,-30],[-47,-34],[-71,-34],[-27,8],[-53,-20],[-16,-47],[-40,-12],[19,37],[24,16],[-68,28],[29,22],[-36,39],[33,0],[17,-22],[22,30],[79,22],[11,-11]],[[9241,8591],[11,-17],[-36,-5],[-33,16],[24,20],[34,-14]],[[9213,8694],[36,-16],[-48,-2],[12,18]],[[9115,8686],[43,-7],[22,-35],[-66,-15],[-32,-23],[-25,41],[-77,20],[84,9],[27,29],[24,-19]],[[9999,8326],[-55,19],[-7,-11],[-64,-16],[-47,26],[-48,38],[-4,17],[-42,3],[-13,16],[-94,38],[-12,-21],[-22,19],[-82,-30],[-30,0],[-46,-19]],[[9433,8405],[32,50],[1,44],[17,20],[-48,12],[-14,-25],[-30,-9],[-36,22],[-35,3],[-12,44],[-27,14],[-3,41],[55,-4],[2,17],[-77,-9],[19,14],[-21,21],[41,16],[-33,5],[12,33],[-10,21],[57,17],[68,8],[-15,13],[131,32],[87,8],[60,-10],[26,10],[-10,34],[27,-22],[74,14],[18,-12],[84,-12],[41,1],[47,-23],[38,-2],[0,-116],[-30,-18],[-4,-24],[34,-24],[0,-283]],[[9138,8976],[-21,-36],[-52,-12],[-4,47],[73,9],[4,-8]],[[8961,9027],[10,-17],[-41,10],[7,24],[24,-17]],[[8786,9736],[57,-20],[-24,-14],[-33,34]],[[9999,9061],[-88,-30],[-43,17],[-30,-26],[-62,20],[-17,-53],[-39,0],[-13,29],[-34,-29],[-61,0],[-4,-16],[-109,-11],[-38,-36],[-15,21],[-26,-9],[-127,-20],[-35,0],[-42,-18],[6,-11],[-70,-7],[53,19],[-13,10],[31,27],[-49,3],[-29,33],[28,22],[-26,6],[-65,-23],[-21,10],[36,32],[-68,1],[-68,34],[-33,-10],[11,37],[-46,-35],[-52,50],[17,-3],[-24,46],[19,17],[-22,27],[33,5],[18,34],[7,69],[-17,21],[42,-11],[-36,31],[-33,71],[-27,11],[20,91],[-41,12],[12,48],[-23,19],[33,47],[44,20],[7,30],[32,-14],[-32,47],[80,13],[-1,-18],[63,13],[34,20],[-37,34],[43,-10],[37,70],[47,-15],[34,42],[85,27],[-7,30],[45,-5],[26,46],[51,35],[629,0],[0,-937]],[[6454,4676],[17,-34],[3,-108],[-30,-37],[0,-61],[-28,-43],[-7,-39],[-21,16],[-65,30],[1,20],[25,12],[-54,15],[26,18],[-2,26],[-32,-7],[-6,16],[32,18],[-37,27],[-3,21],[29,10],[-26,17],[18,19],[12,39],[62,16],[18,20],[47,5],[-8,22],[9,41],[21,-7],[6,-43],[-7,-29]],[[4302,5491],[22,-25],[-7,-22],[-31,36],[-8,23],[24,-12]],[[3934,5818],[-25,-3],[-1,18],[26,-15]],[[5721,6359],[34,-24],[46,15],[31,-11]],[[5807,5562],[15,20],[41,9],[57,1]],[[5968,5471],[-45,-23],[3,-32],[31,-17],[3,-28],[35,-28],[-19,-44],[-44,-22],[-22,7],[-27,-14],[25,-22],[4,-26],[52,-19],[10,-35],[-44,-37],[17,-24],[-11,-16],[26,-33],[67,-28],[66,12],[7,-23],[-43,-54],[5,-18]],[[6064,4947],[-13,-11]],[[6051,4936],[-15,-5]],[[6036,4931],[-43,-16],[-2,-25],[-36,-3],[-8,-23],[-38,-10],[-27,-30],[17,-22],[-56,-13],[-5,-14],[-25,9],[-62,-13],[-62,29],[-57,7],[-2,29],[-55,-2],[-12,13],[34,12],[-29,32],[0,-35],[-20,5],[-22,-23],[-51,7],[-11,21],[-61,0],[-15,20],[-36,1],[-88,-64],[-26,1],[-54,-44],[-15,-41],[2,-95],[26,-31]],[[4200,4848],[26,4],[37,44],[26,108],[19,104],[-1,28],[14,27],[29,1],[-24,27],[-19,-37],[24,211],[16,9],[59,-49],[9,-44],[16,-18],[-13,61],[-27,47],[-71,48],[-7,21],[21,3],[15,57],[-32,30],[20,23],[-79,40],[-61,21],[-10,33],[-55,63],[28,35],[-8,14],[-42,11],[16,33],[25,5],[51,-20],[-46,27],[-57,-18],[-52,33],[33,10],[-25,25],[-58,-7],[6,33],[-72,-13],[-33,31],[1,17],[-31,-17],[-16,19],[-66,4],[-26,26],[-48,-26],[-29,2],[-4,32],[-59,32],[79,10],[-2,22],[-32,13],[-14,-16],[-9,26],[78,1],[-55,12],[24,18],[-83,-18],[-6,18],[12,37],[81,27],[3,-9],[66,23],[24,-26],[9,26],[40,-13],[19,39],[59,-8],[24,17],[15,-25],[39,-29],[4,-14],[39,-14],[35,29],[27,5],[19,-24],[14,13],[61,19],[9,-24],[81,9],[-32,23],[1,72],[-22,61],[-32,23],[-14,36],[9,11],[-19,37],[65,-18],[31,13],[39,-2],[-9,-34],[25,-31],[73,-17],[60,-1],[60,-19],[57,18],[20,15],[50,9],[-62,10],[14,49],[70,35],[131,31],[43,28],[26,35],[31,-6],[-27,21],[7,41],[1,104],[69,32],[120,22]],[[3178,9327],[42,-41],[-38,11],[-4,30]],[[3187,9395],[45,-19],[-10,-18],[-37,20],[2,17]],[[3124,9452],[24,-11],[-33,-17],[-46,32],[55,-4]],[[3118,9496],[95,-68],[-4,-24],[-50,39],[-51,23],[10,30]],[[3178,9498],[32,-33],[33,-12],[-25,-15],[-66,40],[-12,20],[38,0]],[[3279,9483],[-31,-8],[-5,33],[36,-25]],[[4300,6663],[46,-21],[-43,-27],[-44,22],[41,26]],[[4747,6809],[-28,0],[-6,18],[34,-18]],[[3717,7283],[32,1],[-63,-43],[-43,36],[3,31],[46,5],[25,-30]],[[3302,7478],[-70,-14],[-4,32],[-37,16],[-11,27],[-28,18],[-38,-30],[11,-17],[-32,-28],[-59,7],[-46,16],[-9,21],[-58,42],[34,19],[59,16],[-40,14],[73,19],[27,64],[32,17]],[[3106,7717],[37,-6],[20,37],[42,-4],[55,18],[89,-20],[10,-47],[57,-37],[-1,-22],[-44,-27],[70,13],[29,-49],[-8,-30],[-32,39],[-7,-34],[22,-20],[-61,-16],[-10,-35],[-23,-13],[-49,14]],[[3533,7808],[-46,11],[-10,32],[20,27],[28,-11],[12,-27],[-4,-32]],[[3555,7880],[-21,12],[-11,34],[28,-25],[4,-21]],[[3336,7905],[15,-38],[-57,-23],[13,19],[-21,28],[-31,-24],[10,40],[63,25],[8,-27]],[[3400,7951],[-36,-53],[-20,1],[-3,27],[24,29],[42,25],[-7,-29]],[[3179,8055],[-21,15],[49,11],[-28,-26]],[[3349,8098],[15,-23],[33,-2],[29,-23],[-31,-27],[-104,-9],[47,18],[-47,63],[40,12],[18,-9]],[[3243,8093],[-28,-3],[50,25],[-22,-22]],[[3302,8196],[-14,-19],[-23,16],[37,3]],[[3085,8292],[31,-25],[-18,-20],[10,-31],[-31,7],[-13,27],[21,42]],[[3359,8314],[-1,-37],[-16,22],[17,15]],[[3118,8353],[11,-29],[-35,-7],[-48,20],[14,17],[58,-1]],[[3294,8364],[30,-28],[11,-65],[41,-20],[51,6],[-10,-19],[-51,-38],[1,30],[-16,10],[-59,-9],[-32,37],[-61,36],[44,11],[-15,26],[51,-22],[-6,28],[21,17]],[[3317,8525],[-42,-36],[0,-50],[-36,-22],[-36,21],[21,-30],[-64,-36],[-20,19],[33,24],[-40,20],[-3,33],[19,29],[29,-18],[36,5],[-22,23],[111,56],[14,-38]],[[3888,8597],[66,-2],[-20,-27],[6,-29],[-27,-27],[-159,-87],[1,-20],[27,-13],[-77,-34],[47,-5],[-12,-17],[50,1],[49,12],[20,18],[42,2],[41,-13],[28,8],[84,-8],[118,3],[35,-51],[-45,-38],[-42,-101],[-44,-35],[-24,-45],[-47,-26],[-67,-8],[-32,-23],[89,22],[9,-26],[39,-12],[-46,-24],[-32,4],[-44,-36],[-48,-8],[-59,1],[128,-20],[33,8],[22,21],[34,-2],[66,-30],[32,-4],[68,-70],[35,-12],[13,-75],[54,-122],[39,-39],[63,-15],[45,-21],[39,-56],[59,-34],[-29,-22],[14,-30],[57,-63],[-36,-4],[-52,28],[-69,-8],[24,-7],[45,9],[24,-24],[71,-37],[35,-59],[-1,-33],[-66,-50],[74,-25],[29,41],[33,8],[118,-14],[74,-39],[21,-37],[5,-33],[-29,-53],[-9,-46],[-22,-6],[-55,-44],[15,-8],[-48,-17],[-11,17],[-27,-27],[20,0],[-4,-36],[-22,-13],[-72,-7],[48,-7],[-22,-22],[78,-10],[90,10],[-13,-64],[-55,-14],[-24,-22],[3,-16],[-36,5],[-35,-20],[-55,-11],[-24,-17],[-81,21],[-80,-7],[-49,-16],[-38,28],[-32,-1],[3,-16],[-60,32],[26,-27],[-140,-27],[7,-23],[-72,9],[-29,-10],[-77,35],[-111,-26],[-17,-26],[4,-27],[-29,-24],[-3,-22],[-28,-4],[-37,27],[-13,-6],[-40,34],[0,-20],[-104,-5],[-9,-25],[-31,-7],[-32,-25],[10,-9],[-28,-25],[-21,30],[-33,12],[-18,-18],[-29,-1],[4,25],[50,9],[78,58],[7,27],[44,14],[44,44],[9,59],[46,-3],[18,18],[-9,18],[21,15],[77,9],[77,-15],[77,9],[-2,22],[42,41],[21,8],[46,53],[-50,-35],[-60,-13],[-35,-33],[-71,0],[-42,25],[-16,29],[-29,-13],[-63,-3],[0,16],[40,6],[-41,7],[-17,14],[-60,-2],[-7,-18],[-46,-12],[-13,27],[-44,6],[24,11],[-6,22],[-30,13],[41,25],[50,0],[39,29],[25,-1],[64,36],[20,25],[9,39],[-14,21],[14,23],[-20,21],[16,27],[-71,-7],[-17,-25],[-51,0],[33,35],[48,24],[3,18],[39,32],[64,13],[46,0],[55,17],[41,-22],[-7,36],[25,5],[-13,27],[39,48],[-29,7],[6,40],[26,5],[-6,21],[24,23],[-11,17],[-29,-9],[-7,16],[-23,-39],[-19,11],[-46,70],[-32,29],[54,95],[46,17],[-89,6],[-4,-28],[-50,-3],[-24,-23],[-42,5],[-43,27],[2,-55],[-96,46],[-20,-14],[20,-45],[-60,62],[-3,32],[22,-17],[11,49],[25,19],[27,48],[25,14],[-10,28],[-50,30],[13,11],[-3,45],[74,-4],[-73,34],[-24,-46],[-30,32],[-32,-36],[-9,34],[-18,5],[5,-37],[16,-13],[-27,-30],[0,-26],[-24,-37],[12,-14],[-47,-18],[15,92],[20,21],[-24,39],[39,66],[-20,-12],[7,47],[36,32],[-7,18],[62,70],[-113,-79],[-64,30],[28,15],[-75,12],[54,13],[23,-9],[4,61],[33,38],[14,32],[-28,5],[22,29],[-32,-17],[-15,26],[4,31],[35,-9],[-25,38],[-3,38],[39,19],[31,-19],[6,14],[45,2],[-45,28],[24,9],[-17,43],[59,8],[-15,19],[25,25],[-11,15],[22,28],[67,-18],[63,-4],[107,8],[30,12],[60,-5],[3,12]],[[3981,8639],[-11,-22],[-19,23],[30,-1]],[[3908,8657],[18,-27],[-28,-1],[-24,31],[34,-3]],[[3926,8718],[44,-32],[45,-11],[-25,-21],[-31,19],[-25,-11],[-50,25],[18,31],[24,0]],[[3969,8769],[15,-25],[-42,21],[27,4]],[[4300,9076],[-15,-49],[30,24],[28,-35],[-28,-31],[19,-18],[-25,-39],[-5,-35],[-21,13],[23,51],[-13,22],[-25,-12],[-33,14],[0,25],[72,10],[-25,6],[-13,27],[-32,-3],[38,32],[25,-2]],[[4343,9109],[17,-1],[-8,-57],[-27,8],[18,50]],[[4404,9123],[-35,-27],[14,40],[21,-13]],[[4050,6333],[-26,0],[30,20],[-4,-20]],[[3488,3070],[-3,0]],[[9974,2894],[-25,-19],[4,18],[21,1]],[[9352,2918],[25,-2],[18,20],[28,-29],[2,-27],[15,-5],[77,19],[50,0],[21,-21],[60,0],[21,-10],[32,10],[17,-11],[1,-41],[18,-3],[15,17],[35,11],[17,-9],[21,22],[8,-24],[-12,-36],[-21,-10],[-42,9],[-23,-7],[-42,2],[-59,-8],[-42,-12],[-72,0],[-4,39],[-31,4],[-32,20],[-22,-2],[-94,18],[-48,-4],[-14,14],[18,78],[7,-27],[16,2],[4,43],[15,-37],[17,-3]],[[9999,2894],[-12,40],[12,24],[0,-64]],[[9182,3085],[-10,-14],[-19,14],[-2,30],[12,14],[29,-37],[-10,-7]],[[9865,3182],[-23,-22],[-15,20],[38,2]],[[9462,3219],[17,4],[3,-20],[-44,-9],[5,25],[19,0]],[[9653,3214],[-6,-18],[-24,18],[11,16],[19,-16]],[[9999,3221],[-42,-10],[42,37],[0,-27]],[[9788,3255],[-36,-23],[-8,11],[30,23],[14,-11]],[[9504,3293],[22,-25],[-11,-11],[-11,36]],[[9968,3291],[15,-12],[-27,-13],[12,25]],[[9629,3311],[-7,-27],[-29,0],[15,27],[21,0]],[[9692,3305],[-9,-32],[-20,-12],[-22,39],[39,29],[12,-24]],[[9466,3386],[-20,-30],[5,36],[15,-6]],[[9642,3404],[22,-14],[-30,-8],[8,22]],[[9565,3379],[-20,-2],[7,29],[13,-27]],[[9589,3440],[33,-7],[-6,-23],[-44,27],[17,3]],[[9447,3449],[4,-16],[-24,-23],[1,23],[19,16]],[[9837,3436],[-52,-28],[-18,3],[21,26],[49,-1]],[[9271,3447],[-14,22],[27,0],[-13,-22]],[[9965,3465],[16,-9],[-48,-18],[-18,18],[-22,-9],[-4,16],[39,18],[37,-16]],[[8721,3490],[19,-4],[27,-30],[-18,4],[-16,-20],[-39,52],[13,16],[14,-18]],[[9542,3505],[23,-4],[5,-20],[-14,-25],[-46,58],[14,10],[18,-19]],[[9278,3521],[-3,-20],[-22,0],[25,20]],[[8685,3643],[11,-36],[36,-56],[-18,-9],[-21,13],[-21,-2],[-15,20],[-19,2],[12,41],[16,-14],[19,41]],[[8705,3645],[6,-42],[-18,38],[12,4]],[[9786,3668],[20,-9],[0,-59],[-10,-19],[-30,-14],[-18,27],[24,17],[-29,57],[43,0]],[[8710,3694],[4,-14],[-34,-14],[11,52],[17,16],[2,-40]],[[9487,3743],[22,-19],[-23,-8],[-2,18],[-25,9],[12,24],[16,-24]],[[9260,3747],[4,-11],[63,-36],[72,-11],[16,-30],[-6,-33],[12,-41],[47,-25],[22,4],[-4,-41],[-39,-4],[-21,31],[-17,7],[0,23],[-29,43],[-80,4],[-1,28],[-87,75],[-69,1],[56,43],[32,7],[29,-34]],[[9292,3822],[38,-21],[-27,-6],[-11,27]],[[9856,3851],[-7,-11],[30,-29],[-18,-14],[22,-29],[-28,-5],[-49,14],[-12,13],[38,25],[-24,5],[-18,-25],[-50,21],[4,18],[62,17],[0,14],[36,0],[14,-14]],[[8556,3966],[-18,-22],[18,-55],[30,-8],[5,-20],[-39,15],[-16,36],[-41,43],[8,11],[37,8],[16,-8]],[[9660,4023],[-27,-54],[-13,29],[-4,-29],[-31,10],[-6,37],[43,2],[8,-12],[30,17]],[[9707,4137],[2,-17],[-23,-5],[-21,21],[42,1]],[[9529,4170],[-28,-14],[-23,16],[1,22],[22,21],[29,-18],[-1,-27]],[[8794,4227],[58,13],[35,-10],[37,14],[32,45],[52,12],[26,-9],[52,0],[29,7],[13,46],[27,0]],[[9840,4438],[54,-31],[7,-46],[-61,-36],[5,-70],[-31,-25],[-18,-29],[-14,-2]],[[9782,4199],[-1,23],[-95,8],[-53,21],[-53,13],[-9,-15],[-38,-22],[-35,1],[-12,23],[-35,-5],[-11,-25],[-46,-25],[-54,14],[-29,-16],[29,-49],[6,-26],[64,-17],[39,-41],[-17,-13],[-26,36],[-49,24],[-45,-11],[13,-27],[43,-22],[2,-42],[-29,17],[-34,47],[-48,16],[-20,-18],[33,-40],[34,-14],[7,-18],[-65,22],[-15,25],[-2,32],[-54,22],[-41,44],[31,15],[-13,20],[-35,-32],[-32,-12],[17,-24],[-23,-56],[10,-32],[22,-13],[4,-18],[25,-23],[17,-52],[33,-20],[34,-43],[14,-32],[-28,-22],[-20,0],[23,19],[-16,28],[-39,17],[-20,-18],[31,-59],[1,-21],[-54,-23],[-22,10],[-20,-14],[36,-2],[9,-12],[59,-13],[12,-27],[17,13],[27,-11],[2,-31],[42,-1],[26,-38],[56,-16],[25,-25],[-17,-18],[9,-27],[-5,-29],[16,-27],[-11,-32],[-17,7],[-9,25],[-28,15],[-17,26],[-26,8],[6,16],[-34,-18],[-37,0],[-46,-27],[37,-14],[-3,-47],[34,-20],[-5,20],[17,6],[0,-31],[26,-18],[-59,-14],[-6,-19],[-26,13],[12,23],[-30,15],[-52,5],[7,-34],[40,-66],[11,-45],[20,-39],[-17,-16],[11,-35],[23,-35],[-20,3],[-12,21],[-44,33],[-16,36],[-32,-7],[-19,-43],[6,-38],[-27,7],[-2,47],[-30,55],[-16,5],[3,26],[-44,-11],[7,-45],[-18,-18],[-12,22],[-26,9],[4,23],[-27,32],[3,36],[18,16],[-1,27],[-21,38],[-34,27],[-21,4],[-2,26],[-33,14],[2,27],[29,13],[19,32],[1,22],[45,-18],[33,37],[38,10],[53,-38],[22,-2],[70,-27],[38,-32],[17,16],[-20,9],[18,11],[32,-5],[22,25],[-40,14],[-41,2],[-32,39],[-14,-25],[-35,41],[-4,-28],[-79,18],[-32,-4],[-12,-15],[-34,4],[-15,-13],[-10,18],[-28,6],[-33,-23],[-17,11],[0,46],[-35,38],[-11,27],[-26,0],[8,39],[31,0],[33,-23],[16,2],[-1,30],[-15,16],[-17,-11],[-36,24],[-18,-41],[-9,32],[-42,36],[1,14],[-32,6],[-20,33],[8,18],[-26,4],[9,23],[-36,18]],[[8775,4186],[-1,2]],[[8763,4213],[31,14]],[[8045,4703],[55,-12],[18,-12],[-72,19],[-1,5]],[[7922,4747],[53,3],[34,-16],[-70,-4],[-43,8],[26,9]],[[8257,4646],[11,-35]],[[8268,4611],[-51,35],[-4,15],[-30,6],[-47,40],[-18,-4],[-61,20],[-46,27],[-39,7],[45,3],[55,-30],[27,-4]],[[7881,4810],[32,-17],[93,-9],[-104,0],[-61,18],[40,8]],[[7930,4838],[8,-18],[-44,-1],[-42,13],[1,19],[77,-13]],[[7564,5022],[32,-35],[-4,-9],[-28,44]],[[7536,5146],[12,3],[29,-42],[7,6],[34,-31],[-25,-6],[-74,85],[17,-15]],[[7518,5207],[18,-35],[-32,36],[14,-1]],[[7461,5234],[1,-82],[-17,21],[-21,57],[21,-7],[-23,53],[39,-42]],[[7480,5306],[20,-39],[29,-27],[-21,-8],[-16,22],[-40,13],[21,10],[7,29]],[[7871,5614],[65,-30],[26,-42],[46,-22],[29,-40],[43,-2],[22,-26],[83,-17],[62,-9],[28,13],[29,30],[18,-7],[28,12]],[[8350,5474],[-12,-30],[24,-32],[-11,-24],[40,-17],[-20,-4],[-1,-32],[24,-17],[48,-12],[6,-20],[-54,7],[-16,-14],[18,-45],[-23,-22]],[[8085,4739],[-53,45],[-49,27],[-39,43],[-52,10],[-30,22],[-99,-9],[-2,34],[-100,68],[-65,69],[24,33],[48,-18],[-42,26],[-56,50],[-22,29],[-5,43],[9,24],[-19,37],[-57,43],[-43,16],[-33,-87],[-39,-23],[5,-22],[-21,1],[-56,74],[-2,41],[-19,37],[16,13]],[[7284,5365],[61,-16],[14,22],[26,-10],[57,1],[19,12],[22,34],[18,-32],[26,-18],[21,13],[46,-20],[39,5],[-12,37],[21,9],[-25,18],[40,24],[44,5],[5,51],[-21,18],[11,24],[72,20],[10,21],[45,-1],[-8,29],[21,14],[35,-11]],[[8998,6081],[28,0],[17,-40],[24,0],[24,-34],[47,-7],[9,-32]],[[9147,5968],[-55,-45],[-30,7],[-50,-30],[-8,-20],[-35,-23],[2,-24],[-28,-24],[-19,-48],[-27,-19],[4,-20],[-30,-34],[1,-20],[-41,-30],[-4,-45],[-21,-9],[-4,-20],[-25,-17],[-39,10],[-46,-36],[-28,12],[-45,-17]],[[8619,5516],[-63,14],[-28,-9],[-48,9],[-58,-45],[-39,9],[-17,-23],[-16,3]],[[7871,5614],[-28,31],[-21,57],[-35,0]],[[7997,5982],[39,-1],[47,-41],[51,-21],[82,2],[64,10],[28,-4],[25,14],[-15,34],[19,16],[79,5],[50,13],[6,23],[27,4],[52,-24],[43,28],[41,10],[32,61],[63,11],[62,-20],[64,18],[60,-55],[82,16]],[[3639,7477],[-35,-8],[11,40],[36,36],[33,13],[11,-32],[-16,-23],[-40,-26]],[[2563,7459],[0,-33],[-47,33],[47,0]],[[3302,7478],[33,-20],[-40,0],[-14,-28],[26,-8],[1,-44],[30,-27],[-7,-45],[-19,-11],[25,-16],[20,-78],[-44,-75],[-1,-32],[-32,-42],[-23,0],[35,-30],[-5,-10],[-51,-4],[-23,9],[-57,-18],[-88,-5],[-33,-13],[3,-18],[-49,-10],[-35,-31],[-46,-7],[11,21],[-50,0],[29,-21],[-12,-20],[-25,-1],[-45,-35],[-32,6],[-106,-30],[-4,17],[-84,-25],[-3,11],[58,30],[-45,-5],[63,23],[-84,-6],[-31,-15],[-12,18],[71,41],[-79,-20],[-21,23],[-21,-15],[-8,22],[23,27],[67,20],[-5,18],[-46,-9],[-59,11],[41,29],[81,-9],[7,35],[-23,9],[40,11],[27,30],[76,1],[56,17],[-13,23],[-25,-31],[-37,-5],[-44,10],[-31,-15],[-24,4],[47,36],[19,2],[29,45],[-25,2],[41,51],[23,-9],[53,27],[-10,11],[-137,-5],[13,23],[-15,11],[-21,-17],[-32,1],[23,18],[-46,-4],[-33,44],[42,1],[21,13],[-7,37],[67,8],[0,25],[-69,-11],[0,64],[-20,26],[-24,-23],[25,44],[32,6],[126,-11],[14,-26],[19,27],[87,-8],[-9,25],[91,37],[-12,4],[29,30],[-33,-10],[-26,9],[-51,-6],[-24,20],[47,29],[49,15],[-30,15],[37,54],[74,7],[50,22],[26,-44],[-22,-14],[35,0],[-15,38],[4,23],[35,6],[-4,16],[86,-36],[-44,-20],[-18,-21]],[[1584,9998],[-32,-23],[-68,11],[-4,12],[104,0]],[[1475,9998],[-17,-27],[-45,-3],[-60,-23],[-72,-43],[-53,-23],[-84,-5],[-112,-26],[-59,-3],[17,-15],[-33,-37],[-155,-31],[-113,11],[-94,23],[-84,3],[-78,41],[-119,40],[-3,21],[-36,-27],[-60,-5],[-26,10],[-54,-9],[-56,7],[-75,-9],[4,65],[30,-27],[102,17],[56,37],[-34,8],[50,30],[1263,0]],[[7696,3591],[-28,-45],[-58,-78],[-10,-48],[-13,-19],[2,-42],[29,-16],[-12,-19],[22,-19],[6,-23],[-33,-16],[-15,-36],[8,-29],[-44,11],[-28,-5],[-58,23],[-19,36],[-37,34],[-23,9],[-40,-4],[-42,22],[-23,20],[-58,30],[-21,23],[-33,4],[-7,14],[-63,1],[-31,25],[-8,39],[6,48],[52,40],[28,-38],[27,8],[17,32],[42,7],[14,-29],[23,2],[10,-16],[46,-18],[47,18],[16,-6],[72,4],[35,11],[20,18],[40,7],[31,-13],[85,41],[26,-8]],[[6236,3801],[21,-15],[-11,-25],[-10,40]],[[6412,4323],[41,-28],[25,-3],[-9,-23],[9,-29],[29,-16],[-9,-10],[32,-69],[-13,-32],[-26,-26],[4,-35],[16,-15],[-8,-21],[-3,-68],[-22,-140],[-25,-6],[-45,26],[-29,5],[-12,-31],[6,-18],[-41,-43],[-20,13],[-28,-7],[-8,39],[-16,4],[-22,36],[11,14],[-8,47],[16,25],[-4,47],[12,-6],[10,31],[-32,9],[2,35],[11,2],[0,65],[-30,64],[-30,-3],[6,32],[-12,8],[16,34],[62,-11],[64,34],[33,39],[28,8],[19,23]],[[6651,4709],[-9,-13],[-56,-2],[5,13],[60,2]],[[7307,5618],[-4,-13],[-51,-27],[-1,-31],[43,-13],[-35,-42],[28,-5],[0,-47],[35,-12],[23,-29],[-36,-9]],[[7309,5390],[19,6],[-16,21],[-35,23],[-26,-18],[-41,13],[-28,-11],[0,-21],[-135,-51],[26,24],[-54,-18],[-11,-37],[7,-28],[11,9],[6,-32],[41,-35],[-19,-35],[-30,7],[-9,-34],[15,-87],[14,-32],[64,-59],[48,-21],[61,-47],[72,-43],[45,-100],[22,-81],[26,-48],[97,-92],[32,-15],[4,-19],[42,-16],[39,-23],[61,-4],[116,9],[31,-14],[2,-24],[-53,-37],[-3,-34],[21,-18],[116,-54],[93,-31],[29,-15],[55,-47],[105,-44],[7,-23],[41,-25],[40,-46],[16,-38],[-17,-22],[-13,-57],[-60,30],[-21,34],[9,11],[-33,47],[-67,4],[-62,28],[24,20],[-55,5],[-27,-18],[-35,-58],[-27,-32],[5,-28],[-28,-39],[5,-29],[21,-17],[35,-4],[11,-14],[61,-35],[-9,-33],[2,-45],[18,-14],[-21,-32],[-34,10],[-65,-30],[-14,-23],[8,-49],[-15,-38],[-33,-17],[-34,-40],[-19,-50],[-63,-2],[-23,15],[1,62],[27,9],[25,67],[-15,25],[33,18],[24,-1],[19,22],[-2,31],[-25,34],[-9,66],[-32,50],[-14,36],[-7,49],[-32,43],[-54,-16],[-43,41],[-44,18],[17,38],[-26,50],[-16,17],[-60,-9],[-26,-13],[24,36],[-40,28],[-39,-3],[-46,78],[-27,26],[-28,-11],[-51,21],[-56,-16],[-10,21],[-32,26],[-40,7],[-37,45],[-41,25],[-20,42],[-46,33],[-18,-1],[-34,59],[-58,32],[-55,-1],[19,28],[-40,48],[-52,23],[10,22],[-30,16],[-26,-5],[7,71],[-20,38],[-24,27],[-10,77],[-32,52],[-52,22],[-6,-11],[-118,71],[-81,19],[-20,-1],[-52,-31],[-14,-29],[-33,-20],[-13,-36],[-41,-25],[-54,-16],[-38,0]],[[7046,4976],[0,0]],[[7056,4485],[0,0]],[[4134,6291],[19,-22],[-42,4],[23,18]],[[8884,4569],[-43,-8],[-13,-31],[-38,27],[-63,-28],[-16,-58],[-27,6]],[[8583,4643],[8,26],[-16,22],[32,0],[32,21]],[[8639,4712],[26,5],[0,29],[29,13],[10,21],[-13,22],[38,17],[9,-23],[51,-21],[24,-22],[4,-21],[35,-16],[-6,-25],[47,-16],[31,-2],[-30,-70],[-20,-18],[10,-16]],[[9569,0],[-2623,0]],[[6468,1618],[45,25],[26,5],[64,92],[16,46],[-5,40],[-28,82],[2,21],[40,54],[40,9],[18,49],[40,20],[14,25],[114,57],[23,34],[-23,31],[2,66],[10,68]],[[6866,2342],[27,-18],[42,-5],[54,-40],[47,-23],[95,-7],[68,27],[38,-2],[43,-25],[44,0],[77,-20],[60,-50],[47,-14],[41,-4],[58,-12],[17,-18],[18,-40],[0,-55],[28,-74],[22,-33],[28,-26],[57,-29],[63,-12],[73,0],[88,-26],[40,-8],[21,-13],[62,-24],[29,-19],[58,-22],[23,-27],[49,-38],[17,-21],[63,-34],[54,-2],[76,36],[27,23],[57,76],[22,55],[0,43],[-25,44],[-21,89],[5,48],[26,53],[51,57],[48,38],[47,21],[60,33],[38,-2],[34,10],[33,31],[43,-9],[53,6],[56,-13],[20,-16],[126,-41],[-2,-79],[29,-24],[86,-9],[66,-23],[18,-21],[92,-3],[36,10],[51,-17],[8,-27],[26,-50]],[[8768,7767],[-13,3]],[[8755,7770],[32,52],[1,56],[9,-16],[-5,-59],[-24,-36]],[[9269,7440],[-2,42],[-32,31],[-96,41],[-14,-11]],[[9125,7543],[-18,23],[9,66],[22,13],[-2,27],[-38,18],[-12,26],[-65,1],[-30,-9],[-99,40],[-46,24],[-22,-10]],[[8824,7762],[5,12],[-19,70],[-25,39],[-4,81]],[[8781,7964],[28,3],[8,19],[73,36],[100,26],[84,-5],[34,-11],[48,15],[38,-24],[35,15],[39,-11],[47,5],[85,-23],[30,10],[32,-9],[38,24],[55,16],[39,-59],[111,-11],[7,-12],[97,-59],[20,-26],[63,-19]],[[8781,7964],[-17,43],[13,61],[7,86],[59,34],[14,79],[68,69],[46,3],[97,35],[25,3],[-2,-31],[87,-57],[20,-6],[24,-63],[18,-14],[71,-22],[34,4],[69,34],[40,43],[-10,95],[-11,45]],[[9999,8326],[0,-420]],[[3487,2997],[5,-32],[15,-33],[36,-41],[51,-38],[94,-27],[84,29],[12,-16],[34,22],[57,-24],[44,11],[30,18],[14,32],[5,-28]],[[3975,2857],[6,-31],[64,-14],[30,14],[39,-15]],[[2818,986],[-27,0],[9,-48],[-6,-25],[10,-42],[-8,-17],[-42,-8],[-82,0],[-65,-55],[-33,-3],[-26,14],[-44,-11],[-60,32],[-42,7],[-33,-4],[-94,-30],[15,-34],[-4,-27],[-27,-29],[-43,-74],[-6,-27],[-63,-19],[-28,-96],[-28,-130],[-24,-68],[-56,-49],[-57,-40],[-14,-17],[-34,-76],[-17,-26],[-105,-58],[-16,-26]],[[1768,0],[-393,0],[22,35],[1,17],[-25,-10],[10,22],[44,31],[35,47],[29,31],[26,36],[31,17],[24,35],[12,50],[-2,76],[13,56],[14,19],[17,63],[22,36],[9,63],[35,29],[23,31],[28,4],[85,60],[24,42],[19,79],[21,35],[25,88],[23,15],[19,43],[26,12],[65,8],[91,22],[11,9],[104,49],[32,47],[56,61],[95,56],[62,72],[36,55],[4,19],[49,62],[33,70],[10,61],[-19,42],[-37,35],[13,26],[2,122],[-7,27],[31,58],[5,24],[60,72],[18,41],[6,63],[-6,23],[56,63],[26,20],[50,64],[18,31],[16,-2],[41,36],[28,5],[116,51],[24,23],[58,25],[38,27],[21,25],[53,93],[54,113],[17,59],[36,94],[18,64],[68,13],[40,27]],[[6051,4936],[-15,-5]],[[9999,5984],[-26,39],[-38,22],[-38,0]],[[9897,6045],[35,12],[8,20],[22,-9],[37,6]],[[9999,6074],[0,-90]],[[8763,4228],[0,-1]],[[8794,4227],[-8,28],[-23,12],[-1,-32]],[[8759,4240],[0,0]],[[8715,4240],[14,6],[5,44],[-19,15],[-18,-22]],[[8884,4569],[22,-3],[51,24],[33,-7],[28,11],[22,-9]],[[3270,0],[-33,332],[356,0]],[[4011,0],[-741,0]],[[7480,2997],[-7,-11],[-38,20],[-4,22],[38,-11],[11,-20]],[[8409,4884],[4,-23],[28,-11],[48,-53],[42,-22],[25,7],[37,-34],[48,-22],[-2,-14]],[[8450,4589],[-6,-9]],[[8442,4576],[-51,2],[28,-34],[25,-14]],[[8443,4472],[-38,19],[-8,27],[-45,45],[-27,12],[-19,46],[-38,-10]],[[2150,0],[0,577],[303,0],[360,0],[6,6],[-1,312]],[[3270,0],[-1120,0]],[[5231,6811],[39,10],[63,-18],[25,15],[48,-9]],[[5365,6890],[-8,-19],[-58,24],[55,4],[11,-9]],[[5730,7103],[-11,-36],[-48,-15],[-24,-22],[-50,17],[-8,11],[104,56],[37,-11]],[[5540,7237],[-19,-27],[-18,6],[30,40],[7,-19]],[[5414,6809],[-64,20],[-23,-15],[-28,16],[-31,1],[-17,17],[22,15],[54,5],[9,-15],[37,-10],[14,-16],[31,0],[-8,18],[-51,18],[41,7],[-42,47],[19,9],[-14,32],[27,7],[73,82],[18,41],[30,114],[34,-16],[93,47],[14,31],[29,20],[78,25],[73,2],[77,12],[24,-4],[10,-23],[59,-26]],[[5575,7191],[12,-38],[36,-15],[-34,-22],[-17,5],[8,-50],[-12,-22],[66,-19],[35,0],[66,50],[-7,34],[-34,0],[-11,34],[24,22],[-63,4],[-7,54],[-62,-37]],[[5618,8755],[4,-31],[-27,7],[9,54],[14,-30]],[[5605,8887],[-4,-55],[-17,11],[21,44]],[[5662,8880],[-38,-2],[-12,28],[28,12],[22,-38]],[[5694,8945],[-26,-41],[-28,16],[13,20],[41,5]],[[5581,9007],[2,-32],[-28,13],[-4,46],[30,-27]],[[5567,9057],[25,-6],[-5,-24],[-20,30]],[[5698,9045],[-39,-8],[-32,26],[73,32],[-2,-50]],[[5553,9394],[54,-12],[-62,-16],[-22,15],[30,13]],[[5703,9493],[15,-23],[-48,-3],[5,24],[28,2]],[[5776,9505],[-39,-23],[-14,26],[28,17],[25,-20]],[[5944,9599],[-45,-18],[5,19],[40,-1]],[[6100,9670],[-31,-18],[-25,27],[56,-9]],[[6201,9704],[-52,5],[37,15],[15,-20]],[[6261,9726],[16,-17],[-44,-1],[-14,25],[42,-7]],[[6184,9749],[-59,7],[39,25],[36,-20],[-16,-12]],[[6357,9826],[29,-30],[-140,-25],[-25,14],[25,17],[63,2],[-36,9],[84,13]],[[6323,9863],[6,-21],[-70,-14],[-41,5],[105,30]],[[7393,9998],[3,-46],[-41,-39],[-142,20],[-50,-8],[-61,-25],[-77,-74],[-25,-14],[7,-35],[-43,-41],[46,-71],[-26,-28],[12,-37],[-12,-37],[38,-59],[7,-27],[-31,-125],[51,-35],[33,-5],[60,-47],[-12,-41],[-27,-40],[-81,-6],[18,-64],[45,-59],[0,-30],[-22,-24],[0,-53],[-68,-45],[-59,-6],[9,-39],[-41,-22],[-3,-16],[27,-76],[-30,-81],[-42,-6],[-3,24]],[[6853,8681],[-14,27],[-106,14],[-50,67],[20,12],[-26,60],[19,32],[13,-29],[7,37],[-46,-2],[-8,-30],[22,-46],[-46,-11],[30,-55],[-31,-8],[-9,-35],[-72,-42],[-29,2],[-6,21],[-49,17],[38,-25],[-43,-30],[-44,-3],[31,-12],[-50,-40],[-50,-22],[-1,-14],[-89,-66],[-15,4],[-61,-42],[-20,15],[-21,-20],[-61,-14],[-123,2],[-76,9],[-16,10],[28,28],[-67,15],[-69,26],[-10,22],[-50,10],[-45,58],[19,34],[-5,35],[38,-27],[26,9],[45,-29],[-44,59],[60,43],[-35,18],[36,27],[-51,-22],[-23,45],[-9,-26],[19,-20],[-47,-14],[-7,30],[-23,-34],[-28,34],[-7,-18],[-23,41],[61,56],[6,-49],[12,35],[29,-4],[36,25],[-47,22],[86,58],[9,30],[42,38],[37,16],[24,-13],[4,29],[-90,-31],[-20,-31],[-26,4],[-27,-25],[-1,-34],[-35,4],[15,42],[-37,11],[-33,-30],[-37,19],[-9,44],[24,2],[1,32],[54,-28],[27,14],[8,61],[-45,-8],[1,-14],[-46,-17],[-64,61],[89,-36],[-38,28],[12,11],[-50,6],[-6,49],[24,8],[60,-13],[34,16],[58,8],[68,-5],[9,-13],[54,13],[11,18],[71,-21],[78,13],[3,12],[-85,-19],[-8,12],[-68,15],[-24,-27],[-99,14],[-81,-10],[-32,-12],[-48,35],[-37,7],[60,23],[-50,0],[57,33],[-59,37],[-1,28],[70,24],[11,17],[111,-18],[47,-18],[-17,20],[-74,12],[47,5],[-89,5],[-73,-10],[31,32],[-40,20],[14,26],[55,-37],[-5,30],[39,-5],[52,9],[29,26],[133,35],[-41,-5],[-47,9],[56,17],[-54,-2],[12,20],[65,0],[26,10],[64,0],[85,-27],[-19,14],[20,19],[110,26],[-138,-23],[-14,14],[-69,-4],[9,28],[-27,17],[78,26],[47,-26],[55,17],[-17,-17],[56,16],[23,-7],[14,-32],[82,-33],[-79,43],[-5,23],[-52,13],[22,22],[45,-15],[3,29],[62,-4],[13,17],[-27,22],[45,8],[-12,16],[48,2],[28,17],[14,-36],[69,14],[-53,6],[-1,26],[112,31],[47,-51],[-25,-24],[54,-1],[-1,28],[41,7],[102,-12],[-10,24],[32,21],[-51,-13],[18,19],[56,23],[82,16],[-7,16],[-59,0],[22,23],[55,19],[-47,2],[-60,-20],[22,-28],[-33,-25],[-49,-11],[-50,-27],[-87,-21],[-37,49],[43,22],[-95,-29],[2,27],[123,47],[-46,-1],[48,58],[57,26],[-1,12],[738,1]],[[8492,7567],[2,-1]],[[8494,7566],[-36,-20],[-43,-9],[32,-14],[67,27],[7,12]],[[8521,7562],[307,-12],[283,-11],[14,4]],[[9293,6845],[18,-27],[-12,-25],[46,-38],[9,-36],[44,-41],[-32,-4],[22,-26],[5,-42],[-25,-34],[-47,-4],[-129,-107],[-92,-104],[19,-63],[-6,-25],[27,-18],[5,-21],[-66,14]],[[9079,6244],[-106,35],[-3,17],[-35,24],[-13,-8],[-31,20],[-35,-4],[-33,10],[-46,-13],[-18,-25],[-51,25],[-29,-7],[-45,5],[-37,-20],[-13,-32],[-27,12],[-38,-5],[13,16],[-10,31],[-27,0],[-39,48],[-40,-21],[-12,-27],[-42,-2],[0,25],[-26,5]],[[7420,7381],[6,11],[44,-19],[23,41],[-53,10],[-9,-14],[-24,14]],[[7408,7440],[32,-5],[84,29],[271,62],[29,17],[44,43],[87,18],[21,14],[60,21],[110,18],[86,4],[27,-12],[25,-83],[29,-17],[57,-9],[75,8],[47,19]],[[1136,2253],[34,5],[32,-24],[-14,-21],[-33,-2],[-48,26],[6,30],[23,-14]],[[3073,3327],[-20,-4],[-62,-44],[-36,5],[-21,13],[-67,3],[-41,9],[-8,-9],[-63,-14],[23,52],[18,73],[-5,97],[-15,6],[24,57],[-4,43],[-24,27],[51,-15],[-24,20],[-35,4],[-19,-16],[-37,-6],[10,34],[-14,27],[40,8],[22,19],[-14,33],[-19,-24],[2,-18],[-45,-16],[-34,9],[-1,25],[15,29],[-3,25],[17,41],[-10,41],[32,13],[30,40],[4,25],[41,108],[1,37],[20,76],[24,28],[-8,22],[-13,-32],[19,82],[-6,41],[-20,58],[2,18],[-21,67],[2,30],[24,26]],[[9110,5055],[-1,16],[-28,14],[-14,34],[17,17],[40,7],[-59,35],[-30,-10],[-27,-42],[-12,-3],[-24,36],[-30,12],[-40,-3],[-12,19],[-37,4],[-9,21],[31,4],[-1,13],[-33,14],[27,40],[-50,17],[-20,20],[-31,7],[-45,39],[6,64],[-18,-4],[-28,40],[-38,17],[-25,33]],[[9147,5968],[29,9],[23,28],[45,-25],[84,-2],[90,-23],[36,15],[27,-2],[71,-58],[45,15],[28,32],[98,9],[85,14],[26,54],[63,11]],[[9999,5984],[0,-951]],[[8521,7562],[130,61],[-73,8],[-84,-65]],[[8492,7567],[58,51],[12,32],[-4,35],[85,1],[54,27],[58,57]],[[8768,7767],[-60,-54],[-32,-21],[88,-16],[53,10],[-9,66],[16,10]],[[2150,0],[-382,0]],[[9079,6244],[-34,-52],[-17,-48],[-26,-18],[-4,-45]],[[7284,5365],[-4,11],[37,5],[-8,9]],[[7983,8276],[-1,-29],[-37,-77],[-48,-84],[-15,-52],[-20,-32],[-14,17],[0,63],[44,78],[20,5],[34,56],[16,46],[21,9]],[[8326,8398],[43,18],[-11,-45],[-25,2],[-10,-63],[32,-22],[-50,-20],[7,-17],[-66,-28],[-17,-46],[-32,-5],[12,36],[-20,47],[16,30],[-15,32],[72,72],[47,29],[17,-20]],[[8414,8435],[20,-4],[-57,-17],[37,21]],[[6912,8452],[-16,-26],[-24,-1],[-2,25],[42,2]],[[6923,8498],[3,-30],[-79,1],[56,40],[20,-11]],[[8274,8754],[5,-16],[-41,18],[36,-2]],[[8257,9040],[24,-36],[-31,15],[7,21]],[[7393,9998],[1442,0],[-75,-55],[-32,-62],[-57,-14],[-24,-36],[-62,-2],[-87,-55],[-34,29],[3,-36],[-39,13],[-5,-31],[-27,-8],[-19,-32],[-26,22],[-60,-22],[-38,-51],[9,-27],[-54,-21],[-55,11],[25,-48],[-37,-31],[-60,-14],[-27,24],[-17,-10],[4,-38],[58,-28],[-30,-6],[-7,-35],[-25,-31],[11,-53],[20,-21],[-46,14],[-42,-27],[24,-24],[-15,-21],[22,-40],[-12,-71],[32,-50],[-25,-10],[91,-21],[-1,-25],[68,18],[4,-19],[37,-28],[50,-12],[27,-30],[-33,-5],[84,-22],[17,-42],[34,-12],[-57,-29],[51,2],[-65,-27],[-6,-17],[-55,-29],[-81,-20],[42,-22],[53,7],[-12,22],[43,-30],[-73,0],[30,-42],[-76,-21],[-19,-35],[-36,11],[-33,33],[4,-43],[-32,-9],[-1,-22],[-66,-14],[-8,-18],[-34,-9],[-138,11],[28,-19],[12,13],[62,-12],[38,-26],[-56,-19],[28,-22],[-3,-48],[-21,9],[16,-35],[-15,-4],[16,-32],[-68,4],[57,-43],[-38,-32],[35,-28],[-45,-73],[24,-32],[-30,1],[7,-25],[-23,-47],[1,-25],[-28,-12],[-37,-86],[-37,-42],[-5,18],[-51,11],[-18,-14],[-157,4],[14,-33],[-58,0],[-55,-52],[-2,-22],[34,-50],[-41,-33],[-47,11],[-56,-4],[-74,-18],[-61,14],[-9,44],[27,23],[-28,19],[0,20],[-65,71],[-19,38],[38,-13],[28,10],[-44,37],[55,9],[-4,49],[-28,-2],[-26,43],[-46,23],[-30,44],[-15,54],[-34,9],[-15,25],[3,42],[-42,25],[21,15],[-25,13],[14,16],[19,80],[-25,25],[-45,-12],[34,35],[-25,10],[-5,-31],[-21,13],[-40,-11],[15,31],[-23,61],[11,20],[-23,34],[15,35],[31,2],[18,-24]],[[6751,2518],[26,-23],[-35,-40],[-15,24],[-15,-6],[0,43],[39,2]],[[6821,2731],[-26,-23],[5,22],[21,1]],[[6284,3266],[61,20],[27,32],[34,20],[27,0],[78,27],[24,-4],[-16,-29],[22,-16],[0,29],[36,1],[42,-22],[-19,-37],[34,-36],[-15,-17],[33,-20],[21,11],[4,21],[35,9],[37,40],[26,5],[14,-59],[-19,-13],[-45,-82],[-56,-29],[-8,-29],[2,-42],[26,-51],[44,-18],[0,-16],[43,-21],[-2,-68],[23,-24],[-48,-70],[-1,-20],[-36,-48],[-23,-12],[-5,-20],[-33,-13],[-61,-41],[-22,-42],[6,-42],[23,-36],[34,-34],[32,-13],[44,15],[0,-56],[40,14],[14,25],[27,-25],[-5,-20],[15,-30],[3,-30],[65,-8]],[[9766,4055],[-44,-14],[-16,6],[19,21],[31,9],[10,-22]],[[9999,4524],[0,-355],[-16,-1],[-73,-39],[-13,-23],[-38,-33],[-11,-18],[-39,-26],[18,51],[-12,16],[78,46],[46,23],[-7,14],[-57,-15],[-84,1],[-9,34]],[[9999,3523],[-36,19],[-15,-7],[-22,43],[-25,-2],[-5,-21],[-34,23],[-42,15],[49,23],[7,16],[-29,25],[-2,32],[26,0],[29,-35],[-9,-26],[17,-26],[6,30],[19,-18],[66,16],[0,-107]],[[9999,3637],[-38,-5],[-37,45],[-7,26],[44,12],[-8,12],[32,13],[-3,17],[-35,-8],[-12,30],[15,9],[-45,56],[55,46],[-8,25],[-87,-16],[-61,-16],[-16,5],[15,36],[0,77],[8,17],[24,3],[18,39],[21,10],[42,43],[56,0],[27,16],[0,-492]],[[9999,6904],[0,-830]]],\"transform\":{\"scale\":[0.004986829262226212,0.004072407240724072],\"translate\":[-22.73680579299989,23.64]}},\"route\":{\"type\":\"Topology\",\"bbox\":[-9.489908,36.014466,13.438575,53.569421],\"objects\":{\"route\":{\"type\":\"GeometryCollection\",\"geometries\":[{\"type\":\"LineString\",\"arcs\":[0,1]}]}},\"arcs\":[[[13.4294,52.486752],[13.427112,52.487307],[13.425447,52.487947],[13.424177,52.489814],[13.422464,52.492632],[13.420527,52.495617],[13.420077,52.495998],[13.418527,52.49933],[13.41759,52.49908],[13.414562,52.498675],[13.412356,52.498725],[13.409784,52.498595],[13.405674,52.498493],[13.400258,52.498508],[13.395885,52.498382],[13.39423,52.498109],[13.392704,52.498058],[13.391149,52.497874],[13.389472,52.49799],[13.38532,52.498915],[13.383821,52.499185],[13.380565,52.499255],[13.379593,52.499441],[13.378466,52.500036],[13.377435,52.50141],[13.376567,52.502268],[13.374487,52.503316],[13.372937,52.504741],[13.372233,52.505118],[13.372638,52.50677],[13.368289,52.525188],[13.36808,52.525737],[13.367521,52.525965],[13.365692,52.525443],[13.365396,52.525543],[13.36404,52.527201],[13.364082,52.528084],[13.357617,52.535848],[13.356755,52.535729],[13.356474,52.536306],[13.35575,52.536724],[13.354528,52.536803],[13.352775,52.536641],[13.351594,52.53624],[13.348797,52.535869],[13.344169,52.535378],[13.343432,52.535151],[13.341736,52.534986],[13.34007,52.535032],[13.33679,52.534534],[13.332336,52.533991],[13.329621,52.533101],[13.328635,52.533059],[13.328277,52.534247],[13.328445,52.534698],[13.328124,52.535345],[13.326909,52.536751],[13.326269,52.538307],[13.326338,52.538956],[13.326976,52.539764],[13.327032,52.540416],[13.326438,52.54099],[13.324942,52.541738],[13.324166,52.542273],[13.318594,52.546615],[13.316593,52.547431],[13.315219,52.547606],[13.312185,52.54766],[13.308268,52.547855],[13.302707,52.547969],[13.302291,52.547897],[13.301501,52.547185],[13.300894,52.547084],[13.30038,52.547458],[13.300575,52.547896],[13.302156,52.549873],[13.304301,52.552322],[13.306534,52.554736],[13.30996,52.558299],[13.309031,52.566459],[13.307532,52.566957],[13.306387,52.567892],[13.305793,52.569365],[13.305825,52.571317],[13.305688,52.572385],[13.304964,52.573755],[13.304071,52.574547],[13.301904,52.575786],[13.299424,52.576949],[13.297973,52.577836],[13.29649,52.579226],[13.295023,52.581261],[13.291991,52.585819],[13.286679,52.593194],[13.28646,52.593782],[13.285375,52.595694],[13.284499,52.59684],[13.282991,52.598246],[13.281161,52.60027],[13.279778,52.601314],[13.278213,52.602072],[13.275826,52.602793],[13.273358,52.603389],[13.272013,52.603928],[13.269862,52.605164],[13.267258,52.606192],[13.261482,52.608],[13.250254,52.612357],[13.248726,52.613241],[13.248205,52.613783],[13.247878,52.614708],[13.248129,52.615341],[13.248735,52.615867],[13.250716,52.616983],[13.251352,52.617475],[13.251568,52.618077],[13.250892,52.619247],[13.249477,52.620169],[13.248866,52.621041],[13.248912,52.622315],[13.24844,52.622908],[13.244174,52.625927],[13.241741,52.628206],[13.241078,52.629035],[13.24076,52.629772],[13.240596,52.631177],[13.241049,52.634141],[13.241807,52.638351],[13.24213,52.64059],[13.242649,52.64352],[13.243355,52.648059],[13.243935,52.651264],[13.244108,52.652623],[13.244163,52.654887],[13.244068,52.656498],[13.243727,52.658562],[13.243109,52.66082],[13.241888,52.663674],[13.240796,52.665541],[13.240011,52.666695],[13.23839,52.668718],[13.236406,52.670904],[13.234888,52.672284],[13.233364,52.673492],[13.229935,52.675796],[13.219584,52.681966],[13.211967,52.686399],[13.210456,52.687328],[13.207155,52.68969],[13.204459,52.691957],[13.202908,52.693413],[13.200926,52.695512],[13.199485,52.697293],[13.1985,52.698698],[13.19718,52.700983],[13.194709,52.705553],[13.193942,52.706541],[13.192264,52.707673],[13.191345,52.708063],[13.189659,52.708503],[13.187445,52.708673],[13.185954,52.708574],[13.184204,52.708207],[13.182638,52.70759],[13.180877,52.706731],[13.178903,52.706109],[13.177816,52.705947],[13.17055,52.705834],[13.168775,52.70576],[13.16365,52.705709],[13.159848,52.70575],[13.151403,52.705741],[13.142891,52.705837],[13.137355,52.706043],[13.133385,52.706287],[13.120996,52.707278],[13.118312,52.707427],[13.113004,52.707549],[13.10752,52.707469],[13.10394,52.7073],[13.102495,52.70747],[13.102135,52.707894],[13.102416,52.708244],[13.104312,52.708683],[13.104414,52.708858],[13.103381,52.710825],[13.101132,52.714284],[13.101537,52.715687],[13.100643,52.717839],[13.09868,52.720157],[13.097198,52.721654],[13.09681,52.722242],[13.097224,52.724392],[13.096985,52.724782],[13.096074,52.725305],[13.094312,52.726758],[13.093256,52.728224],[13.092014,52.731597],[13.091867,52.731742],[13.093214,52.728121],[13.094502,52.726496],[13.096243,52.725144],[13.09709,52.724641],[13.097127,52.72415],[13.09673,52.722567],[13.0969,52.7219],[13.099187,52.71951],[13.10039,52.718114],[13.101442,52.715587],[13.100992,52.714377],[13.103443,52.710596],[13.104255,52.708804],[13.102803,52.708408],[13.101838,52.707982],[13.101268,52.707273],[13.100619,52.707001],[13.094636,52.70627],[13.090264,52.705798],[13.083154,52.704961],[13.080594,52.704708],[13.075775,52.704415],[13.073135,52.704333],[13.068227,52.704413],[13.062423,52.704791],[13.059946,52.705051],[13.056122,52.705589],[13.052669,52.706148],[13.043559,52.707756],[13.036565,52.708941],[13.03516,52.70915],[13.026843,52.71058],[13.019035,52.711843],[13.015517,52.712499],[13.011977,52.7131],[13.003271,52.714449],[12.994516,52.715689],[12.990042,52.716244],[12.98656,52.7166],[12.980259,52.717316],[12.966592,52.718457],[12.961535,52.719196],[12.958317,52.719766],[12.953041,52.720949],[12.950937,52.721508],[12.94797,52.722438],[12.945502,52.723356],[12.94178,52.724913],[12.939097,52.726177],[12.928536,52.731466],[12.919555,52.736028],[12.912805,52.739269],[12.907113,52.741651],[12.904378,52.742706],[12.899684,52.744327],[12.895187,52.745718],[12.892872,52.746359],[12.888655,52.747438],[12.885615,52.748153],[12.882406,52.748811],[12.874223,52.750314],[12.864873,52.75192],[12.860232,52.752776],[12.857269,52.753394],[12.854548,52.754379],[12.852322,52.754913],[12.850998,52.754742],[12.846764,52.755782],[12.842707,52.757001],[12.83714,52.758894],[12.83442,52.759935],[12.831691,52.761065],[12.827506,52.762978],[12.823818,52.764891],[12.820258,52.766961],[12.816844,52.769153],[12.813417,52.771677],[12.810464,52.774065],[12.80736,52.777007],[12.805814,52.77865],[12.803545,52.78126],[12.801023,52.78471],[12.800119,52.786102],[12.798246,52.789399],[12.797527,52.790973],[12.796226,52.794475],[12.795421,52.797321],[12.794967,52.799642],[12.794516,52.803537],[12.79437,52.805776],[12.794327,52.81233],[12.794399,52.820592],[12.794259,52.82515],[12.79382,52.828132],[12.793175,52.830446],[12.792557,52.832113],[12.791512,52.834363],[12.789981,52.836959],[12.788161,52.839404],[12.786485,52.841335],[12.785079,52.842758],[12.779501,52.847823],[12.776859,52.850324],[12.773113,52.854095],[12.76974,52.857939],[12.768208,52.860017],[12.766525,52.86254],[12.764108,52.866796],[12.762795,52.869434],[12.760585,52.873621],[12.753627,52.886993],[12.751044,52.891992],[12.74941,52.894864],[12.748265,52.896575],[12.746776,52.898444],[12.745211,52.900185],[12.743491,52.901875],[12.742037,52.903172],[12.74048,52.904418],[12.738252,52.90599],[12.735627,52.907677],[12.734221,52.908469],[12.72723,52.912711],[12.725224,52.914076],[12.722827,52.915825],[12.721444,52.916926],[12.715902,52.921602],[12.711565,52.92535],[12.709013,52.927371],[12.706777,52.928928],[12.70521,52.929929],[12.702126,52.931672],[12.699169,52.933155],[12.696695,52.934236],[12.692166,52.935954],[12.683985,52.938742],[12.679125,52.940426],[12.674766,52.94219],[12.672387,52.943306],[12.667984,52.945754],[12.664518,52.948088],[12.66218,52.94985],[12.655782,52.954988],[12.652633,52.95733],[12.6497,52.959237],[12.647242,52.960681],[12.641583,52.963754],[12.639635,52.964874],[12.636106,52.967028],[12.634056,52.968421],[12.630617,52.971279],[12.628551,52.973233],[12.626849,52.975079],[12.621197,52.981601],[12.619227,52.983777],[12.617339,52.985713],[12.614329,52.988557],[12.611135,52.991256],[12.604714,52.996425],[12.596557,53.003077],[12.59069,53.007766],[12.585207,53.012405],[12.581439,53.015971],[12.577929,53.019648],[12.575475,53.022532],[12.573884,53.024491],[12.570999,53.028243],[12.569236,53.030404],[12.568182,53.031568],[12.565883,53.033851],[12.564179,53.035333],[12.560409,53.038083],[12.557618,53.039873],[12.548289,53.045508],[12.546086,53.046947],[12.544477,53.048104],[12.541951,53.050163],[12.539393,53.052477],[12.537791,53.05412],[12.535576,53.056822],[12.534336,53.058581],[12.533219,53.060368],[12.532165,53.062412],[12.531233,53.064449],[12.528351,53.071169],[12.527106,53.07396],[12.525295,53.077208],[12.524298,53.078661],[12.522726,53.080738],[12.521031,53.082764],[12.518788,53.085113],[12.516363,53.087344],[12.513174,53.08984],[12.509567,53.092233],[12.507148,53.09375],[12.50247,53.096226],[12.499055,53.097815],[12.485092,53.103883],[12.480934,53.105883],[12.477558,53.107771],[12.47549,53.109108],[12.473766,53.110329],[12.471665,53.111947],[12.469549,53.113813],[12.467783,53.115566],[12.465905,53.117753],[12.464469,53.119744],[12.462452,53.12349],[12.462289,53.124327],[12.462412,53.125192],[12.462784,53.126017],[12.463607,53.126953],[12.464858,53.127994],[12.465643,53.128918],[12.466116,53.13033],[12.465989,53.13137],[12.465338,53.132533],[12.46397,53.133696],[12.462672,53.134355],[12.460161,53.134977],[12.458459,53.135117],[12.455329,53.135235],[12.451064,53.135515],[12.44821,53.135777],[12.444748,53.136222],[12.439533,53.137047],[12.434328,53.138101],[12.430177,53.139111],[12.426764,53.140104],[12.4234,53.141213],[12.419114,53.142833],[12.41534,53.144469],[12.410688,53.146821],[12.407713,53.148546],[12.403921,53.151023],[12.401673,53.152764],[12.399297,53.154506],[12.397492,53.15572],[12.39505,53.157208],[12.391125,53.159393],[12.388149,53.160854],[12.385704,53.161959],[12.381943,53.163509],[12.378751,53.164646],[12.375412,53.165686],[12.372356,53.166564],[12.369258,53.167376],[12.365446,53.168253],[12.36022,53.169193],[12.357013,53.169659],[12.353781,53.170047],[12.34402,53.17093],[12.339295,53.171333],[12.337175,53.171572],[12.332397,53.172008],[12.328073,53.1726],[12.323076,53.17348],[12.319252,53.174301],[12.313884,53.17566],[12.308613,53.177258],[12.305139,53.178479],[12.300206,53.180474],[12.295902,53.182532],[12.292407,53.184417],[12.288832,53.186574],[12.286929,53.187862],[12.283745,53.190189],[12.281251,53.192261],[12.27883,53.194389],[12.275762,53.196812],[12.273121,53.198702],[12.270344,53.200539],[12.268007,53.201967],[12.265377,53.203486],[12.256711,53.208058],[12.242883,53.215299],[12.240422,53.21661],[12.223865,53.225227],[12.22063,53.226813],[12.217925,53.228048],[12.213491,53.229838],[12.208909,53.231496],[12.205215,53.232736],[12.201381,53.234165],[12.197704,53.235726],[12.19385,53.237582],[12.189378,53.240016],[12.186969,53.24149],[12.183567,53.243929],[12.179779,53.246736],[12.177809,53.248079],[12.174283,53.250328],[12.169703,53.252998],[12.164414,53.255752],[12.160223,53.25774],[12.15623,53.259449],[12.152141,53.261057],[12.147278,53.262788],[12.142669,53.264261],[12.136873,53.265896],[12.134108,53.266605],[12.130361,53.267482],[12.11996,53.269714],[12.103003,53.273428],[12.099568,53.274298],[12.094329,53.275874],[12.091783,53.276733],[12.088629,53.277917],[12.084713,53.279592],[12.081217,53.281262],[12.076696,53.283569],[12.073456,53.285046],[12.071042,53.286068],[12.067296,53.28746],[12.062865,53.288898],[12.060282,53.289653],[12.05536,53.290965],[12.051992,53.291728],[12.049267,53.292274],[12.042391,53.293445],[12.037947,53.2941],[12.032966,53.294785],[12.026593,53.295522],[12.019454,53.296231],[12.012393,53.296691],[12.008438,53.296885],[12.003468,53.297038],[11.984331,53.297156],[11.975272,53.297232],[11.964501,53.297279],[11.961405,53.297329],[11.9568,53.297511],[11.951136,53.297951],[11.94853,53.298223],[11.944425,53.298762],[11.938955,53.299715],[11.934181,53.300721],[11.931615,53.301339],[11.926356,53.30281],[11.923013,53.303887],[11.918794,53.305414],[11.915656,53.306674],[11.913202,53.307765],[11.908496,53.310063],[11.905986,53.311431],[11.903637,53.312838],[11.900417,53.314897],[11.893962,53.319686],[11.88915,53.323043],[11.884905,53.325692],[11.881854,53.327368],[11.879507,53.328541],[11.876155,53.330093],[11.873589,53.331167],[11.869023,53.332892],[11.865942,53.333906],[11.860282,53.335532],[11.855289,53.336705],[11.846914,53.338329],[11.844343,53.338898],[11.839124,53.340227],[11.835051,53.341383],[11.832699,53.342106],[11.826906,53.344094],[11.823563,53.34516],[11.818705,53.346434],[11.816231,53.347008],[11.811212,53.347962],[11.805181,53.348877],[11.800223,53.349336],[11.794283,53.349818],[11.788741,53.350524],[11.785971,53.350964],[11.782891,53.351537],[11.778566,53.352508],[11.774928,53.353448],[11.770546,53.354828],[11.766514,53.356284],[11.763799,53.357367],[11.760333,53.358934],[11.755614,53.360944],[11.752772,53.362016],[11.748624,53.363404],[11.745059,53.364437],[11.742762,53.365028],[11.738359,53.36603],[11.734865,53.366695],[11.731425,53.367243],[11.726503,53.367785],[11.723626,53.368035],[11.717713,53.368312],[11.708155,53.368423],[11.701899,53.368445],[11.690267,53.368563],[11.686694,53.36857],[11.675375,53.36868],[11.667775,53.368883],[11.663378,53.369137],[11.657338,53.369743],[11.653032,53.370364],[11.64966,53.370969],[11.645596,53.371798],[11.641613,53.372757],[11.637478,53.373935],[11.633637,53.375214],[11.631081,53.37615],[11.626193,53.378192],[11.623574,53.37941],[11.620146,53.38116],[11.616353,53.383404],[11.611135,53.386793],[11.608977,53.38807],[11.60702,53.389123],[11.604692,53.390259],[11.600044,53.392238],[11.595936,53.393733],[11.592029,53.39505],[11.58643,53.397037],[11.583922,53.398065],[11.580592,53.39963],[11.576386,53.401929],[11.57269,53.404295],[11.569056,53.406773],[11.566131,53.408618],[11.564479,53.409579],[11.560037,53.411838],[11.557877,53.412797],[11.555671,53.413672],[11.551481,53.415147],[11.547595,53.416279],[11.543025,53.417425],[11.537372,53.418668],[11.532878,53.419767],[11.530285,53.420466],[11.526887,53.421547],[11.521182,53.423675],[11.517547,53.424975],[11.515198,53.425759],[11.511334,53.426932],[11.507713,53.427869],[11.501234,53.429272],[11.497967,53.429892],[11.492658,53.430728],[11.486213,53.431444],[11.482288,53.431753],[11.476154,53.432029],[11.47289,53.432065],[11.468147,53.431991],[11.46519,53.43189],[11.462264,53.431718],[11.457891,53.431357],[11.449499,53.430528],[11.444416,53.430156],[11.440728,53.429992],[11.434778,53.429915],[11.429257,53.430045],[11.423162,53.430388],[11.419643,53.430706],[11.414887,53.431298],[11.410839,53.431911],[11.405717,53.432911],[11.401268,53.433928],[11.396713,53.435115],[11.393098,53.436164],[11.389544,53.437341],[11.385068,53.439004],[11.381951,53.440288],[11.377328,53.44242],[11.374082,53.444093],[11.371802,53.445373],[11.369056,53.447027],[11.363316,53.450692],[11.356948,53.454705],[11.350024,53.459103],[11.346738,53.461026],[11.341931,53.463401],[11.339755,53.464374],[11.336284,53.465798],[11.334031,53.466621],[11.330084,53.467901],[11.325207,53.469252],[11.320925,53.470241],[11.315526,53.471364],[11.311915,53.472255],[11.307442,53.473547],[11.304134,53.474629],[11.301854,53.475467],[11.297447,53.477289],[11.292131,53.479692],[11.289812,53.480661],[11.285746,53.482183],[11.282316,53.483298],[11.279548,53.484118],[11.274597,53.48536],[11.270332,53.48626],[11.267423,53.486745],[11.262958,53.487387],[11.259934,53.487716],[11.256887,53.48798],[11.252616,53.488249],[11.24908,53.488326],[11.244435,53.488309],[11.239112,53.48805],[11.236112,53.487793],[11.23208,53.487362],[11.226596,53.486619],[11.221794,53.48612],[11.219193,53.485917],[11.213521,53.485711],[11.209372,53.485708],[11.205304,53.485827],[11.200189,53.486146],[11.195137,53.486686],[11.187918,53.48767],[11.179158,53.488919],[11.169808,53.4902],[11.158372,53.491819],[11.153248,53.492504],[11.145948,53.493546],[11.139348,53.494321],[11.134679,53.494785],[11.123892,53.495759],[11.120957,53.49599],[11.108813,53.497145],[11.102522,53.497587],[11.097784,53.497839],[11.090971,53.49808],[11.08411,53.498284],[11.078242,53.498563],[11.073843,53.498846],[11.06754,53.499383],[11.063135,53.499861],[11.049002,53.501553],[11.042988,53.502232],[11.03004,53.503763],[11.019191,53.505024],[11.01188,53.505911],[11.00645,53.50652],[11.001795,53.507092],[10.984787,53.509084],[10.979336,53.509752],[10.975321,53.510205],[10.968676,53.510787],[10.962796,53.511163],[10.955006,53.511516],[10.949465,53.511815],[10.94067,53.512249],[10.936323,53.512387],[10.931554,53.5124],[10.926737,53.512235],[10.913805,53.511441],[10.908441,53.511276],[10.905517,53.511241],[10.898084,53.511347],[10.893612,53.511379],[10.890386,53.511448],[10.876994,53.511575],[10.870202,53.511623],[10.865597,53.511716],[10.856049,53.511821],[10.849919,53.512101],[10.843818,53.512588],[10.839843,53.513061],[10.836392,53.513565],[10.832236,53.514251],[10.826435,53.515381],[10.810908,53.519229],[10.793058,53.523677],[10.789924,53.52444],[10.782067,53.52643],[10.775442,53.528057],[10.770358,53.529207],[10.768222,53.529755],[10.760219,53.531408],[10.742632,53.534904],[10.736151,53.53626],[10.731591,53.537331],[10.728094,53.538269],[10.727003,53.538672],[10.720746,53.540492],[10.719026,53.541086],[10.70695,53.545097],[10.700245,53.547161],[10.697693,53.547808],[10.691531,53.549094],[10.685679,53.550048],[10.68124,53.55065],[10.678307,53.550993],[10.67287,53.55149],[10.668525,53.551803],[10.66595,53.551928],[10.660201,53.55206],[10.654846,53.552091],[10.644275,53.551903],[10.638127,53.551734],[10.636424,53.551628],[10.632027,53.551563],[10.627786,53.551666],[10.624956,53.551882],[10.621422,53.552301],[10.617654,53.552957],[10.611911,53.554163],[10.607442,53.555018],[10.604176,53.555461],[10.601772,53.555701],[10.593178,53.556213],[10.587901,53.556754],[10.583045,53.557594],[10.580194,53.558269],[10.573824,53.559921],[10.569826,53.560738],[10.567192,53.561156],[10.56346,53.561584],[10.555282,53.562247],[10.551538,53.562649],[10.54829,53.563143],[10.54259,53.56429],[10.533686,53.56628],[10.52751,53.567625],[10.521912,53.568607],[10.519292,53.56892],[10.515043,53.569266],[10.512112,53.569384],[10.507927,53.569417],[10.504434,53.569331],[10.499382,53.568996],[10.496687,53.568711],[10.490811,53.567884],[10.485837,53.567263],[10.476397,53.565883],[10.468991,53.564773],[10.464948,53.564207],[10.459135,53.563283],[10.449219,53.561819],[10.444506,53.561258],[10.439566,53.560584],[10.434397,53.56005],[10.430439,53.559786],[10.426417,53.559653],[10.420393,53.559691],[10.417614,53.559801],[10.412343,53.560157],[10.409216,53.560427],[10.403421,53.561003],[10.396343,53.561647],[10.39158,53.56214],[10.385658,53.562584],[10.383276,53.562671],[10.379314,53.562643],[10.37816,53.562572],[10.374279,53.562119],[10.366594,53.561137],[10.365828,53.561006],[10.361845,53.56059],[10.357454,53.560351],[10.353165,53.56037],[10.348214,53.560753],[10.343975,53.561479],[10.342496,53.561792],[10.336725,53.563171],[10.33022,53.564812],[10.325677,53.565916],[10.321383,53.566887],[10.317335,53.567495],[10.313016,53.567947],[10.308768,53.56821],[10.303921,53.568327],[10.300088,53.568283],[10.297968,53.5682],[10.294051,53.567935],[10.279384,53.566671],[10.27231,53.565921],[10.268643,53.565468],[10.258044,53.563841],[10.246671,53.561992],[10.244419,53.561667],[10.235855,53.560294],[10.228424,53.559135],[10.22393,53.558515],[10.218316,53.55792],[10.213809,53.557639],[10.204795,53.557192],[10.20256,53.55713],[10.199573,53.557166],[10.196601,53.557315],[10.194414,53.557498],[10.189622,53.558158],[10.186359,53.558801],[10.176153,53.561032],[10.173709,53.561483],[10.170404,53.561809],[10.169683,53.561669],[10.166602,53.561683],[10.163205,53.561516],[10.161743,53.561264],[10.159651,53.560714],[10.158098,53.560039],[10.155876,53.558838],[10.153639,53.557008],[10.152376,53.555608],[10.151627,53.554558],[10.15048,53.552612],[10.149566,53.550597],[10.147209,53.544503],[10.146451,53.542928],[10.144836,53.540251],[10.143718,53.538741],[10.140152,53.534469],[10.138628,53.532787],[10.135811,53.529903],[10.13313,53.527358],[10.131082,53.525751],[10.12867,53.523976],[10.124929,53.521499],[10.121813,53.519666],[10.117579,53.51746],[10.113587,53.5156],[10.108518,53.513568],[10.105454,53.512453],[10.100841,53.510935],[10.096894,53.509849],[10.092638,53.508736],[10.088982,53.50793],[10.085502,53.50746],[10.08202,53.507293],[10.07994,53.507349],[10.077501,53.507559],[10.075149,53.507886],[10.069696,53.508884],[10.067563,53.509141],[10.065399,53.509278],[10.059797,53.509404],[10.046405,53.509761],[10.044659,53.509871],[10.038506,53.510013],[10.037098,53.510239],[10.035525,53.510988],[10.03454,53.511754],[10.032327,53.514131],[10.031735,53.515163],[10.030967,53.515989],[10.030009,53.516515],[10.028346,53.517098],[10.026411,53.517379],[10.024071,53.517309],[10.021614,53.517582],[10.018534,53.517683],[10.014786,53.517549],[10.014313,53.518183],[10.015468,53.518591],[10.01553,53.519626],[10.015822,53.521177],[10.013078,53.52135],[10.007904,53.520862],[10.002386,53.520275],[9.999662,53.520073],[9.995125,53.519554],[9.988547,53.519043],[9.987314,53.519138],[9.985634,53.520123],[9.984282,53.520484],[9.983007,53.52037],[9.982287,53.520096],[9.980673,53.51914],[9.9798,53.518404],[9.981729,53.517186],[9.984443,53.516415],[9.987721,53.515654],[9.993036,53.5154],[9.993356,53.515431],[9.993654,53.517998],[9.993885,53.519247],[9.994124,53.519392],[10.000821,53.520096],[10.006414,53.520623],[10.011392,53.521129],[10.013319,53.521258],[10.015014,53.521008],[10.015367,53.520205],[10.0152,53.519002],[10.015396,53.51834],[10.016249,53.516844],[10.015896,53.5165],[10.015215,53.516437],[10.014663,53.516923],[10.015005,53.517284],[10.016563,53.517454],[10.020477,53.517474],[10.022607,53.517286],[10.024754,53.516959],[10.028265,53.516288],[10.029597,53.515775],[10.030725,53.51501],[10.033892,53.511576],[10.035404,53.50973],[10.037306,53.506975],[10.038218,53.505414],[10.03877,53.504109],[10.039016,53.502824],[10.038964,53.501573],[10.038434,53.499881],[10.037696,53.498634],[10.034041,53.494261],[10.032818,53.49291],[10.027147,53.486088],[10.023958,53.482192],[10.022727,53.480287],[10.022226,53.478274],[10.022406,53.47598],[10.022689,53.474496],[10.02359,53.470702],[10.024593,53.4661],[10.025105,53.464016],[10.026779,53.458315],[10.028739,53.45147],[10.028992,53.450049],[10.029572,53.443774],[10.029973,53.441647],[10.030399,53.440232],[10.033321,53.431925],[10.034368,53.429206],[10.034597,53.428059],[10.034523,53.426444],[10.034274,53.425537],[10.033346,53.423382],[10.03114,53.41907],[10.030687,53.417892],[10.02996,53.415529],[10.028697,53.410292],[10.028391,53.408671],[10.02757,53.40513],[10.02691,53.402784],[10.026752,53.401868],[10.026022,53.399278],[10.025477,53.397897],[10.023565,53.393589],[10.022798,53.391982],[10.021134,53.387932],[10.019933,53.385607],[10.017838,53.383094],[10.016105,53.381759],[10.015182,53.381328],[10.013186,53.380734],[10.011755,53.380547],[10.00859,53.380702],[10.004783,53.381222],[10.003009,53.381565],[9.999954,53.381755],[9.998524,53.381715],[9.990142,53.381139],[9.985238,53.380845],[9.982712,53.380757],[9.979778,53.380511],[9.976578,53.380342],[9.973518,53.380115],[9.967321,53.379488],[9.96209,53.378852],[9.959594,53.37864],[9.954872,53.378143],[9.952276,53.378],[9.950043,53.377767],[9.947803,53.377406],[9.939752,53.376608],[9.928089,53.375319],[9.906984,53.373103],[9.902282,53.372584],[9.891594,53.371463],[9.887331,53.371214],[9.884607,53.371268],[9.882295,53.371396],[9.877962,53.371882],[9.867608,53.372963],[9.864897,53.373124],[9.861681,53.373116],[9.843887,53.372522],[9.842466,53.372511],[9.838985,53.372319],[9.834017,53.372205],[9.828793,53.372146],[9.828428,53.372089],[9.81801,53.37178],[9.806114,53.37137],[9.796827,53.371096],[9.790077,53.370841],[9.788907,53.370848],[9.783377,53.370611],[9.780555,53.370582],[9.771567,53.370245],[9.7569,53.369772],[9.754026,53.36966],[9.751566,53.369471],[9.74913,53.369163],[9.746374,53.368634],[9.738712,53.366607],[9.736149,53.365868],[9.732551,53.364912],[9.728588,53.363794],[9.726733,53.363327],[9.723567,53.362396],[9.721676,53.361942],[9.714464,53.359859],[9.709409,53.358471],[9.703462,53.356975],[9.701214,53.356254],[9.696484,53.3549],[9.685382,53.35178],[9.674877,53.348846],[9.664188,53.34592],[9.644849,53.340529],[9.640876,53.339467],[9.638872,53.338871],[9.626482,53.335414],[9.619626,53.33348],[9.607834,53.330253],[9.6031,53.328926],[9.60077,53.328227],[9.595535,53.326426],[9.591699,53.324907],[9.582619,53.320999],[9.575962,53.31811],[9.566189,53.313915],[9.563088,53.312558],[9.553553,53.308465],[9.551688,53.307621],[9.539362,53.302298],[9.536908,53.301296],[9.536068,53.300844],[9.530087,53.298316],[9.527858,53.297445],[9.525599,53.29666],[9.522821,53.295859],[9.520753,53.295337],[9.505778,53.29184],[9.501579,53.290833],[9.489418,53.287978],[9.485212,53.286858],[9.48291,53.286098],[9.478168,53.284206],[9.475905,53.283062],[9.467994,53.278422],[9.461907,53.274812],[9.458234,53.2727],[9.451797,53.268931],[9.44315,53.263803],[9.433488,53.258147],[9.431156,53.256821],[9.424663,53.252943],[9.421469,53.251203],[9.417776,53.249409],[9.415872,53.248582],[9.407349,53.24522],[9.402125,53.243118],[9.400066,53.242369],[9.396872,53.2414],[9.394685,53.240851],[9.391329,53.240147],[9.383213,53.238978],[9.37366,53.237511],[9.367777,53.236852],[9.361977,53.236338],[9.359664,53.23606],[9.355826,53.235431],[9.353629,53.234961],[9.350592,53.234189],[9.341258,53.231567],[9.338856,53.230805],[9.336895,53.230076],[9.334082,53.228779],[9.332821,53.228092],[9.328762,53.225443],[9.323596,53.221769],[9.320299,53.218962],[9.316822,53.21572],[9.315653,53.214803],[9.31202,53.21154],[9.310226,53.210202],[9.306653,53.207994],[9.302037,53.204888],[9.300044,53.203647],[9.292258,53.198531],[9.281725,53.191577],[9.277227,53.188497],[9.27556,53.187258],[9.273064,53.185572],[9.2711,53.183962],[9.269611,53.182848],[9.266414,53.180774],[9.26483,53.179542],[9.262544,53.178084],[9.254309,53.172639],[9.250258,53.169664],[9.248437,53.168166],[9.243003,53.163231],[9.238763,53.159303],[9.236624,53.15708],[9.234272,53.154444],[9.231608,53.151553],[9.224423,53.143583],[9.222859,53.141632],[9.220564,53.138362],[9.219864,53.137226],[9.217003,53.132281],[9.215882,53.1302],[9.214368,53.127708],[9.212995,53.125173],[9.210012,53.120006],[9.208101,53.117345],[9.206347,53.115442],[9.203746,53.113027],[9.202179,53.111665],[9.197893,53.107751],[9.186032,53.096865],[9.184589,53.095506],[9.18331,53.094109],[9.182454,53.093585],[9.179753,53.091189],[9.179418,53.090753],[9.176909,53.088963],[9.174624,53.087613],[9.169581,53.085306],[9.16533,53.083712],[9.164399,53.083418],[9.159136,53.081532],[9.145046,53.076677],[9.140645,53.075102],[9.138602,53.074438],[9.13062,53.071653],[9.129028,53.071033],[9.127378,53.070519],[9.103272,53.062112],[9.100556,53.06123],[9.09785,53.060427],[9.093695,53.059369],[9.088211,53.058231],[9.084041,53.057551],[9.080119,53.057044],[9.072506,53.056222],[9.064881,53.055442],[9.05758,53.054614],[9.046082,53.053404],[9.043644,53.053192],[9.039696,53.052958],[9.017547,53.052204],[9.015492,53.052054],[9.012178,53.051607],[9.007704,53.050625],[9.006182,53.050157],[9.003038,53.049031],[8.996733,53.046588],[8.992541,53.045046],[8.988651,53.043748],[8.986587,53.043287],[8.985024,53.043301],[8.982214,53.043566],[8.98036,53.044194],[8.978448,53.045278],[8.975196,53.047472],[8.974159,53.048315],[8.972614,53.049908],[8.971377,53.051743],[8.969455,53.056223],[8.965139,53.065819],[8.964032,53.06851],[8.963384,53.069752],[8.962233,53.071405],[8.961299,53.072394],[8.95978,53.073717],[8.958522,53.074581],[8.956863,53.075526],[8.954413,53.076657],[8.952699,53.077242],[8.949171,53.078131],[8.945607,53.078676],[8.942743,53.078956],[8.93799,53.079243],[8.934639,53.079282],[8.922617,53.078953],[8.92072,53.078975],[8.918791,53.07911],[8.915034,53.079672],[8.911875,53.080462],[8.909305,53.081399],[8.908116,53.081945],[8.905924,53.08319],[8.892994,53.091563],[8.889515,53.09386],[8.888559,53.094569],[8.886866,53.096084],[8.88545,53.097853],[8.88391,53.100447],[8.883333,53.101227],[8.881915,53.102762],[8.880173,53.104148],[8.87867,53.105131],[8.877031,53.105985],[8.868712,53.109675],[8.863226,53.112068],[8.859988,53.113308],[8.857755,53.113992],[8.853801,53.114904],[8.851767,53.115223],[8.849675,53.115438],[8.847212,53.11558],[8.832482,53.116055],[8.822532,53.116411],[8.816144,53.116773],[8.814539,53.117156],[8.813676,53.117716],[8.812455,53.117829],[8.811873,53.117331],[8.811112,53.113456],[8.809998,53.112088],[8.808934,53.111432],[8.805854,53.109776],[8.80407,53.108657],[8.803157,53.107577],[8.801549,53.104281],[8.800353,53.103081],[8.799008,53.102827],[8.794375,53.103202],[8.788873,53.103489],[8.786464,53.103222],[8.784693,53.102179],[8.781579,53.101105],[8.780939,53.101776],[8.778722,53.101011],[8.779347,53.100263],[8.781587,53.100966],[8.785246,53.102278],[8.786152,53.102973],[8.788411,53.103369],[8.792418,53.10319],[8.794152,53.103054],[8.794032,53.101472],[8.795951,53.101207],[8.796594,53.101329],[8.794263,53.101458],[8.794054,53.101826],[8.79415,53.103033],[8.797073,53.102726],[8.798074,53.102757],[8.798939,53.102565],[8.799153,53.101952],[8.79642,53.099748],[8.795664,53.0987],[8.794285,53.093944],[8.793665,53.09294],[8.794144,53.091783],[8.796531,53.088608],[8.797369,53.087941],[8.79896,53.087395],[8.802774,53.085845],[8.807069,53.0838],[8.808261,53.083106],[8.808431,53.083275],[8.805446,53.084816],[8.802125,53.086365],[8.799571,53.087353],[8.798676,53.087542],[8.797707,53.087461],[8.797088,53.0872],[8.795569,53.085833],[8.794139,53.084802],[8.793242,53.08394],[8.789498,53.078929],[8.787648,53.076158],[8.786099,53.074058],[8.784672,53.072451],[8.783803,53.071787],[8.781611,53.070473],[8.780225,53.069294],[8.779168,53.068247],[8.776287,53.065001],[8.774146,53.063151],[8.77232,53.062068],[8.771485,53.06174],[8.769607,53.061301],[8.764527,53.060516],[8.761641,53.059832],[8.759369,53.059001],[8.758021,53.058397],[8.751259,53.05507],[8.74969,53.054386],[8.748011,53.053826],[8.745063,53.053201],[8.742018,53.052938],[8.739838,53.052916],[8.73594,53.0533],[8.733213,53.053724],[8.730861,53.053916],[8.729379,53.053906],[8.727006,53.053676],[8.724674,53.053189],[8.723021,53.052702],[8.720944,53.051898],[8.711368,53.047983],[8.709268,53.047305],[8.706859,53.046817],[8.700008,53.046139],[8.696772,53.045603],[8.69435,53.04506],[8.692294,53.044495],[8.689321,53.043495],[8.687041,53.042512],[8.683722,53.040737],[8.681851,53.039493],[8.678921,53.037184],[8.6769,53.035731],[8.675296,53.034744],[8.67322,53.033616],[8.672372,53.033332],[8.671414,53.033282],[8.670803,53.033024],[8.670837,53.032583],[8.671944,53.03176],[8.672175,53.031325],[8.671785,53.030306],[8.671284,53.02995],[8.67023,53.029814],[8.669557,53.030236],[8.66995,53.030757],[8.671842,53.030645],[8.673965,53.030075],[8.676925,53.028768],[8.679523,53.02724],[8.682682,53.025159],[8.688541,53.021032],[8.691307,53.018894],[8.693105,53.017383],[8.695047,53.015618],[8.696104,53.014526],[8.697864,53.012374],[8.698665,53.011194],[8.701101,53.006946],[8.701157,53.005916],[8.70065,53.005501],[8.699858,53.005253],[8.693396,53.004434],[8.690329,53.003967],[8.685905,53.003169],[8.681609,53.002242],[8.674775,53.000376],[8.669474,52.998677],[8.666087,52.997449],[8.66347,52.996417],[8.660606,52.995209],[8.655373,52.992884],[8.650744,52.990599],[8.646087,52.988247],[8.641368,52.985704],[8.638677,52.984301],[8.634664,52.982112],[8.626793,52.977921],[8.62595,52.977414],[8.618869,52.973869],[8.615702,52.972472],[8.613732,52.971529],[8.605668,52.968231],[8.6011,52.966408],[8.599046,52.965761],[8.594419,52.96409],[8.590283,52.962776],[8.586243,52.961566],[8.58399,52.960948],[8.579361,52.959576],[8.575107,52.958527],[8.573108,52.957967],[8.570373,52.957388],[8.560621,52.955009],[8.553286,52.953274],[8.547875,52.951907],[8.545294,52.951308],[8.542479,52.950515],[8.538129,52.949415],[8.534863,52.948438],[8.526961,52.945753],[8.523331,52.944396],[8.517422,52.941923],[8.512278,52.939507],[8.508867,52.937743],[8.506191,52.936227],[8.503585,52.93463],[8.492543,52.927465],[8.489538,52.925757],[8.486646,52.924257],[8.483951,52.923041],[8.481561,52.922044],[8.477611,52.9206],[8.476133,52.920122],[8.472659,52.919175],[8.468407,52.91819],[8.464919,52.917487],[8.460659,52.916749],[8.457027,52.916281],[8.453318,52.915883],[8.448652,52.915467],[8.443137,52.915104],[8.437691,52.914851],[8.433111,52.914684],[8.423678,52.914503],[8.421586,52.914527],[8.408788,52.914231],[8.400694,52.91388],[8.394613,52.913459],[8.387848,52.912752],[8.381512,52.91196],[8.377896,52.91141],[8.374598,52.910741],[8.372227,52.910353],[8.365883,52.909065],[8.361747,52.908036],[8.355469,52.9064],[8.352185,52.905418],[8.34748,52.903894],[8.342528,52.902127],[8.339413,52.900953],[8.335545,52.899353],[8.330466,52.897067],[8.326807,52.895301],[8.323348,52.893818],[8.319051,52.892102],[8.315673,52.890954],[8.312987,52.890182],[8.310253,52.88948],[8.306187,52.888561],[8.302077,52.88773],[8.297498,52.887034],[8.291944,52.886373],[8.285899,52.885711],[8.281685,52.885111],[8.277123,52.884203],[8.273486,52.883276],[8.270841,52.882487],[8.270503,52.882288],[8.266806,52.881085],[8.262451,52.879369],[8.259326,52.877984],[8.255161,52.875864],[8.25237,52.874314],[8.248255,52.871802],[8.244631,52.869316],[8.240689,52.866272],[8.237085,52.863298],[8.233135,52.859555],[8.231375,52.857654],[8.229236,52.855196],[8.22743,52.853022],[8.224195,52.848603],[8.22222,52.845584],[8.220292,52.842337],[8.218375,52.838338],[8.216587,52.833879],[8.21526,52.829785],[8.21399,52.825405],[8.213404,52.823614],[8.212184,52.819185],[8.211161,52.815057],[8.210227,52.811669],[8.208657,52.806368],[8.205396,52.797427],[8.204042,52.794075],[8.202176,52.789953],[8.200025,52.785402],[8.198175,52.781697],[8.195139,52.776216],[8.191792,52.770358],[8.189783,52.767039],[8.187112,52.762771],[8.183592,52.756839],[8.181385,52.752756],[8.180056,52.750108],[8.177578,52.744603],[8.176091,52.740665],[8.175547,52.738859],[8.174511,52.734971],[8.173744,52.731337],[8.173269,52.728455],[8.17308,52.726875],[8.172804,52.723473],[8.172722,52.717131],[8.172763,52.712812],[8.173186,52.703338],[8.173271,52.698484],[8.173176,52.696055],[8.173189,52.693345],[8.173026,52.690071],[8.172603,52.685785],[8.172185,52.683114],[8.171332,52.678682],[8.170533,52.675458],[8.169871,52.673182],[8.168612,52.669463],[8.167699,52.667058],[8.166708,52.664714],[8.164142,52.659456],[8.162157,52.655868],[8.158486,52.650124],[8.155626,52.646038],[8.152978,52.642515],[8.148074,52.63656],[8.145392,52.633458],[8.140635,52.628298],[8.133318,52.620948],[8.1262,52.613725],[8.123827,52.611236],[8.12092,52.607993],[8.118075,52.604432],[8.116141,52.601645],[8.115061,52.59989],[8.113688,52.597332],[8.112025,52.593475],[8.110927,52.59009],[8.11034,52.587695],[8.109927,52.585518],[8.109668,52.582739],[8.109598,52.579713],[8.109648,52.578431],[8.110037,52.574336],[8.110325,52.572579],[8.111475,52.566651],[8.112929,52.559606],[8.113606,52.555208],[8.113798,52.552829],[8.113901,52.549715],[8.113895,52.547203],[8.113735,52.54382],[8.113449,52.540703],[8.112921,52.537045],[8.112218,52.533835],[8.111287,52.531136],[8.110248,52.528911],[8.108108,52.525401],[8.106488,52.523186],[8.104151,52.520422],[8.101104,52.517255],[8.099402,52.515607],[8.098456,52.514841],[8.096259,52.512832],[8.087914,52.505794],[8.083273,52.501623],[8.078897,52.49762],[8.07491,52.493816],[8.069256,52.488133],[8.06554,52.484182],[8.061863,52.480064],[8.058255,52.475847],[8.054871,52.471709],[8.051058,52.46673],[8.047653,52.461947],[8.044237,52.456896],[8.0422,52.453585],[8.039901,52.449695],[8.038028,52.446157],[8.036824,52.443694],[8.035613,52.440991],[8.034215,52.437445],[8.033399,52.435169],[8.032321,52.431296],[8.031559,52.427398],[8.031126,52.424137],[8.030957,52.421189],[8.030946,52.419401],[8.031109,52.415561],[8.031527,52.412432],[8.032271,52.409015],[8.033485,52.405185],[8.033969,52.403881],[8.036029,52.399177],[8.037651,52.395787],[8.03983,52.391018],[8.041001,52.388284],[8.041839,52.38602],[8.042831,52.382758],[8.043243,52.380837],[8.043572,52.378532],[8.043677,52.375439],[8.043422,52.372747],[8.042788,52.369597],[8.042342,52.368113],[8.041395,52.365555],[8.040376,52.363436],[8.038575,52.360334],[8.036931,52.357922],[8.03527,52.355782],[8.033162,52.353278],[8.029947,52.34989],[8.026551,52.346743],[8.024499,52.345025],[8.021763,52.342984],[8.01845,52.340882],[8.015767,52.339401],[8.013836,52.3385],[8.01004,52.337065],[8.006761,52.336133],[7.996035,52.333582],[7.99146,52.332369],[7.98643,52.330903],[7.979856,52.328727],[7.975024,52.327077],[7.972902,52.326307],[7.968095,52.324271],[7.965782,52.323144],[7.962964,52.321638],[7.95988,52.319719],[7.956616,52.317477],[7.953591,52.315028],[7.951266,52.312834],[7.950018,52.311505],[7.947985,52.309136],[7.946549,52.307195],[7.944589,52.304124],[7.94321,52.301353],[7.942299,52.299125],[7.941506,52.296467],[7.941103,52.294722],[7.940596,52.291884],[7.939865,52.288927],[7.93847,52.285519],[7.937109,52.283042],[7.934504,52.279227],[7.931134,52.274405],[7.929404,52.272018],[7.923231,52.263216],[7.919257,52.257613],[7.918123,52.256139],[7.915736,52.253499],[7.914499,52.252323],[7.912195,52.250429],[7.909947,52.248855],[7.90723,52.247238],[7.905201,52.246171],[7.902906,52.245111],[7.899083,52.243607],[7.893114,52.24142],[7.890582,52.24034],[7.888647,52.239387],[7.886921,52.238432],[7.884683,52.237072],[7.883168,52.236061],[7.88211,52.235212],[7.879583,52.232934],[7.878056,52.231255],[7.876947,52.229747],[7.874103,52.225304],[7.872939,52.223785],[7.870781,52.221417],[7.867926,52.219026],[7.865683,52.217485],[7.863235,52.216169],[7.861269,52.215199],[7.857777,52.21371],[7.854227,52.212548],[7.8521,52.211963],[7.848944,52.211256],[7.846178,52.21078],[7.841248,52.210087],[7.837414,52.209505],[7.832879,52.208716],[7.82923,52.207974],[7.8238,52.206623],[7.819761,52.205325],[7.817095,52.20453],[7.813454,52.203183],[7.810643,52.202026],[7.807548,52.200599],[7.803595,52.198517],[7.800326,52.196432],[7.796988,52.194027],[7.795961,52.193199],[7.793172,52.190626],[7.789917,52.187316],[7.787176,52.184943],[7.784213,52.182693],[7.782293,52.181352],[7.779688,52.179767],[7.775128,52.177177],[7.772322,52.175685],[7.767861,52.173161],[7.763641,52.170881],[7.759491,52.168707],[7.754079,52.165613],[7.750303,52.163232],[7.748125,52.161705],[7.746041,52.160128],[7.743013,52.15769],[7.740595,52.155543],[7.736655,52.151641],[7.735358,52.150244],[7.731611,52.145956],[7.727347,52.140634],[7.72354,52.135963],[7.720181,52.132168],[7.717973,52.129749],[7.714602,52.126296],[7.711077,52.1229],[7.705441,52.118002],[7.701797,52.115101],[7.699812,52.113697],[7.695455,52.110733],[7.693667,52.10972],[7.687646,52.106137],[7.684901,52.10462],[7.683615,52.10403],[7.680357,52.102343],[7.676567,52.100588],[7.671998,52.098584],[7.664075,52.095308],[7.658554,52.092838],[7.656313,52.091708],[7.652165,52.08939],[7.647571,52.086596],[7.644818,52.084744],[7.643158,52.083537],[7.640892,52.081755],[7.637234,52.078597],[7.634059,52.075568],[7.632228,52.073553],[7.628839,52.069431],[7.626461,52.066443],[7.621873,52.060763],[7.619809,52.05804],[7.617049,52.054719],[7.614697,52.05172],[7.611589,52.047371],[7.610237,52.04534],[7.608547,52.042603],[7.606974,52.039839],[7.605976,52.037955],[7.603207,52.032994],[7.601248,52.02992],[7.600099,52.028313],[7.598326,52.026055],[7.595762,52.023186],[7.593113,52.020608],[7.590966,52.018739],[7.589027,52.017245],[7.583017,52.012856],[7.579861,52.010365],[7.576563,52.007389],[7.574751,52.005573],[7.572695,52.003296],[7.570654,52.000703],[7.567631,51.997034],[7.565876,51.995156],[7.564403,51.993702],[7.56036,51.99009],[7.558831,51.98866],[7.555668,51.985265],[7.553943,51.983113],[7.552106,51.980618],[7.551053,51.979033],[7.549497,51.976106],[7.548239,51.973075],[7.547091,51.969708],[7.546502,51.967118],[7.546097,51.964292],[7.545847,51.960432],[7.545995,51.95801],[7.546516,51.955059],[7.547229,51.951752],[7.548237,51.947581],[7.549236,51.943933],[7.550322,51.940563],[7.550886,51.938385],[7.552161,51.935013],[7.552653,51.933324],[7.555194,51.92661],[7.556018,51.924792],[7.55707,51.922108],[7.557333,51.921092],[7.5584,51.918658],[7.55861,51.917973],[7.558216,51.916628],[7.556834,51.915801],[7.55555,51.915419],[7.55346,51.915098],[7.548191,51.914541],[7.545042,51.914156],[7.539266,51.913286],[7.535996,51.912725],[7.531476,51.911802],[7.527654,51.910834],[7.523656,51.909687],[7.520732,51.908751],[7.518169,51.907847],[7.516236,51.907328],[7.513653,51.906421],[7.510865,51.905603],[7.506155,51.904327],[7.503518,51.90368],[7.498131,51.902523],[7.491879,51.901328],[7.48658,51.90061],[7.482394,51.900312],[7.478178,51.900285],[7.474065,51.900604],[7.468038,51.901369],[7.464855,51.901833],[7.462548,51.902261],[7.455883,51.903115],[7.451561,51.903459],[7.448054,51.903626],[7.444772,51.90367],[7.438075,51.903846],[7.43476,51.904019],[7.428859,51.904562],[7.424667,51.905113],[7.419222,51.905932],[7.412589,51.906642],[7.410064,51.906788],[7.407555,51.906848],[7.404992,51.906736],[7.40209,51.906455],[7.400443,51.906223],[7.398016,51.905752],[7.394898,51.904947],[7.393056,51.904358],[7.39058,51.903354],[7.387682,51.901899],[7.385992,51.900887],[7.382044,51.898088],[7.380503,51.896866],[7.375308,51.893315],[7.372909,51.891832],[7.370731,51.890596],[7.367443,51.888894],[7.363645,51.887184],[7.361203,51.886222],[7.356246,51.883923],[7.351229,51.881749],[7.349103,51.880891],[7.343326,51.878387],[7.334571,51.874487],[7.329721,51.872355],[7.326713,51.871081],[7.319331,51.867847],[7.315275,51.865981],[7.311977,51.864306],[7.309126,51.862748],[7.303484,51.859463],[7.301303,51.858246],[7.297469,51.856343],[7.295503,51.855449],[7.291793,51.853938],[7.286191,51.852044],[7.281754,51.850806],[7.278325,51.849973],[7.270132,51.848223],[7.265441,51.847006],[7.263247,51.846375],[7.258112,51.844567],[7.255351,51.843463],[7.252999,51.842351],[7.249357,51.84044],[7.24687,51.83893],[7.243987,51.836917],[7.2424,51.835632],[7.237232,51.830947],[7.234868,51.829051],[7.232692,51.82744],[7.230133,51.825809],[7.226335,51.82364],[7.223135,51.822073],[7.219524,51.820477],[7.216567,51.819257],[7.210612,51.817123],[7.207534,51.815878],[7.205531,51.814989],[7.202045,51.813312],[7.200179,51.8123],[7.196319,51.809975],[7.193219,51.807847],[7.191961,51.806848],[7.189535,51.804735],[7.186741,51.801971],[7.183987,51.798695],[7.182424,51.796396],[7.18132,51.794471],[7.179849,51.791333],[7.178956,51.788899],[7.178003,51.785318],[7.177127,51.780428],[7.176444,51.775004],[7.175995,51.772016],[7.175454,51.769046],[7.174623,51.765549],[7.173755,51.762936],[7.173238,51.761627],[7.1719,51.758959],[7.170764,51.757138],[7.169064,51.754883],[7.166308,51.751944],[7.164836,51.750573],[7.159629,51.746101],[7.155776,51.742894],[7.15436,51.741573],[7.152908,51.740009],[7.151193,51.737663],[7.149894,51.73512],[7.149285,51.733328],[7.148773,51.730371],[7.148963,51.727691],[7.149626,51.724881],[7.150632,51.7213],[7.151235,51.718427],[7.151223,51.715508],[7.151029,51.714059],[7.150259,51.711282],[7.148264,51.705792],[7.147798,51.704308],[7.147254,51.701617],[7.147183,51.699577],[7.14727,51.698304],[7.147658,51.696216],[7.148496,51.693726],[7.149568,51.691547],[7.150997,51.689246],[7.154084,51.684653],[7.155546,51.682067],[7.156661,51.679388],[7.157039,51.677856],[7.157314,51.674903],[7.157191,51.673074],[7.156603,51.668205],[7.156666,51.666936],[7.157032,51.665198],[7.157376,51.664243],[7.158087,51.662908],[7.158755,51.661941],[7.160501,51.660084],[7.162027,51.658825],[7.166001,51.655857],[7.166869,51.655138],[7.168192,51.653794],[7.169039,51.652773],[7.17044,51.650656],[7.171478,51.648156],[7.17183,51.646553],[7.171921,51.644453],[7.171749,51.642841],[7.171308,51.641077],[7.170575,51.639289],[7.1684,51.63511],[7.167458,51.632919],[7.166966,51.631377],[7.166509,51.629152],[7.166306,51.62628],[7.166389,51.624648],[7.166761,51.622379],[7.167241,51.620637],[7.168636,51.617365],[7.17026,51.614624],[7.171793,51.61262],[7.173485,51.61072],[7.175194,51.609199],[7.179259,51.605801],[7.181466,51.603799],[7.183593,51.601295],[7.185081,51.59892],[7.185908,51.597083],[7.186359,51.595664],[7.186896,51.59286],[7.187284,51.589666],[7.187556,51.588353],[7.187829,51.585965],[7.187585,51.58517],[7.185945,51.583408],[7.185056,51.582916],[7.183334,51.58242],[7.174577,51.58002],[7.164467,51.577143],[7.161827,51.576444],[7.158677,51.575915],[7.156731,51.575689],[7.153679,51.575465],[7.144721,51.575094],[7.141958,51.5749],[7.138355,51.574385],[7.134911,51.573698],[7.124954,51.571784],[7.119968,51.570775],[7.118338,51.57052],[7.114843,51.570221],[7.112172,51.570168],[7.10138,51.570408],[7.09932,51.570401],[7.096845,51.570248],[7.094751,51.570027],[7.091508,51.569477],[7.089535,51.569008],[7.080896,51.566345],[7.074078,51.564161],[7.066706,51.562228],[7.061453,51.561344],[7.057501,51.560902],[7.053058,51.560271],[7.047201,51.559647],[7.044231,51.559262],[7.040309,51.558854],[7.035622,51.558302],[7.031508,51.557906],[7.028278,51.557731],[7.024901,51.557833],[7.016182,51.558606],[7.014009,51.558771],[7.01098,51.558908],[7.007533,51.558895],[7.004124,51.558655],[6.996585,51.557726],[6.993014,51.557211],[6.988658,51.556729],[6.983677,51.556007],[6.979182,51.555192],[6.971948,51.553809],[6.969937,51.553483],[6.967022,51.553192],[6.964038,51.553102],[6.960246,51.553292],[6.95822,51.553514],[6.955118,51.554048],[6.95322,51.554488],[6.948362,51.55573],[6.945265,51.556352],[6.94168,51.556818],[6.938545,51.556972],[6.935952,51.556915],[6.934089,51.556774],[6.930582,51.556358],[6.928645,51.55601],[6.925574,51.555181],[6.923928,51.554636],[6.921446,51.553603],[6.919779,51.552753],[6.917386,51.551375],[6.911567,51.547577],[6.909431,51.546377],[6.907624,51.545527],[6.905418,51.544664],[6.90382,51.544145],[6.899663,51.543148],[6.890479,51.541535],[6.88784,51.541129],[6.884074,51.540427],[6.878576,51.539494],[6.876106,51.539267],[6.873653,51.539167],[6.855883,51.538992],[6.849995,51.538902],[6.844844,51.53887],[6.840923,51.538627],[6.839354,51.538439],[6.835741,51.537802],[6.832783,51.537031],[6.830695,51.536312],[6.827747,51.53502],[6.82556,51.533882],[6.823764,51.532792],[6.821107,51.53082],[6.817726,51.527795],[6.816357,51.526336],[6.815538,51.525201],[6.814603,51.523329],[6.814122,51.521305],[6.814149,51.519974],[6.814691,51.517807],[6.815669,51.515911],[6.816826,51.514293],[6.821392,51.508593],[6.822007,51.507705],[6.822608,51.506298],[6.822749,51.504341],[6.822258,51.502668],[6.820742,51.499658],[6.818863,51.495705],[6.815816,51.489546],[6.814042,51.486192],[6.813257,51.483974],[6.813066,51.481847],[6.813204,51.480381],[6.813688,51.478692],[6.815109,51.475393],[6.815834,51.473437],[6.816275,51.471542],[6.816382,51.470013],[6.816301,51.468237],[6.815966,51.466791],[6.815107,51.464703],[6.814334,51.46364],[6.813356,51.462643],[6.812437,51.461914],[6.810907,51.460983],[6.809517,51.46033],[6.805719,51.459016],[6.803329,51.45787],[6.801776,51.456778],[6.800349,51.455292],[6.799685,51.454282],[6.798964,51.452465],[6.798548,51.450639],[6.798399,51.449233],[6.798469,51.448056],[6.798809,51.446183],[6.799738,51.444246],[6.801643,51.442162],[6.802546,51.441668],[6.803661,51.441516],[6.804898,51.441864],[6.805727,51.442722],[6.80567,51.443398],[6.804675,51.444111],[6.80325,51.444268],[6.802419,51.444526],[6.799226,51.446088],[6.796914,51.446976],[6.793778,51.447746],[6.79122,51.448004],[6.789177,51.447998],[6.78776,51.447892],[6.785263,51.447559],[6.774488,51.445785],[6.771596,51.445242],[6.768748,51.444567],[6.766663,51.443896],[6.76506,51.443254],[6.763613,51.442537],[6.761149,51.440938],[6.758831,51.438924],[6.757735,51.438125],[6.755946,51.437142],[6.754452,51.436569],[6.752095,51.435926],[6.750289,51.435604],[6.746971,51.435209],[6.744028,51.435088],[6.741797,51.43511],[6.73895,51.435341],[6.735981,51.435941],[6.73365,51.436719],[6.731549,51.437585],[6.729646,51.438197],[6.727097,51.438634],[6.725204,51.438758],[6.723163,51.438727],[6.719836,51.438309],[6.71277,51.437186],[6.70613,51.4361],[6.702096,51.435604],[6.698719,51.43552],[6.696493,51.435658],[6.693877,51.436034],[6.689128,51.436891],[6.685463,51.437368],[6.682928,51.437532],[6.679939,51.437591],[6.671509,51.437461],[6.663302,51.437185],[6.657828,51.436948],[6.649663,51.436741],[6.645792,51.436581],[6.637986,51.436052],[6.633513,51.435821],[6.62796,51.435769],[6.623181,51.435906],[6.617286,51.436221],[6.611004,51.436361],[6.605175,51.436226],[6.600115,51.435908],[6.594252,51.435305],[6.590418,51.434784],[6.587055,51.434203],[6.580593,51.432856],[6.575346,51.431543],[6.571341,51.43068],[6.567184,51.430022],[6.562686,51.42954],[6.536401,51.427627],[6.529943,51.427292],[6.524243,51.427185],[6.516295,51.426903],[6.513431,51.426664],[6.509025,51.426061],[6.50512,51.425224],[6.500922,51.424073],[6.49729,51.422792],[6.495208,51.421919],[6.491973,51.420368],[6.482539,51.415252],[6.479988,51.414004],[6.477939,51.413185],[6.475002,51.412349],[6.471882,51.41179],[6.468333,51.411477],[6.456404,51.410805],[6.447579,51.410283],[6.438756,51.409806],[6.436526,51.409636],[6.429159,51.409198],[6.425127,51.409007],[6.417634,51.408365],[6.412996,51.407834],[6.408681,51.40725],[6.403181,51.40639],[6.396236,51.405123],[6.391407,51.404051],[6.385767,51.402682],[6.383527,51.402084],[6.378741,51.400704],[6.373658,51.399076],[6.361569,51.394936],[6.355613,51.39294],[6.350592,51.391389],[6.34725,51.390551],[6.34272,51.389636],[6.340002,51.389246],[6.334498,51.388779],[6.331239,51.388666],[6.324223,51.388791],[6.32178,51.388922],[6.310769,51.389384],[6.303817,51.389657],[6.296724,51.389989],[6.289974,51.390237],[6.286437,51.390426],[6.282949,51.390438],[6.280198,51.390303],[6.275925,51.389845],[6.273682,51.389472],[6.270447,51.388753],[6.267327,51.387832],[6.263651,51.386446],[6.260443,51.384984],[6.256128,51.38319],[6.252543,51.382032],[6.24875,51.381147],[6.243714,51.38038],[6.241717,51.380193],[6.239301,51.38011],[6.234942,51.38016],[6.230982,51.38053],[6.2274,51.381091],[6.224265,51.381765],[6.221544,51.382545],[6.209803,51.386243],[6.206881,51.387118],[6.199476,51.389462],[6.184326,51.393923],[6.180366,51.394889],[6.177796,51.395371],[6.174,51.395863],[6.171293,51.396043],[6.168999,51.396121],[6.1657,51.39612],[6.163267,51.396044],[6.161535,51.39631],[6.160103,51.395876],[6.157892,51.395685],[6.143873,51.394791],[6.138428,51.394488],[6.135679,51.394377],[6.129405,51.393963],[6.126913,51.393858],[6.125939,51.394076],[6.125705,51.394871],[6.126845,51.39516],[6.127647,51.394763],[6.127722,51.394263],[6.127504,51.391573],[6.126974,51.389719],[6.126544,51.388762],[6.125684,51.387468],[6.123201,51.384417],[6.122679,51.383571],[6.122141,51.38202],[6.122017,51.380599],[6.122201,51.379381],[6.122717,51.377429],[6.123051,51.375702],[6.123062,51.373249],[6.122694,51.370804],[6.122744,51.369164],[6.123082,51.368052],[6.123812,51.366612],[6.124766,51.365435],[6.125564,51.364677],[6.126997,51.363626],[6.129702,51.362313],[6.133147,51.361084],[6.140517,51.358555],[6.141854,51.35802],[6.143374,51.35725],[6.152752,51.351889],[6.15514,51.350265],[6.156008,51.349442],[6.157135,51.347913],[6.157772,51.346333],[6.158152,51.344055],[6.158733,51.342071],[6.159517,51.340363],[6.160723,51.338445],[6.162035,51.337022],[6.164216,51.335367],[6.165908,51.334434],[6.168479,51.333394],[6.17166,51.332555],[6.173892,51.332213],[6.177325,51.332053],[6.18073,51.332286],[6.187577,51.333313],[6.191081,51.333251],[6.192686,51.333035],[6.195282,51.333249],[6.195351,51.334136],[6.195816,51.33509],[6.197154,51.336123],[6.197791,51.337163],[6.19755,51.33811],[6.194255,51.341817],[6.192802,51.343545],[6.192299,51.344321],[6.191625,51.346014],[6.192272,51.346885],[6.192015,51.347321],[6.191081,51.347549],[6.190478,51.347398],[6.189796,51.346677],[6.187636,51.346434],[6.186383,51.347027],[6.182762,51.352186],[6.182024,51.353079],[6.180876,51.354832],[6.179997,51.356499],[6.178378,51.358822],[6.178255,51.359207],[6.177663,51.358763],[6.177485,51.356368],[6.175559,51.356492],[6.175658,51.356275],[6.175217,51.354818],[6.174578,51.353878],[6.173237,51.352982],[6.170119,51.351612],[6.169501,51.351727],[6.166587,51.353984],[6.16588,51.354436],[6.162027,51.35647],[6.159746,51.357758],[6.157984,51.358325],[6.15395,51.355418],[6.152748,51.354465],[6.102735,51.292926],[6.074259,51.265621],[6.071747,51.26484],[6.068275,51.263491],[6.065712,51.262223],[6.064553,51.261539],[6.062401,51.26009],[6.060243,51.258243],[6.057953,51.255807],[6.055041,51.252097],[6.050987,51.247318],[6.049523,51.245784],[6.0473,51.243897],[6.045867,51.24293],[6.043129,51.241366],[6.041882,51.240738],[6.033217,51.236137],[6.029119,51.233489],[6.02848,51.233001],[6.025992,51.230591],[6.024956,51.229377],[6.023262,51.226985],[6.020462,51.22257],[6.019543,51.22085],[6.018932,51.219074],[6.018787,51.218064],[6.018802,51.216309],[6.019075,51.214816],[6.019625,51.213346],[6.0203,51.212134],[6.02191,51.210059],[6.024619,51.207166],[6.025373,51.206252],[6.027391,51.203458],[6.028255,51.202013],[6.028986,51.200513],[6.030102,51.197636],[6.0305,51.19624],[6.030773,51.194107],[6.030762,51.193141],[6.030384,51.191419],[6.029777,51.189967],[6.028158,51.187654],[6.026899,51.18639],[6.025134,51.184996],[6.02214,51.183326],[6.017899,51.181422],[6.015635,51.180107],[6.013566,51.178506],[6.012339,51.177385],[5.98562,51.175112],[5.983679,51.174757],[5.981048,51.173891],[5.979259,51.173088],[5.974457,51.170177],[5.966148,51.164876],[5.960423,51.161432],[5.951987,51.156297],[5.946149,51.152652],[5.943403,51.150677],[5.941115,51.149212],[5.937665,51.147515],[5.935392,51.146576],[5.932303,51.145421],[5.929871,51.144444],[5.927851,51.143546],[5.922518,51.14102],[5.918689,51.13908],[5.913871,51.136471],[5.911194,51.134896],[5.905886,51.131662],[5.902243,51.129758],[5.899779,51.128669],[5.896645,51.127575],[5.894451,51.126965],[5.890173,51.126033],[5.886193,51.125223],[5.883919,51.124206],[5.882863,51.123582],[5.880528,51.121744],[5.877168,51.119897],[5.874033,51.118323],[5.870702,51.116534],[5.867707,51.114759],[5.865071,51.113061],[5.861601,51.110669],[5.858352,51.108617],[5.855942,51.107315],[5.852642,51.105424],[5.850918,51.104573],[5.848911,51.103421],[5.847028,51.102218],[5.845233,51.100731],[5.843784,51.099337],[5.842553,51.09795],[5.839969,51.094825],[5.838632,51.093333],[5.836504,51.090795],[5.835662,51.089916],[5.829332,51.082603],[5.828233,51.08104],[5.826422,51.078233],[5.825266,51.075944],[5.824625,51.074018],[5.823861,51.071169],[5.823601,51.069521],[5.823356,51.068915],[5.824101,51.065913],[5.824745,51.062702],[5.82491,51.062248],[5.826354,51.055761],[5.826883,51.05279],[5.826995,51.051351],[5.826894,51.048128],[5.826563,51.046497],[5.82592,51.044365],[5.825639,51.042156],[5.825102,51.040153],[5.824331,51.036189],[5.823778,51.034024],[5.82245,51.031623],[5.821426,51.030193],[5.81921,51.028072],[5.814999,51.02444],[5.812328,51.022261],[5.811174,51.021227],[5.80854,51.019068],[5.807198,51.017853],[5.805054,51.016092],[5.801278,51.012782],[5.797274,51.00948],[5.796633,51.008859],[5.79426,51.006899],[5.792371,51.00499],[5.790681,51.002736],[5.788947,50.99941],[5.785401,50.992068],[5.78319,50.987589],[5.782695,50.985896],[5.782565,50.984649],[5.782728,50.982671],[5.783298,50.980695],[5.783775,50.979706],[5.785055,50.977857],[5.786502,50.975515],[5.787103,50.974044],[5.787467,50.972785],[5.787674,50.971236],[5.787609,50.969708],[5.786934,50.96494],[5.786181,50.958666],[5.786196,50.957159],[5.786511,50.955041],[5.787742,50.952018],[5.788244,50.950486],[5.788513,50.949093],[5.788624,50.946968],[5.788316,50.94453],[5.787559,50.941877],[5.786268,50.939087],[5.785162,50.937277],[5.783325,50.934923],[5.781499,50.932943],[5.779196,50.930593],[5.777546,50.928763],[5.776518,50.927412],[5.773099,50.921925],[5.7717,50.91958],[5.770669,50.918192],[5.769573,50.917053],[5.767005,50.914997],[5.764661,50.913039],[5.762889,50.911234],[5.759079,50.906497],[5.757335,50.903267],[5.75655,50.902066],[5.754929,50.900585],[5.753943,50.900071],[5.751775,50.899218],[5.750572,50.898521],[5.74944,50.897575],[5.747193,50.895959],[5.743532,50.893127],[5.741829,50.891257],[5.737044,50.883072],[5.735567,50.87957],[5.734644,50.877241],[5.734047,50.876191],[5.731903,50.873595],[5.730663,50.871123],[5.729795,50.870005],[5.727916,50.868574],[5.723412,50.866211],[5.721391,50.865094],[5.720111,50.864029],[5.718123,50.863109],[5.714881,50.860401],[5.71319,50.859118],[5.712049,50.858126],[5.710877,50.856819],[5.710182,50.85463],[5.710153,50.853401],[5.710705,50.848931],[5.711475,50.84758],[5.712133,50.846899],[5.715436,50.844487],[5.716398,50.844021],[5.717116,50.8431],[5.717537,50.842098],[5.718343,50.84125],[5.718281,50.839953],[5.718464,50.837159],[5.718365,50.836505],[5.718188,50.83085],[5.718236,50.8272],[5.718354,50.825825],[5.718735,50.823243],[5.719327,50.820823],[5.720046,50.818652],[5.721634,50.814717],[5.722831,50.811564],[5.723418,50.809572],[5.723878,50.807562],[5.724303,50.804252],[5.724566,50.799184],[5.72475,50.797426],[5.725221,50.795221],[5.725572,50.794025],[5.726475,50.791672],[5.728078,50.787928],[5.728667,50.786275],[5.729142,50.7846],[5.729459,50.782408],[5.729417,50.780936],[5.729074,50.778943],[5.728449,50.777205],[5.727842,50.775978],[5.726379,50.773837],[5.724682,50.772001],[5.723184,50.770737],[5.721776,50.769725],[5.719649,50.76844],[5.717705,50.767466],[5.714291,50.766079],[5.709059,50.764172],[5.705512,50.762677],[5.702893,50.761223],[5.701036,50.75995],[5.699833,50.758965],[5.698357,50.757501],[5.6971,50.755989],[5.695498,50.753591],[5.69455,50.751758],[5.693695,50.749662],[5.693178,50.748],[5.691931,50.742275],[5.691786,50.741332],[5.691772,50.739423],[5.692062,50.737746],[5.692748,50.735357],[5.693479,50.733215],[5.69371,50.731306],[5.693602,50.730369],[5.693017,50.727708],[5.692055,50.72162],[5.691689,50.720348],[5.691076,50.71918],[5.690506,50.718441],[5.687309,50.715152],[5.685968,50.713431],[5.684999,50.711752],[5.684496,50.710477],[5.683519,50.706975],[5.682992,50.705762],[5.681913,50.704323],[5.68042,50.702653],[5.677276,50.69835],[5.676802,50.697465],[5.67462,50.691906],[5.673546,50.689959],[5.672363,50.688469],[5.671579,50.687834],[5.670166,50.686988],[5.667553,50.685748],[5.663661,50.68428],[5.661922,50.683481],[5.660322,50.682487],[5.658326,50.681542],[5.656428,50.681493],[5.647562,50.684133],[5.645586,50.684841],[5.64544,50.685774],[5.64457,50.6862],[5.646034,50.689153],[5.648377,50.693413],[5.648693,50.693392],[5.650367,50.692305],[5.649569,50.691647],[5.647401,50.688752],[5.648157,50.68842],[5.647234,50.687333],[5.645469,50.688056],[5.645246,50.687903],[5.644143,50.686063],[5.645377,50.68562],[5.645222,50.685201],[5.644383,50.685097],[5.636023,50.687558],[5.632233,50.688478],[5.62946,50.688921],[5.625587,50.68925],[5.622029,50.689235],[5.618917,50.689003],[5.615346,50.688433],[5.611386,50.687462],[5.602647,50.684528],[5.599778,50.683526],[5.596006,50.682317],[5.584634,50.678494],[5.579929,50.677099],[5.576212,50.676262],[5.571931,50.675524],[5.567331,50.674961],[5.557534,50.673901],[5.549088,50.672948],[5.545072,50.672535],[5.533325,50.671667],[5.521328,50.670731],[5.519795,50.670642],[5.509941,50.669867],[5.506555,50.669648],[5.502284,50.669514],[5.4956,50.669696],[5.491341,50.670163],[5.489016,50.670319],[5.488105,50.670263],[5.486596,50.669931],[5.48526,50.669043],[5.484695,50.667463],[5.484977,50.666479],[5.485588,50.665072],[5.486351,50.66298],[5.487079,50.659693],[5.487217,50.65809],[5.487,50.656935],[5.486501,50.65578],[5.48545,50.654296],[5.483961,50.652993],[5.481407,50.651552],[5.463306,50.642322],[5.459736,50.640207],[5.452733,50.635903],[5.450198,50.634575],[5.447825,50.633496],[5.442683,50.63131],[5.434476,50.627755],[5.428356,50.62518],[5.420748,50.621845],[5.415855,50.619752],[5.413357,50.61876],[5.409577,50.617579],[5.406447,50.616855],[5.402744,50.616258],[5.398195,50.615796],[5.386386,50.614732],[5.382469,50.614285],[5.380198,50.613921],[5.3755,50.613038],[5.362784,50.610497],[5.358747,50.609649],[5.354314,50.608636],[5.349594,50.60729],[5.346044,50.606091],[5.337074,50.602847],[5.331867,50.601007],[5.325303,50.598592],[5.320374,50.596838],[5.314504,50.595006],[5.311824,50.594307],[5.307527,50.593434],[5.303165,50.592793],[5.300362,50.592542],[5.296344,50.592265],[5.27869,50.591331],[5.2709,50.590876],[5.263908,50.590556],[5.25519,50.590034],[5.249101,50.58972],[5.241018,50.589239],[5.237802,50.588998],[5.23417,50.588562],[5.229816,50.587804],[5.226685,50.587085],[5.224362,50.586447],[5.220605,50.585246],[5.217401,50.584033],[5.213266,50.58225],[5.203061,50.577371],[5.195382,50.573824],[5.190496,50.57185],[5.185719,50.570128],[5.177703,50.567459],[5.176602,50.567132],[5.170651,50.565143],[5.16734,50.563918],[5.164412,50.562663],[5.160551,50.560695],[5.155258,50.557728],[5.152438,50.556086],[5.150052,50.554789],[5.148374,50.553777],[5.146492,50.552786],[5.142972,50.550719],[5.140014,50.5491],[5.136973,50.547342],[5.127822,50.542184],[5.125651,50.541045],[5.122623,50.539713],[5.120053,50.537943],[5.117257,50.536279],[5.114241,50.534729],[5.111579,50.533499],[5.108439,50.532239],[5.106402,50.531569],[5.104316,50.530991],[5.101872,50.530464],[5.097641,50.52982],[5.095855,50.529622],[5.092127,50.529446],[5.087071,50.529478],[5.082564,50.529637],[5.080229,50.529793],[5.06689,50.530463],[5.06437,50.530544],[5.052896,50.531036],[5.050553,50.531181],[5.040199,50.531657],[5.038999,50.531744],[5.026937,50.532273],[5.022452,50.532369],[5.01999,50.532318],[5.015134,50.531973],[5.009627,50.531173],[5.007247,50.530715],[4.999748,50.5296],[4.99573,50.529073],[4.994107,50.528923],[4.990387,50.52871],[4.984517,50.52867],[4.981654,50.528808],[4.978044,50.529082],[4.974406,50.52942],[4.970753,50.530072],[4.963857,50.531371],[4.958506,50.532066],[4.95561,50.532318],[4.953858,50.532392],[4.950094,50.532345],[4.946393,50.532065],[4.94238,50.531483],[4.93966,50.53093],[4.936882,50.530195],[4.934926,50.529592],[4.932588,50.52866],[4.929004,50.527027],[4.92585,50.525696],[4.922309,50.524557],[4.919451,50.523894],[4.915639,50.523227],[4.912095,50.522828],[4.910042,50.522683],[4.90024,50.522482],[4.894294,50.522389],[4.891125,50.522289],[4.887562,50.522049],[4.884363,50.521713],[4.881532,50.521284],[4.878352,50.520611],[4.875599,50.51987],[4.871713,50.518611],[4.86836,50.517324],[4.857642,50.512679],[4.855824,50.51195],[4.851653,50.510453],[4.847437,50.509157],[4.839888,50.507163],[4.837447,50.50665],[4.831219,50.50556],[4.825765,50.504697],[4.820811,50.50366],[4.818038,50.5029],[4.814648,50.501705],[4.812859,50.500973],[4.808088,50.498765],[4.806389,50.498043],[4.803662,50.497034],[4.8012,50.496293],[4.79676,50.495288],[4.793226,50.494782],[4.790603,50.494538],[4.786409,50.494415],[4.779067,50.494654],[4.773894,50.494886],[4.771018,50.494946],[4.767447,50.495111],[4.764377,50.495184],[4.756847,50.495479],[4.752775,50.495669],[4.751139,50.495695],[4.744033,50.49596],[4.737761,50.496152],[4.731109,50.496442],[4.727354,50.49651],[4.723962,50.496496],[4.718966,50.496337],[4.71358,50.495975],[4.700493,50.494857],[4.697098,50.494626],[4.692855,50.494462],[4.688634,50.49441],[4.67983,50.49441],[4.670551,50.494349],[4.664288,50.494362],[4.651353,50.494352],[4.648966,50.494304],[4.644862,50.494343],[4.639893,50.494208],[4.636574,50.494007],[4.630413,50.493456],[4.626845,50.493008],[4.622502,50.492312],[4.61868,50.491536],[4.612794,50.490105],[4.60244,50.487162],[4.600846,50.486644],[4.599458,50.486325],[4.596849,50.485538],[4.59329,50.484565],[4.591509,50.484016],[4.580722,50.480988],[4.576522,50.479844],[4.571932,50.478545],[4.567026,50.47711],[4.560465,50.475238],[4.555651,50.473924],[4.550748,50.472722],[4.547561,50.472052],[4.539607,50.470591],[4.534975,50.469943],[4.531701,50.469563],[4.525614,50.46904],[4.521168,50.468935],[4.517869,50.468994],[4.512487,50.469437],[4.510059,50.469742],[4.505163,50.470506],[4.499954,50.47144],[4.494934,50.472521],[4.492714,50.473051],[4.486385,50.474736],[4.479816,50.476575],[4.477091,50.47729],[4.472327,50.478417],[4.468718,50.479161],[4.463918,50.480047],[4.460716,50.480586],[4.457104,50.481104],[4.452707,50.481646],[4.450704,50.481806],[4.447876,50.481906],[4.444038,50.481755],[4.441426,50.481447],[4.437422,50.480655],[4.434042,50.479633],[4.426432,50.477014],[4.424079,50.476298],[4.421744,50.475679],[4.419005,50.475086],[4.414761,50.474575],[4.412297,50.474455],[4.410183,50.474457],[4.408159,50.474564],[4.402769,50.475106],[4.39608,50.476041],[4.391649,50.476703],[4.379796,50.478298],[4.376577,50.478763],[4.354955,50.48166],[4.351741,50.481966],[4.347501,50.482119],[4.343392,50.481953],[4.33741,50.481466],[4.328603,50.480683],[4.321383,50.480112],[4.307968,50.478954],[4.307598,50.478979],[4.303779,50.478624],[4.301246,50.478489],[4.297883,50.478453],[4.293261,50.478665],[4.290691,50.478981],[4.288747,50.479315],[4.286111,50.479921],[4.281972,50.481261],[4.280646,50.481785],[4.277245,50.483282],[4.272351,50.485762],[4.268178,50.487973],[4.267594,50.488335],[4.260036,50.492026],[4.2556,50.494003],[4.251564,50.49564],[4.247669,50.497003],[4.243539,50.498052],[4.241238,50.498463],[4.238613,50.498809],[4.234958,50.499038],[4.232925,50.499045],[4.229646,50.498805],[4.226137,50.498377],[4.22199,50.498033],[4.218307,50.49804],[4.215551,50.498219],[4.208862,50.499063],[4.207954,50.499254],[4.203636,50.499831],[4.200895,50.500026],[4.193527,50.501026],[4.191265,50.501468],[4.18695,50.501998],[4.18218,50.502651],[4.177297,50.503125],[4.171763,50.503524],[4.167077,50.503748],[4.164643,50.503657],[4.162326,50.503439],[4.159049,50.502897],[4.155272,50.501929],[4.152354,50.501044],[4.150977,50.500727],[4.146357,50.499819],[4.137704,50.498165],[4.125212,50.495863],[4.118909,50.494563],[4.118583,50.494536],[4.113794,50.493385],[4.106062,50.491651],[4.103772,50.491073],[4.101044,50.490504],[4.095465,50.489213],[4.085591,50.486972],[4.075536,50.484784],[4.074352,50.484487],[4.064676,50.482264],[4.05814,50.480883],[4.054866,50.480452],[4.052791,50.480452],[4.049908,50.480688],[4.047535,50.481096],[4.04491,50.481705],[4.037967,50.483228],[4.034487,50.484029],[4.027544,50.485528],[4.022172,50.486765],[4.010313,50.489414],[4.002077,50.4912],[3.998605,50.491828],[3.996628,50.492086],[3.994124,50.492263],[3.992003,50.492272],[3.988628,50.492073],[3.985739,50.49162],[3.982993,50.4909],[3.979672,50.489748],[3.975409,50.487969],[3.971796,50.486624],[3.96745,50.48541],[3.965803,50.48505],[3.962564,50.48448],[3.958866,50.484006],[3.951967,50.483498],[3.950055,50.483279],[3.947439,50.482735],[3.944927,50.481974],[3.943571,50.48144],[3.941693,50.48046],[3.939774,50.479137],[3.938599,50.478066],[3.937608,50.476925],[3.936388,50.475005],[3.934278,50.470275],[3.933078,50.468048],[3.9323,50.466845],[3.930791,50.464957],[3.9285,50.46275],[3.927487,50.461917],[3.925842,50.460786],[3.922877,50.459009],[3.919162,50.457208],[3.913863,50.455464],[3.910607,50.454698],[3.907899,50.454263],[3.903484,50.45387],[3.898344,50.453724],[3.892442,50.453735],[3.887616,50.453614],[3.886872,50.453669],[3.88093,50.453568],[3.874105,50.453495],[3.871561,50.453419],[3.869524,50.453444],[3.857875,50.453301],[3.857137,50.453337],[3.84759,50.453131],[3.846141,50.453058],[3.842561,50.453017],[3.834735,50.452855],[3.830804,50.452715],[3.81761,50.452595],[3.811289,50.452506],[3.807493,50.452382],[3.802565,50.452083],[3.800028,50.451999],[3.789728,50.451835],[3.784085,50.451811],[3.779975,50.451703],[3.773214,50.451638],[3.763214,50.451482],[3.757515,50.451321],[3.752497,50.451314],[3.741646,50.451105],[3.730479,50.450949],[3.724663,50.450733],[3.720005,50.450424],[3.711492,50.44955],[3.705982,50.448826],[3.700065,50.447883],[3.694383,50.446754],[3.691499,50.446104],[3.684529,50.444285],[3.680767,50.443206],[3.674404,50.441287],[3.671863,50.440399],[3.668936,50.439551],[3.667904,50.439173],[3.665435,50.437984],[3.661412,50.436378],[3.657918,50.434857],[3.651796,50.431826],[3.64698,50.429253],[3.6425,50.426549],[3.638529,50.423943],[3.634978,50.421352],[3.632369,50.419277],[3.629409,50.416685],[3.627541,50.414925],[3.625571,50.41288],[3.62409,50.411205],[3.62104,50.407384],[3.620007,50.40591],[3.61737,50.401651],[3.616582,50.400143],[3.615576,50.39789],[3.614252,50.394535],[3.613608,50.392728],[3.612026,50.387547],[3.611166,50.384941],[3.610396,50.3829],[3.609466,50.380871],[3.608667,50.379355],[3.607375,50.377422],[3.60591,50.375506],[3.604711,50.374128],[3.603065,50.372421],[3.601379,50.370835],[3.598837,50.36871],[3.595137,50.365851],[3.594014,50.365084],[3.590309,50.362363],[3.590073,50.362065],[3.585635,50.358474],[3.580905,50.354269],[3.577548,50.350878],[3.573999,50.347433],[3.572834,50.34643],[3.57037,50.344098],[3.568674,50.342663],[3.565762,50.340533],[3.563662,50.339335],[3.56106,50.338157],[3.558604,50.337253],[3.556428,50.336665],[3.553825,50.336227],[3.551403,50.336066],[3.549018,50.336124],[3.546778,50.336399],[3.543897,50.337003],[3.539267,50.338591],[3.537407,50.33901],[3.534699,50.339307],[3.533126,50.339337],[3.530331,50.339088],[3.524755,50.338251],[3.520704,50.337722],[3.517587,50.337426],[3.515681,50.337339],[3.512716,50.337339],[3.509591,50.337595],[3.505673,50.338196],[3.491234,50.340611],[3.487878,50.34108],[3.484644,50.341305],[3.483042,50.341323],[3.477801,50.341143],[3.476039,50.340967],[3.472387,50.340733],[3.467288,50.340234],[3.464934,50.339934],[3.460864,50.339311],[3.458263,50.338702],[3.456397,50.338182],[3.453967,50.337377],[3.450782,50.336109],[3.44882,50.33521],[3.44525,50.333329],[3.44268,50.331809],[3.438793,50.329413],[3.432601,50.325544],[3.427642,50.322689],[3.424117,50.320893],[3.419761,50.318978],[3.417678,50.318163],[3.415167,50.317285],[3.411796,50.316338],[3.407272,50.315142],[3.404668,50.314511],[3.399038,50.313044],[3.39599,50.312182],[3.393378,50.311341],[3.385773,50.308695],[3.383543,50.307851],[3.379986,50.306382],[3.376933,50.304946],[3.375327,50.304105],[3.372649,50.302507],[3.369267,50.299998],[3.367878,50.298771],[3.363951,50.295063],[3.361275,50.292602],[3.359141,50.290781],[3.357404,50.289413],[3.355266,50.287891],[3.351272,50.285195],[3.342993,50.279872],[3.341027,50.278441],[3.337936,50.275769],[3.336309,50.273796],[3.33507,50.272039],[3.334033,50.270223],[3.332746,50.267635],[3.331272,50.264864],[3.330352,50.263382],[3.328498,50.260739],[3.326925,50.258859],[3.324907,50.25679],[3.322153,50.254317],[3.320523,50.253005],[3.317932,50.251134],[3.314276,50.248857],[3.311683,50.247463],[3.307634,50.245533],[3.299062,50.241956],[3.29645,50.24076],[3.291656,50.238333],[3.286584,50.235645],[3.283396,50.234087],[3.280614,50.232856],[3.276343,50.231172],[3.271502,50.229519],[3.270029,50.228863],[3.261244,50.225602],[3.259632,50.22505],[3.254983,50.223315],[3.249493,50.221108],[3.245692,50.21934],[3.241431,50.217115],[3.238628,50.215484],[3.233101,50.211866],[3.225053,50.20615],[3.221349,50.203728],[3.219263,50.202527],[3.215147,50.200406],[3.20939,50.197532],[3.205908,50.195734],[3.202253,50.193672],[3.199101,50.191641],[3.195856,50.189246],[3.193813,50.187502],[3.192627,50.18638],[3.190613,50.184303],[3.187736,50.180896],[3.185627,50.178227],[3.180839,50.172366],[3.178516,50.169785],[3.176155,50.167469],[3.173554,50.165308],[3.171425,50.163722],[3.169018,50.162064],[3.166996,50.160835],[3.164049,50.15923],[3.162244,50.15834],[3.158823,50.156865],[3.154654,50.155291],[3.150942,50.154091],[3.144231,50.152077],[3.141005,50.151031],[3.13815,50.149986],[3.134318,50.148348],[3.131964,50.147223],[3.128802,50.145516],[3.126447,50.144086],[3.124022,50.142442],[3.117192,50.137527],[3.115344,50.136307],[3.112803,50.134778],[3.108878,50.13271],[3.105272,50.131084],[3.100154,50.128884],[3.096223,50.127057],[3.09181,50.124671],[3.090163,50.123656],[3.087018,50.12147],[3.084708,50.119718],[3.070829,50.108598],[3.065166,50.104236],[3.062124,50.101949],[3.054533,50.096537],[3.04732,50.091697],[3.04304,50.088958],[3.036679,50.085099],[3.034462,50.083834],[3.030993,50.08199],[3.026839,50.079874],[3.023143,50.07819],[3.019986,50.076846],[3.017714,50.075963],[3.01336,50.074402],[3.009194,50.073076],[3.004534,50.071796],[3.00124,50.071002],[2.995251,50.069737],[2.989162,50.068329],[2.985069,50.067259],[2.980019,50.065857],[2.967857,50.062246],[2.958384,50.059397],[2.95439,50.05816],[2.951199,50.057042],[2.949115,50.056218],[2.946396,50.05504],[2.943427,50.053617],[2.932799,50.048189],[2.926864,50.045212],[2.922896,50.04336],[2.913728,50.039438],[2.905465,50.036065],[2.903502,50.03519],[2.900727,50.03373],[2.898976,50.032698],[2.895706,50.030498],[2.892546,50.028308],[2.883041,50.021638],[2.881714,50.020255],[2.880589,50.01852],[2.880179,50.017513],[2.879222,50.014048],[2.877256,50.009912],[2.876765,50.008769],[2.875923,50.005858],[2.875573,50.003524],[2.875218,49.999473],[2.874914,49.997078],[2.874459,49.994911],[2.873357,49.99194],[2.872198,49.989582],[2.868136,49.982031],[2.867091,49.979992],[2.86291,49.972204],[2.860922,49.96887],[2.857681,49.964347],[2.855869,49.961359],[2.854898,49.959123],[2.854188,49.956808],[2.853853,49.955225],[2.852438,49.945709],[2.85189,49.941524],[2.851753,49.938981],[2.851786,49.937378],[2.852017,49.932867],[2.852009,49.930782],[2.851571,49.925491],[2.850515,49.915108],[2.850125,49.910316],[2.849928,49.908471],[2.849443,49.905618],[2.848905,49.903843],[2.847971,49.901607],[2.846526,49.899131],[2.845477,49.897639],[2.841773,49.892833],[2.840209,49.890467],[2.839,49.888081],[2.838071,49.885378],[2.837652,49.883586],[2.836606,49.877601],[2.835196,49.869015],[2.834709,49.866371],[2.833112,49.856784],[2.832741,49.854906],[2.83118,49.845624],[2.830045,49.839064],[2.829326,49.835907],[2.82865,49.833773],[2.82803,49.832179],[2.826931,49.829759],[2.825494,49.826845],[2.819978,49.8158],[2.817943,49.811627],[2.816471,49.808944],[2.815484,49.807383],[2.814196,49.805671],[2.81252,49.803761],[2.80883,49.799962],[2.807293,49.798237],[2.805239,49.795397],[2.804213,49.793509],[2.803387,49.791587],[2.802927,49.790223],[2.80053,49.782192],[2.79832,49.774991],[2.797494,49.772144],[2.79553,49.765761],[2.795206,49.764467],[2.79431,49.761559],[2.792844,49.757202],[2.791806,49.754489],[2.789138,49.747877],[2.78853,49.746232],[2.786991,49.742556],[2.784745,49.736931],[2.783122,49.73302],[2.781012,49.728537],[2.776412,49.719315],[2.774446,49.715519],[2.773294,49.713179],[2.772313,49.710802],[2.771557,49.707677],[2.771382,49.704303],[2.771948,49.686914],[2.772235,49.679196],[2.772199,49.678148],[2.771905,49.676038],[2.771158,49.673123],[2.76922,49.668449],[2.765752,49.660259],[2.760582,49.647921],[2.759841,49.645816],[2.759053,49.643186],[2.758083,49.639561],[2.75641,49.633809],[2.75578,49.630912],[2.755486,49.627377],[2.755359,49.62411],[2.755294,49.614994],[2.755054,49.609236],[2.754752,49.606738],[2.753987,49.603159],[2.753021,49.600262],[2.752382,49.598715],[2.749129,49.59016],[2.747309,49.585747],[2.740718,49.571892],[2.738864,49.568088],[2.737542,49.565234],[2.733186,49.556164],[2.731432,49.552291],[2.730416,49.549826],[2.728826,49.545628],[2.72603,49.538053],[2.725272,49.536109],[2.722967,49.529916],[2.72217,49.527424],[2.721795,49.525882],[2.718995,49.512267],[2.716852,49.502045],[2.713481,49.485785],[2.711734,49.47761],[2.711179,49.474894],[2.710436,49.472194],[2.709699,49.470339],[2.708875,49.468759],[2.702183,49.457776],[2.700462,49.454898],[2.699556,49.453156],[2.698528,49.450893],[2.697696,49.448595],[2.696969,49.446024],[2.696298,49.442248],[2.695544,49.432943],[2.693776,49.412021],[2.693687,49.410517],[2.69372,49.408263],[2.694063,49.406028],[2.694613,49.404045],[2.695484,49.40159],[2.697172,49.397167],[2.698931,49.392239],[2.700711,49.387457],[2.70243,49.382654],[2.70348,49.378773],[2.703819,49.375733],[2.703914,49.373198],[2.70382,49.365735],[2.703483,49.362016],[2.702326,49.356523],[2.701598,49.35352],[2.700827,49.351022],[2.699927,49.348787],[2.69754,49.343512],[2.695487,49.339083],[2.689927,49.326828],[2.687584,49.321592],[2.68641,49.318428],[2.685955,49.316972],[2.684397,49.311263],[2.684091,49.309681],[2.684145,49.307847],[2.684484,49.306468],[2.685198,49.30492],[2.685912,49.303879],[2.688238,49.301079],[2.688984,49.299823],[2.689707,49.297695],[2.691509,49.289659],[2.691869,49.288409],[2.693103,49.285472],[2.694525,49.282616],[2.695114,49.281177],[2.69569,49.279238],[2.695885,49.277536],[2.695723,49.275719],[2.695243,49.274072],[2.694322,49.272195],[2.693604,49.271037],[2.691255,49.267614],[2.684518,49.257052],[2.682891,49.254441],[2.681795,49.25281],[2.681052,49.251905],[2.679371,49.250178],[2.678414,49.249372],[2.676582,49.248052],[2.665969,49.241127],[2.663625,49.239475],[2.661941,49.238102],[2.659692,49.236029],[2.653686,49.230039],[2.65219,49.228624],[2.651014,49.227675],[2.648951,49.226284],[2.647263,49.225339],[2.644245,49.223914],[2.63519,49.219888],[2.630652,49.217814],[2.627485,49.216247],[2.621864,49.213846],[2.620998,49.213438],[2.617823,49.211565],[2.61614,49.210422],[2.613757,49.208555],[2.612234,49.207151],[2.610492,49.205253],[2.609287,49.203684],[2.605924,49.198983],[2.604527,49.196941],[2.60362,49.195077],[2.603216,49.193633],[2.603149,49.191189],[2.603722,49.188994],[2.604735,49.186556],[2.605144,49.185059],[2.605299,49.183524],[2.605236,49.182271],[2.604837,49.180556],[2.603721,49.178213],[2.602604,49.176642],[2.601331,49.17516],[2.600737,49.174272],[2.59983,49.172415],[2.599535,49.171467],[2.599291,49.169786],[2.599263,49.166965],[2.598983,49.165767],[2.598293,49.163923],[2.597501,49.162543],[2.596111,49.160803],[2.594567,49.159406],[2.591309,49.156804],[2.583264,49.150521],[2.574726,49.143722],[2.570847,49.140708],[2.562953,49.134408],[2.560928,49.132529],[2.559128,49.130287],[2.558025,49.128336],[2.55741,49.126764],[2.556806,49.123987],[2.556271,49.120122],[2.555878,49.118623],[2.554627,49.115568],[2.553017,49.112425],[2.551906,49.109693],[2.551299,49.107296],[2.550206,49.100642],[2.550012,49.099123],[2.549968,49.096454],[2.550815,49.086084],[2.551459,49.078988],[2.552395,49.067703],[2.552442,49.065722],[2.552293,49.06419],[2.552028,49.062905],[2.551469,49.061139],[2.549425,49.057079],[2.548428,49.054616],[2.547538,49.050883],[2.546624,49.047875],[2.545793,49.046182],[2.544071,49.043407],[2.543089,49.041564],[2.542376,49.039995],[2.540659,49.035168],[2.539461,49.032045],[2.538627,49.030257],[2.536581,49.026201],[2.535349,49.023933],[2.535251,49.023505],[2.532248,49.017705],[2.530691,49.014585],[2.526715,49.006782],[2.524886,49.003794],[2.52347,49.002108],[2.522066,49.000655],[2.51837,48.997288],[2.51493,48.994097],[2.511902,48.991454],[2.509696,48.989405],[2.508133,48.988067],[2.50706,48.987339],[2.504861,48.986377],[2.503193,48.985304],[2.501134,48.983151],[2.499856,48.982177],[2.492831,48.977423],[2.490521,48.975919],[2.481029,48.969612],[2.479557,48.968798],[2.477676,48.967964],[2.476472,48.967289],[2.475444,48.966516],[2.474417,48.965213],[2.47377,48.963386],[2.473208,48.96009],[2.473076,48.957867],[2.473133,48.956007],[2.473298,48.95452],[2.473715,48.952516],[2.474084,48.951305],[2.474925,48.94918],[2.477367,48.943752],[2.478064,48.942318],[2.479277,48.939499],[2.479974,48.937221],[2.480423,48.934815],[2.481273,48.92821],[2.481207,48.926402],[2.480858,48.924582],[2.480446,48.923397],[2.478863,48.919667],[2.478253,48.917867],[2.477194,48.914349],[2.475797,48.911655],[2.47507,48.910614],[2.472539,48.907356],[2.47098,48.903357],[2.469904,48.901314],[2.46938,48.899965],[2.46926,48.898939],[2.469466,48.897565],[2.469909,48.896568],[2.471769,48.894121],[2.472743,48.892456],[2.473859,48.88857],[2.473901,48.88784],[2.473378,48.886644],[2.47245,48.885768],[2.470898,48.884736],[2.470226,48.884425],[2.468449,48.883992],[2.467342,48.883937],[2.461645,48.884184],[2.459747,48.884002],[2.458299,48.883525],[2.451778,48.880651],[2.448312,48.879161],[2.445792,48.877994],[2.444468,48.877505],[2.442283,48.876422],[2.438468,48.874634],[2.433737,48.872276],[2.430372,48.870122],[2.428499,48.868476],[2.426125,48.867103],[2.424501,48.866652],[2.420661,48.865753],[2.419167,48.865611],[2.418017,48.865688],[2.413846,48.866373],[2.412568,48.866053],[2.412258,48.865437],[2.412816,48.864539],[2.413276,48.863422],[2.413806,48.860618],[2.414025,48.858345],[2.413731,48.855093],[2.413992,48.853503],[2.414954,48.851704],[2.415081,48.8505],[2.414856,48.849205],[2.414554,48.848649],[2.413941,48.846589],[2.414495,48.846392],[2.416015,48.846563],[2.419801,48.846182],[2.424218,48.845839],[2.425875,48.845649],[2.437758,48.844655],[2.438688,48.844488],[2.438188,48.841825],[2.398972,48.828839],[2.39503,48.828006],[2.391873,48.827576],[2.390309,48.827097],[2.386672,48.825815],[2.383769,48.824605],[2.378612,48.821544],[2.369504,48.818396],[2.365784,48.817256],[2.363796,48.816412],[2.362092,48.816193],[2.36109,48.816259],[2.35591,48.815305],[2.354497,48.813511],[2.350891,48.811479],[2.349422,48.810131],[2.348829,48.809232],[2.346861,48.807489],[2.344061,48.804293],[2.343734,48.803724],[2.343333,48.802024],[2.343837,48.798135],[2.343813,48.797122],[2.344582,48.794287],[2.344511,48.793444],[2.343889,48.790692],[2.343842,48.789816],[2.344072,48.788865],[2.345243,48.786194],[2.345794,48.78512],[2.346205,48.783743],[2.346351,48.782395],[2.34601,48.778579],[2.345366,48.773229],[2.34493,48.770919],[2.344309,48.769698],[2.342979,48.767636],[2.342532,48.765722],[2.342146,48.764653],[2.340476,48.762377],[2.335318,48.757727],[2.334251,48.756649],[2.331912,48.753981],[2.32854,48.750456],[2.32742,48.749101],[2.3261,48.747931],[2.325069,48.746749],[2.323022,48.744721],[2.322036,48.743932],[2.320745,48.742657],[2.318815,48.741008],[2.318024,48.740181],[2.316555,48.738086],[2.315673,48.736157],[2.314714,48.734997],[2.312101,48.733189],[2.308011,48.730526],[2.300187,48.725354],[2.297974,48.723863],[2.295619,48.721961],[2.294303,48.720747],[2.291998,48.718237],[2.289651,48.714996],[2.289028,48.714471],[2.28511,48.712938],[2.284118,48.712845],[2.283067,48.712954],[2.27667,48.713861],[2.273187,48.714514],[2.270541,48.71512],[2.266814,48.716141],[2.260765,48.718309],[2.257247,48.719958],[2.256492,48.720166],[2.255257,48.720112],[2.254723,48.719796],[2.254106,48.718907],[2.253928,48.716103],[2.252982,48.713458],[2.250557,48.707811],[2.248965,48.703814],[2.24841,48.702769],[2.247121,48.701219],[2.245154,48.699718],[2.242636,48.698519],[2.239106,48.69725],[2.235641,48.696066],[2.231387,48.694545],[2.228033,48.693227],[2.22542,48.692139],[2.22102,48.689968],[2.218236,48.688415],[2.215336,48.686562],[2.212879,48.684856],[2.209455,48.682333],[2.20744,48.680758],[2.201282,48.676183],[2.19815,48.673798],[2.197067,48.672899],[2.194798,48.670783],[2.192501,48.668336],[2.188979,48.664086],[2.186313,48.661277],[2.184216,48.659382],[2.181128,48.656958],[2.178789,48.655348],[2.175598,48.65339],[2.170024,48.650209],[2.164723,48.647049],[2.158534,48.643432],[2.154273,48.640747],[2.151537,48.638885],[2.149449,48.637291],[2.146405,48.634703],[2.144,48.632302],[2.138355,48.62623],[2.137236,48.625085],[2.134057,48.622121],[2.131508,48.620146],[2.129067,48.618567],[2.126141,48.616962],[2.124068,48.615973],[2.120183,48.614494],[2.11561,48.613121],[2.111867,48.612172],[2.097942,48.609004],[2.094118,48.608056],[2.089818,48.607171],[2.0803,48.604965],[2.077198,48.604291],[2.068026,48.602171],[2.065383,48.601505],[2.062476,48.600678],[2.058173,48.599229],[2.055689,48.598274],[2.051221,48.596317],[2.04484,48.593331],[2.042623,48.592385],[2.039179,48.591016],[2.036805,48.590179],[2.029023,48.587702],[2.026407,48.586797],[2.023815,48.585804],[2.021005,48.58461],[2.018524,48.5834],[2.015466,48.581819],[2.012514,48.580076],[2.005913,48.576471],[2.003334,48.575222],[1.99811,48.572859],[1.996052,48.571978],[1.991197,48.570054],[1.987183,48.568606],[1.984109,48.567559],[1.980102,48.566303],[1.977557,48.565599],[1.973161,48.564659],[1.968672,48.563905],[1.962101,48.5631],[1.957214,48.562374],[1.954824,48.561919],[1.952165,48.561294],[1.947606,48.560096],[1.94284,48.558557],[1.926447,48.552612],[1.922544,48.551147],[1.914797,48.548148],[1.912163,48.546982],[1.909728,48.545591],[1.908226,48.544462],[1.906431,48.542682],[1.905202,48.540903],[1.904436,48.539199],[1.904049,48.537665],[1.904018,48.535277],[1.904404,48.533541],[1.906001,48.529794],[1.906709,48.527896],[1.90758,48.524619],[1.907925,48.522432],[1.908104,48.520233],[1.908017,48.516935],[1.907703,48.514273],[1.907248,48.511614],[1.907074,48.509674],[1.907027,48.507768],[1.907152,48.504742],[1.907386,48.502795],[1.908112,48.499393],[1.909222,48.496047],[1.910732,48.492335],[1.911805,48.489197],[1.912484,48.486187],[1.912749,48.484236],[1.912882,48.482262],[1.912922,48.47938],[1.912904,48.47461],[1.91272,48.468132],[1.912564,48.465286],[1.91203,48.458019],[1.911565,48.454399],[1.910984,48.451406],[1.910455,48.449223],[1.909328,48.445593],[1.907953,48.441999],[1.901567,48.426272],[1.89992,48.422],[1.897859,48.416205],[1.89671,48.412677],[1.895417,48.408396],[1.893911,48.402836],[1.891248,48.391524],[1.889913,48.385717],[1.88901,48.382061],[1.888496,48.380333],[1.887603,48.377731],[1.886477,48.374953],[1.88499,48.371796],[1.883747,48.369506],[1.882534,48.367471],[1.875819,48.35655],[1.873008,48.351545],[1.871334,48.348259],[1.870001,48.345309],[1.868349,48.341281],[1.867495,48.338961],[1.866272,48.335264],[1.865662,48.333225],[1.86485,48.330092],[1.863983,48.326102],[1.863504,48.323449],[1.862965,48.319519],[1.862489,48.314392],[1.861675,48.304136],[1.861107,48.297669],[1.86087,48.294389],[1.860464,48.289764],[1.859912,48.286125],[1.859402,48.283783],[1.858165,48.279578],[1.857648,48.278201],[1.856875,48.276587],[1.856431,48.276001],[1.855432,48.275233],[1.855678,48.274688],[1.855013,48.274359],[1.855423,48.273618],[1.855199,48.272575],[1.854303,48.270382],[1.853271,48.26744],[1.852482,48.264538],[1.851924,48.26195],[1.851518,48.258755],[1.851292,48.254581],[1.851341,48.249363],[1.851323,48.24546],[1.851127,48.242445],[1.850697,48.23965],[1.850131,48.237043],[1.849582,48.235032],[1.849089,48.232743],[1.847395,48.22648],[1.846906,48.223513],[1.846692,48.220066],[1.846659,48.217857],[1.846742,48.216059],[1.847151,48.212059],[1.847755,48.208995],[1.848696,48.205735],[1.849929,48.201781],[1.850122,48.200965],[1.851506,48.196554],[1.852332,48.193145],[1.853096,48.189741],[1.853482,48.187456],[1.853936,48.183018],[1.854092,48.178291],[1.854006,48.176215],[1.853547,48.169493],[1.853499,48.168019],[1.853693,48.164282],[1.854113,48.160984],[1.854984,48.156373],[1.855386,48.152871],[1.855596,48.149647],[1.855593,48.145875],[1.855325,48.141591],[1.854851,48.138311],[1.854267,48.135161],[1.853533,48.131865],[1.853178,48.130629],[1.851733,48.12468],[1.851371,48.122621],[1.850911,48.11911],[1.850663,48.11523],[1.850636,48.113029],[1.850702,48.109952],[1.851363,48.100344],[1.851703,48.09678],[1.851866,48.094118],[1.851911,48.088879],[1.851648,48.085195],[1.851171,48.081404],[1.850765,48.079293],[1.849935,48.075753],[1.848878,48.072229],[1.846426,48.065166],[1.845348,48.062341],[1.844793,48.06057],[1.8438,48.05789],[1.842742,48.054587],[1.841903,48.051624],[1.841373,48.049299],[1.840893,48.046781],[1.840457,48.043851],[1.84002,48.039443],[1.839957,48.035432],[1.840105,48.032253],[1.840397,48.0291],[1.840805,48.026172],[1.841411,48.022884],[1.842204,48.019638],[1.843058,48.01702],[1.843952,48.014575],[1.845307,48.011228],[1.846539,48.008547],[1.849485,48.002955],[1.852728,47.997316],[1.855027,47.993461],[1.85618,47.991166],[1.857054,47.989007],[1.857738,47.986987],[1.858545,47.983822],[1.858781,47.982506],[1.858989,47.979388],[1.858881,47.975911],[1.858427,47.972781],[1.857445,47.969249],[1.856272,47.966211],[1.855488,47.964589],[1.852411,47.959244],[1.851108,47.956627],[1.849747,47.95296],[1.84891,47.949883],[1.848309,47.946485],[1.848198,47.944843],[1.848219,47.941762],[1.848743,47.936691],[1.84915,47.93368],[1.849327,47.931195],[1.849312,47.928712],[1.849068,47.925508],[1.848639,47.921263],[1.848577,47.919621],[1.848644,47.916929],[1.849451,47.909531],[1.849472,47.907874],[1.849351,47.90707],[1.848919,47.905911],[1.847971,47.904415],[1.846612,47.90305],[1.84581,47.902433],[1.844228,47.901488],[1.842151,47.900616],[1.840727,47.900187],[1.838952,47.899848],[1.837157,47.899692],[1.83559,47.899676],[1.83029,47.900244],[1.824173,47.900736],[1.819554,47.9008],[1.815483,47.900679],[1.811224,47.900409],[1.807878,47.90005],[1.798362,47.898894],[1.791652,47.89799],[1.78332,47.896905],[1.778758,47.896001],[1.77515,47.895226],[1.769433,47.893766],[1.764761,47.892403],[1.759327,47.890534],[1.756198,47.88932],[1.753664,47.888215],[1.749952,47.886438],[1.745204,47.883915],[1.739992,47.88074],[1.732379,47.875458],[1.728965,47.873133],[1.726543,47.871386],[1.721971,47.868265],[1.71694,47.86505],[1.715382,47.864109],[1.711195,47.861733],[1.709488,47.860858],[1.704853,47.858679],[1.701421,47.857226],[1.696985,47.85523],[1.692908,47.853275],[1.689875,47.851668],[1.687051,47.850029],[1.683584,47.847813],[1.681244,47.846238],[1.679394,47.844875],[1.676468,47.842526],[1.671342,47.838499],[1.667751,47.835553],[1.664639,47.833193],[1.661036,47.830749],[1.658377,47.829076],[1.656286,47.827874],[1.652935,47.826063],[1.650068,47.824594],[1.644774,47.821968],[1.641443,47.820273],[1.637942,47.818557],[1.634956,47.816907],[1.632388,47.815371],[1.627734,47.812339],[1.625086,47.810387],[1.623102,47.808824],[1.620842,47.806899],[1.618222,47.804388],[1.614458,47.800867],[1.613778,47.800173],[1.608599,47.795264],[1.605056,47.792021],[1.601834,47.78894],[1.599181,47.786537],[1.596072,47.784009],[1.593611,47.782116],[1.589244,47.779067],[1.58435,47.776037],[1.582167,47.774816],[1.579679,47.773519],[1.576914,47.772196],[1.569853,47.768737],[1.567628,47.767594],[1.563947,47.765598],[1.560776,47.763747],[1.557882,47.761958],[1.553237,47.758908],[1.550501,47.756952],[1.539401,47.748312],[1.536292,47.746129],[1.533273,47.744162],[1.530643,47.742563],[1.525724,47.739886],[1.523286,47.738673],[1.52001,47.737141],[1.515575,47.735225],[1.510206,47.73282],[1.505949,47.730755],[1.503354,47.729352],[1.500857,47.727894],[1.491808,47.722219],[1.489307,47.720781],[1.486486,47.719268],[1.483618,47.717876],[1.480366,47.716458],[1.478013,47.715497],[1.475634,47.714635],[1.468732,47.71224],[1.46607,47.711381],[1.463763,47.710525],[1.46029,47.709135],[1.45596,47.707111],[1.454041,47.706079],[1.451793,47.704732],[1.448626,47.702712],[1.44425,47.699633],[1.439328,47.696035],[1.43695,47.694404],[1.434703,47.692997],[1.432175,47.691524],[1.430304,47.690516],[1.426957,47.688842],[1.420886,47.686155],[1.417911,47.684919],[1.411968,47.682308],[1.409746,47.681242],[1.406647,47.679662],[1.401922,47.676922],[1.397429,47.673906],[1.394598,47.671711],[1.392679,47.670009],[1.389984,47.66745],[1.386962,47.664257],[1.385194,47.662126],[1.381503,47.658035],[1.378326,47.655068],[1.375365,47.652554],[1.370797,47.648965],[1.367915,47.64683],[1.365578,47.644852],[1.363394,47.642775],[1.361013,47.64033],[1.359001,47.638001],[1.355814,47.633727],[1.353532,47.630749],[1.352506,47.629618],[1.351158,47.628352],[1.348969,47.626554],[1.346779,47.625036],[1.34386,47.623353],[1.341815,47.62232],[1.337949,47.620742],[1.334126,47.619532],[1.329715,47.61857],[1.323654,47.617658],[1.319553,47.617197],[1.315733,47.616827],[1.310728,47.616452],[1.305827,47.616204],[1.301754,47.616139],[1.297306,47.61617],[1.291829,47.61632],[1.287617,47.616528],[1.282742,47.616841],[1.269581,47.617802],[1.266809,47.617969],[1.262875,47.618332],[1.259437,47.618523],[1.257048,47.618743],[1.254225,47.618894],[1.248665,47.619345],[1.245783,47.619507],[1.238837,47.619808],[1.2358,47.619796],[1.230965,47.619582],[1.227557,47.619285],[1.22473,47.618908],[1.220667,47.61827],[1.218216,47.617813],[1.214484,47.617204],[1.212856,47.616998],[1.209715,47.616728],[1.206233,47.61651],[1.202447,47.616394],[1.199862,47.616387],[1.194897,47.616591],[1.186301,47.617095],[1.182152,47.617167],[1.177475,47.617141],[1.174321,47.617034],[1.168981,47.616659],[1.164299,47.616103],[1.159429,47.615433],[1.151442,47.614129],[1.145004,47.612821],[1.140613,47.611814],[1.136266,47.610718],[1.132242,47.609617],[1.129152,47.608703],[1.123599,47.606954],[1.117014,47.604649],[1.113231,47.603195],[1.109549,47.601655],[1.105381,47.599825],[1.102852,47.598643],[1.098615,47.596563],[1.095119,47.594738],[1.088153,47.590883],[1.08422,47.58887],[1.080907,47.587268],[1.070371,47.582462],[1.067088,47.580804],[1.06309,47.578658],[1.058453,47.575909],[1.051495,47.571532],[1.048372,47.569661],[1.044882,47.567704],[1.041272,47.565855],[1.037336,47.56398],[1.031892,47.561657],[1.026945,47.55977],[1.023515,47.558573],[1.014594,47.555613],[1.010315,47.554242],[1.00536,47.552584],[1.002137,47.551551],[0.988407,47.547055],[0.983096,47.545214],[0.9801,47.544075],[0.975944,47.542275],[0.9644,47.53682],[0.959937,47.534743],[0.950672,47.530363],[0.947718,47.529033],[0.945698,47.528203],[0.941523,47.526656],[0.938001,47.525488],[0.93438,47.524439],[0.92775,47.522718],[0.924437,47.521733],[0.920424,47.520371],[0.916807,47.518975],[0.903502,47.513542],[0.89739,47.511169],[0.893218,47.509831],[0.889143,47.508756],[0.886168,47.508092],[0.881638,47.507247],[0.878847,47.506779],[0.874189,47.505882],[0.868882,47.504681],[0.865449,47.503815],[0.861891,47.502833],[0.85722,47.501387],[0.855519,47.500742],[0.851402,47.499306],[0.845626,47.49739],[0.840967,47.496021],[0.837474,47.495069],[0.829609,47.493026],[0.825131,47.491835],[0.819921,47.490871],[0.818565,47.490484],[0.816054,47.489462],[0.810389,47.48795],[0.801795,47.485526],[0.798196,47.4844],[0.795867,47.483606],[0.793003,47.482533],[0.788467,47.480676],[0.785132,47.479224],[0.782549,47.477987],[0.778231,47.475763],[0.775523,47.474245],[0.772918,47.472658],[0.769575,47.470356],[0.767662,47.468901],[0.76477,47.466405],[0.762484,47.464156],[0.758213,47.459544],[0.756086,47.457416],[0.75351,47.455211],[0.750671,47.453232],[0.748051,47.45171],[0.744816,47.44998],[0.742355,47.448366],[0.740674,47.446861],[0.739651,47.445641],[0.738522,47.44371],[0.737979,47.442161],[0.737299,47.439209],[0.735979,47.43404],[0.734919,47.430407],[0.733253,47.425341],[0.729343,47.414475],[0.728783,47.413256],[0.727818,47.4119],[0.726912,47.410998],[0.725391,47.409877],[0.723868,47.409063],[0.720997,47.408024],[0.718159,47.407206],[0.7166,47.406595],[0.715652,47.406073],[0.71431,47.404901],[0.711412,47.401396],[0.706831,47.395744],[0.705903,47.394172],[0.705699,47.393363],[0.705768,47.392143],[0.706357,47.390839],[0.712656,47.379981],[0.714326,47.37682],[0.714996,47.374798],[0.715353,47.372918],[0.715331,47.37059],[0.715153,47.369379],[0.714459,47.367085],[0.713573,47.365076],[0.712207,47.36262],[0.708604,47.356824],[0.706697,47.353892],[0.69939,47.342953],[0.697383,47.339432],[0.696521,47.337634],[0.694446,47.332864],[0.692086,47.32713],[0.689658,47.320095],[0.689034,47.317595],[0.688904,47.315058],[0.689249,47.31273],[0.689772,47.311057],[0.691679,47.306601],[0.692118,47.304934],[0.692304,47.302585],[0.692097,47.300852],[0.691433,47.298663],[0.69062,47.296957],[0.689823,47.295731],[0.688721,47.29438],[0.6863,47.29194],[0.68473,47.290201],[0.683981,47.289186],[0.682443,47.286422],[0.680377,47.282008],[0.678587,47.278618],[0.677326,47.276636],[0.675923,47.274718],[0.672458,47.270351],[0.670568,47.267783],[0.668656,47.264663],[0.667222,47.261653],[0.6664,47.259443],[0.665509,47.256103],[0.664514,47.251383],[0.66394,47.249127],[0.663381,47.247338],[0.662409,47.244669],[0.660377,47.239442],[0.659863,47.237818],[0.659242,47.235303],[0.658869,47.233234],[0.658621,47.230952],[0.657924,47.221251],[0.657205,47.219309],[0.657043,47.218348],[0.657,47.215771],[0.656055,47.212271],[0.655231,47.209843],[0.654192,47.207235],[0.64489,47.185933],[0.64381,47.183679],[0.642727,47.181635],[0.640856,47.178537],[0.638542,47.175286],[0.636645,47.172985],[0.633733,47.169704],[0.631051,47.166606],[0.629557,47.164694],[0.627607,47.161843],[0.626006,47.159005],[0.625098,47.157032],[0.623936,47.153756],[0.623205,47.151334],[0.621741,47.14544],[0.62112,47.143508],[0.620075,47.140891],[0.619071,47.13881],[0.615752,47.13268],[0.614575,47.130883],[0.613553,47.129601],[0.61181,47.127769],[0.610016,47.126235],[0.604607,47.122303],[0.601527,47.119877],[0.59934,47.117926],[0.596481,47.114977],[0.595297,47.113562],[0.593478,47.1112],[0.592335,47.10959],[0.590543,47.106418],[0.589741,47.105942],[0.589036,47.10594],[0.588325,47.106355],[0.587218,47.108276],[0.587608,47.108607],[0.592511,47.108849],[0.593642,47.108571],[0.594691,47.108875],[0.613521,47.108606],[0.613879,47.108366],[0.613584,47.107494],[0.612495,47.103489],[0.612369,47.1033],[0.615524,47.102345],[0.616108,47.102804],[0.61593,47.102221],[0.61557,47.10219],[0.615522,47.103034],[0.614475,47.102719],[0.612385,47.103328],[0.612093,47.102031],[0.611765,47.101694],[0.611913,47.101232],[0.610476,47.095992],[0.61017,47.09417],[0.610533,47.091598],[0.611681,47.084717],[0.612353,47.081154],[0.613006,47.077271],[0.613126,47.07704],[0.612327,47.081835],[0.610971,47.089651],[0.610247,47.094424],[0.610252,47.094825],[0.611028,47.097522],[0.611989,47.101296],[0.612336,47.101732],[0.610767,47.102041],[0.608035,47.102106],[0.605858,47.102577],[0.605128,47.102922],[0.603005,47.104206],[0.601571,47.104819],[0.59998,47.105344],[0.598089,47.106112],[0.595561,47.107374],[0.593935,47.108456],[0.593604,47.108868],[0.592046,47.108875],[0.588547,47.108666],[0.586831,47.108761],[0.587047,47.108212],[0.588554,47.105626],[0.589196,47.104801],[0.58938,47.103801],[0.588542,47.1012],[0.587745,47.098474],[0.587141,47.095795],[0.586701,47.09343],[0.586219,47.089819],[0.585993,47.087427],[0.585897,47.084231],[0.585976,47.080495],[0.586183,47.077588],[0.586428,47.075431],[0.586954,47.072088],[0.588803,47.062994],[0.589249,47.059116],[0.589166,47.0568],[0.588735,47.054247],[0.58778,47.051298],[0.586958,47.049579],[0.586142,47.048157],[0.585035,47.046529],[0.583388,47.044512],[0.580781,47.04191],[0.576547,47.038074],[0.574741,47.036332],[0.572872,47.034314],[0.570854,47.03177],[0.569298,47.029478],[0.567817,47.027126],[0.567192,47.025953],[0.564738,47.02185],[0.562651,47.018073],[0.562487,47.017559],[0.560689,47.014898],[0.559693,47.01316],[0.557874,47.009738],[0.556921,47.008395],[0.55491,47.005072],[0.552512,47.000607],[0.551193,46.997529],[0.549671,46.993234],[0.548954,46.990632],[0.548251,46.987348],[0.547973,46.985377],[0.547456,46.983021],[0.546863,46.98081],[0.546535,46.978744],[0.546399,46.977269],[0.546408,46.97566],[0.546678,46.972902],[0.547536,46.967911],[0.547934,46.965891],[0.548909,46.959796],[0.549126,46.957188],[0.549149,46.954837],[0.548813,46.951772],[0.548541,46.950359],[0.547798,46.947728],[0.54634,46.942959],[0.54531,46.939746],[0.54453,46.937536],[0.542831,46.933576],[0.541649,46.931367],[0.539996,46.928698],[0.538019,46.926078],[0.533433,46.920464],[0.530742,46.917248],[0.528732,46.914926],[0.525577,46.910872],[0.524618,46.909744],[0.523336,46.907677],[0.522216,46.905458],[0.521115,46.901598],[0.520585,46.899242],[0.520255,46.897103],[0.519663,46.89436],[0.518912,46.891783],[0.518632,46.889475],[0.51825,46.887763],[0.517787,46.884756],[0.517733,46.882153],[0.517964,46.879941],[0.518657,46.876898],[0.51931,46.875238],[0.520967,46.871884],[0.521909,46.870212],[0.523402,46.866872],[0.524437,46.863731],[0.525374,46.859478],[0.52573,46.856864],[0.52576,46.854905],[0.525984,46.851853],[0.525891,46.848463],[0.525927,46.847469],[0.525782,46.844978],[0.52528,46.840783],[0.524558,46.837354],[0.523834,46.834936],[0.522881,46.832825],[0.521362,46.829735],[0.517894,46.822536],[0.516013,46.818827],[0.514947,46.816386],[0.514448,46.814817],[0.513941,46.812572],[0.513448,46.807754],[0.513375,46.806528],[0.512727,46.801585],[0.511943,46.798384],[0.51083,46.795226],[0.509652,46.792748],[0.507367,46.788827],[0.505187,46.786074],[0.503298,46.784062],[0.501257,46.782103],[0.498953,46.780061],[0.494874,46.777137],[0.491727,46.775246],[0.489134,46.773806],[0.485754,46.77225],[0.483223,46.771232],[0.481801,46.770751],[0.477046,46.768766],[0.473913,46.767626],[0.470584,46.76614],[0.465602,46.764364],[0.45983,46.762002],[0.454257,46.759581],[0.451396,46.757996],[0.45019,46.757403],[0.445341,46.754465],[0.445156,46.754291],[0.43879,46.750186],[0.437358,46.749432],[0.436812,46.749605],[0.435705,46.749138],[0.434671,46.748242],[0.433338,46.747452],[0.431485,46.74655],[0.428531,46.74492],[0.428328,46.744706],[0.425745,46.74359],[0.422066,46.742222],[0.419145,46.741293],[0.417843,46.741009],[0.413959,46.739611],[0.40995,46.737969],[0.407399,46.736803],[0.402708,46.734268],[0.401143,46.733289],[0.397756,46.730826],[0.397042,46.730233],[0.392141,46.726534],[0.389601,46.724521],[0.383222,46.719712],[0.381161,46.717829],[0.37943,46.71614],[0.375666,46.71179],[0.374785,46.710567],[0.373823,46.709463],[0.371496,46.70469],[0.370707,46.702856],[0.369919,46.700562],[0.368932,46.697078],[0.367528,46.693579],[0.366706,46.692125],[0.365296,46.68995],[0.364802,46.689025],[0.363651,46.687344],[0.362006,46.684684],[0.36026,46.681153],[0.35932,46.678381],[0.358772,46.676245],[0.358063,46.672883],[0.357254,46.669507],[0.356771,46.666771],[0.3559,46.662861],[0.355434,46.660282],[0.355183,46.65815],[0.355061,46.654884],[0.355449,46.650815],[0.355523,46.649324],[0.355424,46.647074],[0.355267,46.645683],[0.354773,46.642818],[0.354052,46.640154],[0.35369,46.639183],[0.352969,46.636606],[0.352374,46.634874],[0.351355,46.630453],[0.350616,46.627827],[0.349496,46.625403],[0.348255,46.62356],[0.346059,46.620978],[0.344558,46.619577],[0.342895,46.618228],[0.340007,46.616392],[0.336848,46.614781],[0.331443,46.612154],[0.326505,46.609626],[0.323847,46.608151],[0.321042,46.606482],[0.317537,46.604253],[0.31448,46.602177],[0.31131,46.599813],[0.308027,46.597232],[0.305073,46.594728],[0.301788,46.591762],[0.299109,46.589131],[0.295941,46.585885],[0.294974,46.584812],[0.293202,46.582553],[0.291673,46.580182],[0.290994,46.578771],[0.289911,46.575532],[0.289167,46.572124],[0.288201,46.569039],[0.288032,46.568028],[0.287634,46.566881],[0.287374,46.565307],[0.286849,46.563216],[0.285408,46.558853],[0.284064,46.556189],[0.281119,46.555125],[0.280948,46.554075],[0.282443,46.5527],[0.283849,46.551639],[0.285467,46.55076],[0.287258,46.549947],[0.290062,46.548491],[0.291011,46.548152],[0.294855,46.546318],[0.295594,46.545383],[0.295122,46.544375],[0.293808,46.543101],[0.290714,46.54047],[0.290059,46.540009],[0.286838,46.53831],[0.285366,46.537257],[0.284519,46.536359],[0.284025,46.535585],[0.283482,46.534228],[0.282755,46.530602],[0.281933,46.526072],[0.28113,46.523709],[0.280346,46.522191],[0.279312,46.520457],[0.278652,46.518474],[0.278438,46.516731],[0.278888,46.51309],[0.278733,46.511085],[0.277648,46.506221],[0.277377,46.5045],[0.277378,46.503215],[0.27786,46.500832],[0.278285,46.499264],[0.278278,46.497564],[0.277498,46.495681],[0.275348,46.492623],[0.273964,46.490341],[0.272796,46.487853],[0.272453,46.486302],[0.272365,46.484532],[0.271449,46.482021],[0.270423,46.47854],[0.269708,46.475642],[0.268936,46.473147],[0.268776,46.472128],[0.268283,46.470747],[0.268122,46.469123],[0.267791,46.467116],[0.267733,46.465355],[0.267326,46.462416],[0.266969,46.458985],[0.266693,46.458278],[0.265816,46.45737],[0.265532,46.45684],[0.265765,46.455862],[0.266134,46.455593],[0.265834,46.452739],[0.266032,46.451961],[0.265709,46.447831],[0.26551,46.4469],[0.265334,46.444732],[0.264837,46.441199],[0.264607,46.438775],[0.264378,46.437293],[0.264231,46.435377],[0.263541,46.433567],[0.262339,46.431958],[0.261816,46.43143],[0.259213,46.429237],[0.257519,46.427457],[0.252514,46.422031],[0.251406,46.420725],[0.249391,46.418681],[0.248395,46.417536],[0.24671,46.415917],[0.244861,46.413644],[0.239748,46.408012],[0.239547,46.407581],[0.237565,46.40563],[0.236266,46.404128],[0.235356,46.403285],[0.233315,46.400949],[0.229917,46.397188],[0.227272,46.39433],[0.226201,46.393051],[0.222135,46.388659],[0.217039,46.382975],[0.215828,46.381709],[0.21344,46.37891],[0.211319,46.37654],[0.209936,46.3746],[0.208876,46.37204],[0.208412,46.369602],[0.208025,46.368371],[0.207338,46.366978],[0.206249,46.365484],[0.204855,46.364075],[0.203493,46.363059],[0.201869,46.362122],[0.199642,46.361016],[0.197565,46.359803],[0.196619,46.359141],[0.193823,46.356881],[0.192261,46.35532],[0.188881,46.352433],[0.186657,46.350081],[0.185778,46.348376],[0.185508,46.347214],[0.185435,46.345658],[0.185684,46.339966],[0.185593,46.33675],[0.185875,46.334576],[0.186101,46.329258],[0.185889,46.327888],[0.186174,46.326138],[0.186058,46.325888],[0.186521,46.322366],[0.186571,46.320762],[0.186845,46.316652],[0.186856,46.315027],[0.186549,46.313643],[0.185881,46.312325],[0.184779,46.311078],[0.183063,46.309795],[0.181018,46.308528],[0.179593,46.307239],[0.178661,46.30611],[0.174826,46.299929],[0.174306,46.298852],[0.173784,46.297043],[0.173643,46.295889],[0.17364,46.294419],[0.174521,46.289115],[0.174777,46.286775],[0.17479,46.285243],[0.174503,46.282623],[0.173058,46.275473],[0.172769,46.273704],[0.172171,46.271069],[0.172043,46.269826],[0.171786,46.268961],[0.171544,46.267251],[0.171258,46.266201],[0.17039,46.261934],[0.169879,46.259167],[0.168911,46.256903],[0.166502,46.25336],[0.165389,46.251257],[0.165081,46.250062],[0.164879,46.248013],[0.164975,46.246905],[0.165685,46.242893],[0.165968,46.241767],[0.166016,46.240391],[0.165637,46.238053],[0.165194,46.236141],[0.164765,46.233807],[0.164299,46.232004],[0.164177,46.230774],[0.163315,46.226701],[0.162796,46.22398],[0.162492,46.222949],[0.162202,46.221223],[0.161114,46.216264],[0.160869,46.214585],[0.159879,46.210072],[0.159622,46.208201],[0.159774,46.206041],[0.160092,46.204547],[0.160543,46.203081],[0.161996,46.200202],[0.162521,46.198538],[0.162844,46.195677],[0.162864,46.193362],[0.163376,46.186758],[0.16369,46.185129],[0.165285,46.179903],[0.166021,46.177343],[0.16674,46.175198],[0.167269,46.17325],[0.169721,46.165491],[0.172228,46.15709],[0.173259,46.153737],[0.174156,46.151296],[0.174808,46.148996],[0.175047,46.147397],[0.174893,46.144898],[0.174143,46.142686],[0.17408,46.140102],[0.174344,46.138646],[0.174751,46.137429],[0.175501,46.135995],[0.176165,46.135035],[0.178666,46.132298],[0.17959,46.130911],[0.180852,46.127949],[0.182108,46.125474],[0.182569,46.124078],[0.184782,46.116764],[0.186797,46.110231],[0.187028,46.109228],[0.188809,46.103761],[0.189652,46.100681],[0.191243,46.095967],[0.192027,46.093372],[0.192274,46.091786],[0.192167,46.090622],[0.191802,46.089408],[0.19106,46.087962],[0.190123,46.086543],[0.189613,46.085335],[0.18939,46.084253],[0.189417,46.083307],[0.189778,46.081642],[0.190413,46.080346],[0.191292,46.079121],[0.191985,46.078553],[0.1943,46.076258],[0.194908,46.075489],[0.195884,46.073891],[0.19723,46.070491],[0.198728,46.066916],[0.199337,46.064751],[0.199525,46.063416],[0.199467,46.060834],[0.19901,46.057159],[0.198919,46.055206],[0.198603,46.052625],[0.198098,46.049298],[0.197499,46.04756],[0.196967,46.04672],[0.195619,46.045195],[0.194656,46.044382],[0.193256,46.043439],[0.190541,46.04192],[0.188007,46.040415],[0.184505,46.037889],[0.18249,46.03599],[0.18181,46.0352],[0.180266,46.033044],[0.179233,46.030761],[0.178869,46.029241],[0.178761,46.027679],[0.178955,46.025999],[0.179605,46.02401],[0.180411,46.02247],[0.181466,46.020999],[0.182753,46.019649],[0.184995,46.017847],[0.190145,46.014758],[0.19314,46.012795],[0.194996,46.011313],[0.196305,46.009967],[0.19792,46.007841],[0.198936,46.005951],[0.199295,46.004993],[0.199826,46.002962],[0.199998,46.001594],[0.200016,45.99751],[0.199947,45.996675],[0.200719,45.988268],[0.201614,45.98031],[0.201976,45.977577],[0.202775,45.975004],[0.203729,45.973491],[0.204481,45.971988],[0.204977,45.969646],[0.204863,45.967821],[0.204263,45.965884],[0.202752,45.963058],[0.201994,45.960733],[0.201351,45.955279],[0.20105,45.953267],[0.200274,45.94735],[0.200181,45.946276],[0.199187,45.939071],[0.198678,45.936593],[0.197688,45.928951],[0.197328,45.925807],[0.196995,45.923647],[0.196271,45.917837],[0.195749,45.913237],[0.195283,45.909578],[0.194747,45.906755],[0.193851,45.903322],[0.19308,45.901098],[0.192695,45.899653],[0.191388,45.895725],[0.191,45.894193],[0.189967,45.887249],[0.189643,45.885831],[0.188908,45.880756],[0.188219,45.876894],[0.187718,45.874634],[0.18746,45.871916],[0.187109,45.870091],[0.187443,45.86957],[0.187279,45.868613],[0.187309,45.866475],[0.184746,45.865762],[0.183797,45.864238],[0.183264,45.862887],[0.18299,45.861545],[0.183173,45.859693],[0.184413,45.855397],[0.184673,45.854072],[0.185773,45.850284],[0.186265,45.848068],[0.187015,45.84546],[0.187414,45.844481],[0.187967,45.841996],[0.189402,45.836517],[0.190177,45.833768],[0.190598,45.832593],[0.191457,45.829294],[0.192622,45.825077],[0.193011,45.823929],[0.193166,45.82269],[0.192929,45.818902],[0.192328,45.810859],[0.191989,45.808558],[0.19142,45.806656],[0.189993,45.803888],[0.189346,45.802922],[0.187382,45.799509],[0.186874,45.798479],[0.186345,45.796537],[0.186326,45.794213],[0.18685,45.792232],[0.187609,45.790772],[0.188294,45.789788],[0.189562,45.787532],[0.190315,45.785229],[0.190311,45.782122],[0.189974,45.777755],[0.189876,45.77471],[0.189582,45.773223],[0.189025,45.771537],[0.188633,45.77112],[0.188546,45.770414],[0.188768,45.768857],[0.189582,45.767063],[0.190371,45.765992],[0.190739,45.765841],[0.191368,45.764609],[0.192585,45.761475],[0.192852,45.760097],[0.192703,45.757608],[0.192145,45.756032],[0.191576,45.754947],[0.189177,45.751416],[0.188573,45.750372],[0.187836,45.748388],[0.187616,45.746918],[0.187735,45.744673],[0.188653,45.738824],[0.188893,45.737782],[0.188987,45.736479],[0.188908,45.735249],[0.187894,45.730982],[0.18732,45.728187],[0.187042,45.727304],[0.186268,45.723519],[0.186179,45.72261],[0.185769,45.72114],[0.184698,45.719168],[0.183135,45.717367],[0.181603,45.716097],[0.180511,45.715326],[0.178472,45.714084],[0.177473,45.713695],[0.17671,45.712801],[0.17569,45.71132],[0.175145,45.709978],[0.174982,45.709055],[0.17503,45.707679],[0.17529,45.706682],[0.17584,45.705516],[0.178532,45.702167],[0.179213,45.700107],[0.179201,45.698935],[0.178759,45.697689],[0.178107,45.696704],[0.176752,45.695382],[0.175835,45.694849],[0.173979,45.694219],[0.171974,45.6939],[0.168739,45.693739],[0.164884,45.693035],[0.163458,45.692675],[0.16183,45.691944],[0.16061,45.691085],[0.159606,45.690064],[0.157787,45.687762],[0.155797,45.685384],[0.154006,45.683434],[0.151396,45.680923],[0.149272,45.679264],[0.143639,45.675186],[0.142986,45.674778],[0.138989,45.671632],[0.137818,45.670846],[0.135295,45.66882],[0.132648,45.666426],[0.131323,45.665391],[0.128477,45.662957],[0.127643,45.662144],[0.126047,45.660844],[0.124591,45.659494],[0.121043,45.656463],[0.119732,45.655018],[0.118373,45.652209],[0.118356,45.649006],[0.118453,45.647702],[0.118439,45.645241],[0.11852,45.644182],[0.118451,45.641793],[0.118583,45.64079],[0.118511,45.638829],[0.118322,45.637629],[0.117838,45.636164],[0.116582,45.634078],[0.115833,45.633169],[0.112074,45.628088],[0.110607,45.626017],[0.109354,45.624498],[0.107727,45.622996],[0.10608,45.621635],[0.103508,45.619666],[0.100703,45.617366],[0.098114,45.615507],[0.096321,45.614394],[0.093578,45.61302],[0.090305,45.611841],[0.086665,45.610289],[0.083884,45.609563],[0.08095,45.60899],[0.079263,45.608508],[0.077203,45.607523],[0.076411,45.607022],[0.07495,45.605771],[0.073793,45.604175],[0.071824,45.600339],[0.071131,45.599195],[0.069531,45.597859],[0.067661,45.596824],[0.064666,45.595005],[0.063287,45.594063],[0.06136,45.592938],[0.05714,45.59063],[0.051693,45.588831],[0.048442,45.587635],[0.046649,45.58676],[0.045511,45.585975],[0.043927,45.584506],[0.042273,45.583199],[0.04078,45.581821],[0.034886,45.57679],[0.033466,45.575782],[0.029643,45.572558],[0.028776,45.571772],[0.027456,45.570887],[0.024739,45.569391],[0.023751,45.568939],[0.019667,45.566733],[0.014047,45.563611],[0.012806,45.562835],[0.007823,45.560197],[0.003255,45.557552],[-0.000743,45.555482],[-0.006467,45.552292],[-0.008174,45.551714],[-0.014852,45.549158],[-0.016123,45.548574],[-0.022121,45.546415],[-0.024728,45.545783],[-0.026605,45.545632],[-0.033079,45.545539],[-0.034487,45.545399],[-0.037158,45.544819],[-0.038767,45.544234],[-0.041213,45.542793],[-0.042063,45.542108],[-0.043457,45.540645],[-0.044464,45.539211],[-0.046375,45.537318],[-0.049228,45.535694],[-0.058237,45.530885],[-0.062124,45.529304],[-0.06341,45.528644],[-0.064737,45.527743],[-0.066834,45.525942],[-0.068859,45.524602],[-0.07092,45.523651],[-0.07352,45.522816],[-0.076308,45.522364],[-0.077883,45.522306],[-0.085607,45.522842],[-0.088483,45.522701],[-0.090912,45.522303],[-0.095674,45.521684],[-0.098321,45.521077],[-0.100494,45.520111],[-0.102175,45.518923],[-0.105881,45.515549],[-0.109875,45.511818],[-0.114533,45.507667],[-0.115952,45.506253],[-0.117724,45.50478],[-0.120073,45.502693],[-0.124565,45.498485],[-0.126646,45.495978],[-0.128677,45.493198],[-0.129467,45.491886],[-0.129911,45.490686],[-0.130267,45.489095],[-0.130879,45.483108],[-0.131159,45.480969],[-0.131454,45.479492],[-0.131942,45.477774],[-0.133115,45.472926],[-0.133579,45.468879],[-0.134126,45.466832],[-0.134577,45.465836],[-0.135471,45.464519],[-0.137044,45.462768],[-0.138599,45.461532],[-0.139954,45.460711],[-0.144711,45.458105],[-0.146893,45.456807],[-0.148858,45.455523],[-0.155551,45.451323],[-0.157361,45.450268],[-0.163625,45.446358],[-0.166147,45.444877],[-0.168097,45.443853],[-0.169863,45.442659],[-0.17137,45.441229],[-0.172621,45.439575],[-0.173257,45.43838],[-0.17385,45.43653],[-0.174027,45.434838],[-0.173975,45.433765],[-0.173696,45.432089],[-0.173204,45.430228],[-0.172849,45.428362],[-0.172769,45.426856],[-0.172876,45.425794],[-0.173461,45.423565],[-0.174587,45.420765],[-0.175286,45.418611],[-0.175636,45.416028],[-0.176127,45.41444],[-0.177632,45.41169],[-0.178336,45.409716],[-0.178603,45.407538],[-0.179333,45.398829],[-0.180028,45.389565],[-0.180245,45.387952],[-0.180532,45.386775],[-0.181412,45.384741],[-0.182725,45.38241],[-0.183052,45.381445],[-0.183265,45.379589],[-0.183392,45.377322],[-0.183772,45.373653],[-0.18412,45.372345],[-0.185034,45.37063],[-0.185686,45.369785],[-0.186673,45.36883],[-0.189435,45.366832],[-0.198545,45.360938],[-0.199445,45.360294],[-0.200289,45.35936],[-0.200954,45.357719],[-0.201349,45.354911],[-0.201201,45.352492],[-0.201505,45.351195],[-0.202757,45.349649],[-0.204714,45.348191],[-0.218007,45.339004],[-0.219704,45.337521],[-0.221288,45.335157],[-0.22303,45.33227],[-0.226454,45.326728],[-0.228193,45.324016],[-0.229088,45.321645],[-0.229807,45.318513],[-0.230791,45.315392],[-0.232244,45.312796],[-0.237355,45.305014],[-0.23824,45.303318],[-0.238693,45.302169],[-0.239104,45.300614],[-0.240036,45.296518],[-0.240705,45.294279],[-0.241166,45.293514],[-0.242761,45.291843],[-0.240263,45.292706],[-0.239725,45.292735],[-0.239478,45.293173],[-0.240196,45.292718],[-0.242422,45.292097],[-0.241502,45.291163],[-0.241392,45.290301],[-0.241964,45.286419],[-0.242334,45.284727],[-0.243756,45.280176],[-0.24435,45.278078],[-0.246608,45.270996],[-0.247221,45.268797],[-0.248201,45.265738],[-0.249045,45.264089],[-0.250358,45.262379],[-0.251848,45.261013],[-0.252949,45.260209],[-0.256723,45.258023],[-0.258741,45.256537],[-0.25978,45.255362],[-0.261805,45.252526],[-0.263386,45.250793],[-0.265545,45.248967],[-0.266536,45.248011],[-0.274782,45.239045],[-0.275813,45.237677],[-0.276385,45.236643],[-0.277528,45.234045],[-0.278015,45.233173],[-0.279269,45.231531],[-0.280703,45.229934],[-0.283857,45.226014],[-0.288238,45.220431],[-0.291164,45.216791],[-0.299667,45.206052],[-0.301633,45.203421],[-0.304957,45.199222],[-0.306813,45.197323],[-0.310232,45.194178],[-0.315536,45.189162],[-0.318524,45.186245],[-0.321162,45.183785],[-0.326548,45.178622],[-0.329756,45.175622],[-0.34174,45.164177],[-0.343761,45.16249],[-0.345031,45.161661],[-0.348148,45.159951],[-0.354763,45.156188],[-0.358174,45.154296],[-0.359356,45.153432],[-0.360624,45.152316],[-0.36211,45.150458],[-0.366247,45.142689],[-0.371533,45.132558],[-0.373709,45.12848],[-0.374459,45.126889],[-0.374924,45.124998],[-0.376599,45.115551],[-0.377119,45.113925],[-0.379854,45.10856],[-0.380292,45.107462],[-0.3808,45.104933],[-0.380859,45.103079],[-0.380907,45.098113],[-0.380982,45.094957],[-0.381266,45.092689],[-0.38185,45.090817],[-0.386753,45.075868],[-0.387469,45.073842],[-0.388254,45.072566],[-0.390839,45.069279],[-0.394528,45.064475],[-0.396409,45.062206],[-0.397265,45.061454],[-0.402161,45.05817],[-0.403454,45.056719],[-0.409939,45.047317],[-0.410803,45.045786],[-0.411644,45.043267],[-0.412439,45.041443],[-0.413239,45.040141],[-0.414862,45.038338],[-0.416709,45.036675],[-0.418136,45.035111],[-0.418667,45.034255],[-0.420754,45.030269],[-0.422493,45.027439],[-0.423834,45.025069],[-0.424466,45.023774],[-0.425071,45.022],[-0.426321,45.017979],[-0.426785,45.016894],[-0.427423,45.015852],[-0.430105,45.012302],[-0.430387,45.01098],[-0.429996,45.010241],[-0.428665,45.009008],[-0.428257,45.007983],[-0.427802,45.006256],[-0.427332,45.003656],[-0.427037,45.00065],[-0.427004,44.99709],[-0.427074,44.993362],[-0.427236,44.990867],[-0.427215,44.989821],[-0.427419,44.98807],[-0.428181,44.984829],[-0.428909,44.982889],[-0.430042,44.980473],[-0.431871,44.978023],[-0.433624,44.97533],[-0.434684,44.973084],[-0.435716,44.97058],[-0.436233,44.969537],[-0.437916,44.967451],[-0.442006,44.963263],[-0.444078,44.961268],[-0.446594,44.959286],[-0.447997,44.958395],[-0.450908,44.956866],[-0.456201,44.954259],[-0.460278,44.952207],[-0.461436,44.951476],[-0.462807,44.950373],[-0.464023,44.949126],[-0.464864,44.947903],[-0.465721,44.945962],[-0.466433,44.942175],[-0.466858,44.93945],[-0.467293,44.937198],[-0.467746,44.934284],[-0.468126,44.932924],[-0.46874,44.931555],[-0.469473,44.930378],[-0.47415,44.923315],[-0.474909,44.922004],[-0.477143,44.917784],[-0.477643,44.916985],[-0.479111,44.915291],[-0.480929,44.913957],[-0.482158,44.91327],[-0.486459,44.911199],[-0.488654,44.909997],[-0.490263,44.90873],[-0.491483,44.907305],[-0.492081,44.906284],[-0.492899,44.904397],[-0.494212,44.901035],[-0.494839,44.899705],[-0.495551,44.89786],[-0.495992,44.897088],[-0.497381,44.895402],[-0.500681,44.892512],[-0.504296,44.889214],[-0.506145,44.887203],[-0.508115,44.885885],[-0.50956,44.885379],[-0.511733,44.885403],[-0.512872,44.884909],[-0.513031,44.883949],[-0.512144,44.88279],[-0.5112,44.881328],[-0.509598,44.878458],[-0.507498,44.87454],[-0.507376,44.873322],[-0.50665,44.872891],[-0.505803,44.871375],[-0.50483,44.868886],[-0.504343,44.866896],[-0.504143,44.865566],[-0.504052,44.863027],[-0.504273,44.860827],[-0.505189,44.856831],[-0.505412,44.855322],[-0.505376,44.853804],[-0.504744,44.851521],[-0.502236,44.845305],[-0.501848,44.843994],[-0.501743,44.843019],[-0.501776,44.840152],[-0.501215,44.838206],[-0.500473,44.836736],[-0.500092,44.834919],[-0.500486,44.833116],[-0.501464,44.830964],[-0.502055,44.830098],[-0.503369,44.828938],[-0.504951,44.828177],[-0.507492,44.827281],[-0.509019,44.826434],[-0.509973,44.825711],[-0.511458,44.824251],[-0.513057,44.823101],[-0.514225,44.822524],[-0.517605,44.821399],[-0.518719,44.820806],[-0.519797,44.819919],[-0.520739,44.8185],[-0.521031,44.81733],[-0.520808,44.815382],[-0.520839,44.8142],[-0.521125,44.813242],[-0.521824,44.811994],[-0.522711,44.811041],[-0.525913,44.808769],[-0.530862,44.805486],[-0.531878,44.804731],[-0.532671,44.803806],[-0.533453,44.802604],[-0.53682,44.798805],[-0.538149,44.797031],[-0.539339,44.794916],[-0.539996,44.793404],[-0.542111,44.78448],[-0.542353,44.783867],[-0.543286,44.78254],[-0.544402,44.781537],[-0.545569,44.780844],[-0.546588,44.780413],[-0.547983,44.780041],[-0.551201,44.779377],[-0.55681,44.778156],[-0.559456,44.777752],[-0.562603,44.777756],[-0.564293,44.778104],[-0.571714,44.779356],[-0.575086,44.780006],[-0.577876,44.78062],[-0.582717,44.781843],[-0.587093,44.783178],[-0.590639,44.784401],[-0.592506,44.78511],[-0.600691,44.788518],[-0.60258,44.789172],[-0.605471,44.789879],[-0.608149,44.790197],[-0.610846,44.790253],[-0.620128,44.789421],[-0.620451,44.789459],[-0.62385,44.789217],[-0.625953,44.789449],[-0.627151,44.789343],[-0.627905,44.789069],[-0.628786,44.788319],[-0.628929,44.787648],[-0.628513,44.786299],[-0.628768,44.785666],[-0.629574,44.784949],[-0.630946,44.784017],[-0.632584,44.783155],[-0.641168,44.779467],[-0.649417,44.775962],[-0.651397,44.775155],[-0.661202,44.770972],[-0.666553,44.768415],[-0.670559,44.766293],[-0.673923,44.764314],[-0.677254,44.762191],[-0.686057,44.756385],[-0.688774,44.754636],[-0.695861,44.749955],[-0.700507,44.746955],[-0.702861,44.74555],[-0.706699,44.743348],[-0.710074,44.741467],[-0.711924,44.740347],[-0.716463,44.737374],[-0.721039,44.73412],[-0.725524,44.730834],[-0.727064,44.729802],[-0.730298,44.727469],[-0.733481,44.725096],[-0.736505,44.722646],[-0.738032,44.721289],[-0.741173,44.718354],[-0.743328,44.716211],[-0.748986,44.710465],[-0.753709,44.70581],[-0.75645,44.70316],[-0.760707,44.699352],[-0.764741,44.696049],[-0.768834,44.693086],[-0.772014,44.690975],[-0.77605,44.688571],[-0.780998,44.685847],[-0.78529,44.683634],[-0.793204,44.67974],[-0.797773,44.67755],[-0.800817,44.67593],[-0.803764,44.674208],[-0.821101,44.663527],[-0.824981,44.660891],[-0.828155,44.658416],[-0.831099,44.655753],[-0.83304,44.653689],[-0.834988,44.651384],[-0.836729,44.649015],[-0.838397,44.646386],[-0.839501,44.644513],[-0.842111,44.639718],[-0.843221,44.637774],[-0.845353,44.633773],[-0.846638,44.631054],[-0.847935,44.628093],[-0.848502,44.626584],[-0.849537,44.623306],[-0.850177,44.620654],[-0.850513,44.618219],[-0.850765,44.615034],[-0.850681,44.61208],[-0.850325,44.609166],[-0.849598,44.606003],[-0.848811,44.603568],[-0.847494,44.600316],[-0.846259,44.59774],[-0.845366,44.596087],[-0.839903,44.587019],[-0.838607,44.584715],[-0.837304,44.582183],[-0.835764,44.578555],[-0.834793,44.5755],[-0.834086,44.572625],[-0.833172,44.567662],[-0.832489,44.562948],[-0.832118,44.559576],[-0.832038,44.557552],[-0.832092,44.554648],[-0.832534,44.550421],[-0.832964,44.548206],[-0.833703,44.545328],[-0.83445,44.54287],[-0.835699,44.538407],[-0.836714,44.533683],[-0.837166,44.530729],[-0.837769,44.524941],[-0.837969,44.523365],[-0.838499,44.521116],[-0.838802,44.520219],[-0.840392,44.51626],[-0.841523,44.5137],[-0.842024,44.512132],[-0.84248,44.509579],[-0.842517,44.507232],[-0.841971,44.503698],[-0.840236,44.496907],[-0.83915,44.493569],[-0.838308,44.491371],[-0.837101,44.488763],[-0.835015,44.485119],[-0.83366,44.483],[-0.830539,44.479004],[-0.827538,44.475557],[-0.825436,44.473274],[-0.816385,44.463188],[-0.814758,44.4612],[-0.813863,44.459949],[-0.812814,44.45822],[-0.811839,44.456223],[-0.810979,44.453768],[-0.810423,44.450774],[-0.810243,44.448157],[-0.810566,44.445074],[-0.811457,44.442331],[-0.812564,44.439374],[-0.813916,44.436258],[-0.81611,44.43094],[-0.817439,44.427879],[-0.818888,44.424334],[-0.820119,44.421496],[-0.8205,44.420371],[-0.820753,44.418527],[-0.820529,44.41645],[-0.818668,44.40741],[-0.818531,44.406037],[-0.818577,44.404682],[-0.819092,44.402884],[-0.820411,44.400565],[-0.821266,44.399607],[-0.822639,44.398398],[-0.829843,44.393249],[-0.831346,44.392086],[-0.832864,44.390559],[-0.833472,44.389737],[-0.835902,44.385036],[-0.838325,44.381221],[-0.84144,44.37653],[-0.843825,44.372736],[-0.84552,44.370197],[-0.846607,44.368436],[-0.850786,44.362113],[-0.852454,44.359457],[-0.85701,44.352489],[-0.858564,44.350022],[-0.860722,44.346902],[-0.861621,44.34533],[-0.863308,44.342669],[-0.868497,44.334662],[-0.871423,44.330095],[-0.873303,44.32781],[-0.875077,44.326256],[-0.878652,44.323676],[-0.880495,44.32183],[-0.881319,44.320595],[-0.881896,44.319311],[-0.882284,44.317514],[-0.882299,44.315386],[-0.881993,44.312999],[-0.882004,44.311068],[-0.882163,44.309899],[-0.882675,44.308094],[-0.88618,44.298796],[-0.889556,44.289663],[-0.890228,44.287963],[-0.892608,44.281527],[-0.896344,44.271624],[-0.897819,44.267522],[-0.899233,44.263864],[-0.900553,44.260214],[-0.905851,44.246133],[-0.907731,44.241259],[-0.909948,44.235307],[-0.911375,44.231697],[-0.912578,44.229662],[-0.913511,44.228538],[-0.914983,44.227144],[-0.916251,44.226194],[-0.920464,44.223445],[-0.921826,44.222343],[-0.923764,44.220227],[-0.924977,44.218201],[-0.925546,44.216686],[-0.926078,44.214662],[-0.926715,44.211536],[-0.927191,44.208876],[-0.928098,44.206497],[-0.929497,44.204028],[-0.931545,44.200672],[-0.933053,44.1981],[-0.937563,44.190613],[-0.939794,44.186796],[-0.94105,44.184753],[-0.947143,44.17445],[-0.949603,44.170394],[-0.951223,44.167621],[-0.959364,44.153967],[-0.960431,44.152396],[-0.961825,44.150916],[-0.963528,44.149653],[-0.966305,44.147966],[-0.968361,44.146337],[-0.96918,44.145429],[-0.971059,44.142686],[-0.972074,44.141314],[-0.97373,44.139698],[-0.977802,44.136089],[-0.979133,44.134607],[-0.979844,44.133636],[-0.980753,44.132016],[-0.982496,44.127994],[-0.985948,44.120152],[-0.988925,44.113306],[-0.990619,44.10951],[-0.993314,44.103212],[-0.995431,44.09841],[-0.998344,44.091577],[-0.998921,44.090342],[-1.004918,44.076478],[-1.005199,44.075395],[-1.005512,44.073437],[-1.005994,44.066105],[-1.00598,44.064606],[-1.005114,44.059629],[-1.004997,44.058543],[-1.005089,44.057003],[-1.005551,44.055274],[-1.006151,44.054004],[-1.007028,44.052575],[-1.010118,44.047304],[-1.013926,44.040962],[-1.015458,44.038466],[-1.016353,44.036805],[-1.016787,44.035717],[-1.017165,44.03392],[-1.017165,44.032365],[-1.016955,44.031059],[-1.01549,44.025083],[-1.015404,44.023106],[-1.015559,44.022016],[-1.016311,44.019896],[-1.016913,44.018895],[-1.017994,44.017558],[-1.020772,44.014701],[-1.024498,44.01027],[-1.04584,43.98499],[-1.048972,43.981223],[-1.050669,43.979404],[-1.052828,43.977832],[-1.05382,43.977295],[-1.057537,43.975696],[-1.059512,43.974632],[-1.060639,43.973845],[-1.061638,43.972966],[-1.062969,43.971415],[-1.063929,43.96975],[-1.064436,43.968224],[-1.064642,43.966416],[-1.064773,43.961022],[-1.064913,43.959693],[-1.065479,43.957951],[-1.06615,43.956697],[-1.067027,43.955515],[-1.068931,43.953757],[-1.075003,43.94929],[-1.082542,43.943794],[-1.087289,43.940294],[-1.106898,43.925986],[-1.113358,43.921257],[-1.115637,43.919424],[-1.117597,43.917132],[-1.123129,43.909839],[-1.130056,43.90064],[-1.132806,43.897024],[-1.133851,43.895203],[-1.134325,43.893904],[-1.134575,43.892148],[-1.13448,43.890786],[-1.133847,43.888565],[-1.131642,43.883807],[-1.131341,43.882758],[-1.131166,43.880814],[-1.131497,43.878651],[-1.132291,43.876815],[-1.133233,43.875487],[-1.135182,43.873631],[-1.137159,43.872379],[-1.138827,43.871599],[-1.141416,43.870773],[-1.144504,43.870257],[-1.150123,43.869528],[-1.152749,43.869025],[-1.154171,43.868589],[-1.156295,43.867691],[-1.157504,43.867008],[-1.158832,43.866069],[-1.160459,43.864446],[-1.16121,43.86347],[-1.164874,43.858425],[-1.166686,43.855663],[-1.172908,43.846396],[-1.174402,43.844238],[-1.176622,43.840864],[-1.178648,43.83789],[-1.180276,43.835891],[-1.181592,43.833615],[-1.182561,43.832095],[-1.187715,43.824511],[-1.192152,43.817879],[-1.194301,43.814748],[-1.19878,43.80811],[-1.202335,43.80276],[-1.207775,43.794752],[-1.20894,43.792631],[-1.209408,43.79102],[-1.20956,43.789618],[-1.209331,43.786348],[-1.20938,43.784759],[-1.209712,43.783408],[-1.211405,43.778823],[-1.212677,43.776781],[-1.213995,43.7755],[-1.216557,43.773465],[-1.21771,43.772362],[-1.2185,43.771359],[-1.219571,43.769476],[-1.219984,43.768123],[-1.220534,43.765811],[-1.221648,43.76063],[-1.222962,43.754781],[-1.223845,43.751009],[-1.225352,43.743876],[-1.226583,43.738532],[-1.226807,43.736524],[-1.226782,43.735565],[-1.227114,43.732042],[-1.227159,43.729656],[-1.227275,43.72876],[-1.227361,43.726289],[-1.227562,43.723533],[-1.228048,43.715414],[-1.228127,43.713611],[-1.228414,43.710062],[-1.228381,43.709386],[-1.228758,43.703202],[-1.228789,43.701143],[-1.228943,43.699822],[-1.229465,43.698259],[-1.230023,43.697169],[-1.230941,43.695934],[-1.231689,43.695184],[-1.232993,43.694177],[-1.234537,43.693336],[-1.236255,43.692677],[-1.241044,43.691185],[-1.243844,43.690071],[-1.248025,43.688691],[-1.254448,43.686987],[-1.261929,43.684453],[-1.264428,43.683792],[-1.268472,43.683069],[-1.271805,43.682749],[-1.278554,43.682529],[-1.282842,43.682068],[-1.285964,43.6815],[-1.289729,43.681051],[-1.291304,43.680923],[-1.294876,43.680768],[-1.298336,43.680714],[-1.302344,43.680281],[-1.304167,43.679894],[-1.306515,43.679237],[-1.308228,43.678625],[-1.310964,43.677431],[-1.313893,43.675641],[-1.317028,43.673178],[-1.319559,43.670961],[-1.322639,43.666897],[-1.323489,43.665922],[-1.32513,43.663613],[-1.326134,43.662384],[-1.327979,43.660425],[-1.329224,43.659551],[-1.329303,43.65932],[-1.331177,43.657694],[-1.332526,43.656641],[-1.334714,43.655217],[-1.33612,43.654538],[-1.338611,43.653747],[-1.342138,43.652972],[-1.345178,43.652036],[-1.348973,43.650303],[-1.350688,43.649723],[-1.352911,43.649188],[-1.354932,43.648973],[-1.357619,43.648948],[-1.359284,43.649011],[-1.361252,43.64896],[-1.362879,43.648795],[-1.36558,43.648172],[-1.366732,43.647764],[-1.36866,43.646859],[-1.371863,43.644972],[-1.373881,43.643897],[-1.378529,43.641839],[-1.380677,43.64075],[-1.381965,43.639977],[-1.383827,43.638599],[-1.385751,43.637019],[-1.387119,43.635784],[-1.389479,43.633909],[-1.390536,43.632847],[-1.397257,43.627213],[-1.400658,43.624302],[-1.401607,43.62322],[-1.404051,43.620804],[-1.4057,43.619413],[-1.406873,43.618564],[-1.410411,43.616389],[-1.411425,43.61557],[-1.412879,43.614088],[-1.41418,43.611781],[-1.415743,43.607786],[-1.416336,43.605344],[-1.416349,43.603233],[-1.415728,43.600432],[-1.415525,43.598494],[-1.415694,43.596643],[-1.416191,43.594881],[-1.417142,43.592567],[-1.418941,43.58954],[-1.419919,43.587317],[-1.420862,43.584096],[-1.421733,43.582089],[-1.422802,43.580355],[-1.424416,43.57837],[-1.427193,43.575856],[-1.428277,43.574728],[-1.429136,43.573529],[-1.430165,43.571474],[-1.430675,43.569609],[-1.431045,43.566981],[-1.430904,43.565325],[-1.430484,43.563459],[-1.43039,43.56186],[-1.430488,43.56072],[-1.430893,43.558939],[-1.432068,43.556007],[-1.432264,43.554914],[-1.43246,43.552269],[-1.432709,43.550046],[-1.43259,43.547827],[-1.431736,43.544768],[-1.431582,43.543571],[-1.431626,43.542401],[-1.432052,43.539459],[-1.431959,43.538089],[-1.431369,43.535346],[-1.431354,43.534156],[-1.431692,43.532926],[-1.432984,43.531001],[-1.434903,43.529434],[-1.43719,43.527899],[-1.438217,43.527015],[-1.439387,43.525731],[-1.440766,43.523609],[-1.441875,43.520902],[-1.442156,43.519959],[-1.442775,43.516366],[-1.443589,43.514356],[-1.443797,43.512937],[-1.443686,43.511265],[-1.44294,43.509424],[-1.44094,43.506641],[-1.44049,43.505766],[-1.440119,43.504104],[-1.440217,43.502624],[-1.440968,43.500723],[-1.441627,43.499854],[-1.443225,43.498618],[-1.446317,43.496817],[-1.44766,43.49573],[-1.448974,43.494096],[-1.449478,43.492944],[-1.44993,43.490925],[-1.44988,43.490151],[-1.44837,43.485375],[-1.447362,43.482407],[-1.447183,43.481509],[-1.447218,43.48054],[-1.447628,43.479201],[-1.448796,43.477828],[-1.450161,43.47686],[-1.452623,43.475624],[-1.453624,43.475233],[-1.455652,43.474646],[-1.458991,43.473971],[-1.460811,43.473425],[-1.464717,43.470974],[-1.466478,43.470344],[-1.467722,43.470105],[-1.471165,43.469924],[-1.473149,43.469726],[-1.475335,43.46925],[-1.478254,43.468142],[-1.485588,43.464318],[-1.488056,43.463238],[-1.490289,43.462607],[-1.492167,43.461913],[-1.494715,43.461287],[-1.497461,43.460885],[-1.503211,43.461305],[-1.505183,43.461492],[-1.507762,43.461616],[-1.511599,43.461685],[-1.513395,43.461625],[-1.514681,43.461464],[-1.516947,43.460905],[-1.518567,43.460229],[-1.520049,43.459392],[-1.523436,43.456603],[-1.525736,43.455348],[-1.52962,43.453792],[-1.532205,43.45232],[-1.533326,43.45146],[-1.535191,43.449732],[-1.536212,43.448917],[-1.537379,43.448255],[-1.539058,43.447652],[-1.541724,43.447191],[-1.543511,43.447235],[-1.550511,43.448384],[-1.5526,43.448843],[-1.553764,43.448983],[-1.557249,43.448872],[-1.558817,43.448661],[-1.561338,43.44793],[-1.562652,43.447287],[-1.564634,43.445942],[-1.565456,43.445158],[-1.566506,43.443704],[-1.567949,43.441028],[-1.569622,43.439139],[-1.571265,43.437509],[-1.57264,43.435497],[-1.573989,43.434139],[-1.575165,43.433295],[-1.577115,43.432358],[-1.578683,43.431895],[-1.584061,43.430472],[-1.585576,43.429932],[-1.586641,43.429362],[-1.58838,43.428233],[-1.58908,43.427656],[-1.595058,43.424441],[-1.597173,43.423103],[-1.598643,43.421882],[-1.600836,43.419771],[-1.602197,43.418749],[-1.605398,43.416914],[-1.607111,43.416251],[-1.610341,43.415358],[-1.611542,43.41492],[-1.613107,43.414063],[-1.615449,43.412422],[-1.617086,43.411625],[-1.620895,43.410103],[-1.622706,43.40903],[-1.624697,43.407729],[-1.629083,43.405609],[-1.630871,43.404643],[-1.632319,43.403739],[-1.63406,43.402419],[-1.635486,43.400951],[-1.636575,43.399194],[-1.637112,43.397575],[-1.637471,43.395003],[-1.637877,43.393455],[-1.63881,43.391724],[-1.640418,43.389637],[-1.641628,43.387774],[-1.643402,43.384589],[-1.644129,43.382832],[-1.644812,43.38078],[-1.645658,43.379221],[-1.646854,43.377785],[-1.648938,43.375883],[-1.650484,43.374905],[-1.652065,43.374163],[-1.653657,43.373787],[-1.655669,43.373618],[-1.657305,43.373585],[-1.658481,43.373726],[-1.66217,43.374605],[-1.664101,43.374913],[-1.665589,43.374964],[-1.667907,43.374753],[-1.669081,43.374519],[-1.675308,43.372468],[-1.67933,43.37075],[-1.681515,43.369694],[-1.686455,43.366529],[-1.688901,43.364687],[-1.690638,43.363287],[-1.69316,43.361677],[-1.695297,43.360589],[-1.698494,43.359319],[-1.70139,43.358705],[-1.70328,43.358493],[-1.706419,43.358519],[-1.70875,43.35862],[-1.710312,43.358466],[-1.712754,43.357978],[-1.714122,43.357566],[-1.715677,43.356731],[-1.716834,43.355658],[-1.717446,43.354653],[-1.717746,43.353369],[-1.717775,43.350874],[-1.718372,43.349344],[-1.719148,43.348592],[-1.720901,43.347287],[-1.722888,43.344904],[-1.723754,43.344073],[-1.724618,43.343498],[-1.727313,43.342179],[-1.730017,43.341306],[-1.731406,43.341077],[-1.734069,43.341044],[-1.737327,43.340883],[-1.740412,43.340996],[-1.745664,43.341482],[-1.747642,43.34177],[-1.748822,43.341718],[-1.749544,43.341404],[-1.751245,43.340246],[-1.752095,43.339937],[-1.753836,43.339602],[-1.759601,43.338274],[-1.762751,43.337861],[-1.765169,43.337118],[-1.767022,43.336176],[-1.768169,43.335806],[-1.769977,43.335542],[-1.773328,43.335345],[-1.775451,43.334858],[-1.777626,43.333965],[-1.779378,43.332923],[-1.780753,43.332321],[-1.782081,43.332023],[-1.785322,43.331931],[-1.787245,43.331694],[-1.789548,43.330885],[-1.790476,43.33066],[-1.792066,43.330551],[-1.795437,43.330955],[-1.798553,43.330961],[-1.800338,43.330635],[-1.803475,43.329597],[-1.804396,43.32897],[-1.806036,43.328244],[-1.807836,43.327858],[-1.81092,43.327679],[-1.812409,43.327431],[-1.814411,43.326822],[-1.816868,43.32561],[-1.817998,43.325183],[-1.820066,43.324625],[-1.822449,43.324111],[-1.823534,43.323769],[-1.824928,43.32307],[-1.825679,43.322484],[-1.827574,43.320698],[-1.828898,43.319935],[-1.830779,43.319398],[-1.834489,43.3188],[-1.835969,43.31874],[-1.837412,43.318493],[-1.840182,43.317559],[-1.841845,43.317229],[-1.844053,43.317313],[-1.846253,43.317743],[-1.847061,43.317801],[-1.848745,43.317672],[-1.852466,43.316701],[-1.853593,43.316657],[-1.855871,43.316863],[-1.85813,43.316785],[-1.86099,43.315942],[-1.862343,43.31566],[-1.864572,43.315536],[-1.867225,43.315164],[-1.868961,43.314618],[-1.871349,43.313403],[-1.872477,43.312581],[-1.873913,43.310914],[-1.875202,43.308737],[-1.876184,43.307944],[-1.878234,43.30714],[-1.879671,43.306995],[-1.881112,43.307122],[-1.883361,43.307559],[-1.884506,43.30764],[-1.885901,43.307525],[-1.887154,43.307197],[-1.888261,43.306691],[-1.890586,43.305375],[-1.89276,43.304859],[-1.894953,43.304973],[-1.897694,43.305642],[-1.900187,43.30598],[-1.901221,43.306266],[-1.903583,43.307378],[-1.905302,43.308044],[-1.906628,43.308412],[-1.90822,43.308671],[-1.910308,43.308816],[-1.913892,43.308658],[-1.916455,43.308954],[-1.917246,43.308931],[-1.918904,43.30859],[-1.920959,43.307691],[-1.922568,43.30723],[-1.924866,43.307113],[-1.925962,43.3073],[-1.927778,43.307982],[-1.930331,43.309579],[-1.932509,43.310326],[-1.933781,43.310526],[-1.937177,43.310728],[-1.939928,43.31119],[-1.94203,43.311868],[-1.942707,43.312251],[-1.943945,43.313424],[-1.944575,43.314425],[-1.945454,43.315142],[-1.946546,43.315763],[-1.948985,43.31617],[-1.949904,43.316122],[-1.950696,43.315705],[-1.952542,43.315087],[-1.954277,43.314788],[-1.955912,43.314897],[-1.957265,43.31536],[-1.958903,43.316126],[-1.960737,43.316456],[-1.961934,43.31639],[-1.963281,43.316066],[-1.966794,43.31417],[-1.967991,43.31331],[-1.969402,43.31206],[-1.969849,43.311383],[-1.970113,43.310474],[-1.969973,43.309551],[-1.969627,43.308868],[-1.968545,43.307528],[-1.968374,43.306886],[-1.968492,43.306111],[-1.969715,43.304388],[-1.969876,43.303488],[-1.969826,43.302225],[-1.969188,43.301653],[-1.969039,43.300827],[-1.969637,43.299462],[-1.970338,43.29889],[-1.971614,43.298267],[-1.972551,43.298],[-1.973769,43.297869],[-1.97517,43.29795],[-1.978779,43.298605],[-1.980314,43.298785],[-1.982712,43.298524],[-1.985446,43.297801],[-1.98778,43.297584],[-1.989695,43.297743],[-1.990898,43.297731],[-1.994333,43.297081],[-1.995628,43.296629],[-1.996601,43.295987],[-1.996973,43.295416],[-1.99726,43.294175],[-1.997024,43.293531],[-1.996214,43.293478],[-1.995665,43.294711],[-1.995709,43.295529],[-1.995993,43.296127],[-1.996766,43.296768],[-1.999069,43.297669],[-1.999964,43.298202],[-2.002138,43.300418],[-2.002671,43.301078],[-2.005449,43.303968],[-2.005608,43.304508],[-2.006111,43.304677],[-2.009547,43.308406],[-2.00966,43.308823],[-2.011854,43.307793],[-2.011799,43.307617],[-2.010436,43.308338],[-2.009644,43.308598],[-2.009951,43.308923],[-2.010442,43.308749],[-2.011178,43.309358],[-2.012413,43.309202],[-2.012667,43.308497],[-2.01192,43.307559],[-2.009597,43.308741],[-2.010144,43.309153],[-2.010273,43.310138],[-2.009951,43.310689],[-2.00859,43.311534],[-2.008346,43.31148],[-2.006637,43.30966],[-2.005449,43.310069],[-2.006479,43.311226],[-2.008628,43.310185],[-2.008966,43.309815],[-2.008727,43.309366],[-2.004865,43.305293],[-2.004141,43.303912],[-2.004438,43.303599],[-2.005907,43.302907],[-2.006529,43.30247],[-2.006933,43.301722],[-2.007347,43.299738],[-2.008193,43.298976],[-2.009894,43.298044],[-2.011422,43.296584],[-2.013022,43.295568],[-2.015995,43.29435],[-2.016779,43.293754],[-2.017578,43.292108],[-2.019014,43.290801],[-2.019319,43.290065],[-2.019432,43.288801],[-2.019194,43.286183],[-2.018679,43.284094],[-2.018669,43.283091],[-2.0191,43.281166],[-2.018564,43.28039],[-2.017478,43.279654],[-2.017217,43.279223],[-2.01661,43.279055],[-2.01631,43.279385],[-2.0169,43.280489],[-2.016244,43.280862],[-2.015067,43.281021],[-2.014905,43.280474],[-2.014371,43.280484],[-2.014308,43.280092],[-2.013091,43.279997],[-2.012914,43.280724],[-2.013362,43.281188],[-2.016223,43.280868],[-2.016862,43.28054],[-2.016665,43.279997],[-2.017352,43.27959],[-2.017095,43.27919],[-2.015349,43.278365],[-2.01549,43.277725],[-2.018213,43.276368],[-2.020873,43.276691],[-2.024952,43.276781],[-2.026466,43.276754],[-2.026883,43.276451],[-2.026855,43.275791],[-2.026383,43.275548],[-2.021164,43.274904],[-2.021149,43.2766],[-2.021973,43.276693],[-2.022486,43.275847],[-2.023886,43.276114],[-2.023907,43.275907],[-2.021615,43.275669],[-2.02131,43.274856],[-2.021151,43.276561],[-2.020983,43.276693],[-2.017987,43.276393],[-2.016646,43.277197],[-2.015521,43.277709],[-2.015315,43.278313],[-2.016229,43.278967],[-2.016126,43.279184],[-2.014465,43.279015],[-2.013924,43.278788],[-2.014453,43.278079],[-2.016001,43.277113],[-2.016514,43.276648],[-2.016753,43.276036],[-2.016392,43.274286],[-2.016619,43.272592],[-2.016731,43.270447],[-2.017068,43.268188],[-2.01727,43.265901],[-2.017866,43.263226],[-2.017525,43.261961],[-2.017788,43.260995],[-2.018529,43.260319],[-2.019588,43.259629],[-2.020232,43.258731],[-2.020453,43.257494],[-2.021183,43.255022],[-2.023338,43.250951],[-2.024709,43.248068],[-2.025354,43.24553],[-2.02564,43.244795],[-2.02671,43.243798],[-2.028625,43.243019],[-2.029751,43.242399],[-2.030253,43.241808],[-2.030474,43.241101],[-2.030488,43.239611],[-2.031131,43.238086],[-2.031121,43.236848],[-2.030536,43.235729],[-2.028916,43.234345],[-2.027163,43.23321],[-2.026591,43.232325],[-2.026501,43.231468],[-2.026747,43.229496],[-2.02657,43.22854],[-2.025939,43.226406],[-2.025929,43.223979],[-2.025598,43.22243],[-2.025113,43.2209],[-2.024895,43.218616],[-2.025014,43.217047],[-2.024508,43.215841],[-2.024457,43.215206],[-2.02474,43.214595],[-2.025663,43.213972],[-2.029198,43.212966],[-2.031043,43.212302],[-2.032579,43.211588],[-2.033927,43.210379],[-2.036144,43.207365],[-2.036518,43.206408],[-2.036328,43.20475],[-2.036507,43.203519],[-2.038795,43.200709],[-2.041088,43.197733],[-2.041976,43.197054],[-2.04314,43.196596],[-2.044622,43.196301],[-2.047283,43.196141],[-2.048134,43.195961],[-2.049591,43.195344],[-2.050752,43.194314],[-2.051354,43.193118],[-2.051424,43.192144],[-2.051111,43.190678],[-2.051279,43.188983],[-2.051731,43.186731],[-2.051768,43.185336],[-2.051576,43.18312],[-2.051797,43.182369],[-2.052649,43.181086],[-2.054742,43.178844],[-2.05582,43.177171],[-2.057129,43.17582],[-2.059557,43.173984],[-2.061922,43.172073],[-2.065316,43.169488],[-2.066231,43.168177],[-2.066334,43.167181],[-2.065971,43.165534],[-2.066233,43.164615],[-2.067036,43.163367],[-2.06717,43.162788],[-2.066801,43.161576],[-2.066137,43.160213],[-2.065844,43.159265],[-2.065868,43.158524],[-2.066409,43.157193],[-2.069447,43.152745],[-2.070899,43.149434],[-2.07115,43.148154],[-2.07087,43.146648],[-2.070204,43.145514],[-2.069774,43.143984],[-2.069839,43.140962],[-2.069351,43.139233],[-2.069321,43.137982],[-2.06958,43.137202],[-2.070743,43.135274],[-2.071334,43.133314],[-2.0721,43.131519],[-2.07284,43.130437],[-2.073382,43.129987],[-2.074326,43.129612],[-2.077584,43.129273],[-2.079824,43.128412],[-2.080887,43.128201],[-2.082936,43.128036],[-2.083766,43.127843],[-2.085186,43.127208],[-2.086078,43.12639],[-2.087311,43.124131],[-2.088874,43.122029],[-2.090211,43.119445],[-2.090811,43.118591],[-2.092179,43.117303],[-2.092598,43.116376],[-2.092595,43.11539],[-2.092235,43.113683],[-2.092844,43.112519],[-2.093895,43.112044],[-2.095509,43.111758],[-2.09673,43.11124],[-2.097833,43.110058],[-2.098109,43.108623],[-2.097911,43.107217],[-2.096991,43.105202],[-2.096809,43.104505],[-2.09687,43.103376],[-2.097472,43.102296],[-2.098823,43.101306],[-2.099829,43.100958],[-2.101489,43.100735],[-2.104318,43.100751],[-2.10539,43.100537],[-2.106316,43.100066],[-2.109478,43.097632],[-2.110814,43.09681],[-2.11379,43.095435],[-2.115339,43.094863],[-2.118017,43.094258],[-2.120084,43.093664],[-2.12236,43.09266],[-2.123399,43.092094],[-2.126154,43.090164],[-2.127248,43.089476],[-2.128679,43.088775],[-2.130543,43.088147],[-2.132522,43.087654],[-2.134508,43.086854],[-2.137083,43.085123],[-2.139403,43.083977],[-2.140904,43.083585],[-2.1453,43.083231],[-2.147879,43.082707],[-2.154466,43.079011],[-2.156632,43.078479],[-2.158051,43.077628],[-2.158514,43.07691],[-2.159059,43.074914],[-2.160075,43.073141],[-2.160487,43.070867],[-2.160779,43.070236],[-2.162849,43.067282],[-2.163739,43.066389],[-2.165836,43.064745],[-2.166738,43.064216],[-2.168612,43.063781],[-2.170044,43.063146],[-2.170736,43.062478],[-2.171126,43.061716],[-2.171194,43.06091],[-2.171197,43.056952],[-2.171304,43.056303],[-2.171797,43.055226],[-2.172387,43.054441],[-2.173827,43.053303],[-2.17478,43.052778],[-2.181602,43.050455],[-2.19282,43.046461],[-2.195166,43.045742],[-2.197412,43.044918],[-2.198228,43.044786],[-2.199597,43.044856],[-2.20203,43.045199],[-2.205119,43.045727],[-2.207943,43.046115],[-2.209311,43.046003],[-2.210553,43.045541],[-2.212915,43.044427],[-2.213563,43.044012],[-2.214853,43.042576],[-2.215318,43.041753],[-2.21737,43.03751],[-2.219497,43.030986],[-2.220259,43.028441],[-2.22105,43.026937],[-2.221996,43.026189],[-2.222961,43.025889],[-2.230747,43.025082],[-2.231485,43.024819],[-2.232679,43.024025],[-2.233283,43.023149],[-2.235017,43.019474],[-2.23533,43.018028],[-2.235452,43.015882],[-2.235667,43.01421],[-2.23567,43.012957],[-2.235882,43.011582],[-2.236526,43.009568],[-2.23681,43.00804],[-2.236748,43.006502],[-2.236272,43.005053],[-2.235005,43.003447],[-2.234691,43.002703],[-2.2346,43.001403],[-2.235179,42.998228],[-2.235059,42.996057],[-2.234801,42.995102],[-2.233644,42.993551],[-2.233392,42.992622],[-2.233454,42.991497],[-2.233941,42.990294],[-2.235011,42.989004],[-2.235332,42.988121],[-2.236563,42.986358],[-2.238323,42.984858],[-2.238457,42.984298],[-2.237829,42.982792],[-2.237457,42.980668],[-2.237067,42.979904],[-2.236405,42.979349],[-2.234715,42.978609],[-2.233822,42.977984],[-2.233372,42.976796],[-2.2337,42.975894],[-2.235372,42.974411],[-2.238324,42.972108],[-2.238785,42.971529],[-2.239081,42.970044],[-2.238533,42.968653],[-2.23757,42.967603],[-2.237073,42.966739],[-2.23694,42.965275],[-2.237405,42.964323],[-2.238276,42.963181],[-2.238451,42.962341],[-2.238293,42.961536],[-2.237672,42.959692],[-2.237782,42.958309],[-2.237642,42.95758],[-2.236974,42.956572],[-2.235579,42.955409],[-2.23506,42.954305],[-2.234099,42.95339],[-2.233419,42.95387],[-2.233994,42.954468],[-2.234521,42.955594],[-2.235405,42.956227],[-2.235434,42.956621],[-2.234866,42.956613],[-2.233438,42.955502],[-2.232369,42.954521],[-2.231037,42.953868],[-2.229872,42.952771],[-2.229431,42.952586],[-2.22834,42.952643],[-2.227637,42.952349],[-2.227116,42.948698],[-2.227552,42.947478],[-2.227521,42.94675],[-2.226624,42.944843],[-2.22629,42.943125],[-2.226548,42.941434],[-2.226536,42.940566],[-2.226011,42.938586],[-2.225963,42.937294],[-2.226553,42.935579],[-2.227536,42.934133],[-2.228136,42.932608],[-2.228195,42.930737],[-2.227469,42.928866],[-2.226354,42.927452],[-2.224513,42.926098],[-2.223106,42.925441],[-2.221211,42.924902],[-2.217264,42.924386],[-2.213892,42.923702],[-2.211656,42.923038],[-2.208797,42.921909],[-2.207311,42.921204],[-2.204584,42.919711],[-2.201393,42.918194],[-2.197935,42.917031],[-2.194536,42.916279],[-2.186754,42.915049],[-2.184731,42.914584],[-2.182763,42.913887],[-2.181218,42.913127],[-2.179836,42.912225],[-2.178264,42.910844],[-2.177339,42.909669],[-2.176597,42.90843],[-2.175794,42.906016],[-2.175621,42.903142],[-2.175705,42.900341],[-2.175517,42.898581],[-2.175547,42.897235],[-2.176275,42.894821],[-2.1765,42.89307],[-2.17646,42.892417],[-2.175928,42.889617],[-2.17617,42.888344],[-2.176824,42.887173],[-2.177677,42.886266],[-2.179465,42.885079],[-2.181101,42.884455],[-2.184084,42.883851],[-2.185257,42.883522],[-2.188286,42.882352],[-2.192386,42.880532],[-2.1929,42.880233],[-2.196174,42.878759],[-2.199542,42.877003],[-2.206413,42.874146],[-2.208044,42.873588],[-2.217183,42.871239],[-2.221227,42.870124],[-2.225169,42.868926],[-2.230243,42.867209],[-2.233008,42.866541],[-2.234985,42.86623],[-2.236779,42.866069],[-2.242561,42.866252],[-2.246018,42.86613],[-2.253319,42.865085],[-2.255984,42.864839],[-2.258024,42.864752],[-2.260401,42.864773],[-2.265642,42.865151],[-2.271148,42.865679],[-2.273319,42.865945],[-2.276525,42.866124],[-2.281164,42.866206],[-2.289931,42.866114],[-2.294851,42.866236],[-2.298895,42.866593],[-2.303806,42.867366],[-2.306615,42.867758],[-2.310539,42.867992],[-2.313481,42.867837],[-2.314888,42.867647],[-2.318284,42.866956],[-2.320489,42.866298],[-2.322812,42.865436],[-2.325985,42.864073],[-2.329355,42.862834],[-2.331276,42.862287],[-2.33326,42.861832],[-2.335496,42.861447],[-2.338004,42.861186],[-2.342323,42.860987],[-2.347784,42.860501],[-2.350408,42.860181],[-2.354213,42.859596],[-2.356274,42.859212],[-2.359392,42.858502],[-2.361953,42.857822],[-2.364355,42.857007],[-2.367206,42.85576],[-2.369855,42.854269],[-2.372276,42.852607],[-2.374626,42.850597],[-2.37667,42.848755],[-2.379891,42.8465],[-2.382457,42.845135],[-2.384109,42.844396],[-2.386359,42.843534],[-2.389567,42.842507],[-2.392298,42.841869],[-2.393858,42.8416],[-2.396766,42.841256],[-2.401486,42.841164],[-2.403997,42.841281],[-2.406524,42.841557],[-2.408741,42.841951],[-2.410271,42.842366],[-2.412302,42.843063],[-2.41578,42.844661],[-2.417947,42.846022],[-2.420015,42.847715],[-2.421268,42.849001],[-2.42352,42.851571],[-2.425516,42.853425],[-2.4281,42.855067],[-2.430945,42.85629],[-2.433423,42.856999],[-2.435465,42.857354],[-2.438837,42.857589],[-2.440414,42.857511],[-2.443618,42.857209],[-2.446523,42.857056],[-2.449782,42.857154],[-2.453092,42.857519],[-2.455045,42.857848],[-2.457548,42.858427],[-2.463917,42.860382],[-2.468658,42.861478],[-2.471266,42.862292],[-2.474229,42.863646],[-2.475677,42.864563],[-2.477174,42.865751],[-2.479724,42.868261],[-2.481843,42.869912],[-2.484308,42.87142],[-2.485621,42.872075],[-2.490192,42.874085],[-2.493935,42.875993],[-2.494798,42.876361],[-2.497516,42.877278],[-2.499089,42.877629],[-2.501039,42.877893],[-2.504217,42.878188],[-2.507042,42.878582],[-2.511225,42.879241],[-2.513531,42.879352],[-2.515158,42.879314],[-2.521993,42.878819],[-2.526851,42.878267],[-2.536269,42.876858],[-2.540213,42.876529],[-2.542863,42.876478],[-2.547089,42.876637],[-2.549344,42.87686],[-2.557557,42.877928],[-2.560767,42.878282],[-2.564884,42.878636],[-2.567992,42.878832],[-2.573504,42.87895],[-2.578397,42.87894],[-2.584533,42.878653],[-2.587612,42.87845],[-2.593378,42.877854],[-2.597957,42.877504],[-2.602968,42.877267],[-2.606979,42.877185],[-2.610302,42.877188],[-2.612989,42.877278],[-2.615902,42.877535],[-2.61851,42.877952],[-2.620256,42.878342],[-2.623194,42.87916],[-2.625499,42.879949],[-2.628735,42.880934],[-2.630505,42.881382],[-2.632987,42.881879],[-2.636415,42.882257],[-2.637966,42.88235],[-2.640742,42.882374],[-2.644165,42.882212],[-2.646685,42.881994],[-2.652815,42.881181],[-2.655225,42.880955],[-2.658284,42.880951],[-2.661477,42.881098],[-2.664327,42.881304],[-2.666853,42.881326],[-2.670875,42.881048],[-2.677044,42.880117],[-2.680394,42.879948],[-2.682544,42.88008],[-2.684076,42.880281],[-2.687059,42.880905],[-2.688517,42.881124],[-2.68997,42.881168],[-2.691982,42.881009],[-2.695337,42.880454],[-2.697723,42.880413],[-2.701294,42.880673],[-2.703627,42.880689],[-2.705646,42.8805],[-2.707922,42.880021],[-2.710646,42.879098],[-2.712445,42.878266],[-2.714809,42.87687],[-2.716137,42.875895],[-2.718237,42.873922],[-2.720717,42.87106],[-2.722739,42.869359],[-2.724418,42.868369],[-2.727341,42.867238],[-2.730998,42.866106],[-2.733425,42.865171],[-2.735437,42.864203],[-2.738259,42.862457],[-2.739537,42.861445],[-2.742502,42.858578],[-2.744342,42.857085],[-2.745826,42.855415],[-2.746598,42.853996],[-2.746954,42.852932],[-2.747578,42.850363],[-2.748223,42.849107],[-2.750022,42.846786],[-2.750966,42.845142],[-2.751279,42.844258],[-2.75151,42.842873],[-2.751706,42.839079],[-2.751945,42.837982],[-2.752693,42.836058],[-2.753424,42.834806],[-2.754847,42.833045],[-2.757156,42.830917],[-2.759557,42.829112],[-2.760962,42.828206],[-2.763436,42.826789],[-2.765938,42.825529],[-2.768547,42.8243],[-2.77951,42.819296],[-2.785387,42.816593],[-2.790141,42.814536],[-2.793384,42.812996],[-2.796015,42.811637],[-2.797241,42.810922],[-2.80038,42.808852],[-2.80176,42.80804],[-2.804263,42.806909],[-2.808489,42.805216],[-2.811063,42.803974],[-2.815438,42.801335],[-2.817019,42.800247],[-2.818938,42.798409],[-2.819992,42.796938],[-2.820995,42.794889],[-2.822024,42.792397],[-2.822778,42.790136],[-2.823406,42.787718],[-2.823976,42.784665],[-2.82413,42.781412],[-2.824045,42.778338],[-2.823775,42.775606],[-2.82255,42.766911],[-2.822465,42.765534],[-2.822645,42.76335],[-2.823587,42.761516],[-2.82406,42.761273],[-2.821849,42.760216],[-2.816712,42.758385],[-2.812797,42.757543],[-2.81158,42.757055],[-2.808411,42.754919],[-2.801518,42.751494],[-2.800092,42.750497],[-2.797022,42.747594],[-2.79597,42.746696],[-2.794246,42.74549],[-2.79318,42.744421],[-2.790487,42.743084],[-2.790881,42.741738],[-2.791709,42.742281],[-2.792343,42.74295],[-2.792917,42.744224],[-2.794556,42.745737],[-2.79597,42.746749],[-2.800475,42.750822],[-2.801244,42.75134],[-2.808496,42.754987],[-2.81194,42.757325],[-2.812599,42.757552],[-2.816627,42.758406],[-2.821406,42.7601],[-2.822169,42.760774],[-2.822033,42.761574],[-2.822,42.76596],[-2.822239,42.767932],[-2.823439,42.776172],[-2.823635,42.779964],[-2.823553,42.78243],[-2.82274,42.788767],[-2.820925,42.794253],[-2.819893,42.79642],[-2.81935,42.797327],[-2.817903,42.799015],[-2.815948,42.800651],[-2.810464,42.803957],[-2.809246,42.804591],[-2.802702,42.807217],[-2.800093,42.808616],[-2.797413,42.810432],[-2.795584,42.811525],[-2.792308,42.813236],[-2.786737,42.815665],[-2.783607,42.816988],[-2.779016,42.819153],[-2.773936,42.821611],[-2.770863,42.823025],[-2.763876,42.826361],[-2.761414,42.82771],[-2.759269,42.829109],[-2.757609,42.83031],[-2.755844,42.831822],[-2.754557,42.833044],[-2.753372,42.834531],[-2.752257,42.836569],[-2.751656,42.838184],[-2.751131,42.841241],[-2.750249,42.842246],[-2.74953,42.842573],[-2.748492,42.842704],[-2.747963,42.842573],[-2.747516,42.841991],[-2.746706,42.842085],[-2.74626,42.842631],[-2.744253,42.843633],[-2.742078,42.844542],[-2.738833,42.846094],[-2.738577,42.846419],[-2.733384,42.849072],[-2.732303,42.849432],[-2.729035,42.849872],[-2.725725,42.850387],[-2.721828,42.850873],[-2.710227,42.849115],[-2.709885,42.848683],[-2.710643,42.844482],[-2.71158,42.841228],[-2.71182,42.840966],[-2.711643,42.83875],[-2.710943,42.83573],[-2.710172,42.834411],[-2.710316,42.833963],[-2.70983,42.833725],[-2.70886,42.834321],[-2.704177,42.835584],[-2.703427,42.835983],[-2.701783,42.836489],[-2.697255,42.837673],[-2.696408,42.837684],[-2.696177,42.83809],[-2.696387,42.838661],[-2.696861,42.838846],[-2.697602,42.837671],[-2.700953,42.836726],[-2.703771,42.835869],[-2.705625,42.835387],[-2.709248,42.834324],[-2.7103,42.834305],[-2.710888,42.833838],[-2.714424,42.832666],[-2.718478,42.831263],[-2.719325,42.831233],[-2.719648,42.830867],[-2.72256,42.829876],[-2.725412,42.829189],[-2.727486,42.828819],[-2.731222,42.828563],[-2.738607,42.828495],[-2.742075,42.828508],[-2.743576,42.828895],[-2.74447,42.82985],[-2.74464,42.830528],[-2.744371,42.830941],[-2.744646,42.83138],[-2.745433,42.831007],[-2.744971,42.830766],[-2.744394,42.831163],[-2.744951,42.831582],[-2.745014,42.832185],[-2.746036,42.837104],[-2.745802,42.837547],[-2.74626,42.837987],[-2.74703,42.841807],[-2.746337,42.842585],[-2.740259,42.845548],[-2.737476,42.847004],[-2.733067,42.849211],[-2.731423,42.849601],[-2.72898,42.849913],[-2.729505,42.851617],[-2.733102,42.851149],[-2.733158,42.850748],[-2.734062,42.85099],[-2.733137,42.84987],[-2.733439,42.849517],[-2.737098,42.847723],[-2.741747,42.845352],[-2.745793,42.843347],[-2.746816,42.842892],[-2.748485,42.842827],[-2.74996,42.84346],[-2.750588,42.844323],[-2.750635,42.845035],[-2.749759,42.846705],[-2.748217,42.848648],[-2.747556,42.849784],[-2.747145,42.8509],[-2.746767,42.852835],[-2.7463,42.854144],[-2.74523,42.8559],[-2.744252,42.856921],[-2.742244,42.858476],[-2.740338,42.86037],[-2.737832,42.862491],[-2.736574,42.863342],[-2.73422,42.864634],[-2.730869,42.865966],[-2.727373,42.867],[-2.724309,42.868184],[-2.723035,42.868902],[-2.721307,42.870175],[-2.720214,42.871269],[-2.718237,42.873596],[-2.716677,42.875146],[-2.714643,42.876725],[-2.712777,42.877852],[-2.710325,42.878964],[-2.707406,42.879914],[-2.706164,42.880206],[-2.704108,42.880456],[-2.702274,42.880499],[-2.696629,42.880178],[-2.695117,42.880276],[-2.690869,42.880931],[-2.689567,42.880974],[-2.687212,42.880746],[-2.684905,42.88026],[-2.682529,42.879879],[-2.680626,42.879768],[-2.67762,42.879857],[-2.674687,42.880249],[-2.671975,42.880746],[-2.669296,42.881011],[-2.666549,42.881151],[-2.66275,42.881028],[-2.659036,42.880754],[-2.655946,42.88067],[-2.652157,42.881021],[-2.649702,42.881412],[-2.646976,42.881753],[-2.643723,42.882002],[-2.639957,42.882133],[-2.635839,42.881972],[-2.63306,42.881635],[-2.63014,42.881011],[-2.627896,42.880398],[-2.623004,42.878814],[-2.620244,42.878022],[-2.618133,42.87755],[-2.615193,42.877142],[-2.613335,42.876998],[-2.609775,42.876903],[-2.606145,42.876965],[-2.605287,42.876921],[-2.599514,42.877149],[-2.596252,42.877364],[-2.590187,42.877889],[-2.586966,42.87821],[-2.582713,42.878513],[-2.579538,42.878659],[-2.57072,42.878673],[-2.567246,42.878537],[-2.563502,42.878308],[-2.559883,42.877958],[-2.556013,42.877451],[-2.553266,42.876987],[-2.548289,42.876375],[-2.547494,42.875842],[-2.547748,42.87552],[-2.548907,42.875441],[-2.549404,42.875662],[-2.54932,42.87614],[-2.547559,42.876771],[-2.543106,42.877468],[-2.539801,42.877637],[-2.54015,42.875656],[-2.540989,42.873099],[-2.541108,42.872243],[-2.539871,42.876863],[-2.539511,42.877645],[-2.534187,42.877807],[-2.529043,42.878136],[-2.529037,42.878822],[-2.526461,42.88143],[-2.525577,42.882666],[-2.524482,42.88463],[-2.523926,42.886113],[-2.521496,42.889249],[-2.519886,42.892773],[-2.520475,42.893274],[-2.523339,42.894492],[-2.526585,42.895948],[-2.532924,42.898697],[-2.533324,42.899008],[-2.53551,42.90159],[-2.535508,42.902021],[-2.53621,42.902436],[-2.536401,42.903074],[-2.536217,42.903748],[-2.53646,42.906144],[-2.537033,42.906915],[-2.537734,42.90735],[-2.539197,42.90791],[-2.542568,42.907745],[-2.543457,42.907281],[-2.544467,42.907004],[-2.545267,42.905687],[-2.545754,42.904548],[-2.543662,42.903351],[-2.542786,42.902444],[-2.541385,42.902074],[-2.540437,42.902258],[-2.538367,42.901793],[-2.536924,42.901239],[-2.536397,42.901361],[-2.535107,42.901128],[-2.533288,42.898959],[-2.53286,42.898651],[-2.521225,42.893545],[-2.520234,42.893068],[-2.519976,42.892704],[-2.521452,42.889386],[-2.523982,42.886139],[-2.525041,42.883745],[-2.526555,42.881364],[-2.529616,42.878268],[-2.529847,42.878129],[-2.536526,42.877772],[-2.536787,42.876958],[-2.538566,42.876684],[-2.541451,42.876487],[-2.544141,42.876477],[-2.54655,42.876578],[-2.550433,42.876942],[-2.559202,42.878061],[-2.562801,42.878423],[-2.566424,42.878699],[-2.57031,42.878876],[-2.573404,42.878924],[-2.579607,42.878828],[-2.582962,42.878681],[-2.587709,42.878365],[-2.592228,42.877909],[-2.59562,42.877621],[-2.599832,42.877352],[-2.604281,42.877177],[-2.608145,42.877117],[-2.613385,42.877238],[-2.616417,42.877528],[-2.618572,42.87789],[-2.622499,42.878841],[-2.627608,42.88045],[-2.629689,42.881038],[-2.631784,42.881523],[-2.634734,42.881993],[-2.636966,42.882202],[-2.639457,42.882279],[-2.641647,42.882264],[-2.64529,42.882065],[-2.647541,42.881843],[-2.651714,42.881255],[-2.654745,42.88094],[-2.657494,42.880874],[-2.661431,42.88112],[-2.665404,42.881291],[-2.667376,42.881279],[-2.670758,42.881027],[-2.675263,42.880326],[-2.678354,42.879944],[-2.680673,42.879909],[-2.682124,42.880001],[-2.684441,42.880302],[-2.687866,42.880997],[-2.690396,42.881129],[-2.692772,42.880886],[-2.695405,42.880488],[-2.696472,42.880649],[-2.696654,42.881188],[-2.695659,42.881379],[-2.694297,42.878292],[-2.692592,42.874999],[-2.690823,42.872213],[-2.690221,42.870897],[-2.689353,42.869517],[-2.68737,42.866675],[-2.68668,42.866606],[-2.686384,42.866935],[-2.68428,42.867721],[-2.683525,42.866598],[-2.683329,42.866689],[-2.683912,42.867849],[-2.682201,42.868312],[-2.682232,42.868491],[-2.68348,42.868173],[-2.686191,42.867193],[-2.687192,42.867089],[-2.687465,42.866715],[-2.685382,42.86369],[-2.684622,42.863945],[-2.685432,42.865162],[-2.684293,42.865665],[-2.684816,42.866698],[-2.685462,42.866836],[-2.686091,42.866516],[-2.685887,42.866184],[-2.684836,42.866526],[-2.685443,42.866864],[-2.683703,42.867141],[-2.68399,42.867813],[-2.682055,42.868388],[-2.682314,42.868555],[-2.683958,42.868048],[-2.686142,42.867231],[-2.687067,42.867585],[-2.690544,42.872732],[-2.690573,42.873203],[-2.698548,42.87014],[-2.699256,42.870132],[-2.699986,42.869561],[-2.705829,42.86728],[-2.706427,42.86717],[-2.707304,42.866548],[-2.712077,42.864696],[-2.712732,42.864671],[-2.713765,42.863624],[-2.714113,42.8626],[-2.714737,42.862163],[-2.720366,42.859965],[-2.720815,42.859654],[-2.721886,42.858273],[-2.722129,42.85819],[-2.722828,42.856463],[-2.722663,42.856091],[-2.722449,42.852643],[-2.722474,42.851561],[-2.723098,42.851182],[-2.728821,42.850351],[-2.729213,42.85053],[-2.729504,42.851613],[-2.733145,42.851143],[-2.733143,42.850929],[-2.734117,42.850957],[-2.733174,42.849913],[-2.733665,42.849435],[-2.743504,42.844514],[-2.743415,42.84417],[-2.742165,42.84453],[-2.739217,42.845936],[-2.739142,42.845377],[-2.740121,42.844862],[-2.743566,42.84449],[-2.746705,42.842944],[-2.747876,42.842784],[-2.749242,42.84308],[-2.750069,42.843564],[-2.750609,42.84481],[-2.750423,42.845613],[-2.749686,42.846802],[-2.747825,42.849241],[-2.747173,42.850703],[-2.746632,42.853131],[-2.745968,42.854716],[-2.745434,42.855528],[-2.743857,42.857203],[-2.742718,42.858116],[-2.740281,42.860408],[-2.738426,42.862018],[-2.73593,42.863723],[-2.733282,42.865048],[-2.730131,42.866241],[-2.726111,42.867478],[-2.724842,42.868006],[-2.722931,42.869022],[-2.721857,42.869772],[-2.720525,42.870912],[-2.717813,42.874033],[-2.71539,42.876202],[-2.713682,42.877336],[-2.712291,42.878139],[-2.710801,42.878828],[-2.70819,42.879763],[-2.706577,42.88016],[-2.703412,42.880568],[-2.701041,42.880524],[-2.69672,42.880255],[-2.694996,42.880319],[-2.692136,42.880762],[-2.690057,42.880976],[-2.687379,42.88079],[-2.68476,42.8802],[-2.683052,42.879957],[-2.680317,42.879744],[-2.677618,42.879902],[-2.675207,42.880219],[-2.671569,42.8808],[-2.668807,42.881072],[-2.665651,42.881148],[-2.663723,42.8811],[-2.657528,42.880605],[-2.655304,42.880638],[-2.654824,42.880519],[-2.654622,42.879979],[-2.65529,42.879706],[-2.655846,42.880236],[-2.655112,42.882779],[-2.654402,42.885566],[-2.652933,42.890194],[-2.65192,42.893577],[-2.650513,42.898022],[-2.649486,42.901673],[-2.648872,42.90406],[-2.647581,42.909921],[-2.647384,42.911035],[-2.647378,42.912321],[-2.647811,42.914767],[-2.647789,42.916803],[-2.647272,42.918373],[-2.646788,42.919249],[-2.645239,42.921555],[-2.644491,42.923257],[-2.643955,42.926191],[-2.643771,42.928063],[-2.643657,42.932596],[-2.643199,42.934573],[-2.642791,42.935643],[-2.641633,42.938174],[-2.640708,42.940375],[-2.637908,42.946636],[-2.63749,42.947828],[-2.637096,42.950128],[-2.636274,42.956533],[-2.636486,42.958378],[-2.636961,42.960002],[-2.63709,42.961069],[-2.636883,42.967081],[-2.636905,42.968192],[-2.637459,42.969777],[-2.638332,42.97073],[-2.639304,42.971415],[-2.641701,42.972878],[-2.643975,42.975678],[-2.644243,42.976286],[-2.64537,42.982033],[-2.646289,42.982766],[-2.648965,42.983497],[-2.65213,42.983328],[-2.654076,42.983694],[-2.654837,42.983646],[-2.65641,42.983105],[-2.657224,42.982954],[-2.657972,42.983079],[-2.660057,42.984319],[-2.665552,42.987364],[-2.666399,42.987687],[-2.669763,42.988641],[-2.675195,42.990357],[-2.676652,42.991077],[-2.677532,42.991909],[-2.678041,42.992934],[-2.6782,42.996138],[-2.677786,42.997971],[-2.677554,43.002824],[-2.677763,43.003869],[-2.678158,43.004652],[-2.680866,43.00817],[-2.683582,43.01264],[-2.684512,43.015154],[-2.684584,43.016817],[-2.684225,43.017966],[-2.684181,43.0187],[-2.684923,43.022628],[-2.685558,43.02388],[-2.689483,43.02756],[-2.690401,43.028732],[-2.691688,43.031523],[-2.692025,43.032521],[-2.692602,43.035109],[-2.693628,43.039276],[-2.693731,43.040299],[-2.693279,43.044443],[-2.693621,43.045299],[-2.695366,43.047174],[-2.699709,43.052478],[-2.701812,43.054957],[-2.702961,43.056178],[-2.708614,43.062407],[-2.712226,43.066502],[-2.712324,43.067948],[-2.713541,43.068533],[-2.713875,43.068896],[-2.712857,43.069851],[-2.712904,43.0703],[-2.71417,43.071585],[-2.715574,43.073187],[-2.715753,43.073671],[-2.715052,43.074536],[-2.713064,43.075247],[-2.712251,43.076359],[-2.711518,43.07679],[-2.711259,43.078195],[-2.712619,43.080618],[-2.713442,43.081062],[-2.715103,43.080981],[-2.716224,43.081081],[-2.717515,43.082047],[-2.717845,43.081741],[-2.717249,43.08071],[-2.716422,43.080621],[-2.715444,43.080226],[-2.71548,43.079893],[-2.716596,43.080298],[-2.719234,43.080616],[-2.719785,43.080807],[-2.721278,43.082027],[-2.722208,43.082241],[-2.724536,43.082239],[-2.725315,43.082606],[-2.725829,43.08257],[-2.72679,43.082059],[-2.728145,43.081883],[-2.729193,43.082111],[-2.731391,43.08159],[-2.732904,43.08208],[-2.734496,43.082228],[-2.735659,43.082766],[-2.735845,43.083369],[-2.736546,43.083873],[-2.73712,43.084786],[-2.737901,43.085447],[-2.73821,43.086036],[-2.739174,43.086961],[-2.73961,43.088198],[-2.740665,43.088743],[-2.744171,43.089323],[-2.74577,43.089684],[-2.748357,43.090628],[-2.748727,43.090908],[-2.749251,43.093216],[-2.749783,43.094096],[-2.751212,43.095627],[-2.751949,43.097539],[-2.752187,43.099376],[-2.752127,43.10059],[-2.751207,43.102547],[-2.751147,43.103443],[-2.751553,43.104686],[-2.752026,43.105206],[-2.75403,43.106596],[-2.756787,43.109457],[-2.75932,43.111176],[-2.759998,43.111552],[-2.76483,43.113424],[-2.765898,43.114318],[-2.766191,43.11662],[-2.766131,43.119602],[-2.765829,43.121837],[-2.765893,43.122504],[-2.766525,43.1231],[-2.769801,43.124793],[-2.774064,43.128052],[-2.774724,43.128807],[-2.7754,43.130115],[-2.775864,43.13069],[-2.780765,43.134369],[-2.784116,43.136813],[-2.784928,43.13776],[-2.785203,43.138496],[-2.785719,43.140643],[-2.786818,43.143246],[-2.789146,43.148417],[-2.790916,43.152499],[-2.791005,43.153465],[-2.79041,43.154328],[-2.78859,43.15555],[-2.787025,43.157049],[-2.78529,43.157812],[-2.784033,43.158065],[-2.781374,43.158298],[-2.779219,43.158366],[-2.776089,43.158748],[-2.773492,43.159223],[-2.771475,43.159721],[-2.770534,43.160131],[-2.769536,43.160827],[-2.768838,43.161673],[-2.768387,43.163321],[-2.768699,43.164561],[-2.76934,43.165496],[-2.771122,43.16762],[-2.771976,43.169323],[-2.772866,43.170817],[-2.773302,43.172388],[-2.773128,43.174412],[-2.773726,43.175769],[-2.774648,43.176862],[-2.775156,43.17782],[-2.775069,43.179451],[-2.774297,43.181417],[-2.774119,43.182988],[-2.774615,43.184484],[-2.774817,43.187564],[-2.775123,43.188581],[-2.776018,43.190157],[-2.77603,43.191339],[-2.775465,43.192443],[-2.775467,43.194398],[-2.775944,43.196077],[-2.775766,43.196764],[-2.774408,43.198515],[-2.773017,43.199485],[-2.772691,43.200225],[-2.772945,43.202265],[-2.773172,43.203191],[-2.774983,43.205213],[-2.775557,43.205549],[-2.777289,43.206145],[-2.777997,43.206517],[-2.778993,43.208314],[-2.779457,43.208628],[-2.783653,43.210206],[-2.785327,43.210738],[-2.787415,43.210858],[-2.789537,43.210654],[-2.794988,43.20885],[-2.795929,43.208696],[-2.798161,43.20862],[-2.8024,43.208615],[-2.806601,43.209661],[-2.808421,43.21114],[-2.809522,43.211298],[-2.809927,43.21161],[-2.811258,43.213615],[-2.816313,43.221831],[-2.816851,43.222168],[-2.81864,43.222385],[-2.81988,43.223144],[-2.82019,43.223987],[-2.819612,43.226546],[-2.820415,43.226835],[-2.820961,43.227785],[-2.821106,43.230056],[-2.821296,43.230525],[-2.822383,43.23056],[-2.823398,43.230036],[-2.826066,43.229943],[-2.827942,43.229668],[-2.830482,43.229077],[-2.831631,43.228967],[-2.833068,43.22908],[-2.83411,43.229397],[-2.835242,43.229943],[-2.838366,43.232026],[-2.840299,43.233525],[-2.841657,43.234319],[-2.842653,43.234706],[-2.844956,43.235319],[-2.847534,43.235862],[-2.849895,43.236137],[-2.851757,43.236081],[-2.853264,43.235891],[-2.856594,43.235267],[-2.859637,43.234905],[-2.862316,43.234187],[-2.865032,43.233556],[-2.866064,43.233165],[-2.868499,43.232023],[-2.869759,43.2316],[-2.871892,43.23126],[-2.872963,43.231296],[-2.876098,43.231643],[-2.878189,43.231587],[-2.880907,43.231219],[-2.8845,43.231016],[-2.887679,43.2312],[-2.89145,43.231708],[-2.907596,43.233791],[-2.909144,43.23378],[-2.913548,43.233278],[-2.914833,43.233474],[-2.915697,43.233878],[-2.91679,43.234637],[-2.919051,43.235963],[-2.920695,43.237688],[-2.921779,43.238222],[-2.924036,43.238475],[-2.92516,43.238832],[-2.926042,43.239499],[-2.926697,43.240294],[-2.927785,43.242265],[-2.92898,43.24319],[-2.930429,43.243816],[-2.931247,43.244583],[-2.932012,43.24569],[-2.933082,43.246698],[-2.934229,43.247397],[-2.935825,43.247917],[-2.936795,43.24803],[-2.939041,43.24767],[-2.940322,43.247634],[-2.941029,43.247807],[-2.942164,43.248509],[-2.943152,43.24962],[-2.944434,43.25076],[-2.945305,43.251858],[-2.947398,43.252905],[-2.948143,43.253417],[-2.94946,43.255308],[-2.950005,43.255673],[-2.951782,43.256287],[-2.952428,43.256638],[-2.953095,43.25741],[-2.954009,43.258772],[-2.955744,43.259655],[-2.958982,43.261126],[-2.96,43.262854],[-2.96089,43.264001],[-2.962845,43.265861],[-2.963845,43.267334],[-2.964372,43.267819],[-2.965862,43.268151],[-2.966396,43.26854],[-2.96712,43.269464],[-2.967826,43.270032],[-2.969093,43.270374],[-2.970133,43.270287],[-2.971577,43.269587],[-2.971423,43.269171],[-2.97078,43.268988],[-2.969583,43.269604],[-2.968502,43.26928],[-2.967188,43.267296],[-2.967614,43.267263],[-2.968097,43.268043],[-2.969188,43.267725],[-2.968326,43.267009],[-2.965944,43.264738],[-2.965235,43.263685],[-2.965132,43.262984],[-2.965369,43.262285],[-2.964815,43.261047],[-2.963484,43.259773],[-2.963819,43.259688],[-2.964443,43.260362],[-2.965442,43.260282],[-2.964504,43.259947],[-2.963957,43.259427],[-2.963423,43.259734],[-2.964532,43.260734],[-2.965138,43.261545],[-2.96537,43.262263],[-2.965144,43.262913],[-2.965238,43.263695],[-2.965858,43.264676],[-2.968235,43.266977],[-2.969112,43.267674],[-2.968085,43.268048],[-2.96753,43.267099],[-2.96693,43.267403],[-2.967644,43.268102],[-2.968749,43.269548],[-2.969614,43.269645],[-2.97065,43.26911],[-2.970792,43.269282],[-2.969919,43.269931],[-2.968953,43.270179],[-2.968204,43.270071],[-2.96715,43.269405],[-2.965754,43.267826],[-2.964868,43.267624],[-2.964408,43.267997],[-2.964709,43.268598],[-2.965527,43.269343],[-2.96652,43.270527],[-2.968231,43.272908],[-2.969118,43.273781],[-2.96987,43.274251],[-2.970798,43.274552],[-2.971719,43.274627],[-2.97363,43.274431],[-2.976264,43.274392],[-2.977618,43.274683],[-2.978407,43.275033],[-2.978989,43.275549],[-2.979727,43.276969],[-2.980439,43.277769],[-2.981342,43.278364],[-2.982821,43.279113],[-2.983897,43.2798],[-2.985969,43.283029],[-2.986375,43.283925],[-2.986622,43.285296],[-2.985342,43.285831],[-2.984112,43.286047],[-2.9828,43.285807],[-2.981426,43.284961],[-2.980164,43.283173],[-2.981448,43.282196],[-2.982917,43.283314],[-2.983056,43.282908],[-2.982777,43.281857],[-2.981602,43.282128],[-2.981254,43.281827],[-2.981208,43.280974],[-2.980752,43.280169],[-2.981736,43.279943],[-2.98212,43.280694],[-2.983155,43.280698],[-2.983203,43.281136],[-2.98372,43.280897],[-2.984045,43.281241],[-2.981957,43.282006],[-2.980102,43.282907],[-2.980046,43.283142],[-2.981525,43.285171],[-2.98274,43.285867],[-2.983497,43.286065],[-2.985605,43.286101],[-2.985778,43.286315],[-2.985477,43.289221],[-2.985322,43.289816],[-2.984459,43.291226],[-2.98468,43.291373],[-2.985883,43.291255],[-2.985845,43.290405],[-2.986047,43.288849],[-2.986487,43.287193],[-2.987099,43.286219],[-2.988516,43.285498],[-2.991721,43.284813],[-2.993555,43.28456],[-2.994623,43.284613],[-2.996643,43.285179],[-2.998032,43.285768],[-3.009581,43.290918],[-3.011693,43.291785],[-3.013595,43.292444],[-3.015747,43.29332],[-3.017037,43.294061],[-3.018569,43.295235],[-3.019512,43.296222],[-3.020475,43.297625],[-3.021483,43.299412],[-3.023095,43.30164],[-3.023555,43.303556],[-3.024113,43.304811],[-3.02557,43.306273],[-3.027743,43.30787],[-3.029133,43.309492],[-3.030453,43.310618],[-3.032628,43.311674],[-3.034798,43.312255],[-3.037793,43.312714],[-3.039645,43.313171],[-3.0449,43.314789],[-3.046165,43.315293],[-3.048175,43.316508],[-3.049721,43.318006],[-3.050991,43.319807],[-3.05226,43.321091],[-3.053458,43.321909],[-3.054485,43.322434],[-3.056044,43.322999],[-3.060643,43.324439],[-3.063114,43.325407],[-3.065671,43.326584],[-3.069142,43.328339],[-3.070999,43.329197],[-3.073933,43.330244],[-3.075018,43.330442],[-3.076762,43.330519],[-3.078242,43.330335],[-3.080481,43.329907],[-3.082378,43.329916],[-3.084833,43.330296],[-3.087207,43.330192],[-3.089018,43.32961],[-3.091069,43.328668],[-3.093113,43.328258],[-3.095284,43.328409],[-3.097043,43.328995],[-3.097911,43.329507],[-3.10071,43.331782],[-3.102948,43.33376],[-3.104514,43.335581],[-3.105178,43.336877],[-3.106017,43.338914],[-3.107374,43.340154],[-3.108833,43.340758],[-3.11052,43.340984],[-3.111941,43.340836],[-3.114785,43.33984],[-3.115895,43.339644],[-3.117606,43.339707],[-3.118949,43.340102],[-3.120058,43.340742],[-3.121192,43.341594],[-3.122245,43.3421],[-3.123157,43.34234],[-3.124974,43.342383],[-3.128916,43.341855],[-3.131523,43.341724],[-3.133672,43.341826],[-3.135749,43.342133],[-3.138978,43.342833],[-3.141986,43.343125],[-3.144876,43.343478],[-3.146487,43.343315],[-3.147233,43.343095],[-3.148886,43.342256],[-3.150152,43.341776],[-3.151265,43.341613],[-3.152386,43.341673],[-3.153448,43.341926],[-3.155086,43.342573],[-3.157331,43.34381],[-3.158574,43.344752],[-3.160181,43.346139],[-3.161279,43.346957],[-3.164255,43.348689],[-3.165143,43.349346],[-3.1664,43.350588],[-3.167921,43.352458],[-3.168649,43.353117],[-3.169784,43.353737],[-3.171342,43.354127],[-3.172389,43.354174],[-3.177497,43.353657],[-3.17871,43.353753],[-3.179813,43.354047],[-3.181524,43.355106],[-3.182139,43.355757],[-3.183667,43.357706],[-3.185462,43.359695],[-3.186632,43.360761],[-3.188258,43.361647],[-3.189141,43.361912],[-3.190629,43.36197],[-3.191862,43.361675],[-3.192704,43.36123],[-3.195227,43.359144],[-3.197105,43.358215],[-3.198416,43.357103],[-3.202136,43.352527],[-3.203717,43.351098],[-3.205322,43.350283],[-3.207217,43.349777],[-3.208598,43.349641],[-3.210323,43.349714],[-3.211968,43.350044],[-3.213496,43.35063],[-3.214334,43.351137],[-3.215153,43.351997],[-3.21555,43.352788],[-3.215845,43.354418],[-3.21636,43.355549],[-3.217877,43.357165],[-3.218404,43.358088],[-3.218557,43.359276],[-3.218335,43.360061],[-3.217731,43.361198],[-3.217331,43.362362],[-3.217342,43.363202],[-3.217822,43.364339],[-3.218814,43.365774],[-3.218623,43.366149],[-3.217055,43.367178],[-3.21587,43.36856],[-3.21495,43.369101],[-3.21404,43.369179],[-3.215034,43.369488],[-3.214293,43.371919],[-3.214302,43.372578],[-3.215117,43.3748],[-3.217063,43.37971],[-3.217804,43.380227],[-3.219108,43.379988],[-3.219931,43.381123],[-3.22087,43.38269],[-3.220922,43.383691],[-3.224034,43.384094],[-3.224321,43.384227],[-3.229769,43.388729],[-3.231028,43.390316],[-3.231505,43.39123],[-3.231536,43.39217],[-3.231942,43.393063],[-3.233677,43.394381],[-3.237825,43.396404],[-3.241274,43.397433],[-3.243199,43.397752],[-3.247143,43.398042],[-3.249949,43.398635],[-3.25145,43.399219],[-3.254176,43.400009],[-3.257675,43.400332],[-3.265435,43.400797],[-3.266771,43.400643],[-3.267526,43.400367],[-3.270824,43.398794],[-3.272461,43.398365],[-3.273621,43.39825],[-3.276549,43.398413],[-3.27781,43.398699],[-3.278984,43.399242],[-3.280665,43.400254],[-3.281725,43.40072],[-3.283105,43.401114],[-3.287596,43.402154],[-3.293891,43.403267],[-3.294259,43.402941],[-3.297552,43.402668],[-3.304482,43.402442],[-3.306728,43.402402],[-3.30983,43.402452],[-3.311576,43.402154],[-3.314783,43.397139],[-3.314039,43.395633],[-3.313753,43.394748],[-3.313527,43.392734],[-3.313538,43.391421],[-3.313799,43.390536],[-3.314959,43.388694],[-3.316527,43.386664],[-3.318011,43.385512],[-3.319069,43.385039],[-3.321454,43.384622],[-3.323015,43.384758],[-3.323915,43.384977],[-3.325852,43.385688],[-3.327526,43.386786],[-3.329201,43.38888],[-3.330625,43.389966],[-3.332362,43.390692],[-3.333869,43.390993],[-3.335814,43.39115],[-3.337435,43.391159],[-3.339122,43.390921],[-3.33995,43.390654],[-3.342605,43.389319],[-3.34381,43.38895],[-3.345716,43.388794],[-3.346571,43.388858],[-3.348231,43.389275],[-3.351183,43.390414],[-3.353538,43.391015],[-3.354782,43.391133],[-3.356402,43.391003],[-3.357341,43.390794],[-3.359281,43.389907],[-3.360572,43.388895],[-3.362012,43.387441],[-3.363048,43.385866],[-3.363902,43.38492],[-3.365836,43.383144],[-3.366904,43.382307],[-3.36842,43.381593],[-3.370379,43.380946],[-3.372174,43.38065],[-3.374206,43.380562],[-3.376655,43.380784],[-3.379153,43.381422],[-3.380904,43.38218],[-3.382922,43.383582],[-3.383775,43.384559],[-3.385257,43.386505],[-3.386934,43.387679],[-3.3896,43.388559],[-3.391465,43.389263],[-3.393738,43.390526],[-3.39505,43.391539],[-3.396499,43.393068],[-3.397372,43.394304],[-3.398507,43.396413],[-3.399458,43.397759],[-3.400821,43.399198],[-3.402647,43.400718],[-3.405034,43.402305],[-3.405995,43.402737],[-3.410603,43.404459],[-3.411973,43.404775],[-3.414264,43.404824],[-3.416014,43.404569],[-3.417425,43.404192],[-3.419573,43.403429],[-3.421814,43.402387],[-3.42352,43.401929],[-3.425032,43.40184],[-3.428734,43.402192],[-3.430393,43.402259],[-3.432548,43.402026],[-3.433612,43.40174],[-3.435515,43.400967],[-3.438313,43.399455],[-3.440378,43.397936],[-3.441658,43.396725],[-3.442918,43.395213],[-3.443737,43.393938],[-3.444922,43.391757],[-3.446087,43.390569],[-3.447065,43.389995],[-3.448827,43.389515],[-3.450984,43.389499],[-3.452568,43.389908],[-3.455646,43.391126],[-3.457158,43.391535],[-3.458248,43.391685],[-3.460515,43.391648],[-3.470924,43.390521],[-3.473571,43.390461],[-3.475325,43.390652],[-3.477468,43.391237],[-3.478707,43.391818],[-3.480663,43.39318],[-3.481899,43.394521],[-3.484688,43.398012],[-3.484803,43.398528],[-3.484379,43.39921],[-3.483366,43.399908],[-3.481564,43.400798],[-3.480192,43.400953],[-3.479753,43.401232],[-3.479608,43.402576],[-3.479631,43.403818],[-3.479936,43.404484],[-3.480737,43.405256],[-3.482107,43.406244],[-3.483128,43.407183],[-3.489575,43.414116],[-3.491331,43.417416],[-3.491218,43.418107],[-3.491524,43.421853],[-3.491906,43.425384],[-3.492632,43.429061],[-3.492441,43.429883],[-3.490765,43.431237],[-3.487663,43.434012],[-3.484144,43.436777],[-3.482767,43.437599],[-3.480854,43.438205],[-3.479301,43.439175],[-3.478881,43.440217],[-3.478352,43.440964],[-3.47452,43.443527],[-3.473056,43.443794],[-3.466068,43.444565],[-3.461791,43.444831],[-3.461727,43.445674],[-3.460604,43.445828],[-3.460674,43.450336],[-3.460511,43.450764],[-3.459824,43.45109],[-3.458461,43.451428],[-3.460212,43.453591],[-3.460128,43.454313],[-3.460876,43.454407],[-3.462738,43.45616],[-3.465069,43.458022],[-3.46638,43.458874],[-3.469274,43.460306],[-3.47135,43.461026],[-3.473006,43.461355],[-3.475008,43.461477],[-3.476152,43.461429],[-3.479981,43.460791],[-3.479685,43.460435],[-3.480455,43.459565],[-3.482537,43.459137],[-3.483127,43.458854],[-3.49171,43.45347],[-3.49321,43.452383],[-3.496965,43.449068],[-3.499876,43.446576],[-3.510713,43.43708],[-3.511498,43.436576],[-3.513339,43.435752],[-3.514738,43.434384],[-3.516108,43.432509],[-3.516524,43.431029],[-3.517288,43.430137],[-3.518063,43.429841],[-3.520459,43.429223],[-3.521212,43.4289],[-3.521808,43.428117],[-3.522311,43.425859],[-3.522363,43.424207],[-3.522698,43.423928],[-3.524498,43.42397],[-3.526903,43.42434],[-3.527655,43.424298],[-3.529011,43.423369],[-3.529673,43.423109],[-3.531995,43.422742],[-3.532659,43.422746],[-3.533336,43.422374],[-3.541379,43.420069],[-3.545632,43.418457],[-3.545184,43.417408],[-3.544346,43.416467],[-3.543208,43.415589],[-3.542766,43.414776],[-3.542964,43.414131],[-3.543435,43.413939],[-3.545144,43.414184],[-3.546857,43.415057],[-3.548268,43.41605],[-3.549529,43.416643],[-3.551439,43.417074],[-3.553139,43.417086],[-3.554931,43.416699],[-3.555789,43.416328],[-3.556992,43.415549],[-3.559192,43.413255],[-3.560611,43.412341],[-3.56236,43.411714],[-3.563638,43.411471],[-3.565561,43.411391],[-3.567733,43.411729],[-3.57033,43.412435],[-3.571827,43.412667],[-3.57399,43.412611],[-3.577457,43.411876],[-3.579106,43.411771],[-3.581903,43.411806],[-3.584887,43.411274],[-3.585944,43.411201],[-3.588767,43.411547],[-3.590402,43.411642],[-3.59207,43.411456],[-3.594812,43.410681],[-3.597072,43.409594],[-3.599049,43.408277],[-3.600712,43.407417],[-3.602456,43.406929],[-3.603742,43.406834],[-3.60699,43.407045],[-3.609519,43.40689],[-3.61116,43.406957],[-3.613141,43.407264],[-3.615227,43.407369],[-3.617898,43.407056],[-3.620712,43.406282],[-3.622617,43.405959],[-3.623924,43.40557],[-3.625313,43.404816],[-3.627365,43.402963],[-3.628283,43.402344],[-3.629685,43.401756],[-3.631308,43.401459],[-3.633716,43.401525],[-3.635751,43.401486],[-3.638459,43.401053],[-3.640077,43.400595],[-3.642365,43.399538],[-3.6441,43.398399],[-3.64569,43.397548],[-3.647226,43.397004],[-3.650093,43.396253],[-3.652718,43.395108],[-3.655092,43.393721],[-3.657191,43.392805],[-3.659355,43.39208],[-3.661061,43.391342],[-3.66209,43.390771],[-3.664314,43.38931],[-3.665415,43.388749],[-3.666938,43.388183],[-3.668864,43.387741],[-3.67147,43.387392],[-3.673369,43.387317],[-3.676517,43.387533],[-3.67811,43.387791],[-3.682485,43.388868],[-3.685703,43.389463],[-3.688977,43.390253],[-3.691024,43.390583],[-3.693502,43.390821],[-3.695505,43.391241],[-3.698394,43.392002],[-3.700076,43.392117],[-3.701441,43.392005],[-3.703417,43.391663],[-3.708891,43.391165],[-3.71362,43.390555],[-3.714586,43.390497],[-3.717668,43.390599],[-3.720321,43.390515],[-3.721809,43.390259],[-3.723318,43.389818],[-3.725994,43.388891],[-3.728016,43.388621],[-3.73236,43.388679],[-3.740658,43.388715],[-3.7422,43.38883],[-3.743392,43.38912],[-3.744997,43.389876],[-3.748381,43.392347],[-3.749591,43.393134],[-3.751502,43.394044],[-3.755497,43.395273],[-3.756358,43.395681],[-3.757326,43.39641],[-3.758809,43.398174],[-3.76049,43.399384],[-3.761361,43.399731],[-3.763495,43.40015],[-3.764767,43.400147],[-3.766645,43.399966],[-3.767961,43.399978],[-3.770597,43.400445],[-3.772626,43.40067],[-3.774957,43.400691],[-3.77758,43.400393],[-3.779474,43.399965],[-3.788763,43.397035],[-3.790394,43.396658],[-3.794049,43.395989],[-3.798756,43.395064],[-3.801219,43.394936],[-3.803191,43.394994],[-3.805123,43.394763],[-3.806675,43.394268],[-3.80912,43.392881],[-3.811322,43.391947],[-3.812981,43.39163],[-3.814408,43.39155],[-3.823699,43.391714],[-3.827473,43.391621],[-3.830362,43.391269],[-3.834057,43.390435],[-3.83568,43.389906],[-3.838723,43.388646],[-3.842848,43.386428],[-3.844709,43.385617],[-3.846389,43.385083],[-3.849767,43.384427],[-3.851995,43.38428],[-3.853902,43.384312],[-3.856394,43.384608],[-3.858474,43.385064],[-3.860175,43.385583],[-3.86244,43.386677],[-3.864099,43.387922],[-3.865074,43.389011],[-3.866079,43.3908],[-3.867532,43.397676],[-3.868475,43.399767],[-3.869284,43.401808],[-3.870478,43.405239],[-3.870961,43.406412],[-3.872246,43.409024],[-3.872648,43.410866],[-3.872593,43.411709],[-3.871975,43.413823],[-3.871751,43.415423],[-3.871655,43.418969],[-3.871339,43.42238],[-3.871394,43.424437],[-3.872071,43.426435],[-3.874435,43.430323],[-3.875312,43.431985],[-3.875875,43.434074],[-3.875965,43.435503],[-3.875871,43.436913],[-3.875614,43.437457],[-3.875097,43.437559],[-3.874629,43.437125],[-3.875318,43.43673],[-3.884995,43.438689],[-3.887485,43.439385],[-3.888028,43.440024],[-3.889878,43.439595],[-3.890777,43.439507],[-3.89127,43.439181],[-3.895817,43.437832],[-3.896476,43.437748],[-3.898721,43.437856],[-3.900328,43.437781],[-3.90604,43.436469],[-3.90685,43.436484],[-3.909148,43.435377],[-3.913476,43.433011],[-3.916503,43.431303],[-3.917096,43.431261],[-3.918403,43.432199],[-3.918438,43.43261],[-3.919369,43.431638],[-3.92,43.431294],[-3.921577,43.430802],[-3.922922,43.430622],[-3.925998,43.430468],[-3.927944,43.430028],[-3.929185,43.429545],[-3.930343,43.428897],[-3.932884,43.426897],[-3.934129,43.426137],[-3.935766,43.425377],[-3.938179,43.424783],[-3.939447,43.424716],[-3.94201,43.42478],[-3.943307,43.424612],[-3.945686,43.423824],[-3.947804,43.422649],[-3.951426,43.421361],[-3.953392,43.420447],[-3.95553,43.419825],[-3.958365,43.419362],[-3.959284,43.419089],[-3.96039,43.418539],[-3.962394,43.416875],[-3.963469,43.416234],[-3.965019,43.415712],[-3.967617,43.415171],[-3.969174,43.414669],[-3.97063,43.414045],[-3.973381,43.412613],[-3.976066,43.41157],[-3.979478,43.410599],[-3.981194,43.410045],[-3.983981,43.408872],[-3.985601,43.408009],[-3.988216,43.406226],[-3.989535,43.405016],[-3.991313,43.402693],[-3.992183,43.401766],[-3.993533,43.400849],[-3.994897,43.400283],[-3.996093,43.399992],[-3.998503,43.399608],[-4.000536,43.398949],[-4.002834,43.39802],[-4.004912,43.397379],[-4.00876,43.39569],[-4.012112,43.394847],[-4.013945,43.393932],[-4.016139,43.392058],[-4.017685,43.391336],[-4.020461,43.390454],[-4.021443,43.389901],[-4.022839,43.388695],[-4.024563,43.386789],[-4.025913,43.385772],[-4.027173,43.385054],[-4.028821,43.38438],[-4.03162,43.383437],[-4.032639,43.382909],[-4.03372,43.382077],[-4.034403,43.381326],[-4.035457,43.379655],[-4.036575,43.378232],[-4.03731,43.376667],[-4.03743,43.375965],[-4.037258,43.373598],[-4.037351,43.372656],[-4.037786,43.37137],[-4.038518,43.370445],[-4.040302,43.369001],[-4.040905,43.368218],[-4.042225,43.365388],[-4.043562,43.363112],[-4.044854,43.359823],[-4.045332,43.359451],[-4.049163,43.358579],[-4.0522,43.357617],[-4.054153,43.357081],[-4.055348,43.356903],[-4.058745,43.356929],[-4.059985,43.356848],[-4.062704,43.35633],[-4.06429,43.35617],[-4.066233,43.356261],[-4.070804,43.35693],[-4.073079,43.356961],[-4.075712,43.356515],[-4.076901,43.35612],[-4.080049,43.354779],[-4.08143,43.354271],[-4.08365,43.353738],[-4.085008,43.353569],[-4.087357,43.353547],[-4.090134,43.353965],[-4.092499,43.354694],[-4.094367,43.355126],[-4.096972,43.355367],[-4.098616,43.355329],[-4.100572,43.35505],[-4.103326,43.354239],[-4.104683,43.35361],[-4.109373,43.350789],[-4.111143,43.349785],[-4.113747,43.348787],[-4.115674,43.348383],[-4.119598,43.34793],[-4.121362,43.34757],[-4.123506,43.346917],[-4.127005,43.345638],[-4.128817,43.345252],[-4.130638,43.34508],[-4.132918,43.345184],[-4.134317,43.345355],[-4.136395,43.345444],[-4.138586,43.345238],[-4.139783,43.34496],[-4.141186,43.344463],[-4.142969,43.343518],[-4.144407,43.342502],[-4.146364,43.341264],[-4.148069,43.34043],[-4.150699,43.339469],[-4.153203,43.338756],[-4.154777,43.338119],[-4.156706,43.336901],[-4.158198,43.335275],[-4.158818,43.334118],[-4.159741,43.331709],[-4.160378,43.33057],[-4.16174,43.328926],[-4.162979,43.327868],[-4.164967,43.326522],[-4.16638,43.325739],[-4.168999,43.324611],[-4.172244,43.323641],[-4.175451,43.323088],[-4.178052,43.322903],[-4.180361,43.323],[-4.181658,43.323199],[-4.183261,43.323637],[-4.184764,43.324263],[-4.187633,43.325709],[-4.189942,43.326319],[-4.191643,43.326461],[-4.194564,43.326192],[-4.196686,43.325783],[-4.199683,43.32481],[-4.201578,43.323917],[-4.204551,43.3223],[-4.205849,43.321751],[-4.207885,43.321163],[-4.210654,43.320816],[-4.212047,43.320823],[-4.213888,43.320996],[-4.216108,43.321511],[-4.219058,43.322434],[-4.220846,43.322829],[-4.222758,43.323039],[-4.225244,43.322955],[-4.22677,43.322721],[-4.228572,43.322257],[-4.230555,43.321422],[-4.231749,43.320737],[-4.235034,43.318629],[-4.236627,43.317848],[-4.239278,43.316969],[-4.242137,43.316477],[-4.24441,43.316397],[-4.245714,43.316469],[-4.247961,43.316767],[-4.251126,43.317351],[-4.253073,43.317524],[-4.256041,43.317416],[-4.258655,43.316986],[-4.260343,43.316804],[-4.262667,43.316972],[-4.265041,43.317676],[-4.266281,43.318331],[-4.268152,43.31958],[-4.270475,43.320684],[-4.272535,43.321215],[-4.275611,43.321599],[-4.287948,43.32269],[-4.291259,43.32317],[-4.293603,43.323736],[-4.296926,43.324907],[-4.299326,43.326035],[-4.304912,43.329023],[-4.308623,43.331066],[-4.31097,43.332185],[-4.313555,43.333037],[-4.315952,43.333506],[-4.319299,43.333735],[-4.321767,43.333525],[-4.322117,43.333401],[-4.325216,43.333188],[-4.326435,43.333244],[-4.327946,43.333489],[-4.329909,43.334102],[-4.331391,43.334856],[-4.332453,43.335645],[-4.333534,43.33671],[-4.334672,43.338363],[-4.335971,43.339899],[-4.337431,43.341023],[-4.339203,43.34188],[-4.340578,43.342313],[-4.342631,43.342644],[-4.344402,43.34269],[-4.345547,43.342589],[-4.348941,43.341899],[-4.350606,43.341646],[-4.352359,43.341593],[-4.354541,43.341863],[-4.35626,43.342361],[-4.357833,43.343092],[-4.358878,43.343782],[-4.359966,43.344776],[-4.360874,43.346014],[-4.362213,43.348166],[-4.363473,43.34935],[-4.364878,43.350141],[-4.366508,43.350661],[-4.367981,43.350879],[-4.370728,43.35108],[-4.373461,43.351508],[-4.381268,43.353499],[-4.386036,43.354747],[-4.389037,43.355807],[-4.39154,43.357112],[-4.393395,43.35851],[-4.395121,43.3602],[-4.39646,43.361971],[-4.398621,43.365218],[-4.399385,43.366767],[-4.399299,43.368397],[-4.399762,43.370966],[-4.399662,43.371707],[-4.398868,43.372636],[-4.398733,43.373673],[-4.399506,43.374561],[-4.399629,43.375211],[-4.399019,43.376409],[-4.399037,43.377585],[-4.397939,43.378591],[-4.397523,43.37929],[-4.397413,43.380625],[-4.396901,43.381315],[-4.398838,43.383523],[-4.399463,43.384573],[-4.398049,43.385634],[-4.398009,43.38587],[-4.398859,43.387505],[-4.398085,43.385605],[-4.399609,43.384547],[-4.399578,43.384306],[-4.397242,43.381537],[-4.397698,43.378957],[-4.398752,43.378127],[-4.399114,43.377474],[-4.39909,43.376305],[-4.399626,43.375134],[-4.399591,43.374643],[-4.398683,43.373298],[-4.398998,43.37258],[-4.399744,43.371688],[-4.399837,43.371144],[-4.399341,43.367998],[-4.399648,43.367414],[-4.400237,43.36742],[-4.401532,43.368082],[-4.403668,43.368852],[-4.405748,43.369741],[-4.407737,43.370401],[-4.411356,43.371075],[-4.41305,43.37122],[-4.415059,43.371261],[-4.418024,43.371121],[-4.422397,43.370692],[-4.425708,43.370414],[-4.430312,43.370139],[-4.435369,43.369971],[-4.439175,43.369735],[-4.441827,43.369372],[-4.44676,43.368477],[-4.448646,43.368349],[-4.451239,43.368496],[-4.452665,43.368742],[-4.459668,43.370526],[-4.46101,43.370802],[-4.46373,43.371126],[-4.466565,43.371171],[-4.471425,43.371093],[-4.473993,43.37079],[-4.476401,43.370096],[-4.47805,43.369752],[-4.479484,43.369682],[-4.480622,43.369776],[-4.482509,43.370229],[-4.483706,43.370769],[-4.485411,43.371759],[-4.486351,43.372159],[-4.48861,43.372793],[-4.490407,43.373542],[-4.492344,43.374758],[-4.494283,43.37547],[-4.496122,43.375714],[-4.499012,43.375694],[-4.501215,43.375948],[-4.504205,43.37696],[-4.504142,43.375998],[-4.504572,43.375653],[-4.504265,43.375361],[-4.502905,43.375481],[-4.50102,43.375147],[-4.50111,43.37533],[-4.502639,43.375511],[-4.503777,43.375479],[-4.504145,43.37582],[-4.504656,43.375242],[-4.505144,43.375087],[-4.507351,43.375139],[-4.512065,43.374813],[-4.514575,43.374719],[-4.517685,43.374419],[-4.518838,43.373373],[-4.521476,43.370253],[-4.521909,43.369568],[-4.522266,43.36824],[-4.522085,43.367726],[-4.520286,43.366812],[-4.520024,43.366049],[-4.520338,43.365579],[-4.52274,43.36356],[-4.524026,43.362871],[-4.524816,43.362677],[-4.528995,43.362219],[-4.529848,43.362054],[-4.530538,43.361667],[-4.53096,43.360729],[-4.530621,43.359175],[-4.530841,43.358299],[-4.531785,43.357232],[-4.5321,43.35635],[-4.532167,43.354327],[-4.533288,43.351632],[-4.534372,43.349593],[-4.534413,43.348487],[-4.533977,43.345448],[-4.534088,43.344758],[-4.534904,43.3439],[-4.537086,43.342912],[-4.538677,43.342007],[-4.539445,43.341189],[-4.539589,43.340544],[-4.53913,43.33924],[-4.538681,43.338692],[-4.536961,43.337712],[-4.536353,43.336908],[-4.535757,43.335415],[-4.535922,43.334965],[-4.536816,43.334651],[-4.538194,43.334826],[-4.539564,43.334589],[-4.542205,43.333135],[-4.542959,43.332829],[-4.545281,43.332212],[-4.547595,43.331905],[-4.552367,43.33177],[-4.553296,43.331264],[-4.553625,43.33072],[-4.553635,43.329309],[-4.554016,43.328489],[-4.55464,43.328081],[-4.557119,43.326829],[-4.558803,43.326398],[-4.559841,43.326425],[-4.562076,43.326833],[-4.563035,43.326832],[-4.564804,43.326302],[-4.566601,43.326278],[-4.568346,43.326684],[-4.570793,43.326488],[-4.571662,43.326781],[-4.573071,43.327747],[-4.574337,43.328205],[-4.575247,43.328308],[-4.577989,43.328199],[-4.581203,43.327996],[-4.582247,43.327649],[-4.58467,43.326304],[-4.589779,43.327435],[-4.59059,43.327377],[-4.591299,43.32706],[-4.595486,43.324642],[-4.595979,43.324109],[-4.596178,43.323223],[-4.59664,43.322726],[-4.597337,43.322442],[-4.599369,43.322304],[-4.601787,43.323038],[-4.603089,43.322903],[-4.605184,43.322531],[-4.606492,43.322612],[-4.6082,43.322503],[-4.610221,43.322166],[-4.610933,43.321831],[-4.611346,43.321294],[-4.611526,43.320417],[-4.613847,43.31844],[-4.615656,43.317614],[-4.618342,43.317649],[-4.621719,43.318606],[-4.623496,43.319565],[-4.624247,43.319805],[-4.626317,43.319711],[-4.62787,43.319515],[-4.628875,43.31958],[-4.630718,43.320193],[-4.632262,43.320274],[-4.633441,43.320511],[-4.634515,43.320899],[-4.635613,43.321762],[-4.637824,43.322788],[-4.639119,43.324272],[-4.639754,43.324665],[-4.642225,43.325749],[-4.64445,43.326895],[-4.64575,43.327249],[-4.648699,43.327639],[-4.651353,43.32759],[-4.653353,43.328054],[-4.655377,43.328049],[-4.657252,43.328638],[-4.65864,43.329669],[-4.659399,43.329809],[-4.660578,43.329578],[-4.661625,43.329081],[-4.66239,43.329005],[-4.665718,43.329483],[-4.66643,43.329244],[-4.667773,43.328498],[-4.672854,43.327242],[-4.674503,43.326302],[-4.675933,43.324904],[-4.676412,43.324685],[-4.677294,43.324747],[-4.678539,43.324471],[-4.678934,43.324149],[-4.678122,43.321972],[-4.677828,43.319951],[-4.677435,43.318914],[-4.678276,43.316837],[-4.678807,43.31649],[-4.681393,43.315533],[-4.68285,43.315594],[-4.685575,43.31511],[-4.687679,43.315242],[-4.690988,43.315199],[-4.694035,43.315607],[-4.698672,43.315852],[-4.701031,43.315682],[-4.701926,43.316108],[-4.704108,43.316798],[-4.705634,43.317104],[-4.706668,43.317449],[-4.708729,43.317631],[-4.710033,43.318132],[-4.712691,43.317875],[-4.713841,43.317901],[-4.715201,43.317011],[-4.716519,43.31651],[-4.717529,43.314954],[-4.719343,43.314711],[-4.721671,43.313963],[-4.723007,43.313762],[-4.725204,43.313162],[-4.727681,43.312303],[-4.729617,43.311297],[-4.730243,43.311077],[-4.73226,43.309988],[-4.73268,43.309398],[-4.733852,43.308402],[-4.734954,43.307778],[-4.738155,43.306565],[-4.739127,43.305717],[-4.740111,43.305287],[-4.742683,43.304748],[-4.744751,43.303802],[-4.745428,43.30318],[-4.746236,43.301558],[-4.747492,43.300521],[-4.749493,43.29912],[-4.752392,43.297768],[-4.753501,43.296823],[-4.754142,43.296627],[-4.755623,43.296576],[-4.757236,43.296857],[-4.75851,43.296919],[-4.760461,43.296285],[-4.76247,43.296109],[-4.764071,43.295743],[-4.765481,43.295964],[-4.768562,43.296186],[-4.771717,43.295885],[-4.773294,43.295956],[-4.775656,43.295868],[-4.776749,43.296211],[-4.780751,43.296703],[-4.78252,43.297213],[-4.784576,43.298487],[-4.787235,43.299751],[-4.788662,43.299684],[-4.789861,43.299138],[-4.791248,43.298866],[-4.79272,43.298424],[-4.796036,43.298043],[-4.79949,43.298305],[-4.801218,43.298872],[-4.803758,43.300274],[-4.80514,43.300761],[-4.806737,43.300889],[-4.808796,43.300634],[-4.809198,43.301448],[-4.809846,43.301553],[-4.814342,43.30181],[-4.815538,43.301926],[-4.81604,43.302771],[-4.817458,43.3029],[-4.818559,43.302611],[-4.818916,43.30196],[-4.818449,43.300989],[-4.819473,43.2999],[-4.819402,43.299449],[-4.818834,43.299308],[-4.817612,43.299727],[-4.817426,43.299586],[-4.819188,43.298814],[-4.819944,43.298241],[-4.820758,43.297026],[-4.821516,43.296231],[-4.821587,43.295782],[-4.822642,43.295162],[-4.82281,43.294467],[-4.823682,43.293614],[-4.82466,43.293305],[-4.824952,43.292705],[-4.825286,43.29108],[-4.825795,43.289873],[-4.826372,43.28974],[-4.827764,43.288842],[-4.828631,43.288617],[-4.830982,43.287525],[-4.832598,43.286445],[-4.833293,43.285613],[-4.833699,43.284709],[-4.833811,43.283501],[-4.834551,43.278358],[-4.833805,43.277209],[-4.83432,43.275651],[-4.83308,43.274084],[-4.832838,43.272937],[-4.83215,43.271285],[-4.831021,43.270007],[-4.83092,43.269568],[-4.831137,43.268507],[-4.831581,43.267954],[-4.831582,43.266925],[-4.83181,43.266485],[-4.831873,43.26507],[-4.831757,43.264162],[-4.831208,43.262997],[-4.830782,43.262481],[-4.830676,43.261226],[-4.830986,43.260637],[-4.830609,43.259835],[-4.830952,43.259405],[-4.830755,43.25838],[-4.832546,43.257083],[-4.832824,43.257076],[-4.830072,43.258186],[-4.830763,43.258382],[-4.830558,43.258759],[-4.830663,43.260086],[-4.830985,43.260484],[-4.830712,43.262183],[-4.83137,43.262823],[-4.831832,43.263918],[-4.832083,43.265424],[-4.83169,43.268164],[-4.831371,43.268535],[-4.831152,43.269529],[-4.831228,43.270131],[-4.832317,43.271451],[-4.832995,43.273195],[-4.83305,43.274024],[-4.833554,43.274832],[-4.83427,43.275576],[-4.834238,43.276297],[-4.833806,43.277285],[-4.834566,43.278591],[-4.83423,43.280868],[-4.833964,43.281703],[-4.833685,43.284818],[-4.83332,43.28576],[-4.832084,43.287006],[-4.830838,43.287749],[-4.827144,43.289218],[-4.826299,43.289796],[-4.825721,43.289941],[-4.825702,43.290487],[-4.825292,43.29125],[-4.824764,43.293271],[-4.824259,43.293598],[-4.823466,43.293684],[-4.822726,43.294647],[-4.822789,43.295084],[-4.822106,43.295687],[-4.821557,43.295756],[-4.821442,43.296357],[-4.820671,43.29707],[-4.819816,43.298382],[-4.818926,43.299009],[-4.817431,43.29965],[-4.817638,43.299789],[-4.818976,43.299364],[-4.819467,43.299601],[-4.819389,43.300028],[-4.8185,43.300907],[-4.818909,43.301877],[-4.818551,43.302575],[-4.817868,43.302844],[-4.823035,43.30492],[-4.826084,43.306219],[-4.827213,43.307178],[-4.828596,43.307697],[-4.829781,43.307911],[-4.832189,43.307993],[-4.833104,43.308155],[-4.837293,43.310422],[-4.837842,43.310838],[-4.838955,43.312475],[-4.839465,43.31292],[-4.841699,43.313934],[-4.842066,43.31463],[-4.842598,43.31494],[-4.844083,43.314862],[-4.844831,43.314963],[-4.845967,43.315719],[-4.848377,43.315648],[-4.853537,43.316023],[-4.857049,43.316948],[-4.857898,43.317035],[-4.860005,43.316898],[-4.862352,43.316304],[-4.862786,43.315984],[-4.863299,43.315132],[-4.86384,43.314992],[-4.865557,43.314976],[-4.86704,43.315495],[-4.868042,43.315646],[-4.869444,43.316344],[-4.872165,43.317204],[-4.873339,43.318777],[-4.873369,43.319841],[-4.872958,43.320983],[-4.873492,43.321148],[-4.874183,43.320552],[-4.875029,43.318714],[-4.874882,43.318193],[-4.876632,43.31654],[-4.879746,43.315695],[-4.880591,43.315612],[-4.883232,43.315774],[-4.884846,43.316254],[-4.886676,43.316671],[-4.888808,43.316988],[-4.890211,43.317908],[-4.893394,43.318892],[-4.894791,43.319108],[-4.895789,43.319557],[-4.89678,43.319795],[-4.900272,43.319453],[-4.901017,43.319973],[-4.900662,43.321242],[-4.900951,43.323032],[-4.901584,43.324638],[-4.902699,43.326074],[-4.903265,43.327838],[-4.903054,43.328909],[-4.903498,43.330813],[-4.903751,43.332707],[-4.904089,43.333128],[-4.906097,43.334422],[-4.906665,43.335172],[-4.907706,43.335666],[-4.909544,43.336185],[-4.911349,43.336307],[-4.912262,43.336505],[-4.912938,43.336954],[-4.913774,43.337906],[-4.914854,43.338297],[-4.915184,43.33796],[-4.916709,43.337574],[-4.918957,43.337462],[-4.922259,43.337638],[-4.923537,43.338039],[-4.924862,43.338741],[-4.926687,43.338862],[-4.928046,43.339601],[-4.930091,43.339664],[-4.93123,43.339143],[-4.931732,43.338361],[-4.932316,43.33801],[-4.933818,43.338106],[-4.934555,43.338017],[-4.936002,43.337309],[-4.937873,43.336815],[-4.940106,43.33654],[-4.942698,43.335821],[-4.944778,43.335094],[-4.945825,43.335164],[-4.948793,43.334192],[-4.951716,43.334019],[-4.952382,43.334155],[-4.954248,43.334981],[-4.955242,43.335177],[-4.961776,43.335059],[-4.963517,43.335216],[-4.966183,43.334945],[-4.967623,43.335041],[-4.969482,43.334723],[-4.97156,43.334962],[-4.972751,43.335203],[-4.974606,43.336149],[-4.975271,43.336314],[-4.9786,43.336626],[-4.980635,43.336908],[-4.983428,43.336971],[-4.986224,43.337235],[-4.992125,43.337865],[-4.99361,43.337904],[-4.994633,43.337778],[-4.997118,43.337249],[-4.997904,43.337168],[-5.000003,43.337294],[-5.00157,43.337679],[-5.003541,43.337419],[-5.005571,43.337561],[-5.007388,43.338692],[-5.008506,43.338999],[-5.010034,43.339049],[-5.011453,43.34006],[-5.013383,43.340755],[-5.013763,43.341014],[-5.01559,43.342848],[-5.016597,43.345157],[-5.017093,43.345586],[-5.021971,43.348518],[-5.022577,43.348724],[-5.023753,43.348705],[-5.025331,43.348369],[-5.028029,43.347429],[-5.029245,43.347227],[-5.034028,43.346742],[-5.037106,43.346525],[-5.043856,43.346151],[-5.044564,43.345913],[-5.046252,43.345008],[-5.04782,43.344775],[-5.049489,43.344109],[-5.05091,43.344341],[-5.051873,43.345736],[-5.052483,43.347281],[-5.053684,43.347887],[-5.055832,43.348225],[-5.058488,43.34781],[-5.060415,43.347014],[-5.061185,43.34695],[-5.063845,43.347369],[-5.066409,43.348273],[-5.067502,43.348383],[-5.068656,43.347688],[-5.068774,43.346571],[-5.069159,43.34609],[-5.070732,43.345243],[-5.072002,43.345281],[-5.073631,43.345674],[-5.075701,43.346453],[-5.077815,43.347496],[-5.078702,43.34772],[-5.081651,43.348004],[-5.082694,43.347925],[-5.085325,43.347409],[-5.086387,43.347039],[-5.086999,43.347016],[-5.088194,43.347375],[-5.090446,43.348293],[-5.094311,43.350344],[-5.095679,43.350713],[-5.096563,43.350609],[-5.099494,43.349754],[-5.101575,43.349481],[-5.102637,43.34946],[-5.107824,43.350266],[-5.108795,43.350536],[-5.109373,43.351207],[-5.110141,43.351009],[-5.112136,43.351235],[-5.115467,43.350878],[-5.117541,43.351],[-5.120731,43.351772],[-5.123793,43.352422],[-5.124691,43.352963],[-5.124834,43.353553],[-5.125269,43.353764],[-5.125825,43.354533],[-5.126553,43.355099],[-5.129758,43.356335],[-5.132629,43.357013],[-5.134905,43.357028],[-5.138145,43.35735],[-5.145154,43.361412],[-5.146744,43.362244],[-5.15202,43.364363],[-5.152997,43.365101],[-5.153189,43.366358],[-5.152614,43.367337],[-5.148473,43.370553],[-5.147869,43.371485],[-5.147757,43.372146],[-5.148202,43.373821],[-5.149275,43.374445],[-5.152902,43.374557],[-5.154744,43.374239],[-5.156325,43.374088],[-5.15861,43.374132],[-5.160269,43.374716],[-5.162308,43.376192],[-5.16461,43.377009],[-5.165226,43.377339],[-5.166109,43.378655],[-5.166628,43.379142],[-5.168346,43.380064],[-5.169557,43.381464],[-5.171411,43.382589],[-5.175581,43.385848],[-5.17605,43.386642],[-5.176785,43.387302],[-5.178546,43.387958],[-5.179262,43.388434],[-5.179904,43.389486],[-5.180601,43.389813],[-5.180767,43.390244],[-5.179932,43.391939],[-5.179402,43.392396],[-5.178239,43.392766],[-5.171969,43.393588],[-5.169671,43.394083],[-5.167259,43.394112],[-5.161316,43.394836],[-5.158559,43.394882],[-5.155357,43.395144],[-5.154547,43.395277],[-5.142528,43.398355],[-5.141637,43.398467],[-5.139438,43.398024],[-5.138044,43.398165],[-5.137121,43.398768],[-5.136761,43.399466],[-5.136405,43.400924],[-5.136329,43.402409],[-5.13599,43.403074],[-5.136092,43.404064],[-5.135864,43.405161],[-5.135484,43.406074],[-5.134293,43.407009],[-5.13317,43.407088],[-5.13033,43.406172],[-5.127498,43.406117],[-5.126778,43.405934],[-5.124125,43.404735],[-5.122859,43.404548],[-5.12195,43.404825],[-5.117121,43.406983],[-5.114659,43.407674],[-5.112085,43.409462],[-5.111136,43.409856],[-5.109266,43.409584],[-5.106377,43.409779],[-5.102678,43.409724],[-5.100729,43.40887],[-5.098922,43.408879],[-5.097277,43.409254],[-5.096702,43.409577],[-5.096016,43.410609],[-5.094621,43.411299],[-5.094044,43.411755],[-5.093307,43.412889],[-5.093208,43.414123],[-5.092839,43.414982],[-5.092063,43.41568],[-5.090559,43.416283],[-5.089973,43.416791],[-5.088517,43.418518],[-5.08809,43.420941],[-5.087636,43.4217],[-5.086109,43.423439],[-5.084698,43.424581],[-5.083406,43.42477],[-5.082439,43.424271],[-5.080924,43.424067],[-5.080195,43.424298],[-5.078867,43.425453],[-5.078183,43.425676],[-5.076895,43.425561],[-5.07605,43.425669],[-5.073756,43.426787],[-5.072465,43.427827],[-5.07148,43.428788],[-5.070063,43.429376],[-5.06911,43.429356],[-5.067964,43.428746],[-5.066471,43.427084],[-5.065409,43.426307],[-5.063464,43.425773],[-5.062522,43.425642],[-5.061606,43.425798],[-5.06062,43.42644],[-5.060338,43.4271],[-5.060487,43.427798],[-5.062234,43.430549],[-5.062108,43.431375],[-5.057389,43.437778],[-5.055862,43.439967],[-5.055042,43.440045],[-5.054458,43.439829],[-5.052555,43.438606],[-5.050363,43.43734],[-5.048585,43.436734],[-5.046716,43.43673],[-5.045399,43.437301],[-5.044312,43.438352],[-5.043523,43.438147],[-5.043701,43.437736],[-5.045343,43.436994],[-5.047162,43.436509],[-5.052256,43.435916],[-5.058059,43.435154],[-5.061418,43.435089],[-5.063853,43.435303],[-5.066197,43.435691],[-5.068005,43.436125],[-5.070096,43.436777],[-5.077389,43.439599],[-5.079191,43.440174],[-5.081798,43.440512],[-5.084384,43.440487],[-5.086162,43.440613],[-5.087356,43.440833],[-5.088948,43.441387],[-5.090364,43.44215],[-5.095689,43.446163],[-5.09786,43.447412],[-5.099546,43.448041],[-5.101965,43.448655],[-5.104631,43.449507],[-5.10624,43.450285],[-5.108557,43.451846],[-5.110443,43.453654],[-5.111219,43.454541],[-5.113921,43.45727],[-5.115819,43.458597],[-5.117272,43.45923],[-5.118378,43.459565],[-5.120425,43.459901],[-5.124961,43.460029],[-5.127382,43.460379],[-5.13035,43.461358],[-5.132522,43.461877],[-5.134102,43.462044],[-5.137613,43.461976],[-5.139483,43.462141],[-5.140953,43.462486],[-5.142604,43.463048],[-5.155795,43.470029],[-5.157776,43.470683],[-5.159629,43.471044],[-5.162145,43.471223],[-5.164836,43.470999],[-5.166749,43.470547],[-5.169258,43.469643],[-5.171127,43.469173],[-5.17256,43.469002],[-5.174371,43.46901],[-5.175604,43.46916],[-5.177154,43.46952],[-5.180135,43.470498],[-5.182355,43.470781],[-5.184558,43.470593],[-5.187672,43.470107],[-5.191316,43.469998],[-5.191837,43.470262],[-5.194205,43.470577],[-5.19674,43.470735],[-5.198655,43.47068],[-5.200227,43.470522],[-5.202378,43.47009],[-5.205021,43.469382],[-5.208009,43.468934],[-5.211545,43.468865],[-5.212031,43.468942],[-5.214647,43.469835],[-5.215814,43.470333],[-5.218769,43.471825],[-5.220458,43.472474],[-5.221968,43.472816],[-5.223862,43.472977],[-5.225999,43.472856],[-5.229657,43.471919],[-5.231606,43.471638],[-5.233955,43.471737],[-5.236145,43.472282],[-5.238867,43.473313],[-5.241083,43.473807],[-5.245091,43.474158],[-5.246202,43.474353],[-5.247999,43.474937],[-5.249174,43.475547],[-5.250589,43.476666],[-5.252022,43.478161],[-5.253678,43.479526],[-5.254883,43.480279],[-5.256515,43.481043],[-5.258573,43.481718],[-5.260396,43.482083],[-5.263623,43.482282],[-5.266118,43.482042],[-5.267935,43.48166],[-5.272183,43.480625],[-5.274061,43.480409],[-5.275998,43.480399],[-5.278015,43.480628],[-5.279302,43.480888],[-5.282654,43.481936],[-5.28392,43.482241],[-5.285862,43.482416],[-5.287806,43.482287],[-5.289064,43.482033],[-5.292104,43.481059],[-5.293363,43.48078],[-5.295302,43.480642],[-5.297839,43.480961],[-5.300867,43.481689],[-5.304687,43.482793],[-5.307184,43.483898],[-5.310554,43.486137],[-5.312988,43.487248],[-5.315476,43.488047],[-5.316912,43.488669],[-5.318314,43.489534],[-5.319133,43.4902],[-5.320658,43.491808],[-5.322135,43.492959],[-5.3232,43.49351],[-5.325802,43.494643],[-5.327585,43.495952],[-5.328458,43.497012],[-5.328907,43.497855],[-5.329268,43.499033],[-5.32966,43.501099],[-5.330383,43.50291],[-5.331864,43.504767],[-5.33284,43.505471],[-5.333966,43.506044],[-5.335659,43.506571],[-5.337447,43.506771],[-5.339556,43.5066],[-5.341187,43.506135],[-5.344775,43.504318],[-5.345833,43.503951],[-5.347854,43.503626],[-5.35271,43.503917],[-5.354775,43.503616],[-5.355916,43.503272],[-5.361287,43.501069],[-5.362883,43.500287],[-5.364264,43.499326],[-5.36568,43.498069],[-5.366846,43.497231],[-5.368274,43.496578],[-5.369208,43.496313],[-5.370856,43.496087],[-5.371867,43.496079],[-5.373881,43.496339],[-5.378976,43.4974],[-5.380503,43.49784],[-5.384143,43.499539],[-5.386346,43.500132],[-5.3923,43.501042],[-5.39389,43.501172],[-5.395553,43.501133],[-5.398152,43.500938],[-5.399454,43.500925],[-5.401699,43.501164],[-5.40388,43.501646],[-5.406604,43.502032],[-5.40818,43.501993],[-5.4105,43.501454],[-5.412037,43.500693],[-5.413465,43.499494],[-5.414056,43.498707],[-5.415093,43.496305],[-5.416024,43.494806],[-5.418539,43.491914],[-5.419261,43.491194],[-5.42064,43.49026],[-5.422021,43.489692],[-5.423182,43.489412],[-5.431819,43.487827],[-5.443116,43.487279],[-5.445881,43.487552],[-5.447631,43.487543],[-5.450285,43.487212],[-5.451449,43.486913],[-5.453228,43.486239],[-5.454816,43.485381],[-5.456209,43.484347],[-5.457332,43.483201],[-5.458206,43.481909],[-5.459936,43.478932],[-5.461256,43.477209],[-5.462686,43.475765],[-5.464,43.474647],[-5.465447,43.473601],[-5.466762,43.472794],[-5.469859,43.471282],[-5.471659,43.470611],[-5.474582,43.469791],[-5.478792,43.468925],[-5.480409,43.468477],[-5.48215,43.467848],[-5.484652,43.466732],[-5.485894,43.466391],[-5.487833,43.46622],[-5.489188,43.466354],[-5.493101,43.467152],[-5.495662,43.467378],[-5.497045,43.467212],[-5.499205,43.466705],[-5.503257,43.465631],[-5.5055,43.464757],[-5.507734,43.463685],[-5.509443,43.463161],[-5.510812,43.46294],[-5.512231,43.462904],[-5.514077,43.463054],[-5.527506,43.480903],[-5.528253,43.482799],[-5.531928,43.493028],[-5.532795,43.494923],[-5.533899,43.496464],[-5.534866,43.497286],[-5.537725,43.498995],[-5.539385,43.500102],[-5.540629,43.501141],[-5.542418,43.503129],[-5.54432,43.505725],[-5.545925,43.507001],[-5.547531,43.507755],[-5.548833,43.508121],[-5.550779,43.508357],[-5.553982,43.508234],[-5.556415,43.508409],[-5.5582,43.508789],[-5.560392,43.509596],[-5.564886,43.5119],[-5.565957,43.512332],[-5.567719,43.512717],[-5.570474,43.512732],[-5.57258,43.512403],[-5.574295,43.511954],[-5.57561,43.51141],[-5.576969,43.510523],[-5.577645,43.509811],[-5.579357,43.507251],[-5.586709,43.503663],[-5.589425,43.503687],[-5.591177,43.504074],[-5.592499,43.504637],[-5.593397,43.505222],[-5.59446,43.506275],[-5.596077,43.509107],[-5.597205,43.510158],[-5.598744,43.510897],[-5.599595,43.511166],[-5.601128,43.511376],[-5.60236,43.511344],[-5.605704,43.510837],[-5.607655,43.510902],[-5.60895,43.511193],[-5.610144,43.511666],[-5.612945,43.513108],[-5.614575,43.513696],[-5.61597,43.514063],[-5.621924,43.514438],[-5.624608,43.514887],[-5.626022,43.515303],[-5.628373,43.516381],[-5.630356,43.517731],[-5.634346,43.52075],[-5.636003,43.521699],[-5.637648,43.52223],[-5.639732,43.522459],[-5.641178,43.522353],[-5.645146,43.52167],[-5.649849,43.520797],[-5.651168,43.520467],[-5.65336,43.519506],[-5.655158,43.518236],[-5.656328,43.518268],[-5.657185,43.518898],[-5.65781,43.520081],[-5.660805,43.520616],[-5.662375,43.521227],[-5.663244,43.52203],[-5.663615,43.523107],[-5.663526,43.523938],[-5.66311,43.525308],[-5.663344,43.525428],[-5.667857,43.526011],[-5.671762,43.526461],[-5.67323,43.526768],[-5.673952,43.527079],[-5.677331,43.529183],[-5.6824,43.533264],[-5.683624,43.534118],[-5.684684,43.534561],[-5.68732,43.53537],[-5.688988,43.535998],[-5.689859,43.5365],[-5.690958,43.537452],[-5.695663,43.543071],[-5.695591,43.544014],[-5.696501,43.544112],[-5.696846,43.543764],[-5.695271,43.542329],[-5.690903,43.537107],[-5.689668,43.536106],[-5.688278,43.535465],[-5.684355,43.534206],[-5.682907,43.533368],[-5.682732,43.532686],[-5.684801,43.530506],[-5.687975,43.527917],[-5.691174,43.525652],[-5.692495,43.524618],[-5.694779,43.522402],[-5.696228,43.521303],[-5.697944,43.520452],[-5.700417,43.519701],[-5.704437,43.518936],[-5.707116,43.518594],[-5.710123,43.518761],[-5.713432,43.519159],[-5.715311,43.51916],[-5.717203,43.518966],[-5.718753,43.518648],[-5.72511,43.516803],[-5.732042,43.514685],[-5.734005,43.513915],[-5.736185,43.512695],[-5.737351,43.511794],[-5.738569,43.510586],[-5.739594,43.509185],[-5.740629,43.507199],[-5.741558,43.505979],[-5.742627,43.505118],[-5.743638,43.504562],[-5.745053,43.504054],[-5.746291,43.503797],[-5.747595,43.503695],[-5.749215,43.503812],[-5.753025,43.504527],[-5.754627,43.504641],[-5.756614,43.504555],[-5.759503,43.504025],[-5.762826,43.502958],[-5.765687,43.502392],[-5.768224,43.502232],[-5.773302,43.502572],[-5.775882,43.502468],[-5.777777,43.502098],[-5.78072,43.501286],[-5.782577,43.501107],[-5.785105,43.501292],[-5.786338,43.501579],[-5.78937,43.502634],[-5.791818,43.502936],[-5.795514,43.502725],[-5.79727,43.502777],[-5.798944,43.50297],[-5.800787,43.503431],[-5.803011,43.504325],[-5.804995,43.50551],[-5.807872,43.507762],[-5.808953,43.508452],[-5.81069,43.509284],[-5.814624,43.510641],[-5.817319,43.511965],[-5.819139,43.513337],[-5.820269,43.514465],[-5.821199,43.515694],[-5.821759,43.516801],[-5.822251,43.518388],[-5.822916,43.521711],[-5.823971,43.524044],[-5.825036,43.525589],[-5.826359,43.527003],[-5.827458,43.527951],[-5.830883,43.530363],[-5.83199,43.531277],[-5.833338,43.532692],[-5.834291,43.533984],[-5.836142,43.537157],[-5.837111,43.538428],[-5.839265,43.540562],[-5.841712,43.542251],[-5.844205,43.543555],[-5.84632,43.544345],[-5.848848,43.544985],[-5.850482,43.545147],[-5.852738,43.54504],[-5.85396,43.544811],[-5.856441,43.544008],[-5.859209,43.542547],[-5.861503,43.540927],[-5.864083,43.538615],[-5.865602,43.537439],[-5.867295,43.536368],[-5.871951,43.533978],[-5.874018,43.532697],[-5.874968,43.53198],[-5.880656,43.52725],[-5.882072,43.526161],[-5.883815,43.524976],[-5.886403,43.523536],[-5.888229,43.52274],[-5.889912,43.522293],[-5.891389,43.522093],[-5.893502,43.522088],[-5.896151,43.52237],[-5.898607,43.522329],[-5.900813,43.521944],[-5.90346,43.52109],[-5.904973,43.520681],[-5.907563,43.520419],[-5.909168,43.520556],[-5.91041,43.520806],[-5.911938,43.521285],[-5.913576,43.522126],[-5.91619,43.523964],[-5.918559,43.525325],[-5.919975,43.525985],[-5.922714,43.527038],[-5.925356,43.52844],[-5.927745,43.530105],[-5.929819,43.531314],[-5.931745,43.532251],[-5.933951,43.533085],[-5.935293,43.533459],[-5.936956,43.533691],[-5.938355,43.533706],[-5.940441,43.533496],[-5.941921,43.533124],[-5.945611,43.531739],[-5.94738,43.531346],[-5.949311,43.531145],[-5.952563,43.531282],[-5.954301,43.531629],[-5.955707,43.532077],[-5.957752,43.53303],[-5.959122,43.533953],[-5.960453,43.535214],[-5.961651,43.536837],[-5.963246,43.539425],[-5.963689,43.540271],[-5.965217,43.54266],[-5.966654,43.544328],[-5.968067,43.545475],[-5.969465,43.546342],[-5.970972,43.547074],[-5.973266,43.547852],[-5.975725,43.548341],[-5.977262,43.548507],[-5.981689,43.548639],[-5.984192,43.548896],[-5.988464,43.549846],[-5.990344,43.550136],[-5.992875,43.550208],[-5.99508,43.549947],[-5.997738,43.54924],[-5.999638,43.548386],[-6.002369,43.54649],[-6.0036,43.545735],[-6.005245,43.545113],[-6.007114,43.544759],[-6.008378,43.544705],[-6.010569,43.544884],[-6.01289,43.545449],[-6.015229,43.545673],[-6.01667,43.545572],[-6.018053,43.545241],[-6.021872,43.543551],[-6.024534,43.542954],[-6.02664,43.542946],[-6.028948,43.543345],[-6.03074,43.543894],[-6.03258,43.544208],[-6.034423,43.54424],[-6.036237,43.54401],[-6.038592,43.543187],[-6.039992,43.542346],[-6.041263,43.541136],[-6.041932,43.540106],[-6.04283,43.538194],[-6.043873,43.536578],[-6.045608,43.534737],[-6.047124,43.533565],[-6.049349,43.532283],[-6.051482,43.53132],[-6.052542,43.530735],[-6.053878,43.529731],[-6.054783,43.528779],[-6.055352,43.527953],[-6.05631,43.525494],[-6.056884,43.524391],[-6.058335,43.52262],[-6.059869,43.521446],[-6.060882,43.520885],[-6.062825,43.520045],[-6.064653,43.519573],[-6.06623,43.519354],[-6.069819,43.519288],[-6.078317,43.519255],[-6.081105,43.519354],[-6.082608,43.519599],[-6.084952,43.520283],[-6.086003,43.520752],[-6.087688,43.521794],[-6.088551,43.522488],[-6.090424,43.524651],[-6.091438,43.525547],[-6.093324,43.526649],[-6.095426,43.527503],[-6.09757,43.52874],[-6.09887,43.530031],[-6.100254,43.532044],[-6.100888,43.5328],[-6.102477,43.534178],[-6.10442,43.535289],[-6.106611,43.536122],[-6.108171,43.53653],[-6.114448,43.537783],[-6.121282,43.5392],[-6.123073,43.539451],[-6.125964,43.540299],[-6.127987,43.541077],[-6.132814,43.543634],[-6.134521,43.544224],[-6.135987,43.544538],[-6.138206,43.544665],[-6.139977,43.544508],[-6.141441,43.544218],[-6.144674,43.543078],[-6.146534,43.542624],[-6.148087,43.542449],[-6.150231,43.542478],[-6.152644,43.542815],[-6.156177,43.544015],[-6.157385,43.544693],[-6.161721,43.547841],[-6.164742,43.550122],[-6.167269,43.552176],[-6.168529,43.553306],[-6.17044,43.555609],[-6.170278,43.556858],[-6.169845,43.556929],[-6.169958,43.557404],[-6.170596,43.557404],[-6.170635,43.556429],[-6.1712,43.556238],[-6.172508,43.556891],[-6.175193,43.557781],[-6.17667,43.558165],[-6.178067,43.558369],[-6.180356,43.558491],[-6.182652,43.558243],[-6.184036,43.557906],[-6.185869,43.557232],[-6.187562,43.556396],[-6.189112,43.555788],[-6.190741,43.555382],[-6.192211,43.555187],[-6.194289,43.555195],[-6.196094,43.555435],[-6.202428,43.556577],[-6.20446,43.557006],[-6.205949,43.557579],[-6.207756,43.558716],[-6.215898,43.566131],[-6.218142,43.567527],[-6.219412,43.56806],[-6.221012,43.568484],[-6.222461,43.56864],[-6.223935,43.568623],[-6.226629,43.568127],[-6.229492,43.566761],[-6.231628,43.566013],[-6.23364,43.565929],[-6.235875,43.566239],[-6.237995,43.566256],[-6.23941,43.565982],[-6.24111,43.565459],[-6.244338,43.564939],[-6.245461,43.564547],[-6.248373,43.562916],[-6.250161,43.562263],[-6.251516,43.562102],[-6.252793,43.562142],[-6.256788,43.56269],[-6.258386,43.562849],[-6.259606,43.56279],[-6.260759,43.562569],[-6.261874,43.562178],[-6.264052,43.561139],[-6.265742,43.560488],[-6.267708,43.560118],[-6.271038,43.560048],[-6.273287,43.55969],[-6.277079,43.558397],[-6.279126,43.558019],[-6.281802,43.557743],[-6.282642,43.5575],[-6.2839,43.55688],[-6.285393,43.555808],[-6.286618,43.555228],[-6.287738,43.554964],[-6.290746,43.554744],[-6.292208,43.55457],[-6.293557,43.554133],[-6.294712,43.553488],[-6.297653,43.551534],[-6.299195,43.551066],[-6.300018,43.550956],[-6.301738,43.551011],[-6.3073,43.5516],[-6.308474,43.551623],[-6.310172,43.551358],[-6.312495,43.550449],[-6.314443,43.550012],[-6.318266,43.550026],[-6.323778,43.549403],[-6.326413,43.549266],[-6.327835,43.549057],[-6.329124,43.548582],[-6.331085,43.547326],[-6.332301,43.546736],[-6.338281,43.544689],[-6.339401,43.544438],[-6.340816,43.544356],[-6.344353,43.544782],[-6.347924,43.54482],[-6.352488,43.544808],[-6.35451,43.544289],[-6.355779,43.54356],[-6.35835,43.541672],[-6.360417,43.540952],[-6.362234,43.54086],[-6.363918,43.541173],[-6.366275,43.542034],[-6.36797,43.542315],[-6.369423,43.542245],[-6.372829,43.541692],[-6.37515,43.541446],[-6.378782,43.541279],[-6.380219,43.541075],[-6.381339,43.540708],[-6.383434,43.539718],[-6.385893,43.538958],[-6.388065,43.538743],[-6.389414,43.538912],[-6.390701,43.539282],[-6.39187,43.539851],[-6.393829,43.541496],[-6.394901,43.542056],[-6.39608,43.542444],[-6.397556,43.542669],[-6.399493,43.542581],[-6.401725,43.541981],[-6.40358,43.541653],[-6.408868,43.541268],[-6.410564,43.541291],[-6.412828,43.541567],[-6.415398,43.541503],[-6.417053,43.541148],[-6.419127,43.540487],[-6.42108,43.54016],[-6.42224,43.540125],[-6.423929,43.54027],[-6.425287,43.540582],[-6.426556,43.541064],[-6.433514,43.544386],[-6.435279,43.544971],[-6.437453,43.545307],[-6.442502,43.545395],[-6.444373,43.545584],[-6.448235,43.54619],[-6.450422,43.546328],[-6.454244,43.546302],[-6.45564,43.546481],[-6.457565,43.546944],[-6.460169,43.547961],[-6.462037,43.548319],[-6.464625,43.548353],[-6.466397,43.548039],[-6.467699,43.54759],[-6.469345,43.546693],[-6.470153,43.546083],[-6.473026,43.543388],[-6.476246,43.540168],[-6.477418,43.539201],[-6.478467,43.538542],[-6.484484,43.535282],[-6.486546,43.534556],[-6.487953,43.53435],[-6.489117,43.534336],[-6.490529,43.534502],[-6.492996,43.535105],[-6.494161,43.535248],[-6.495654,43.535241],[-6.500015,43.534953],[-6.502607,43.534519],[-6.512165,43.532138],[-6.513913,43.531796],[-6.519614,43.531174],[-6.521075,43.530883],[-6.523021,43.530232],[-6.524776,43.529359],[-6.530257,43.52582],[-6.531546,43.525229],[-6.533558,43.524774],[-6.53591,43.524775],[-6.544093,43.525843],[-6.545275,43.526074],[-6.550286,43.527346],[-6.553593,43.528121],[-6.555111,43.528403],[-6.557565,43.528609],[-6.559024,43.52883],[-6.561195,43.529317],[-6.562804,43.529509],[-6.565342,43.529442],[-6.568119,43.529049],[-6.571246,43.528835],[-6.573849,43.528933],[-6.576544,43.529316],[-6.57878,43.529868],[-6.581699,43.530927],[-6.583672,43.53191],[-6.58637,43.533672],[-6.588688,43.534787],[-6.591149,43.535372],[-6.593252,43.535503],[-6.597754,43.535244],[-6.599211,43.535323],[-6.601157,43.535638],[-6.604528,43.536931],[-6.607797,43.538578],[-6.610546,43.539497],[-6.614986,43.540293],[-6.618016,43.541372],[-6.620415,43.541925],[-6.622359,43.542111],[-6.625419,43.541706],[-6.627227,43.541324],[-6.6287,43.54089],[-6.632274,43.539545],[-6.634296,43.538981],[-6.636698,43.53858],[-6.641131,43.538116],[-6.643698,43.537684],[-6.647146,43.536861],[-6.650682,43.535805],[-6.655766,43.533854],[-6.658687,43.53326],[-6.660249,43.533183],[-6.661828,43.533287],[-6.665529,43.533854],[-6.667771,43.534067],[-6.669996,43.534081],[-6.673252,43.533862],[-6.676797,43.533465],[-6.680223,43.533483],[-6.683159,43.533678],[-6.684584,43.53366],[-6.686277,43.53344],[-6.689379,43.53286],[-6.692939,43.53253],[-6.695072,43.532575],[-6.698471,43.532923],[-6.700597,43.53294],[-6.703176,43.532664],[-6.7054,43.532083],[-6.706456,43.531666],[-6.70959,43.530219],[-6.711505,43.529559],[-6.713435,43.529065],[-6.716238,43.528612],[-6.717697,43.528497],[-6.721039,43.528542],[-6.722505,43.528754],[-6.725355,43.529382],[-6.727539,43.530101],[-6.730344,43.531346],[-6.732137,43.532024],[-6.735404,43.532735],[-6.738823,43.532903],[-6.741294,43.533294],[-6.74258,43.533665],[-6.746946,43.535455],[-6.75498,43.53867],[-6.756562,43.539236],[-6.758525,43.539755],[-6.761236,43.540177],[-6.766544,43.540616],[-6.768377,43.540582],[-6.770674,43.540222],[-6.773223,43.539632],[-6.775431,43.539283],[-6.77837,43.539188],[-6.779678,43.539278],[-6.781805,43.539585],[-6.783614,43.53998],[-6.7904,43.541834],[-6.792995,43.542512],[-6.796639,43.543657],[-6.799435,43.544345],[-6.801688,43.54464],[-6.803364,43.544729],[-6.806956,43.54461],[-6.812665,43.543538],[-6.816186,43.543278],[-6.820647,43.543375],[-6.824194,43.543316],[-6.828317,43.54307],[-6.832736,43.542585],[-6.834325,43.542484],[-6.836567,43.542481],[-6.838192,43.542605],[-6.84011,43.54288],[-6.842615,43.543403],[-6.844393,43.543947],[-6.846341,43.544701],[-6.849716,43.546355],[-6.851662,43.547077],[-6.854603,43.547736],[-6.860618,43.548016],[-6.864508,43.548003],[-6.866905,43.547727],[-6.87043,43.54691],[-6.871955,43.546745],[-6.875448,43.546541],[-6.88145,43.546121],[-6.883472,43.545761],[-6.886909,43.544874],[-6.889189,43.544444],[-6.892396,43.544112],[-6.893811,43.544071],[-6.896388,43.544147],[-6.899742,43.54459],[-6.905972,43.546028],[-6.907962,43.546335],[-6.911957,43.546752],[-6.913875,43.547148],[-6.914661,43.547688],[-6.915402,43.549431],[-6.916049,43.55136],[-6.919408,43.55512],[-6.920273,43.55571],[-6.922563,43.556592],[-6.923892,43.557704],[-6.924177,43.558227],[-6.924246,43.559172],[-6.923956,43.559551],[-6.924204,43.560158],[-6.924152,43.561357],[-6.923713,43.562642],[-6.922979,43.563104],[-6.923419,43.563399],[-6.924587,43.563153],[-6.929178,43.564102],[-6.932099,43.565687],[-6.935279,43.566881],[-6.942306,43.569184],[-6.94353,43.56898],[-6.946685,43.567287],[-6.946168,43.566597],[-6.94637,43.566126],[-6.945691,43.565868],[-6.946716,43.567204],[-6.947353,43.566167],[-6.946934,43.564995],[-6.947139,43.564171],[-6.946719,43.563443],[-6.945399,43.562091],[-6.945019,43.561092],[-6.945343,43.560094],[-6.945499,43.558887],[-6.947353,43.55695],[-6.948643,43.555011],[-6.949662,43.55396],[-6.950724,43.553299],[-6.953611,43.552302],[-6.957362,43.551193],[-6.963058,43.549126],[-6.964706,43.54859],[-6.966861,43.54803],[-6.96778,43.547656],[-6.96919,43.54645],[-6.970111,43.546028],[-6.970907,43.545965],[-6.974024,43.546215],[-6.975141,43.545936],[-6.976068,43.545305],[-6.977054,43.544247],[-6.978185,43.543591],[-6.978742,43.543451],[-6.98206,43.543072],[-6.985148,43.542094],[-6.986305,43.54199],[-6.986377,43.541665],[-6.985856,43.541125],[-6.986149,43.540759],[-6.990056,43.540457],[-6.992069,43.540408],[-6.993634,43.540534],[-6.996074,43.541184],[-6.997398,43.541693],[-6.998866,43.542528],[-7.001094,43.5435],[-7.004719,43.544519],[-7.006649,43.544902],[-7.010237,43.545204],[-7.012579,43.545173],[-7.014194,43.545051],[-7.01832,43.544376],[-7.022358,43.54348],[-7.025904,43.543097],[-7.030378,43.542958],[-7.036932,43.542942],[-7.039646,43.542874],[-7.042,43.542915],[-7.0437,43.542845],[-7.045688,43.542502],[-7.049617,43.541649],[-7.051965,43.541475],[-7.059883,43.541687],[-7.061695,43.541859],[-7.062866,43.542098],[-7.064842,43.542793],[-7.066784,43.543676],[-7.069293,43.544367],[-7.070982,43.544508],[-7.07299,43.544368],[-7.075512,43.543631],[-7.077621,43.542392],[-7.078798,43.54123],[-7.079975,43.539523],[-7.080954,43.538623],[-7.082364,43.53771],[-7.08483,43.536841],[-7.086571,43.536617],[-7.089732,43.536433],[-7.091421,43.536032],[-7.092906,43.535442],[-7.093849,43.534868],[-7.095754,43.533342],[-7.096845,43.532637],[-7.098338,43.531993],[-7.100334,43.531551],[-7.101856,43.531457],[-7.103405,43.531559],[-7.104641,43.53179],[-7.106113,43.532279],[-7.107528,43.532907],[-7.109499,43.533934],[-7.111687,43.534715],[-7.113019,43.534986],[-7.115064,43.535215],[-7.118536,43.535049],[-7.120544,43.534783],[-7.122956,43.534762],[-7.124328,43.534906],[-7.126925,43.535484],[-7.129549,43.535823],[-7.131617,43.535757],[-7.133945,43.535241],[-7.136515,43.534507],[-7.139261,43.534162],[-7.14104,43.534194],[-7.142751,43.534431],[-7.144414,43.53483],[-7.145928,43.53543],[-7.148166,43.536595],[-7.149937,43.537291],[-7.151512,43.537718],[-7.152825,43.537918],[-7.156189,43.538078],[-7.161461,43.538245],[-7.16726,43.538513],[-7.171501,43.539254],[-7.174106,43.539388],[-7.178902,43.539217],[-7.185356,43.539375],[-7.187447,43.539162],[-7.19004,43.538556],[-7.19159,43.537977],[-7.194126,43.536727],[-7.196915,43.535661],[-7.199296,43.535322],[-7.200673,43.535286],[-7.203023,43.535504],[-7.205836,43.536067],[-7.209631,43.537003],[-7.212834,43.537637],[-7.215484,43.537691],[-7.218846,43.537387],[-7.223566,43.536898],[-7.22501,43.536665],[-7.228025,43.535729],[-7.229212,43.535435],[-7.231789,43.535176],[-7.237973,43.535774],[-7.240865,43.535721],[-7.243785,43.5352],[-7.245248,43.53558],[-7.245956,43.535171],[-7.246048,43.534678],[-7.245488,43.53343],[-7.245577,43.532866],[-7.246136,43.53214],[-7.247484,43.531593],[-7.249428,43.531517],[-7.250878,43.531742],[-7.252539,43.532177],[-7.254113,43.533058],[-7.255119,43.534169],[-7.258742,43.535717],[-7.259017,43.536016],[-7.258038,43.536592],[-7.251672,43.539988],[-7.251663,43.540411],[-7.255608,43.540384],[-7.258708,43.540494],[-7.260997,43.540404],[-7.263543,43.539951],[-7.26495,43.539836],[-7.26607,43.539937],[-7.26715,43.540252],[-7.268315,43.540864],[-7.269695,43.542039],[-7.269983,43.542896],[-7.26984,43.543731],[-7.270003,43.54439],[-7.270908,43.545869],[-7.270515,43.546961],[-7.268675,43.548804],[-7.26729,43.5504],[-7.266668,43.550945],[-7.266076,43.552922],[-7.266251,43.55388],[-7.266727,43.554395],[-7.269235,43.555389],[-7.269971,43.555925],[-7.270454,43.556554],[-7.270695,43.557374],[-7.270317,43.559443],[-7.270515,43.559988],[-7.273143,43.562941],[-7.274405,43.564462],[-7.274695,43.565038],[-7.274618,43.566174],[-7.274239,43.566686],[-7.270981,43.568881],[-7.27046,43.569614],[-7.270308,43.570734],[-7.271218,43.575476],[-7.271983,43.576222],[-7.275258,43.577723],[-7.277013,43.578606],[-7.278692,43.579624],[-7.280777,43.581141],[-7.283359,43.583481],[-7.285267,43.5854],[-7.285908,43.585847],[-7.290619,43.588566],[-7.292151,43.58924],[-7.294345,43.590415],[-7.296437,43.591686],[-7.297536,43.592889],[-7.297992,43.593968],[-7.298421,43.59546],[-7.300698,43.600831],[-7.301682,43.602308],[-7.303387,43.603355],[-7.30513,43.604952],[-7.309263,43.607227],[-7.310516,43.608104],[-7.310976,43.609704],[-7.31132,43.610172],[-7.315988,43.613642],[-7.31662,43.614055],[-7.322754,43.618575],[-7.326184,43.621281],[-7.327807,43.622328],[-7.333802,43.62688],[-7.335175,43.62799],[-7.338433,43.630471],[-7.339357,43.631999],[-7.339716,43.634087],[-7.340342,43.635479],[-7.34191,43.637482],[-7.342962,43.638317],[-7.344978,43.639487],[-7.346529,43.640722],[-7.348116,43.641684],[-7.351454,43.643282],[-7.353053,43.644588],[-7.35597,43.647237],[-7.35716,43.648175],[-7.361003,43.651601],[-7.362666,43.652859],[-7.365783,43.654898],[-7.366816,43.655677],[-7.36719,43.6564],[-7.36697,43.657584],[-7.366998,43.658685],[-7.367546,43.659568],[-7.368531,43.660125],[-7.37005,43.66073],[-7.371181,43.661579],[-7.371968,43.663564],[-7.372957,43.66522],[-7.375681,43.668404],[-7.375881,43.670209],[-7.376319,43.671032],[-7.377008,43.671756],[-7.378264,43.672614],[-7.379613,43.673081],[-7.381133,43.673196],[-7.383042,43.67306],[-7.384351,43.673349],[-7.385839,43.674142],[-7.387549,43.674476],[-7.39121,43.673762],[-7.394326,43.672902],[-7.396677,43.672406],[-7.397592,43.672376],[-7.399739,43.672826],[-7.400442,43.672773],[-7.402345,43.672136],[-7.403137,43.67215],[-7.405609,43.672804],[-7.407255,43.672725],[-7.408439,43.672815],[-7.410382,43.673331],[-7.413423,43.67342],[-7.418544,43.674315],[-7.424172,43.675482],[-7.42466,43.675755],[-7.425457,43.675757],[-7.431046,43.676833],[-7.431863,43.676902],[-7.434198,43.676813],[-7.435069,43.676884],[-7.437601,43.677494],[-7.440231,43.678527],[-7.441888,43.679539],[-7.44266,43.68017],[-7.443602,43.680623],[-7.445733,43.681182],[-7.4489,43.682716],[-7.45302,43.683799],[-7.45701,43.684445],[-7.458328,43.684796],[-7.45909,43.68516],[-7.460758,43.686433],[-7.462711,43.686831],[-7.468107,43.68646],[-7.470255,43.68678],[-7.47235,43.686774],[-7.474554,43.685996],[-7.476159,43.6859],[-7.477611,43.684952],[-7.478544,43.684603],[-7.481781,43.684834],[-7.482839,43.684511],[-7.483864,43.683591],[-7.484995,43.683079],[-7.486186,43.683037],[-7.487756,43.683295],[-7.488929,43.683087],[-7.492536,43.681692],[-7.494034,43.681327],[-7.495324,43.68148],[-7.49957,43.682482],[-7.502224,43.683169],[-7.504147,43.683547],[-7.507402,43.684028],[-7.509669,43.684544],[-7.512228,43.684962],[-7.51444,43.684851],[-7.515908,43.684055],[-7.516639,43.68382],[-7.517708,43.684132],[-7.519336,43.685213],[-7.519993,43.685443],[-7.521933,43.685288],[-7.526187,43.685863],[-7.527289,43.686164],[-7.528203,43.686674],[-7.529315,43.68682],[-7.533549,43.686686],[-7.541874,43.686697],[-7.543997,43.686478],[-7.54701,43.687792],[-7.547925,43.688104],[-7.548644,43.688128],[-7.552006,43.687779],[-7.552722,43.687575],[-7.553541,43.686234],[-7.554701,43.685799],[-7.55689,43.686251],[-7.558469,43.686375],[-7.559412,43.686264],[-7.560892,43.685628],[-7.562231,43.684861],[-7.563252,43.684668],[-7.564244,43.68493],[-7.566681,43.684782],[-7.568715,43.685193],[-7.570813,43.685475],[-7.571933,43.685369],[-7.57337,43.684773],[-7.574274,43.684596],[-7.577342,43.685286],[-7.57812,43.685352],[-7.579669,43.684943],[-7.580459,43.684932],[-7.583305,43.685425],[-7.584841,43.685439],[-7.585997,43.685149],[-7.586738,43.684483],[-7.588892,43.683694],[-7.590237,43.682879],[-7.590349,43.681758],[-7.588793,43.680744],[-7.588158,43.679625],[-7.586911,43.678644],[-7.585175,43.676455],[-7.585269,43.675127],[-7.586402,43.674781],[-7.588469,43.675248],[-7.5906,43.675151],[-7.592739,43.674888],[-7.593217,43.67456],[-7.594149,43.671956],[-7.593976,43.669783],[-7.593337,43.668627],[-7.593341,43.66816],[-7.594261,43.665752],[-7.594623,43.664468],[-7.594937,43.663921],[-7.595792,43.663308],[-7.596471,43.662442],[-7.600074,43.663736],[-7.601391,43.664412],[-7.601702,43.664803],[-7.601498,43.667494],[-7.60179,43.668354],[-7.602251,43.668598],[-7.605668,43.669171],[-7.60908,43.66963],[-7.609852,43.670078],[-7.611839,43.671616],[-7.612514,43.672486],[-7.613525,43.673166],[-7.614674,43.674538],[-7.615144,43.675554],[-7.615239,43.676257],[-7.614869,43.677433],[-7.61488,43.678567],[-7.615274,43.6808],[-7.615334,43.681805],[-7.615154,43.68549],[-7.615356,43.686332],[-7.616326,43.686823],[-7.617112,43.686777],[-7.618622,43.686381],[-7.620147,43.68622],[-7.620945,43.686526],[-7.621573,43.687284],[-7.62188,43.688164],[-7.622612,43.6888],[-7.624678,43.689587],[-7.625685,43.69045],[-7.627715,43.691094],[-7.629471,43.691364],[-7.630494,43.691767],[-7.634469,43.694364],[-7.635136,43.695171],[-7.63522,43.695685],[-7.634683,43.696609],[-7.631856,43.700354],[-7.630574,43.702238],[-7.630124,43.703064],[-7.628486,43.70694],[-7.626774,43.710842],[-7.626501,43.711918],[-7.62642,43.713931],[-7.626926,43.715039],[-7.628159,43.716022],[-7.628795,43.716913],[-7.629515,43.718893],[-7.630958,43.721102],[-7.633191,43.724756],[-7.633507,43.726431],[-7.632842,43.72834],[-7.632953,43.729224],[-7.634006,43.729939],[-7.635923,43.73014],[-7.636731,43.730419],[-7.639644,43.732257],[-7.641082,43.73278],[-7.64339,43.732915],[-7.64429,43.732709],[-7.647688,43.731305],[-7.648367,43.730851],[-7.648823,43.729893],[-7.649274,43.72939],[-7.650024,43.729226],[-7.652464,43.730031],[-7.654092,43.730369],[-7.655137,43.730925],[-7.655229,43.731476],[-7.654551,43.732859],[-7.654626,43.733408],[-7.655564,43.733705],[-7.659133,43.73249],[-7.660605,43.731811],[-7.66667,43.732372],[-7.668167,43.732663],[-7.67073,43.732546],[-7.672808,43.733013],[-7.675907,43.732207],[-7.678608,43.72988],[-7.680022,43.729121],[-7.681244,43.728976],[-7.683746,43.728975],[-7.686497,43.72854],[-7.688187,43.728391],[-7.689192,43.728525],[-7.690301,43.729031],[-7.69162,43.730009],[-7.693533,43.730891],[-7.694865,43.731845],[-7.695699,43.732151],[-7.696935,43.732148],[-7.70075,43.731265],[-7.701877,43.731271],[-7.702412,43.731605],[-7.702545,43.732345],[-7.701958,43.733055],[-7.70193,43.734369],[-7.703176,43.735029],[-7.703497,43.735998],[-7.704117,43.736794],[-7.702259,43.737209],[-7.701618,43.737675],[-7.701889,43.738249],[-7.70118,43.738924],[-7.701614,43.739833],[-7.702751,43.739135],[-7.703718,43.737913],[-7.706394,43.736626],[-7.706675,43.737338],[-7.706661,43.736286],[-7.707528,43.734493],[-7.708396,43.732994],[-7.708607,43.731982],[-7.708096,43.729733],[-7.708699,43.728173],[-7.709358,43.727513],[-7.710897,43.726787],[-7.714342,43.725831],[-7.715756,43.725909],[-7.716229,43.726396],[-7.716235,43.727365],[-7.716845,43.728025],[-7.719132,43.729265],[-7.72044,43.729175],[-7.723091,43.727892],[-7.723992,43.727875],[-7.726405,43.729136],[-7.726997,43.730724],[-7.727775,43.73102],[-7.729352,43.730763],[-7.730338,43.731094],[-7.73096,43.731747],[-7.732878,43.73217],[-7.734074,43.731949],[-7.737501,43.730215],[-7.741335,43.728347],[-7.742341,43.727657],[-7.743139,43.726498],[-7.744013,43.725965],[-7.746207,43.725314],[-7.747835,43.725009],[-7.750008,43.724282],[-7.752585,43.723139],[-7.755516,43.722605],[-7.756292,43.722561],[-7.757807,43.722791],[-7.758633,43.722728],[-7.759889,43.72204],[-7.762447,43.720472],[-7.763064,43.71986],[-7.763504,43.718875],[-7.765524,43.717155],[-7.76696,43.716517],[-7.76848,43.715286],[-7.76925,43.713872],[-7.770485,43.713452],[-7.772805,43.713459],[-7.776269,43.714201],[-7.777042,43.7141],[-7.777926,43.713579],[-7.778655,43.713427],[-7.781147,43.713764],[-7.783101,43.714427],[-7.783951,43.714395],[-7.785384,43.713813],[-7.787357,43.713693],[-7.787933,43.71396],[-7.788747,43.714807],[-7.78952,43.715202],[-7.790248,43.715236],[-7.791094,43.714932],[-7.79353,43.712603],[-7.793939,43.711727],[-7.794769,43.711055],[-7.795659,43.711025],[-7.796729,43.711614],[-7.797487,43.711693],[-7.798907,43.710759],[-7.800193,43.710736],[-7.801352,43.710918],[-7.80212,43.710782],[-7.803283,43.709975],[-7.80529,43.708923],[-7.806712,43.707632],[-7.808047,43.706844],[-7.807456,43.705418],[-7.806097,43.704964],[-7.806557,43.703737],[-7.806679,43.702919],[-7.806147,43.700624],[-7.805314,43.699187],[-7.804828,43.69805],[-7.804795,43.696248],[-7.805207,43.695097],[-7.805727,43.69434],[-7.806591,43.693521],[-7.80793,43.692722],[-7.809418,43.692222],[-7.810797,43.691978],[-7.812657,43.691925],[-7.813882,43.692044],[-7.815327,43.692006],[-7.817611,43.691463],[-7.818637,43.69093],[-7.819656,43.690091],[-7.82048,43.688858],[-7.820757,43.687956],[-7.820886,43.685445],[-7.820807,43.682568],[-7.821375,43.681128],[-7.822598,43.679869],[-7.825175,43.678503],[-7.826592,43.67762],[-7.829865,43.675737],[-7.831421,43.674269],[-7.831946,43.673263],[-7.832162,43.672448],[-7.83219,43.67103],[-7.831928,43.664581],[-7.832119,43.662787],[-7.832501,43.6616],[-7.833638,43.659809],[-7.834388,43.659063],[-7.835958,43.658083],[-7.837149,43.657597],[-7.841725,43.656493],[-7.84572,43.655742],[-7.846497,43.655755],[-7.846448,43.6568],[-7.845686,43.658301],[-7.845145,43.658521],[-7.845316,43.658917],[-7.84419,43.66108],[-7.843877,43.661884],[-7.843943,43.662725],[-7.845213,43.665266],[-7.845837,43.665057],[-7.847825,43.664869],[-7.848536,43.664978],[-7.851835,43.666046],[-7.852476,43.666012],[-7.855806,43.664663],[-7.861755,43.662087],[-7.865142,43.660687],[-7.866014,43.660596],[-7.868215,43.661],[-7.870274,43.661087],[-7.872363,43.660833],[-7.879227,43.660632],[-7.884312,43.660585],[-7.885582,43.660672],[-7.887612,43.660396],[-7.888766,43.660626],[-7.889308,43.66105],[-7.889849,43.662197],[-7.890158,43.66445],[-7.890018,43.665734],[-7.89061,43.666375],[-7.891683,43.666197],[-7.892953,43.66547],[-7.894598,43.665463],[-7.897413,43.666143],[-7.901106,43.667556],[-7.903283,43.669542],[-7.905107,43.670298],[-7.905993,43.670178],[-7.906849,43.669142],[-7.907082,43.669207],[-7.907705,43.670883],[-7.90768,43.671383],[-7.907109,43.672209],[-7.904992,43.672692],[-7.9036,43.673558],[-7.902747,43.674322],[-7.90022,43.677078],[-7.899877,43.677861],[-7.899877,43.68114],[-7.899362,43.681678],[-7.898271,43.682241],[-7.895798,43.683262],[-7.894816,43.68452],[-7.893004,43.689296],[-7.892604,43.69019],[-7.890437,43.691401],[-7.88926,43.691447],[-7.888776,43.692218],[-7.888275,43.692583],[-7.885908,43.692845],[-7.88487,43.693246],[-7.883858,43.694651],[-7.882787,43.695168],[-7.881067,43.696342],[-7.880734,43.697867],[-7.881044,43.69852],[-7.883181,43.699928],[-7.884298,43.700456],[-7.884389,43.700854],[-7.883486,43.701433],[-7.881967,43.7018],[-7.880555,43.701774],[-7.87919,43.702198],[-7.877965,43.702783],[-7.877242,43.703739],[-7.877274,43.704257],[-7.878175,43.705566],[-7.878838,43.706242],[-7.879235,43.70701],[-7.878197,43.709805],[-7.878065,43.711886],[-7.879493,43.713665],[-7.879559,43.714277],[-7.879185,43.715756],[-7.879109,43.716806],[-7.879751,43.71792],[-7.879556,43.719826],[-7.879561,43.720925],[-7.879772,43.722478],[-7.879372,43.723516],[-7.879542,43.724123],[-7.879143,43.724951],[-7.879178,43.726203],[-7.878938,43.726828],[-7.877953,43.72815],[-7.877722,43.72884],[-7.878197,43.730965],[-7.878348,43.731164],[-7.880165,43.731599],[-7.881285,43.732053],[-7.883745,43.731934],[-7.883903,43.733015],[-7.888552,43.733767],[-7.889236,43.733937],[-7.89165,43.735197],[-7.893302,43.735941],[-7.893011,43.735476],[-7.891505,43.733982],[-7.891648,43.733099],[-7.892616,43.732709],[-7.895977,43.731702],[-7.898198,43.731196],[-7.899449,43.731024],[-7.900757,43.730529],[-7.902955,43.729285],[-7.904055,43.728984],[-7.904735,43.729016],[-7.906409,43.729794],[-7.907982,43.731294],[-7.908211,43.731904],[-7.907862,43.732613],[-7.908938,43.73179],[-7.91085,43.731592],[-7.909805,43.731896],[-7.909596,43.73266],[-7.910338,43.732906],[-7.911645,43.733942],[-7.913117,43.733669],[-7.915076,43.733517],[-7.916368,43.733175],[-7.917222,43.732634],[-7.91823,43.731585],[-7.918753,43.731276],[-7.919702,43.731165],[-7.920907,43.731272],[-7.921804,43.731172],[-7.923763,43.731607],[-7.925592,43.731637],[-7.924287,43.732915],[-7.924031,43.733361],[-7.924634,43.733886],[-7.924947,43.734523],[-7.925687,43.735145],[-7.927059,43.7351],[-7.928853,43.734318],[-7.929413,43.733811],[-7.931192,43.731468],[-7.934445,43.728761],[-7.935089,43.728323],[-7.940185,43.725333],[-7.94165,43.724381],[-7.944297,43.722813],[-7.947269,43.720902],[-7.951874,43.717778],[-7.956095,43.712237],[-7.95757,43.711075],[-7.95889,43.710181],[-7.961839,43.709053],[-7.962425,43.708585],[-7.962873,43.707409],[-7.96353,43.706781],[-7.964604,43.707195],[-7.964765,43.707586],[-7.964448,43.708193],[-7.964364,43.709355],[-7.965933,43.70894],[-7.966253,43.708996],[-7.970716,43.710924],[-7.971393,43.711136],[-7.97203,43.710898],[-7.974314,43.70949],[-7.975133,43.708889],[-7.975815,43.708124],[-7.975938,43.707239],[-7.976824,43.706129],[-7.975776,43.705423],[-7.975627,43.704185],[-7.975853,43.702733],[-7.978589,43.701166],[-7.979497,43.700289],[-7.981537,43.699903],[-7.982677,43.699469],[-7.983559,43.698942],[-7.984688,43.698753],[-7.985057,43.699079],[-7.986287,43.699398],[-7.987255,43.69933],[-7.988871,43.698497],[-7.989474,43.698525],[-7.989486,43.699745],[-7.989333,43.701441],[-7.990194,43.701966],[-7.991004,43.701736],[-7.992437,43.699874],[-7.99272,43.698607],[-7.99719,43.694631],[-7.997677,43.694399],[-8.004789,43.692711],[-8.004967,43.692545],[-8.007273,43.688898],[-8.008285,43.688121],[-8.008369,43.687069],[-8.008653,43.68631],[-8.009614,43.685096],[-8.009161,43.684184],[-8.009122,43.683378],[-8.009668,43.681956],[-8.010606,43.681414],[-8.012937,43.681044],[-8.014529,43.680266],[-8.014915,43.679935],[-8.014633,43.678304],[-8.01478,43.677892],[-8.015622,43.677336],[-8.017391,43.676928],[-8.018058,43.676604],[-8.019034,43.675435],[-8.018099,43.675395],[-8.0178,43.674904],[-8.01877,43.674751],[-8.01995,43.674302],[-8.021148,43.673255],[-8.022411,43.67285],[-8.023565,43.672709],[-8.023932,43.673442],[-8.026185,43.672362],[-8.033267,43.670732],[-8.034008,43.670753],[-8.036202,43.672401],[-8.036595,43.672116],[-8.036935,43.66999],[-8.03768,43.669563],[-8.037892,43.66889],[-8.039362,43.668197],[-8.040739,43.668031],[-8.041848,43.66751],[-8.042751,43.666778],[-8.043963,43.665428],[-8.044482,43.665203],[-8.046894,43.665059],[-8.051156,43.66358],[-8.052427,43.662634],[-8.053855,43.661202],[-8.053894,43.660756],[-8.051768,43.659001],[-8.050022,43.657699],[-8.048683,43.656412],[-8.045367,43.65364],[-8.044454,43.652799],[-8.043669,43.65161],[-8.043652,43.651144],[-8.044503,43.650742],[-8.045188,43.649951],[-8.045287,43.648103],[-8.045875,43.647598],[-8.048655,43.646588],[-8.049474,43.645543],[-8.051411,43.644298],[-8.051657,43.643979],[-8.051146,43.643519],[-8.049375,43.642834],[-8.048579,43.642741],[-8.047077,43.642859],[-8.04508,43.642278],[-8.044506,43.641922],[-8.043878,43.640881],[-8.044206,43.639715],[-8.045537,43.638856],[-8.047138,43.638593],[-8.050629,43.63823],[-8.0517,43.637489],[-8.05188,43.636763],[-8.051434,43.63653],[-8.049779,43.636526],[-8.048635,43.636092],[-8.04882,43.635771],[-8.048304,43.635418],[-8.048399,43.634969],[-8.049647,43.633345],[-8.050576,43.632573],[-8.052164,43.632216],[-8.053135,43.631815],[-8.054045,43.631896],[-8.054942,43.631738],[-8.05689,43.631858],[-8.058237,43.632205],[-8.060142,43.633073],[-8.061313,43.633945],[-8.063227,43.634397],[-8.066347,43.634853],[-8.067095,43.635326],[-8.068118,43.635566],[-8.069167,43.636035],[-8.073167,43.637252],[-8.073683,43.637651],[-8.074803,43.639323],[-8.07584,43.640021],[-8.076766,43.639842],[-8.078279,43.638188],[-8.07942,43.636148],[-8.08067,43.634814],[-8.081382,43.63463],[-8.082305,43.634951],[-8.082993,43.63571],[-8.084571,43.636201],[-8.085879,43.63717],[-8.087221,43.637469],[-8.089373,43.638474],[-8.090232,43.63928],[-8.090746,43.640998],[-8.092427,43.643012],[-8.093353,43.643335],[-8.094484,43.643341],[-8.095178,43.643108],[-8.098964,43.640778],[-8.09937,43.64036],[-8.099836,43.638005],[-8.100319,43.637157],[-8.100419,43.636329],[-8.100186,43.634601],[-8.100388,43.633883],[-8.101031,43.632942],[-8.102682,43.63158],[-8.104394,43.63088],[-8.105383,43.630307],[-8.106352,43.629381],[-8.106994,43.627862],[-8.108482,43.626295],[-8.109687,43.62484],[-8.111287,43.622561],[-8.112746,43.621166],[-8.113684,43.620859],[-8.114428,43.621003],[-8.115088,43.621651],[-8.115847,43.623989],[-8.116898,43.625691],[-8.11766,43.626216],[-8.118264,43.6262],[-8.119733,43.62538],[-8.121577,43.624719],[-8.122614,43.624994],[-8.12385,43.624818],[-8.124741,43.624291],[-8.125541,43.624208],[-8.126485,43.624625],[-8.126901,43.625718],[-8.127487,43.626768],[-8.128812,43.6281],[-8.129514,43.628295],[-8.130368,43.62775],[-8.130683,43.625711],[-8.130474,43.623951],[-8.13096,43.623077],[-8.133349,43.621461],[-8.134146,43.620761],[-8.13412,43.61973],[-8.13302,43.618361],[-8.132821,43.617885],[-8.133597,43.61699],[-8.133977,43.616233],[-8.134722,43.615914],[-8.137944,43.615603],[-8.138686,43.615443],[-8.140156,43.6146],[-8.141514,43.612192],[-8.141646,43.611698],[-8.14114,43.609486],[-8.141198,43.608979],[-8.141675,43.608289],[-8.142695,43.607804],[-8.143464,43.607138],[-8.145016,43.604463],[-8.145788,43.603275],[-8.15016,43.595726],[-8.150777,43.594501],[-8.152427,43.590351],[-8.154535,43.585277],[-8.155136,43.583982],[-8.156114,43.580913],[-8.156841,43.579134],[-8.158358,43.577941],[-8.15912,43.576902],[-8.162691,43.5705],[-8.163316,43.569291],[-8.168495,43.560247],[-8.170581,43.556665],[-8.172165,43.553794],[-8.172939,43.552525],[-8.175664,43.547484],[-8.17617,43.546681],[-8.177704,43.543824],[-8.178655,43.541858],[-8.18509,43.527749],[-8.185955,43.527123],[-8.189639,43.525094],[-8.190232,43.525049],[-8.191773,43.524095],[-8.192319,43.523894],[-8.191611,43.522789],[-8.191473,43.521934],[-8.191685,43.520646],[-8.192843,43.518807],[-8.193327,43.517536],[-8.193372,43.516754],[-8.193181,43.513229],[-8.192647,43.505579],[-8.193197,43.50455],[-8.192735,43.50424],[-8.190917,43.504582],[-8.186632,43.504183],[-8.185253,43.503999],[-8.177246,43.50278],[-8.175174,43.50228],[-8.17354,43.501783],[-8.171839,43.501126],[-8.16593,43.498624],[-8.16287,43.497364],[-8.16129,43.496571],[-8.160067,43.495827],[-8.158467,43.494472],[-8.157617,43.49348],[-8.156744,43.491868],[-8.157475,43.48265],[-8.157757,43.482347],[-8.158253,43.480983],[-8.158639,43.479492],[-8.158576,43.477472],[-8.157411,43.474465],[-8.156834,43.471888],[-8.156898,43.46962],[-8.157297,43.467825],[-8.157798,43.46649],[-8.158577,43.464916],[-8.160024,43.462828],[-8.161367,43.461279],[-8.162427,43.460234],[-8.164314,43.458734],[-8.166799,43.457175],[-8.168684,43.455863],[-8.169658,43.454926],[-8.170485,43.453443],[-8.171184,43.450938],[-8.171994,43.449118],[-8.172548,43.448162],[-8.173082,43.446773],[-8.173233,43.445095],[-8.172859,43.443413],[-8.172179,43.442167],[-8.171237,43.440995],[-8.169661,43.439763],[-8.167983,43.438946],[-8.166919,43.43859],[-8.164163,43.43792],[-8.16224,43.437068],[-8.160909,43.43632],[-8.160107,43.435702],[-8.158719,43.433867],[-8.157421,43.431653],[-8.150594,43.424476],[-8.150498,43.422446],[-8.150915,43.420724],[-8.151487,43.419414],[-8.152369,43.418033],[-8.153974,43.416163],[-8.155831,43.414512],[-8.157034,43.413223],[-8.157926,43.411979],[-8.158707,43.410541],[-8.159304,43.408846],[-8.159882,43.406475],[-8.160307,43.40545],[-8.161214,43.403801],[-8.161933,43.401445],[-8.162126,43.39948],[-8.162611,43.39807],[-8.163207,43.397233],[-8.164012,43.396469],[-8.165061,43.395764],[-8.166167,43.395281],[-8.168179,43.394801],[-8.175033,43.393418],[-8.175693,43.393008],[-8.17683,43.39178],[-8.17753,43.39014],[-8.177746,43.388407],[-8.17768,43.386285],[-8.177837,43.385221],[-8.178653,43.383084],[-8.179515,43.381809],[-8.181753,43.379398],[-8.182577,43.378396],[-8.184433,43.375732],[-8.185238,43.375024],[-8.18746,43.374224],[-8.188655,43.373175],[-8.189568,43.372005],[-8.190575,43.371418],[-8.192159,43.370234],[-8.194526,43.367703],[-8.196525,43.366058],[-8.200143,43.364017],[-8.201019,43.363257],[-8.201827,43.361967],[-8.202192,43.360947],[-8.202287,43.360114],[-8.202218,43.358425],[-8.202722,43.356048],[-8.202697,43.354499],[-8.202462,43.353647],[-8.201455,43.351944],[-8.200972,43.350322],[-8.201004,43.348899],[-8.201576,43.347424],[-8.202431,43.345996],[-8.202808,43.345097],[-8.202966,43.3438],[-8.202547,43.342318],[-8.201671,43.341063],[-8.199374,43.339235],[-8.198033,43.337621],[-8.197627,43.336135],[-8.197717,43.334781],[-8.198436,43.333229],[-8.200265,43.331306],[-8.201888,43.329091],[-8.202587,43.326957],[-8.203203,43.325653],[-8.204005,43.324642],[-8.204986,43.323773],[-8.205939,43.323175],[-8.207829,43.322398],[-8.209311,43.321998],[-8.211114,43.321813],[-8.213484,43.321713],[-8.214666,43.321473],[-8.216733,43.320674],[-8.218115,43.31962],[-8.218856,43.318675],[-8.21937,43.317609],[-8.220021,43.314606],[-8.220355,43.313779],[-8.224312,43.306026],[-8.225002,43.304601],[-8.226086,43.303251],[-8.227868,43.302089],[-8.229791,43.301465],[-8.232374,43.30128],[-8.235149,43.301465],[-8.237437,43.301361],[-8.239056,43.301146],[-8.241438,43.300698],[-8.243434,43.300523],[-8.245759,43.300765],[-8.24793,43.301351],[-8.249939,43.301567],[-8.251609,43.301448],[-8.253974,43.300773],[-8.255386,43.299977],[-8.256345,43.299231],[-8.258316,43.297066],[-8.259285,43.296213],[-8.260239,43.295594],[-8.262213,43.294652],[-8.264842,43.294074],[-8.267358,43.293939],[-8.26929,43.294214],[-8.272364,43.295278],[-8.274623,43.295625],[-8.276041,43.295606],[-8.277864,43.295337],[-8.280166,43.294424],[-8.281644,43.293332],[-8.282235,43.292541],[-8.282649,43.291391],[-8.282686,43.290636],[-8.282306,43.289252],[-8.281815,43.288488],[-8.280699,43.287479],[-8.279042,43.286564],[-8.277808,43.285638],[-8.276058,43.284139],[-8.274535,43.283076],[-8.269631,43.280651],[-8.267176,43.279205],[-8.264231,43.27716],[-8.262095,43.275965],[-8.25854,43.274557],[-8.256986,43.273734],[-8.255821,43.272929],[-8.254544,43.271561],[-8.253612,43.270035],[-8.253007,43.26799],[-8.253011,43.266542],[-8.253159,43.2658],[-8.254339,43.262399],[-8.254532,43.261039],[-8.254464,43.2594],[-8.254103,43.25617],[-8.254196,43.254305],[-8.254523,43.252449],[-8.255846,43.248604],[-8.256174,43.247075],[-8.256392,43.243586],[-8.256573,43.242052],[-8.257103,43.240309],[-8.257967,43.238467],[-8.259872,43.235926],[-8.260751,43.235009],[-8.262293,43.233666],[-8.264812,43.231938],[-8.269228,43.229462],[-8.271342,43.227828],[-8.273269,43.225721],[-8.274091,43.224478],[-8.275016,43.222303],[-8.275397,43.220526],[-8.275535,43.218167],[-8.27594,43.216253],[-8.276762,43.21416],[-8.278289,43.211922],[-8.279203,43.210939],[-8.281047,43.209361],[-8.284032,43.207407],[-8.286536,43.205994],[-8.287995,43.205297],[-8.291819,43.203684],[-8.294729,43.202339],[-8.295659,43.201836],[-8.299356,43.199426],[-8.300787,43.198588],[-8.304099,43.196857],[-8.30579,43.195754],[-8.307824,43.193966],[-8.308999,43.192555],[-8.309593,43.19167],[-8.310509,43.189847],[-8.311102,43.18795],[-8.311362,43.186464],[-8.311431,43.184474],[-8.311342,43.183464],[-8.311018,43.18218],[-8.310806,43.18059],[-8.310892,43.179102],[-8.311309,43.177516],[-8.312459,43.175325],[-8.314129,43.173254],[-8.315562,43.171958],[-8.316535,43.171227],[-8.318861,43.16987],[-8.322059,43.168349],[-8.32383,43.167121],[-8.324821,43.166046],[-8.326056,43.163816],[-8.326596,43.161796],[-8.32677,43.159364],[-8.326533,43.155876],[-8.326662,43.154089],[-8.326965,43.152734],[-8.327597,43.15095],[-8.329245,43.147781],[-8.329835,43.146055],[-8.33019,43.143812],[-8.330051,43.139699],[-8.330248,43.138302],[-8.330691,43.136437],[-8.330909,43.135015],[-8.330965,43.133581],[-8.330542,43.131429],[-8.329938,43.130038],[-8.328756,43.128009],[-8.327994,43.126008],[-8.327718,43.124426],[-8.328116,43.122158],[-8.328924,43.120685],[-8.329773,43.119702],[-8.332561,43.117168],[-8.333802,43.115753],[-8.33539,43.113484],[-8.33709,43.111688],[-8.339196,43.110143],[-8.342858,43.108165],[-8.344685,43.10696],[-8.346146,43.105764],[-8.347393,43.104495],[-8.348271,43.103382],[-8.349398,43.101542],[-8.350232,43.099606],[-8.35077,43.097724],[-8.351018,43.095997],[-8.351239,43.093375],[-8.351436,43.092211],[-8.35194,43.090558],[-8.352425,43.089411],[-8.353413,43.087606],[-8.354966,43.085242],[-8.356239,43.083037],[-8.357253,43.080782],[-8.358197,43.077993],[-8.358786,43.075892],[-8.359599,43.074015],[-8.360763,43.072148],[-8.362345,43.070191],[-8.363511,43.069057],[-8.36667,43.066356],[-8.367756,43.065204],[-8.368821,43.063777],[-8.369857,43.061792],[-8.370284,43.060394],[-8.370824,43.05754],[-8.371217,43.056381],[-8.371716,43.055514],[-8.373536,43.053209],[-8.374737,43.050966],[-8.375873,43.049215],[-8.377003,43.047962],[-8.378531,43.046608],[-8.380001,43.045554],[-8.383562,43.043375],[-8.385037,43.04216],[-8.387532,43.039593],[-8.389612,43.038013],[-8.393883,43.035524],[-8.395856,43.034182],[-8.398147,43.032175],[-8.400078,43.029922],[-8.402014,43.026836],[-8.40349,43.024871],[-8.405392,43.02284],[-8.407682,43.021147],[-8.409169,43.020213],[-8.412154,43.0186],[-8.414469,43.01718],[-8.41583,43.016069],[-8.417353,43.01444],[-8.418383,43.012903],[-8.418994,43.011517],[-8.419477,43.00959],[-8.4195,43.005566],[-8.419782,43.004363],[-8.420653,43.002518],[-8.421664,43.001256],[-8.424086,42.998924],[-8.424998,42.997874],[-8.425938,42.996506],[-8.426775,42.994709],[-8.42763,42.992375],[-8.427991,42.991693],[-8.429002,42.990359],[-8.430139,42.98918],[-8.43183,42.987186],[-8.432988,42.985326],[-8.434258,42.983748],[-8.435458,42.982603],[-8.43753,42.980913],[-8.440149,42.978111],[-8.440768,42.977166],[-8.441653,42.976336],[-8.443083,42.975268],[-8.444464,42.974424],[-8.446443,42.97348],[-8.450178,42.972077],[-8.451221,42.971471],[-8.452366,42.970601],[-8.453167,42.969799],[-8.45404,42.968533],[-8.454562,42.96721],[-8.454769,42.965473],[-8.455039,42.964213],[-8.456231,42.961934],[-8.456716,42.960509],[-8.456808,42.958602],[-8.456524,42.956375],[-8.456727,42.954099],[-8.457544,42.951994],[-8.458712,42.95028],[-8.459687,42.949105],[-8.460506,42.947803],[-8.460988,42.946235],[-8.461011,42.943355],[-8.46161,42.941287],[-8.462619,42.939895],[-8.46411,42.938438],[-8.464542,42.937831],[-8.466238,42.934841],[-8.467117,42.933673],[-8.468167,42.932573],[-8.469433,42.931515],[-8.471979,42.929865],[-8.47496,42.928257],[-8.476865,42.926589],[-8.477774,42.925231],[-8.478527,42.923325],[-8.478629,42.921584],[-8.478403,42.920382],[-8.477511,42.917509],[-8.477236,42.915348],[-8.477532,42.91345],[-8.477807,42.912564],[-8.478468,42.91128],[-8.479497,42.90973],[-8.480926,42.908301],[-8.48308,42.90682],[-8.484328,42.906172],[-8.48603,42.905477],[-8.488381,42.904688],[-8.495485,42.902722],[-8.498446,42.90161],[-8.499964,42.900815],[-8.500904,42.900188],[-8.502105,42.899145],[-8.503292,42.897652],[-8.503867,42.896427],[-8.50422,42.894609],[-8.504189,42.892788],[-8.504578,42.890484],[-8.505102,42.889789],[-8.506045,42.889386],[-8.507899,42.889567],[-8.508511,42.890143],[-8.507085,42.892303],[-8.50662,42.8933],[-8.506619,42.894087],[-8.507307,42.895303],[-8.508345,42.896219],[-8.508855,42.896863],[-8.509364,42.898879],[-8.50999,42.899583],[-8.510848,42.901096],[-8.511166,42.902252],[-8.510154,42.902536],[-8.509827,42.90186],[-8.509818,42.902824],[-8.510701,42.902472],[-8.51203,42.902324],[-8.51099,42.90089],[-8.510415,42.898963],[-8.510598,42.898714],[-8.516097,42.89763],[-8.519056,42.897095],[-8.520338,42.896968],[-8.522527,42.897142],[-8.52358,42.897437],[-8.525157,42.898157],[-8.525849,42.89865],[-8.526119,42.899255],[-8.526582,42.899414],[-8.527555,42.898684],[-8.528501,42.89819],[-8.530239,42.896633],[-8.531898,42.89445],[-8.53262,42.89416],[-8.533551,42.894515],[-8.533141,42.895268],[-8.532469,42.895028],[-8.532106,42.894077],[-8.533458,42.892115],[-8.533911,42.891728],[-8.533737,42.891367],[-8.531553,42.894502],[-8.529835,42.896759],[-8.528726,42.89775],[-8.527334,42.898558],[-8.526129,42.898857],[-8.5263,42.899282],[-8.526854,42.899233],[-8.526822,42.898794],[-8.52613,42.898664],[-8.524233,42.897574],[-8.522837,42.897107],[-8.520447,42.896848],[-8.518669,42.897004],[-8.515058,42.897725],[-8.510762,42.898513],[-8.509986,42.898329],[-8.50944,42.8985],[-8.509441,42.89891],[-8.510532,42.900289],[-8.511207,42.902002],[-8.511013,42.90239],[-8.510221,42.902535],[-8.509773,42.902298],[-8.509231,42.901106],[-8.506271,42.901935],[-8.505793,42.901901],[-8.503819,42.900828],[-8.502923,42.901979],[-8.502223,42.902642],[-8.500895,42.90269],[-8.500272,42.90372],[-8.499452,42.903206],[-8.498864,42.90322],[-8.496341,42.903907],[-8.496276,42.904083],[-8.497774,42.905315],[-8.497921,42.905663],[-8.499217,42.906243],[-8.503117,42.903552],[-8.504106,42.904028],[-8.504868,42.90392],[-8.510353,42.902521],[-8.512076,42.902163],[-8.511568,42.901786],[-8.510887,42.900744],[-8.510603,42.899985],[-8.510403,42.898535],[-8.509012,42.896723],[-8.507598,42.895323],[-8.506843,42.894075],[-8.507047,42.892785],[-8.507857,42.891623],[-8.50975,42.889727],[-8.509377,42.88936],[-8.507882,42.889423],[-8.506555,42.889195],[-8.505638,42.888526],[-8.505621,42.887894],[-8.506671,42.885413],[-8.507704,42.883341],[-8.508264,42.882483],[-8.509742,42.881153],[-8.511129,42.880445],[-8.513303,42.87985],[-8.515726,42.879403],[-8.517097,42.878901],[-8.518309,42.878208],[-8.519378,42.877333],[-8.520181,42.876305],[-8.520801,42.875227],[-8.521393,42.873033],[-8.521377,42.871714],[-8.520967,42.869738],[-8.520046,42.867593],[-8.519652,42.866452],[-8.519438,42.864554],[-8.519793,42.863231],[-8.520331,42.862424],[-8.521059,42.861725],[-8.526228,42.858582],[-8.528677,42.857264],[-8.530776,42.856726],[-8.53182,42.855741],[-8.531971,42.854901],[-8.53151,42.853516],[-8.531477,42.852502],[-8.531756,42.851589],[-8.532629,42.850267],[-8.533148,42.849114],[-8.533308,42.847637],[-8.533037,42.846448],[-8.532421,42.84534],[-8.530846,42.843705],[-8.529759,42.842083],[-8.529036,42.839277],[-8.528323,42.837614],[-8.52839,42.837106],[-8.529104,42.836351],[-8.529857,42.835046],[-8.530139,42.83379],[-8.530133,42.832465],[-8.529732,42.830727],[-8.529289,42.829452],[-8.528955,42.827469],[-8.529217,42.82607],[-8.529546,42.82545],[-8.531885,42.822415],[-8.533425,42.820138],[-8.534006,42.818177],[-8.533787,42.815821],[-8.532931,42.813238],[-8.532712,42.811137],[-8.532838,42.809926],[-8.533956,42.805124],[-8.534401,42.801335],[-8.534668,42.800414],[-8.535614,42.798916],[-8.536773,42.797814],[-8.538428,42.796745],[-8.540325,42.79537],[-8.541403,42.794169],[-8.542021,42.793043],[-8.542578,42.790882],[-8.54315,42.789764],[-8.543847,42.789013],[-8.545018,42.788179],[-8.546321,42.78767],[-8.547096,42.787561],[-8.548609,42.78775],[-8.550585,42.787595],[-8.55195,42.788068],[-8.552311,42.787798],[-8.551994,42.787359],[-8.551789,42.785687],[-8.551845,42.784761],[-8.552209,42.783396],[-8.551992,42.781834],[-8.551632,42.781208],[-8.551617,42.780034],[-8.552207,42.77921],[-8.552036,42.778268],[-8.551332,42.777434],[-8.551476,42.776324],[-8.550808,42.774332],[-8.550491,42.77307],[-8.54979,42.769298],[-8.549023,42.766732],[-8.547184,42.76391],[-8.546784,42.762662],[-8.547257,42.760098],[-8.547823,42.759396],[-8.54948,42.758493],[-8.550406,42.757701],[-8.551205,42.756292],[-8.551309,42.755068],[-8.550992,42.753244],[-8.550425,42.752358],[-8.549527,42.751583],[-8.547923,42.75055],[-8.545508,42.748841],[-8.545032,42.748303],[-8.54447,42.747073],[-8.543971,42.743142],[-8.544141,42.741203],[-8.543568,42.74041],[-8.542418,42.739938],[-8.541665,42.73922],[-8.541618,42.737901],[-8.541277,42.736988],[-8.541334,42.736536],[-8.542238,42.73506],[-8.542635,42.734019],[-8.542885,42.732715],[-8.543786,42.731137],[-8.543746,42.729337],[-8.544783,42.728401],[-8.545435,42.726771],[-8.54546,42.723692],[-8.545715,42.721635],[-8.545947,42.721115],[-8.547066,42.719661],[-8.547275,42.719095],[-8.547129,42.717386],[-8.545785,42.714736],[-8.545301,42.70965],[-8.545377,42.705918],[-8.545333,42.704625],[-8.54583,42.703888],[-8.545879,42.703048],[-8.545677,42.700889],[-8.545338,42.698726],[-8.545154,42.696367],[-8.545438,42.695443],[-8.544769,42.69478],[-8.545109,42.693468],[-8.54555,42.692544],[-8.547055,42.691913],[-8.54747,42.690992],[-8.54723,42.690588],[-8.5458,42.690024],[-8.54539,42.689139],[-8.545865,42.688254],[-8.546159,42.686558],[-8.547223,42.685181],[-8.546681,42.68413],[-8.548854,42.681087],[-8.55054,42.67997],[-8.55197,42.677125],[-8.55382,42.673137],[-8.555483,42.666362],[-8.555463,42.664258],[-8.55634,42.661306],[-8.557004,42.65941],[-8.558879,42.653168],[-8.558943,42.652614],[-8.558505,42.650232],[-8.559095,42.646504],[-8.560005,42.644488],[-8.560577,42.642151],[-8.560702,42.639907],[-8.560672,42.638056],[-8.561094,42.635909],[-8.561606,42.634033],[-8.562561,42.632736],[-8.563727,42.632103],[-8.565236,42.631759],[-8.565796,42.631466],[-8.566415,42.630779],[-8.566795,42.629362],[-8.566795,42.628475],[-8.567153,42.627955],[-8.567862,42.627673],[-8.57035,42.627107],[-8.573322,42.626234],[-8.574114,42.625916],[-8.577026,42.624311],[-8.57859,42.623658],[-8.581944,42.622765],[-8.583126,42.622298],[-8.583898,42.621816],[-8.586745,42.619359],[-8.587318,42.618976],[-8.589201,42.618379],[-8.593677,42.616342],[-8.595948,42.615595],[-8.598388,42.61461],[-8.599844,42.613607],[-8.601087,42.613255],[-8.602793,42.613112],[-8.603889,42.612817],[-8.605575,42.611841],[-8.606512,42.610464],[-8.607657,42.609807],[-8.608888,42.609662],[-8.609612,42.609818],[-8.611357,42.610632],[-8.61231,42.610769],[-8.614703,42.610273],[-8.615895,42.610282],[-8.616757,42.610487],[-8.62057,42.612274],[-8.622736,42.612885],[-8.623329,42.613291],[-8.624535,42.614465],[-8.625807,42.614831],[-8.628273,42.613886],[-8.628631,42.613366],[-8.628283,42.612812],[-8.626226,42.612462],[-8.625639,42.612003],[-8.624429,42.6105],[-8.624032,42.609544],[-8.623903,42.608553],[-8.624037,42.607512],[-8.624596,42.606608],[-8.625623,42.605626],[-8.627317,42.604754],[-8.629938,42.603854],[-8.631405,42.602803],[-8.634339,42.599639],[-8.634689,42.59913],[-8.635097,42.597938],[-8.63489,42.593244],[-8.634993,42.592228],[-8.635695,42.590844],[-8.636854,42.589826],[-8.640908,42.586861],[-8.642064,42.585697],[-8.642461,42.584756],[-8.642424,42.581997],[-8.64203,42.576386],[-8.641696,42.572445],[-8.641622,42.570864],[-8.641271,42.566526],[-8.641047,42.564424],[-8.640498,42.563422],[-8.637879,42.559775],[-8.637503,42.558887],[-8.638098,42.550224],[-8.638332,42.548064],[-8.638049,42.545926],[-8.637375,42.542891],[-8.636988,42.540743],[-8.636949,42.53959],[-8.637318,42.536815],[-8.637677,42.535371],[-8.638323,42.530657],[-8.638711,42.528646],[-8.638993,42.525809],[-8.638683,42.524631],[-8.637972,42.5227],[-8.637679,42.520684],[-8.638048,42.519587],[-8.639355,42.518042],[-8.641826,42.516132],[-8.64263,42.515049],[-8.642923,42.514203],[-8.6429,42.513182],[-8.642489,42.511675],[-8.642552,42.510838],[-8.643947,42.509362],[-8.644199,42.507921],[-8.644037,42.507182],[-8.642979,42.504383],[-8.642051,42.503197],[-8.641843,42.502634],[-8.64187,42.500104],[-8.641585,42.499247],[-8.64111,42.498703],[-8.639591,42.497551],[-8.639249,42.496694],[-8.639435,42.496205],[-8.640626,42.495113],[-8.640838,42.494464],[-8.640666,42.492124],[-8.640492,42.492239],[-8.63852,42.452278],[-8.637862,42.451001],[-8.637004,42.450795],[-8.636381,42.450033],[-8.636295,42.449276],[-8.636725,42.448569],[-8.636792,42.447408],[-8.636016,42.445952],[-8.635848,42.445252],[-8.636468,42.443431],[-8.637079,42.442573],[-8.637998,42.441672],[-8.639205,42.440214],[-8.641223,42.436321],[-8.641793,42.436263],[-8.64364,42.436571],[-8.646265,42.437192],[-8.648342,42.437304],[-8.650557,42.437602],[-8.652088,42.437489],[-8.652297,42.438081],[-8.651489,42.438792],[-8.650933,42.438806],[-8.650413,42.438295],[-8.650534,42.43778],[-8.651686,42.435576],[-8.652327,42.434554],[-8.653293,42.433606],[-8.654887,42.43252],[-8.656046,42.431096],[-8.656364,42.430086],[-8.656363,42.4291],[-8.656061,42.428134],[-8.655375,42.427081],[-8.651708,42.423915],[-8.650955,42.422808],[-8.650738,42.422201],[-8.650637,42.420598],[-8.651284,42.418311],[-8.651979,42.417037],[-8.653115,42.415269],[-8.653781,42.413585],[-8.654028,42.412009],[-8.653906,42.41004],[-8.653256,42.407913],[-8.652335,42.406305],[-8.650635,42.404195],[-8.649858,42.402822],[-8.648556,42.398381],[-8.648088,42.397559],[-8.647171,42.396512],[-8.646424,42.395885],[-8.643933,42.394316],[-8.643134,42.393696],[-8.642005,42.392471],[-8.641429,42.391518],[-8.640879,42.389787],[-8.640652,42.388223],[-8.640282,42.386615],[-8.639475,42.384628],[-8.638619,42.383089],[-8.637409,42.381155],[-8.636509,42.37869],[-8.636131,42.376256],[-8.636167,42.374718],[-8.63666,42.372465],[-8.637696,42.369824],[-8.638195,42.368938],[-8.639626,42.366906],[-8.64028,42.365508],[-8.64058,42.364396],[-8.640646,42.362431],[-8.640459,42.361114],[-8.640584,42.359239],[-8.641219,42.357449],[-8.642218,42.355974],[-8.6434,42.354587],[-8.645152,42.353092],[-8.645695,42.352386],[-8.646573,42.350836],[-8.646937,42.349594],[-8.647061,42.348393],[-8.646701,42.344919],[-8.646889,42.343845],[-8.647244,42.342997],[-8.64834,42.341389],[-8.648999,42.340124],[-8.649278,42.339086],[-8.649385,42.337801],[-8.649276,42.336981],[-8.648391,42.334349],[-8.648192,42.333177],[-8.648414,42.331715],[-8.649279,42.330144],[-8.650309,42.328888],[-8.651471,42.326786],[-8.652979,42.325233],[-8.653857,42.324673],[-8.656493,42.323313],[-8.657717,42.322349],[-8.658415,42.321578],[-8.659913,42.319325],[-8.663097,42.316285],[-8.663995,42.315146],[-8.664981,42.313398],[-8.665744,42.310904],[-8.665813,42.309601],[-8.665542,42.308371],[-8.664667,42.306906],[-8.662382,42.304632],[-8.661669,42.30366],[-8.660732,42.301937],[-8.659743,42.300785],[-8.658126,42.299421],[-8.657517,42.298517],[-8.657299,42.297084],[-8.657876,42.295432],[-8.6594,42.293822],[-8.659924,42.292756],[-8.660272,42.289827],[-8.660703,42.287239],[-8.660799,42.285612],[-8.661308,42.282274],[-8.66169,42.280865],[-8.662341,42.279971],[-8.664602,42.278335],[-8.665586,42.277268],[-8.666069,42.275782],[-8.665969,42.274852],[-8.66562,42.273973],[-8.664398,42.272335],[-8.663799,42.270906],[-8.663752,42.270052],[-8.663989,42.268944],[-8.664566,42.267885],[-8.66611,42.266452],[-8.667942,42.2654],[-8.669306,42.264393],[-8.670981,42.262716],[-8.673755,42.260538],[-8.674426,42.259848],[-8.675061,42.258659],[-8.675635,42.256453],[-8.67641,42.255258],[-8.677703,42.253765],[-8.68195,42.248632],[-8.682497,42.247449],[-8.682708,42.246454],[-8.682654,42.244664],[-8.682132,42.243315],[-8.681309,42.24221],[-8.679619,42.240917],[-8.677994,42.240184],[-8.676902,42.239879],[-8.675191,42.239752],[-8.664721,42.240454],[-8.663389,42.240577],[-8.661838,42.240537],[-8.660403,42.240306],[-8.658871,42.239843],[-8.656998,42.238828],[-8.655847,42.237788],[-8.65419,42.235768],[-8.652438,42.234263],[-8.651545,42.233663],[-8.649602,42.232637],[-8.647887,42.231589],[-8.646117,42.230109],[-8.645046,42.228844],[-8.644241,42.227303],[-8.644023,42.226204],[-8.644093,42.225346],[-8.644652,42.223794],[-8.64523,42.223034],[-8.646735,42.221832],[-8.648343,42.220984],[-8.650942,42.219117],[-8.652986,42.217901],[-8.654194,42.216983],[-8.656872,42.214359],[-8.657884,42.213565],[-8.65991,42.212273],[-8.663192,42.210694],[-8.665222,42.20939],[-8.666785,42.20796],[-8.667976,42.206225],[-8.668504,42.204755],[-8.668722,42.203072],[-8.668672,42.202056],[-8.668302,42.200682],[-8.667696,42.199449],[-8.666991,42.198422],[-8.664759,42.19588],[-8.663776,42.19417],[-8.663036,42.192591],[-8.661956,42.191253],[-8.661129,42.190591],[-8.660043,42.190039],[-8.658344,42.189404],[-8.656165,42.188956],[-8.654923,42.188585],[-8.653032,42.187582],[-8.652145,42.186837],[-8.651334,42.185745],[-8.650917,42.18452],[-8.650885,42.183501],[-8.651114,42.181984],[-8.651071,42.18077],[-8.65011,42.177626],[-8.65001,42.176653],[-8.650292,42.174638],[-8.65133,42.172012],[-8.651597,42.170349],[-8.651498,42.169394],[-8.651161,42.168233],[-8.650598,42.167114],[-8.64996,42.166257],[-8.64837,42.164747],[-8.647206,42.163915],[-8.645758,42.162388],[-8.644666,42.160885],[-8.644237,42.159559],[-8.644039,42.158202],[-8.643988,42.155222],[-8.64369,42.153264],[-8.64299,42.151157],[-8.64221,42.149591],[-8.641449,42.148323],[-8.639561,42.145783],[-8.63895,42.144399],[-8.638514,42.14245],[-8.638512,42.140382],[-8.638285,42.138753],[-8.637099,42.135763],[-8.636832,42.133919],[-8.637019,42.132517],[-8.637413,42.13137],[-8.638416,42.129375],[-8.63879,42.128216],[-8.639081,42.125608],[-8.639602,42.124023],[-8.640996,42.121102],[-8.641844,42.118659],[-8.642484,42.117439],[-8.643774,42.116024],[-8.645352,42.115014],[-8.647338,42.114083],[-8.648426,42.113444],[-8.649363,42.112586],[-8.649952,42.111823],[-8.650463,42.110777],[-8.650706,42.109858],[-8.650563,42.108459],[-8.649963,42.107147],[-8.648712,42.105767],[-8.646435,42.104114],[-8.645497,42.103151],[-8.644756,42.102078],[-8.644107,42.100417],[-8.643984,42.098682],[-8.643954,42.095558],[-8.643631,42.093579],[-8.642537,42.090846],[-8.640717,42.08762],[-8.640291,42.086724],[-8.63976,42.085131],[-8.639537,42.083632],[-8.639504,42.082212],[-8.639769,42.080338],[-8.640149,42.078486],[-8.640265,42.076604],[-8.640108,42.075173],[-8.639695,42.073322],[-8.639659,42.071672],[-8.640247,42.069602],[-8.640693,42.069089],[-8.641703,42.068546],[-8.6447,42.068115],[-8.646037,42.067231],[-8.648642,42.063945],[-8.649468,42.062511],[-8.65002,42.060831],[-8.650494,42.059935],[-8.651614,42.058775],[-8.653363,42.057615],[-8.654348,42.056493],[-8.654942,42.055205],[-8.655133,42.054367],[-8.655392,42.051134],[-8.656237,42.049296],[-8.656638,42.04815],[-8.656783,42.046771],[-8.657299,42.045549],[-8.658899,42.043895],[-8.659442,42.043181],[-8.659864,42.042022],[-8.659796,42.040366],[-8.659358,42.039391],[-8.654903,42.034366],[-8.651957,42.03117],[-8.651038,42.02965],[-8.65084,42.028624],[-8.650652,42.026633],[-8.650285,42.025055],[-8.649478,42.023341],[-8.64788,42.02068],[-8.64737,42.019512],[-8.646894,42.017914],[-8.646674,42.016455],[-8.646677,42.014765],[-8.647215,42.009563],[-8.647251,42.008238],[-8.647016,42.006755],[-8.646541,42.005535],[-8.643138,41.998225],[-8.642948,41.997404],[-8.642945,41.996129],[-8.643222,41.995073],[-8.644989,41.990747],[-8.646205,41.987968],[-8.647113,41.986236],[-8.648129,41.984637],[-8.65009,41.982345],[-8.651138,41.981348],[-8.653376,41.979602],[-8.658012,41.976266],[-8.664783,41.971513],[-8.666185,41.97027],[-8.667393,41.968685],[-8.667952,41.967484],[-8.66825,41.966428],[-8.66851,41.9643],[-8.66889,41.962904],[-8.669989,41.960863],[-8.671478,41.95901],[-8.672228,41.957712],[-8.672707,41.956374],[-8.672908,41.954735],[-8.672718,41.953139],[-8.671882,41.951169],[-8.671244,41.950226],[-8.67026,41.949151],[-8.669025,41.94817],[-8.666303,41.946263],[-8.665572,41.945861],[-8.663748,41.94433],[-8.662243,41.942034],[-8.660371,41.939504],[-8.659546,41.938498],[-8.657934,41.936809],[-8.657141,41.935621],[-8.656402,41.933723],[-8.655237,41.931801],[-8.653635,41.929746],[-8.652919,41.928242],[-8.652643,41.927331],[-8.652559,41.925264],[-8.652819,41.923882],[-8.653387,41.922549],[-8.657102,41.916314],[-8.657796,41.914827],[-8.658167,41.913731],[-8.658454,41.911267],[-8.658274,41.90359],[-8.658522,41.900303],[-8.659142,41.895919],[-8.65967,41.892689],[-8.660293,41.891235],[-8.661348,41.889996],[-8.663021,41.888516],[-8.663829,41.887645],[-8.66473,41.885947],[-8.664973,41.884533],[-8.664798,41.883119],[-8.664091,41.881594],[-8.663424,41.880729],[-8.6577,41.874165],[-8.654639,41.870982],[-8.652043,41.868569],[-8.644681,41.862412],[-8.639168,41.857668],[-8.63729,41.855776],[-8.634902,41.852995],[-8.633705,41.852026],[-8.632333,41.851239],[-8.630445,41.850631],[-8.629097,41.850421],[-8.627054,41.850423],[-8.625987,41.850578],[-8.622121,41.851348],[-8.620369,41.851324],[-8.618512,41.850826],[-8.616896,41.849842],[-8.614903,41.848051],[-8.613483,41.847128],[-8.612411,41.84663],[-8.608683,41.845354],[-8.607356,41.844739],[-8.606135,41.843979],[-8.604681,41.842743],[-8.603681,41.841542],[-8.602876,41.840009],[-8.602591,41.839123],[-8.60239,41.837721],[-8.602436,41.83679],[-8.602873,41.833779],[-8.602895,41.831101],[-8.602537,41.828395],[-8.601746,41.824969],[-8.60076,41.821156],[-8.599978,41.817661],[-8.599592,41.813424],[-8.599056,41.811487],[-8.598053,41.809871],[-8.597182,41.808917],[-8.59631,41.808208],[-8.594095,41.806982],[-8.587321,41.804261],[-8.586197,41.803667],[-8.584575,41.802528],[-8.583445,41.801507],[-8.582628,41.800562],[-8.581824,41.799357],[-8.578528,41.79364],[-8.574276,41.786102],[-8.573086,41.784099],[-8.571831,41.782596],[-8.569868,41.781261],[-8.568062,41.780516],[-8.565225,41.779884],[-8.563841,41.779471],[-8.562114,41.778643],[-8.560839,41.777735],[-8.560113,41.777016],[-8.559233,41.775784],[-8.558756,41.774619],[-8.558544,41.773197],[-8.5586,41.772302],[-8.559128,41.770257],[-8.560708,41.763404],[-8.560867,41.76191],[-8.560643,41.76015],[-8.560165,41.758718],[-8.559422,41.757375],[-8.557463,41.754629],[-8.556766,41.753095],[-8.556597,41.751803],[-8.556687,41.750127],[-8.557011,41.748833],[-8.557641,41.747529],[-8.559676,41.744225],[-8.560398,41.742341],[-8.562718,41.732774],[-8.562793,41.731895],[-8.562625,41.730572],[-8.561936,41.729002],[-8.560966,41.727776],[-8.559343,41.726493],[-8.548955,41.71994],[-8.546856,41.718342],[-8.545594,41.71694],[-8.544749,41.715802],[-8.544101,41.714592],[-8.543373,41.712399],[-8.543046,41.710245],[-8.54253,41.707549],[-8.541434,41.704691],[-8.540602,41.703239],[-8.538001,41.699733],[-8.537301,41.698398],[-8.537,41.697165],[-8.536976,41.695681],[-8.537221,41.693942],[-8.537313,41.692181],[-8.5372,41.690673],[-8.536865,41.688512],[-8.537022,41.686983],[-8.537799,41.685284],[-8.538952,41.68369],[-8.539717,41.681954],[-8.539844,41.680797],[-8.539541,41.679128],[-8.53903,41.677671],[-8.538802,41.675696],[-8.539068,41.674516],[-8.540075,41.672755],[-8.541118,41.671772],[-8.542599,41.670848],[-8.54486,41.669814],[-8.546689,41.668539],[-8.547709,41.667341],[-8.548168,41.666378],[-8.548515,41.664359],[-8.548368,41.660094],[-8.548502,41.658251],[-8.548867,41.656694],[-8.550346,41.652457],[-8.551953,41.648068],[-8.552846,41.646364],[-8.553788,41.645198],[-8.557197,41.64166],[-8.557876,41.640888],[-8.558982,41.639264],[-8.561564,41.634527],[-8.562066,41.633203],[-8.562182,41.631338],[-8.561857,41.629989],[-8.561366,41.628901],[-8.560639,41.627871],[-8.556031,41.622091],[-8.554484,41.620072],[-8.553561,41.618588],[-8.551901,41.615406],[-8.551569,41.614537],[-8.549842,41.60831],[-8.549801,41.607479],[-8.550155,41.605735],[-8.550505,41.604872],[-8.552024,41.60191],[-8.552764,41.600136],[-8.553028,41.598498],[-8.553508,41.593236],[-8.553955,41.591463],[-8.555249,41.588676],[-8.555745,41.587412],[-8.555896,41.5863],[-8.555502,41.584337],[-8.555055,41.583492],[-8.552369,41.579879],[-8.551672,41.578602],[-8.550684,41.576043],[-8.549732,41.573206],[-8.548514,41.570016],[-8.547918,41.56898],[-8.546312,41.567343],[-8.544899,41.566496],[-8.54301,41.565745],[-8.541222,41.565354],[-8.537955,41.56492],[-8.53655,41.564558],[-8.535472,41.56412],[-8.534276,41.563391],[-8.533267,41.562525],[-8.532298,41.561348],[-8.530624,41.558909],[-8.529972,41.558148],[-8.528283,41.5568],[-8.52615,41.555796],[-8.521622,41.554428],[-8.51913,41.553522],[-8.514388,41.551457],[-8.511064,41.549874],[-8.504651,41.546973],[-8.502203,41.545764],[-8.500373,41.544643],[-8.498673,41.543269],[-8.497313,41.541764],[-8.495706,41.539289],[-8.494508,41.53806],[-8.493602,41.537466],[-8.491085,41.536285],[-8.48984,41.53534],[-8.488737,41.533993],[-8.487911,41.533298],[-8.486277,41.532348],[-8.485033,41.531181],[-8.484533,41.530014],[-8.482449,41.52031],[-8.482137,41.519313],[-8.481271,41.517837],[-8.480214,41.51674],[-8.478302,41.515779],[-8.475809,41.514871],[-8.47416,41.513882],[-8.472733,41.512539],[-8.472016,41.511442],[-8.471447,41.509756],[-8.471457,41.507777],[-8.472181,41.50513],[-8.472321,41.503819],[-8.472037,41.501375],[-8.471319,41.499692],[-8.470309,41.498191],[-8.469116,41.496938],[-8.466076,41.494725],[-8.465422,41.493935],[-8.464904,41.492788],[-8.464949,41.491315],[-8.466057,41.48924],[-8.466493,41.488178],[-8.466603,41.48732],[-8.466417,41.486056],[-8.465377,41.484442],[-8.464453,41.483703],[-8.461148,41.482019],[-8.459981,41.481099],[-8.459343,41.480189],[-8.459025,41.478504],[-8.459499,41.477214],[-8.460214,41.476344],[-8.460915,41.475777],[-8.463643,41.474057],[-8.46451,41.473378],[-8.466067,41.471923],[-8.468638,41.470074],[-8.469798,41.468583],[-8.470529,41.466242],[-8.471179,41.465044],[-8.472495,41.464116],[-8.475277,41.462659],[-8.476685,41.461801],[-8.47823,41.460633],[-8.48079,41.458237],[-8.48214,41.457259],[-8.48613,41.455582],[-8.487705,41.454561],[-8.488967,41.453287],[-8.489818,41.451805],[-8.490486,41.449805],[-8.490963,41.448969],[-8.492613,41.447115],[-8.493074,41.445843],[-8.492842,41.443501],[-8.492952,41.442777],[-8.494195,41.439384],[-8.495261,41.437247],[-8.496391,41.435737],[-8.497107,41.434532],[-8.497617,41.433023],[-8.497801,41.431894],[-8.497818,41.430319],[-8.497503,41.428633],[-8.496674,41.426711],[-8.495295,41.424497],[-8.494358,41.422529],[-8.493902,41.420925],[-8.493692,41.41947],[-8.493775,41.417556],[-8.494212,41.415698],[-8.495541,41.412772],[-8.495803,41.411884],[-8.495805,41.410249],[-8.495455,41.409154],[-8.493782,41.406802],[-8.493367,41.405744],[-8.493249,41.404857],[-8.493552,41.403277],[-8.495607,41.399912],[-8.496093,41.398607],[-8.496331,41.397489],[-8.496401,41.395904],[-8.496243,41.394794],[-8.495263,41.391572],[-8.495102,41.389794],[-8.495273,41.388672],[-8.495668,41.387589],[-8.496849,41.385759],[-8.498911,41.383922],[-8.499752,41.383015],[-8.500789,41.381347],[-8.501264,41.379703],[-8.501418,41.37698],[-8.50194,41.375472],[-8.502881,41.373848],[-8.503383,41.372389],[-8.503377,41.37043],[-8.503196,41.36973],[-8.501763,41.36678],[-8.500473,41.364286],[-8.500172,41.363308],[-8.500097,41.362263],[-8.500265,41.361004],[-8.500814,41.359688],[-8.50144,41.358777],[-8.502272,41.357924],[-8.504226,41.356545],[-8.505395,41.355534],[-8.506573,41.354032],[-8.507114,41.352575],[-8.507285,41.351079],[-8.50715,41.349942],[-8.505911,41.346679],[-8.505751,41.345436],[-8.505809,41.344476],[-8.506406,41.342315],[-8.508082,41.338748],[-8.508985,41.336096],[-8.509902,41.33472],[-8.511478,41.333252],[-8.514066,41.331668],[-8.514976,41.331013],[-8.515991,41.330041],[-8.517126,41.328444],[-8.517624,41.327337],[-8.517937,41.325891],[-8.517903,41.324146],[-8.517624,41.323018],[-8.51653,41.32077],[-8.516241,41.31956],[-8.516223,41.318595],[-8.516504,41.317326],[-8.51681,41.316701],[-8.517742,41.3155],[-8.519393,41.314297],[-8.521049,41.313615],[-8.5229,41.313051],[-8.524382,41.312338],[-8.526012,41.310964],[-8.526948,41.309477],[-8.527721,41.30779],[-8.529052,41.306312],[-8.529959,41.305717],[-8.53121,41.305129],[-8.532295,41.304802],[-8.534256,41.304415],[-8.535584,41.303941],[-8.536737,41.303264],[-8.537591,41.302408],[-8.538117,41.301595],[-8.538415,41.300749],[-8.538711,41.298342],[-8.538932,41.297703],[-8.539739,41.296285],[-8.541257,41.294653],[-8.543249,41.293341],[-8.546394,41.291844],[-8.554918,41.287646],[-8.556526,41.286772],[-8.55843,41.285308],[-8.559649,41.283977],[-8.560803,41.282075],[-8.56126,41.280613],[-8.561408,41.278402],[-8.561064,41.276695],[-8.560236,41.274558],[-8.559914,41.272983],[-8.560038,41.271622],[-8.560591,41.269875],[-8.560864,41.269461],[-8.565292,41.261487],[-8.566915,41.258675],[-8.567622,41.257245],[-8.568292,41.255373],[-8.568582,41.253644],[-8.568641,41.252364],[-8.568264,41.250073],[-8.567512,41.248015],[-8.567237,41.247761],[-8.56638,41.245179],[-8.565062,41.243046],[-8.56488,41.242055],[-8.565177,41.241573],[-8.566086,41.241048],[-8.567611,41.240832],[-8.573583,41.239752],[-8.575762,41.239508],[-8.579706,41.239465],[-8.580806,41.239354],[-8.585002,41.238247],[-8.587215,41.237988],[-8.593875,41.237994],[-8.595512,41.238162],[-8.59658,41.238431],[-8.600287,41.239919],[-8.602423,41.240404],[-8.603531,41.240461],[-8.606271,41.240265],[-8.614143,41.239472],[-8.615632,41.239447],[-8.617314,41.239675],[-8.620294,41.240636],[-8.622697,41.241302],[-8.622985,41.24196],[-8.62225,41.243227],[-8.618882,41.248292],[-8.618404,41.248162],[-8.618853,41.247788],[-8.620467,41.24842],[-8.621586,41.248453],[-8.622971,41.247232],[-8.623417,41.246577],[-8.624054,41.246127],[-8.624956,41.245872],[-8.630223,41.244788],[-8.630594,41.242315],[-8.630949,41.241657],[-8.632219,41.240909],[-8.633775,41.240446],[-8.633568,41.239635],[-8.633836,41.23941],[-8.634699,41.239498],[-8.636326,41.239218],[-8.636781,41.239331],[-8.637579,41.240498],[-8.637569,41.241174],[-8.638277,41.244207],[-8.63884,41.245942],[-8.640554,41.247904],[-8.641071,41.248161],[-8.643872,41.247603],[-8.648602,41.245388],[-8.64844,41.244259],[-8.649023,41.24359],[-8.648553,41.242322],[-8.648979,41.241121],[-8.648188,41.239992],[-8.64827,41.237447],[-8.649298,41.235675],[-8.651781,41.234148],[-8.652496,41.233609],[-8.653685,41.232167],[-8.654426,41.231671],[-8.656661,41.231439],[-8.65726,41.231556],[-8.658117,41.232225],[-8.659823,41.232556],[-8.661159,41.232368],[-8.660679,41.230979],[-8.659293,41.228866],[-8.659316,41.228505],[-8.661071,41.226692],[-8.662502,41.226348],[-8.662753,41.224696],[-8.661569,41.224014],[-8.661494,41.223532],[-8.66207,41.223472],[-8.662598,41.223783],[-8.665251,41.226562],[-8.667299,41.228085],[-8.667878,41.22889],[-8.668024,41.229509],[-8.66759,41.230949],[-8.666782,41.232483],[-8.66672,41.233885],[-8.667575,41.235413],[-8.668031,41.23779],[-8.668652,41.238581],[-8.669889,41.239046],[-8.670531,41.238585],[-8.669657,41.235387],[-8.66907,41.23509],[-8.668721,41.235595],[-8.66912,41.236814],[-8.66872,41.237438],[-8.668956,41.238206],[-8.66829,41.237575],[-8.667694,41.2354],[-8.666955,41.234108],[-8.666824,41.232847],[-8.667722,41.23106],[-8.668153,41.229951],[-8.669117,41.225807],[-8.669151,41.224782],[-8.668397,41.223969],[-8.667522,41.223782],[-8.664465,41.223663],[-8.662999,41.22333],[-8.661942,41.222742],[-8.655081,41.215442],[-8.65439,41.214586],[-8.653755,41.213478],[-8.652265,41.210115],[-8.65179,41.208262],[-8.651876,41.206133],[-8.651781,41.204763],[-8.651244,41.20346],[-8.651828,41.202719],[-8.654691,41.202169],[-8.656805,41.20151],[-8.657822,41.200917],[-8.664575,41.196085],[-8.6658,41.194773],[-8.666108,41.193986],[-8.66658,41.191825],[-8.667322,41.190699],[-8.667996,41.189962],[-8.669447,41.1897],[-8.670411,41.188959],[-8.670409,41.188372],[-8.669866,41.187339],[-8.669228,41.187061],[-8.667604,41.187048],[-8.666068,41.186448],[-8.661463,41.182685],[-8.655134,41.17761],[-8.652253,41.175225],[-8.649773,41.173245],[-8.643982,41.168475],[-8.643851,41.167417],[-8.643494,41.166614],[-8.643886,41.166259],[-8.647968,41.16423],[-8.64876,41.163511],[-8.649396,41.162272],[-8.649394,41.161044],[-8.649112,41.160024],[-8.649545,41.159749],[-8.650181,41.160218],[-8.650221,41.161229],[-8.649983,41.161314],[-8.643993,41.160329],[-8.64488,41.158694],[-8.644648,41.158643],[-8.642383,41.159823],[-8.641841,41.159942],[-8.644511,41.158924],[-8.644811,41.158933],[-8.645432,41.158048],[-8.645474,41.156934],[-8.647674,41.155054],[-8.648275,41.155545],[-8.648551,41.156884],[-8.649337,41.158215],[-8.649242,41.15903],[-8.648274,41.159076],[-8.647823,41.158866],[-8.646554,41.157422],[-8.646081,41.156625],[-8.644878,41.153901],[-8.643965,41.152686],[-8.642187,41.15146],[-8.641423,41.150756],[-8.640718,41.148792],[-8.640384,41.147097],[-8.639242,41.142541],[-8.638319,41.140591],[-8.636158,41.137841],[-8.635659,41.13673],[-8.635422,41.135169],[-8.635902,41.126081],[-8.636003,41.125502],[-8.636138,41.122359],[-8.636001,41.121426],[-8.6355,41.120333],[-8.634819,41.11952],[-8.631667,41.117356],[-8.628686,41.115795],[-8.627819,41.114927],[-8.626773,41.113514],[-8.626507,41.112625],[-8.626493,41.108595],[-8.626422,41.107266],[-8.626494,41.103428],[-8.626398,41.101454],[-8.626516,41.100402],[-8.626988,41.098731],[-8.628208,41.096371],[-8.630484,41.091533],[-8.630955,41.090104],[-8.630938,41.08908],[-8.630488,41.086887],[-8.631096,41.083956],[-8.631337,41.081532],[-8.631851,41.08054],[-8.632835,41.079934],[-8.634083,41.079613],[-8.637426,41.078476],[-8.638335,41.077979],[-8.639068,41.07732],[-8.64071,41.075146],[-8.641528,41.073468],[-8.642261,41.071118],[-8.642582,41.069423],[-8.642418,41.068293],[-8.641583,41.066611],[-8.641382,41.065699],[-8.641791,41.062581],[-8.641517,41.061311],[-8.640661,41.059656],[-8.640157,41.057946],[-8.639781,41.056026],[-8.639011,41.053952],[-8.638817,41.052882],[-8.63876,41.050232],[-8.638817,41.048891],[-8.639162,41.0469],[-8.63898,41.045583],[-8.638374,41.044564],[-8.637515,41.043704],[-8.633148,41.040815],[-8.630277,41.038212],[-8.62837,41.036969],[-8.627549,41.036208],[-8.62706,41.0355],[-8.625681,41.032666],[-8.624586,41.031267],[-8.624138,41.029767],[-8.62436,41.028468],[-8.624991,41.026872],[-8.625208,41.025701],[-8.624953,41.024474],[-8.623235,41.021383],[-8.623011,41.020548],[-8.623001,41.019285],[-8.623343,41.017632],[-8.623312,41.016584],[-8.622948,41.015366],[-8.62095,41.011531],[-8.619796,41.008661],[-8.619203,41.006932],[-8.61887,41.005389],[-8.618677,41.002722],[-8.618757,40.998885],[-8.618389,40.99762],[-8.615727,40.993391],[-8.615006,40.991863],[-8.614771,40.988935],[-8.614259,40.987751],[-8.613132,40.985912],[-8.612617,40.984439],[-8.61246,40.982687],[-8.612157,40.98131],[-8.611073,40.978931],[-8.61086,40.977667],[-8.610969,40.974368],[-8.610918,40.973762],[-8.610378,40.971761],[-8.608777,40.966917],[-8.60839,40.965462],[-8.608418,40.964349],[-8.609277,40.960121],[-8.609254,40.958617],[-8.607806,40.954318],[-8.607449,40.953474],[-8.606354,40.952133],[-8.601957,40.948225],[-8.601242,40.947262],[-8.600803,40.946208],[-8.600707,40.944642],[-8.600906,40.943798],[-8.601856,40.941128],[-8.602143,40.939342],[-8.602222,40.928836],[-8.602278,40.927994],[-8.602677,40.926747],[-8.603331,40.925741],[-8.605417,40.923849],[-8.606298,40.922934],[-8.608795,40.917785],[-8.609079,40.915957],[-8.608744,40.914176],[-8.607541,40.911377],[-8.605591,40.907151],[-8.605166,40.906107],[-8.603775,40.903308],[-8.602503,40.901581],[-8.600889,40.899973],[-8.597367,40.897124],[-8.597149,40.896103],[-8.598001,40.894648],[-8.597868,40.894056],[-8.596368,40.891614],[-8.596299,40.891012],[-8.597509,40.889906],[-8.599597,40.888649],[-8.602302,40.886558],[-8.603366,40.88606],[-8.605441,40.885433],[-8.606378,40.884996],[-8.607521,40.884103],[-8.609792,40.881522],[-8.610768,40.880695],[-8.611777,40.880157],[-8.612863,40.879849],[-8.613968,40.879751],[-8.618118,40.879829],[-8.626708,40.878951],[-8.629355,40.878729],[-8.631009,40.87844],[-8.633371,40.877751],[-8.632623,40.877414],[-8.632534,40.876743],[-8.632953,40.874598],[-8.63331,40.874234],[-8.63451,40.87384],[-8.634647,40.874491],[-8.635487,40.874282],[-8.63482,40.873813],[-8.636432,40.873854],[-8.638425,40.874377],[-8.639078,40.875307],[-8.641215,40.874263],[-8.643546,40.873293],[-8.654376,40.868627],[-8.655399,40.867966],[-8.655881,40.867388],[-8.656599,40.865603],[-8.658689,40.858984],[-8.65889,40.857319],[-8.659416,40.848557],[-8.660169,40.847472],[-8.661956,40.846224],[-8.662543,40.84556],[-8.663204,40.843041],[-8.663872,40.840859],[-8.664384,40.832802],[-8.664545,40.830755],[-8.664907,40.829306],[-8.666107,40.826856],[-8.667353,40.824116],[-8.669434,40.819789],[-8.670366,40.815713],[-8.670812,40.813206],[-8.672667,40.804994],[-8.67441,40.800735],[-8.674487,40.7999],[-8.673555,40.79655],[-8.673453,40.795706],[-8.674392,40.792167],[-8.674613,40.791701],[-8.676063,40.79048],[-8.6801,40.788088],[-8.681237,40.787357],[-8.687339,40.783008],[-8.688149,40.782343],[-8.688464,40.78173],[-8.69175,40.777277],[-8.692751,40.775773],[-8.692854,40.775272],[-8.695068,40.770184],[-8.695789,40.768033],[-8.696411,40.76734],[-8.698157,40.766003],[-8.698649,40.765798],[-8.698459,40.765426],[-8.699028,40.763571],[-8.699621,40.762265],[-8.701589,40.759449],[-8.701856,40.758587],[-8.702151,40.75669],[-8.702251,40.755191],[-8.702077,40.753413],[-8.701442,40.751406],[-8.696952,40.73959],[-8.696894,40.738445],[-8.698496,40.731054],[-8.698809,40.727458],[-8.699761,40.724133],[-8.699711,40.723558],[-8.699147,40.721195],[-8.699298,40.720514],[-8.700197,40.718267],[-8.701176,40.717223],[-8.70614,40.71419],[-8.707347,40.713233],[-8.711695,40.708198],[-8.714606,40.705671],[-8.715032,40.705118],[-8.718499,40.699947],[-8.720349,40.696348],[-8.720509,40.695735],[-8.720832,40.693011],[-8.720756,40.692288],[-8.719877,40.690256],[-8.71963,40.689227],[-8.719759,40.687486],[-8.71874,40.683131],[-8.718173,40.679808],[-8.718208,40.678095],[-8.718515,40.677354],[-8.722303,40.672888],[-8.724648,40.670823],[-8.725368,40.670046],[-8.729402,40.663919],[-8.730569,40.662039],[-8.730612,40.661609],[-8.729617,40.660806],[-8.731217,40.659832],[-8.731891,40.659264],[-8.732484,40.658407],[-8.733088,40.656945],[-8.733137,40.655956],[-8.732641,40.654656],[-8.732223,40.65421],[-8.729848,40.650866],[-8.729745,40.650012],[-8.730465,40.649721],[-8.730668,40.650145],[-8.73127,40.650204],[-8.734719,40.647518],[-8.734257,40.647063],[-8.733426,40.6458],[-8.731494,40.64528],[-8.730495,40.644623],[-8.727477,40.641599],[-8.726574,40.640429],[-8.726239,40.639433],[-8.729409,40.632743],[-8.730538,40.629774],[-8.730904,40.628613],[-8.731793,40.627084],[-8.73239,40.626837],[-8.732965,40.627425],[-8.732015,40.627717],[-8.728635,40.626501],[-8.726674,40.625953],[-8.724704,40.625643],[-8.723067,40.625568],[-8.72052,40.625754],[-8.717253,40.626251],[-8.708867,40.627626],[-8.701481,40.628885],[-8.690428,40.631245],[-8.687797,40.631691],[-8.683119,40.632708],[-8.681367,40.633167],[-8.671184,40.635364],[-8.669891,40.635739],[-8.668227,40.636473],[-8.666388,40.637728],[-8.662566,40.640767],[-8.658914,40.643413],[-8.656998,40.644611],[-8.654179,40.646208],[-8.650088,40.648313],[-8.648142,40.649393],[-8.642318,40.652768],[-8.639925,40.653831],[-8.638316,40.654196],[-8.636661,40.654308],[-8.634223,40.654002],[-8.631509,40.652998],[-8.62352,40.64913],[-8.622169,40.648551],[-8.620503,40.648173],[-8.615927,40.647882],[-8.614259,40.647505],[-8.612347,40.646557],[-8.610147,40.644946],[-8.608785,40.644077],[-8.606582,40.643111],[-8.605153,40.642653],[-8.603539,40.642307],[-8.602421,40.641905],[-8.601837,40.641436],[-8.601427,40.640484],[-8.601628,40.639587],[-8.602955,40.635424],[-8.603137,40.634373],[-8.603041,40.632469],[-8.602621,40.631042],[-8.602023,40.629868],[-8.601143,40.628549],[-8.597778,40.62377],[-8.596732,40.622559],[-8.59545,40.621504],[-8.59386,40.620436],[-8.588247,40.616828],[-8.587465,40.616283],[-8.586224,40.61515],[-8.585065,40.613448],[-8.584689,40.612412],[-8.584435,40.610702],[-8.584739,40.609011],[-8.585324,40.60779],[-8.586286,40.606483],[-8.587762,40.605197],[-8.590845,40.603055],[-8.592879,40.601356],[-8.594169,40.59978],[-8.595123,40.597973],[-8.595608,40.596331],[-8.595818,40.594867],[-8.595898,40.592767],[-8.596033,40.591933],[-8.59654,40.590293],[-8.597212,40.58893],[-8.597973,40.587857],[-8.599853,40.58578],[-8.601368,40.584507],[-8.602275,40.583911],[-8.602264,40.583504],[-8.60173,40.583037],[-8.601166,40.583054],[-8.600447,40.583453],[-8.599491,40.583526],[-8.597567,40.583304],[-8.59077,40.582629],[-8.59016,40.582459],[-8.582378,40.579045],[-8.580697,40.577948],[-8.574436,40.57221],[-8.57314,40.571201],[-8.570267,40.569597],[-8.569038,40.568996],[-8.567507,40.570031],[-8.566222,40.570376],[-8.562028,40.570566],[-8.561418,40.570433],[-8.560781,40.569842],[-8.560607,40.568047],[-8.561221,40.564059],[-8.561349,40.561474],[-8.561129,40.558522],[-8.560031,40.553169],[-8.55996,40.552097],[-8.56006,40.550572],[-8.560281,40.549509],[-8.561525,40.546296],[-8.561891,40.544922],[-8.561999,40.543759],[-8.561822,40.542065],[-8.561207,40.540396],[-8.560393,40.5391],[-8.557519,40.53529],[-8.556359,40.533393],[-8.555148,40.53086],[-8.553767,40.526889],[-8.552963,40.524963],[-8.552029,40.523215],[-8.550745,40.521365],[-8.54891,40.519258],[-8.547019,40.517537],[-8.545737,40.516544],[-8.543291,40.51497],[-8.538973,40.512581],[-8.537208,40.511368],[-8.535786,40.510155],[-8.534124,40.508304],[-8.532811,40.506237],[-8.532192,40.504846],[-8.531711,40.503226],[-8.531491,40.501759],[-8.531225,40.498819],[-8.530968,40.497587],[-8.530116,40.495386],[-8.528808,40.493365],[-8.525813,40.489591],[-8.524114,40.486849],[-8.523046,40.484468],[-8.522494,40.482809],[-8.521999,40.480843],[-8.521667,40.478353],[-8.521611,40.476645],[-8.521747,40.472047],[-8.521695,40.470575],[-8.521294,40.467636],[-8.520934,40.46621],[-8.520153,40.463781],[-8.518616,40.459315],[-8.518026,40.456597],[-8.517738,40.454046],[-8.517581,40.449606],[-8.517424,40.448139],[-8.517101,40.446469],[-8.516722,40.445234],[-8.515948,40.443457],[-8.515208,40.442108],[-8.513455,40.439759],[-8.512348,40.438593],[-8.508712,40.435453],[-8.504835,40.432291],[-8.502516,40.429972],[-8.501186,40.428393],[-8.499922,40.426619],[-8.498945,40.425012],[-8.497564,40.421949],[-8.496489,40.418484],[-8.495595,40.415855],[-8.494514,40.413474],[-8.492943,40.410562],[-8.492176,40.40875],[-8.491665,40.407123],[-8.49136,40.405255],[-8.491275,40.402321],[-8.491102,40.400211],[-8.490666,40.398366],[-8.48993,40.396123],[-8.489367,40.39409],[-8.489108,40.392597],[-8.488966,40.390279],[-8.48909,40.388387],[-8.489371,40.386709],[-8.490205,40.384038],[-8.492043,40.379835],[-8.492961,40.37695],[-8.493422,40.374683],[-8.493604,40.371954],[-8.493518,40.369888],[-8.492657,40.364453],[-8.492575,40.363421],[-8.492637,40.36133],[-8.493104,40.358863],[-8.494501,40.354165],[-8.494809,40.351623],[-8.494771,40.348909],[-8.49491,40.347283],[-8.495562,40.343794],[-8.495679,40.342218],[-8.495541,40.340147],[-8.49492,40.3377],[-8.493352,40.333444],[-8.492887,40.331164],[-8.492771,40.329482],[-8.492751,40.326711],[-8.492668,40.325442],[-8.492398,40.323774],[-8.491619,40.321095],[-8.49021,40.317449],[-8.489945,40.316374],[-8.489707,40.314608],[-8.489507,40.311829],[-8.488872,40.309073],[-8.487409,40.305839],[-8.486645,40.303822],[-8.486203,40.301779],[-8.486046,40.296849],[-8.485757,40.295208],[-8.485176,40.293402],[-8.484201,40.291471],[-8.483485,40.290383],[-8.481662,40.288356],[-8.479884,40.286796],[-8.478491,40.28501],[-8.477661,40.282969],[-8.477452,40.281514],[-8.47751,40.280458],[-8.477786,40.279219],[-8.478725,40.277261],[-8.479845,40.275669],[-8.481658,40.273637],[-8.482508,40.272534],[-8.483186,40.272113],[-8.483777,40.27269],[-8.48338,40.273012],[-8.480804,40.272488],[-8.478955,40.272477],[-8.475803,40.271337],[-8.473852,40.270891],[-8.471982,40.270586],[-8.468478,40.269899],[-8.466322,40.269656],[-8.463536,40.26983],[-8.461274,40.270193],[-8.459235,40.270397],[-8.455399,40.270236],[-8.453564,40.270383],[-8.450496,40.271186],[-8.448402,40.271219],[-8.446356,40.271642],[-8.445736,40.271668],[-8.444571,40.271122],[-8.444136,40.270666],[-8.442818,40.266141],[-8.442567,40.264918],[-8.442621,40.263893],[-8.443498,40.261319],[-8.443672,40.26052],[-8.443614,40.259107],[-8.442687,40.249462],[-8.442541,40.248624],[-8.441964,40.247249],[-8.437595,40.240028],[-8.436929,40.238587],[-8.436401,40.236633],[-8.435284,40.230675],[-8.435071,40.22907],[-8.435438,40.227617],[-8.435987,40.226798],[-8.438154,40.224211],[-8.439666,40.222742],[-8.439655,40.221804],[-8.43919,40.219595],[-8.438336,40.217496],[-8.438334,40.216944],[-8.439219,40.216166],[-8.4413,40.214987],[-8.442517,40.214843],[-8.443082,40.215232],[-8.442878,40.215562],[-8.441998,40.215329],[-8.441706,40.214717],[-8.441533,40.213507],[-8.440285,40.211451],[-8.439652,40.210109],[-8.437454,40.206949],[-8.435786,40.204703],[-8.434954,40.203223],[-8.434414,40.20324],[-8.432599,40.203953],[-8.432058,40.203791],[-8.429779,40.199449],[-8.429653,40.19895],[-8.429988,40.197955],[-8.43075,40.196971],[-8.431563,40.196551],[-8.431585,40.196089],[-8.430523,40.195992],[-8.430733,40.1966],[-8.431656,40.196454],[-8.431602,40.195888],[-8.432374,40.194558],[-8.432565,40.193582],[-8.432339,40.192683],[-8.431649,40.191828],[-8.43157,40.191429],[-8.430919,40.190862],[-8.429514,40.189102],[-8.429346,40.187787],[-8.429874,40.186648],[-8.431944,40.184778],[-8.432744,40.184267],[-8.434273,40.183827],[-8.436745,40.183798],[-8.438383,40.183502],[-8.442494,40.181744],[-8.446459,40.180137],[-8.447194,40.179949],[-8.447852,40.18032],[-8.448318,40.180072],[-8.448496,40.178886],[-8.449211,40.177702],[-8.452149,40.174483],[-8.45338,40.172848],[-8.458632,40.163362],[-8.459086,40.162305],[-8.459424,40.160363],[-8.459459,40.155333],[-8.459847,40.15374],[-8.460343,40.152683],[-8.464904,40.144969],[-8.467493,40.139969],[-8.4692,40.136362],[-8.470274,40.135401],[-8.473198,40.134052],[-8.475095,40.132294],[-8.475821,40.131914],[-8.478561,40.130899],[-8.481888,40.129405],[-8.482663,40.129178],[-8.486367,40.129354],[-8.487534,40.129615],[-8.489999,40.129927],[-8.490813,40.130221],[-8.492607,40.131417],[-8.494161,40.13229],[-8.495024,40.132579],[-8.496788,40.132764],[-8.497682,40.132316],[-8.497114,40.131114],[-8.497358,40.130113],[-8.498729,40.128593],[-8.500198,40.127499],[-8.501571,40.126815],[-8.503143,40.12628],[-8.50471,40.125973],[-8.507778,40.125624],[-8.509121,40.125398],[-8.511235,40.124836],[-8.513074,40.124139],[-8.514767,40.123223],[-8.516895,40.121601],[-8.520523,40.118169],[-8.523683,40.115623],[-8.525118,40.114255],[-8.525888,40.113299],[-8.526909,40.111637],[-8.527574,40.110095],[-8.527896,40.108968],[-8.528196,40.107154],[-8.528321,40.105585],[-8.528726,40.103811],[-8.529192,40.102729],[-8.530518,40.10073],[-8.532299,40.098871],[-8.532915,40.098057],[-8.533744,40.096558],[-8.534088,40.095464],[-8.534264,40.093512],[-8.534022,40.091422],[-8.53412,40.089601],[-8.534868,40.087519],[-8.536224,40.085517],[-8.537009,40.084187],[-8.537553,40.082277],[-8.537557,40.080887],[-8.537284,40.078105],[-8.537441,40.076725],[-8.538004,40.075012],[-8.538789,40.073646],[-8.539443,40.072806],[-8.54151,40.070779],[-8.543145,40.068666],[-8.544403,40.066361],[-8.545781,40.064551],[-8.547016,40.06344],[-8.550357,40.061252],[-8.553545,40.058923],[-8.556112,40.057162],[-8.558231,40.055878],[-8.560786,40.054539],[-8.56553,40.052476],[-8.567384,40.051414],[-8.568978,40.050165],[-8.570706,40.048136],[-8.572501,40.044948],[-8.573075,40.044189],[-8.57487,40.042437],[-8.57768,40.040437],[-8.580188,40.03838],[-8.581863,40.036781],[-8.583437,40.035108],[-8.58464,40.033657],[-8.586266,40.031351],[-8.588989,40.026573],[-8.59018,40.024817],[-8.59118,40.023512],[-8.59289,40.021527],[-8.594086,40.020301],[-8.595947,40.018596],[-8.598371,40.016506],[-8.599463,40.015094],[-8.599968,40.014176],[-8.601214,40.011038],[-8.602099,40.009689],[-8.603415,40.008275],[-8.605237,40.006629],[-8.607022,40.004515],[-8.608185,40.002272],[-8.609033,40.000152],[-8.609596,39.999094],[-8.610635,39.997718],[-8.613402,39.994967],[-8.614549,39.993493],[-8.615728,39.991597],[-8.616799,39.990133],[-8.617955,39.988966],[-8.619098,39.988081],[-8.621827,39.986356],[-8.623674,39.984888],[-8.624571,39.983895],[-8.62677,39.980947],[-8.627949,39.979785],[-8.628896,39.979059],[-8.63054,39.978043],[-8.632629,39.977088],[-8.639832,39.974138],[-8.648052,39.97072],[-8.650589,39.969785],[-8.654292,39.968614],[-8.655988,39.967861],[-8.657146,39.967176],[-8.658641,39.965988],[-8.659457,39.965094],[-8.661196,39.962587],[-8.662434,39.961194],[-8.663316,39.960421],[-8.666529,39.958105],[-8.667763,39.956903],[-8.668652,39.95564],[-8.669344,39.954073],[-8.669993,39.950835],[-8.670458,39.949075],[-8.670982,39.947954],[-8.671695,39.946862],[-8.673463,39.945039],[-8.676385,39.942729],[-8.678092,39.941069],[-8.678774,39.94017],[-8.67961,39.938704],[-8.680132,39.937333],[-8.680513,39.935132],[-8.680502,39.933904],[-8.68022,39.931046],[-8.68016,39.928362],[-8.680455,39.926399],[-8.680968,39.924723],[-8.682267,39.922077],[-8.683679,39.919734],[-8.684406,39.918123],[-8.684746,39.916403],[-8.684611,39.912017],[-8.684917,39.910108],[-8.685275,39.90909],[-8.686313,39.907198],[-8.688563,39.90409],[-8.689337,39.902677],[-8.690092,39.900684],[-8.690376,39.89896],[-8.690365,39.897329],[-8.690192,39.896079],[-8.689515,39.892696],[-8.689428,39.891212],[-8.689822,39.889156],[-8.690561,39.887602],[-8.691524,39.886339],[-8.692872,39.885036],[-8.694374,39.883809],[-8.697004,39.881349],[-8.698569,39.879649],[-8.699724,39.878197],[-8.700925,39.876489],[-8.702161,39.874315],[-8.703387,39.871691],[-8.704362,39.869004],[-8.705038,39.866478],[-8.706013,39.863739],[-8.707353,39.860931],[-8.708282,39.859382],[-8.71026,39.8567],[-8.712041,39.854652],[-8.713153,39.85354],[-8.715231,39.851655],[-8.716494,39.850267],[-8.717264,39.848888],[-8.717709,39.847459],[-8.718294,39.844387],[-8.719318,39.841133],[-8.720733,39.837939],[-8.721155,39.83673],[-8.721364,39.8355],[-8.721287,39.834022],[-8.72102,39.832986],[-8.720297,39.831482],[-8.718652,39.829227],[-8.718132,39.828314],[-8.71764,39.826939],[-8.717503,39.824831],[-8.71773,39.823753],[-8.718454,39.822104],[-8.721331,39.818335],[-8.722148,39.816717],[-8.722567,39.815476],[-8.72284,39.814023],[-8.722871,39.812767],[-8.722316,39.80859],[-8.722338,39.807768],[-8.722678,39.806199],[-8.723087,39.805264],[-8.72379,39.804214],[-8.72571,39.801905],[-8.728625,39.797734],[-8.730532,39.795984],[-8.733022,39.794338],[-8.735073,39.792533],[-8.736172,39.790963],[-8.736679,39.789855],[-8.737074,39.788135],[-8.737163,39.784648],[-8.73728,39.7834],[-8.737751,39.781819],[-8.738244,39.780873],[-8.739664,39.779089],[-8.741618,39.777263],[-8.742684,39.776057],[-8.743731,39.774117],[-8.744206,39.771993],[-8.744499,39.769856],[-8.744713,39.766234],[-8.745073,39.763037],[-8.745373,39.761524],[-8.74633,39.759518],[-8.747681,39.757656],[-8.748783,39.75564],[-8.749135,39.754311],[-8.749178,39.752542],[-8.748756,39.750901],[-8.747816,39.74861],[-8.74708,39.746455],[-8.746477,39.745083],[-8.745632,39.743802],[-8.744744,39.742851],[-8.742972,39.741451],[-8.742625,39.741022],[-8.742494,39.739851],[-8.743103,39.739013],[-8.743605,39.738708],[-8.746539,39.737653],[-8.748809,39.736951],[-8.75009,39.736756],[-8.751935,39.736635],[-8.753234,39.736706],[-8.754023,39.736988],[-8.756608,39.738811],[-8.758304,39.739338],[-8.760432,39.739244],[-8.762034,39.739369],[-8.764853,39.740264],[-8.766935,39.740603],[-8.768873,39.740706],[-8.769371,39.740885],[-8.76938,39.741349],[-8.768854,39.74148],[-8.768474,39.741137],[-8.76849,39.740363],[-8.768877,39.739364],[-8.769751,39.738262],[-8.771148,39.736741],[-8.772104,39.735442],[-8.773375,39.732284],[-8.774352,39.73098],[-8.775902,39.729738],[-8.777382,39.729015],[-8.778809,39.728583],[-8.784421,39.727321],[-8.787808,39.726358],[-8.794149,39.724388],[-8.797859,39.723277],[-8.800384,39.722837],[-8.809427,39.722028],[-8.810716,39.72198],[-8.812277,39.722128],[-8.81429,39.72272],[-8.815637,39.723414],[-8.818319,39.725418],[-8.819181,39.72588],[-8.821794,39.726911],[-8.82624,39.72857],[-8.827874,39.72908],[-8.829394,39.729198],[-8.830416,39.729056],[-8.831869,39.728568],[-8.833933,39.727649],[-8.835183,39.727331],[-8.836453,39.727206],[-8.83769,39.727261],[-8.843803,39.728055],[-8.846434,39.728435],[-8.848421,39.728814],[-8.849628,39.729208],[-8.851265,39.730101],[-8.852811,39.731536],[-8.853627,39.732759],[-8.854893,39.735067],[-8.856224,39.737039],[-8.857896,39.738679],[-8.859404,39.739686],[-8.861111,39.740653],[-8.863329,39.741634],[-8.86505,39.742193],[-8.867685,39.742757],[-8.869891,39.742986],[-8.872914,39.742955],[-8.875498,39.742596],[-8.877662,39.742053],[-8.880222,39.741173],[-8.88302,39.740389],[-8.884724,39.739704],[-8.88603,39.738865],[-8.887072,39.737825],[-8.887662,39.736943],[-8.889085,39.733677],[-8.891054,39.730572],[-8.892309,39.72897],[-8.893159,39.728134],[-8.89486,39.72677],[-8.895906,39.726092],[-8.897759,39.725133],[-8.901296,39.723669],[-8.907135,39.721539],[-8.90944,39.720555],[-8.911377,39.719183],[-8.912611,39.717882],[-8.913402,39.716695],[-8.915673,39.712819],[-8.919096,39.706831],[-8.922476,39.700979],[-8.923701,39.699178],[-8.925875,39.696857],[-8.928607,39.694363],[-8.930534,39.692385],[-8.931548,39.691138],[-8.933357,39.688317],[-8.934411,39.686125],[-8.936216,39.682885],[-8.937493,39.681178],[-8.939703,39.678863],[-8.94132,39.677495],[-8.946113,39.674077],[-8.94802,39.672555],[-8.950009,39.670842],[-8.952882,39.668027],[-8.954203,39.666549],[-8.955728,39.664639],[-8.956846,39.663072],[-8.959041,39.659472],[-8.962264,39.65313],[-8.963548,39.650676],[-8.965882,39.646041],[-8.968679,39.640648],[-8.970259,39.637905],[-8.972422,39.635102],[-8.974701,39.632779],[-8.977239,39.630654],[-8.985643,39.624524],[-8.990193,39.621242],[-8.995208,39.617522],[-8.997061,39.615811],[-8.997873,39.614886],[-8.998892,39.613339],[-8.999367,39.612301],[-9.000001,39.610377],[-9.000229,39.609048],[-9.00059,39.604675],[-9.001053,39.598083],[-9.001529,39.595936],[-9.002037,39.594674],[-9.003228,39.592717],[-9.004814,39.590922],[-9.006163,39.589789],[-9.007375,39.588957],[-9.010282,39.587364],[-9.010822,39.58729],[-9.011171,39.587621],[-9.010924,39.588058],[-9.010007,39.587783],[-9.009141,39.586831],[-9.008766,39.585931],[-9.008941,39.584893],[-9.008956,39.582989],[-9.0094,39.582462],[-9.011266,39.582203],[-9.011837,39.582384],[-9.012576,39.584538],[-9.013014,39.585442],[-9.01377,39.586295],[-9.014912,39.587266],[-9.013743,39.587913],[-9.008493,39.591549],[-9.009282,39.592252],[-9.010679,39.594418],[-9.011006,39.594728],[-9.012488,39.594894],[-9.014509,39.597196],[-9.015325,39.597888],[-9.016571,39.598685],[-9.018615,39.599637],[-9.026536,39.602478],[-9.028235,39.603506],[-9.029521,39.605002],[-9.030901,39.606068],[-9.031799,39.60645],[-9.033011,39.606736],[-9.035535,39.606742],[-9.054521,39.605727],[-9.055798,39.606034],[-9.056288,39.605964],[-9.057887,39.607205],[-9.058281,39.60772],[-9.058375,39.609073],[-9.058886,39.609675],[-9.061986,39.610988],[-9.062554,39.611412],[-9.063271,39.610045],[-9.064155,39.609058],[-9.065849,39.607941],[-9.066913,39.607989],[-9.069494,39.606756],[-9.072149,39.606007],[-9.072898,39.606528],[-9.073598,39.606565],[-9.074129,39.607335],[-9.074823,39.607083],[-9.076583,39.605745],[-9.077818,39.605406],[-9.078315,39.604726],[-9.076441,39.604669],[-9.074447,39.605793],[-9.072836,39.605783],[-9.071125,39.606154],[-9.069473,39.606681],[-9.067072,39.607847],[-9.066445,39.607952],[-9.065871,39.607523],[-9.063947,39.609176],[-9.062457,39.611136],[-9.05906,39.609702],[-9.058482,39.609153],[-9.058273,39.60737],[-9.056177,39.60575],[-9.055917,39.605347],[-9.054425,39.605692],[-9.041045,39.606436],[-9.036918,39.606601],[-9.035794,39.606719],[-9.033329,39.606748],[-9.032273,39.606604],[-9.031286,39.60623],[-9.030214,39.605603],[-9.029523,39.604967],[-9.028695,39.603883],[-9.027885,39.603131],[-9.026636,39.602447],[-9.018963,39.59976],[-9.017121,39.598981],[-9.015568,39.597931],[-9.014527,39.597034],[-9.012858,39.594892],[-9.012797,39.594408],[-9.013344,39.593859],[-9.013295,39.593405],[-9.010889,39.590598],[-9.010933,39.589947],[-9.012951,39.588527],[-9.014509,39.587597],[-9.015455,39.587256],[-9.01456,39.586875],[-9.013146,39.585488],[-9.011934,39.582547],[-9.012153,39.582148],[-9.011717,39.581731],[-9.011051,39.582018],[-9.009598,39.582197],[-9.008838,39.582718],[-9.008644,39.584159],[-9.008718,39.585961],[-9.00914,39.58688],[-9.010063,39.587887],[-9.01058,39.588125],[-9.011145,39.587955],[-9.011704,39.58688],[-9.012414,39.586213],[-9.017297,39.583432],[-9.020796,39.5816],[-9.024282,39.579662],[-9.029416,39.576909],[-9.03364,39.574911],[-9.035071,39.573918],[-9.036037,39.572907],[-9.037669,39.570281],[-9.040486,39.565989],[-9.041265,39.564705],[-9.043358,39.56154],[-9.045252,39.558557],[-9.045967,39.55766],[-9.047101,39.556723],[-9.047978,39.556202],[-9.050562,39.554979],[-9.051848,39.554152],[-9.053494,39.552759],[-9.058239,39.548322],[-9.060963,39.5457],[-9.062401,39.543674],[-9.064225,39.540259],[-9.065785,39.538542],[-9.066632,39.537883],[-9.070164,39.535693],[-9.073331,39.533421],[-9.075614,39.531551],[-9.078819,39.528591],[-9.080095,39.52721],[-9.082709,39.523999],[-9.084121,39.52194],[-9.085313,39.520017],[-9.086723,39.517484],[-9.087544,39.515711],[-9.089003,39.511712],[-9.089678,39.509242],[-9.09028,39.505814],[-9.090721,39.50255],[-9.09134,39.499641],[-9.092448,39.495975],[-9.093181,39.494037],[-9.095176,39.490126],[-9.098027,39.485368],[-9.098986,39.483617],[-9.101882,39.478658],[-9.103277,39.476587],[-9.105721,39.473578],[-9.107273,39.471865],[-9.109691,39.469565],[-9.116037,39.463943],[-9.117303,39.462426],[-9.117918,39.461269],[-9.11836,39.460065],[-9.118926,39.457621],[-9.119836,39.454185],[-9.120106,39.452721],[-9.120851,39.449749],[-9.121911,39.446694],[-9.122557,39.445371],[-9.123453,39.443972],[-9.125591,39.44104],[-9.127791,39.43869],[-9.131486,39.435492],[-9.133018,39.434292],[-9.135951,39.431679],[-9.139841,39.428072],[-9.14274,39.425212],[-9.144635,39.423826],[-9.147031,39.422583],[-9.150453,39.42098],[-9.151306,39.420486],[-9.15254,39.419346],[-9.155235,39.415474],[-9.155984,39.413696],[-9.156063,39.412664],[-9.155812,39.411426],[-9.154824,39.409274],[-9.154468,39.407853],[-9.154504,39.406797],[-9.154746,39.405559],[-9.155634,39.402192],[-9.155655,39.400137],[-9.155337,39.398724],[-9.1546,39.396939],[-9.15284,39.393294],[-9.150391,39.388431],[-9.149291,39.386591],[-9.148429,39.385565],[-9.146593,39.384078],[-9.143792,39.382182],[-9.136686,39.377487],[-9.135601,39.376614],[-9.134838,39.375595],[-9.13431,39.374334],[-9.134224,39.373054],[-9.134345,39.372145],[-9.135411,39.368065],[-9.13634,39.366099],[-9.137849,39.364569],[-9.140597,39.362473],[-9.142618,39.36082],[-9.144397,39.359265],[-9.147441,39.356279],[-9.149716,39.354524],[-9.151606,39.353324],[-9.153698,39.351812],[-9.156253,39.34966],[-9.157653,39.348601],[-9.15982,39.347158],[-9.161529,39.346152],[-9.168562,39.342268],[-9.172349,39.340209],[-9.173366,39.339417],[-9.174018,39.338559],[-9.174458,39.337394],[-9.174524,39.336644],[-9.174194,39.33331],[-9.174361,39.33214],[-9.176293,39.324696],[-9.176497,39.323463],[-9.176448,39.322228],[-9.175677,39.318348],[-9.175605,39.316857],[-9.175771,39.314794],[-9.175606,39.313755],[-9.17522,39.312961],[-9.173888,39.311634],[-9.171067,39.309654],[-9.169936,39.308465],[-9.169413,39.307522],[-9.168898,39.305507],[-9.168566,39.304715],[-9.167355,39.303308],[-9.165583,39.302012],[-9.164421,39.300851],[-9.162989,39.298485],[-9.162019,39.297341],[-9.160755,39.296299],[-9.158572,39.29468],[-9.157737,39.293365],[-9.157513,39.292546],[-9.157532,39.291512],[-9.158198,39.289918],[-9.160853,39.286692],[-9.16512,39.281618],[-9.165892,39.280238],[-9.167281,39.275769],[-9.167497,39.274741],[-9.167457,39.272947],[-9.166131,39.267301],[-9.165764,39.265439],[-9.165078,39.259341],[-9.164819,39.256709],[-9.164768,39.255066],[-9.164942,39.254025],[-9.166735,39.24883],[-9.168118,39.245391],[-9.172469,39.237697],[-9.173725,39.236316],[-9.183647,39.229404],[-9.185069,39.228186],[-9.185612,39.227472],[-9.186294,39.225852],[-9.186852,39.221744],[-9.187012,39.219734],[-9.188313,39.208438],[-9.188779,39.206811],[-9.189606,39.205567],[-9.196134,39.198817],[-9.197838,39.197375],[-9.203551,39.193572],[-9.20496,39.192325],[-9.205851,39.191004],[-9.206306,39.189364],[-9.206276,39.188137],[-9.205845,39.186262],[-9.204466,39.181589],[-9.204128,39.179913],[-9.204274,39.17821],[-9.205113,39.176203],[-9.205939,39.175132],[-9.209177,39.171819],[-9.21203,39.168775],[-9.216098,39.16462],[-9.21759,39.163201],[-9.219928,39.161358],[-9.222175,39.159848],[-9.223765,39.158946],[-9.237415,39.151911],[-9.240309,39.150454],[-9.241876,39.149378],[-9.242341,39.148902],[-9.243714,39.146998],[-9.246292,39.143263],[-9.247702,39.141046],[-9.248264,39.139221],[-9.249198,39.131385],[-9.249526,39.130249],[-9.250253,39.128743],[-9.253907,39.123036],[-9.255061,39.121017],[-9.255409,39.120034],[-9.255484,39.119026],[-9.255111,39.117655],[-9.254645,39.116918],[-9.253281,39.11567],[-9.252219,39.115027],[-9.248091,39.11301],[-9.243715,39.110791],[-9.241892,39.109684],[-9.240984,39.108844],[-9.240113,39.107439],[-9.239867,39.106441],[-9.239844,39.105191],[-9.240453,39.099824],[-9.240523,39.098372],[-9.240307,39.097059],[-9.239697,39.095875],[-9.238534,39.094655],[-9.233687,39.090938],[-9.232793,39.090169],[-9.231795,39.088927],[-9.231369,39.087941],[-9.231254,39.085899],[-9.23219,39.082254],[-9.232345,39.080817],[-9.23196,39.079244],[-9.230819,39.0771],[-9.230235,39.075682],[-9.230045,39.074618],[-9.230081,39.0736],[-9.230674,39.071735],[-9.231758,39.069549],[-9.232379,39.068628],[-9.234173,39.067417],[-9.237156,39.066223],[-9.238505,39.065261],[-9.239258,39.064325],[-9.239771,39.063051],[-9.239851,39.061926],[-9.239115,39.055595],[-9.238891,39.054672],[-9.238011,39.052317],[-9.237709,39.051126],[-9.237492,39.048953],[-9.237977,39.044607],[-9.237884,39.042409],[-9.237651,39.041418],[-9.237112,39.040107],[-9.235804,39.038184],[-9.23422,39.036699],[-9.231772,39.035164],[-9.22909,39.033802],[-9.228241,39.033287],[-9.225944,39.031564],[-9.22444,39.030691],[-9.220656,39.029196],[-9.218972,39.028346],[-9.217982,39.027564],[-9.217296,39.026727],[-9.216868,39.025838],[-9.216592,39.024301],[-9.216878,39.022802],[-9.217421,39.021027],[-9.217628,39.019708],[-9.217247,39.018147],[-9.216508,39.017131],[-9.214412,39.015177],[-9.213221,39.013714],[-9.212407,39.011882],[-9.212174,39.009979],[-9.212371,39.008513],[-9.2134,39.005232],[-9.214391,39.00241],[-9.214681,39.00182],[-9.216456,38.996661],[-9.216592,38.995241],[-9.21635,38.99344],[-9.215853,38.991693],[-9.215758,38.98973],[-9.216558,38.987682],[-9.217996,38.98528],[-9.21937,38.982739],[-9.220782,38.98039],[-9.222065,38.978068],[-9.222672,38.976529],[-9.222701,38.974593],[-9.222256,38.973416],[-9.221109,38.971949],[-9.220189,38.971243],[-9.217777,38.969682],[-9.216289,38.968358],[-9.213548,38.965076],[-9.21255,38.963463],[-9.21228,38.962476],[-9.212265,38.961056],[-9.212617,38.959685],[-9.213634,38.957639],[-9.214037,38.956308],[-9.214093,38.955342],[-9.21391,38.954183],[-9.212887,38.951841],[-9.211725,38.949705],[-9.210231,38.946501],[-9.210054,38.944828],[-9.210161,38.944196],[-9.210962,38.942616],[-9.211962,38.941593],[-9.21295,38.940905],[-9.216619,38.938913],[-9.217614,38.938219],[-9.218442,38.937366],[-9.219193,38.936034],[-9.219429,38.935028],[-9.219306,38.933285],[-9.218868,38.932191],[-9.217637,38.929886],[-9.217182,38.928214],[-9.217213,38.925882],[-9.217084,38.924847],[-9.216442,38.923517],[-9.215205,38.922046],[-9.212925,38.919715],[-9.211955,38.918323],[-9.21127,38.917064],[-9.209947,38.913613],[-9.209464,38.912765],[-9.208127,38.910977],[-9.207293,38.910087],[-9.206549,38.90902],[-9.20583,38.907446],[-9.205245,38.905388],[-9.204691,38.904202],[-9.203516,38.902585],[-9.200863,38.900185],[-9.200013,38.899129],[-9.198414,38.896428],[-9.197035,38.894675],[-9.196554,38.893773],[-9.196206,38.892241],[-9.196003,38.889553],[-9.195952,38.887479],[-9.196033,38.886688],[-9.197007,38.882645],[-9.197697,38.880608],[-9.199545,38.877096],[-9.201383,38.87411],[-9.201787,38.873146],[-9.201979,38.872123],[-9.201881,38.870655],[-9.201049,38.86864],[-9.200091,38.867135],[-9.198502,38.865156],[-9.197355,38.864042],[-9.196314,38.863411],[-9.194359,38.862716],[-9.190363,38.862245],[-9.189388,38.861999],[-9.187804,38.861299],[-9.186492,38.860244],[-9.18544,38.858861],[-9.184864,38.856742],[-9.184307,38.855401],[-9.18306,38.853901],[-9.180923,38.852495],[-9.178788,38.851767],[-9.178343,38.85134],[-9.178703,38.850665],[-9.181196,38.850185],[-9.182013,38.849865],[-9.183551,38.848898],[-9.184761,38.847356],[-9.185473,38.845329],[-9.186113,38.843845],[-9.186798,38.842615],[-9.187971,38.839963],[-9.188978,38.837267],[-9.189543,38.835274],[-9.190667,38.830162],[-9.191643,38.826603],[-9.192343,38.825419],[-9.193789,38.823663],[-9.195244,38.822412],[-9.197487,38.821101],[-9.204139,38.81731],[-9.205354,38.816516],[-9.207551,38.815291],[-9.209451,38.814558],[-9.214784,38.813677],[-9.218981,38.812773],[-9.220747,38.812186],[-9.224145,38.810504],[-9.225567,38.810037],[-9.229232,38.80938],[-9.232553,38.808911],[-9.234911,38.808128],[-9.236066,38.807353],[-9.23709,38.80639],[-9.237855,38.80525],[-9.238195,38.80444],[-9.238479,38.80241],[-9.239075,38.796522],[-9.239544,38.7951],[-9.240462,38.793594],[-9.2414,38.791541],[-9.24195,38.789527],[-9.24207,38.788263],[-9.242468,38.786412],[-9.243161,38.784816],[-9.243909,38.783714],[-9.24517,38.782344],[-9.247607,38.780381],[-9.248118,38.779861],[-9.249876,38.777485],[-9.250521,38.77682],[-9.251889,38.775787],[-9.25375,38.774848],[-9.258471,38.77347],[-9.264839,38.77178],[-9.266222,38.771229],[-9.267433,38.770437],[-9.268446,38.769433],[-9.269216,38.768079],[-9.269665,38.76557],[-9.270296,38.7605],[-9.270953,38.757682],[-9.272004,38.754424],[-9.272789,38.751082],[-9.273192,38.748709],[-9.273749,38.747429],[-9.275723,38.744134],[-9.27597,38.743567],[-9.276214,38.742023],[-9.276561,38.740885],[-9.277506,38.739429],[-9.278068,38.73808],[-9.278094,38.73685],[-9.277856,38.736039],[-9.277271,38.735091],[-9.275692,38.733377],[-9.27515,38.732643],[-9.274582,38.731258],[-9.274222,38.728324],[-9.273392,38.722466],[-9.272903,38.721515],[-9.270412,38.71831],[-9.270266,38.717392],[-9.270637,38.716804],[-9.271348,38.716402],[-9.274689,38.715994],[-9.288785,38.713782],[-9.290606,38.713575],[-9.292987,38.713496],[-9.297282,38.713714],[-9.300762,38.713633],[-9.304205,38.713081],[-9.306914,38.712299],[-9.308341,38.711728],[-9.311908,38.709876],[-9.313065,38.709332],[-9.314999,38.708633],[-9.317762,38.708055],[-9.320969,38.707831],[-9.325397,38.708089],[-9.328676,38.708124],[-9.334228,38.708098],[-9.343891,38.708013],[-9.345768,38.708245],[-9.347791,38.708804],[-9.349539,38.709638],[-9.355264,38.713087],[-9.356219,38.713825],[-9.3587,38.716198],[-9.360547,38.717363],[-9.362511,38.718156],[-9.36462,38.71862],[-9.36671,38.718803],[-9.368067,38.718781],[-9.372274,38.718173],[-9.374094,38.718034],[-9.376234,38.71804],[-9.37964,38.718177],[-9.382254,38.717994],[-9.38541,38.71749],[-9.387928,38.717397],[-9.389643,38.717652],[-9.392796,38.718319],[-9.394378,38.719295],[-9.398223,38.723436],[-9.399281,38.724493],[-9.400775,38.725586],[-9.402548,38.72641],[-9.404809,38.726948],[-9.406419,38.727043],[-9.408395,38.726977],[-9.408776,38.726789],[-9.412369,38.725763],[-9.414535,38.725678],[-9.416158,38.726035],[-9.4181,38.726869],[-9.420067,38.727362],[-9.422065,38.7273],[-9.423048,38.727086],[-9.433019,38.724198],[-9.435712,38.723467],[-9.436838,38.723085],[-9.440027,38.722217],[-9.442374,38.721873],[-9.442982,38.722297],[-9.442586,38.722593],[-9.441876,38.722319],[-9.442965,38.724324],[-9.443209,38.725647],[-9.443474,38.726174],[-9.443518,38.72723],[-9.445031,38.730698],[-9.445475,38.731978],[-9.446771,38.733028],[-9.447138,38.733484],[-9.447901,38.735462],[-9.448149,38.736491],[-9.44975,38.738764],[-9.450459,38.740458],[-9.451315,38.741284],[-9.451674,38.74203],[-9.450873,38.743745],[-9.450418,38.744403],[-9.449828,38.745977],[-9.449266,38.748127],[-9.449012,38.750842],[-9.448426,38.752417],[-9.448445,38.752841],[-9.449122,38.753183],[-9.450209,38.753046],[-9.451694,38.752346],[-9.452929,38.753143],[-9.453614,38.75306],[-9.455105,38.752183],[-9.455604,38.75211],[-9.457476,38.752817],[-9.457411,38.753197],[-9.456586,38.754625],[-9.456733,38.755085],[-9.457856,38.75565],[-9.458027,38.756731],[-9.458958,38.757415],[-9.459249,38.75794],[-9.459188,38.75873],[-9.45991,38.758753],[-9.460684,38.757456],[-9.461773,38.757621],[-9.462685,38.758359],[-9.464184,38.758704],[-9.465002,38.75943],[-9.46515,38.759877],[-9.465061,38.761084],[-9.465434,38.76157],[-9.466064,38.761632],[-9.467133,38.761268],[-9.46761,38.761383],[-9.46835,38.762201],[-9.4697,38.76265],[-9.471042,38.764739],[-9.472002,38.76527],[-9.473311,38.76657],[-9.473293,38.767693],[-9.473587,38.768747],[-9.473711,38.770315],[-9.473458,38.770741],[-9.472337,38.771329],[-9.470104,38.772866],[-9.471165,38.773326],[-9.471986,38.77397],[-9.472511,38.773959],[-9.473641,38.773233],[-9.475508,38.772873],[-9.476113,38.77318],[-9.476815,38.772158],[-9.477308,38.771866],[-9.477946,38.771938],[-9.478714,38.772578],[-9.479961,38.774233],[-9.481255,38.776158],[-9.482074,38.777071],[-9.482784,38.778395],[-9.482217,38.779696],[-9.482474,38.780324],[-9.482921,38.780581],[-9.484013,38.780481],[-9.48427,38.78078],[-9.484305,38.781912],[-9.484939,38.782604],[-9.485898,38.782948],[-9.487468,38.783146],[-9.488445,38.784678],[-9.488766,38.785608],[-9.489791,38.787145],[-9.489691,38.786614],[-9.488675,38.785326],[-9.488483,38.784564],[-9.487438,38.783075],[-9.485989,38.78289],[-9.485004,38.782539],[-9.484294,38.781815],[-9.484319,38.780802],[-9.484015,38.780481],[-9.482791,38.780544],[-9.482212,38.779761],[-9.482778,38.778429],[-9.482122,38.777143],[-9.48134,38.776262],[-9.480064,38.774356],[-9.478763,38.77263],[-9.477999,38.771976],[-9.477108,38.771863],[-9.476045,38.77299],[-9.475586,38.772733],[-9.474431,38.772843],[-9.473661,38.773102],[-9.472566,38.773795],[-9.471964,38.773829],[-9.471076,38.773204],[-9.470274,38.772971],[-9.47019,38.772541],[-9.471535,38.771972],[-9.473377,38.770875],[-9.47374,38.770524],[-9.473808,38.769082],[-9.473489,38.767761],[-9.473485,38.766504],[-9.472916,38.765824],[-9.471272,38.764699],[-9.469899,38.762639],[-9.468613,38.762205],[-9.467762,38.761366],[-9.467212,38.761238],[-9.466164,38.761586],[-9.465366,38.761449],[-9.46513,38.761037],[-9.4651,38.759333],[-9.464329,38.758632],[-9.463157,38.758466],[-9.462085,38.757679],[-9.461054,38.757277],[-9.460667,38.757486],[-9.459953,38.758691],[-9.459158,38.758535],[-9.459192,38.757498],[-9.458154,38.756625],[-9.458023,38.755734],[-9.457731,38.755383],[-9.456591,38.754789],[-9.457548,38.753078],[-9.457471,38.752646],[-9.455621,38.75208],[-9.455033,38.752178],[-9.453301,38.753144],[-9.452977,38.753097],[-9.45196,38.752263],[-9.450677,38.752696],[-9.450247,38.752525],[-9.450102,38.75295],[-9.449543,38.753116],[-9.44872,38.752963],[-9.448485,38.75253],[-9.44902,38.751362],[-9.449269,38.750418],[-9.449361,38.748761],[-9.449699,38.747259],[-9.450492,38.744719],[-9.451177,38.743554],[-9.451846,38.741972],[-9.451423,38.741265],[-9.450501,38.740369],[-9.449994,38.738938],[-9.448204,38.736333],[-9.448036,38.735414],[-9.447292,38.733527],[-9.446832,38.732901],[-9.445769,38.732075],[-9.44536,38.731549],[-9.445149,38.730499],[-9.443648,38.727335],[-9.443648,38.726652],[-9.44302,38.724258],[-9.44202,38.722403],[-9.441889,38.720904],[-9.441385,38.721604],[-9.436299,38.723028],[-9.427162,38.725784],[-9.422214,38.727116],[-9.42081,38.727217],[-9.419181,38.727061],[-9.418278,38.726783],[-9.415956,38.72584],[-9.414929,38.725604],[-9.413349,38.725507],[-9.412302,38.725611],[-9.408545,38.72666],[-9.405899,38.726846],[-9.404121,38.726636],[-9.402278,38.726089],[-9.400623,38.725246],[-9.398989,38.723931],[-9.394688,38.719421],[-9.393317,38.718415],[-9.392366,38.718032],[-9.390634,38.717638],[-9.388259,38.717274],[-9.386159,38.717214],[-9.383258,38.71765],[-9.380098,38.717959],[-9.375775,38.717825],[-9.372717,38.717925],[-9.368435,38.71854],[-9.366699,38.718619],[-9.365316,38.71853],[-9.363139,38.718107],[-9.36202,38.717755],[-9.360335,38.716995],[-9.359385,38.716423],[-9.357914,38.715202],[-9.355883,38.713243],[-9.35476,38.71248],[-9.350984,38.71026],[-9.348607,38.708923],[-9.347388,38.708457],[-9.345681,38.708019],[-9.343429,38.707812],[-9.337606,38.707816],[-9.335118,38.707756],[-9.332703,38.707784],[-9.331276,38.707916],[-9.330091,38.707878],[-9.325713,38.707938],[-9.320978,38.707598],[-9.318642,38.70771],[-9.316316,38.708061],[-9.314117,38.708661],[-9.312517,38.709303],[-9.308585,38.711327],[-9.306915,38.712039],[-9.304775,38.712719],[-9.303023,38.713108],[-9.300422,38.713443],[-9.298436,38.713536],[-9.296015,38.713465],[-9.294023,38.71331],[-9.291482,38.713322],[-9.289008,38.713541],[-9.28725,38.71378],[-9.282898,38.714514],[-9.27827,38.71514],[-9.274529,38.715806],[-9.272632,38.716052],[-9.270229,38.716001],[-9.267989,38.715545],[-9.265346,38.7143],[-9.263185,38.713669],[-9.261871,38.713545],[-9.257627,38.713503],[-9.255752,38.713773],[-9.254807,38.714096],[-9.25347,38.714874],[-9.252767,38.715591],[-9.250689,38.718118],[-9.249479,38.719233],[-9.248444,38.719869],[-9.246731,38.720539],[-9.245286,38.720807],[-9.243517,38.72089],[-9.241534,38.720552],[-9.239693,38.719891],[-9.234237,38.717459],[-9.231496,38.716667],[-9.228656,38.716147],[-9.226887,38.716081],[-9.224711,38.716169],[-9.219624,38.716657],[-9.219076,38.716884],[-9.21768,38.718723],[-9.211779,38.72165],[-9.21033,38.722573],[-9.209488,38.723521],[-9.208986,38.724675],[-9.208913,38.725378],[-9.209196,38.726725],[-9.210033,38.728809],[-9.210049,38.730069],[-9.20954,38.731136],[-9.20842,38.732824],[-9.207096,38.735039],[-9.204384,38.738983],[-9.203519,38.739242],[-9.202379,38.740399],[-9.200274,38.740781],[-9.199344,38.741326],[-9.196382,38.744267],[-9.194871,38.745063],[-9.191735,38.746011],[-9.191026,38.74634],[-9.189985,38.747294],[-9.188688,38.750158],[-9.187831,38.751668],[-9.186509,38.753255],[-9.185043,38.754536],[-9.182533,38.756002],[-9.181166,38.7566],[-9.179083,38.757188],[-9.177171,38.757491],[-9.174446,38.75758],[-9.17151,38.757359],[-9.167099,38.757157],[-9.165202,38.757225],[-9.163375,38.757509],[-9.154852,38.759576],[-9.150269,38.76116],[-9.148161,38.761787],[-9.143317,38.76275],[-9.139602,38.763114],[-9.132522,38.762989],[-9.130756,38.763293],[-9.129333,38.763823],[-9.127713,38.764885],[-9.125815,38.766673],[-9.124987,38.767708],[-9.124032,38.769587],[-9.125752,38.770133],[-9.127602,38.770172],[-9.127936,38.770713],[-9.128276,38.770542],[-9.127574,38.767605],[-9.127851,38.767227],[-9.128814,38.76705],[-9.128908,38.767633],[-9.128337,38.768063],[-9.127228,38.768393],[-9.127473,38.769821],[-9.126531,38.769903],[-9.125816,38.769673],[-9.125866,38.770144],[-9.126559,38.770023],[-9.127608,38.770159],[-9.128251,38.770511],[-9.127551,38.767973],[-9.127832,38.767168],[-9.128902,38.767057],[-9.129227,38.768046],[-9.128818,38.768564],[-9.129017,38.76892],[-9.129679,38.768722],[-9.129201,38.766837],[-9.128947,38.76684],[-9.128926,38.767646],[-9.12829,38.768076],[-9.127251,38.768426],[-9.127869,38.770519],[-9.128277,38.770676],[-9.128108,38.770028],[-9.119934,38.769027],[-9.120487,38.768473],[-9.119529,38.767967],[-9.11986,38.766411],[-9.118846,38.763676],[-9.119031,38.763193],[-9.120336,38.762176],[-9.120723,38.761581],[-9.121353,38.761405],[-9.125883,38.762723],[-9.127744,38.762999],[-9.129461,38.763098],[-9.130795,38.76292],[-9.131447,38.76299],[-9.132722,38.763512],[-9.134146,38.76355],[-9.13635,38.763177],[-9.140221,38.763293],[-9.145793,38.762522],[-9.149047,38.76171],[-9.154942,38.759729],[-9.160941,38.758239],[-9.162579,38.757459],[-9.164761,38.75722],[-9.1651,38.757317],[-9.167142,38.757268],[-9.172952,38.757595],[-9.173403,38.757919],[-9.173289,38.758353],[-9.172523,38.758296],[-9.171984,38.757158],[-9.171567,38.755395],[-9.17175,38.755214],[-9.171054,38.753883],[-9.168378,38.750227],[-9.16796,38.750182],[-9.167282,38.749353],[-9.171867,38.705696],[-9.169146,38.704632],[-9.167866,38.70484],[-9.167429,38.7074],[-9.166852,38.708948],[-9.166415,38.709481],[-9.164302,38.711321],[-9.163925,38.711454],[-9.162861,38.710775],[-9.160501,38.711937],[-9.161573,38.712182],[-9.163189,38.710883],[-9.165157,38.712669],[-9.165856,38.712857],[-9.166906,38.712636],[-9.168486,38.712671],[-9.16947,38.71509],[-9.169999,38.71513],[-9.171833,38.7157],[-9.172619,38.716145],[-9.171226,38.719003],[-9.171549,38.719151],[-9.172486,38.718634],[-9.172477,38.719029],[-9.171522,38.719483],[-9.170549,38.720458],[-9.173726,38.719703],[-9.174203,38.718609],[-9.174713,38.718558],[-9.175362,38.721165],[-9.175235,38.722012],[-9.174793,38.723146],[-9.174262,38.723784],[-9.172536,38.724912],[-9.171918,38.726572],[-9.171926,38.727636],[-9.171461,38.728662],[-9.170213,38.729988],[-9.169013,38.731676],[-9.16853,38.732856],[-9.168644,38.733861],[-9.169095,38.734705],[-9.170744,38.73662],[-9.171271,38.738075],[-9.171019,38.73932],[-9.170593,38.740018],[-9.169377,38.741015],[-9.166761,38.742407],[-9.16578,38.743051],[-9.165008,38.74409],[-9.164833,38.744903],[-9.164972,38.74572],[-9.165579,38.746862],[-9.170479,38.753388],[-9.171207,38.754513],[-9.171601,38.755483],[-9.171555,38.755928],[-9.170455,38.756964],[-9.169348,38.757266],[-9.166039,38.757169],[-9.163556,38.757443],[-9.159691,38.758405],[-9.155586,38.759354],[-9.1541,38.75978],[-9.149202,38.761456],[-9.147748,38.761855],[-9.145074,38.762415],[-9.142769,38.762818],[-9.140981,38.763023],[-9.139028,38.763096],[-9.133373,38.762983],[-9.131606,38.762703],[-9.130879,38.762189],[-9.129391,38.762756],[-9.129103,38.763085],[-9.129431,38.763578],[-9.129007,38.767416],[-9.129277,38.76678],[-9.129604,38.764771],[-9.129975,38.764422],[-9.133136,38.763868],[-9.136445,38.763605],[-9.138087,38.763572],[-9.138199,38.76379],[-9.130352,38.764384],[-9.129833,38.764476],[-9.129536,38.765097],[-9.129305,38.766639],[-9.129083,38.766486],[-9.12932,38.765663],[-9.129552,38.76356],[-9.129885,38.762859],[-9.128905,38.762932],[-9.126941,38.762778],[-9.125861,38.76254],[-9.12164,38.761303],[-9.120893,38.761135],[-9.118008,38.760172],[-9.112732,38.758578],[-9.112441,38.75856],[-9.107089,38.756959],[-9.104189,38.756052],[-9.10301,38.755764],[-9.102975,38.755966],[-9.103527,38.761164],[-9.103857,38.76346],[-9.104509,38.770489],[-9.104642,38.772661],[-9.104996,38.774613],[-9.105448,38.774753],[-9.105821,38.774236],[-9.105837,38.772921],[-9.107849,38.771477],[-9.10906,38.771061],[-9.11006,38.770506],[-9.109241,38.770066],[-9.110315,38.768318],[-9.109456,38.763324],[-9.109601,38.762532],[-9.110211,38.761979],[-9.112015,38.761038],[-9.1116,38.759839],[-9.111965,38.758902],[-9.112601,38.758765],[-9.115866,38.759698],[-9.119537,38.760886],[-9.120529,38.761356],[-9.12123,38.761264],[-9.121123,38.76082],[-9.120274,38.760816],[-9.118334,38.760338],[-9.114279,38.75906],[-9.113613,38.758518],[-9.114745,38.758292],[-9.11377,38.758105],[-9.113594,38.758701],[-9.112764,38.758658],[-9.107747,38.757116],[-9.103058,38.755778],[-9.103215,38.758142],[-9.10422,38.767347],[-9.104803,38.773314],[-9.105393,38.774428],[-9.105351,38.777306],[-9.105059,38.780036],[-9.105186,38.781317],[-9.104987,38.7826],[-9.105201,38.783035],[-9.10646,38.783931],[-9.106838,38.784616],[-9.106787,38.785125],[-9.106218,38.785686],[-9.104513,38.785987],[-9.09891,38.786526],[-9.096665,38.786653],[-9.094926,38.786578],[-9.085262,38.785487],[-9.079633,38.78475],[-9.077052,38.784217],[-9.074116,38.783368],[-9.071068,38.78215],[-9.069007,38.781091],[-9.067428,38.780149],[-9.06515,38.778563],[-9.06337,38.777216],[-9.058858,38.773929],[-9.046735,38.76489],[-9.041917,38.761277],[-9.038621,38.758894],[-9.029599,38.752085],[-9.021455,38.746079],[-9.009314,38.737011],[-9.007564,38.735831],[-9.004624,38.734012],[-9.001113,38.732189],[-8.989388,38.727138],[-8.987721,38.726596],[-8.985469,38.72603],[-8.982477,38.725579],[-8.978123,38.725289],[-8.976526,38.725113],[-8.974409,38.724744],[-8.971063,38.723816],[-8.96456,38.721703],[-8.958875,38.719501],[-8.952084,38.717764],[-8.950587,38.717429],[-8.947521,38.717085],[-8.945296,38.717093],[-8.940982,38.717319],[-8.939134,38.717243],[-8.935363,38.716962],[-8.933725,38.717031],[-8.932098,38.71725],[-8.93002,38.717746],[-8.927289,38.718809],[-8.924923,38.719547],[-8.923019,38.719839],[-8.921614,38.71986],[-8.920267,38.719736],[-8.918714,38.719401],[-8.916238,38.718417],[-8.915133,38.717749],[-8.91042,38.713689],[-8.909145,38.712479],[-8.908101,38.711157],[-8.90715,38.709351],[-8.905128,38.702959],[-8.904288,38.700946],[-8.902193,38.69658],[-8.901481,38.694967],[-8.898814,38.689393],[-8.897365,38.686461],[-8.895295,38.682005],[-8.894403,38.679209],[-8.894122,38.677271],[-8.894093,38.675539],[-8.894926,38.664804],[-8.895191,38.66315],[-8.89501,38.661302],[-8.894227,38.65957],[-8.893923,38.658325],[-8.8943,38.657444],[-8.895479,38.656701],[-8.897147,38.65617],[-8.899665,38.654829],[-8.901124,38.654134],[-8.902842,38.653501],[-8.90448,38.653282],[-8.909201,38.653203],[-8.91065,38.653113],[-8.913095,38.652454],[-8.91378,38.652064],[-8.914658,38.651177],[-8.916546,38.650506],[-8.916537,38.650302],[-8.915291,38.647509],[-8.914981,38.646202],[-8.914862,38.641956],[-8.914598,38.634236],[-8.914475,38.63183],[-8.914782,38.631521],[-8.911202,38.63159],[-8.91099,38.631474],[-8.90957,38.631698],[-8.904019,38.633495],[-8.887736,38.638885],[-8.886938,38.63939],[-8.885556,38.640836],[-8.884694,38.641144],[-8.880091,38.641162],[-8.879413,38.641244],[-8.872869,38.651423],[-8.8685,38.658028],[-8.866297,38.661231],[-8.864627,38.663401],[-8.864311,38.663953],[-8.863582,38.666183],[-8.862038,38.669667],[-8.861641,38.66984],[-8.860315,38.669637],[-8.851406,38.66688],[-8.850805,38.666818],[-8.849224,38.667282],[-8.845672,38.667832],[-8.845031,38.667737],[-8.835946,38.664786],[-8.83186,38.663429],[-8.827778,38.662163],[-8.816787,38.658525],[-8.810585,38.656537],[-8.804847,38.65463],[-8.799495,38.652919],[-8.79422,38.651184],[-8.788805,38.64936],[-8.779686,38.646398],[-8.775454,38.644971],[-8.770945,38.6435],[-8.768756,38.642727],[-8.763174,38.640862],[-8.753221,38.637655],[-8.751346,38.636999],[-8.744754,38.634833],[-8.742173,38.634637],[-8.741844,38.634079],[-8.736161,38.62921],[-8.722295,38.619844],[-8.71926,38.617809],[-8.718672,38.617331],[-8.714914,38.612657],[-8.711018,38.60775],[-8.701142,38.595415],[-8.700366,38.594611],[-8.693269,38.589923],[-8.692855,38.589345],[-8.692159,38.584571],[-8.691383,38.584096],[-8.69014,38.583724],[-8.688782,38.582872],[-8.688653,38.582462],[-8.687324,38.582283],[-8.681523,38.580494],[-8.670367,38.576911],[-8.668516,38.575914],[-8.667385,38.574948],[-8.66213,38.570208],[-8.659558,38.567936],[-8.658753,38.56703],[-8.656707,38.564263],[-8.656141,38.563064],[-8.655322,38.559686],[-8.65375,38.557032],[-8.65187,38.555189],[-8.651015,38.554207],[-8.650558,38.553248],[-8.649743,38.551042],[-8.647983,38.546819],[-8.647496,38.545843],[-8.643069,38.540176],[-8.642499,38.539522],[-8.6412,38.538566],[-8.634129,38.534749],[-8.632471,38.533681],[-8.627258,38.530009],[-8.624382,38.527191],[-8.623649,38.526653],[-8.620004,38.52432],[-8.61929,38.523707],[-8.61577,38.52028],[-8.615332,38.519785],[-8.614674,38.518455],[-8.614012,38.515475],[-8.613518,38.514257],[-8.612726,38.513352],[-8.604153,38.505067],[-8.603357,38.50412],[-8.602614,38.502656],[-8.600946,38.495938],[-8.600019,38.491921],[-8.597569,38.482188],[-8.597308,38.481541],[-8.595719,38.478885],[-8.594211,38.476533],[-8.593593,38.475893],[-8.585812,38.470046],[-8.58458,38.468666],[-8.58292,38.465526],[-8.582323,38.464741],[-8.581483,38.464041],[-8.577102,38.461507],[-8.571326,38.459261],[-8.56797,38.458008],[-8.560707,38.455396],[-8.554898,38.452168],[-8.550942,38.449499],[-8.54975,38.448506],[-8.544393,38.442827],[-8.539484,38.437743],[-8.536416,38.434612],[-8.53498,38.433673],[-8.533779,38.433179],[-8.52866,38.431526],[-8.526999,38.430914],[-8.523299,38.42968],[-8.521637,38.428716],[-8.519859,38.427173],[-8.519148,38.426053],[-8.518579,38.424509],[-8.517718,38.41908],[-8.516898,38.413418],[-8.516087,38.408156],[-8.516016,38.406836],[-8.516331,38.40452],[-8.516865,38.402859],[-8.519415,38.397003],[-8.521426,38.392506],[-8.522889,38.388854],[-8.524576,38.383543],[-8.525284,38.381462],[-8.526832,38.376569],[-8.527014,38.375124],[-8.526826,38.37366],[-8.526538,38.372786],[-8.524888,38.36864],[-8.523374,38.364595],[-8.521814,38.360574],[-8.52149,38.359339],[-8.521417,38.358106],[-8.521548,38.354918],[-8.521378,38.353584],[-8.520782,38.352018],[-8.519134,38.34867],[-8.51856,38.347011],[-8.518455,38.345838],[-8.518788,38.343885],[-8.522477,38.332292],[-8.522846,38.331027],[-8.525103,38.323952],[-8.527084,38.317934],[-8.528432,38.313252],[-8.529762,38.309176],[-8.530701,38.30592],[-8.531836,38.302506],[-8.533902,38.295814],[-8.53424,38.294597],[-8.535471,38.290829],[-8.537179,38.285322],[-8.538048,38.282386],[-8.538924,38.279763],[-8.543013,38.266453],[-8.546014,38.256964],[-8.547584,38.251816],[-8.54938,38.246183],[-8.550561,38.242198],[-8.552892,38.234866],[-8.554094,38.230987],[-8.556889,38.222143],[-8.557334,38.220541],[-8.55884,38.215692],[-8.559572,38.21348],[-8.560908,38.20911],[-8.56166,38.207688],[-8.563421,38.206373],[-8.56485,38.205572],[-8.56675,38.205281],[-8.568439,38.20526],[-8.574067,38.205465],[-8.577505,38.205628],[-8.579528,38.205647],[-8.580803,38.205527],[-8.583007,38.205057],[-8.584384,38.204594],[-8.590884,38.2018],[-8.595337,38.199787],[-8.598479,38.198714],[-8.600939,38.198231],[-8.602434,38.198064],[-8.60414,38.198018],[-8.610401,38.198153],[-8.614215,38.198054],[-8.615861,38.197871],[-8.618303,38.197357],[-8.620247,38.196725],[-8.621702,38.196096],[-8.623376,38.195201],[-8.624592,38.194364],[-8.625949,38.19318],[-8.627773,38.191081],[-8.629281,38.188416],[-8.630172,38.186979],[-8.631705,38.185263],[-8.633185,38.184217],[-8.635038,38.18315],[-8.639853,38.180539],[-8.641566,38.179228],[-8.642355,38.178314],[-8.643312,38.176502],[-8.643524,38.17542],[-8.64367,38.17286],[-8.644455,38.170227],[-8.646974,38.163887],[-8.648234,38.160584],[-8.649072,38.157834],[-8.649532,38.15466],[-8.649783,38.148998],[-8.650142,38.147026],[-8.650634,38.145084],[-8.651657,38.142092],[-8.652077,38.14038],[-8.652331,38.137133],[-8.652188,38.13542],[-8.651364,38.131629],[-8.651127,38.129525],[-8.65114,38.128508],[-8.651731,38.123851],[-8.651817,38.122647],[-8.651767,38.121002],[-8.651525,38.119523],[-8.650705,38.117073],[-8.649719,38.115331],[-8.648885,38.114206],[-8.647596,38.112786],[-8.64669,38.111951],[-8.64322,38.109063],[-8.641479,38.107335],[-8.640231,38.105356],[-8.63964,38.103638],[-8.639444,38.101674],[-8.639352,38.096948],[-8.639445,38.09525],[-8.639961,38.092733],[-8.641445,38.088614],[-8.642203,38.086357],[-8.642483,38.084467],[-8.642526,38.080723],[-8.642834,38.079203],[-8.643277,38.078149],[-8.644142,38.076785],[-8.645076,38.075738],[-8.645971,38.074976],[-8.647571,38.073992],[-8.649555,38.073179],[-8.654491,38.071775],[-8.656066,38.071439],[-8.658506,38.071088],[-8.661016,38.070931],[-8.663263,38.070963],[-8.668506,38.070911],[-8.672551,38.070658],[-8.675117,38.070309],[-8.690296,38.067586],[-8.692987,38.067057],[-8.695885,38.066288],[-8.699764,38.064936],[-8.705856,38.062607],[-8.707705,38.062052],[-8.710764,38.061341],[-8.712974,38.060663],[-8.714183,38.060109],[-8.715431,38.059326],[-8.717887,38.05743],[-8.719483,38.056514],[-8.720751,38.056011],[-8.726137,38.054235],[-8.728323,38.053078],[-8.730354,38.051381],[-8.733416,38.048123],[-8.734299,38.047058],[-8.735581,38.045213],[-8.736281,38.043895],[-8.737096,38.041837],[-8.741158,38.027746],[-8.741805,38.024688],[-8.741987,38.023159],[-8.742141,38.020722],[-8.742242,38.003569],[-8.742841,38.002031],[-8.743983,38.000961],[-8.74541,38.000028],[-8.746795,37.99948],[-8.748347,37.999068],[-8.759757,37.995617],[-8.763451,37.994216],[-8.765843,37.993083],[-8.771089,37.990108],[-8.773822,37.988845],[-8.778004,37.987305],[-8.780604,37.986272],[-8.783829,37.98465],[-8.786465,37.983219],[-8.78819,37.982386],[-8.791767,37.981002],[-8.796301,37.979686],[-8.798638,37.978889],[-8.800343,37.978138],[-8.802431,37.977],[-8.804234,37.975853],[-8.805678,37.975099],[-8.806961,37.97458],[-8.809131,37.973992],[-8.810874,37.973734],[-8.813227,37.97363],[-8.817229,37.973567],[-8.819191,37.973284],[-8.821563,37.972652],[-8.82422,37.971636],[-8.827034,37.970689],[-8.830102,37.969509],[-8.83135,37.96976],[-8.832366,37.96956],[-8.832975,37.96882],[-8.832712,37.967924],[-8.831776,37.967387],[-8.830614,37.965547],[-8.827724,37.962564],[-8.826467,37.961],[-8.825549,37.959622],[-8.823654,37.955743],[-8.823121,37.954377],[-8.823234,37.953322],[-8.822781,37.952433],[-8.822789,37.951359],[-8.823308,37.9494],[-8.824168,37.947836],[-8.825801,37.945796],[-8.828405,37.942681],[-8.829991,37.941148],[-8.830632,37.940375],[-8.831477,37.939996],[-8.83145,37.939381],[-8.830087,37.938791],[-8.827892,37.938315],[-8.824745,37.936983],[-8.820861,37.935404],[-8.809694,37.930752],[-8.802486,37.927694],[-8.799331,37.925085],[-8.796732,37.923236],[-8.788866,37.917443],[-8.78559,37.915099],[-8.778896,37.910144],[-8.775497,37.907546],[-8.774423,37.906349],[-8.773893,37.906004],[-8.771798,37.905346],[-8.771443,37.904896],[-8.77118,37.902872],[-8.770967,37.902145],[-8.770371,37.901703],[-8.769933,37.900715],[-8.769277,37.898109],[-8.769012,37.897533],[-8.768323,37.8968],[-8.765626,37.894844],[-8.763598,37.893274],[-8.761773,37.891967],[-8.756202,37.887854],[-8.756597,37.886168],[-8.758577,37.880564],[-8.758866,37.879912],[-8.760082,37.877878],[-8.760278,37.876813],[-8.760784,37.869992],[-8.761725,37.861368],[-8.761839,37.86104],[-8.763644,37.858059],[-8.763972,37.857738],[-8.770691,37.855531],[-8.773907,37.855136],[-8.783308,37.854051],[-8.785913,37.853783],[-8.787835,37.853473],[-8.790857,37.852094],[-8.791091,37.852677],[-8.78862,37.853757],[-8.788096,37.853321],[-8.78656,37.853622],[-8.781632,37.854176],[-8.773138,37.855195],[-8.770339,37.855601],[-8.764856,37.857399],[-8.764346,37.857272],[-8.763645,37.856041],[-8.76358,37.855599],[-8.767223,37.848646],[-8.767609,37.848],[-8.767098,37.84703],[-8.766962,37.844869],[-8.767228,37.842316],[-8.766975,37.841636],[-8.764722,37.838381],[-8.764391,37.837811],[-8.761136,37.831257],[-8.759969,37.828287],[-8.760057,37.827137],[-8.763405,37.817106],[-8.764169,37.814198],[-8.76507,37.812309],[-8.768999,37.80577],[-8.770044,37.80437],[-8.771472,37.80225],[-8.771838,37.801861],[-8.775611,37.801873],[-8.777684,37.802691],[-8.778426,37.803246],[-8.779507,37.804377],[-8.780461,37.804721],[-8.783286,37.805466],[-8.785847,37.806893],[-8.787392,37.806853],[-8.791554,37.807005],[-8.789709,37.807078],[-8.788087,37.80692],[-8.785769,37.806891],[-8.783081,37.805379],[-8.7796,37.804428],[-8.777926,37.802625],[-8.777205,37.802544],[-8.775579,37.801872],[-8.77182,37.801828],[-8.773056,37.800662],[-8.7738,37.80025],[-8.778001,37.79934],[-8.778742,37.798792],[-8.780271,37.794176],[-8.781218,37.791173],[-8.782406,37.787783],[-8.782951,37.785868],[-8.783078,37.781568],[-8.78383,37.776128],[-8.783696,37.775206],[-8.780956,37.770564],[-8.780806,37.769886],[-8.780998,37.76715],[-8.780794,37.7665],[-8.780102,37.765843],[-8.777746,37.764576],[-8.774411,37.761935],[-8.771382,37.759465],[-8.768285,37.757903],[-8.767399,37.757318],[-8.763434,37.753911],[-8.761716,37.752566],[-8.761088,37.752284],[-8.757313,37.751574],[-8.756986,37.751256],[-8.759275,37.749118],[-8.763386,37.743782],[-8.765783,37.74053],[-8.766017,37.739907],[-8.766732,37.739255],[-8.769217,37.735987],[-8.770124,37.735159],[-8.77125,37.733794],[-8.772498,37.733214],[-8.773641,37.73202],[-8.776353,37.729477],[-8.77828,37.730909],[-8.779173,37.730448],[-8.781005,37.730059],[-8.782619,37.729572],[-8.783692,37.729023],[-8.785559,37.728427],[-8.786609,37.729852],[-8.786871,37.730467],[-8.787754,37.733712],[-8.788032,37.733977],[-8.7897,37.734413],[-8.791659,37.735056],[-8.795456,37.736976],[-8.79718,37.737754],[-8.7915,37.734946],[-8.78831,37.734138],[-8.787768,37.733712],[-8.78688,37.730352],[-8.785703,37.728502],[-8.783917,37.72893],[-8.782093,37.727014],[-8.781647,37.726995],[-8.781591,37.728497],[-8.781364,37.728641],[-8.77887,37.729302],[-8.778196,37.729564],[-8.777059,37.728846],[-8.77362,37.731986],[-8.772501,37.73307],[-8.771994,37.733237],[-8.771749,37.73292],[-8.77188,37.730923],[-8.771527,37.729632],[-8.769931,37.726655],[-8.76938,37.725847],[-8.768205,37.723674],[-8.767165,37.720962],[-8.766659,37.718416],[-8.766597,37.714979],[-8.76673,37.71405],[-8.767494,37.71164],[-8.767946,37.710533],[-8.770607,37.70486],[-8.77121,37.703201],[-8.771294,37.702622],[-8.771109,37.701257],[-8.76995,37.698385],[-8.767764,37.692679],[-8.767067,37.691027],[-8.765805,37.687707],[-8.762183,37.679042],[-8.761528,37.676958],[-8.760194,37.673382],[-8.7598,37.671884],[-8.759596,37.670066],[-8.759645,37.664866],[-8.759597,37.660745],[-8.759686,37.659582],[-8.759695,37.655811],[-8.759582,37.654542],[-8.759576,37.650404],[-8.759652,37.644806],[-8.759592,37.643221],[-8.759201,37.641771],[-8.758437,37.640376],[-8.757806,37.639552],[-8.755684,37.637542],[-8.75284,37.635496],[-8.745839,37.630857],[-8.744249,37.629725],[-8.734555,37.623201],[-8.72819,37.61883],[-8.726563,37.617405],[-8.724084,37.614918],[-8.724235,37.614507],[-8.729732,37.61102],[-8.738056,37.605703],[-8.744233,37.601798],[-8.744409,37.60115],[-8.743356,37.59756],[-8.742648,37.594792],[-8.741982,37.593221],[-8.739198,37.585688],[-8.737674,37.574695],[-8.737564,37.573537],[-8.736469,37.565636],[-8.736247,37.5636],[-8.735305,37.556892],[-8.734275,37.549141],[-8.734329,37.548751],[-8.722293,37.539832],[-8.721879,37.539412],[-8.719445,37.535822],[-8.717669,37.533336],[-8.716892,37.531554],[-8.714402,37.526594],[-8.71119,37.520377],[-8.708596,37.517307],[-8.709462,37.516539],[-8.712064,37.51308],[-8.713039,37.512458],[-8.715438,37.511655],[-8.716295,37.511234],[-8.718638,37.509042],[-8.719773,37.508107],[-8.71973,37.506482],[-8.719845,37.505943],[-8.720549,37.505338],[-8.720784,37.504556],[-8.719882,37.503753],[-8.718437,37.501997],[-8.718127,37.501111],[-8.718359,37.500175],[-8.719851,37.49708],[-8.720235,37.496464],[-8.721272,37.495379],[-8.721484,37.494718],[-8.721361,37.492639],[-8.722766,37.48851],[-8.723095,37.487226],[-8.722991,37.486652],[-8.721632,37.484608],[-8.721848,37.482529],[-8.722718,37.481742],[-8.742877,37.47456],[-8.743888,37.474012],[-8.744558,37.473405],[-8.754585,37.46248],[-8.755253,37.461673],[-8.756097,37.460203],[-8.761702,37.447692],[-8.761661,37.446868],[-8.761365,37.446322],[-8.759152,37.444708],[-8.758195,37.443762],[-8.756982,37.442813],[-8.756785,37.442256],[-8.757276,37.440635],[-8.757138,37.440078],[-8.756259,37.438786],[-8.756036,37.438053],[-8.756091,37.436475],[-8.756594,37.435351],[-8.757391,37.434713],[-8.758482,37.434151],[-8.759725,37.433769],[-8.761686,37.434113],[-8.762957,37.434616],[-8.764284,37.435344],[-8.764796,37.4352],[-8.766308,37.433705],[-8.766632,37.433585],[-8.767965,37.434244],[-8.769367,37.434181],[-8.769991,37.43437],[-8.771724,37.434307],[-8.772778,37.433356],[-8.774175,37.43268],[-8.774604,37.43178],[-8.775,37.43143],[-8.776615,37.430895],[-8.777245,37.430936],[-8.779034,37.431434],[-8.779506,37.431761],[-8.782044,37.432638],[-8.782941,37.432599],[-8.784722,37.43342],[-8.785199,37.434651],[-8.785625,37.434858],[-8.786554,37.433663],[-8.787095,37.433625],[-8.788869,37.433962],[-8.789716,37.434753],[-8.791048,37.434996],[-8.791875,37.434523],[-8.792593,37.434435],[-8.793193,37.434696],[-8.793876,37.435427],[-8.795443,37.435981],[-8.795672,37.436417],[-8.795114,37.436771],[-8.795508,37.437759],[-8.796506,37.438615],[-8.797259,37.438438],[-8.796085,37.437901],[-8.796132,37.436847],[-8.795564,37.435855],[-8.794034,37.435262],[-8.793667,37.434483],[-8.790905,37.434858],[-8.79032,37.43506],[-8.789547,37.434608],[-8.789024,37.433937],[-8.787179,37.433503],[-8.78658,37.433555],[-8.785717,37.434696],[-8.785287,37.43457],[-8.784887,37.433431],[-8.783989,37.432887],[-8.782909,37.432558],[-8.782049,37.432607],[-8.779588,37.431739],[-8.779029,37.431377],[-8.777047,37.430804],[-8.7764,37.430856],[-8.774966,37.43137],[-8.774041,37.432719],[-8.772673,37.433435],[-8.771412,37.434308],[-8.769594,37.434353],[-8.767959,37.434141],[-8.76647,37.433563],[-8.764687,37.435365],[-8.764864,37.435751],[-8.765568,37.436119],[-8.767305,37.436356],[-8.768205,37.436736],[-8.770436,37.436841],[-8.77126,37.437141],[-8.772168,37.437151],[-8.772701,37.437667],[-8.774019,37.437954],[-8.774538,37.437373],[-8.775036,37.4374],[-8.775705,37.436957],[-8.778812,37.43571],[-8.780693,37.435723],[-8.78209,37.435291],[-8.782594,37.435355],[-8.784037,37.436423],[-8.785365,37.436568],[-8.786853,37.436039],[-8.787662,37.43776],[-8.788864,37.438342],[-8.789901,37.438603],[-8.791018,37.437218],[-8.791817,37.437337],[-8.79357,37.438451],[-8.795283,37.440858],[-8.795138,37.439702],[-8.794074,37.438679],[-8.792156,37.437469],[-8.79104,37.437204],[-8.790545,37.437652],[-8.790075,37.43856],[-8.789005,37.438385],[-8.787864,37.437897],[-8.787417,37.43734],[-8.786832,37.436025],[-8.785414,37.436559],[-8.784079,37.43643],[-8.782336,37.435255],[-8.780699,37.435722],[-8.778845,37.435703],[-8.775663,37.436974],[-8.775108,37.437388],[-8.774565,37.437369],[-8.773872,37.437971],[-8.772788,37.437704],[-8.772218,37.437169],[-8.771132,37.437113],[-8.769413,37.436711],[-8.768162,37.43673],[-8.767206,37.436333],[-8.765788,37.43619],[-8.764955,37.435858],[-8.764655,37.435289],[-8.766285,37.43371],[-8.766902,37.433599],[-8.767642,37.434019],[-8.768522,37.434031],[-8.768995,37.433794],[-8.769056,37.433071],[-8.767552,37.431519],[-8.768141,37.431112],[-8.769029,37.431652],[-8.769337,37.4315],[-8.768125,37.430165],[-8.767445,37.429005],[-8.766289,37.427962],[-8.765925,37.427119],[-8.766275,37.426733],[-8.765667,37.425421],[-8.765935,37.424601],[-8.767233,37.422677],[-8.767343,37.421606],[-8.766695,37.419235],[-8.766616,37.418607],[-8.768023,37.41028],[-8.768338,37.409843],[-8.772886,37.40595],[-8.778794,37.400674],[-8.781784,37.397825],[-8.783749,37.395349],[-8.787272,37.391043],[-8.791602,37.385539],[-8.798809,37.376505],[-8.799107,37.375995],[-8.80058,37.367515],[-8.80079,37.366013],[-8.800538,37.352036],[-8.800571,37.350863],[-8.801784,37.343481],[-8.801757,37.342867],[-8.801173,37.341738],[-8.800759,37.341312],[-8.799535,37.340788],[-8.796712,37.340924],[-8.796207,37.34031],[-8.796497,37.338302],[-8.79639,37.337416],[-8.794662,37.334512],[-8.793266,37.332702],[-8.793002,37.331746],[-8.793402,37.33033],[-8.793939,37.32958],[-8.793953,37.328219],[-8.793042,37.326352],[-8.79317,37.325568],[-8.793872,37.325138],[-8.795087,37.324766],[-8.797577,37.321341],[-8.798467,37.320446],[-8.79875,37.317878],[-8.799256,37.316836],[-8.800459,37.316661],[-8.80254,37.316828],[-8.803658,37.316502],[-8.803854,37.314059],[-8.803657,37.3127],[-8.80227,37.310324],[-8.802045,37.309206],[-8.801774,37.306166],[-8.800725,37.303913],[-8.79928,37.302071],[-8.799186,37.30161],[-8.800049,37.29914],[-8.79998,37.298141],[-8.797709,37.296096],[-8.797205,37.29535],[-8.797423,37.294714],[-8.79859,37.293812],[-8.798737,37.292946],[-8.798437,37.290508],[-8.798612,37.289739],[-8.799441,37.288407],[-8.799765,37.286248],[-8.799974,37.285652],[-8.801487,37.284286],[-8.802216,37.283154],[-8.802415,37.282309],[-8.802203,37.280926],[-8.80288,37.278209],[-8.803292,37.277336],[-8.809275,37.269375],[-8.809534,37.268814],[-8.809175,37.26568],[-8.809427,37.264722],[-8.809815,37.264148],[-8.812371,37.260919],[-8.812938,37.260112],[-8.813339,37.25806],[-8.814412,37.257939],[-8.814793,37.257679],[-8.816199,37.255839],[-8.817756,37.253608],[-8.81875,37.252003],[-8.821419,37.247984],[-8.82354,37.244649],[-8.825152,37.240999],[-8.829013,37.231934],[-8.829388,37.231129],[-8.832926,37.225323],[-8.83475,37.219202],[-8.835119,37.217753],[-8.834759,37.216579],[-8.834842,37.214435],[-8.836243,37.212863],[-8.836943,37.212427],[-8.838202,37.211292],[-8.838982,37.211068],[-8.83865,37.210235],[-8.838953,37.209372],[-8.83962,37.209211],[-8.839715,37.208823],[-8.839156,37.208174],[-8.839366,37.207358],[-8.838805,37.206273],[-8.839234,37.205392],[-8.839619,37.205085],[-8.841025,37.204774],[-8.84165,37.204253],[-8.842622,37.202814],[-8.843091,37.202535],[-8.846097,37.201802],[-8.848529,37.200418],[-8.849715,37.199388],[-8.851265,37.199301],[-8.852984,37.198648],[-8.857338,37.198471],[-8.860335,37.198426],[-8.861623,37.198852],[-8.86366,37.198462],[-8.865325,37.198627],[-8.86592,37.199229],[-8.866221,37.200404],[-8.867047,37.200569],[-8.867761,37.200077],[-8.86865,37.199941],[-8.869544,37.200098],[-8.871981,37.199419],[-8.873273,37.199604],[-8.875001,37.199372],[-8.875735,37.19945],[-8.876761,37.199856],[-8.879952,37.201885],[-8.88135,37.202837],[-8.882241,37.202832],[-8.884141,37.201821],[-8.884823,37.201599],[-8.886231,37.201575],[-8.886955,37.201112],[-8.888928,37.197307],[-8.889238,37.196353],[-8.890519,37.1895],[-8.890763,37.188767],[-8.891167,37.188381],[-8.895444,37.185051],[-8.895807,37.184336],[-8.895099,37.182755],[-8.894502,37.182053],[-8.892887,37.181195],[-8.890497,37.180076],[-8.888748,37.178796],[-8.887916,37.177858],[-8.884386,37.173165],[-8.883626,37.172492],[-8.880831,37.171234],[-8.880469,37.170847],[-8.8798,37.16938],[-8.879395,37.168938],[-8.876941,37.167042],[-8.875851,37.165866],[-8.875632,37.164801],[-8.875043,37.164162],[-8.873823,37.163392],[-8.87324,37.161856],[-8.872562,37.161242],[-8.870826,37.160321],[-8.870166,37.159768],[-8.869204,37.158098],[-8.869503,37.156353],[-8.868906,37.153827],[-8.868998,37.153457],[-8.87038,37.152871],[-8.871265,37.152047],[-8.871684,37.151423],[-8.871537,37.148702],[-8.871642,37.147884],[-8.873547,37.145704],[-8.873906,37.145147],[-8.874976,37.14243],[-8.876006,37.140692],[-8.884853,37.126549],[-8.885506,37.125751],[-8.8901,37.121707],[-8.892742,37.118926],[-8.899005,37.112446],[-8.901993,37.109227],[-8.903758,37.107465],[-8.908758,37.102206],[-8.909705,37.100714],[-8.911054,37.097408],[-8.912288,37.093516],[-8.912359,37.092447],[-8.912228,37.091455],[-8.911083,37.086459],[-8.910609,37.08568],[-8.909954,37.08526],[-8.908229,37.084473],[-8.907728,37.083704],[-8.907561,37.082836],[-8.907897,37.08244],[-8.908829,37.082145],[-8.909256,37.082983],[-8.908867,37.082802],[-8.909294,37.081955],[-8.911706,37.081107],[-8.911039,37.08043],[-8.911451,37.079939],[-8.912645,37.079098],[-8.913948,37.077908],[-8.915422,37.075755],[-8.91786,37.072009],[-8.918637,37.070937],[-8.920563,37.068697],[-8.921602,37.067642],[-8.922263,37.066745],[-8.922746,37.065485],[-8.922877,37.064356],[-8.923048,37.057951],[-8.923213,37.055401],[-8.923709,37.054085],[-8.924728,37.052731],[-8.928387,37.048932],[-8.928989,37.047979],[-8.931105,37.042873],[-8.931471,37.041892],[-8.933292,37.037567],[-8.936182,37.0305],[-8.93697,37.027711],[-8.93747,37.026384],[-8.937801,37.02464],[-8.93785,37.022523],[-8.940908,37.016023],[-8.942136,37.013581],[-8.944257,37.009178],[-8.944703,37.00814],[-8.945347,37.00784],[-8.946509,37.008291],[-8.948378,37.009382],[-8.95283,37.014529],[-8.956292,37.01869],[-8.962326,37.026416],[-8.963308,37.02747],[-8.963875,37.027571],[-8.968655,37.027681],[-8.971039,37.027557],[-8.975068,37.027262],[-8.975796,37.027292],[-8.98155,37.028269],[-8.981676,37.028253],[-8.976083,37.027293],[-8.975325,37.027247],[-8.968763,37.02768],[-8.963909,37.027572],[-8.963166,37.027372],[-8.961592,37.025435],[-8.956152,37.018517],[-8.952732,37.014415],[-8.948381,37.009385],[-8.946416,37.008243],[-8.944981,37.00755],[-8.942919,37.011781],[-8.94192,37.013932],[-8.940347,37.016965],[-8.937702,37.022573],[-8.937745,37.024836],[-8.937657,37.025417],[-8.936402,37.029876],[-8.935842,37.031319],[-8.93224,37.039955],[-8.929974,37.045556],[-8.928932,37.048012],[-8.92841,37.048842],[-8.924377,37.053106],[-8.923779,37.05386],[-8.923117,37.055419],[-8.923016,37.05617],[-8.92297,37.059896],[-8.922878,37.061435],[-8.922843,37.064452],[-8.922687,37.065685],[-8.922288,37.066652],[-8.921498,37.06779],[-8.919037,37.07037],[-8.91814,37.071512],[-8.914154,37.077486],[-8.913129,37.078656],[-8.909775,37.081042],[-8.90876,37.081651],[-8.907634,37.082093],[-8.90565,37.082423],[-8.900532,37.082447],[-8.897646,37.082256],[-8.896361,37.082326],[-8.89359,37.082678],[-8.890209,37.082273],[-8.888119,37.082198],[-8.884914,37.081698],[-8.882876,37.081874],[-8.880239,37.082651],[-8.874454,37.084026],[-8.871886,37.084157],[-8.869419,37.084057],[-8.868095,37.083793],[-8.867084,37.083355],[-8.864991,37.082057],[-8.863916,37.081507],[-8.861361,37.080705],[-8.859711,37.079674],[-8.857846,37.077867],[-8.856861,37.07675],[-8.855506,37.075732],[-8.852552,37.074355],[-8.851653,37.074071],[-8.850232,37.07392],[-8.847495,37.074198],[-8.845792,37.074788],[-8.845029,37.075384],[-8.843754,37.077093],[-8.842533,37.07804],[-8.841104,37.078472],[-8.838267,37.078419],[-8.835706,37.078656],[-8.834607,37.079454],[-8.830618,37.08295],[-8.82933,37.084423],[-8.827014,37.086688],[-8.824278,37.089221],[-8.823151,37.09005],[-8.821254,37.090779],[-8.817406,37.091617],[-8.813028,37.092516],[-8.812288,37.092464],[-8.811547,37.092807],[-8.80782,37.093586],[-8.806729,37.093681],[-8.805152,37.093509],[-8.8025,37.092734],[-8.801435,37.092572],[-8.789956,37.091913],[-8.787428,37.091587],[-8.784233,37.090925],[-8.782907,37.090854],[-8.781097,37.091058],[-8.772555,37.093162],[-8.768605,37.094249],[-8.767848,37.094249],[-8.767457,37.094576],[-8.760978,37.096546],[-8.7599,37.09708],[-8.757458,37.098495],[-8.756448,37.098921],[-8.755359,37.099178],[-8.749366,37.099778],[-8.747482,37.099612],[-8.746535,37.099305],[-8.744066,37.097959],[-8.742083,37.097461],[-8.740683,37.097496],[-8.739349,37.097853],[-8.738421,37.098279],[-8.736294,37.099619],[-8.734776,37.100255],[-8.728726,37.101581],[-8.726101,37.102303],[-8.721749,37.103736],[-8.718371,37.104642],[-8.717034,37.105167],[-8.712147,37.107397],[-8.710311,37.107882],[-8.708539,37.107802],[-8.707616,37.107551],[-8.707169,37.107043],[-8.706614,37.107017],[-8.705941,37.106586],[-8.702832,37.103946],[-8.701334,37.102884],[-8.700123,37.102347],[-8.699013,37.102067],[-8.695352,37.101764],[-8.694742,37.101403],[-8.693372,37.101606],[-8.689763,37.101441],[-8.688562,37.101311],[-8.680793,37.100001],[-8.679682,37.099251],[-8.678116,37.096702],[-8.676988,37.095709],[-8.676061,37.09546],[-8.674629,37.095334],[-8.674572,37.096007],[-8.673262,37.096362],[-8.673726,37.096994],[-8.674582,37.097257],[-8.675844,37.097265],[-8.67671,37.099146],[-8.676249,37.099376],[-8.676922,37.099586],[-8.677667,37.100534],[-8.677931,37.101485],[-8.678617,37.101879],[-8.680091,37.1021],[-8.680547,37.102313],[-8.68024,37.103062],[-8.680911,37.103505],[-8.680711,37.104732],[-8.680938,37.105333],[-8.680771,37.106333],[-8.681361,37.107877],[-8.681263,37.108746],[-8.681753,37.109812],[-8.682628,37.110815],[-8.682462,37.110995],[-8.680928,37.11131],[-8.681369,37.11187],[-8.68151,37.112687],[-8.680489,37.11435],[-8.681001,37.11443],[-8.681026,37.113999],[-8.681627,37.112903],[-8.681655,37.112219],[-8.681392,37.111354],[-8.68107,37.111068],[-8.680591,37.111278],[-8.679518,37.110842],[-8.679376,37.111007],[-8.680902,37.111458],[-8.6815,37.112359],[-8.68081,37.114012],[-8.680334,37.114157],[-8.678276,37.113553],[-8.677624,37.113475],[-8.676573,37.114161],[-8.675985,37.114102],[-8.676014,37.112912],[-8.675543,37.11341],[-8.675062,37.113411],[-8.67189,37.111342],[-8.671732,37.111508],[-8.67325,37.112292],[-8.674695,37.113347],[-8.675594,37.113662],[-8.675911,37.114294],[-8.675486,37.115204],[-8.674589,37.115779],[-8.673734,37.116595],[-8.673222,37.117922],[-8.673114,37.119297],[-8.673071,37.12325],[-8.672513,37.125023],[-8.670192,37.128522],[-8.669172,37.129673],[-8.665252,37.133127],[-8.663865,37.134851],[-8.663443,37.136037],[-8.663091,37.138865],[-8.662672,37.139425],[-8.667474,37.139899],[-8.668348,37.140073],[-8.669609,37.140759],[-8.67277,37.144354],[-8.673998,37.145629],[-8.674848,37.146265],[-8.685312,37.152826],[-8.687012,37.153586],[-8.689057,37.154103],[-8.689804,37.154496],[-8.690754,37.155479],[-8.690868,37.156051],[-8.690431,37.156894],[-8.689097,37.157997],[-8.684449,37.161643],[-8.682859,37.162726],[-8.681612,37.163407],[-8.679479,37.164304],[-8.67797,37.164767],[-8.676215,37.16514],[-8.672809,37.165716],[-8.670768,37.166212],[-8.668928,37.166835],[-8.664753,37.168662],[-8.66302,37.16921],[-8.661427,37.169543],[-8.649901,37.170878],[-8.649612,37.170891],[-8.638411,37.172217],[-8.633131,37.172791],[-8.631211,37.173073],[-8.628968,37.173591],[-8.627227,37.17418],[-8.623691,37.175768],[-8.622033,37.176439],[-8.620264,37.176996],[-8.617892,37.177539],[-8.613103,37.178224],[-8.610965,37.178595],[-8.608675,37.179128],[-8.605775,37.180001],[-8.598816,37.182517],[-8.595901,37.183211],[-8.59405,37.183401],[-8.591242,37.183307],[-8.590001,37.18314],[-8.587292,37.182404],[-8.585615,37.181693],[-8.583517,37.180663],[-8.578788,37.178191],[-8.575266,37.176504],[-8.57361,37.175979],[-8.571059,37.175584],[-8.569029,37.175623],[-8.567525,37.175844],[-8.557584,37.177707],[-8.555761,37.17793],[-8.553678,37.178029],[-8.551021,37.177909],[-8.546071,37.177345],[-8.542603,37.177257],[-8.539691,37.1775],[-8.534559,37.178334],[-8.533278,37.178418],[-8.531469,37.178343],[-8.53019,37.178138],[-8.528511,37.177618],[-8.526711,37.176788],[-8.519039,37.172501],[-8.517345,37.171443],[-8.51565,37.170055],[-8.514421,37.168731],[-8.512576,37.166221],[-8.511632,37.165207],[-8.50964,37.163812],[-8.507801,37.163034],[-8.499428,37.160509],[-8.494846,37.159099],[-8.488982,37.15735],[-8.48746,37.156965],[-8.485396,37.15666],[-8.482517,37.15657],[-8.471845,37.157425],[-8.470112,37.157415],[-8.468157,37.15719],[-8.466707,37.156851],[-8.464588,37.156082],[-8.461465,37.154657],[-8.456557,37.152347],[-8.455201,37.151774],[-8.453521,37.151257],[-8.450741,37.150761],[-8.447847,37.150665],[-8.446268,37.150801],[-8.435939,37.152242],[-8.433878,37.152478],[-8.432066,37.152511],[-8.42998,37.152303],[-8.427942,37.15183],[-8.425376,37.150732],[-8.42374,37.149645],[-8.422777,37.14885],[-8.416765,37.143012],[-8.414493,37.141219],[-8.41218,37.139887],[-8.41057,37.139184],[-8.407046,37.138226],[-8.404153,37.137867],[-8.401742,37.137842],[-8.399965,37.137996],[-8.395893,37.138666],[-8.394148,37.138759],[-8.392887,37.138688],[-8.390738,37.138302],[-8.38842,37.137639],[-8.386042,37.137325],[-8.384475,37.13735],[-8.383161,37.137544],[-8.381132,37.138119],[-8.378736,37.139082],[-8.377007,37.139618],[-8.374656,37.140027],[-8.373325,37.1401],[-8.371208,37.140007],[-8.368843,37.139547],[-8.367052,37.138967],[-8.362498,37.136808],[-8.358813,37.13557],[-8.358132,37.134959],[-8.358435,37.133917],[-8.359138,37.133702],[-8.3593,37.133121],[-8.358858,37.132834],[-8.357935,37.133068],[-8.350711,37.131794],[-8.34861,37.131086],[-8.347782,37.130514],[-8.346727,37.128753],[-8.346177,37.126965],[-8.346129,37.126322],[-8.344684,37.124462],[-8.34383,37.123761],[-8.342737,37.123384],[-8.340975,37.123378],[-8.337024,37.124068],[-8.328045,37.124154],[-8.324729,37.124226],[-8.319504,37.124257],[-8.318717,37.124339],[-8.31778,37.124749],[-8.317333,37.125228],[-8.316239,37.127065],[-8.315306,37.127535],[-8.31443,37.127588],[-8.312045,37.127328],[-8.310967,37.127371],[-8.306476,37.128231],[-8.305734,37.128276],[-8.300502,37.128045],[-8.297242,37.127952],[-8.290483,37.127655],[-8.288458,37.12787],[-8.28375,37.128827],[-8.28067,37.128855],[-8.278113,37.128756],[-8.274403,37.128694],[-8.262224,37.128428],[-8.259047,37.128322],[-8.25772,37.12801],[-8.256275,37.127077],[-8.252881,37.124112],[-8.249678,37.121182],[-8.248376,37.120112],[-8.246533,37.11919],[-8.244304,37.119016],[-8.242724,37.119336],[-8.233121,37.122681],[-8.23215,37.122931],[-8.231417,37.122861],[-8.231195,37.123227],[-8.229357,37.123218],[-8.225579,37.123015],[-8.224205,37.123062],[-8.223779,37.12275],[-8.223721,37.121444],[-8.224325,37.120508],[-8.225727,37.119601],[-8.226817,37.119068],[-8.227986,37.117759],[-8.228797,37.116503],[-8.2296,37.115998],[-8.229816,37.114762],[-8.229696,37.114143],[-8.229539,37.11563],[-8.229146,37.116188],[-8.228277,37.116738],[-8.22806,37.117589],[-8.226719,37.119125],[-8.224967,37.12001],[-8.223933,37.120906],[-8.223496,37.121758],[-8.223681,37.122891],[-8.22334,37.123245],[-8.222039,37.123703],[-8.22056,37.124009],[-8.218014,37.123951],[-8.216571,37.123625],[-8.21457,37.122756],[-8.213073,37.122229],[-8.211896,37.122051],[-8.206904,37.121546],[-8.205332,37.121788],[-8.201146,37.123281],[-8.198693,37.123627],[-8.194249,37.123799],[-8.191788,37.123386],[-8.186212,37.121903],[-8.18315,37.121408],[-8.182077,37.121316],[-8.180641,37.12152],[-8.172616,37.124069],[-8.169643,37.124791],[-8.167488,37.125548],[-8.166147,37.126285],[-8.164872,37.126753],[-8.163656,37.126806],[-8.161592,37.126697],[-8.158947,37.127091],[-8.158169,37.12734],[-8.15677,37.128387],[-8.155714,37.128676],[-8.150989,37.128436],[-8.14991,37.128053],[-8.149289,37.127559],[-8.147286,37.124532],[-8.144707,37.122824],[-8.142198,37.120219],[-8.141186,37.119306],[-8.140103,37.118868],[-8.137345,37.118585],[-8.134068,37.118129],[-8.129309,37.117589],[-8.121634,37.116637],[-8.119737,37.116238],[-8.11603,37.115121],[-8.113002,37.114108],[-8.109136,37.112915],[-8.103148,37.111636],[-8.100171,37.110931],[-8.098754,37.110728],[-8.09454,37.109864],[-8.09174,37.109446],[-8.087277,37.108928],[-8.08616,37.108741],[-8.083943,37.108161],[-8.079408,37.106268],[-8.075803,37.104612],[-8.073436,37.103651],[-8.071503,37.10272],[-8.070512,37.102351],[-8.061261,37.100581],[-8.0603,37.100317],[-8.055733,37.099552],[-8.051643,37.098793],[-8.051037,37.098338],[-8.050362,37.098459],[-8.049636,37.0982],[-8.046604,37.096744],[-8.044847,37.096046],[-8.043423,37.095643],[-8.04073,37.095263],[-8.039618,37.094914],[-8.037474,37.09381],[-8.036088,37.093428],[-8.034476,37.093329],[-8.032568,37.093474],[-8.027802,37.093546],[-8.026948,37.093326],[-8.024551,37.092274],[-8.02355,37.092061],[-8.021774,37.091925],[-8.020333,37.091961],[-8.017815,37.09162],[-8.016999,37.091305],[-8.015828,37.090458],[-8.015071,37.089188],[-8.014579,37.087298],[-8.014128,37.085078],[-8.013561,37.083857],[-8.012525,37.08286],[-8.01057,37.081985],[-8.008709,37.08138],[-8.006584,37.08107],[-8.003087,37.081041],[-8.00028,37.080405],[-7.997056,37.07986],[-7.994579,37.079591],[-7.993093,37.079325],[-7.991647,37.078761],[-7.989524,37.077446],[-7.988395,37.076992],[-7.985698,37.076797],[-7.984894,37.076466],[-7.983101,37.075273],[-7.982099,37.074768],[-7.979876,37.073907],[-7.979012,37.073323],[-7.977299,37.070614],[-7.976223,37.068512],[-7.974829,37.066859],[-7.970073,37.063053],[-7.96076,37.057369],[-7.955644,37.053763],[-7.954403,37.052478],[-7.953398,37.050816],[-7.953013,37.049407],[-7.95295,37.046997],[-7.952659,37.045583],[-7.951926,37.043195],[-7.951354,37.041797],[-7.950476,37.040015],[-7.949934,37.038346],[-7.949949,37.037646],[-7.950321,37.035151],[-7.95016,37.034638],[-7.948649,37.031419],[-7.946166,37.028018],[-7.945641,37.027061],[-7.945079,37.026696],[-7.943775,37.025116],[-7.943771,37.024691],[-7.942718,37.023761],[-7.939996,37.021608],[-7.939375,37.021524],[-7.939433,37.020877],[-7.940738,37.020197],[-7.93967,37.018872],[-7.939011,37.017854],[-7.938282,37.017684],[-7.936228,37.016719],[-7.935287,37.016177],[-7.935483,37.014786],[-7.934158,37.014865],[-7.933687,37.014615],[-7.931359,37.011418],[-7.929608,37.012436],[-7.928273,37.012963],[-7.927034,37.013156],[-7.92639,37.013533],[-7.925626,37.013424],[-7.918654,37.014526],[-7.916683,37.014917],[-7.915359,37.015588],[-7.915447,37.016194],[-7.914828,37.017162],[-7.914297,37.018971],[-7.914532,37.02046],[-7.915224,37.021635],[-7.91679,37.023367],[-7.916934,37.024167],[-7.916679,37.026041],[-7.914967,37.027304],[-7.916313,37.029692],[-7.916064,37.03004],[-7.914629,37.030856],[-7.913511,37.031014],[-7.913974,37.031603],[-7.914806,37.031376],[-7.91282,37.030159],[-7.910874,37.029485],[-7.908444,37.029052],[-7.901602,37.027062],[-7.895925,37.025928],[-7.894175,37.025838],[-7.887694,37.026128],[-7.885671,37.02633],[-7.875826,37.028063],[-7.874678,37.027797],[-7.873997,37.028463],[-7.870877,37.02915],[-7.866483,37.030326],[-7.864899,37.030391],[-7.861853,37.029701],[-7.859585,37.029499],[-7.856061,37.029798],[-7.853368,37.03014],[-7.8514,37.030275],[-7.84807,37.031335],[-7.843274,37.033015],[-7.840385,37.033897],[-7.840123,37.033855],[-7.838463,37.034417],[-7.832079,37.036244],[-7.831699,37.036619],[-7.828289,37.038637],[-7.826547,37.039517],[-7.822749,37.04106],[-7.821714,37.041583],[-7.820013,37.042644],[-7.818711,37.04312],[-7.818261,37.042969],[-7.817665,37.043326],[-7.816402,37.043494],[-7.81394,37.043378],[-7.812643,37.04345],[-7.811082,37.04379],[-7.809591,37.043967],[-7.805326,37.043713],[-7.803832,37.043823],[-7.799849,37.044544],[-7.79854,37.045047],[-7.793331,37.047659],[-7.791159,37.048509],[-7.788636,37.049237],[-7.785905,37.049549],[-7.782905,37.049659],[-7.780962,37.049904],[-7.780019,37.050272],[-7.775869,37.052892],[-7.774107,37.054693],[-7.771602,37.056616],[-7.770661,37.057082],[-7.767287,37.058231],[-7.765274,37.05884],[-7.764064,37.059382],[-7.761421,37.061232],[-7.758664,37.064407],[-7.756502,37.066394],[-7.754883,37.067184],[-7.75178,37.068108],[-7.746641,37.06921],[-7.742438,37.070411],[-7.741374,37.07077],[-7.736502,37.072961],[-7.731876,37.074408],[-7.730313,37.075067],[-7.727768,37.076674],[-7.725363,37.078415],[-7.722241,37.080887],[-7.720472,37.082203],[-7.715851,37.085755],[-7.713828,37.087115],[-7.711274,37.088309],[-7.705758,37.090796],[-7.703954,37.091896],[-7.701513,37.092091],[-7.699785,37.092722],[-7.696431,37.093739],[-7.692695,37.095626],[-7.691609,37.096017],[-7.688679,37.097304],[-7.685782,37.098298],[-7.68365,37.099594],[-7.682189,37.100144],[-7.681928,37.100034],[-7.681669,37.099147],[-7.68079,37.09749],[-7.68025,37.097398],[-7.678882,37.09755],[-7.676771,37.095277],[-7.676898,37.094875],[-7.675859,37.093351],[-7.675127,37.09321],[-7.673483,37.093914],[-7.67144,37.095251],[-7.669974,37.096623],[-7.669539,37.097744],[-7.668894,37.098202],[-7.66715,37.09819],[-7.664946,37.099233],[-7.664792,37.099587],[-7.663232,37.100899],[-7.664212,37.102655],[-7.665133,37.102656],[-7.666696,37.1053],[-7.665343,37.106343],[-7.663817,37.107082],[-7.663057,37.107284],[-7.661708,37.107912],[-7.661529,37.108308],[-7.66233,37.110942],[-7.66203,37.111972],[-7.662063,37.112807],[-7.660804,37.115276],[-7.660684,37.115878],[-7.660075,37.117054],[-7.659275,37.119293],[-7.659941,37.119376],[-7.659197,37.12047],[-7.658899,37.121282],[-7.658857,37.122252],[-7.65923,37.124054],[-7.659003,37.124686],[-7.659714,37.125398],[-7.660077,37.126745],[-7.660062,37.127941],[-7.659812,37.128737],[-7.658903,37.130085],[-7.65796,37.130818],[-7.656791,37.131348],[-7.650972,37.13316],[-7.647434,37.133888],[-7.644403,37.134424],[-7.641886,37.13451],[-7.641515,37.134214],[-7.640843,37.13449],[-7.635574,37.134662],[-7.634881,37.134488],[-7.633833,37.134724],[-7.629374,37.134798],[-7.628188,37.134955],[-7.62707,37.135338],[-7.625845,37.136165],[-7.625277,37.13695],[-7.624344,37.138923],[-7.623938,37.139411],[-7.623774,37.14021],[-7.622612,37.142611],[-7.621653,37.143646],[-7.620986,37.144064],[-7.615832,37.146666],[-7.614361,37.146982],[-7.608776,37.147351],[-7.606603,37.147551],[-7.604563,37.147974],[-7.600833,37.148966],[-7.600106,37.149234],[-7.595434,37.151497],[-7.593855,37.151976],[-7.586548,37.15353],[-7.585165,37.15396],[-7.583764,37.154808],[-7.581062,37.157722],[-7.580497,37.158236],[-7.575252,37.161971],[-7.574382,37.162415],[-7.573365,37.162688],[-7.570891,37.162872],[-7.569705,37.163061],[-7.566259,37.164088],[-7.563664,37.165007],[-7.559982,37.165476],[-7.555263,37.166245],[-7.549651,37.167949],[-7.548173,37.16819],[-7.541431,37.169623],[-7.538078,37.170261],[-7.536181,37.170759],[-7.534819,37.171263],[-7.533524,37.171917],[-7.530996,37.173615],[-7.528617,37.175124],[-7.52498,37.177545],[-7.523637,37.178254],[-7.521795,37.178809],[-7.516898,37.179295],[-7.513306,37.179738],[-7.509939,37.180052],[-7.508226,37.17999],[-7.507804,37.180253],[-7.496168,37.181539],[-7.494649,37.181451],[-7.493946,37.181752],[-7.488398,37.182479],[-7.486918,37.182902],[-7.481948,37.184692],[-7.480057,37.185108],[-7.477857,37.185105],[-7.471489,37.183966],[-7.476056,37.184817],[-7.478112,37.185152],[-7.480584,37.185094],[-7.483863,37.18425],[-7.484566,37.185516],[-7.484372,37.186843],[-7.484143,37.190323],[-7.48457,37.193729],[-7.484575,37.194627],[-7.484278,37.195677],[-7.482617,37.19838],[-7.480936,37.200661],[-7.480196,37.201334],[-7.47713,37.20308],[-7.475014,37.204866],[-7.47406,37.205938],[-7.472811,37.207647],[-7.472405,37.209435],[-7.470246,37.214647],[-7.469208,37.215216],[-7.463147,37.217972],[-7.461726,37.218558],[-7.461168,37.218608],[-7.458003,37.218391],[-7.455297,37.217921],[-7.454031,37.217926],[-7.452792,37.217764],[-7.448617,37.217922],[-7.447545,37.217795],[-7.447294,37.218153],[-7.444954,37.218835],[-7.444224,37.219437],[-7.444592,37.220681],[-7.444144,37.220899],[-7.445173,37.223806],[-7.446606,37.226385],[-7.448022,37.228734],[-7.448256,37.229374],[-7.448149,37.230207],[-7.446878,37.231568],[-7.446069,37.23224],[-7.443957,37.234286],[-7.44322,37.234804],[-7.441109,37.235655],[-7.434031,37.237188],[-7.432028,37.237519],[-7.429514,37.237649],[-7.425971,37.237628],[-7.421111,37.237684],[-7.415098,37.237618],[-7.413803,37.237743],[-7.412372,37.238049],[-7.410252,37.238688],[-7.408019,37.23895],[-7.406486,37.238927],[-7.40127,37.238476],[-7.399948,37.238427],[-7.392563,37.238616],[-7.386567,37.238886],[-7.378053,37.23909],[-7.375479,37.239248],[-7.373523,37.239458],[-7.371696,37.239522],[-7.366991,37.240157],[-7.361958,37.241085],[-7.357683,37.242107],[-7.354522,37.243032],[-7.351963,37.2439],[-7.348693,37.245112],[-7.347073,37.245778],[-7.343759,37.247288],[-7.337425,37.25043],[-7.330812,37.254121],[-7.327489,37.255815],[-7.323622,37.257375],[-7.320931,37.258178],[-7.318621,37.258718],[-7.315375,37.259319],[-7.310531,37.259772],[-7.304788,37.260096],[-7.301264,37.260508],[-7.297747,37.261045],[-7.294722,37.261622],[-7.291822,37.262269],[-7.288915,37.263028],[-7.282853,37.264688],[-7.277643,37.265994],[-7.271682,37.267225],[-7.268243,37.267792],[-7.264595,37.268289],[-7.261222,37.269036],[-7.259117,37.2697],[-7.256158,37.271028],[-7.253732,37.272554],[-7.25138,37.274462],[-7.247544,37.278414],[-7.245397,37.280199],[-7.241639,37.282706],[-7.239687,37.284085],[-7.237058,37.286132],[-7.233953,37.288891],[-7.232176,37.290293],[-7.229567,37.291974],[-7.227646,37.293023],[-7.225395,37.294069],[-7.222574,37.295183],[-7.219647,37.296597],[-7.217678,37.297832],[-7.214269,37.300484],[-7.212406,37.301719],[-7.209877,37.303059],[-7.206126,37.304626],[-7.203356,37.306096],[-7.202045,37.306975],[-7.199067,37.309296],[-7.197265,37.31051],[-7.195833,37.311266],[-7.193186,37.312482],[-7.191412,37.313388],[-7.189397,37.314676],[-7.187365,37.316238],[-7.185639,37.317465],[-7.183707,37.318648],[-7.179999,37.320577],[-7.177665,37.322281],[-7.176231,37.323617],[-7.174505,37.325608],[-7.173272,37.326826],[-7.172227,37.32761],[-7.170354,37.328639],[-7.169109,37.329108],[-7.1649,37.330278],[-7.163115,37.330975],[-7.159903,37.332455],[-7.157763,37.333106],[-7.155543,37.333354],[-7.152669,37.333252],[-7.150324,37.332503],[-7.14762,37.331245],[-7.14606,37.330656],[-7.142795,37.329812],[-7.1402,37.328936],[-7.136786,37.327444],[-7.134787,37.326689],[-7.132452,37.325963],[-7.130889,37.325572],[-7.127887,37.325077],[-7.12231,37.324618],[-7.119826,37.324269],[-7.116722,37.323587],[-7.115245,37.323148],[-7.112846,37.322624],[-7.110503,37.322297],[-7.10792,37.322129],[-7.106013,37.322123],[-7.101408,37.322634],[-7.098943,37.322786],[-7.096388,37.322807],[-7.092919,37.322501],[-7.089264,37.322333],[-7.086684,37.3224],[-7.079577,37.323172],[-7.075835,37.323247],[-7.072859,37.323111],[-7.069351,37.32303],[-7.067206,37.323078],[-7.064015,37.32333],[-7.060776,37.323828],[-7.057767,37.324549],[-7.05359,37.325885],[-7.052073,37.326447],[-7.042979,37.330016],[-7.039644,37.3312],[-7.036247,37.332292],[-7.033339,37.333124],[-7.027257,37.334644],[-7.020601,37.335932],[-7.016078,37.336958],[-7.012964,37.337893],[-7.008439,37.33962],[-7.005544,37.340997],[-7.002951,37.34242],[-6.997101,37.345838],[-6.995006,37.34694],[-6.992567,37.348035],[-6.990415,37.348789],[-6.987053,37.349843],[-6.980046,37.352108],[-6.977055,37.353046],[-6.971955,37.354445],[-6.967602,37.355328],[-6.962687,37.356021],[-6.95853,37.356409],[-6.953457,37.356599],[-6.950228,37.356586],[-6.947827,37.356448],[-6.943931,37.356095],[-6.939901,37.355301],[-6.936428,37.354134],[-6.933762,37.352979],[-6.932626,37.352384],[-6.930482,37.351083],[-6.927908,37.349195],[-6.926314,37.347771],[-6.924722,37.346091],[-6.922712,37.343375],[-6.921195,37.340982],[-6.918775,37.336643],[-6.918023,37.335131],[-6.916834,37.333021],[-6.915483,37.33084],[-6.913727,37.32836],[-6.912794,37.327163],[-6.910434,37.324523],[-6.9087,37.322796],[-6.905938,37.320371],[-6.90404,37.31894],[-6.901418,37.317245],[-6.898117,37.315596],[-6.896024,37.314789],[-6.893403,37.314001],[-6.891476,37.313539],[-6.889743,37.313232],[-6.887657,37.312986],[-6.885033,37.312791],[-6.882509,37.312439],[-6.880532,37.311996],[-6.879012,37.311817],[-6.877162,37.311859],[-6.875609,37.312116],[-6.874118,37.312605],[-6.870694,37.314321],[-6.869185,37.314798],[-6.862641,37.316351],[-6.860319,37.316969],[-6.856591,37.318173],[-6.852194,37.319921],[-6.848139,37.32176],[-6.846627,37.32235],[-6.844315,37.323101],[-6.841915,37.323665],[-6.836865,37.324428],[-6.834371,37.324969],[-6.83252,37.325488],[-6.828147,37.326996],[-6.825541,37.327799],[-6.820747,37.328985],[-6.817227,37.329584],[-6.813951,37.330065],[-6.810965,37.330603],[-6.80619,37.331613],[-6.803765,37.332053],[-6.801093,37.332439],[-6.798629,37.332708],[-6.792438,37.333103],[-6.789418,37.333384],[-6.783912,37.334085],[-6.780019,37.334421],[-6.777036,37.334529],[-6.770562,37.334498],[-6.767316,37.334707],[-6.763887,37.335178],[-6.761347,37.335719],[-6.752774,37.338106],[-6.750427,37.338669],[-6.746775,37.339353],[-6.742247,37.339886],[-6.738385,37.340159],[-6.731158,37.340232],[-6.724934,37.340805],[-6.722293,37.34089],[-6.720138,37.340821],[-6.714131,37.340287],[-6.708461,37.340139],[-6.706316,37.340185],[-6.703092,37.340384],[-6.697344,37.34094],[-6.691583,37.341168],[-6.688441,37.341535],[-6.684548,37.342216],[-6.681101,37.342617],[-6.678215,37.342666],[-6.674503,37.342399],[-6.672532,37.342096],[-6.667652,37.341046],[-6.665385,37.340751],[-6.663572,37.340741],[-6.66199,37.340851],[-6.659812,37.341192],[-6.657455,37.341802],[-6.655251,37.342525],[-6.653376,37.343021],[-6.650686,37.343542],[-6.647667,37.343925],[-6.644712,37.344011],[-6.643515,37.343977],[-6.638815,37.343599],[-6.636109,37.343543],[-6.634342,37.34363],[-6.631043,37.344003],[-6.628094,37.344577],[-6.625684,37.345279],[-6.624047,37.345861],[-6.620137,37.347487],[-6.618238,37.348146],[-6.615858,37.348811],[-6.613482,37.349288],[-6.608068,37.349995],[-6.604313,37.350797],[-6.599592,37.352249],[-6.597374,37.35283],[-6.594211,37.353357],[-6.591811,37.35357],[-6.588391,37.353573],[-6.585738,37.353344],[-6.582342,37.3528],[-6.580269,37.352539],[-6.578173,37.352435],[-6.575847,37.35243],[-6.573601,37.352568],[-6.571559,37.352823],[-6.566225,37.35364],[-6.561111,37.354027],[-6.558845,37.354331],[-6.555407,37.355063],[-6.54994,37.356687],[-6.547085,37.357309],[-6.544985,37.357603],[-6.542992,37.357768],[-6.539027,37.357992],[-6.535506,37.358391],[-6.528453,37.359503],[-6.524535,37.35987],[-6.522747,37.359968],[-6.51807,37.360018],[-6.513198,37.35972],[-6.510808,37.359441],[-6.508451,37.359081],[-6.505163,37.358463],[-6.503198,37.35802],[-6.500029,37.357175],[-6.497421,37.356349],[-6.495125,37.355489],[-6.491372,37.353941],[-6.487728,37.352576],[-6.485167,37.35176],[-6.483259,37.35124],[-6.47981,37.350437],[-6.478048,37.350093],[-6.47494,37.349615],[-6.47056,37.349052],[-6.467256,37.348533],[-6.463217,37.347708],[-6.457794,37.346345],[-6.453493,37.345563],[-6.44969,37.345079],[-6.446581,37.344822],[-6.44427,37.344754],[-6.440937,37.344767],[-6.439143,37.344835],[-6.435703,37.345116],[-6.432658,37.345463],[-6.429076,37.346093],[-6.427288,37.346471],[-6.424279,37.347231],[-6.420786,37.348283],[-6.415601,37.350037],[-6.411376,37.351156],[-6.407881,37.351846],[-6.405052,37.352289],[-6.401525,37.352669],[-6.399279,37.352827],[-6.393674,37.353018],[-6.391607,37.353148],[-6.387998,37.353493],[-6.382873,37.353736],[-6.379009,37.353725],[-6.374318,37.353487],[-6.370929,37.353496],[-6.369072,37.353567],[-6.365374,37.353831],[-6.359835,37.354555],[-6.357157,37.354845],[-6.354487,37.355051],[-6.350985,37.355227],[-6.346739,37.355576],[-6.344382,37.355872],[-6.341479,37.356368],[-6.335397,37.357749],[-6.330773,37.358616],[-6.327395,37.359078],[-6.325558,37.359253],[-6.322463,37.359432],[-6.31933,37.359447],[-6.314505,37.359327],[-6.309739,37.359543],[-6.305844,37.359976],[-6.300009,37.360814],[-6.29686,37.361106],[-6.292203,37.361294],[-6.289491,37.361261],[-6.283751,37.360902],[-6.281283,37.360829],[-6.276909,37.360889],[-6.272757,37.361225],[-6.268471,37.361838],[-6.264558,37.362625],[-6.260856,37.363619],[-6.258949,37.364192],[-6.253319,37.366086],[-6.249667,37.367103],[-6.246605,37.367795],[-6.239977,37.368992],[-6.238186,37.369428],[-6.235308,37.370374],[-6.233079,37.370973],[-6.230809,37.371337],[-6.22789,37.37142],[-6.225947,37.37125],[-6.223751,37.370838],[-6.222019,37.370362],[-6.220057,37.369532],[-6.218957,37.368961],[-6.215636,37.366728],[-6.213542,37.365423],[-6.210681,37.363988],[-6.207723,37.362748],[-6.205582,37.362072],[-6.202868,37.361536],[-6.199896,37.361044],[-6.197765,37.360473],[-6.193806,37.358915],[-6.192079,37.358408],[-6.18979,37.357962],[-6.187161,37.357761],[-6.183411,37.35779],[-6.179634,37.357548],[-6.177501,37.357223],[-6.175078,37.35699],[-6.171846,37.356915],[-6.168363,37.357162],[-6.164711,37.357642],[-6.161191,37.358027],[-6.157814,37.358232],[-6.153719,37.358336],[-6.150196,37.358541],[-6.146701,37.358927],[-6.142469,37.359649],[-6.137756,37.360807],[-6.134032,37.361876],[-6.130327,37.362782],[-6.127405,37.363363],[-6.124996,37.363727],[-6.119069,37.364512],[-6.11422,37.365482],[-6.111525,37.366195],[-6.10765,37.367448],[-6.102233,37.369523],[-6.09996,37.370333],[-6.096128,37.371517],[-6.093255,37.372227],[-6.088739,37.373132],[-6.086121,37.373811],[-6.084265,37.374403],[-6.081907,37.375328],[-6.079071,37.37678],[-6.07556,37.37895],[-6.074091,37.379778],[-6.071892,37.380849],[-6.069422,37.381803],[-6.065718,37.382822],[-6.063686,37.383156],[-6.061295,37.383434],[-6.056273,37.38371],[-6.053408,37.383437],[-6.040436,37.380867],[-6.038494,37.380726],[-6.037622,37.380869],[-6.036105,37.381492],[-6.034828,37.382719],[-6.034354,37.383958],[-6.033796,37.388038],[-6.033577,37.388654],[-6.032501,37.389507],[-6.031681,37.389744],[-6.031835,37.389211],[-6.031337,37.388958],[-6.031184,37.389569],[-6.030705,37.389743],[-6.029641,37.389348],[-6.028253,37.388358],[-6.026709,37.386679],[-6.025996,37.385461],[-6.025789,37.384659],[-6.025791,37.383413],[-6.026027,37.381499],[-6.026906,37.37602],[-6.027786,37.373584],[-6.027752,37.372738],[-6.02738,37.372161],[-6.026464,37.371626],[-6.024538,37.3715],[-6.019192,37.371339],[-6.016275,37.371739],[-6.015673,37.371277],[-6.015341,37.369721],[-6.014783,37.368739],[-6.013874,37.368703],[-6.013376,37.369966],[-6.012509,37.37004],[-5.998702,37.367902],[-5.997536,37.367495],[-5.99707,37.367603],[-5.997162,37.368894],[-5.995934,37.367997],[-5.99522,37.367969],[-5.995185,37.370498],[-5.995902,37.370494],[-5.995919,37.369844],[-5.997351,37.369745],[-5.997369,37.368517],[-5.997902,37.367932],[-5.997897,37.367203],[-6.000482,37.363531],[-6.001035,37.363134],[-6.000849,37.362794],[-5.998637,37.365957],[-5.99777,37.366894],[-5.994096,37.36645],[-5.993872,37.366114],[-5.993993,37.363254],[-5.994591,37.362665],[-5.993576,37.363115],[-5.993979,37.363814],[-5.993881,37.365881],[-5.994415,37.366425],[-5.997859,37.366875],[-5.997565,37.367367],[-5.996508,37.367726],[-5.989591,37.367526],[-5.989503,37.367332],[-5.989824,37.359684],[-5.989987,37.356626],[-5.990212,37.350748],[-5.990219,37.34834],[-5.990042,37.346757],[-5.989549,37.346454],[-5.986935,37.344253],[-5.984626,37.342944],[-5.984261,37.342405],[-5.985096,37.341206],[-5.985789,37.340753],[-5.98546,37.340455],[-5.984851,37.340682],[-5.983754,37.340372],[-5.983562,37.339618],[-5.984766,37.33711],[-5.985409,37.335134],[-5.985666,37.333676],[-5.985888,37.330726],[-5.985744,37.327956],[-5.985486,37.326061],[-5.985064,37.324426],[-5.983534,37.319464],[-5.983166,37.317005],[-5.983114,37.315523],[-5.983247,37.31236],[-5.983175,37.310075],[-5.983013,37.308215],[-5.982468,37.305993],[-5.982071,37.304772],[-5.980429,37.300397],[-5.979551,37.297596],[-5.978967,37.294734],[-5.978827,37.293687],[-5.97872,37.291415],[-5.978841,37.28853],[-5.97922,37.284417],[-5.979303,37.281862],[-5.979176,37.280009],[-5.978711,37.277282],[-5.978348,37.276115],[-5.977627,37.27462],[-5.976612,37.273165],[-5.975041,37.271495],[-5.973779,37.270518],[-5.969025,37.267698],[-5.966413,37.265901],[-5.964471,37.264191],[-5.963208,37.26286],[-5.96178,37.261137],[-5.959809,37.259131],[-5.958095,37.257787],[-5.95658,37.256896],[-5.955439,37.256364],[-5.953521,37.255677],[-5.950691,37.25512],[-5.947242,37.254851],[-5.943253,37.254762],[-5.939376,37.254528],[-5.937056,37.254251],[-5.934488,37.253813],[-5.927939,37.252536],[-5.925435,37.251952],[-5.924476,37.251644],[-5.92387,37.251204],[-5.9233,37.250295],[-5.923147,37.249425],[-5.923302,37.247963],[-5.923879,37.245728],[-5.926755,37.235843],[-5.926885,37.234013],[-5.925156,37.227651],[-5.924853,37.227109],[-5.923139,37.224835],[-5.922487,37.223503],[-5.92139,37.220371],[-5.920208,37.216785],[-5.920291,37.215106],[-5.921437,37.212665],[-5.923496,37.206594],[-5.925136,37.199436],[-5.925095,37.197143],[-5.924599,37.190903],[-5.924287,37.186127],[-5.924437,37.18426],[-5.925112,37.182707],[-5.925765,37.181798],[-5.926784,37.180889],[-5.929414,37.179155],[-5.934687,37.175804],[-5.939988,37.172339],[-5.941264,37.17135],[-5.942185,37.170157],[-5.942622,37.168973],[-5.942728,37.16771],[-5.94272,37.165253],[-5.942389,37.159966],[-5.941799,37.158154],[-5.941179,37.15727],[-5.940191,37.156315],[-5.938227,37.155231],[-5.927876,37.151482],[-5.925978,37.150715],[-5.924494,37.149869],[-5.922854,37.148499],[-5.921534,37.146626],[-5.920261,37.144977],[-5.919098,37.143844],[-5.917802,37.142771],[-5.915685,37.141419],[-5.91342,37.140303],[-5.911908,37.139368],[-5.909776,37.137707],[-5.904999,37.133298],[-5.903809,37.13214],[-5.899612,37.128318],[-5.891025,37.120307],[-5.887366,37.116978],[-5.88502,37.114758],[-5.878869,37.109062],[-5.874872,37.105399],[-5.873079,37.1037],[-5.865769,37.096943],[-5.86501,37.096071],[-5.861257,37.091048],[-5.860393,37.089784],[-5.858209,37.083594],[-5.857109,37.081607],[-5.854054,37.076796],[-5.847013,37.068844],[-5.843727,37.065604],[-5.839976,37.06177],[-5.839249,37.059972],[-5.838658,37.055955],[-5.838556,37.054916],[-5.839083,37.048003],[-5.83908,37.046969],[-5.838384,37.040626],[-5.837857,37.036415],[-5.837249,37.029557],[-5.836923,37.026237],[-5.836397,37.022799],[-5.834762,37.019359],[-5.833668,37.017208],[-5.832322,37.014016],[-5.832046,37.012801],[-5.832098,37.007582],[-5.831772,37.005945],[-5.830718,37.003944],[-5.830074,37.002128],[-5.829003,36.999573],[-5.828867,36.998994],[-5.828543,36.995545],[-5.828492,36.992759],[-5.828769,36.991659],[-5.829372,36.990715],[-5.829997,36.990196],[-5.831003,36.989699],[-5.835938,36.987964],[-5.838775,36.986818],[-5.841735,36.98572],[-5.844174,36.98437],[-5.845418,36.983438],[-5.846564,36.9828],[-5.849118,36.981792],[-5.849639,36.981428],[-5.851187,36.979531],[-5.853284,36.978293],[-5.855494,36.977267],[-5.858756,36.976027],[-5.859878,36.975397],[-5.86638,36.97113],[-5.869004,36.969577],[-5.870535,36.968796],[-5.877444,36.965777],[-5.88152,36.964297],[-5.885824,36.962082],[-5.886947,36.961409],[-5.888546,36.960195],[-5.890487,36.958864],[-5.894713,36.956632],[-5.895481,36.956165],[-5.898982,36.953251],[-5.899555,36.952583],[-5.901915,36.949391],[-5.903955,36.947238],[-5.908406,36.94391],[-5.916479,36.939459],[-5.919039,36.93759],[-5.921531,36.935472],[-5.922998,36.93385],[-5.924817,36.930688],[-5.926067,36.929046],[-5.926844,36.928241],[-5.927585,36.927781],[-5.93009,36.926643],[-5.932177,36.925158],[-5.935792,36.922481],[-5.941422,36.918627],[-5.94406,36.917393],[-5.94617,36.916792],[-5.951451,36.915815],[-5.956014,36.915175],[-5.956997,36.914829],[-5.963621,36.91146],[-5.968518,36.908445],[-5.971948,36.906669],[-5.974122,36.905889],[-5.981055,36.903958],[-5.983684,36.903267],[-5.985079,36.902796],[-5.986106,36.902204],[-5.988993,36.900023],[-5.989994,36.899376],[-5.994189,36.897132],[-5.997433,36.896017],[-5.999493,36.895027],[-6.001084,36.894116],[-6.003603,36.892867],[-6.005987,36.891864],[-6.008685,36.890129],[-6.009083,36.889786],[-6.013494,36.885244],[-6.01508,36.883885],[-6.017255,36.881494],[-6.021451,36.877435],[-6.024544,36.8742],[-6.026713,36.87239],[-6.028636,36.869819],[-6.029731,36.8678],[-6.032551,36.864166],[-6.035006,36.861263],[-6.038232,36.857214],[-6.039106,36.855121],[-6.039836,36.854482],[-6.040193,36.85371],[-6.041368,36.852483],[-6.042706,36.851304],[-6.04671,36.84883],[-6.047319,36.848363],[-6.050253,36.844694],[-6.051832,36.843263],[-6.052499,36.842112],[-6.053213,36.840191],[-6.053625,36.83961],[-6.054567,36.838994],[-6.063538,36.835801],[-6.064585,36.835294],[-6.065423,36.834617],[-6.068672,36.831175],[-6.06921,36.830172],[-6.069257,36.829312],[-6.067198,36.823231],[-6.066213,36.820947],[-6.064904,36.81905],[-6.064129,36.818252],[-6.06176,36.816487],[-6.060885,36.815455],[-6.060465,36.814643],[-6.060249,36.813291],[-6.060726,36.810893],[-6.062336,36.806139],[-6.062484,36.805152],[-6.062359,36.804041],[-6.061777,36.802682],[-6.060502,36.801063],[-6.058266,36.797955],[-6.057437,36.796426],[-6.056667,36.794663],[-6.055657,36.791609],[-6.055543,36.790383],[-6.055822,36.78808],[-6.05605,36.784137],[-6.056594,36.780997],[-6.056911,36.780187],[-6.058312,36.777583],[-6.064684,36.767891],[-6.066421,36.765737],[-6.068407,36.763441],[-6.071238,36.759535],[-6.073154,36.757661],[-6.076964,36.752568],[-6.078658,36.750134],[-6.085194,36.739755],[-6.087253,36.736617],[-6.088989,36.734104],[-6.090426,36.732466],[-6.095614,36.727319],[-6.097078,36.725802],[-6.101509,36.721483],[-6.103181,36.720129],[-6.104901,36.719067],[-6.107478,36.71788],[-6.109727,36.71719],[-6.112087,36.716757],[-6.115505,36.716429],[-6.118668,36.716249],[-6.122895,36.716124],[-6.126299,36.716149],[-6.128359,36.716262],[-6.132187,36.716282],[-6.134622,36.716182],[-6.136759,36.715998],[-6.139174,36.715665],[-6.142118,36.715032],[-6.145905,36.713856],[-6.15148,36.711568],[-6.154801,36.71008],[-6.15715,36.708954],[-6.159829,36.707376],[-6.161881,36.705901],[-6.163209,36.704745],[-6.165345,36.702429],[-6.166619,36.700721],[-6.167785,36.698725],[-6.168706,36.696656],[-6.169188,36.695165],[-6.171086,36.68801],[-6.173037,36.680906],[-6.173518,36.678734],[-6.174058,36.675541],[-6.174373,36.672539],[-6.174372,36.668527],[-6.174255,36.666127],[-6.173803,36.662665],[-6.173189,36.6597],[-6.172622,36.657644],[-6.172386,36.655903],[-6.1726,36.653797],[-6.173085,36.65273],[-6.17515,36.649814],[-6.176124,36.64756],[-6.176902,36.646452],[-6.177886,36.645539],[-6.179399,36.644601],[-6.180913,36.643976],[-6.182057,36.643314],[-6.186089,36.640302],[-6.187097,36.639082],[-6.187512,36.638041],[-6.18764,36.63704],[-6.187498,36.636044],[-6.18698,36.634878],[-6.185487,36.633366],[-6.184637,36.632278],[-6.184292,36.631433],[-6.184208,36.629901],[-6.184529,36.628825],[-6.185778,36.626413],[-6.186273,36.625249],[-6.187082,36.622814],[-6.187476,36.621326],[-6.187732,36.619618],[-6.187827,36.61799],[-6.187801,36.615873],[-6.187394,36.612642],[-6.186014,36.606408],[-6.1843,36.598975],[-6.183842,36.596491],[-6.18305,36.593202],[-6.182966,36.591244],[-6.183295,36.589022],[-6.184417,36.584488],[-6.184682,36.583634],[-6.186291,36.577069],[-6.18675,36.575799],[-6.187883,36.573543],[-6.188619,36.571653],[-6.18901,36.569429],[-6.189017,36.567857],[-6.188753,36.566106],[-6.188452,36.565],[-6.187829,36.563512],[-6.187129,36.562264],[-6.186284,36.561109],[-6.185313,36.56003],[-6.183018,36.558154],[-6.174915,36.553099],[-6.172672,36.551814],[-6.170378,36.550217],[-6.169045,36.548556],[-6.168495,36.547309],[-6.168165,36.5456],[-6.168124,36.542152],[-6.168224,36.539223],[-6.168394,36.536914],[-6.168811,36.532704],[-6.168526,36.530534],[-6.16757,36.528472],[-6.166876,36.527516],[-6.165542,36.52616],[-6.163848,36.524072],[-6.16281,36.522644],[-6.160954,36.520536],[-6.1572,36.517246],[-6.154894,36.515411],[-6.153466,36.514023],[-6.151858,36.512134],[-6.149955,36.510261],[-6.148498,36.508965],[-6.146772,36.506873],[-6.145689,36.505304],[-6.145086,36.504083],[-6.144692,36.502338],[-6.144178,36.498073],[-6.143536,36.493571],[-6.143582,36.490625],[-6.143917,36.48772],[-6.143915,36.487087],[-6.144263,36.485038],[-6.144535,36.48177],[-6.145201,36.474787],[-6.145504,36.473343],[-6.146391,36.471851],[-6.147217,36.471081],[-6.148904,36.470165],[-6.150517,36.469665],[-6.155029,36.468409],[-6.156725,36.468178],[-6.158925,36.468322],[-6.161457,36.468693],[-6.163746,36.468501],[-6.164967,36.468062],[-6.16722,36.466895],[-6.168076,36.466581],[-6.168775,36.466601],[-6.169031,36.467038],[-6.168292,36.467656],[-6.166911,36.467776],[-6.165811,36.467439],[-6.165185,36.467003],[-6.162668,36.463845],[-6.158411,36.458793],[-6.152765,36.452574],[-6.149075,36.448337],[-6.148318,36.447283],[-6.146272,36.445462],[-6.145349,36.444945],[-6.14392,36.444428],[-6.142698,36.444212],[-6.139755,36.444248],[-6.137163,36.44392],[-6.135856,36.443491],[-6.132133,36.441939],[-6.130079,36.441019],[-6.128442,36.440167],[-6.126,36.438697],[-6.123219,36.436653],[-6.118332,36.432042],[-6.116148,36.429713],[-6.115144,36.428392],[-6.114583,36.427364],[-6.114202,36.42581],[-6.114388,36.423812],[-6.114917,36.422538],[-6.11662,36.420263],[-6.117878,36.418155],[-6.118664,36.415952],[-6.118951,36.413848],[-6.118984,36.412153],[-6.119263,36.410719],[-6.119572,36.409924],[-6.120315,36.408775],[-6.121952,36.407349],[-6.123672,36.406288],[-6.125161,36.404953],[-6.125819,36.40401],[-6.126247,36.402986],[-6.126449,36.401257],[-6.126336,36.400353],[-6.125714,36.398874],[-6.125142,36.397852],[-6.122927,36.394567],[-6.121208,36.392252],[-6.118216,36.388449],[-6.117331,36.386877],[-6.11548,36.382878],[-6.11497,36.38137],[-6.114699,36.38006],[-6.113011,36.370043],[-6.112559,36.367687],[-6.111677,36.364861],[-6.110841,36.362889],[-6.109202,36.360066],[-6.107922,36.358624],[-6.106184,36.357298],[-6.103896,36.356185],[-6.102379,36.355732],[-6.100039,36.355387],[-6.098733,36.355361],[-6.091155,36.355694],[-6.087236,36.35558],[-6.083692,36.355161],[-6.077638,36.354146],[-6.07298,36.353289],[-6.070389,36.352505],[-6.069047,36.351893],[-6.067554,36.350927],[-6.065427,36.3492],[-6.064005,36.348156],[-6.062406,36.34722],[-6.059672,36.346042],[-6.055592,36.345129],[-6.053862,36.344442],[-6.052253,36.343479],[-6.05098,36.34231],[-6.050093,36.341163],[-6.04923,36.339279],[-6.048996,36.337968],[-6.049081,36.336616],[-6.049658,36.334659],[-6.050412,36.333475],[-6.053255,36.329704],[-6.054405,36.32788],[-6.055277,36.326135],[-6.056318,36.323327],[-6.057102,36.319987],[-6.057347,36.317563],[-6.057321,36.315167],[-6.057192,36.313854],[-6.05656,36.310043],[-6.056095,36.306584],[-6.056039,36.303272],[-6.056486,36.29992],[-6.057265,36.296278],[-6.057381,36.294227],[-6.05758,36.29283],[-6.058318,36.292075],[-6.060973,36.291437],[-6.061887,36.291125],[-6.06334,36.290261],[-6.064985,36.289647],[-6.06661,36.288056],[-6.069027,36.286347],[-6.070057,36.285399],[-6.07122,36.283851],[-6.072684,36.282311],[-6.073758,36.281345],[-6.075096,36.279825],[-6.076529,36.27856],[-6.077757,36.278132],[-6.08001,36.27703],[-6.078097,36.276285],[-6.076666,36.276212],[-6.075739,36.276022],[-6.074991,36.275481],[-6.074595,36.273969],[-6.073588,36.271932],[-6.073498,36.271093],[-6.07407,36.268373],[-6.074236,36.265149],[-6.073903,36.263381],[-6.073615,36.262719],[-6.07179,36.260304],[-6.069747,36.254407],[-6.068875,36.251631],[-6.066534,36.248528],[-6.065012,36.246758],[-6.063676,36.244937],[-6.062192,36.243637],[-6.060913,36.242023],[-6.059869,36.241192],[-6.058473,36.240401],[-6.054481,36.238305],[-6.053224,36.237536],[-6.051708,36.236037],[-6.048491,36.234379],[-6.047664,36.233699],[-6.047555,36.233147],[-6.047797,36.231763],[-6.048172,36.230541],[-6.048189,36.227937],[-6.048473,36.227239],[-6.047001,36.2261],[-6.04483,36.224956],[-6.043836,36.224229],[-6.042248,36.222726],[-6.040668,36.220258],[-6.039578,36.218939],[-6.037083,36.21633],[-6.035525,36.214278],[-6.033007,36.211773],[-6.032897,36.210463],[-6.033656,36.209258],[-6.035329,36.208086],[-6.0354,36.207419],[-6.034076,36.204962],[-6.034341,36.204245],[-6.035285,36.202674],[-6.035552,36.201356],[-6.034222,36.199417],[-6.033274,36.198806],[-6.031248,36.197845],[-6.030598,36.197335],[-6.030975,36.195968],[-6.031389,36.19306],[-6.030734,36.192061],[-6.026973,36.190598],[-6.026305,36.190253],[-6.023765,36.188482],[-6.023326,36.188257],[-6.020766,36.187736],[-6.013639,36.185854],[-6.01151,36.185839],[-6.009196,36.185454],[-6.008832,36.185769],[-6.008172,36.186896],[-6.009013,36.187634],[-6.008573,36.188256],[-6.005116,36.188226],[-6.004521,36.188555],[-6.004214,36.189502],[-6.003623,36.189888],[-6.000082,36.191687],[-5.996655,36.192234],[-5.995289,36.19265],[-5.993705,36.193311],[-5.99198,36.193519],[-5.978168,36.190949],[-5.968647,36.189225],[-5.967945,36.188966],[-5.96698,36.18798],[-5.966341,36.18768],[-5.965165,36.187469],[-5.959365,36.187277],[-5.957701,36.187358],[-5.955217,36.186941],[-5.952775,36.187037],[-5.951726,36.187445],[-5.951352,36.187984],[-5.951084,36.18973],[-5.950517,36.190285],[-5.948212,36.191195],[-5.947592,36.192047],[-5.947071,36.192267],[-5.946167,36.192195],[-5.944578,36.191142],[-5.942045,36.189959],[-5.940998,36.189086],[-5.938805,36.188097],[-5.938286,36.187761],[-5.937623,36.186894],[-5.936865,36.186321],[-5.936157,36.186166],[-5.933209,36.18684],[-5.930029,36.187014],[-5.926702,36.186698],[-5.924944,36.186721],[-5.924222,36.187011],[-5.921473,36.189999],[-5.919027,36.193168],[-5.917749,36.194916],[-5.913951,36.194649],[-5.913437,36.194285],[-5.911955,36.189537],[-5.911454,36.188325],[-5.910507,36.18686],[-5.90947,36.185783],[-5.904564,36.181571],[-5.899849,36.177448],[-5.89361,36.172312],[-5.891406,36.170316],[-5.890205,36.169346],[-5.886356,36.166724],[-5.885361,36.166311],[-5.882788,36.165675],[-5.87701,36.166417],[-5.871168,36.16723],[-5.869771,36.166976],[-5.86914,36.166665],[-5.86642,36.164416],[-5.865104,36.162225],[-5.86469,36.160709],[-5.863643,36.157961],[-5.862879,36.156636],[-5.860933,36.153775],[-5.860221,36.152331],[-5.860288,36.151395],[-5.859254,36.148939],[-5.851647,36.139868],[-5.850495,36.139097],[-5.84809,36.138422],[-5.846672,36.13821],[-5.845195,36.138503],[-5.84391,36.139646],[-5.84125,36.141244],[-5.840733,36.141671],[-5.839711,36.143033],[-5.837603,36.144988],[-5.836036,36.147336],[-5.834887,36.148236],[-5.833099,36.148973],[-5.830397,36.149831],[-5.82883,36.150149],[-5.827702,36.150082],[-5.826676,36.1502],[-5.822071,36.151914],[-5.82145,36.152229],[-5.819102,36.154004],[-5.818395,36.154734],[-5.817659,36.15677],[-5.817603,36.157945],[-5.817006,36.160023],[-5.815774,36.160973],[-5.815627,36.161444],[-5.815454,36.164509],[-5.816043,36.166077],[-5.81589,36.166861],[-5.815953,36.16816],[-5.815443,36.168875],[-5.812946,36.170252],[-5.811318,36.17249],[-5.810212,36.175845],[-5.809937,36.176293],[-5.808513,36.177706],[-5.807607,36.179148],[-5.806448,36.179693],[-5.805749,36.180355],[-5.804574,36.182299],[-5.803609,36.183227],[-5.802695,36.184955],[-5.80208,36.185687],[-5.800291,36.188979],[-5.79898,36.191549],[-5.798489,36.19375],[-5.796112,36.198341],[-5.794168,36.201992],[-5.793849,36.203604],[-5.792518,36.207688],[-5.791351,36.210452],[-5.791016,36.210742],[-5.790015,36.210877],[-5.787614,36.209076],[-5.782203,36.204675],[-5.777061,36.200577],[-5.775904,36.199614],[-5.771469,36.196097],[-5.765992,36.191688],[-5.765175,36.19108],[-5.760656,36.187374],[-5.75954,36.18669],[-5.756345,36.185422],[-5.75471,36.184707],[-5.753491,36.183772],[-5.750072,36.179871],[-5.748271,36.177725],[-5.738252,36.166206],[-5.737444,36.16518],[-5.735572,36.162185],[-5.732951,36.158222],[-5.731256,36.156545],[-5.730112,36.155746],[-5.719122,36.149526],[-5.718315,36.148953],[-5.71756,36.148057],[-5.712462,36.138773],[-5.711217,36.136561],[-5.709637,36.135072],[-5.709277,36.134505],[-5.708802,36.132429],[-5.70874,36.131221],[-5.708831,36.128521],[-5.708538,36.126588],[-5.708579,36.124297],[-5.708354,36.123429],[-5.707404,36.121798],[-5.706939,36.120515],[-5.706903,36.119432],[-5.707554,36.11772],[-5.709429,36.114513],[-5.709785,36.11279],[-5.709596,36.109467],[-5.709289,36.108481],[-5.70678,36.103529],[-5.706279,36.102658],[-5.705287,36.101838],[-5.703054,36.100379],[-5.702009,36.099308],[-5.699719,36.097309],[-5.699236,36.096683],[-5.698493,36.094858],[-5.696697,36.092914],[-5.695432,36.090713],[-5.694483,36.089727],[-5.693469,36.089048],[-5.69243,36.087948],[-5.69203,36.086987],[-5.69204,36.084632],[-5.691632,36.081982],[-5.690168,36.077566],[-5.689776,36.076844],[-5.685856,36.072491],[-5.684309,36.070877],[-5.680689,36.068793],[-5.67974,36.068142],[-5.671424,36.061949],[-5.670452,36.061268],[-5.664698,36.057934],[-5.662507,36.057041],[-5.659813,36.056534],[-5.653396,36.056347],[-5.651863,36.056145],[-5.651138,36.055858],[-5.634603,36.045321],[-5.633774,36.044896],[-5.631445,36.044007],[-5.629058,36.043262],[-5.62723,36.042376],[-5.623058,36.039922],[-5.622064,36.039101],[-5.620648,36.037341],[-5.616123,36.033245],[-5.613475,36.030926],[-5.611978,36.029512],[-5.611731,36.028696],[-5.611887,36.027821],[-5.611552,36.024433],[-5.611584,36.022553],[-5.611058,36.021702],[-5.608472,36.018304],[-5.606477,36.016184],[-5.607929,36.01506],[-5.607965,36.014466],[-5.610592,36.01606],[-5.611157,36.017073],[-5.610226,36.017859],[-5.610127,36.018411],[-5.609384,36.019583],[-5.611416,36.022293],[-5.61158,36.022723],[-5.611538,36.024851],[-5.611849,36.027171],[-5.611839,36.027913],[-5.611456,36.029151],[-5.619598,36.036477],[-5.620245,36.037483],[-5.620873,36.037692],[-5.621974,36.039122],[-5.623028,36.039993],[-5.627619,36.042668],[-5.628364,36.043051],[-5.63075,36.043837],[-5.63364,36.044915],[-5.634637,36.045422],[-5.644055,36.051429],[-5.650839,36.05571],[-5.651487,36.05604],[-5.652993,36.056343],[-5.658297,36.0565],[-5.659461,36.056454],[-5.662819,36.057015],[-5.660818,36.056608],[-5.657622,36.056388],[-5.652912,36.056255],[-5.65169,36.056053],[-5.650808,36.05562],[-5.647281,36.05338],[-5.641491,36.049776],[-5.639999,36.048744],[-5.63456,36.045312],[-5.634101,36.045067],[-5.630278,36.04363],[-5.628696,36.043165],[-5.627671,36.042637],[-5.622869,36.039801],[-5.622082,36.039121],[-5.620629,36.037301],[-5.611252,36.028995],[-5.608876,36.027823],[-5.604274,36.026532],[-5.601379,36.026288],[-5.60031,36.025811],[-5.599792,36.025318],[-5.598791,36.02385],[-5.597441,36.023133],[-5.596498,36.02311],[-5.592995,36.024214],[-5.58784,36.026648],[-5.586797,36.02727],[-5.584812,36.028732],[-5.582711,36.030519],[-5.581351,36.031311],[-5.578904,36.03215],[-5.576657,36.032589],[-5.576082,36.032836],[-5.574958,36.033851],[-5.574401,36.034171],[-5.57266,36.03479],[-5.571923,36.035373],[-5.571573,36.036449],[-5.569287,36.038722],[-5.568821,36.040455],[-5.567659,36.041094],[-5.566743,36.04109],[-5.565242,36.040214],[-5.564377,36.04026],[-5.563031,36.040771],[-5.561693,36.041116],[-5.561053,36.041617],[-5.560428,36.043138],[-5.560612,36.045238],[-5.560309,36.045853],[-5.559553,36.046176],[-5.557485,36.04641],[-5.557179,36.046718],[-5.557098,36.047477],[-5.556516,36.048252],[-5.555595,36.048752],[-5.55493,36.04986],[-5.554339,36.050317],[-5.554097,36.050933],[-5.5545,36.051727],[-5.553792,36.053087],[-5.552112,36.054116],[-5.550626,36.054201],[-5.550085,36.054423],[-5.54859,36.055762],[-5.547403,36.057264],[-5.544652,36.058095],[-5.543197,36.058003],[-5.542483,36.058163],[-5.539804,36.059328],[-5.538967,36.059904],[-5.537765,36.061215],[-5.537392,36.062006],[-5.536951,36.062391],[-5.535381,36.063161],[-5.534554,36.063793],[-5.532926,36.064519],[-5.532479,36.065639],[-5.531018,36.067381],[-5.530482,36.06882],[-5.529523,36.069565],[-5.528562,36.069415],[-5.527335,36.068911],[-5.525731,36.068906],[-5.524499,36.069253],[-5.522634,36.069609],[-5.521583,36.070272],[-5.519686,36.070855],[-5.512478,36.072795],[-5.511627,36.073211],[-5.511189,36.07367],[-5.509235,36.076507],[-5.508696,36.076853],[-5.507297,36.07726],[-5.506414,36.078222],[-5.506381,36.079834],[-5.506121,36.080799],[-5.505685,36.081374],[-5.504682,36.08201],[-5.501688,36.082909],[-5.500315,36.083234],[-5.497557,36.083722],[-5.496679,36.084065],[-5.494835,36.085222],[-5.492687,36.086211],[-5.491396,36.087118],[-5.490649,36.087354],[-5.488431,36.087699],[-5.486597,36.088201],[-5.485255,36.088775],[-5.482615,36.089531],[-5.480879,36.090528],[-5.480318,36.091006],[-5.479728,36.092506],[-5.479235,36.092979],[-5.477345,36.093243],[-5.475749,36.093654],[-5.474042,36.093819],[-5.473262,36.094096],[-5.472659,36.09458],[-5.472025,36.095467],[-5.470288,36.096726],[-5.469101,36.097743],[-5.467764,36.098404],[-5.466658,36.099691],[-5.465622,36.100186],[-5.464552,36.101155],[-5.463797,36.102326],[-5.463115,36.104072],[-5.461982,36.105494],[-5.459878,36.107221],[-5.459283,36.107937],[-5.457708,36.110262],[-5.457786,36.110645],[-5.457321,36.111713],[-5.456038,36.112676],[-5.455708,36.11322],[-5.456073,36.113829],[-5.458617,36.115242],[-5.459773,36.115988],[-5.460589,36.116806],[-5.46103,36.118204],[-5.460697,36.122818],[-5.460855,36.123599],[-5.461283,36.124308],[-5.462944,36.126018],[-5.463277,36.126722],[-5.46418,36.130185],[-5.464218,36.131564],[-5.464,36.132155],[-5.463041,36.13317],[-5.461133,36.134657],[-5.460486,36.135423],[-5.459962,36.136571],[-5.4599,36.137481],[-5.460458,36.140091],[-5.460473,36.141157],[-5.460207,36.141817],[-5.459405,36.142633],[-5.458651,36.143027],[-5.454319,36.144645],[-5.453766,36.145042],[-5.453457,36.145646],[-5.453555,36.146658],[-5.454605,36.148723],[-5.454757,36.150188],[-5.45458,36.154709],[-5.454895,36.155626],[-5.455465,36.156312],[-5.458272,36.158597],[-5.459089,36.159629],[-5.459552,36.160982],[-5.459382,36.162027],[-5.458594,36.164184],[-5.456961,36.167641],[-5.456519,36.169697],[-5.455019,36.173841],[-5.454481,36.174727],[-5.453469,36.175581],[-5.442574,36.182112],[-5.440103,36.183633],[-5.43927,36.184349],[-5.435525,36.188625],[-5.431284,36.193363],[-5.427834,36.197908],[-5.425886,36.200026],[-5.423414,36.202349],[-5.422755,36.202881],[-5.421043,36.203503],[-5.418472,36.203741],[-5.417406,36.204094],[-5.415498,36.205086],[-5.413335,36.205896],[-5.410416,36.206751],[-5.404773,36.207737],[-5.403715,36.207743],[-5.39584,36.206993],[-5.393788,36.206953],[-5.389061,36.207592],[-5.387647,36.207479],[-5.385475,36.206642],[-5.383999,36.206557],[-5.382962,36.206843],[-5.381939,36.207464],[-5.381451,36.208009],[-5.378192,36.215939],[-5.376964,36.217892],[-5.375774,36.219068],[-5.372331,36.221442],[-5.36658,36.226308],[-5.365605,36.226869],[-5.364108,36.227416],[-5.362432,36.227643],[-5.359758,36.227815],[-5.358265,36.228237],[-5.356889,36.22886],[-5.350175,36.232112],[-5.348266,36.233439],[-5.344172,36.237014],[-5.343408,36.237828],[-5.342487,36.239121],[-5.34132,36.241355],[-5.338236,36.245971],[-5.337792,36.247584],[-5.337947,36.248951],[-5.338459,36.250247],[-5.339167,36.251479],[-5.3394,36.252542],[-5.339346,36.25339],[-5.339024,36.254408],[-5.338209,36.255543],[-5.336749,36.256601],[-5.329557,36.26066],[-5.328586,36.261158],[-5.326229,36.262055],[-5.324808,36.262432],[-5.321634,36.262919],[-5.319952,36.263268],[-5.31842,36.264015],[-5.317621,36.264693],[-5.316733,36.265981],[-5.316448,36.266931],[-5.31661,36.268746],[-5.31734,36.271095],[-5.317426,36.272342],[-5.316986,36.274348],[-5.316343,36.275665],[-5.314616,36.278398],[-5.313887,36.27985],[-5.312152,36.284493],[-5.310961,36.286457],[-5.309944,36.287519],[-5.308309,36.288727],[-5.30714,36.289328],[-5.304224,36.290498],[-5.300305,36.291963],[-5.298301,36.292616],[-5.291254,36.294659],[-5.28592,36.296242],[-5.28385,36.296755],[-5.282748,36.296815],[-5.279252,36.295988],[-5.279509,36.296621],[-5.279388,36.297443],[-5.278036,36.299626],[-5.277761,36.301648],[-5.277256,36.302588],[-5.276622,36.303259],[-5.275075,36.304307],[-5.273463,36.305719],[-5.272611,36.306306],[-5.271444,36.306873],[-5.2695,36.307257],[-5.266798,36.307165],[-5.264962,36.30743],[-5.263736,36.308054],[-5.262918,36.308816],[-5.262079,36.310493],[-5.261561,36.311037],[-5.260992,36.311032],[-5.260704,36.311438],[-5.259709,36.311888],[-5.258997,36.311937],[-5.256874,36.311399],[-5.256121,36.311428],[-5.253522,36.31216],[-5.252451,36.312167],[-5.251006,36.311338],[-5.249879,36.311144],[-5.249053,36.311288],[-5.248348,36.311661],[-5.24768,36.312515],[-5.247212,36.313492],[-5.245648,36.317556],[-5.2455,36.318226],[-5.24598,36.319848],[-5.245877,36.320992],[-5.245138,36.321785],[-5.244671,36.321925],[-5.243513,36.322843],[-5.242731,36.323803],[-5.24234,36.325386],[-5.242063,36.328012],[-5.241263,36.330099],[-5.24032,36.334492],[-5.237572,36.344288],[-5.23711,36.345524],[-5.235876,36.348137],[-5.235329,36.348879],[-5.235156,36.350705],[-5.234845,36.351612],[-5.233535,36.35468],[-5.232774,36.356157],[-5.230755,36.359571],[-5.229779,36.361492],[-5.229006,36.363645],[-5.228157,36.366417],[-5.227466,36.367709],[-5.227305,36.368332],[-5.226602,36.369322],[-5.225787,36.371544],[-5.225587,36.372535],[-5.22492,36.374609],[-5.224426,36.375443],[-5.223792,36.375902],[-5.221365,36.377024],[-5.220446,36.377755],[-5.218962,36.379388],[-5.217638,36.380306],[-5.213078,36.381348],[-5.212144,36.381778],[-5.211514,36.38255],[-5.210942,36.384092],[-5.207856,36.386596],[-5.206495,36.388225],[-5.204852,36.390502],[-5.204,36.392126],[-5.202931,36.392732],[-5.200761,36.394497],[-5.199604,36.395663],[-5.198346,36.396471],[-5.196044,36.3976],[-5.194909,36.398628],[-5.194735,36.399306],[-5.195108,36.401561],[-5.195005,36.402584],[-5.194403,36.403652],[-5.193848,36.40418],[-5.190481,36.406275],[-5.187869,36.407993],[-5.18595,36.409088],[-5.184775,36.409864],[-5.183814,36.410772],[-5.182575,36.412234],[-5.178233,36.41683],[-5.17739,36.417423],[-5.175443,36.420071],[-5.174805,36.421445],[-5.174549,36.422347],[-5.173111,36.428922],[-5.172487,36.431585],[-5.172162,36.432107],[-5.171161,36.432774],[-5.169537,36.43299],[-5.164088,36.433041],[-5.161227,36.433216],[-5.159319,36.433544],[-5.153417,36.435063],[-5.15054,36.435597],[-5.149229,36.435686],[-5.146732,36.435603],[-5.141934,36.435183],[-5.139627,36.43541],[-5.135852,36.436422],[-5.133565,36.436726],[-5.131757,36.436601],[-5.129781,36.436122],[-5.128658,36.435659],[-5.125042,36.433505],[-5.123939,36.432963],[-5.122168,36.432467],[-5.12081,36.432339],[-5.118931,36.432504],[-5.117171,36.43303],[-5.11217,36.435013],[-5.107503,36.436904],[-5.103627,36.439171],[-5.10016,36.441358],[-5.099575,36.441912],[-5.098337,36.443615],[-5.097541,36.444179],[-5.095205,36.445539],[-5.092096,36.447149],[-5.089835,36.448226],[-5.086368,36.449984],[-5.084222,36.451133],[-5.081077,36.452701],[-5.079211,36.453277],[-5.0638,36.454],[-5.061833,36.454379],[-5.060688,36.454893],[-5.058309,36.456241],[-5.057135,36.456745],[-5.053492,36.458102],[-5.047729,36.460713],[-5.044178,36.461959],[-5.039379,36.463129],[-5.036164,36.463834],[-5.02894,36.46556],[-5.027785,36.465901],[-5.022006,36.46722],[-5.014271,36.46906],[-5.012954,36.469575],[-5.012096,36.470231],[-5.010662,36.471914],[-5.009286,36.472473],[-5.00544,36.473055],[-5.004158,36.473389],[-5.001607,36.47436],[-5.000577,36.474902],[-4.994121,36.478973],[-4.984562,36.484158],[-4.983237,36.484733],[-4.973896,36.486207],[-4.971218,36.486516],[-4.966541,36.487285],[-4.9631,36.487797],[-4.957861,36.488772],[-4.956079,36.489446],[-4.955055,36.490203],[-4.952423,36.492639],[-4.949209,36.495739],[-4.948295,36.496793],[-4.947729,36.497752],[-4.947303,36.498955],[-4.947136,36.500019],[-4.947139,36.501931],[-4.947373,36.503855],[-4.948229,36.507854],[-4.948348,36.508682],[-4.948082,36.510044],[-4.947255,36.511242],[-4.945632,36.512314],[-4.940844,36.514453],[-4.933765,36.514212],[-4.930991,36.513119],[-4.929832,36.512877],[-4.928349,36.512767],[-4.923232,36.51303],[-4.918241,36.513666],[-4.913032,36.51446],[-4.911325,36.514885],[-4.908155,36.51606],[-4.906001,36.516443],[-4.903766,36.516395],[-4.901077,36.516432],[-4.899482,36.516633],[-4.897779,36.517071],[-4.894404,36.51823],[-4.89278,36.518693],[-4.891616,36.518898],[-4.888402,36.519189],[-4.887292,36.519362],[-4.881865,36.520551],[-4.880207,36.520681],[-4.878836,36.520445],[-4.87722,36.519986],[-4.875003,36.519587],[-4.872542,36.519629],[-4.869228,36.519951],[-4.867737,36.519559],[-4.867115,36.519187],[-4.865904,36.517599],[-4.863594,36.512237],[-4.863116,36.51124],[-4.862465,36.510317],[-4.861231,36.509302],[-4.860152,36.508792],[-4.858208,36.50824],[-4.854734,36.507445],[-4.853042,36.507136],[-4.846899,36.505642],[-4.845673,36.50553],[-4.844544,36.505839],[-4.843573,36.50645],[-4.842298,36.506903],[-4.838347,36.506929],[-4.832837,36.50688],[-4.829263,36.5068],[-4.827516,36.506693],[-4.822498,36.506051],[-4.817788,36.505637],[-4.813131,36.50518],[-4.811452,36.504769],[-4.806476,36.502446],[-4.804899,36.501837],[-4.798619,36.500327],[-4.79167,36.498695],[-4.783884,36.496462],[-4.778539,36.495256],[-4.777567,36.495107],[-4.770265,36.494318],[-4.765312,36.493825],[-4.763629,36.493566],[-4.761554,36.49296],[-4.75848,36.492746],[-4.757711,36.492863],[-4.755953,36.493507],[-4.755134,36.493685],[-4.752869,36.493468],[-4.751749,36.493183],[-4.750769,36.492612],[-4.746191,36.489452],[-4.744192,36.48814],[-4.743043,36.487756],[-4.739796,36.487641],[-4.738403,36.487699],[-4.732489,36.488232],[-4.728554,36.488426],[-4.717653,36.489029],[-4.712779,36.489265],[-4.7111,36.489569],[-4.707653,36.490499],[-4.705406,36.490927],[-4.701424,36.491069],[-4.695575,36.491192],[-4.694093,36.491461],[-4.692793,36.492122],[-4.691917,36.492978],[-4.690712,36.494989],[-4.689356,36.496766],[-4.68505,36.501673],[-4.682687,36.503113],[-4.681631,36.503964],[-4.680606,36.505198],[-4.679617,36.505915],[-4.678754,36.50615],[-4.677195,36.505969],[-4.676631,36.505683],[-4.675681,36.504673],[-4.674723,36.504053],[-4.673865,36.504031],[-4.672347,36.504318],[-4.67048,36.504355],[-4.669364,36.504591],[-4.663656,36.507008],[-4.663006,36.507207],[-4.66161,36.507282],[-4.659503,36.506915],[-4.657372,36.506884],[-4.656712,36.506763],[-4.654716,36.506078],[-4.653409,36.506089],[-4.650349,36.50709],[-4.647263,36.507944],[-4.646129,36.507998],[-4.644507,36.507133],[-4.642958,36.506828],[-4.640478,36.506935],[-4.638999,36.507313],[-4.637237,36.508664],[-4.636622,36.509565],[-4.635258,36.512162],[-4.634378,36.513416],[-4.631151,36.517024],[-4.630513,36.518095],[-4.630136,36.519862],[-4.630305,36.52482],[-4.630113,36.525731],[-4.628712,36.5279],[-4.628527,36.52907],[-4.628652,36.529671],[-4.629518,36.530872],[-4.631328,36.532602],[-4.632731,36.534501],[-4.63423,36.537286],[-4.63469,36.538314],[-4.634995,36.539674],[-4.634999,36.541296],[-4.634709,36.542723],[-4.634296,36.543712],[-4.633567,36.544845],[-4.631075,36.547818],[-4.630083,36.548797],[-4.627249,36.550903],[-4.624456,36.552617],[-4.62175,36.554642],[-4.620966,36.555473],[-4.620192,36.5568],[-4.619964,36.557809],[-4.620181,36.559258],[-4.621283,36.561852],[-4.622019,36.5652],[-4.623098,36.568223],[-4.623289,36.569347],[-4.623235,36.570228],[-4.622858,36.571531],[-4.621684,36.573131],[-4.620368,36.574144],[-4.61894,36.575005],[-4.617345,36.575682],[-4.614035,36.576767],[-4.612749,36.577265],[-4.610614,36.578335],[-4.608945,36.579483],[-4.606711,36.581427],[-4.603939,36.583708],[-4.602861,36.584514],[-4.6011,36.585479],[-4.599831,36.585998],[-4.598122,36.586508],[-4.596751,36.586771],[-4.591538,36.587242],[-4.590129,36.587414],[-4.587747,36.587942],[-4.585428,36.588729],[-4.583623,36.589617],[-4.58224,36.590503],[-4.580714,36.591645],[-4.579048,36.59317],[-4.574873,36.597557],[-4.572821,36.59978],[-4.57046,36.602179],[-4.568678,36.603606],[-4.567762,36.604085],[-4.566476,36.604477],[-4.565113,36.604722],[-4.561991,36.604884],[-4.560641,36.605143],[-4.558306,36.605993],[-4.556454,36.606465],[-4.555626,36.606563],[-4.553933,36.606498],[-4.551508,36.605941],[-4.549299,36.605617],[-4.547063,36.605742],[-4.545186,36.606181],[-4.543909,36.606683],[-4.539491,36.608747],[-4.537723,36.609521],[-4.536075,36.610004],[-4.534671,36.61025],[-4.531833,36.610591],[-4.531022,36.610782],[-4.529135,36.611642],[-4.527302,36.613015],[-4.525965,36.613796],[-4.524957,36.614142],[-4.522512,36.614739],[-4.520979,36.615392],[-4.520108,36.61597],[-4.519081,36.61698],[-4.51861,36.61772],[-4.518092,36.619112],[-4.517468,36.621849],[-4.516921,36.623298],[-4.516102,36.624894],[-4.514176,36.627602],[-4.51332,36.629006],[-4.512584,36.630462],[-4.511481,36.632986],[-4.510592,36.634685],[-4.508738,36.638541],[-4.507771,36.640236],[-4.506354,36.641763],[-4.505441,36.642357],[-4.50415,36.642905],[-4.502459,36.643232],[-4.500996,36.643237],[-4.49818,36.642756],[-4.496185,36.642754],[-4.49481,36.643072],[-4.492911,36.644051],[-4.491866,36.645097],[-4.490654,36.646863],[-4.489985,36.64758],[-4.488419,36.648447],[-4.487398,36.648698],[-4.484377,36.648911],[-4.483338,36.649079],[-4.481707,36.649786],[-4.480447,36.650905],[-4.476593,36.655519],[-4.474793,36.657742],[-4.473527,36.659164],[-4.468159,36.665584],[-4.467603,36.666357],[-4.46703,36.668019],[-4.467006,36.670334],[-4.466526,36.671792],[-4.464241,36.674872],[-4.463773,36.675874],[-4.463348,36.677324],[-4.462595,36.683415],[-4.462117,36.686156],[-4.461956,36.688715],[-4.46153,36.690573],[-4.460821,36.692562],[-4.459656,36.69511],[-4.4584,36.698147],[-4.457961,36.699805],[-4.457629,36.702363],[-4.457588,36.705576],[-4.457941,36.714954],[-4.457952,36.717389],[-4.457667,36.718602],[-4.457268,36.719573],[-4.455936,36.722023],[-4.454139,36.724938],[-4.453626,36.726096],[-4.453615,36.727666],[-4.454177,36.729959],[-4.454064,36.731596],[-4.453693,36.733677],[-4.453751,36.734809],[-4.454021,36.736096],[-4.453758,36.73774],[-4.452994,36.738748],[-4.452036,36.739404],[-4.450861,36.739868],[-4.448571,36.740467],[-4.446838,36.741067],[-4.445938,36.741533],[-4.444775,36.742426],[-4.441912,36.745492],[-4.441191,36.746045],[-4.439845,36.746621],[-4.436606,36.747163],[-4.4351,36.747666],[-4.434167,36.748113],[-4.433107,36.748845],[-4.431833,36.750294],[-4.430294,36.752958],[-4.42935,36.753834],[-4.42771,36.75451],[-4.42664,36.755401],[-4.426326,36.756372],[-4.426402,36.758427],[-4.425991,36.759352],[-4.424533,36.76128],[-4.424149,36.762209],[-4.423608,36.765496],[-4.423782,36.766856],[-4.425094,36.769326],[-4.425515,36.770908],[-4.425622,36.77643],[-4.425885,36.77711],[-4.427547,36.779287],[-4.428202,36.780642],[-4.429008,36.781418],[-4.429885,36.781838],[-4.431994,36.782571],[-4.432828,36.783034],[-4.433483,36.783828],[-4.433699,36.784792],[-4.433612,36.785374],[-4.432716,36.78792],[-4.432605,36.788525],[-4.432779,36.789476],[-4.433539,36.791605],[-4.433297,36.793917],[-4.433343,36.795072],[-4.434267,36.797015],[-4.434334,36.797925],[-4.434078,36.799566],[-4.434124,36.800676],[-4.434533,36.801724],[-4.437176,36.805025],[-4.437937,36.806251],[-4.438161,36.807246],[-4.438049,36.809055],[-4.438217,36.810057],[-4.439009,36.811328],[-4.439917,36.812054],[-4.441821,36.812713],[-4.444964,36.812924],[-4.446202,36.813247],[-4.447041,36.813706],[-4.447977,36.814623],[-4.448362,36.816089],[-4.448074,36.816976],[-4.447644,36.817598],[-4.44613,36.8191],[-4.445479,36.820173],[-4.444188,36.824031],[-4.444098,36.82592],[-4.444401,36.826947],[-4.4451,36.828076],[-4.447115,36.830318],[-4.44824,36.832577],[-4.448993,36.833478],[-4.450654,36.834989],[-4.451239,36.835772],[-4.451711,36.837133],[-4.451728,36.8382],[-4.451346,36.839531],[-4.450644,36.841002],[-4.450291,36.842431],[-4.450343,36.843375],[-4.451037,36.84567],[-4.451535,36.847867],[-4.451506,36.84886],[-4.451199,36.849625],[-4.450664,36.850294],[-4.448984,36.851295],[-4.445746,36.852753],[-4.444133,36.853976],[-4.443374,36.854964],[-4.443064,36.855912],[-4.442907,36.857432],[-4.442417,36.8585],[-4.441668,36.859239],[-4.437915,36.861223],[-4.436871,36.862085],[-4.436429,36.862658],[-4.435838,36.864296],[-4.435878,36.867126],[-4.436196,36.869843],[-4.435993,36.870926],[-4.433483,36.873928],[-4.431201,36.87602],[-4.429895,36.877554],[-4.428405,36.878533],[-4.426201,36.879588],[-4.425242,36.88016],[-4.424256,36.881022],[-4.423491,36.88231],[-4.421474,36.887783],[-4.42117,36.888838],[-4.421152,36.890603],[-4.421458,36.891679],[-4.422877,36.894475],[-4.423394,36.895198],[-4.424243,36.895903],[-4.425696,36.896552],[-4.42679,36.896733],[-4.429883,36.896677],[-4.432571,36.897032],[-4.433998,36.897401],[-4.434989,36.897928],[-4.439306,36.90163],[-4.444541,36.904887],[-4.445601,36.90611],[-4.445974,36.907132],[-4.446029,36.907972],[-4.445618,36.909393],[-4.443602,36.912124],[-4.443167,36.913717],[-4.443411,36.914951],[-4.443978,36.915916],[-4.445381,36.91773],[-4.446147,36.919101],[-4.446745,36.920699],[-4.447172,36.923332],[-4.447072,36.925485],[-4.446081,36.930363],[-4.445781,36.931608],[-4.445197,36.932798],[-4.444082,36.933894],[-4.441638,36.935123],[-4.440432,36.935965],[-4.439762,36.936694],[-4.439072,36.938243],[-4.439083,36.939887],[-4.440039,36.944273],[-4.440362,36.946354],[-4.439985,36.948411],[-4.440039,36.949541],[-4.440254,36.950104],[-4.440976,36.951046],[-4.441746,36.951584],[-4.444154,36.952839],[-4.445164,36.953822],[-4.44608,36.955122],[-4.446534,36.956276],[-4.446781,36.95753],[-4.446727,36.959086],[-4.446324,36.960694],[-4.445776,36.961963],[-4.443915,36.964652],[-4.442908,36.96592],[-4.441603,36.967066],[-4.4377,36.969622],[-4.43496,36.97128],[-4.432828,36.971995],[-4.428211,36.972468],[-4.426066,36.972766],[-4.423676,36.973222],[-4.418856,36.974416],[-4.415407,36.975404],[-4.413625,36.976073],[-4.411621,36.976979],[-4.40885,36.978339],[-4.405727,36.979992],[-4.404005,36.981212],[-4.403066,36.982104],[-4.401792,36.983721],[-4.401156,36.98481],[-4.400707,36.985902],[-4.40037,36.987288],[-4.399657,36.991337],[-4.398995,36.993571],[-4.398825,36.994476],[-4.398525,36.997689],[-4.397981,36.999915],[-4.39727,37.00137],[-4.396216,37.00295],[-4.395013,37.00423],[-4.391757,37.007091],[-4.390398,37.008633],[-4.38943,37.010312],[-4.388978,37.011415],[-4.388675,37.012741],[-4.388598,37.014203],[-4.388743,37.015611],[-4.389343,37.019024],[-4.389527,37.020456],[-4.389568,37.022828],[-4.388963,37.028385],[-4.389082,37.031061],[-4.389273,37.032366],[-4.389319,37.034067],[-4.389,37.035767],[-4.388431,37.037192],[-4.387098,37.039087],[-4.385818,37.040269],[-4.384368,37.041198],[-4.38118,37.042638],[-4.380056,37.043265],[-4.378982,37.04405],[-4.376408,37.046454],[-4.375511,37.047208],[-4.373679,37.048433],[-4.371171,37.049673],[-4.367061,37.051424],[-4.36104,37.053733],[-4.358269,37.054881],[-4.354689,37.056572],[-4.351033,37.058526],[-4.347593,37.060748],[-4.34456,37.062785],[-4.343227,37.063579],[-4.341346,37.064471],[-4.33983,37.065024],[-4.33772,37.065594],[-4.335794,37.065932],[-4.332179,37.066395],[-4.330591,37.066781],[-4.329336,37.067242],[-4.327933,37.067949],[-4.325824,37.069462],[-4.32442,37.070626],[-4.322195,37.072769],[-4.320871,37.074321],[-4.319848,37.075777],[-4.31863,37.077923],[-4.31748,37.080658],[-4.316622,37.08357],[-4.316389,37.085555],[-4.315787,37.088686],[-4.315555,37.090785],[-4.315544,37.095864],[-4.315437,37.097439],[-4.314871,37.099833],[-4.314338,37.101112],[-4.313057,37.103387],[-4.3109,37.106542],[-4.308476,37.109353],[-4.306434,37.111378],[-4.304638,37.112929],[-4.302303,37.114689],[-4.300985,37.115573],[-4.297383,37.117692],[-4.295527,37.119123],[-4.293643,37.121162],[-4.292843,37.122324],[-4.291916,37.124176],[-4.290992,37.126512],[-4.290047,37.128142],[-4.289046,37.129154],[-4.287443,37.130333],[-4.286215,37.131545],[-4.284439,37.134253],[-4.283416,37.135303],[-4.280621,37.13713],[-4.278535,37.138267],[-4.27585,37.139446],[-4.270884,37.140949],[-4.266516,37.142582],[-4.264336,37.143108],[-4.261877,37.143505],[-4.259801,37.144066],[-4.256626,37.145345],[-4.254821,37.145919],[-4.252769,37.146309],[-4.250772,37.146428],[-4.24814,37.146207],[-4.245439,37.145611],[-4.244015,37.145457],[-4.241198,37.14569],[-4.238691,37.145378],[-4.237026,37.145368],[-4.235455,37.145777],[-4.234756,37.146124],[-4.232531,37.147846],[-4.23155,37.148273],[-4.229117,37.148675],[-4.228087,37.149041],[-4.227032,37.14976],[-4.226342,37.150687],[-4.225791,37.152636],[-4.225097,37.153871],[-4.22421,37.154751],[-4.222354,37.155767],[-4.219342,37.156912],[-4.216443,37.158616],[-4.214892,37.159058],[-4.213796,37.159149],[-4.212411,37.159061],[-4.211365,37.158795],[-4.207879,37.157476],[-4.206384,37.157045],[-4.205424,37.156934],[-4.204109,37.157086],[-4.201892,37.157818],[-4.200032,37.158218],[-4.198565,37.158729],[-4.196467,37.159975],[-4.194353,37.160839],[-4.188782,37.162098],[-4.186033,37.1631],[-4.182252,37.165299],[-4.180035,37.166196],[-4.178425,37.16653],[-4.17649,37.16661],[-4.174802,37.166407],[-4.173426,37.166103],[-4.170076,37.165175],[-4.167597,37.164797],[-4.163834,37.164629],[-4.161421,37.164209],[-4.160178,37.163762],[-4.159,37.163162],[-4.156365,37.161629],[-4.155179,37.16115],[-4.153337,37.160726],[-4.150404,37.160259],[-4.148176,37.159566],[-4.146394,37.159286],[-4.14479,37.159388],[-4.140961,37.160503],[-4.139266,37.160635],[-4.137306,37.160295],[-4.134028,37.159294],[-4.131974,37.159237],[-4.13005,37.15983],[-4.127789,37.160986],[-4.126208,37.161487],[-4.121795,37.162452],[-4.118398,37.163107],[-4.117003,37.163138],[-4.115325,37.162891],[-4.112845,37.16225],[-4.110953,37.161929],[-4.108493,37.161928],[-4.106833,37.162042],[-4.104497,37.162592],[-4.10327,37.163109],[-4.099921,37.164813],[-4.09816,37.165435],[-4.096796,37.165738],[-4.095153,37.165918],[-4.090375,37.166166],[-4.088508,37.16664],[-4.087581,37.167149],[-4.086761,37.167823],[-4.083428,37.171418],[-4.082354,37.172976],[-4.080797,37.178118],[-4.080485,37.178765],[-4.079688,37.179685],[-4.078814,37.180305],[-4.077243,37.180864],[-4.075206,37.180933],[-4.072055,37.180411],[-4.070315,37.180207],[-4.068521,37.180159],[-4.058743,37.180398],[-4.052429,37.180934],[-4.046924,37.181528],[-4.039842,37.182183],[-4.03796,37.182444],[-4.03613,37.18291],[-4.035189,37.183362],[-4.033526,37.184463],[-4.028982,37.188443],[-4.023973,37.192741],[-4.022369,37.193861],[-4.021051,37.194459],[-4.019081,37.19499],[-4.016925,37.195212],[-4.012675,37.195419],[-4.011064,37.195394],[-4.009082,37.194963],[-4.006139,37.193707],[-4.00477,37.193216],[-4.003004,37.192924],[-3.998001,37.192764],[-3.995915,37.192991],[-3.991706,37.193632],[-3.989362,37.193783],[-3.987648,37.193647],[-3.979714,37.192432],[-3.97767,37.191991],[-3.966697,37.18791],[-3.963249,37.187067],[-3.96146,37.186415],[-3.957121,37.184351],[-3.949153,37.181725],[-3.944084,37.180128],[-3.941635,37.179704],[-3.939653,37.179869],[-3.934921,37.180473],[-3.934117,37.180529],[-3.927358,37.180718],[-3.924804,37.180745],[-3.921895,37.180503],[-3.914069,37.179311],[-3.910886,37.178867],[-3.908823,37.178664],[-3.904476,37.178465],[-3.902806,37.178553],[-3.900644,37.17919],[-3.896408,37.181199],[-3.892885,37.18222],[-3.884135,37.186157],[-3.880026,37.188055],[-3.873864,37.190816],[-3.871999,37.191839],[-3.86869,37.194203],[-3.866746,37.19514],[-3.865415,37.195434],[-3.864287,37.195488],[-3.862877,37.195355],[-3.859644,37.1945],[-3.857502,37.194193],[-3.853732,37.194207],[-3.848873,37.193947],[-3.847176,37.193959],[-3.84495,37.194202],[-3.843575,37.194208],[-3.842251,37.194034],[-3.840554,37.193441],[-3.83879,37.192441],[-3.834842,37.189944],[-3.832915,37.189107],[-3.831016,37.188861],[-3.829921,37.188967],[-3.828363,37.189453],[-3.827106,37.190042],[-3.81998,37.193733],[-3.818479,37.194416],[-3.816608,37.194959],[-3.814345,37.195163],[-3.808475,37.194848],[-3.801613,37.194239],[-3.793492,37.192939],[-3.785792,37.191588],[-3.782631,37.190818],[-3.781556,37.190679],[-3.778057,37.190748],[-3.775128,37.190404],[-3.771598,37.190613],[-3.767037,37.190493],[-3.76365,37.191072],[-3.760754,37.19129],[-3.756708,37.191776],[-3.753432,37.191785],[-3.750242,37.191479],[-3.744927,37.190785],[-3.742425,37.190556],[-3.741194,37.19053],[-3.73926,37.190709],[-3.737838,37.190571],[-3.736195,37.190158],[-3.73507,37.190013],[-3.733422,37.190033],[-3.731712,37.19021],[-3.729712,37.190628],[-3.726614,37.191497],[-3.723016,37.192382],[-3.721203,37.192553],[-3.71427,37.192476],[-3.70907,37.192378],[-3.707278,37.19244],[-3.704211,37.19275],[-3.700463,37.193041],[-3.698984,37.193085],[-3.693759,37.192674],[-3.691173,37.192516],[-3.687044,37.192498],[-3.677553,37.192339],[-3.669088,37.192305],[-3.665319,37.191684],[-3.663392,37.191463],[-3.658238,37.191672],[-3.656443,37.191933],[-3.654716,37.192442],[-3.65275,37.193534],[-3.64887,37.196556],[-3.647893,37.197242],[-3.646919,37.197707],[-3.645486,37.198101],[-3.643856,37.198215],[-3.639943,37.19782],[-3.637293,37.197928],[-3.636642,37.197838],[-3.632696,37.196515],[-3.632285,37.195941],[-3.632579,37.194161],[-3.633499,37.190689],[-3.633527,37.189384],[-3.632969,37.187665],[-3.632491,37.186959],[-3.631361,37.185864],[-3.628864,37.184561],[-3.626522,37.183546],[-3.621461,37.18121],[-3.618962,37.179971],[-3.617631,37.179202],[-3.615654,37.177722],[-3.614166,37.176237],[-3.612714,37.174596],[-3.611693,37.173045],[-3.610993,37.171636],[-3.610453,37.170152],[-3.61022,37.169079],[-3.610085,37.167586],[-3.610111,37.165536],[-3.610489,37.163343],[-3.611002,37.161734],[-3.612736,37.157565],[-3.61317,37.156233],[-3.613296,37.155237],[-3.613231,37.153857],[-3.6126,37.151978],[-3.61142,37.149544],[-3.610033,37.146381],[-3.609562,37.14513],[-3.609647,37.143901],[-3.610487,37.142794],[-3.610588,37.142176],[-3.609933,37.141467],[-3.609208,37.141393],[-3.606439,37.141785],[-3.605022,37.142558],[-3.603629,37.144025],[-3.60187,37.145158],[-3.599869,37.14594],[-3.598077,37.146882],[-3.596144,37.14804],[-3.593701,37.149116],[-3.592093,37.150062],[-3.589906,37.151888],[-3.587443,37.153524],[-3.585361,37.155022],[-3.583946,37.155731],[-3.582353,37.156254],[-3.579862,37.156852],[-3.572154,37.161063],[-3.570637,37.162796],[-3.571423,37.163479],[-3.571735,37.163236],[-3.572867,37.163507],[-3.5759,37.163928],[-3.578116,37.164445],[-3.582007,37.165555],[-3.582919,37.163909],[-3.585856,37.164924],[-3.585971,37.164747],[-3.584086,37.164327],[-3.579901,37.165246],[-3.57971,37.164886],[-3.575805,37.163911],[-3.573247,37.163526],[-3.57129,37.162737],[-3.571238,37.162369],[-3.572944,37.160391],[-3.580807,37.156647],[-3.581088,37.156751],[-3.583516,37.156058],[-3.584865,37.155503],[-3.587749,37.153532],[-3.589499,37.152473],[-3.591928,37.150486],[-3.593377,37.149545],[-3.596391,37.14811],[-3.598856,37.146657],[-3.599703,37.146251],[-3.60225,37.145273],[-3.603861,37.144136],[-3.605135,37.142786],[-3.606055,37.142296],[-3.606867,37.142238],[-3.608228,37.142883],[-3.608822,37.1438],[-3.609589,37.146006],[-3.612499,37.152282],[-3.612961,37.153548],[-3.613096,37.154561],[-3.61298,37.156127],[-3.612563,37.157405],[-3.610591,37.162325],[-3.610142,37.163974],[-3.60987,37.166301],[-3.609963,37.168394],[-3.610703,37.171184],[-3.611321,37.172634],[-3.612307,37.174334],[-3.61424,37.176712],[-3.615748,37.178053],[-3.617964,37.179615],[-3.619359,37.180351],[-3.62446,37.182688],[-3.630469,37.185529],[-3.63146,37.186215],[-3.632472,37.18738],[-3.63296,37.188293],[-3.633294,37.189466],[-3.633289,37.190558],[-3.632253,37.194643],[-3.631416,37.19729],[-3.630126,37.199957],[-3.628535,37.202394],[-3.627049,37.204156],[-3.624205,37.207356],[-3.623604,37.208304],[-3.623352,37.209282],[-3.623467,37.210597],[-3.624309,37.213809],[-3.624527,37.216446],[-3.624738,37.217241],[-3.625267,37.218062],[-3.62619,37.218835],[-3.628548,37.220049],[-3.629631,37.22111],[-3.630999,37.222817],[-3.633405,37.224351],[-3.634701,37.225503],[-3.635659,37.226858],[-3.637936,37.229022],[-3.639055,37.230244],[-3.640865,37.232609],[-3.641984,37.233794],[-3.643734,37.235137],[-3.647839,37.237648],[-3.649641,37.239144],[-3.651047,37.240718],[-3.652028,37.242054],[-3.651938,37.242524],[-3.651215,37.242394],[-3.651307,37.242008],[-3.654071,37.240507],[-3.654561,37.240052],[-3.659379,37.236826],[-3.663886,37.234024],[-3.666379,37.232806],[-3.668391,37.232119],[-3.671527,37.231488],[-3.673129,37.231325],[-3.6755,37.231285],[-3.678273,37.231464],[-3.68502,37.232033],[-3.686938,37.231835],[-3.688331,37.231397],[-3.689396,37.230827],[-3.694126,37.227471],[-3.695751,37.226742],[-3.697041,37.22648],[-3.700668,37.226194],[-3.701912,37.225874],[-3.703695,37.225039],[-3.704614,37.22441],[-3.705656,37.223406],[-3.706838,37.223334],[-3.70797,37.222737],[-3.713833,37.224796],[-3.716102,37.225639],[-3.720351,37.22712],[-3.722041,37.227878],[-3.728236,37.233609],[-3.729864,37.234928],[-3.735017,37.239664],[-3.736114,37.240621],[-3.740848,37.244991],[-3.744488,37.2485],[-3.747974,37.248143],[-3.748641,37.248187],[-3.754003,37.24991],[-3.754578,37.250381],[-3.757704,37.253723],[-3.759983,37.255057],[-3.762382,37.256174],[-3.764965,37.257258],[-3.766998,37.258261],[-3.768609,37.259203],[-3.76999,37.260527],[-3.771484,37.261553],[-3.773046,37.262018],[-3.778297,37.262858],[-3.785149,37.263864],[-3.78655,37.264214],[-3.787771,37.264911],[-3.788659,37.265864],[-3.78894,37.266414],[-3.790247,37.270643],[-3.79065,37.272226],[-3.791007,37.273125],[-3.791576,37.273931],[-3.792792,37.274827],[-3.795336,37.276],[-3.796474,37.277],[-3.797505,37.278545],[-3.800478,37.281015],[-3.80194,37.282534],[-3.803331,37.284825],[-3.807468,37.294182],[-3.808336,37.295517],[-3.809085,37.296117],[-3.810491,37.296763],[-3.812964,37.297525],[-3.814063,37.298079],[-3.814626,37.298558],[-3.815209,37.299487],[-3.81545,37.300429],[-3.815943,37.301337],[-3.818872,37.304102],[-3.819267,37.304588],[-3.819509,37.305588],[-3.819631,37.307405],[-3.820314,37.308277],[-3.822745,37.309885],[-3.824446,37.311477],[-3.825202,37.311906],[-3.827801,37.313056],[-3.828762,37.314199],[-3.830418,37.315658],[-3.831383,37.316641],[-3.833715,37.319313],[-3.834603,37.319871],[-3.836978,37.320025],[-3.837659,37.320351],[-3.838095,37.32093],[-3.838141,37.321625],[-3.837277,37.322675],[-3.836015,37.323396],[-3.833973,37.323916],[-3.832726,37.325404],[-3.832418,37.326129],[-3.83215,37.328653],[-3.831308,37.330604],[-3.831309,37.33165],[-3.832249,37.333662],[-3.832336,37.334183],[-3.832391,37.337347],[-3.832528,37.341539],[-3.832136,37.34306],[-3.832166,37.343759],[-3.832798,37.345593],[-3.83269,37.346904],[-3.832281,37.347592],[-3.831471,37.348291],[-3.827242,37.351163],[-3.826567,37.351696],[-3.825552,37.353555],[-3.823906,37.35467],[-3.823496,37.355262],[-3.823151,37.356851],[-3.823085,37.358552],[-3.823941,37.36156],[-3.824937,37.363576],[-3.825212,37.364584],[-3.82503,37.365279],[-3.823385,37.36747],[-3.822253,37.369858],[-3.821608,37.37103],[-3.820091,37.372601],[-3.819643,37.37326],[-3.819596,37.375866],[-3.819912,37.376739],[-3.820687,37.377798],[-3.82169,37.378853],[-3.822509,37.379501],[-3.829194,37.384087],[-3.830223,37.384546],[-3.837741,37.385894],[-3.839736,37.386154],[-3.841658,37.386091],[-3.843719,37.385537],[-3.845477,37.385458],[-3.846476,37.38571],[-3.84841,37.386425],[-3.853623,37.387398],[-3.854561,37.387765],[-3.855496,37.388717],[-3.857253,37.391752],[-3.857672,37.392919],[-3.857683,37.394204],[-3.857289,37.398273],[-3.857046,37.399122],[-3.856421,37.400334],[-3.856335,37.401576],[-3.857165,37.403133],[-3.857531,37.404354],[-3.857692,37.406041],[-3.858041,37.408238],[-3.858462,37.410239],[-3.858473,37.411076],[-3.858176,37.412229],[-3.85849,37.413605],[-3.860699,37.417373],[-3.861501,37.418169],[-3.865973,37.420294],[-3.86859,37.421946],[-3.871236,37.422946],[-3.876141,37.424571],[-3.87933,37.425849],[-3.882339,37.428121],[-3.883203,37.428471],[-3.885775,37.429095],[-3.890284,37.431322],[-3.891178,37.431589],[-3.893858,37.432057],[-3.897059,37.432526],[-3.898424,37.433],[-3.899286,37.433972],[-3.899702,37.435305],[-3.900299,37.436383],[-3.902196,37.43811],[-3.902341,37.438534],[-3.903111,37.438807],[-3.905916,37.440376],[-3.909651,37.441988],[-3.911769,37.443116],[-3.913836,37.444604],[-3.915397,37.445979],[-3.917146,37.447365],[-3.91899,37.448482],[-3.92042,37.449123],[-3.923502,37.450109],[-3.925268,37.45054],[-3.928079,37.450959],[-3.933335,37.451222],[-3.935453,37.451655],[-3.937412,37.452483],[-3.943006,37.45508],[-3.945357,37.456313],[-3.946541,37.457311],[-3.947374,37.458235],[-3.947983,37.459238],[-3.950024,37.463478],[-3.951641,37.465468],[-3.955514,37.469168],[-3.959027,37.472456],[-3.960707,37.474217],[-3.961408,37.47529],[-3.961944,37.476431],[-3.962241,37.47744],[-3.962378,37.478764],[-3.962236,37.480324],[-3.961532,37.482894],[-3.961343,37.484536],[-3.961463,37.485642],[-3.962062,37.48746],[-3.964665,37.492876],[-3.965583,37.494202],[-3.967094,37.495497],[-3.968012,37.495993],[-3.971685,37.497429],[-3.973137,37.498517],[-3.97538,37.501601],[-3.977196,37.503648],[-3.978609,37.50558],[-3.979157,37.507276],[-3.979254,37.508462],[-3.979148,37.51044],[-3.978686,37.515924],[-3.978252,37.517278],[-3.977101,37.519626],[-3.976298,37.521735],[-3.976056,37.52341],[-3.97623,37.524438],[-3.976852,37.525799],[-3.978757,37.527824],[-3.979576,37.529307],[-3.980292,37.532751],[-3.980718,37.533806],[-3.981805,37.534881],[-3.983073,37.535305],[-3.98424,37.535375],[-3.986177,37.535273],[-3.987286,37.535485],[-3.988236,37.535987],[-3.989199,37.536831],[-3.99029,37.537513],[-3.991549,37.537925],[-3.99353,37.538367],[-3.994888,37.538961],[-3.996942,37.540161],[-3.998266,37.54063],[-3.999047,37.540631],[-4.002043,37.540121],[-4.003413,37.53999],[-4.00528,37.540226],[-4.006946,37.541019],[-4.008434,37.542181],[-4.009418,37.542771],[-4.011125,37.543403],[-4.011884,37.543418],[-4.014382,37.542949],[-4.024974,37.543886],[-4.030241,37.544383],[-4.033927,37.544812],[-4.035613,37.545243],[-4.039147,37.547121],[-4.043855,37.549064],[-4.044518,37.549411],[-4.045526,37.550347],[-4.046185,37.552145],[-4.04677,37.553385],[-4.047638,37.554436],[-4.0496,37.555933],[-4.051138,37.556846],[-4.055667,37.559127],[-4.056439,37.559677],[-4.057136,37.560507],[-4.057468,37.561299],[-4.057627,37.563763],[-4.058069,37.565145],[-4.059308,37.567192],[-4.060776,37.569073],[-4.06288,37.571046],[-4.066049,37.573207],[-4.067174,37.573812],[-4.068517,37.574225],[-4.06995,37.574332],[-4.072606,37.574337],[-4.083327,37.576455],[-4.08969,37.577753],[-4.09444,37.578564],[-4.096969,37.579102],[-4.101546,37.580247],[-4.104424,37.580903],[-4.106621,37.581326],[-4.112005,37.582243],[-4.114273,37.582706],[-4.118807,37.583852],[-4.130245,37.587017],[-4.131729,37.58735],[-4.132917,37.587258],[-4.133857,37.586999],[-4.138494,37.585296],[-4.13962,37.584833],[-4.14068,37.584212],[-4.142872,37.582176],[-4.144243,37.581599],[-4.15134,37.578924],[-4.152282,37.578329],[-4.152999,37.576631],[-4.153485,37.576148],[-4.154416,37.575738],[-4.155419,37.575692],[-4.156985,37.575913],[-4.157926,37.576323],[-4.158418,37.576808],[-4.159866,37.57891],[-4.160799,37.57958],[-4.162381,37.57983],[-4.163459,37.57925],[-4.163809,37.578572],[-4.163852,37.57791],[-4.164551,37.576741],[-4.166159,37.575715],[-4.167755,37.574504],[-4.168635,37.574075],[-4.170654,37.57339],[-4.171627,37.572916],[-4.172381,37.572762],[-4.17397,37.57296],[-4.175601,37.572802],[-4.176835,37.572089],[-4.177299,37.571461],[-4.178733,37.567906],[-4.179179,37.567208],[-4.180812,37.56615],[-4.182984,37.565195],[-4.184992,37.56413],[-4.186287,37.563617],[-4.189848,37.563039],[-4.19182,37.562179],[-4.192793,37.561983],[-4.197256,37.561294],[-4.198594,37.561398],[-4.200627,37.562628],[-4.201688,37.563077],[-4.205091,37.563652],[-4.207296,37.56356],[-4.211504,37.563567],[-4.212332,37.56363],[-4.216974,37.564413],[-4.217948,37.564519],[-4.223736,37.564697],[-4.225476,37.565036],[-4.230894,37.567043],[-4.233731,37.568039],[-4.234739,37.568283],[-4.237362,37.568287],[-4.2384,37.568131],[-4.241752,37.567266],[-4.244635,37.567261],[-4.246645,37.567449],[-4.247848,37.567792],[-4.24858,37.568177],[-4.253867,37.572023],[-4.255411,37.572537],[-4.262643,37.573284],[-4.264077,37.57349],[-4.265292,37.573833],[-4.267882,37.574782],[-4.271282,37.57613],[-4.27738,37.57842],[-4.279154,37.57919],[-4.288867,37.5836],[-4.289856,37.584144],[-4.290469,37.584693],[-4.294879,37.589157],[-4.296136,37.590707],[-4.296687,37.591213],[-4.299929,37.593448],[-4.301735,37.595053],[-4.302642,37.596223],[-4.303697,37.598232],[-4.30413,37.600035],[-4.304173,37.601806],[-4.303926,37.603189],[-4.303462,37.604539],[-4.302271,37.606752],[-4.301357,37.609068],[-4.300976,37.610678],[-4.300879,37.611728],[-4.300832,37.616665],[-4.300645,37.62315],[-4.300774,37.624528],[-4.301558,37.626605],[-4.302677,37.628083],[-4.303748,37.629055],[-4.305692,37.630229],[-4.306822,37.63068],[-4.30833,37.631076],[-4.310691,37.631308],[-4.312371,37.631217],[-4.314216,37.630843],[-4.317992,37.629726],[-4.32039,37.629288],[-4.32145,37.6292],[-4.325812,37.629037],[-4.331109,37.628987],[-4.335167,37.628901],[-4.346694,37.628807],[-4.349162,37.628718],[-4.352441,37.628221],[-4.353868,37.628099],[-4.355296,37.628183],[-4.356919,37.628547],[-4.35883,37.629367],[-4.360372,37.630549],[-4.36493,37.635688],[-4.367313,37.63819],[-4.370206,37.640695],[-4.371555,37.6413],[-4.374421,37.642211],[-4.375423,37.643113],[-4.378378,37.646835],[-4.379113,37.648156],[-4.380835,37.652888],[-4.381913,37.656004],[-4.383902,37.66113],[-4.384997,37.663299],[-4.385413,37.663931],[-4.388193,37.666714],[-4.389591,37.667469],[-4.390303,37.667589],[-4.395354,37.667932],[-4.397011,37.66753],[-4.398171,37.666772],[-4.399504,37.666322],[-4.400463,37.666343],[-4.401765,37.66683],[-4.405898,37.669489],[-4.411811,37.671873],[-4.413218,37.672196],[-4.420285,37.672715],[-4.422124,37.673054],[-4.426213,37.673955],[-4.4272,37.674254],[-4.429999,37.675434],[-4.431228,37.675804],[-4.438076,37.677673],[-4.439927,37.678212],[-4.440679,37.678708],[-4.442507,37.680291],[-4.443386,37.68055],[-4.44434,37.680559],[-4.445549,37.680264],[-4.44683,37.680341],[-4.454522,37.682077],[-4.456031,37.682044],[-4.457374,37.681516],[-4.458109,37.681393],[-4.46011,37.681835],[-4.46291,37.68288],[-4.464447,37.683332],[-4.46726,37.683939],[-4.46954,37.684166],[-4.479406,37.684399],[-4.484172,37.684604],[-4.487208,37.685234],[-4.488038,37.685743],[-4.488545,37.68631],[-4.489391,37.687871],[-4.490315,37.688688],[-4.49117,37.689027],[-4.492269,37.689209],[-4.493203,37.68912],[-4.495213,37.688399],[-4.496366,37.688254],[-4.503287,37.687731],[-4.504193,37.687454],[-4.505519,37.686446],[-4.506534,37.685877],[-4.509165,37.685351],[-4.509757,37.6851],[-4.514363,37.682625],[-4.515968,37.682376],[-4.518666,37.682157],[-4.520351,37.682187],[-4.521952,37.681749],[-4.523451,37.682574],[-4.524754,37.682682],[-4.525211,37.683015],[-4.526312,37.684408],[-4.527443,37.685003],[-4.527872,37.68546],[-4.528102,37.686811],[-4.529109,37.687517],[-4.530418,37.687583],[-4.531372,37.687375],[-4.533876,37.686442],[-4.535034,37.686271],[-4.538911,37.686116],[-4.540891,37.685581],[-4.545457,37.683455],[-4.546989,37.682434],[-4.550547,37.679888],[-4.551026,37.679429],[-4.553478,37.67664],[-4.554464,37.675897],[-4.557462,37.674295],[-4.558054,37.674217],[-4.559596,37.674389],[-4.560084,37.674597],[-4.561222,37.675632],[-4.562359,37.67692],[-4.567126,37.680205],[-4.568213,37.680747],[-4.569315,37.681822],[-4.570813,37.682838],[-4.57295,37.683219],[-4.576637,37.684405],[-4.577866,37.684451],[-4.579062,37.684294],[-4.587723,37.686298],[-4.589226,37.686512],[-4.592781,37.686769],[-4.594198,37.68705],[-4.594966,37.68753],[-4.595821,37.688698],[-4.59812,37.692122],[-4.598846,37.692932],[-4.600954,37.693984],[-4.601916,37.694918],[-4.60265,37.696664],[-4.604528,37.698632],[-4.60573,37.699386],[-4.610186,37.701762],[-4.612071,37.703088],[-4.61359,37.703911],[-4.615953,37.704726],[-4.618456,37.705374],[-4.619678,37.706093],[-4.623186,37.710541],[-4.623657,37.711034],[-4.624728,37.711596],[-4.627451,37.712371],[-4.628478,37.713266],[-4.629988,37.715949],[-4.630774,37.716765],[-4.635397,37.720535],[-4.636307,37.721511],[-4.636762,37.722443],[-4.637622,37.724995],[-4.637752,37.725747],[-4.637489,37.726721],[-4.635279,37.729972],[-4.635098,37.730478],[-4.635244,37.731435],[-4.635646,37.731968],[-4.638138,37.73407],[-4.638853,37.734451],[-4.642561,37.73521],[-4.643005,37.735366],[-4.650123,37.739367],[-4.650747,37.739989],[-4.654273,37.745738],[-4.65481,37.746432],[-4.656907,37.748414],[-4.657463,37.749509],[-4.657112,37.750875],[-4.655011,37.754437],[-4.654881,37.755445],[-4.655466,37.756596],[-4.657077,37.758524],[-4.658139,37.759315],[-4.65908,37.75959],[-4.66113,37.759918],[-4.662113,37.759942],[-4.665043,37.759674],[-4.666055,37.759835],[-4.667418,37.760269],[-4.668253,37.760703],[-4.668951,37.761498],[-4.669598,37.762567],[-4.67104,37.764544],[-4.676535,37.768994],[-4.678767,37.7718],[-4.679322,37.772702],[-4.680896,37.77607],[-4.681597,37.776892],[-4.683869,37.778119],[-4.685434,37.779403],[-4.688114,37.780329],[-4.68905,37.780871],[-4.689904,37.781735],[-4.690664,37.782881],[-4.691468,37.785102],[-4.692289,37.786245],[-4.694018,37.787094],[-4.695344,37.788068],[-4.696418,37.788468],[-4.697935,37.788789],[-4.70163,37.790327],[-4.703346,37.791836],[-4.705043,37.792837],[-4.709343,37.794935],[-4.711555,37.795801],[-4.712291,37.795978],[-4.719448,37.797051],[-4.721319,37.797548],[-4.722863,37.798502],[-4.723966,37.799837],[-4.724688,37.801074],[-4.726302,37.804163],[-4.727382,37.806399],[-4.731181,37.813435],[-4.731584,37.813952],[-4.73242,37.81451],[-4.733845,37.815209],[-4.734745,37.815957],[-4.735897,37.81835],[-4.736834,37.820675],[-4.73699,37.823255],[-4.73738,37.825011],[-4.737704,37.825748],[-4.739272,37.828448],[-4.739578,37.829427],[-4.739582,37.830632],[-4.739077,37.831935],[-4.739088,37.832813],[-4.739461,37.833979],[-4.74016,37.83518],[-4.741517,37.836398],[-4.744457,37.840221],[-4.745248,37.842211],[-4.746077,37.843316],[-4.746751,37.843685],[-4.751481,37.845148],[-4.757776,37.846888],[-4.759768,37.84775],[-4.765241,37.851884],[-4.767237,37.853457],[-4.770967,37.859132],[-4.773113,37.862524],[-4.773368,37.863135],[-4.774024,37.865979],[-4.774871,37.867839],[-4.776369,37.868833],[-4.776607,37.868811],[-4.778545,37.869858],[-4.778967,37.870279],[-4.779817,37.870508],[-4.78125,37.871212],[-4.783776,37.872653],[-4.784138,37.87306],[-4.785347,37.871067],[-4.786377,37.869184],[-4.787928,37.869141],[-4.789589,37.868708],[-4.790277,37.869113],[-4.790911,37.870173],[-4.788682,37.87131],[-4.787767,37.872141],[-4.786512,37.874488],[-4.786072,37.874467],[-4.785684,37.873853],[-4.784949,37.873305],[-4.779703,37.870423],[-4.779279,37.869963],[-4.778582,37.869776],[-4.775461,37.868107],[-4.774815,37.867654],[-4.774082,37.866145],[-4.773379,37.863248],[-4.773017,37.862273],[-4.773187,37.861882],[-4.772582,37.861516],[-4.771387,37.859545],[-4.771747,37.85899],[-4.772276,37.859346],[-4.77199,37.859732],[-4.770127,37.861076],[-4.768457,37.86289],[-4.76586,37.866765],[-4.76351,37.869993],[-4.758859,37.87649],[-4.754541,37.882431],[-4.752932,37.884277],[-4.750845,37.885976],[-4.749182,37.88701],[-4.745266,37.889205],[-4.738563,37.893025],[-4.736702,37.893795],[-4.734947,37.894243],[-4.73341,37.89444],[-4.731274,37.894451],[-4.72897,37.89409],[-4.727289,37.893539],[-4.72574,37.892787],[-4.720955,37.890172],[-4.719281,37.889375],[-4.718071,37.888921],[-4.715512,37.888228],[-4.713345,37.887929],[-4.711104,37.887813],[-4.709189,37.887935],[-4.707304,37.888208],[-4.705723,37.888569],[-4.695403,37.89146],[-4.693249,37.89193],[-4.678069,37.894028],[-4.675474,37.894548],[-4.67328,37.895245],[-4.663971,37.898891],[-4.662674,37.899352],[-4.65697,37.901592],[-4.655104,37.902234],[-4.651331,37.903788],[-4.649482,37.904459],[-4.646567,37.905061],[-4.644772,37.905251],[-4.638639,37.905636],[-4.636496,37.905673],[-4.630068,37.905262],[-4.627109,37.904995],[-4.615899,37.904162],[-4.614442,37.904158],[-4.612187,37.904448],[-4.61065,37.904862],[-4.608469,37.905814],[-4.603101,37.908679],[-4.60223,37.909208],[-4.595867,37.913424],[-4.585886,37.920081],[-4.584487,37.921094],[-4.583071,37.92265],[-4.582654,37.923455],[-4.581429,37.926582],[-4.580859,37.927831],[-4.577605,37.933611],[-4.576671,37.93486],[-4.575549,37.935762],[-4.573699,37.936583],[-4.571903,37.936904],[-4.567,37.937244],[-4.565916,37.937419],[-4.563704,37.938297],[-4.562653,37.93904],[-4.560491,37.940821],[-4.558968,37.941809],[-4.557499,37.942423],[-4.556163,37.942768],[-4.552048,37.943652],[-4.551267,37.943901],[-4.546348,37.945966],[-4.545651,37.946332],[-4.538345,37.95051],[-4.536689,37.951247],[-4.534319,37.951735],[-4.528877,37.952062],[-4.517175,37.952668],[-4.515307,37.952613],[-4.496382,37.950465],[-4.479847,37.948568],[-4.477067,37.948485],[-4.475683,37.948609],[-4.473534,37.94903],[-4.471272,37.94981],[-4.469215,37.950905],[-4.467817,37.951939],[-4.466926,37.952792],[-4.465847,37.954102],[-4.464722,37.956101],[-4.46357,37.958745],[-4.462648,37.961446],[-4.462435,37.962663],[-4.462477,37.965004],[-4.462102,37.966621],[-4.461756,37.967252],[-4.460798,37.968387],[-4.459831,37.969095],[-4.452585,37.973412],[-4.451116,37.974378],[-4.447417,37.977082],[-4.44306,37.979836],[-4.441535,37.981114],[-4.440336,37.982648],[-4.435878,37.9919],[-4.434647,37.993355],[-4.431779,37.995604],[-4.430126,37.996559],[-4.428527,37.997027],[-4.424925,37.997895],[-4.414574,38.000448],[-4.413065,38.000904],[-4.409948,38.00223],[-4.405032,38.005105],[-4.403179,38.005917],[-4.401981,38.006316],[-4.399952,38.006806],[-4.398042,38.007086],[-4.396039,38.007181],[-4.394577,38.007132],[-4.389706,38.006756],[-4.386872,38.007001],[-4.384732,38.007588],[-4.380955,38.009115],[-4.379708,38.009557],[-4.378652,38.009766],[-4.373418,38.010409],[-4.371553,38.010434],[-4.363252,38.009219],[-4.360151,38.008556],[-4.350461,38.005888],[-4.348737,38.005347],[-4.347872,38.004917],[-4.346789,38.00412],[-4.344511,38.001557],[-4.342884,38.000153],[-4.340976,37.998992],[-4.336199,37.99632],[-4.335198,37.995853],[-4.333085,37.99511],[-4.324875,37.992414],[-4.311533,37.988059],[-4.307011,37.986798],[-4.303459,37.986138],[-4.301034,37.985996],[-4.299677,37.986004],[-4.297472,37.986174],[-4.29366,37.986776],[-4.29142,37.987034],[-4.289449,37.987123],[-4.287517,37.987087],[-4.279286,37.98677],[-4.276205,37.986687],[-4.274617,37.986838],[-4.270568,37.987572],[-4.267511,37.988051],[-4.264971,37.988533],[-4.259265,37.989711],[-4.258295,37.990008],[-4.256667,37.990951],[-4.251581,37.995036],[-4.249429,37.996667],[-4.248046,37.997444],[-4.238868,38.002373],[-4.237218,38.003158],[-4.230523,38.005996],[-4.228946,38.006405],[-4.21931,38.007555],[-4.217735,38.007597],[-4.216675,38.007424],[-4.210814,38.006064],[-4.205678,38.004093],[-4.204117,38.003926],[-4.20287,38.004211],[-4.197334,38.006244],[-4.192819,38.00794],[-4.188618,38.009458],[-4.186091,38.009992],[-4.177299,38.011155],[-4.175916,38.011429],[-4.174891,38.01184],[-4.173604,38.012771],[-4.171411,38.015615],[-4.170362,38.017696],[-4.169425,38.020566],[-4.169072,38.021417],[-4.168427,38.022392],[-4.159598,38.033885],[-4.158753,38.034867],[-4.157521,38.035696],[-4.155556,38.036297],[-4.151421,38.036688],[-4.143083,38.037405],[-4.142158,38.037419],[-4.140421,38.03708],[-4.137844,38.036016],[-4.135459,38.035387],[-4.133294,38.035143],[-4.128694,38.034808],[-4.126767,38.034856],[-4.125584,38.035102],[-4.12231,38.03649],[-4.120138,38.037114],[-4.117554,38.03743],[-4.11569,38.037382],[-4.11438,38.037214],[-4.094912,38.033578],[-4.087749,38.032215],[-4.085158,38.031751],[-4.07309,38.029478],[-4.070788,38.029417],[-4.069387,38.029724],[-4.065903,38.030793],[-4.064773,38.030871],[-4.061695,38.030562],[-4.057651,38.030718],[-4.052692,38.030323],[-4.050435,38.030226],[-4.047574,38.030602],[-4.045135,38.031398],[-4.043886,38.032031],[-4.035094,38.037359],[-4.032881,38.038429],[-4.031592,38.038843],[-4.029981,38.039173],[-4.027178,38.039308],[-4.019635,38.039],[-4.017363,38.039316],[-4.013898,38.040519],[-4.012738,38.040647],[-4.008321,38.040876],[-4.004812,38.041191],[-3.999673,38.041932],[-3.997642,38.041951],[-3.995342,38.041778],[-3.993922,38.041939],[-3.988251,38.043575],[-3.986602,38.043857],[-3.982971,38.044009],[-3.977076,38.044324],[-3.961302,38.045046],[-3.947352,38.045733],[-3.93599,38.046233],[-3.934097,38.045956],[-3.931838,38.045168],[-3.930557,38.045022],[-3.927452,38.045103],[-3.923286,38.046561],[-3.92228,38.046799],[-3.910116,38.048342],[-3.906533,38.049348],[-3.904182,38.050193],[-3.900461,38.051373],[-3.899323,38.051821],[-3.898123,38.052583],[-3.895158,38.0551],[-3.894528,38.05589],[-3.893394,38.057882],[-3.892236,38.05921],[-3.891188,38.060122],[-3.889413,38.061474],[-3.888085,38.063148],[-3.887275,38.06396],[-3.885584,38.065317],[-3.883918,38.066358],[-3.881789,38.067212],[-3.880304,38.067476],[-3.878181,38.067533],[-3.876183,38.068007],[-3.869145,38.070249],[-3.867185,38.070589],[-3.859876,38.071154],[-3.859045,38.071293],[-3.857752,38.071762],[-3.855083,38.073164],[-3.85234,38.073968],[-3.851295,38.074385],[-3.850112,38.075081],[-3.849067,38.075931],[-3.84734,38.077828],[-3.845057,38.081049],[-3.844401,38.081804],[-3.843556,38.08245],[-3.841545,38.083695],[-3.840309,38.084044],[-3.837159,38.084584],[-3.836229,38.084813],[-3.834527,38.085577],[-3.832442,38.086065],[-3.829486,38.086179],[-3.828001,38.086473],[-3.82464,38.087528],[-3.821013,38.089131],[-3.818173,38.090048],[-3.815868,38.090927],[-3.813636,38.092102],[-3.810673,38.093051],[-3.803447,38.095996],[-3.80189,38.096536],[-3.799026,38.097286],[-3.79757,38.097746],[-3.795883,38.09851],[-3.794967,38.099071],[-3.7936,38.10015],[-3.792242,38.101595],[-3.791323,38.102968],[-3.790442,38.104796],[-3.789284,38.106444],[-3.788128,38.107451],[-3.786679,38.108287],[-3.785526,38.108743],[-3.78349,38.109191],[-3.780063,38.109591],[-3.778612,38.109908],[-3.776293,38.110719],[-3.774189,38.111862],[-3.768845,38.115726],[-3.767074,38.116841],[-3.763261,38.11892],[-3.761231,38.120234],[-3.758785,38.122182],[-3.756462,38.124583],[-3.752049,38.129917],[-3.750532,38.131602],[-3.748736,38.133131],[-3.74629,38.134779],[-3.744356,38.136492],[-3.743001,38.13738],[-3.740591,38.138581],[-3.737387,38.139836],[-3.733842,38.141419],[-3.728491,38.142586],[-3.726332,38.143308],[-3.724575,38.144533],[-3.723534,38.145919],[-3.721135,38.150155],[-3.720734,38.150775],[-3.718328,38.153662],[-3.717755,38.154449],[-3.711931,38.162892],[-3.71102,38.164062],[-3.708774,38.166528],[-3.70789,38.167829],[-3.706793,38.170934],[-3.706201,38.172154],[-3.705404,38.173275],[-3.704722,38.173938],[-3.703261,38.174865],[-3.700705,38.176068],[-3.699803,38.176578],[-3.696628,38.178715],[-3.695287,38.179812],[-3.694331,38.181096],[-3.693865,38.182253],[-3.693408,38.184087],[-3.692845,38.185515],[-3.692318,38.186262],[-3.691038,38.187406],[-3.690152,38.187904],[-3.688688,38.188403],[-3.687361,38.188613],[-3.685465,38.188613],[-3.683206,38.188459],[-3.681243,38.188475],[-3.679368,38.188887],[-3.67815,38.189428],[-3.677285,38.189991],[-3.676162,38.190961],[-3.672271,38.19529],[-3.670577,38.196722],[-3.668178,38.198248],[-3.667014,38.199541],[-3.665437,38.202706],[-3.664502,38.204049],[-3.663406,38.205048],[-3.662299,38.20575],[-3.660751,38.2064],[-3.654381,38.208368],[-3.652558,38.209174],[-3.65147,38.20996],[-3.649704,38.211834],[-3.647196,38.213877],[-3.645259,38.216326],[-3.642249,38.219231],[-3.639559,38.222176],[-3.638371,38.223092],[-3.636202,38.224091],[-3.632265,38.225219],[-3.631018,38.225779],[-3.629537,38.227132],[-3.628916,38.228578],[-3.628872,38.229653],[-3.629389,38.234535],[-3.629721,38.238165],[-3.629811,38.240382],[-3.629529,38.242023],[-3.628871,38.244145],[-3.628577,38.246472],[-3.628239,38.247281],[-3.626869,38.249101],[-3.626326,38.250661],[-3.626211,38.252615],[-3.625827,38.253717],[-3.625113,38.254897],[-3.624694,38.256383],[-3.623711,38.260749],[-3.623294,38.261973],[-3.622698,38.262694],[-3.621525,38.263487],[-3.620438,38.263956],[-3.618894,38.264404],[-3.611394,38.267089],[-3.610222,38.267639],[-3.608575,38.268906],[-3.608033,38.269699],[-3.607396,38.271047],[-3.606122,38.27427],[-3.605223,38.275568],[-3.603966,38.276597],[-3.598608,38.279795],[-3.597678,38.280296],[-3.595875,38.281011],[-3.592335,38.28209],[-3.591295,38.282565],[-3.59041,38.283192],[-3.589344,38.284628],[-3.589056,38.285837],[-3.589175,38.288128],[-3.589493,38.290909],[-3.58954,38.292147],[-3.58924,38.293433],[-3.58866,38.294338],[-3.587499,38.295356],[-3.580702,38.299975],[-3.579575,38.300927],[-3.579165,38.301478],[-3.578679,38.302684],[-3.577474,38.307526],[-3.577106,38.308412],[-3.576198,38.309482],[-3.572823,38.312357],[-3.571072,38.313239],[-3.569449,38.313642],[-3.568024,38.314138],[-3.567241,38.314597],[-3.565431,38.316188],[-3.564257,38.316855],[-3.560651,38.318409],[-3.557779,38.320286],[-3.557042,38.320882],[-3.55572,38.32249],[-3.55517,38.322981],[-3.544423,38.329937],[-3.543646,38.330522],[-3.5429,38.331374],[-3.542545,38.332151],[-3.542436,38.332974],[-3.542787,38.334365],[-3.544864,38.338389],[-3.545198,38.339654],[-3.545158,38.341135],[-3.544639,38.342116],[-3.543851,38.342936],[-3.54282,38.343576],[-3.540654,38.344543],[-3.537024,38.345605],[-3.535241,38.346364],[-3.533909,38.34731],[-3.53154,38.349411],[-3.530013,38.350854],[-3.529292,38.351876],[-3.52882,38.352996],[-3.528399,38.354882],[-3.52773,38.35646],[-3.526831,38.357706],[-3.525953,38.358691],[-3.525076,38.359948],[-3.52469,38.36086],[-3.523925,38.364197],[-3.523452,38.365338],[-3.522698,38.36663],[-3.52194,38.367653],[-3.520856,38.36876],[-3.519839,38.369598],[-3.518494,38.370484],[-3.51679,38.371345],[-3.514219,38.372351],[-3.513284,38.37283],[-3.511886,38.373825],[-3.510566,38.375292],[-3.507729,38.379179],[-3.50683,38.380959],[-3.506423,38.38291],[-3.506046,38.383782],[-3.498721,38.399817],[-3.49794,38.402627],[-3.498352,38.406236],[-3.499073,38.40836],[-3.499056,38.40989],[-3.498442,38.411733],[-3.49823,38.413168],[-3.498336,38.414218],[-3.498913,38.415701],[-3.500292,38.41792],[-3.500673,38.419207],[-3.5006,38.420088],[-3.50014,38.421138],[-3.498808,38.422819],[-3.498419,38.424241],[-3.498459,38.426218],[-3.498294,38.427518],[-3.496823,38.432616],[-3.496548,38.43376],[-3.496513,38.435617],[-3.496768,38.43771],[-3.496747,38.438858],[-3.496317,38.441273],[-3.496365,38.443201],[-3.496854,38.445122],[-3.496963,38.446224],[-3.496835,38.449865],[-3.496892,38.451457],[-3.497205,38.45314],[-3.498345,38.455844],[-3.501423,38.462299],[-3.502057,38.463879],[-3.502322,38.465223],[-3.502276,38.468709],[-3.502531,38.470083],[-3.503907,38.475336],[-3.504145,38.477536],[-3.503808,38.479529],[-3.503082,38.481118],[-3.501796,38.483177],[-3.501363,38.484186],[-3.501018,38.485674],[-3.501118,38.487854],[-3.503302,38.494669],[-3.503457,38.495991],[-3.503323,38.497515],[-3.502985,38.498622],[-3.502437,38.499686],[-3.499416,38.504608],[-3.498152,38.506424],[-3.493972,38.511271],[-3.492879,38.512667],[-3.492016,38.513971],[-3.491197,38.515788],[-3.490918,38.516837],[-3.490753,38.518568],[-3.490805,38.519451],[-3.491374,38.521887],[-3.492796,38.525661],[-3.493738,38.528377],[-3.493978,38.529534],[-3.494091,38.531172],[-3.493998,38.532564],[-3.492745,38.540179],[-3.491955,38.544746],[-3.490564,38.553242],[-3.490142,38.556336],[-3.489589,38.559532],[-3.488954,38.56256],[-3.488379,38.564238],[-3.487448,38.565996],[-3.485796,38.568792],[-3.484859,38.571132],[-3.484524,38.572434],[-3.48308,38.579797],[-3.482564,38.581158],[-3.481616,38.582626],[-3.480815,38.583467],[-3.479411,38.584541],[-3.475117,38.586833],[-3.473217,38.588194],[-3.472144,38.589509],[-3.471607,38.590554],[-3.471181,38.592104],[-3.471036,38.594642],[-3.470758,38.595744],[-3.468354,38.602582],[-3.467469,38.604197],[-3.466308,38.605704],[-3.465884,38.606518],[-3.4655,38.607813],[-3.465435,38.608927],[-3.465931,38.612217],[-3.46598,38.613365],[-3.465516,38.61514],[-3.463943,38.617782],[-3.463432,38.619288],[-3.463376,38.620812],[-3.463994,38.627455],[-3.464497,38.628779],[-3.464991,38.629606],[-3.466135,38.63082],[-3.468435,38.632962],[-3.469993,38.634504],[-3.476734,38.640733],[-3.478222,38.642198],[-3.479198,38.643649],[-3.479603,38.644765],[-3.479706,38.645737],[-3.479566,38.646904],[-3.479028,38.648272],[-3.477934,38.649685],[-3.476904,38.650536],[-3.475949,38.651091],[-3.474334,38.651689],[-3.471323,38.652538],[-3.469798,38.653171],[-3.460159,38.65784],[-3.457969,38.659084],[-3.456802,38.659936],[-3.455,38.66176],[-3.449926,38.668497],[-3.446044,38.673591],[-3.442294,38.678674],[-3.440915,38.680411],[-3.435163,38.688095],[-3.429881,38.695093],[-3.425298,38.701115],[-3.423478,38.703275],[-3.4195,38.70853],[-3.418605,38.71015],[-3.418119,38.712151],[-3.417255,38.724163],[-3.416981,38.729119],[-3.417795,38.734291],[-3.419105,38.742157],[-3.420154,38.748294],[-3.42005,38.750261],[-3.419648,38.751339],[-3.418865,38.752528],[-3.406507,38.767615],[-3.401472,38.773852],[-3.399448,38.776306],[-3.397374,38.778711],[-3.392834,38.784275],[-3.392342,38.785076],[-3.391988,38.786136],[-3.391957,38.787429],[-3.393181,38.793447],[-3.39528,38.802715],[-3.395545,38.804033],[-3.395886,38.806668],[-3.396034,38.809151],[-3.395924,38.813163],[-3.395395,38.823438],[-3.394717,38.835713],[-3.39414,38.846492],[-3.393674,38.855621],[-3.393103,38.867311],[-3.392929,38.870135],[-3.39221,38.884093],[-3.39204,38.887847],[-3.388952,38.914905],[-3.388337,38.919865],[-3.38785,38.924343],[-3.38745,38.928569],[-3.386769,38.934529],[-3.386326,38.938108],[-3.385639,38.944238],[-3.384476,38.953753],[-3.383537,38.96211],[-3.383291,38.963948],[-3.382658,38.969574],[-3.381344,38.980738],[-3.381276,38.982766],[-3.381479,38.983869],[-3.382181,38.985566],[-3.383524,38.987294],[-3.387475,38.991077],[-3.388646,38.992629],[-3.389149,38.993669],[-3.38964,38.99562],[-3.389665,38.996901],[-3.389313,38.998542],[-3.388357,39.000468],[-3.387024,39.002011],[-3.382955,39.005789],[-3.376151,39.01198],[-3.375006,39.013133],[-3.373968,39.014844],[-3.373532,39.016316],[-3.373464,39.01739],[-3.373753,39.02471],[-3.37382,39.027725],[-3.374274,39.038759],[-3.374482,39.044348],[-3.375529,39.069974],[-3.375832,39.077714],[-3.376141,39.084911],[-3.376669,39.098702],[-3.377117,39.109173],[-3.377686,39.123664],[-3.37784,39.125666],[-3.378069,39.126992],[-3.378569,39.128744],[-3.380372,39.133627],[-3.386437,39.149743],[-3.387754,39.153303],[-3.390524,39.160602],[-3.399328,39.184059],[-3.403899,39.196173],[-3.40497,39.198786],[-3.412493,39.216241],[-3.413385,39.218626],[-3.413574,39.219744],[-3.41345,39.221786],[-3.413048,39.223135],[-3.411549,39.226175],[-3.410983,39.227919],[-3.41084,39.229037],[-3.410929,39.230871],[-3.411823,39.237708],[-3.412096,39.239068],[-3.412953,39.240991],[-3.414008,39.242323],[-3.415159,39.243341],[-3.416776,39.244305],[-3.418544,39.24501],[-3.420406,39.24544],[-3.424282,39.246013],[-3.425682,39.246327],[-3.428,39.247278],[-3.429752,39.248468],[-3.430648,39.249355],[-3.431645,39.250721],[-3.438069,39.2608],[-3.440029,39.26392],[-3.442983,39.268487],[-3.4488,39.27759],[-3.454565,39.286524],[-3.455662,39.28826],[-3.460175,39.295097],[-3.463194,39.299577],[-3.468573,39.307779],[-3.469215,39.309455],[-3.469327,39.310316],[-3.469196,39.311861],[-3.46874,39.313413],[-3.468589,39.314521],[-3.468714,39.31538],[-3.469153,39.316388],[-3.470204,39.317586],[-3.471713,39.318642],[-3.471435,39.319205],[-3.470689,39.319003],[-3.470186,39.318291],[-3.470341,39.317603],[-3.472263,39.315006],[-3.4728,39.314401],[-3.473278,39.314496],[-3.477206,39.320394],[-3.475725,39.317965],[-3.473307,39.314436],[-3.473395,39.313854],[-3.473022,39.313652],[-3.47205,39.315222],[-3.470332,39.31752],[-3.470155,39.318494],[-3.470518,39.318966],[-3.471191,39.319281],[-3.472845,39.319663],[-3.473569,39.320057],[-3.475222,39.322086],[-3.476941,39.323816],[-3.477496,39.324511],[-3.478205,39.326292],[-3.478233,39.327547],[-3.477965,39.328795],[-3.477953,39.33003],[-3.478465,39.331431],[-3.479446,39.332523],[-3.48213,39.33423],[-3.483264,39.335233],[-3.484277,39.33654],[-3.484685,39.337369],[-3.48504,39.338695],[-3.485491,39.34165],[-3.486334,39.34522],[-3.48762,39.350264],[-3.488729,39.355505],[-3.489684,39.359215],[-3.490978,39.364641],[-3.491399,39.365916],[-3.494743,39.374144],[-3.495994,39.377601],[-3.495862,39.378538],[-3.496395,39.378694],[-3.500515,39.388888],[-3.500854,39.389878],[-3.501175,39.39173],[-3.500663,39.39274],[-3.5016,39.392111],[-3.502723,39.394045],[-3.504948,39.399472],[-3.506141,39.402226],[-3.509433,39.410519],[-3.5103,39.412784],[-3.513173,39.419731],[-3.514297,39.422612],[-3.517385,39.430093],[-3.518837,39.433755],[-3.519607,39.435452],[-3.521885,39.439672],[-3.525794,39.446447],[-3.526396,39.44773],[-3.526666,39.449196],[-3.526424,39.450946],[-3.525645,39.452618],[-3.523153,39.456033],[-3.520628,39.459339],[-3.517937,39.463064],[-3.5174,39.464104],[-3.516891,39.466017],[-3.516941,39.46732],[-3.517182,39.468146],[-3.518175,39.470224],[-3.522203,39.477311],[-3.524544,39.481547],[-3.525094,39.483404],[-3.526111,39.491233],[-3.526904,39.494931],[-3.527322,39.496449],[-3.527532,39.497723],[-3.527447,39.49902],[-3.52665,39.502688],[-3.525989,39.506226],[-3.524711,39.512756],[-3.523601,39.518212],[-3.523035,39.521228],[-3.522331,39.524035],[-3.521278,39.529168],[-3.520151,39.535632],[-3.517356,39.550745],[-3.516744,39.554485],[-3.515849,39.559535],[-3.514582,39.566245],[-3.513935,39.570182],[-3.514212,39.572431],[-3.517958,39.583554],[-3.518651,39.585735],[-3.519468,39.587961],[-3.520046,39.589812],[-3.522049,39.595616],[-3.524571,39.601807],[-3.525135,39.603376],[-3.525277,39.60432],[-3.525143,39.605675],[-3.524397,39.609235],[-3.523673,39.612153],[-3.523327,39.613972],[-3.522306,39.618146],[-3.52113,39.623196],[-3.520676,39.625466],[-3.519359,39.631306],[-3.514747,39.651937],[-3.514069,39.654861],[-3.512988,39.659825],[-3.511337,39.66714],[-3.511058,39.668041],[-3.509138,39.673288],[-3.506382,39.680404],[-3.505766,39.681898],[-3.50519,39.682871],[-3.504408,39.683776],[-3.501638,39.68647],[-3.499181,39.688938],[-3.498177,39.690035],[-3.497473,39.691254],[-3.497004,39.692985],[-3.496977,39.694294],[-3.497336,39.695796],[-3.498059,39.69746],[-3.498562,39.699667],[-3.498491,39.700993],[-3.497645,39.703986],[-3.49638,39.70908],[-3.495435,39.713048],[-3.494222,39.717753],[-3.489469,39.736442],[-3.488741,39.73941],[-3.485163,39.749593],[-3.484913,39.750479],[-3.483564,39.754253],[-3.481467,39.760457],[-3.481121,39.762607],[-3.480713,39.764453],[-3.480155,39.768043],[-3.479108,39.774135],[-3.478922,39.776556],[-3.47902,39.777651],[-3.479357,39.778735],[-3.479949,39.779967],[-3.481626,39.782129],[-3.482553,39.783538],[-3.483226,39.785253],[-3.483477,39.787135],[-3.483152,39.789003],[-3.481374,39.79353],[-3.47963,39.798121],[-3.47937,39.799002],[-3.479095,39.80076],[-3.478761,39.804592],[-3.478537,39.808171],[-3.480353,39.817609],[-3.480703,39.818984],[-3.481246,39.820013],[-3.483909,39.823208],[-3.484413,39.824452],[-3.484497,39.825221],[-3.48421,39.827335],[-3.48375,39.829667],[-3.483349,39.832233],[-3.482815,39.833479],[-3.482207,39.83425],[-3.480734,39.835268],[-3.476792,39.837113],[-3.47574,39.837787],[-3.474861,39.838618],[-3.474013,39.84014],[-3.473443,39.842472],[-3.472797,39.845749],[-3.472,39.849408],[-3.471935,39.85177],[-3.472328,39.853486],[-3.472941,39.854687],[-3.474261,39.856816],[-3.47484,39.858271],[-3.477098,39.864853],[-3.477252,39.866125],[-3.47736,39.868339],[-3.47696,39.87073],[-3.476187,39.874479],[-3.475961,39.875105],[-3.47156,39.882983],[-3.470957,39.884215],[-3.470609,39.885476],[-3.470676,39.887412],[-3.470927,39.888248],[-3.472275,39.890871],[-3.472609,39.891875],[-3.472821,39.899579],[-3.473301,39.901694],[-3.474727,39.907383],[-3.47535,39.909652],[-3.476124,39.912956],[-3.477483,39.916645],[-3.479104,39.920259],[-3.479637,39.921263],[-3.48151,39.924007],[-3.484115,39.929074],[-3.484796,39.930283],[-3.488653,39.936404],[-3.490878,39.939865],[-3.49267,39.942346],[-3.493982,39.94436],[-3.494851,39.945252],[-3.499099,39.9483],[-3.500856,39.949097],[-3.507423,39.951348],[-3.509455,39.951665],[-3.514279,39.951609],[-3.515442,39.951654],[-3.517155,39.95195],[-3.518524,39.952405],[-3.519604,39.952912],[-3.529604,39.959632],[-3.535266,39.96388],[-3.537283,39.965139],[-3.540525,39.966575],[-3.545221,39.96852],[-3.54692,39.969279],[-3.551861,39.971287],[-3.554564,39.972485],[-3.56306,39.976067],[-3.565871,39.977217],[-3.571171,39.979504],[-3.581294,39.984599],[-3.583389,39.985569],[-3.587247,39.987546],[-3.589585,39.988679],[-3.598095,39.992996],[-3.601931,39.994977],[-3.602781,39.995544],[-3.603671,39.99645],[-3.605957,39.999141],[-3.607408,40.000557],[-3.608575,40.001552],[-3.609809,40.002809],[-3.615392,40.008911],[-3.616506,40.009733],[-3.618362,40.010561],[-3.620677,40.011006],[-3.627297,40.01155],[-3.628863,40.011902],[-3.630253,40.012635],[-3.630975,40.013303],[-3.632813,40.015496],[-3.635153,40.017313],[-3.636393,40.018188],[-3.638135,40.019075],[-3.639207,40.019466],[-3.645878,40.021554],[-3.648654,40.023177],[-3.65287,40.025206],[-3.654341,40.026219],[-3.655176,40.027051],[-3.657891,40.03073],[-3.658848,40.032118],[-3.660305,40.033788],[-3.66118,40.034956],[-3.662595,40.038755],[-3.662867,40.040027],[-3.662552,40.0417],[-3.660075,40.046252],[-3.659111,40.047545],[-3.655721,40.050845],[-3.655091,40.051602],[-3.650575,40.058059],[-3.649431,40.059919],[-3.648226,40.063463],[-3.647129,40.065528],[-3.645928,40.067063],[-3.644391,40.068689],[-3.643229,40.070471],[-3.641743,40.073274],[-3.638292,40.07876],[-3.637922,40.079598],[-3.637589,40.081158],[-3.637389,40.083943],[-3.637162,40.085012],[-3.636358,40.086617],[-3.634282,40.089708],[-3.63384,40.091358],[-3.633829,40.09343],[-3.633632,40.09462],[-3.632984,40.096548],[-3.632844,40.097889],[-3.633236,40.099104],[-3.633794,40.099882],[-3.63506,40.100887],[-3.635899,40.101274],[-3.640216,40.10228],[-3.643748,40.103868],[-3.645566,40.105221],[-3.646531,40.106346],[-3.647396,40.107807],[-3.649156,40.111027],[-3.64917,40.111239],[-3.651706,40.11559],[-3.654832,40.120858],[-3.655676,40.122797],[-3.656063,40.125554],[-3.657421,40.135809],[-3.658115,40.142316],[-3.659608,40.155673],[-3.659955,40.157174],[-3.66085,40.159475],[-3.661626,40.161208],[-3.662543,40.163564],[-3.665638,40.171091],[-3.667479,40.175735],[-3.669045,40.179442],[-3.671827,40.186386],[-3.672144,40.187534],[-3.672213,40.188456],[-3.672002,40.190292],[-3.672037,40.191201],[-3.672312,40.192084],[-3.673273,40.193415],[-3.674965,40.194958],[-3.675729,40.196005],[-3.678488,40.203052],[-3.679864,40.206281],[-3.68232,40.2125],[-3.684275,40.217199],[-3.685969,40.221375],[-3.688704,40.227879],[-3.689131,40.229201],[-3.689296,40.230331],[-3.689479,40.2365],[-3.689663,40.241301],[-3.689798,40.24697],[-3.690093,40.256309],[-3.690181,40.260363],[-3.690388,40.264494],[-3.690405,40.266324],[-3.690953,40.283992],[-3.691052,40.289545],[-3.691418,40.300672],[-3.691458,40.301137],[-3.6917,40.309021],[-3.6918,40.310477],[-3.691837,40.313714],[-3.692057,40.319821],[-3.692024,40.320684],[-3.69165,40.322542],[-3.691113,40.324232],[-3.690409,40.325902],[-3.689714,40.326866],[-3.68862,40.328092],[-3.687458,40.329099],[-3.685213,40.330544],[-3.683194,40.331434],[-3.681349,40.332137],[-3.680086,40.33277],[-3.678436,40.333777],[-3.677194,40.334737],[-3.675713,40.336132],[-3.674236,40.33813],[-3.673665,40.339177],[-3.673163,40.34047],[-3.672727,40.342259],[-3.672641,40.344647],[-3.672801,40.345958],[-3.673213,40.347473],[-3.674182,40.349548],[-3.67581,40.352159],[-3.676585,40.352934],[-3.678005,40.354017],[-3.678678,40.354791],[-3.67912,40.355713],[-3.679203,40.357236],[-3.678981,40.357905],[-3.677603,40.360094],[-3.677419,40.360837],[-3.677935,40.36312],[-3.678163,40.366943],[-3.678347,40.36819],[-3.678939,40.370081],[-3.680251,40.372557],[-3.682893,40.375715],[-3.684522,40.377545],[-3.685934,40.379507],[-3.687006,40.381227],[-3.687977,40.382204],[-3.690873,40.38361],[-3.692315,40.384702],[-3.696161,40.387839],[-3.703816,40.395056],[-3.703799,40.395099],[-3.712056,40.400282],[-3.716556,40.40118],[-3.717295,40.400566],[-3.717208,40.399244],[-3.71638,40.398615],[-3.716264,40.398161],[-3.71672,40.397873],[-3.718312,40.39847],[-3.718639,40.397974],[-3.717021,40.397301],[-3.715774,40.397544],[-3.716454,40.397987],[-3.717273,40.397579],[-3.716715,40.397346],[-3.715616,40.397544],[-3.714949,40.397996],[-3.713625,40.397643],[-3.696159,40.386818],[-3.694785,40.385932],[-3.69088,40.382574],[-3.689891,40.382076],[-3.688684,40.381744],[-3.687086,40.38177],[-3.686249,40.382096],[-3.684176,40.38331],[-3.682901,40.384264],[-3.682359,40.384932],[-3.678808,40.390214],[-3.677686,40.391285],[-3.674835,40.39342],[-3.67241,40.395002],[-3.670398,40.396868],[-3.668569,40.398999],[-3.66706,40.401542],[-3.665857,40.404295],[-3.663875,40.407883],[-3.662991,40.409897],[-3.662105,40.411576],[-3.659863,40.415083],[-3.65859,40.417447],[-3.658286,40.418942],[-3.659309,40.42487],[-3.65995,40.427356],[-3.660476,40.431018],[-3.660426,40.432102],[-3.658752,40.438796],[-3.658654,40.439718],[-3.658699,40.441661],[-3.658996,40.443472],[-3.658424,40.444917],[-3.658055,40.445353],[-3.655535,40.446189],[-3.650968,40.448054],[-3.650373,40.448392],[-3.647585,40.449632],[-3.646403,40.449834],[-3.645375,40.449755],[-3.638934,40.448697],[-3.63781,40.448561],[-3.636078,40.448621],[-3.633368,40.448925],[-3.631236,40.449241],[-3.623728,40.449476],[-3.622138,40.449386],[-3.620799,40.449527],[-3.619911,40.44947],[-3.617651,40.449561],[-3.612489,40.449619],[-3.610772,40.449696],[-3.606165,40.449714],[-3.603211,40.44981],[-3.599216,40.45008],[-3.592548,40.450165],[-3.592527,40.449792],[-3.590001,40.448875],[-3.588997,40.448924],[-3.587782,40.44961],[-3.586615,40.451244],[-3.572025,40.463031],[-3.571074,40.463492],[-3.570436,40.464613],[-3.570327,40.465541],[-3.570849,40.466049],[-3.572868,40.465987],[-3.573556,40.46492],[-3.572756,40.464556],[-3.57335,40.463473],[-3.573815,40.463478],[-3.573224,40.464748],[-3.572757,40.464556],[-3.572062,40.465627],[-3.573045,40.465793],[-3.573397,40.465306],[-3.572495,40.465057],[-3.572542,40.464695],[-3.57081,40.464018],[-3.570918,40.463308],[-3.573147,40.465276],[-3.573601,40.464785],[-3.57269,40.464546],[-3.572092,40.465796],[-3.571662,40.465986],[-3.570425,40.465683],[-3.570778,40.466174],[-3.571398,40.466277],[-3.573851,40.466118],[-3.574798,40.465475],[-3.575013,40.464996],[-3.575144,40.463584],[-3.57592,40.462388],[-3.577411,40.461075],[-3.580533,40.458505],[-3.581782,40.457559],[-3.586141,40.453917],[-3.587277,40.452824],[-3.588541,40.45138],[-3.589727,40.449642],[-3.590151,40.44925],[-3.590703,40.449231],[-3.590535,40.44987],[-3.588056,40.449871],[-3.584773,40.449631],[-3.581464,40.449625],[-3.579377,40.449765],[-3.574732,40.449638],[-3.572505,40.449638],[-3.564586,40.449376],[-3.562069,40.449371],[-3.557636,40.449247],[-3.552358,40.448802],[-3.538709,40.447253],[-3.536455,40.446892],[-3.534939,40.446483],[-3.53407,40.446394],[-3.532798,40.44653],[-3.526796,40.448099],[-3.523349,40.448925],[-3.522917,40.448669],[-3.52207,40.447076],[-3.52222,40.446529],[-3.523867,40.446134],[-3.524428,40.446842],[-3.524006,40.447052],[-3.524348,40.447587],[-3.523646,40.447794],[-3.523382,40.447219],[-3.524075,40.447124],[-3.524558,40.447837],[-3.524388,40.448457],[-3.523327,40.448749],[-3.522824,40.448582],[-3.521777,40.446779],[-3.522913,40.449132],[-3.520868,40.449766],[-3.517567,40.451023],[-3.515956,40.451481],[-3.511137,40.453101],[-3.510251,40.453478],[-3.508111,40.454664],[-3.503723,40.457512],[-3.502285,40.458392],[-3.498931,40.460112],[-3.496494,40.461157],[-3.49366,40.462004],[-3.491599,40.462478],[-3.486506,40.463819],[-3.479392,40.465441],[-3.475474,40.466236],[-3.472655,40.466657],[-3.470983,40.466831],[-3.468481,40.466948],[-3.465426,40.466955],[-3.457165,40.466595],[-3.455274,40.466553],[-3.450586,40.466705],[-3.442352,40.467413],[-3.440532,40.467659],[-3.434721,40.468658],[-3.431767,40.469105],[-3.429896,40.469481],[-3.427477,40.47009],[-3.423006,40.47142],[-3.420288,40.472164],[-3.413976,40.473738],[-3.411143,40.474709],[-3.408998,40.4757],[-3.407451,40.476593],[-3.405273,40.478141],[-3.40434,40.478679],[-3.402169,40.480667],[-3.401125,40.480829],[-3.400319,40.480329],[-3.39956,40.479087],[-3.398406,40.479332],[-3.397964,40.479716],[-3.398389,40.480426],[-3.398802,40.48061],[-3.400031,40.480257],[-3.400211,40.480844],[-3.401299,40.481068],[-3.401487,40.481448],[-3.40014,40.482979],[-3.397082,40.48601],[-3.395381,40.487382],[-3.389555,40.491674],[-3.387415,40.493076],[-3.386425,40.493184],[-3.385774,40.494191],[-3.382992,40.495833],[-3.375999,40.499397],[-3.374648,40.500138],[-3.372299,40.50118],[-3.372148,40.501334],[-3.365424,40.504567],[-3.362887,40.505384],[-3.361066,40.50568],[-3.357996,40.505702],[-3.352415,40.505188],[-3.349201,40.50462],[-3.348071,40.504296],[-3.345644,40.503337],[-3.342958,40.502055],[-3.341107,40.501533],[-3.339685,40.501338],[-3.337324,40.501476],[-3.335602,40.501907],[-3.334278,40.502504],[-3.331735,40.504084],[-3.324142,40.509038],[-3.316098,40.514141],[-3.304237,40.521731],[-3.303171,40.522381],[-3.297465,40.526052],[-3.293192,40.528635],[-3.291789,40.529629],[-3.288932,40.532271],[-3.284563,40.536025],[-3.281385,40.538867],[-3.275885,40.54365],[-3.272546,40.546453],[-3.26621,40.552029],[-3.258047,40.559169],[-3.255297,40.561664],[-3.251329,40.565105],[-3.249037,40.567146],[-3.244081,40.571439],[-3.24188,40.573508],[-3.238518,40.577272],[-3.23564,40.580391],[-3.231581,40.584561],[-3.22827,40.588204],[-3.221691,40.595872],[-3.21878,40.599422],[-3.216809,40.601743],[-3.211683,40.607596],[-3.209642,40.610171],[-3.204232,40.616862],[-3.199875,40.62213],[-3.198393,40.623378],[-3.197209,40.62392],[-3.189294,40.625863],[-3.18331,40.627406],[-3.181542,40.627686],[-3.179449,40.627527],[-3.177627,40.627041],[-3.173784,40.625828],[-3.171537,40.625319],[-3.169482,40.624993],[-3.168248,40.624652],[-3.166804,40.623981],[-3.164911,40.622825],[-3.163922,40.622381],[-3.162091,40.621917],[-3.15963,40.621824],[-3.15672,40.622145],[-3.154234,40.622877],[-3.15267,40.623691],[-3.151319,40.624719],[-3.150512,40.625599],[-3.149698,40.62699],[-3.148999,40.628896],[-3.148272,40.630306],[-3.143264,40.636483],[-3.142682,40.637418],[-3.142307,40.638667],[-3.14217,40.642065],[-3.14179,40.643161],[-3.140584,40.644731],[-3.139473,40.645519],[-3.133986,40.648706],[-3.13221,40.649461],[-3.129015,40.650227],[-3.127494,40.650718],[-3.125969,40.651565],[-3.125263,40.652177],[-3.124435,40.653236],[-3.123374,40.655235],[-3.122092,40.656703],[-3.115053,40.661524],[-3.11007,40.665004],[-3.108831,40.665976],[-3.107707,40.667058],[-3.097003,40.678292],[-3.09621,40.679455],[-3.095456,40.681122],[-3.09425,40.682659],[-3.090796,40.68529],[-3.089558,40.686473],[-3.087979,40.688455],[-3.087276,40.689587],[-3.085503,40.693353],[-3.084034,40.696971],[-3.08331,40.698551],[-3.08226,40.700061],[-3.081051,40.701226],[-3.077004,40.704027],[-3.075591,40.705303],[-3.074601,40.706553],[-3.071598,40.711145],[-3.069957,40.712835],[-3.066933,40.715193],[-3.062982,40.718352],[-3.059676,40.720853],[-3.057446,40.722386],[-3.056156,40.723437],[-3.054268,40.725253],[-3.053029,40.7261],[-3.050713,40.727272],[-3.048022,40.728767],[-3.045457,40.730329],[-3.044526,40.731009],[-3.043136,40.732668],[-3.040219,40.737331],[-3.038939,40.738931],[-3.037058,40.7404],[-3.03588,40.741444],[-3.034917,40.742846],[-3.034062,40.744657],[-3.033484,40.745431],[-3.032447,40.746412],[-3.031445,40.747047],[-3.028597,40.748593],[-3.02615,40.750171],[-3.023233,40.752358],[-3.021616,40.753413],[-3.016995,40.756813],[-3.009778,40.762216],[-3.00552,40.765458],[-3.000601,40.769102],[-2.994211,40.77396],[-2.987328,40.779084],[-2.983486,40.78168],[-2.980058,40.783799],[-2.975603,40.786682],[-2.9667,40.792597],[-2.962342,40.795562],[-2.955369,40.80017],[-2.952975,40.801808],[-2.951341,40.80302],[-2.9431,40.80847],[-2.941273,40.809642],[-2.938864,40.811046],[-2.934562,40.813844],[-2.932128,40.815478],[-2.922736,40.821664],[-2.916995,40.825546],[-2.90952,40.830476],[-2.905276,40.833359],[-2.899928,40.836912],[-2.898743,40.837544],[-2.897247,40.838171],[-2.893047,40.839493],[-2.88612,40.841804],[-2.879469,40.843944],[-2.869683,40.847211],[-2.862293,40.849732],[-2.859624,40.850566],[-2.844949,40.855307],[-2.842418,40.856244],[-2.838887,40.857916],[-2.833996,40.860708],[-2.83136,40.862606],[-2.829562,40.863669],[-2.828606,40.864094],[-2.824256,40.865477],[-2.820635,40.866996],[-2.816528,40.868824],[-2.810943,40.871229],[-2.804175,40.874282],[-2.795058,40.878314],[-2.792386,40.879587],[-2.786703,40.882645],[-2.783441,40.884454],[-2.782193,40.885062],[-2.778147,40.887268],[-2.77725,40.887817],[-2.772567,40.890322],[-2.764064,40.894952],[-2.757723,40.898325],[-2.755289,40.899826],[-2.748375,40.904868],[-2.743777,40.908343],[-2.738819,40.911908],[-2.732048,40.91687],[-2.724183,40.922553],[-2.711836,40.931611],[-2.704475,40.937046],[-2.691876,40.946217],[-2.683956,40.952011],[-2.680206,40.954638],[-2.678863,40.955449],[-2.676125,40.956593],[-2.674497,40.957023],[-2.672237,40.957382],[-2.667713,40.957484],[-2.666498,40.957631],[-2.664915,40.958017],[-2.6609,40.959363],[-2.658828,40.959998],[-2.657698,40.960226],[-2.65164,40.96108],[-2.648915,40.96151],[-2.641724,40.962498],[-2.639551,40.962956],[-2.637988,40.963497],[-2.636531,40.964206],[-2.634798,40.965382],[-2.633744,40.966394],[-2.631978,40.968599],[-2.63113,40.969472],[-2.629657,40.970555],[-2.628531,40.971221],[-2.62643,40.972005],[-2.624778,40.972386],[-2.622414,40.97263],[-2.62068,40.97272],[-2.619016,40.973015],[-2.61775,40.973447],[-2.616359,40.974186],[-2.615414,40.974936],[-2.614668,40.975824],[-2.613922,40.977163],[-2.613694,40.977994],[-2.61369,40.979882],[-2.613561,40.981382],[-2.613271,40.982195],[-2.61222,40.983709],[-2.611293,40.984515],[-2.609951,40.985324],[-2.607509,40.986468],[-2.603965,40.987631],[-2.595588,40.989698],[-2.594323,40.990068],[-2.592044,40.990982],[-2.588386,40.993161],[-2.575911,41.00051],[-2.570368,41.003739],[-2.567901,41.005219],[-2.563732,41.007632],[-2.557719,41.011177],[-2.555437,41.012413],[-2.55348,41.013579],[-2.551369,41.014635],[-2.549803,41.015199],[-2.548433,41.015559],[-2.546507,41.015882],[-2.54462,41.016089],[-2.542712,41.016424],[-2.539544,41.017383],[-2.53675,41.018025],[-2.533589,41.018414],[-2.531752,41.018404],[-2.527962,41.018005],[-2.525867,41.017968],[-2.523429,41.018416],[-2.521224,41.019389],[-2.519891,41.020434],[-2.51879,41.021901],[-2.517974,41.023822],[-2.516771,41.025576],[-2.515684,41.026614],[-2.513956,41.027629],[-2.51279,41.028055],[-2.511093,41.028468],[-2.509245,41.02867],[-2.506038,41.028732],[-2.504999,41.028852],[-2.502795,41.029304],[-2.501156,41.02982],[-2.498354,41.031134],[-2.496748,41.031789],[-2.495596,41.032128],[-2.493744,41.032461],[-2.490669,41.032693],[-2.488937,41.033068],[-2.486088,41.034098],[-2.484165,41.034526],[-2.482759,41.034659],[-2.477388,41.034768],[-2.469214,41.034448],[-2.465857,41.034544],[-2.46376,41.034769],[-2.455577,41.036033],[-2.453876,41.036441],[-2.451854,41.037315],[-2.450763,41.038051],[-2.449534,41.039231],[-2.448552,41.040798],[-2.448171,41.042026],[-2.447144,41.048009],[-2.447121,41.049225],[-2.447466,41.050662],[-2.448099,41.052294],[-2.448382,41.053767],[-2.448254,41.055939],[-2.447529,41.057788],[-2.443735,41.064006],[-2.443057,41.065429],[-2.442663,41.066923],[-2.442571,41.067798],[-2.442691,41.069965],[-2.443484,41.072713],[-2.443788,41.074448],[-2.443836,41.075549],[-2.443682,41.079702],[-2.443612,41.083267],[-2.443884,41.085022],[-2.444454,41.086692],[-2.4454,41.088486],[-2.449307,41.094759],[-2.450363,41.096785],[-2.450622,41.098226],[-2.450552,41.099054],[-2.449992,41.101533],[-2.449994,41.102354],[-2.450476,41.104473],[-2.450517,41.105573],[-2.450364,41.10646],[-2.449939,41.107517],[-2.449004,41.108808],[-2.447308,41.110114],[-2.44503,41.111516],[-2.443752,41.112823],[-2.44302,41.114146],[-2.442569,41.116187],[-2.442614,41.117653],[-2.442988,41.119325],[-2.444026,41.121993],[-2.44449,41.122115],[-2.445976,41.123934],[-2.446454,41.124712],[-2.446977,41.126394],[-2.446907,41.127917],[-2.446651,41.128793],[-2.445803,41.130208],[-2.443521,41.132531],[-2.439792,41.136662],[-2.438513,41.137601],[-2.43654,41.138578],[-2.435149,41.139663],[-2.43386,41.14108],[-2.432824,41.141832],[-2.431104,41.142688],[-2.429625,41.143703],[-2.428948,41.144396],[-2.428077,41.145971],[-2.427335,41.148899],[-2.425363,41.152804],[-2.424516,41.153914],[-2.423333,41.1548],[-2.420119,41.156605],[-2.418441,41.157865],[-2.417838,41.158649],[-2.417468,41.159529],[-2.417328,41.160432],[-2.41744,41.164876],[-2.41735,41.165973],[-2.416953,41.167946],[-2.415985,41.170264],[-2.4154,41.171065],[-2.413815,41.172156],[-2.41087,41.173195],[-2.401866,41.175771],[-2.400879,41.176121],[-2.399594,41.176835],[-2.398781,41.177671],[-2.398077,41.179263],[-2.398179,41.180719],[-2.398751,41.181853],[-2.400036,41.183752],[-2.401303,41.186372],[-2.401999,41.187502],[-2.402413,41.188475],[-2.402577,41.189849],[-2.4022,41.19136],[-2.401223,41.192774],[-2.399962,41.193791],[-2.398388,41.194661],[-2.397322,41.195448],[-2.395845,41.197059],[-2.394866,41.197938],[-2.393034,41.198972],[-2.390675,41.199603],[-2.389477,41.199691],[-2.386373,41.199477],[-2.384037,41.199554],[-2.382761,41.19979],[-2.381459,41.200259],[-2.379993,41.201028],[-2.378396,41.202161],[-2.377425,41.202629],[-2.376074,41.202988],[-2.374342,41.203027],[-2.371789,41.202754],[-2.370372,41.202895],[-2.369039,41.203281],[-2.366566,41.204462],[-2.364338,41.204852],[-2.36294,41.204648],[-2.361642,41.204203],[-2.359295,41.202927],[-2.357389,41.202237],[-2.35598,41.201962],[-2.353585,41.201847],[-2.351778,41.202032],[-2.349638,41.202367],[-2.347813,41.202423],[-2.346294,41.202232],[-2.342837,41.201271],[-2.341338,41.201043],[-2.340111,41.201013],[-2.338588,41.201149],[-2.336003,41.201827],[-2.334557,41.202126],[-2.332265,41.202191],[-2.329397,41.20177],[-2.328359,41.201713],[-2.324592,41.201838],[-2.322932,41.201692],[-2.319886,41.200942],[-2.318781,41.200751],[-2.316832,41.200607],[-2.315137,41.200731],[-2.313487,41.201043],[-2.311178,41.201797],[-2.309823,41.202141],[-2.307796,41.202347],[-2.304337,41.202167],[-2.302345,41.202484],[-2.299405,41.203488],[-2.296382,41.204343],[-2.295088,41.204874],[-2.293673,41.205636],[-2.29214,41.207015],[-2.291466,41.208018],[-2.291078,41.208902],[-2.290873,41.21005],[-2.290975,41.212014],[-2.290915,41.213288],[-2.290698,41.214292],[-2.289935,41.215853],[-2.289049,41.216961],[-2.287738,41.218101],[-2.285835,41.219229],[-2.283466,41.220015],[-2.281298,41.220345],[-2.279869,41.220357],[-2.276713,41.220024],[-2.2747,41.219924],[-2.27265,41.219988],[-2.270125,41.220334],[-2.267462,41.220995],[-2.265956,41.221512],[-2.258816,41.22468],[-2.256985,41.225268],[-2.252004,41.227572],[-2.245587,41.230496],[-2.243269,41.231749],[-2.24192,41.232582],[-2.239139,41.234488],[-2.232333,41.239077],[-2.22815,41.242273],[-2.226582,41.243219],[-2.222632,41.245068],[-2.213206,41.249429],[-2.210925,41.250282],[-2.206666,41.25174],[-2.196025,41.255991],[-2.193406,41.257333],[-2.191457,41.258747],[-2.184795,41.264405],[-2.17836,41.269954],[-2.177531,41.270805],[-2.176462,41.272521],[-2.176054,41.273772],[-2.17508,41.277594],[-2.174776,41.279721],[-2.174346,41.282032],[-2.17373,41.284062],[-2.172679,41.286015],[-2.171369,41.287675],[-2.169786,41.289415],[-2.167158,41.291845],[-2.164423,41.293892],[-2.163176,41.294736],[-2.160656,41.296057],[-2.158079,41.296983],[-2.156438,41.297361],[-2.148787,41.298581],[-2.146504,41.299322],[-2.14517,41.300046],[-2.143907,41.30112],[-2.142437,41.303105],[-2.141532,41.304125],[-2.139567,41.305494],[-2.138127,41.306123],[-2.13603,41.306633],[-2.134919,41.306735],[-2.1313,41.306725],[-2.128866,41.306883],[-2.125475,41.307526],[-2.123724,41.308062],[-2.121024,41.309142],[-2.119464,41.309564],[-2.117867,41.309758],[-2.116022,41.309732],[-2.107,41.308711],[-2.104476,41.308713],[-2.101108,41.309154],[-2.098136,41.309462],[-2.091235,41.30973],[-2.08026,41.310082],[-2.077573,41.31034],[-2.076229,41.310675],[-2.074339,41.31144],[-2.070569,41.313697],[-2.067988,41.314903],[-2.064276,41.316365],[-2.060983,41.317828],[-2.060037,41.318149],[-2.058539,41.318409],[-2.057467,41.318423],[-2.053901,41.318279],[-2.048106,41.317975],[-2.046826,41.317758],[-2.044888,41.317077],[-2.043083,41.316099],[-2.041389,41.315467],[-2.039529,41.315123],[-2.038426,41.315074],[-2.036559,41.31523],[-2.026126,41.317432],[-2.024239,41.317735],[-2.022074,41.317855],[-2.020174,41.317777],[-2.018305,41.317511],[-2.016717,41.31712],[-2.008887,41.314636],[-1.996307,41.309799],[-1.991638,41.308026],[-1.990047,41.307552],[-1.984011,41.306402],[-1.974978,41.304733],[-1.973622,41.304572],[-1.971482,41.304794],[-1.969894,41.305173],[-1.96855,41.30532],[-1.966098,41.305009],[-1.962372,41.304208],[-1.954848,41.302674],[-1.953216,41.302491],[-1.950739,41.302573],[-1.942154,41.303579],[-1.940115,41.304123],[-1.936323,41.305883],[-1.934309,41.306472],[-1.932462,41.30659],[-1.930275,41.306427],[-1.9292,41.306486],[-1.92769,41.306855],[-1.926811,41.30728],[-1.925107,41.308427],[-1.923717,41.309129],[-1.921698,41.30974],[-1.920029,41.309944],[-1.917994,41.309734],[-1.916501,41.309247],[-1.914938,41.308997],[-1.913322,41.309114],[-1.912172,41.309451],[-1.911132,41.309951],[-1.909813,41.311121],[-1.909147,41.312621],[-1.90927,41.314898],[-1.909007,41.316141],[-1.908204,41.317285],[-1.906481,41.318407],[-1.905016,41.318788],[-1.902702,41.318814],[-1.899912,41.318319],[-1.896921,41.317305],[-1.895869,41.31704],[-1.893952,41.316807],[-1.892554,41.316825],[-1.890672,41.317096],[-1.888478,41.317837],[-1.886009,41.319231],[-1.884273,41.320087],[-1.881704,41.320983],[-1.88016,41.321342],[-1.876811,41.321915],[-1.871073,41.322825],[-1.867372,41.322965],[-1.864761,41.323277],[-1.863008,41.323105],[-1.860954,41.322483],[-1.85983,41.322265],[-1.857987,41.322139],[-1.856837,41.321935],[-1.855327,41.321231],[-1.854063,41.320305],[-1.852192,41.319392],[-1.850571,41.319118],[-1.849028,41.319171],[-1.846936,41.319467],[-1.84543,41.319872],[-1.843521,41.320655],[-1.842157,41.321324],[-1.840113,41.321833],[-1.838497,41.321786],[-1.837739,41.321616],[-1.835529,41.320823],[-1.833907,41.320568],[-1.832238,41.320582],[-1.830857,41.320466],[-1.829821,41.320188],[-1.828897,41.319739],[-1.825787,41.317666],[-1.823929,41.316745],[-1.822623,41.316395],[-1.821225,41.316251],[-1.819848,41.316285],[-1.818234,41.316473],[-1.816896,41.316494],[-1.815294,41.316172],[-1.813272,41.315533],[-1.812207,41.315351],[-1.810601,41.315293],[-1.808217,41.315707],[-1.806567,41.316441],[-1.804392,41.317784],[-1.803432,41.318143],[-1.801555,41.318426],[-1.799314,41.318332],[-1.797643,41.318493],[-1.796625,41.318786],[-1.793736,41.320343],[-1.791835,41.320743],[-1.790311,41.320692],[-1.788174,41.320004],[-1.786717,41.319634],[-1.785697,41.319519],[-1.782813,41.319513],[-1.780803,41.319008],[-1.773621,41.315487],[-1.768795,41.313067],[-1.76206,41.309779],[-1.760802,41.309272],[-1.758932,41.308753],[-1.756109,41.308417],[-1.752978,41.308309],[-1.745469,41.308179],[-1.734606,41.307919],[-1.731668,41.308011],[-1.729375,41.308324],[-1.727728,41.30869],[-1.723905,41.309703],[-1.714383,41.312163],[-1.705755,41.314697],[-1.701499,41.315907],[-1.693508,41.318273],[-1.67284,41.323786],[-1.671255,41.324284],[-1.669377,41.325209],[-1.668563,41.325783],[-1.666763,41.327348],[-1.665624,41.328206],[-1.664557,41.328776],[-1.662817,41.3293],[-1.659036,41.329761],[-1.656768,41.330363],[-1.655609,41.330859],[-1.652894,41.332284],[-1.650705,41.333157],[-1.649187,41.33352],[-1.647473,41.333724],[-1.642047,41.333874],[-1.639866,41.334167],[-1.637811,41.334858],[-1.636021,41.335788],[-1.634182,41.337124],[-1.632907,41.338356],[-1.631754,41.339925],[-1.63101,41.341481],[-1.630096,41.343722],[-1.628971,41.345424],[-1.627355,41.346936],[-1.625814,41.347922],[-1.621162,41.349908],[-1.619516,41.350855],[-1.618499,41.351653],[-1.615973,41.354077],[-1.614802,41.355068],[-1.613276,41.356064],[-1.612069,41.356692],[-1.610262,41.357392],[-1.606451,41.358349],[-1.60345,41.359213],[-1.599361,41.360796],[-1.59619,41.361812],[-1.594516,41.362226],[-1.587935,41.363532],[-1.585548,41.364207],[-1.58408,41.364785],[-1.58143,41.366111],[-1.578843,41.367969],[-1.577401,41.369359],[-1.574106,41.37276],[-1.572993,41.374224],[-1.571927,41.377456],[-1.571818,41.37961],[-1.571474,41.381101],[-1.571068,41.381923],[-1.57014,41.383195],[-1.566427,41.387279],[-1.565139,41.388503],[-1.563978,41.389433],[-1.561587,41.390816],[-1.560383,41.391249],[-1.558788,41.391598],[-1.556745,41.391896],[-1.555454,41.392252],[-1.552657,41.393285],[-1.550186,41.393841],[-1.549394,41.394112],[-1.547728,41.395029],[-1.546786,41.395884],[-1.546123,41.396865],[-1.545261,41.398755],[-1.544507,41.399742],[-1.542677,41.401205],[-1.540892,41.402021],[-1.538369,41.402562],[-1.536656,41.402615],[-1.534523,41.402329],[-1.532559,41.40181],[-1.530819,41.401684],[-1.52866,41.402126],[-1.527472,41.402726],[-1.526546,41.403486],[-1.525948,41.404357],[-1.525581,41.405892],[-1.525957,41.40738],[-1.526839,41.409109],[-1.526907,41.410595],[-1.526587,41.411454],[-1.526027,41.412235],[-1.524849,41.413141],[-1.522913,41.413826],[-1.521572,41.413942],[-1.520156,41.413781],[-1.517227,41.413118],[-1.511954,41.412133],[-1.510459,41.412057],[-1.509002,41.412279],[-1.500822,41.414489],[-1.50008,41.414767],[-1.498796,41.415545],[-1.498004,41.416409],[-1.494232,41.423529],[-1.492982,41.425192],[-1.491467,41.426866],[-1.490346,41.428588],[-1.489305,41.431014],[-1.487973,41.432333],[-1.481814,41.4365],[-1.480758,41.43761],[-1.480268,41.438671],[-1.480174,41.43955],[-1.480492,41.441889],[-1.480406,41.443325],[-1.479749,41.444921],[-1.478936,41.445957],[-1.478111,41.446692],[-1.47636,41.447717],[-1.474922,41.448194],[-1.472268,41.448888],[-1.47046,41.449793],[-1.469393,41.450627],[-1.468276,41.451987],[-1.46775,41.453079],[-1.467496,41.454201],[-1.467571,41.455565],[-1.467825,41.456449],[-1.468662,41.458177],[-1.469027,41.459287],[-1.469038,41.46109],[-1.468225,41.463031],[-1.465804,41.466361],[-1.464989,41.46814],[-1.46384,41.469464],[-1.463079,41.469949],[-1.461603,41.470565],[-1.459461,41.471196],[-1.458099,41.471823],[-1.457246,41.472445],[-1.455852,41.474185],[-1.455092,41.474958],[-1.45341,41.475902],[-1.45216,41.476243],[-1.449783,41.476572],[-1.44853,41.476937],[-1.447635,41.477406],[-1.446728,41.478139],[-1.445834,41.479603],[-1.445523,41.480983],[-1.445153,41.481928],[-1.444449,41.482934],[-1.443705,41.48365],[-1.442262,41.484535],[-1.435686,41.487891],[-1.434737,41.488307],[-1.432903,41.488834],[-1.431516,41.489024],[-1.429249,41.488979],[-1.427911,41.488625],[-1.426955,41.488165],[-1.425826,41.487197],[-1.424927,41.485845],[-1.423997,41.484784],[-1.421963,41.483299],[-1.42013,41.482232],[-1.418663,41.4815],[-1.416076,41.480467],[-1.41367,41.479723],[-1.410646,41.479112],[-1.407897,41.478732],[-1.405532,41.478608],[-1.40409,41.478655],[-1.402683,41.478869],[-1.400001,41.479451],[-1.393931,41.480881],[-1.392365,41.481318],[-1.387619,41.483008],[-1.383513,41.484418],[-1.381074,41.485065],[-1.370942,41.487251],[-1.369633,41.487633],[-1.367658,41.488448],[-1.3656,41.489054],[-1.356976,41.490803],[-1.34539,41.493591],[-1.341649,41.494725],[-1.333457,41.497735],[-1.325394,41.500611],[-1.324187,41.501142],[-1.317786,41.504574],[-1.308962,41.509227],[-1.301378,41.513338],[-1.299379,41.514302],[-1.296675,41.515074],[-1.288538,41.517014],[-1.286789,41.517482],[-1.284618,41.518305],[-1.274674,41.522825],[-1.27179,41.524089],[-1.269875,41.525011],[-1.260691,41.529093],[-1.253422,41.532379],[-1.247791,41.534881],[-1.241625,41.537169],[-1.238568,41.538354],[-1.235922,41.539777],[-1.231944,41.541474],[-1.225151,41.544476],[-1.22241,41.545439],[-1.21733,41.54705],[-1.215369,41.54773],[-1.213455,41.548777],[-1.210978,41.55064],[-1.209693,41.551385],[-1.208531,41.551879],[-1.201965,41.553774],[-1.19939,41.554674],[-1.194879,41.556508],[-1.192691,41.557324],[-1.187755,41.559262],[-1.186212,41.559753],[-1.18407,41.560179],[-1.182173,41.560329],[-1.179852,41.560235],[-1.177942,41.559903],[-1.176031,41.559318],[-1.174125,41.558469],[-1.169558,41.555928],[-1.16321,41.552202],[-1.156901,41.548609],[-1.155504,41.547577],[-1.153256,41.545159],[-1.152252,41.544437],[-1.150887,41.543789],[-1.149674,41.543428],[-1.147772,41.543181],[-1.146013,41.543294],[-1.14378,41.543919],[-1.141841,41.545094],[-1.140886,41.546109],[-1.139758,41.54775],[-1.13892,41.548734],[-1.137368,41.550058],[-1.136154,41.550828],[-1.133993,41.552007],[-1.131948,41.553393],[-1.130962,41.554285],[-1.129673,41.555938],[-1.124973,41.56269],[-1.122794,41.565748],[-1.120975,41.568078],[-1.119226,41.569426],[-1.118231,41.569922],[-1.115116,41.571018],[-1.11376,41.571784],[-1.112821,41.572539],[-1.11154,41.574224],[-1.108787,41.57868],[-1.105811,41.583287],[-1.104363,41.584674],[-1.103177,41.585388],[-1.100939,41.586455],[-1.099284,41.58691],[-1.098131,41.587098],[-1.094238,41.587403],[-1.091296,41.587736],[-1.088708,41.588313],[-1.086939,41.589159],[-1.086055,41.589777],[-1.084813,41.591145],[-1.084275,41.591995],[-1.083731,41.593535],[-1.083466,41.595544],[-1.083017,41.596897],[-1.082561,41.597763],[-1.081654,41.59891],[-1.079007,41.601663],[-1.076915,41.60394],[-1.073463,41.607962],[-1.072399,41.609045],[-1.070263,41.610588],[-1.067315,41.612088],[-1.063625,41.613813],[-1.059318,41.615943],[-1.058021,41.616401],[-1.050979,41.618356],[-1.049537,41.618575],[-1.048072,41.618622],[-1.038341,41.617297],[-1.036612,41.617153],[-1.03522,41.617295],[-1.032828,41.618024],[-1.03268,41.618267],[-1.028228,41.620307],[-1.025826,41.621199],[-1.022181,41.621943],[-1.019791,41.62257],[-1.015956,41.623358],[-1.009764,41.624755],[-1.004634,41.626185],[-0.995503,41.628639],[-0.990216,41.63014],[-0.987585,41.630818],[-0.98124,41.632579],[-0.976858,41.633401],[-0.974857,41.634044],[-0.97305,41.635225],[-0.972315,41.636043],[-0.971704,41.637171],[-0.971489,41.637944],[-0.971428,41.639734],[-0.971268,41.640565],[-0.970836,41.641539],[-0.969902,41.642782],[-0.967129,41.645364],[-0.961543,41.650389],[-0.956657,41.654623],[-0.95424,41.656515],[-0.951309,41.658359],[-0.94894,41.659532],[-0.942686,41.662184],[-0.940798,41.663236],[-0.939628,41.664004],[-0.937453,41.665852],[-0.935818,41.667517],[-0.930567,41.672569],[-0.928699,41.674492],[-0.927523,41.675555],[-0.92646,41.675555],[-0.926245,41.674946],[-0.926862,41.674491],[-0.927441,41.674615],[-0.929287,41.676132],[-0.931773,41.677692],[-0.933975,41.67857],[-0.936591,41.679296],[-0.939515,41.68043],[-0.942347,41.681776],[-0.945307,41.683045],[-0.951773,41.68542],[-0.954449,41.686482],[-0.957178,41.687744],[-0.95885,41.688748],[-0.960203,41.689854],[-0.961552,41.690693],[-0.963619,41.691309],[-0.964856,41.691339],[-0.968735,41.690838],[-0.969949,41.690858],[-0.971323,41.691194],[-0.972143,41.691637],[-0.972484,41.692257],[-0.972827,41.691814],[-0.974143,41.691603],[-0.97409,41.691253],[-0.973492,41.691316],[-0.971018,41.690774],[-0.969858,41.69062],[-0.966638,41.690662],[-0.965406,41.690548],[-0.963909,41.690211],[-0.962618,41.689741],[-0.958223,41.687694],[-0.953952,41.685875],[-0.945947,41.682899],[-0.941549,41.681035],[-0.936793,41.678627],[-0.933937,41.677693],[-0.931936,41.677426],[-0.929827,41.677398],[-0.928309,41.677561],[-0.926502,41.677933],[-0.924223,41.678702],[-0.922332,41.67968],[-0.920641,41.680426],[-0.919474,41.680809],[-0.914502,41.68152],[-0.913144,41.681607],[-0.910075,41.681484],[-0.905973,41.680996],[-0.895111,41.679797],[-0.891844,41.679709],[-0.887298,41.679672],[-0.883126,41.679489],[-0.882066,41.679268],[-0.881539,41.678906],[-0.881168,41.678136],[-0.88086,41.674921],[-0.88022,41.668896],[-0.880309,41.666746],[-0.881147,41.661604],[-0.881211,41.660482],[-0.881606,41.657949],[-0.8808,41.657707],[-0.881095,41.657147],[-0.881625,41.657123],[-0.882096,41.656648],[-0.883576,41.657175],[-0.885394,41.657536],[-0.88868,41.657798],[-0.890327,41.658188],[-0.890516,41.658061],[-0.891071,41.655876],[-0.891283,41.655774],[-0.8936,41.656155],[-0.89714,41.655545],[-0.897869,41.655642],[-0.898414,41.655408],[-0.89796,41.654905],[-0.897228,41.654878],[-0.895729,41.654168],[-0.894632,41.653822],[-0.892898,41.653492],[-0.892471,41.653208],[-0.890852,41.651363],[-0.887953,41.64969],[-0.889044,41.64885],[-0.892307,41.650044],[-0.893592,41.650941],[-0.893272,41.651943],[-0.891665,41.652246],[-0.891647,41.652454],[-0.893249,41.654288],[-0.893626,41.655826],[-0.893446,41.656908],[-0.892473,41.658617],[-0.891829,41.658987],[-0.891626,41.659826],[-0.887455,41.664151],[-0.88649,41.664909],[-0.884512,41.665905],[-0.88209,41.666505],[-0.880581,41.666586],[-0.875493,41.666553],[-0.872015,41.666468],[-0.871856,41.666088],[-0.872068,41.663839],[-0.873224,41.661648],[-0.874451,41.658428],[-0.876208,41.658483],[-0.877534,41.659013],[-0.878771,41.6601],[-0.879446,41.660473],[-0.88048,41.660069],[-0.878801,41.659781],[-0.879776,41.660593],[-0.88068,41.661026],[-0.880863,41.662012],[-0.880076,41.666739],[-0.879949,41.668251],[-0.880314,41.67285],[-0.880221,41.673966],[-0.879698,41.675465],[-0.879097,41.6764],[-0.877674,41.677852],[-0.875599,41.679068],[-0.873347,41.679481],[-0.870353,41.679592],[-0.863983,41.679531],[-0.860819,41.679559],[-0.857568,41.679301],[-0.852761,41.678501],[-0.848844,41.677892],[-0.845511,41.67731],[-0.838854,41.676254],[-0.828615,41.674529],[-0.826602,41.674091],[-0.823676,41.673099],[-0.820932,41.671767],[-0.819538,41.670907],[-0.816925,41.669112],[-0.815984,41.668546],[-0.814143,41.667783],[-0.806485,41.665374],[-0.804228,41.664817],[-0.798443,41.66383],[-0.795391,41.663076],[-0.791086,41.661652],[-0.787666,41.660385],[-0.783314,41.658873],[-0.782513,41.658543],[-0.778854,41.657308],[-0.772437,41.655001],[-0.770871,41.654323],[-0.769948,41.653752],[-0.76847,41.652605],[-0.76738,41.651312],[-0.765718,41.648919],[-0.764396,41.64717],[-0.762804,41.645503],[-0.76144,41.6443],[-0.75941,41.642721],[-0.758091,41.641839],[-0.756195,41.640795],[-0.754043,41.639755],[-0.751107,41.638449],[-0.749087,41.637479],[-0.743813,41.634612],[-0.742094,41.633747],[-0.739671,41.632818],[-0.736657,41.631826],[-0.734264,41.630818],[-0.731719,41.629305],[-0.72917,41.627499],[-0.72697,41.626323],[-0.724225,41.625305],[-0.720234,41.624267],[-0.717798,41.623461],[-0.715233,41.622326],[-0.7136,41.621394],[-0.710881,41.619662],[-0.708438,41.61839],[-0.706858,41.617767],[-0.705,41.617216],[-0.701382,41.616281],[-0.69997,41.615504],[-0.698878,41.614227],[-0.698527,41.613433],[-0.698439,41.612604],[-0.698725,41.611157],[-0.698634,41.610202],[-0.697893,41.609039],[-0.697044,41.608402],[-0.69574,41.607936],[-0.694052,41.607693],[-0.692147,41.606953],[-0.688965,41.604852],[-0.688686,41.604501],[-0.687246,41.603799],[-0.683905,41.601465],[-0.683221,41.601089],[-0.67481,41.595584],[-0.663333,41.587814],[-0.660108,41.585688],[-0.649598,41.578658],[-0.646874,41.576759],[-0.64168,41.573504],[-0.636102,41.56993],[-0.634177,41.568648],[-0.62966,41.565757],[-0.624908,41.56301],[-0.621032,41.560931],[-0.616017,41.558958],[-0.615034,41.558463],[-0.613367,41.557274],[-0.609532,41.554311],[-0.607818,41.553106],[-0.606571,41.55247],[-0.604216,41.551499],[-0.601183,41.550561],[-0.597529,41.549637],[-0.594522,41.548222],[-0.589737,41.545552],[-0.587773,41.544151],[-0.586019,41.54265],[-0.581739,41.538744],[-0.579324,41.536486],[-0.578591,41.535941],[-0.577466,41.535451],[-0.570963,41.533183],[-0.569797,41.532932],[-0.568681,41.532422],[-0.567552,41.532145],[-0.565547,41.531352],[-0.562815,41.530542],[-0.556658,41.528945],[-0.550808,41.527487],[-0.544883,41.526093],[-0.53712,41.5242],[-0.534637,41.523509],[-0.529969,41.521588],[-0.520775,41.51768],[-0.517465,41.516232],[-0.503932,41.511624],[-0.499339,41.510364],[-0.498524,41.510241],[-0.496424,41.510257],[-0.492263,41.510167],[-0.488958,41.510459],[-0.473253,41.512371],[-0.4718,41.512522],[-0.464523,41.513451],[-0.461369,41.514106],[-0.45936,41.514146],[-0.452292,41.514043],[-0.445356,41.513278],[-0.440791,41.512541],[-0.431066,41.512113],[-0.417583,41.510477],[-0.415856,41.510342],[-0.413866,41.510419],[-0.412735,41.510566],[-0.405629,41.512181],[-0.403837,41.512455],[-0.402591,41.512389],[-0.401371,41.512145],[-0.399441,41.511306],[-0.395106,41.50839],[-0.39192,41.50677],[-0.387552,41.504299],[-0.384365,41.502812],[-0.381831,41.501878],[-0.377751,41.500516],[-0.376081,41.499756],[-0.373413,41.497953],[-0.371395,41.497239],[-0.370266,41.497009],[-0.365271,41.496319],[-0.363813,41.496241],[-0.360322,41.49639],[-0.357414,41.496006],[-0.353988,41.495377],[-0.352865,41.495287],[-0.350487,41.49571],[-0.348243,41.495983],[-0.346511,41.495884],[-0.343843,41.496305],[-0.342451,41.496391],[-0.340422,41.495883],[-0.339506,41.495807],[-0.334711,41.496117],[-0.325535,41.497237],[-0.324116,41.497164],[-0.314517,41.495259],[-0.307638,41.494409],[-0.305013,41.494279],[-0.302973,41.494557],[-0.296794,41.496201],[-0.292147,41.497606],[-0.291102,41.497853],[-0.289543,41.497997],[-0.288115,41.49849],[-0.285695,41.499756],[-0.28414,41.500277],[-0.282152,41.500383],[-0.281052,41.50024],[-0.278906,41.49972],[-0.277676,41.499172],[-0.275917,41.498037],[-0.274188,41.497206],[-0.273149,41.496894],[-0.268137,41.496323],[-0.26563,41.496379],[-0.260415,41.496073],[-0.256337,41.495987],[-0.249236,41.495151],[-0.242895,41.494163],[-0.239454,41.493792],[-0.237386,41.493389],[-0.234162,41.493689],[-0.232168,41.493517],[-0.229854,41.493674],[-0.228203,41.494224],[-0.225901,41.495152],[-0.22435,41.495435],[-0.220788,41.495342],[-0.219706,41.495448],[-0.217909,41.495885],[-0.212114,41.496264],[-0.211248,41.496225],[-0.204333,41.495603],[-0.20093,41.495234],[-0.1968,41.494309],[-0.195882,41.494179],[-0.191896,41.494183],[-0.190774,41.494297],[-0.188204,41.494851],[-0.185252,41.495109],[-0.179884,41.496012],[-0.166381,41.496738],[-0.162175,41.497126],[-0.159191,41.497307],[-0.158521,41.497258],[-0.155664,41.496405],[-0.152839,41.495657],[-0.15182,41.495805],[-0.150146,41.49679],[-0.146382,41.497884],[-0.145575,41.497977],[-0.136318,41.498297],[-0.134704,41.498246],[-0.13392,41.498071],[-0.12661,41.496068],[-0.12037,41.495108],[-0.114523,41.493457],[-0.11373,41.493269],[-0.111138,41.493218],[-0.10765,41.4933],[-0.09531,41.491944],[-0.094248,41.491987],[-0.092687,41.492269],[-0.088825,41.493325],[-0.079917,41.494238],[-0.075454,41.495015],[-0.073951,41.49496],[-0.071387,41.494274],[-0.070253,41.494076],[-0.068535,41.494182],[-0.065979,41.494749],[-0.060032,41.495989],[-0.059191,41.49612],[-0.054671,41.496147],[-0.052507,41.496687],[-0.048643,41.498582],[-0.045652,41.499391],[-0.043991,41.499516],[-0.039068,41.498915],[-0.03793,41.498849],[-0.036861,41.49897],[-0.030793,41.500254],[-0.02842,41.500423],[-0.025909,41.500359],[-0.024547,41.500529],[-0.019286,41.501459],[-0.017875,41.501994],[-0.014339,41.503618],[-0.012672,41.50392],[-0.011481,41.50385],[-0.004607,41.502671],[-0.003094,41.502536],[-0.001348,41.502574],[-0.000032,41.50286],[0.000661,41.503174],[0.002424,41.504301],[0.003283,41.504663],[0.0051,41.504945],[0.007341,41.504767],[0.01424,41.504048],[0.019428,41.503401],[0.022061,41.503025],[0.033901,41.501434],[0.035223,41.501352],[0.044014,41.501601],[0.045462,41.501749],[0.047408,41.502176],[0.049379,41.502906],[0.058463,41.507394],[0.060767,41.508435],[0.062024,41.508811],[0.064691,41.50927],[0.066882,41.509312],[0.068538,41.509129],[0.072069,41.508528],[0.073655,41.508452],[0.075514,41.508562],[0.077328,41.508859],[0.078816,41.509246],[0.087501,41.512366],[0.089641,41.513168],[0.091547,41.513581],[0.092529,41.513553],[0.099311,41.512778],[0.101229,41.512945],[0.106909,41.514727],[0.116089,41.517687],[0.12151,41.519367],[0.123234,41.519621],[0.124727,41.519618],[0.129204,41.519241],[0.136795,41.51854],[0.139109,41.518364],[0.141041,41.517919],[0.141996,41.517446],[0.143745,41.516075],[0.144584,41.515552],[0.145874,41.515046],[0.147038,41.514817],[0.148523,41.514775],[0.149681,41.51495],[0.162873,41.517995],[0.164076,41.518162],[0.181328,41.519857],[0.192387,41.520912],[0.19325,41.520891],[0.211557,41.519426],[0.235066,41.517492],[0.244207,41.516697],[0.25021,41.516225],[0.254036,41.515882],[0.256256,41.515626],[0.262959,41.514959],[0.27163,41.51404],[0.273634,41.513702],[0.275739,41.513189],[0.277445,41.512882],[0.279223,41.512703],[0.281676,41.512669],[0.284894,41.512904],[0.288083,41.512861],[0.290019,41.5126],[0.292543,41.511773],[0.295848,41.51014],[0.297989,41.50943],[0.29993,41.509082],[0.301956,41.508915],[0.304646,41.509196],[0.306853,41.509932],[0.308828,41.510895],[0.310136,41.511375],[0.312462,41.511705],[0.313946,41.51168],[0.315331,41.51147],[0.316578,41.511104],[0.318151,41.510171],[0.320924,41.509236],[0.322653,41.508911],[0.324937,41.508803],[0.326631,41.508991],[0.33013,41.509719],[0.332638,41.50997],[0.335797,41.50999],[0.339394,41.50974],[0.341249,41.50949],[0.34545,41.508788],[0.347899,41.50857],[0.350589,41.508584],[0.358261,41.508741],[0.359953,41.508914],[0.361557,41.509263],[0.363692,41.510142],[0.365014,41.510991],[0.372121,41.516194],[0.377297,41.520065],[0.379014,41.521055],[0.380196,41.521493],[0.38189,41.521886],[0.383281,41.522045],[0.385638,41.522136],[0.388072,41.522484],[0.389358,41.522875],[0.391348,41.524025],[0.392497,41.525097],[0.394175,41.527302],[0.395046,41.528269],[0.396455,41.529474],[0.397701,41.530255],[0.399732,41.531232],[0.401938,41.531928],[0.405443,41.53259],[0.406545,41.5327],[0.411424,41.533808],[0.417071,41.534931],[0.418288,41.5351],[0.426877,41.536779],[0.42833,41.536865],[0.441989,41.536815],[0.443365,41.536854],[0.444895,41.537079],[0.448052,41.538082],[0.450158,41.538592],[0.452492,41.53883],[0.454935,41.53865],[0.458687,41.538136],[0.460326,41.538109],[0.462268,41.538344],[0.46334,41.538613],[0.464878,41.539191],[0.46811,41.540566],[0.472596,41.542582],[0.47666,41.544529],[0.478264,41.545143],[0.486131,41.547768],[0.487374,41.548363],[0.488855,41.549397],[0.489834,41.550474],[0.490443,41.551504],[0.491551,41.554748],[0.492538,41.55691],[0.494035,41.559156],[0.495748,41.561044],[0.499189,41.563962],[0.500707,41.565386],[0.502014,41.566893],[0.503241,41.568712],[0.504944,41.571863],[0.505703,41.573104],[0.506896,41.574647],[0.509385,41.577462],[0.510414,41.57893],[0.512264,41.582073],[0.514465,41.58512],[0.517514,41.588036],[0.51907,41.589692],[0.52139,41.59247],[0.523137,41.594938],[0.525612,41.599132],[0.526971,41.600831],[0.528302,41.602017],[0.529382,41.602775],[0.531613,41.603941],[0.533512,41.604655],[0.536121,41.605747],[0.537635,41.606477],[0.540366,41.608129],[0.541995,41.609404],[0.543629,41.611251],[0.545191,41.613695],[0.546492,41.615236],[0.548741,41.617363],[0.549939,41.6189],[0.550612,41.620105],[0.551002,41.62112],[0.551398,41.623183],[0.551389,41.62524],[0.551586,41.626673],[0.55252,41.630028],[0.553138,41.633774],[0.55361,41.635211],[0.554686,41.637366],[0.555887,41.638954],[0.556826,41.639969],[0.558604,41.641487],[0.560196,41.642559],[0.562587,41.643925],[0.56427,41.645248],[0.566458,41.64741],[0.568578,41.648942],[0.572183,41.650806],[0.573349,41.651575],[0.575915,41.65363],[0.577907,41.655088],[0.580073,41.656345],[0.583571,41.65792],[0.58609,41.658868],[0.588404,41.659578],[0.591345,41.660322],[0.595585,41.661069],[0.59854,41.661435],[0.603686,41.661999],[0.608101,41.662706],[0.612855,41.663372],[0.61782,41.663823],[0.620591,41.66401],[0.625792,41.664169],[0.630172,41.664118],[0.635551,41.66385],[0.640223,41.663431],[0.643984,41.662933],[0.646709,41.662488],[0.647867,41.662203],[0.649816,41.661539],[0.652361,41.660243],[0.654816,41.658449],[0.657173,41.657051],[0.659049,41.656297],[0.663999,41.654891],[0.665754,41.654122],[0.667362,41.653195],[0.668995,41.651919],[0.670603,41.650088],[0.671284,41.648892],[0.672423,41.646102],[0.673163,41.64452],[0.674171,41.643011],[0.67509,41.641931],[0.677099,41.640152],[0.679486,41.638637],[0.681465,41.637753],[0.683054,41.63719],[0.686311,41.636166],[0.688689,41.635262],[0.690421,41.634428],[0.693628,41.632499],[0.695757,41.631348],[0.697803,41.630499],[0.700597,41.62978],[0.703228,41.629497],[0.705262,41.629516],[0.708388,41.629939],[0.712985,41.631265],[0.714682,41.631632],[0.71669,41.631911],[0.720744,41.632204],[0.726058,41.632693],[0.729665,41.63294],[0.734516,41.633057],[0.738181,41.63293],[0.74118,41.632689],[0.748563,41.631816],[0.750369,41.631665],[0.752802,41.631725],[0.755645,41.632269],[0.757235,41.632824],[0.758979,41.63364],[0.763012,41.635953],[0.766066,41.637373],[0.768757,41.638274],[0.770789,41.638726],[0.772897,41.639026],[0.775056,41.639207],[0.777195,41.639248],[0.779033,41.639127],[0.781745,41.638804],[0.784036,41.63839],[0.787323,41.637489],[0.793619,41.635455],[0.797048,41.634694],[0.799075,41.634431],[0.801088,41.634324],[0.804138,41.634393],[0.805663,41.634519],[0.810767,41.635201],[0.813411,41.635474],[0.816633,41.635626],[0.822435,41.635572],[0.825189,41.635658],[0.828205,41.635946],[0.833296,41.636595],[0.836641,41.636789],[0.840909,41.636714],[0.84307,41.636778],[0.848049,41.637231],[0.850239,41.637315],[0.853778,41.637277],[0.855353,41.637318],[0.858174,41.637545],[0.860313,41.637847],[0.864798,41.638665],[0.867254,41.638838],[0.870293,41.638899],[0.873313,41.639079],[0.87661,41.639621],[0.87864,41.640106],[0.88262,41.641177],[0.885825,41.641756],[0.888843,41.641987],[0.893349,41.641995],[0.894846,41.642056],[0.899648,41.642658],[0.90201,41.642883],[0.909431,41.643077],[0.914175,41.643568],[0.91686,41.643775],[0.919884,41.643833],[0.922582,41.643731],[0.924992,41.643524],[0.928222,41.643077],[0.941622,41.640774],[0.943908,41.640456],[0.947101,41.640113],[0.950641,41.639853],[0.95578,41.639725],[0.960733,41.639737],[0.966409,41.63969],[0.969537,41.639557],[0.971991,41.639347],[0.975005,41.638953],[0.977134,41.638546],[0.980417,41.63778],[0.984249,41.636812],[0.987237,41.636124],[0.990287,41.635626],[0.994056,41.635379],[0.997155,41.63547],[1.00347,41.636072],[1.005374,41.636128],[1.01387,41.636037],[1.016918,41.636195],[1.020247,41.636525],[1.022858,41.636604],[1.024539,41.636481],[1.02751,41.635862],[1.03175,41.634469],[1.032905,41.634209],[1.034959,41.633982],[1.040247,41.633999],[1.042183,41.634142],[1.042358,41.634276],[1.044912,41.63471],[1.053643,41.637502],[1.054669,41.637904],[1.056334,41.638754],[1.058171,41.639446],[1.069061,41.642771],[1.071154,41.643314],[1.076484,41.6446],[1.079665,41.645423],[1.083672,41.646824],[1.085155,41.647182],[1.090635,41.647711],[1.092479,41.648142],[1.093834,41.6488],[1.09528,41.649939],[1.095981,41.650831],[1.096864,41.65261],[1.097808,41.653949],[1.098521,41.654626],[1.100239,41.655762],[1.10171,41.656397],[1.103598,41.656885],[1.105275,41.657167],[1.107798,41.657434],[1.110056,41.657528],[1.113372,41.657429],[1.118864,41.656851],[1.120453,41.656801],[1.12335,41.657021],[1.125782,41.657417],[1.127614,41.657895],[1.129388,41.658543],[1.132597,41.659958],[1.134966,41.660763],[1.137229,41.661265],[1.139279,41.661569],[1.142443,41.661698],[1.145237,41.661466],[1.148703,41.660771],[1.15505,41.659071],[1.161539,41.657618],[1.162901,41.657184],[1.164917,41.656867],[1.166616,41.656955],[1.169124,41.657329],[1.174487,41.658245],[1.181497,41.658923],[1.183827,41.65937],[1.188672,41.660582],[1.192326,41.661265],[1.198303,41.662293],[1.201153,41.662611],[1.203411,41.663049],[1.204597,41.663396],[1.211307,41.66571],[1.216183,41.667347],[1.219025,41.668382],[1.220743,41.669179],[1.222488,41.670248],[1.227673,41.67587],[1.228614,41.676958],[1.229882,41.678146],[1.231764,41.679494],[1.233389,41.680349],[1.23545,41.681087],[1.237655,41.681501],[1.239558,41.681707],[1.241265,41.682033],[1.242734,41.682472],[1.246464,41.683793],[1.248293,41.684191],[1.25221,41.684745],[1.254084,41.685176],[1.255632,41.685663],[1.257855,41.686516],[1.259718,41.687037],[1.261854,41.687275],[1.263774,41.687181],[1.265414,41.686852],[1.267578,41.686221],[1.269781,41.685737],[1.271559,41.685514],[1.274843,41.685329],[1.276333,41.685151],[1.278023,41.684755],[1.280398,41.68377],[1.283195,41.682039],[1.285867,41.680053],[1.287553,41.678642],[1.288962,41.677183],[1.289854,41.67587],[1.290583,41.674137],[1.291064,41.671882],[1.291378,41.670972],[1.292015,41.669863],[1.292683,41.669028],[1.293668,41.668135],[1.295045,41.667312],[1.29635,41.666762],[1.299946,41.665693],[1.301997,41.664832],[1.303583,41.663859],[1.306819,41.661387],[1.309006,41.659498],[1.310581,41.658004],[1.311543,41.656927],[1.314177,41.653717],[1.316002,41.651662],[1.31794,41.649646],[1.319495,41.648164],[1.321863,41.646123],[1.32485,41.643698],[1.329462,41.640325],[1.332252,41.638572],[1.333552,41.637839],[1.337599,41.635857],[1.339585,41.635017],[1.342598,41.633862],[1.34577,41.632851],[1.347785,41.632302],[1.351559,41.631405],[1.353987,41.630969],[1.357433,41.630521],[1.364712,41.629775],[1.367288,41.629288],[1.369973,41.628499],[1.371578,41.627912],[1.373933,41.626863],[1.377947,41.62467],[1.379568,41.623902],[1.38181,41.623014],[1.383651,41.622407],[1.387084,41.621565],[1.390358,41.621082],[1.392662,41.620989],[1.396008,41.621341],[1.399304,41.622037],[1.402177,41.622413],[1.404029,41.622526],[1.40653,41.622439],[1.409631,41.622166],[1.412174,41.622157],[1.414526,41.622383],[1.417844,41.623069],[1.419094,41.623457],[1.422847,41.624974],[1.425082,41.625543],[1.427722,41.625748],[1.430163,41.62547],[1.433219,41.624539],[1.437489,41.622603],[1.438966,41.622093],[1.440542,41.621759],[1.442375,41.621626],[1.444546,41.621616],[1.446782,41.621986],[1.448079,41.622344],[1.449612,41.622944],[1.451482,41.624039],[1.453127,41.624795],[1.454391,41.625165],[1.458102,41.625844],[1.459147,41.62613],[1.46093,41.626812],[1.462041,41.6274],[1.464475,41.629018],[1.465397,41.629517],[1.467114,41.63021],[1.468692,41.630567],[1.470084,41.63073],[1.471781,41.630717],[1.473411,41.630509],[1.477462,41.629353],[1.478622,41.62912],[1.483355,41.628719],[1.484687,41.628465],[1.486483,41.627895],[1.487914,41.627193],[1.488932,41.62651],[1.491064,41.624858],[1.491935,41.624329],[1.493845,41.623485],[1.495693,41.623007],[1.497904,41.62277],[1.500129,41.622725],[1.501755,41.6226],[1.502979,41.622382],[1.504967,41.621742],[1.506026,41.621229],[1.508097,41.620002],[1.510531,41.618325],[1.511022,41.618292],[1.511996,41.617693],[1.513585,41.616987],[1.515264,41.616546],[1.51773,41.616286],[1.520355,41.6163],[1.521969,41.61619],[1.523868,41.615747],[1.525179,41.615208],[1.526332,41.614464],[1.527832,41.61301],[1.52907,41.611481],[1.531118,41.609554],[1.532192,41.608823],[1.535512,41.60694],[1.536788,41.60595],[1.537647,41.604991],[1.53839,41.603758],[1.539314,41.601851],[1.54018,41.60068],[1.541358,41.599639],[1.542543,41.598978],[1.54476,41.598429],[1.54753,41.598226],[1.549824,41.598234],[1.551103,41.598033],[1.552543,41.597639],[1.556262,41.596134],[1.557574,41.595694],[1.559635,41.59527],[1.562154,41.595022],[1.567612,41.594684],[1.568815,41.594664],[1.572794,41.594883],[1.574333,41.59486],[1.576138,41.594689],[1.588036,41.592968],[1.591192,41.592802],[1.593626,41.592351],[1.595926,41.591562],[1.596812,41.591355],[1.598948,41.591243],[1.600706,41.591465],[1.604375,41.59167],[1.605266,41.591844],[1.606567,41.592329],[1.608895,41.593607],[1.610725,41.594317],[1.613413,41.595136],[1.614493,41.595702],[1.615254,41.596309],[1.617672,41.598982],[1.618479,41.599764],[1.620319,41.601251],[1.62278,41.602684],[1.624483,41.603478],[1.626144,41.603954],[1.627534,41.604139],[1.62877,41.603986],[1.630706,41.603426],[1.633183,41.601855],[1.636803,41.599118],[1.639313,41.596811],[1.640304,41.596045],[1.641721,41.595225],[1.643343,41.594634],[1.646158,41.593877],[1.648654,41.592766],[1.650472,41.591649],[1.651741,41.591001],[1.653899,41.590143],[1.655526,41.589627],[1.657806,41.589148],[1.661458,41.588872],[1.664991,41.589011],[1.666121,41.588971],[1.668401,41.588572],[1.669956,41.588033],[1.670691,41.58763],[1.672324,41.587176],[1.674762,41.587056],[1.675924,41.587295],[1.67716,41.587794],[1.67859,41.589001],[1.679605,41.59083],[1.681239,41.594112],[1.682243,41.595095],[1.683233,41.595579],[1.684345,41.595883],[1.686044,41.595887],[1.688423,41.595483],[1.691926,41.595571],[1.693933,41.595872],[1.695061,41.596324],[1.697078,41.597848],[1.698067,41.598463],[1.701216,41.599578],[1.70316,41.599992],[1.704555,41.59996],[1.706116,41.599609],[1.709175,41.598381],[1.711205,41.597736],[1.713479,41.597294],[1.716712,41.596834],[1.718596,41.596233],[1.721336,41.59498],[1.722619,41.594552],[1.723929,41.594277],[1.725454,41.594374],[1.727888,41.594778],[1.74433,41.595584],[1.74476,41.595567],[1.74789,41.594686],[1.750797,41.593296],[1.752611,41.592607],[1.755325,41.591759],[1.756502,41.591681],[1.75809,41.591893],[1.759431,41.592541],[1.761174,41.593908],[1.762949,41.594572],[1.76518,41.5946],[1.766839,41.594102],[1.771211,41.591262],[1.771916,41.590656],[1.772754,41.589143],[1.772689,41.587275],[1.77282,41.586152],[1.773385,41.585108],[1.773963,41.584514],[1.776124,41.583032],[1.77748,41.581702],[1.778153,41.580573],[1.779286,41.577231],[1.780383,41.575663],[1.781132,41.574997],[1.782746,41.574091],[1.784401,41.573548],[1.789002,41.57262],[1.791476,41.571939],[1.792782,41.571406],[1.795794,41.569889],[1.797658,41.569106],[1.798854,41.568837],[1.802729,41.568501],[1.803833,41.56832],[1.806505,41.567647],[1.808101,41.56715],[1.809557,41.566378],[1.812257,41.5643],[1.813373,41.563607],[1.816471,41.562078],[1.817776,41.561691],[1.819158,41.561588],[1.820972,41.561864],[1.823395,41.562375],[1.824548,41.56247],[1.826277,41.56242],[1.827649,41.56217],[1.830942,41.561208],[1.832237,41.560633],[1.833745,41.559514],[1.835314,41.557361],[1.836513,41.556109],[1.837533,41.555311],[1.841525,41.552943],[1.850305,41.547956],[1.851469,41.547187],[1.853139,41.545798],[1.855095,41.54353],[1.856892,41.540898],[1.859271,41.537551],[1.861428,41.535489],[1.865318,41.532769],[1.867485,41.531703],[1.868498,41.531393],[1.870362,41.531073],[1.875272,41.530741],[1.876913,41.530345],[1.878084,41.529682],[1.878942,41.528805],[1.879963,41.527028],[1.880755,41.526185],[1.882025,41.525262],[1.885775,41.522987],[1.886742,41.522585],[1.887973,41.522303],[1.89107,41.521818],[1.892682,41.521362],[1.89393,41.520782],[1.895407,41.519812],[1.896817,41.518359],[1.897388,41.517451],[1.899608,41.513025],[1.900425,41.511749],[1.903118,41.508594],[1.904745,41.5066],[1.906091,41.504096],[1.907248,41.502573],[1.908577,41.501409],[1.909627,41.50071],[1.91104,41.499997],[1.913123,41.499292],[1.916623,41.498349],[1.918315,41.497593],[1.92004,41.496464],[1.928775,41.49003],[1.929273,41.4898],[1.932155,41.487636],[1.933937,41.485445],[1.934888,41.483939],[1.935778,41.481915],[1.936723,41.478556],[1.937186,41.477512],[1.938044,41.476134],[1.938929,41.47508],[1.940776,41.473188],[1.942867,41.471425],[1.94468,41.47021],[1.947055,41.469648],[1.948507,41.469529],[1.950253,41.469643],[1.952498,41.470214],[1.954044,41.470898],[1.955393,41.471318],[1.957395,41.471585],[1.959412,41.471429],[1.960791,41.471096],[1.962369,41.470555],[1.965201,41.469071],[1.966481,41.468201],[1.967845,41.466994],[1.972452,41.462295],[1.974136,41.459637],[1.97497,41.457637],[1.975307,41.456116],[1.975526,41.453937],[1.976019,41.451596],[1.976814,41.449745],[1.978289,41.447646],[1.980071,41.445927],[1.985498,41.441608],[1.987911,41.440093],[1.989908,41.438981],[1.99186,41.437347],[1.992846,41.436058],[1.995881,41.431279],[1.996646,41.43028],[1.999658,41.42729],[2.000415,41.426409],[2.001092,41.425207],[2.002956,41.420729],[2.003667,41.418841],[2.004117,41.417098],[2.00468,41.415777],[2.005619,41.414305],[2.007025,41.412682],[2.007698,41.411732],[2.00896,41.409362],[2.010105,41.40745],[2.01169,41.404298],[2.013556,41.401344],[2.015168,41.398263],[2.017673,41.392385],[2.01877,41.390149],[2.020543,41.387065],[2.022082,41.384631],[2.022936,41.383144],[2.02371,41.381207],[2.023942,41.380003],[2.02484,41.378584],[2.025728,41.37797],[2.027404,41.377349],[2.02846,41.377202],[2.031286,41.377089],[2.032509,41.376701],[2.033096,41.376234],[2.034826,41.374224],[2.036158,41.37283],[2.037467,41.371714],[2.039986,41.37026],[2.044971,41.36847],[2.045832,41.36806],[2.047445,41.367057],[2.048338,41.366292],[2.049247,41.365263],[2.050214,41.363401],[2.050538,41.362306],[2.050772,41.35998],[2.051078,41.358354],[2.051581,41.357152],[2.052128,41.356289],[2.053848,41.354586],[2.057622,41.352002],[2.059903,41.350566],[2.062481,41.349186],[2.063876,41.348562],[2.065918,41.347803],[2.068546,41.346993],[2.07151,41.346348],[2.080927,41.345236],[2.083171,41.345021],[2.085572,41.344928],[2.087125,41.345],[2.089844,41.344646],[2.091435,41.344085],[2.092656,41.34348],[2.094775,41.342143],[2.096536,41.341332],[2.098329,41.340733],[2.099554,41.340124],[2.101262,41.338904],[2.102347,41.338612],[2.103181,41.338683],[2.104159,41.339071],[2.104866,41.339898],[2.105842,41.342406],[2.109311,41.345088],[2.115995,41.350096],[2.118318,41.351609],[2.119906,41.352737],[2.126178,41.357645],[2.126783,41.358004],[2.131195,41.361294],[2.134235,41.363773],[2.135851,41.364706],[2.134017,41.367244],[2.127349,41.385794],[2.127231,41.387092],[2.127387,41.38795],[2.128015,41.389963],[2.128866,41.391568],[2.129731,41.392391],[2.133899,41.396],[2.132888,41.397103],[2.133112,41.398092],[2.13483,41.399941],[2.137237,41.402107],[2.137824,41.402816],[2.139282,41.403872],[2.142549,41.40506],[2.144212,41.405444],[2.147336,41.405778],[2.148675,41.406144],[2.151096,41.408057],[2.154484,41.409236],[2.155607,41.40987],[2.158594,41.411797],[2.159741,41.412323],[2.161842,41.412494],[2.164153,41.411771],[2.165082,41.411755],[2.167368,41.412335],[2.167092,41.412695],[2.166134,41.412066],[2.164598,41.411897],[2.164291,41.412214],[2.162962,41.414257],[2.161591,41.413773],[2.161052,41.414202],[2.160966,41.415052],[2.162189,41.416402],[2.162948,41.416696],[2.16388,41.416377],[2.162874,41.417249],[2.161404,41.416762],[2.159957,41.415963],[2.160863,41.415115],[2.162213,41.416417],[2.162949,41.416696],[2.164428,41.416165],[2.16606,41.41511],[2.16601,41.414732],[2.167961,41.415725],[2.169306,41.415612],[2.169646,41.414746],[2.170965,41.413769],[2.173737,41.415802],[2.174562,41.416718],[2.176809,41.41863],[2.178787,41.418865],[2.180462,41.419209],[2.181184,41.419554],[2.186992,41.415282],[2.191278,41.412024],[2.191515,41.412073],[2.200259,41.418597],[2.204345,41.421713],[2.209126,41.425261],[2.208105,41.424727],[2.207004,41.425326],[2.205595,41.425725],[2.207333,41.425064],[2.208123,41.424541],[2.209093,41.425109],[2.20956,41.425672],[2.210655,41.426432],[2.211713,41.427621],[2.212486,41.427403],[2.215265,41.428321],[2.216019,41.428088],[2.218344,41.426251],[2.219553,41.425434],[2.220512,41.424535],[2.218933,41.423438],[2.218059,41.424337],[2.218559,41.425765],[2.219998,41.427704],[2.221519,41.429171],[2.224122,41.427941],[2.224361,41.428],[2.222409,41.429034],[2.220514,41.431219],[2.217226,41.433303],[2.217113,41.433516],[2.21814,41.43399],[2.22107,41.435613],[2.226999,41.438659],[2.228372,41.440209],[2.231258,41.443077],[2.233314,41.445375],[2.236145,41.44818],[2.241072,41.452417],[2.242494,41.453418],[2.245874,41.455076],[2.249986,41.457524],[2.251633,41.458172],[2.256554,41.459289],[2.259572,41.460131],[2.262243,41.461026],[2.26548,41.462224],[2.267578,41.463113],[2.27104,41.464753],[2.271835,41.465045],[2.274922,41.465688],[2.276177,41.466253],[2.276941,41.466789],[2.277738,41.467617],[2.279141,41.469546],[2.281807,41.471953],[2.283483,41.474227],[2.285381,41.47616],[2.286606,41.477062],[2.288783,41.478172],[2.289861,41.47843],[2.290572,41.478388],[2.291725,41.477787],[2.292279,41.476744],[2.292437,41.475526],[2.291958,41.473426],[2.292541,41.471703],[2.294523,41.472011],[2.298949,41.473546],[2.301678,41.474316],[2.306559,41.475934],[2.30799,41.476465],[2.310201,41.477074],[2.313684,41.477746],[2.317624,41.47867],[2.320711,41.479294],[2.325657,41.480465],[2.326746,41.480671],[2.333744,41.482421],[2.3401,41.483664],[2.344236,41.48476],[2.34791,41.485869],[2.353566,41.487389],[2.355184,41.487895],[2.36208,41.489845],[2.367709,41.491693],[2.369675,41.49239],[2.375719,41.49434],[2.379908,41.4958],[2.386157,41.499006],[2.390188,41.500885],[2.391531,41.501436],[2.394917,41.503114],[2.396327,41.503876],[2.400533,41.506293],[2.407851,41.511308],[2.413472,41.515673],[2.415733,41.517531],[2.416123,41.518123],[2.416239,41.518902],[2.416028,41.51966],[2.415262,41.52051],[2.413152,41.522133],[2.411911,41.52368],[2.411567,41.52454],[2.411579,41.525996],[2.411911,41.52685],[2.413808,41.53034],[2.414474,41.531168],[2.415573,41.532166],[2.416404,41.533111],[2.417145,41.534373],[2.417259,41.536033],[2.416913,41.537143],[2.416214,41.538146],[2.41515,41.539265],[2.414495,41.540295],[2.414099,41.541401],[2.41402,41.542308],[2.414164,41.543642],[2.414528,41.544518],[2.415473,41.545893],[2.416695,41.546981],[2.419073,41.548321],[2.421406,41.549333],[2.424978,41.550401],[2.427893,41.551076],[2.430349,41.55174],[2.433155,41.552756],[2.436955,41.554637],[2.438809,41.555222],[2.440809,41.555472],[2.441971,41.55547],[2.445458,41.555258],[2.450193,41.555386],[2.451955,41.555529],[2.454511,41.555978],[2.458603,41.557203],[2.461224,41.557846],[2.463966,41.55862],[2.466413,41.559124],[2.468753,41.559235],[2.469787,41.55915],[2.470921,41.559753],[2.471468,41.559813],[2.472322,41.559256],[2.472322,41.558414],[2.471795,41.556626],[2.471902,41.555944],[2.472396,41.555141],[2.474238,41.553168],[2.475704,41.551085],[2.476007,41.550264],[2.476214,41.548614],[2.480502,41.549582],[2.48351,41.550349],[2.486346,41.551187],[2.490582,41.552307],[2.492132,41.552612],[2.493597,41.553098],[2.495377,41.553919],[2.496116,41.554525],[2.497123,41.555013],[2.497344,41.555365],[2.500485,41.556668],[2.503761,41.558346],[2.506696,41.559944],[2.517035,41.565031],[2.521476,41.567251],[2.525018,41.568179],[2.526062,41.568389],[2.530427,41.570036],[2.532038,41.570805],[2.534446,41.571689],[2.535506,41.572189],[2.536346,41.572809],[2.537983,41.572785],[2.539147,41.573368],[2.539691,41.573859],[2.543986,41.575614],[2.545444,41.575952],[2.546894,41.576455],[2.548915,41.577616],[2.553734,41.579403],[2.554825,41.579648],[2.558128,41.579961],[2.560226,41.580635],[2.563108,41.580676],[2.564471,41.58102],[2.56493,41.581531],[2.565125,41.582209],[2.565568,41.582545],[2.567595,41.583611],[2.568631,41.584038],[2.570689,41.584553],[2.574567,41.585223],[2.576565,41.584985],[2.577538,41.585186],[2.578699,41.585948],[2.580881,41.586615],[2.582053,41.587136],[2.583998,41.587438],[2.585162,41.587779],[2.587018,41.588712],[2.589062,41.589604],[2.589414,41.589619],[2.592589,41.590799],[2.596697,41.591718],[2.598553,41.592263],[2.601268,41.593528],[2.603915,41.594403],[2.607392,41.595095],[2.609083,41.595595],[2.612528,41.597103],[2.613164,41.59747],[2.616149,41.599629],[2.619101,41.601295],[2.621628,41.602192],[2.623641,41.603751],[2.624522,41.604099],[2.625645,41.603627],[2.626267,41.602634],[2.627515,41.602513],[2.630276,41.603853],[2.631351,41.604231],[2.634702,41.604713],[2.640194,41.606077],[2.641923,41.606664],[2.643432,41.606883],[2.644896,41.607388],[2.646559,41.607733],[2.646935,41.608158],[2.647241,41.609452],[2.647058,41.610065],[2.647383,41.610876],[2.650857,41.612264],[2.652235,41.61288],[2.655188,41.613985],[2.656921,41.614306],[2.658236,41.615309],[2.659853,41.616036],[2.663851,41.618557],[2.665255,41.619502],[2.666821,41.620793],[2.669692,41.621949],[2.671132,41.62221],[2.673077,41.622711],[2.673959,41.623333],[2.674961,41.623716],[2.675268,41.624065],[2.677146,41.62474],[2.679674,41.62504],[2.6814,41.625379],[2.683585,41.626278],[2.68678,41.62732],[2.689197,41.628861],[2.689771,41.629122],[2.697383,41.63132],[2.702762,41.632983],[2.703625,41.632999],[2.704269,41.63343],[2.70959,41.635137],[2.710762,41.635277],[2.711189,41.6356],[2.716632,41.637325],[2.726199,41.642672],[2.727516,41.643729],[2.730887,41.646277],[2.732937,41.647484],[2.733883,41.648297],[2.734913,41.649537],[2.735397,41.650751],[2.735395,41.651302],[2.734739,41.654943],[2.73425,41.655935],[2.732932,41.657368],[2.732616,41.658414],[2.732678,41.659249],[2.732388,41.661167],[2.73175,41.663637],[2.731483,41.665219],[2.731062,41.666213],[2.730292,41.667099],[2.727542,41.669894],[2.726768,41.671082],[2.726257,41.67491],[2.725941,41.675956],[2.725549,41.676229],[2.721756,41.680298],[2.721499,41.681168],[2.721987,41.686441],[2.722873,41.691194],[2.723528,41.693043],[2.725594,41.695765],[2.729435,41.700662],[2.730625,41.702008],[2.730977,41.703207],[2.731323,41.703507],[2.730989,41.704186],[2.731081,41.707841],[2.73066,41.710669],[2.73058,41.713696],[2.731248,41.715579],[2.731635,41.716088],[2.733481,41.71775],[2.734742,41.718413],[2.735201,41.719179],[2.73513,41.721095],[2.735565,41.722495],[2.736292,41.72361],[2.736447,41.724184],[2.736319,41.726636],[2.736429,41.728918],[2.736684,41.729456],[2.737888,41.730483],[2.740229,41.731905],[2.741206,41.733285],[2.741749,41.733708],[2.745726,41.735396],[2.746625,41.736515],[2.746737,41.737949],[2.746715,41.739475],[2.74723,41.740409],[2.748836,41.74151],[2.749445,41.742621],[2.749225,41.743513],[2.7494,41.744446],[2.75198,41.747811],[2.753189,41.748716],[2.755081,41.749657],[2.75595,41.750517],[2.756211,41.751064],[2.756125,41.752913],[2.756436,41.755987],[2.756651,41.756726],[2.757743,41.758546],[2.758456,41.760316],[2.758719,41.761766],[2.758399,41.764681],[2.758887,41.769508],[2.759021,41.772064],[2.75857,41.773788],[2.758653,41.775903],[2.759444,41.778981],[2.759473,41.779504],[2.75822,41.783835],[2.758386,41.784698],[2.75926,41.785533],[2.760456,41.785381],[2.76438,41.784425],[2.76705,41.783955],[2.769746,41.783728],[2.771156,41.783686],[2.774104,41.783768],[2.777001,41.783998],[2.780955,41.784621],[2.783237,41.785135],[2.785419,41.785756],[2.78965,41.787141],[2.795537,41.789217],[2.802132,41.791404],[2.810139,41.794097],[2.81291,41.795237],[2.820978,41.798654],[2.822298,41.799062],[2.823991,41.799231],[2.825674,41.799201],[2.827022,41.799372],[2.835052,41.801065],[2.839062,41.802176],[2.840725,41.802296],[2.843747,41.802065],[2.845578,41.802554],[2.847744,41.803799],[2.849594,41.804189],[2.850913,41.804168],[2.852575,41.804451],[2.855949,41.805538],[2.857571,41.806565],[2.858661,41.807801],[2.859481,41.808314],[2.861041,41.808725],[2.866284,41.808838],[2.870098,41.809194],[2.872396,41.809027],[2.875828,41.808355],[2.878283,41.808167],[2.880477,41.808313],[2.88381,41.808833],[2.888862,41.809321],[2.892252,41.809853],[2.894568,41.810582],[2.89567,41.811089],[2.897119,41.812064],[2.898503,41.813415],[2.899464,41.814939],[2.90039,41.816994],[2.901192,41.818291],[2.902458,41.819578],[2.90357,41.820345],[2.905061,41.821012],[2.908574,41.821775],[2.913112,41.823548],[2.916899,41.825077],[2.918105,41.825695],[2.919726,41.827363],[2.920664,41.82809],[2.921621,41.828444],[2.923278,41.828533],[2.925746,41.828068],[2.926559,41.828077],[2.928817,41.828898],[2.931429,41.8296],[2.933261,41.82958],[2.937187,41.828875],[2.940326,41.828127],[2.944189,41.827403],[2.947689,41.826918],[2.949176,41.826842],[2.951293,41.826899],[2.955115,41.827161],[2.963001,41.827617],[2.965389,41.827562],[2.968977,41.827207],[2.97014,41.827006],[2.971704,41.826413],[2.974504,41.824487],[2.975804,41.823276],[2.977813,41.820832],[2.979326,41.819221],[2.980277,41.818419],[2.982061,41.817282],[2.983579,41.816539],[2.985971,41.815511],[2.989821,41.813523],[2.995196,41.810041],[2.996876,41.809201],[2.998212,41.808811],[2.999938,41.808602],[3.00196,41.808567],[3.005161,41.808635],[3.006672,41.808593],[3.008762,41.808339],[3.014774,41.807087],[3.017445,41.806682],[3.020708,41.806285],[3.02251,41.806177],[3.026049,41.806136],[3.02817,41.806257],[3.030434,41.806797],[3.034082,41.808205],[3.036527,41.809013],[3.038353,41.80945],[3.040015,41.810113],[3.040929,41.811089],[3.041232,41.812241],[3.041275,41.81368],[3.041455,41.814488],[3.042339,41.815681],[3.043626,41.816451],[3.045586,41.817256],[3.047975,41.817966],[3.051399,41.8188],[3.05259,41.819226],[3.053443,41.819726],[3.057357,41.822513],[3.058095,41.823222],[3.059222,41.825341],[3.060099,41.826158],[3.06354,41.828161],[3.065244,41.828803],[3.068303,41.829517],[3.069159,41.829952],[3.070109,41.830795],[3.070709,41.832087],[3.070974,41.835709],[3.070984,41.837284],[3.071538,41.838667],[3.072434,41.839393],[3.073964,41.839867],[3.076346,41.840284],[3.077797,41.841017],[3.078736,41.842306],[3.078822,41.843248],[3.078483,41.844176],[3.075483,41.847838],[3.074112,41.850243],[3.07272,41.854189],[3.072699,41.855464],[3.073138,41.856247],[3.073916,41.856815],[3.07494,41.857149],[3.076297,41.857119],[3.07906,41.856444],[3.080217,41.85627],[3.081341,41.85635],[3.082488,41.856691],[3.085992,41.857979],[3.087335,41.858371],[3.088761,41.85851],[3.093082,41.858566],[3.094545,41.85888],[3.098235,41.85991],[3.099365,41.860145],[3.104864,41.860816],[3.106047,41.860769],[3.109683,41.859852],[3.111388,41.859756],[3.113115,41.859901],[3.114574,41.85984],[3.115738,41.859591],[3.117603,41.858777],[3.118743,41.858416],[3.120283,41.858203],[3.121212,41.85825],[3.122929,41.858674],[3.123935,41.859145],[3.128307,41.861598],[3.13014,41.863099],[3.131298,41.863821],[3.134105,41.86464],[3.135607,41.865375],[3.136417,41.866038],[3.137054,41.866817],[3.13749,41.867679],[3.138267,41.870832],[3.138804,41.873347],[3.139941,41.878212],[3.14031,41.879489],[3.141685,41.882681],[3.142267,41.885697],[3.143363,41.890891],[3.143847,41.892982],[3.1447,41.897408],[3.145633,41.900465],[3.146581,41.904194],[3.146709,41.90553],[3.147634,41.912073],[3.147879,41.91221],[3.150904,41.912598],[3.152564,41.912908],[3.15331,41.912873],[3.15584,41.910539],[3.156133,41.910588],[3.161837,41.909913],[3.164523,41.909332],[3.165706,41.909654],[3.167989,41.911023],[3.168703,41.911116],[3.172621,41.908456],[3.173798,41.907429],[3.177027,41.90342],[3.184754,41.896657],[3.188565,41.892782],[3.188604,41.893154],[3.187592,41.893975],[3.186602,41.895086],[3.18563,41.895906],[3.184035,41.89752],[3.179216,41.901614],[3.177067,41.903544],[3.174858,41.90637],[3.173831,41.907576],[3.172721,41.908509],[3.169957,41.910406],[3.16847,41.911582],[3.16802,41.911112],[3.166551,41.910145],[3.165013,41.909499],[3.165232,41.910561],[3.166446,41.91144],[3.16729,41.91079],[3.167807,41.910791],[3.165975,41.909976],[3.165086,41.909467],[3.164198,41.909442],[3.161647,41.910003],[3.156278,41.910602],[3.155943,41.910872],[3.153689,41.908908],[3.153214,41.908638],[3.151881,41.908375],[3.149596,41.908446],[3.146921,41.908291],[3.146483,41.905931],[3.146139,41.903241],[3.145611,41.900803],[3.145287,41.899785],[3.144198,41.895378],[3.144046,41.894014],[3.143515,41.891963],[3.143536,41.891283],[3.143052,41.890058],[3.143,41.889249],[3.142519,41.887758],[3.142351,41.885754],[3.142055,41.885387],[3.141702,41.883206],[3.141359,41.882118],[3.139973,41.878934],[3.138896,41.874421],[3.138716,41.873304],[3.138329,41.872084],[3.13815,41.870615],[3.137834,41.870009],[3.137241,41.867299],[3.136556,41.866376],[3.135805,41.865699],[3.134183,41.864817],[3.13113,41.863912],[3.129693,41.863051],[3.128906,41.862204],[3.127697,41.861209],[3.125869,41.86031],[3.124242,41.859343],[3.123191,41.858884],[3.1217,41.858446],[3.1201,41.858328],[3.118758,41.858465],[3.117715,41.858842],[3.116304,41.859609],[3.114748,41.860008],[3.112701,41.86007],[3.110429,41.859906],[3.108497,41.860202],[3.106605,41.860762],[3.105616,41.860904],[3.104223,41.860855],[3.101467,41.860568],[3.098137,41.860042],[3.094821,41.859081],[3.092866,41.858711],[3.091139,41.858606],[3.088806,41.858678],[3.086379,41.858298],[3.081411,41.856615],[3.080648,41.85648],[3.079117,41.856605],[3.076549,41.857214],[3.075496,41.857346],[3.0743,41.857154],[3.073529,41.856828],[3.07266,41.855908],[3.072335,41.855012],[3.072785,41.853564],[3.073254,41.851311],[3.073816,41.850003],[3.074891,41.848063],[3.078083,41.844148],[3.078543,41.842992],[3.078279,41.841861],[3.077672,41.841102],[3.077027,41.840654],[3.074633,41.840005],[3.073064,41.839802],[3.07189,41.83923],[3.071108,41.83806],[3.070918,41.837076],[3.070849,41.834635],[3.07068,41.834049],[3.070581,41.83242],[3.07028,41.831269],[3.069628,41.830315],[3.0687,41.829742],[3.067561,41.82938],[3.065649,41.829031],[3.064046,41.82857],[3.062319,41.827744],[3.060303,41.826504],[3.059384,41.825832],[3.058977,41.825283],[3.058027,41.823463],[3.057652,41.822977],[3.054424,41.820571],[3.052568,41.819359],[3.051808,41.819026],[3.04679,41.817774],[3.043106,41.816536],[3.041354,41.815119],[3.04109,41.813236],[3.041359,41.812718],[3.041002,41.811208],[3.040475,41.810419],[3.039717,41.809774],[3.038335,41.809089],[3.037358,41.809206],[3.036322,41.809032],[3.033728,41.808192],[3.030434,41.80697],[3.028858,41.806551],[3.027104,41.806322],[3.025103,41.806264],[3.020726,41.806547],[3.017778,41.806628],[3.013261,41.807692],[3.013022,41.807639],[3.009661,41.808354],[3.007558,41.8086],[3.00414,41.808714],[3.000393,41.808719],[2.999276,41.808791],[2.99649,41.809392],[2.994432,41.810356],[2.990704,41.813009],[2.989188,41.814005],[2.987406,41.814947],[2.981424,41.817817],[2.979978,41.818965],[2.97874,41.820092],[2.976566,41.822631],[2.974963,41.824197],[2.972138,41.826281],[2.970611,41.827091],[2.969233,41.82737],[2.96381,41.82776],[2.961556,41.827654],[2.960039,41.827466],[2.956898,41.827407],[2.951601,41.82711],[2.947648,41.827061],[2.945878,41.827254],[2.942012,41.827934],[2.938927,41.828886],[2.937959,41.82957],[2.937527,41.830142],[2.935986,41.831239],[2.934124,41.831318],[2.931333,41.829829],[2.929495,41.829299],[2.926582,41.828327],[2.925632,41.828233],[2.923479,41.828647],[2.922424,41.828713],[2.920624,41.828276],[2.919965,41.82789],[2.91866,41.826347],[2.917105,41.82532],[2.909311,41.822338],[2.907395,41.821647],[2.904927,41.821188],[2.90319,41.820381],[2.901615,41.819019],[2.900963,41.818256],[2.899555,41.815407],[2.898609,41.813764],[2.897419,41.812458],[2.895162,41.811035],[2.893328,41.810374],[2.891398,41.809874],[2.889658,41.809585],[2.885709,41.80927],[2.879493,41.808382],[2.876813,41.808341],[2.87449,41.808678],[2.871338,41.809381],[2.869884,41.809349],[2.866616,41.808981],[2.864752,41.808893],[2.863609,41.808961],[2.861226,41.808908],[2.860164,41.808764],[2.858751,41.808133],[2.856989,41.806191],[2.855892,41.805689],[2.852183,41.804466],[2.851341,41.804309],[2.849386,41.804252],[2.847993,41.804054],[2.844872,41.80243],[2.84398,41.802177],[2.843003,41.802138],[2.840727,41.802421],[2.838699,41.8022],[2.83524,41.801175],[2.830938,41.800302],[2.828041,41.799625],[2.825545,41.799245],[2.823158,41.799288],[2.821493,41.799009],[2.82035,41.798568],[2.809606,41.794065],[2.807417,41.793329],[2.803914,41.792259],[2.800078,41.79092],[2.789879,41.787464],[2.786641,41.786297],[2.784711,41.785706],[2.781649,41.784933],[2.779413,41.784473],[2.775771,41.783961],[2.773079,41.783814],[2.769568,41.783857],[2.767006,41.784058],[2.765566,41.784291],[2.761042,41.785421],[2.759232,41.785982],[2.758147,41.786974],[2.757324,41.787196],[2.757062,41.787615],[2.756168,41.79022],[2.756123,41.791024],[2.757003,41.792751],[2.759165,41.7959],[2.761459,41.799708],[2.763313,41.801923],[2.763825,41.80283],[2.7643,41.804676],[2.764099,41.811698],[2.764174,41.812287],[2.764145,41.815902],[2.764199,41.816755],[2.764037,41.818227],[2.763241,41.82068],[2.763245,41.822406],[2.763404,41.824284],[2.763279,41.825591],[2.762868,41.827049],[2.761955,41.828704],[2.760707,41.830215],[2.75967,41.831812],[2.759025,41.833759],[2.758915,41.835112],[2.759246,41.837293],[2.760389,41.841161],[2.760961,41.84333],[2.761373,41.844397],[2.762431,41.845933],[2.763716,41.847055],[2.764846,41.847654],[2.766386,41.84826],[2.769324,41.849214],[2.770737,41.849943],[2.772267,41.851244],[2.773113,41.852374],[2.773857,41.85398],[2.774719,41.857829],[2.77699,41.866203],[2.777273,41.866781],[2.77784,41.868916],[2.77827,41.869216],[2.77884,41.869135],[2.779213,41.868391],[2.778554,41.867917],[2.775677,41.868124],[2.771902,41.868625],[2.769326,41.869098],[2.767429,41.869709],[2.765144,41.870714],[2.763929,41.871357],[2.761907,41.872665],[2.7611,41.873339],[2.758851,41.874437],[2.757218,41.874949],[2.752575,41.875547],[2.750483,41.87556],[2.746903,41.875724],[2.744491,41.876037],[2.739266,41.877358],[2.737589,41.878069],[2.734821,41.878923],[2.732223,41.879542],[2.725701,41.880666],[2.724047,41.88087],[2.722061,41.880949],[2.719723,41.880879],[2.714267,41.880327],[2.711479,41.880121],[2.70847,41.879804],[2.703026,41.879431],[2.69925,41.878534],[2.697217,41.878332],[2.693844,41.878614],[2.692805,41.878797],[2.691285,41.879351],[2.688987,41.880536],[2.687856,41.881414],[2.68662,41.882031],[2.684475,41.882824],[2.681131,41.883678],[2.680098,41.884031],[2.677894,41.885148],[2.677268,41.885346],[2.676949,41.885788],[2.675833,41.886568],[2.672908,41.888207],[2.671594,41.888733],[2.666901,41.890819],[2.665665,41.891198],[2.663393,41.891556],[2.660706,41.891379],[2.657455,41.890696],[2.656283,41.890325],[2.655415,41.889872],[2.653819,41.888304],[2.652771,41.886498],[2.651598,41.885175],[2.65023,41.884041],[2.647852,41.882392],[2.646492,41.881805],[2.643854,41.881225],[2.642227,41.880687],[2.640827,41.879587],[2.639253,41.877917],[2.638449,41.877296],[2.636848,41.876655],[2.635329,41.876302],[2.632758,41.875999],[2.631603,41.87566],[2.629255,41.87478],[2.626654,41.874421],[2.624633,41.874572],[2.621207,41.87412],[2.618755,41.873478],[2.617034,41.873348],[2.61585,41.873595],[2.613644,41.874559],[2.611281,41.875037],[2.605377,41.874382],[2.598319,41.873705],[2.596309,41.873227],[2.595066,41.87258],[2.593565,41.871122],[2.593156,41.870164],[2.59286,41.868712],[2.592312,41.867504],[2.591223,41.866308],[2.590215,41.865769],[2.58712,41.865187],[2.584107,41.864782],[2.582218,41.863909],[2.581052,41.863026],[2.579219,41.861952],[2.5777,41.861319],[2.575846,41.860779],[2.574214,41.860418],[2.572704,41.859561],[2.571635,41.858391],[2.571024,41.857333],[2.569966,41.856089],[2.568697,41.855367],[2.567613,41.855055],[2.56504,41.85484],[2.563248,41.854405],[2.562529,41.853971],[2.560128,41.851967],[2.559522,41.851573],[2.557868,41.850957],[2.555693,41.85058],[2.553616,41.849856],[2.550305,41.849289],[2.548415,41.84877],[2.545754,41.848365],[2.543946,41.84835],[2.543201,41.848474],[2.540656,41.848316],[2.537517,41.847916],[2.521028,41.850226],[2.519171,41.850531],[2.518245,41.850824],[2.516153,41.851984],[2.51456,41.853296],[2.513873,41.854577],[2.513502,41.856784],[2.512808,41.857757],[2.511349,41.858634],[2.510038,41.858965],[2.508718,41.858944],[2.507107,41.858506],[2.505876,41.857535],[2.503487,41.854789],[2.499391,41.85188],[2.498207,41.851605],[2.496934,41.851491],[2.494785,41.851849],[2.49314,41.852505],[2.491712,41.852875],[2.487709,41.853407],[2.48365,41.853685],[2.48237,41.853606],[2.480173,41.853192],[2.478364,41.852505],[2.477314,41.851662],[2.475078,41.849057],[2.470131,41.844887],[2.469261,41.84429],[2.467828,41.843678],[2.467039,41.843509],[2.465397,41.843432],[2.463695,41.843664],[2.461504,41.844603],[2.460469,41.845785],[2.460069,41.846651],[2.459009,41.847633],[2.456914,41.848978],[2.454126,41.851499],[2.453503,41.852166],[2.452067,41.852666],[2.450942,41.852664],[2.447315,41.851746],[2.445229,41.851754],[2.441453,41.853092],[2.439921,41.85342],[2.433716,41.853823],[2.432104,41.854015],[2.427166,41.855117],[2.425878,41.855766],[2.424997,41.85673],[2.424361,41.857852],[2.424319,41.858279],[2.423103,41.861313],[2.422181,41.862481],[2.418975,41.865073],[2.417852,41.865795],[2.415793,41.866753],[2.415418,41.866681],[2.413305,41.867044],[2.412264,41.867393],[2.40962,41.868808],[2.408662,41.869654],[2.408122,41.870442],[2.407634,41.871736],[2.406993,41.872729],[2.406224,41.873408],[2.40411,41.874572],[2.402966,41.875303],[2.401568,41.876464],[2.399723,41.878461],[2.398583,41.879484],[2.396945,41.880471],[2.393235,41.882292],[2.390545,41.884366],[2.389593,41.885713],[2.388265,41.886858],[2.386039,41.887908],[2.384748,41.888786],[2.382964,41.890252],[2.381292,41.891163],[2.379168,41.892726],[2.377979,41.893425],[2.375892,41.894321],[2.373996,41.894914],[2.371407,41.895475],[2.369525,41.895668],[2.367461,41.895518],[2.365696,41.895013],[2.364198,41.894231],[2.36224,41.892662],[2.360825,41.891847],[2.359441,41.891468],[2.357422,41.891426],[2.355713,41.891885],[2.353074,41.893174],[2.351274,41.893772],[2.348593,41.894254],[2.347738,41.894516],[2.346388,41.895272],[2.345687,41.895961],[2.34409,41.898125],[2.342336,41.899495],[2.339974,41.90088],[2.339262,41.9015],[2.337497,41.902076],[2.333292,41.903669],[2.328342,41.905375],[2.323148,41.906932],[2.320198,41.907607],[2.314649,41.909871],[2.31325,41.910621],[2.310079,41.911982],[2.308252,41.913132],[2.306486,41.914698],[2.305007,41.916908],[2.304172,41.919095],[2.303418,41.921469],[2.302393,41.925821],[2.3015,41.92818],[2.300634,41.929647],[2.298886,41.932098],[2.297292,41.936095],[2.296642,41.938464],[2.296268,41.940459],[2.295879,41.94195],[2.295407,41.943212],[2.294334,41.945025],[2.292165,41.947677],[2.290691,41.949615],[2.290226,41.950413],[2.289662,41.952115],[2.289072,41.953398],[2.287958,41.955227],[2.286599,41.956633],[2.284056,41.958393],[2.28309,41.958895],[2.281199,41.959648],[2.279208,41.960152],[2.277519,41.960427],[2.275249,41.960585],[2.273817,41.960562],[2.271208,41.960366],[2.268614,41.960518],[2.264922,41.961128],[2.262849,41.961166],[2.261368,41.961032],[2.259083,41.960688],[2.253664,41.959663],[2.245937,41.957679],[2.244637,41.957024],[2.242478,41.955298],[2.237551,41.952569],[2.235924,41.951609],[2.233923,41.950049],[2.232368,41.948214],[2.231222,41.94614],[2.231006,41.945495],[2.230695,41.943076],[2.230705,41.941319],[2.230543,41.940763],[2.22967,41.939995],[2.228764,41.939613],[2.22598,41.939159],[2.224517,41.938697],[2.218091,41.93532],[2.216502,41.934635],[2.212852,41.933447],[2.210814,41.932994],[2.207905,41.932647],[2.206144,41.932634],[2.203302,41.932982],[2.201109,41.933495],[2.199124,41.933853],[2.192521,41.93381],[2.190487,41.933891],[2.187717,41.934428],[2.184984,41.935514],[2.182837,41.936215],[2.180988,41.936657],[2.178943,41.936933],[2.176467,41.936732],[2.175249,41.93643],[2.172253,41.935123],[2.169261,41.933732],[2.16808,41.933283],[2.166007,41.932754],[2.163874,41.932525],[2.162335,41.932534],[2.158398,41.933085],[2.1553,41.933046],[2.153008,41.932605],[2.151503,41.93207],[2.149524,41.931068],[2.148591,41.930482],[2.142698,41.92586],[2.141976,41.924833],[2.141156,41.923313],[2.140146,41.922019],[2.138559,41.920459],[2.130566,41.912861],[2.129002,41.91199],[2.127569,41.911634],[2.124657,41.911575],[2.122279,41.911159],[2.120808,41.910584],[2.119871,41.910061],[2.117803,41.908654],[2.116744,41.908133],[2.115322,41.907715],[2.11221,41.907046],[2.110433,41.906259],[2.107467,41.90475],[2.106159,41.904218],[2.103887,41.903639],[2.09952,41.903216],[2.093708,41.90276],[2.092231,41.902551],[2.090274,41.902077],[2.087581,41.901051],[2.08449,41.899475],[2.079714,41.897851],[2.077559,41.896954],[2.075434,41.895567],[2.073005,41.894547],[2.070047,41.893889],[2.068318,41.893407],[2.066997,41.892827],[2.064102,41.891279],[2.061523,41.890216],[2.05924,41.889663],[2.053468,41.888497],[2.051539,41.888028],[2.050198,41.88758],[2.045493,41.885798],[2.043615,41.885154],[2.041672,41.884686],[2.036604,41.884026],[2.033772,41.88319],[2.030992,41.881862],[2.029929,41.88146],[2.026348,41.880418],[2.025038,41.879864],[2.020016,41.877308],[2.019058,41.87675],[2.016354,41.874701],[2.01399,41.872609],[2.011787,41.871123],[2.008227,41.86903],[2.00538,41.867434],[2.003882,41.865773],[2.002964,41.864991],[1.999428,41.863018],[1.998524,41.862204],[1.997644,41.861111],[1.996433,41.859374],[1.99511,41.858227],[1.993219,41.85733],[1.990372,41.856732],[1.988073,41.856419],[1.986692,41.855995],[1.985679,41.85553],[1.984343,41.854658],[1.983294,41.853523],[1.98232,41.852056],[1.981874,41.850762],[1.981863,41.849067],[1.982656,41.844722],[1.982685,41.843809],[1.982507,41.842424],[1.982176,41.841318],[1.981643,41.840213],[1.980118,41.838119],[1.979012,41.836964],[1.976443,41.834935],[1.974763,41.833951],[1.972223,41.832698],[1.970321,41.831539],[1.969165,41.830518],[1.968072,41.829191],[1.967565,41.828309],[1.967018,41.826567],[1.966857,41.824974],[1.966012,41.81865],[1.965662,41.816705],[1.965044,41.815257],[1.96433,41.814265],[1.962842,41.813113],[1.961601,41.812504],[1.960222,41.812094],[1.950637,41.809875],[1.939041,41.807217],[1.937052,41.806657],[1.93546,41.806032],[1.932872,41.804541],[1.931428,41.803384],[1.929757,41.801516],[1.928392,41.799742],[1.927256,41.798675],[1.926204,41.797906],[1.924451,41.797017],[1.920978,41.795723],[1.919743,41.795091],[1.918389,41.794206],[1.912718,41.788986],[1.908799,41.78518],[1.906037,41.782841],[1.904957,41.782139],[1.90321,41.781252],[1.90104,41.780471],[1.899636,41.780133],[1.897661,41.779845],[1.895218,41.779704],[1.891103,41.779586],[1.889887,41.779628],[1.888015,41.779964],[1.886085,41.779988],[1.885092,41.779804],[1.881871,41.778878],[1.880872,41.778527],[1.879463,41.77781],[1.877584,41.77614],[1.875282,41.773446],[1.867511,41.763947],[1.865863,41.762907],[1.863408,41.762005],[1.860856,41.760766],[1.856485,41.757977],[1.85322,41.755975],[1.851304,41.755219],[1.848819,41.754605],[1.847208,41.754045],[1.843586,41.752175],[1.839598,41.750691],[1.838228,41.750302],[1.836184,41.749517],[1.835074,41.748882],[1.833948,41.747957],[1.832463,41.746368],[1.830895,41.745076],[1.8297,41.744389],[1.824232,41.741905],[1.821608,41.740768],[1.820789,41.740509],[1.818923,41.740308],[1.817381,41.740345],[1.816162,41.74022],[1.811009,41.739348],[1.809597,41.738972],[1.808553,41.738514],[1.805388,41.736491],[1.803683,41.735041],[1.802823,41.73383],[1.802318,41.732552],[1.801446,41.731364],[1.800212,41.730568],[1.799142,41.730177],[1.794007,41.729323],[1.791995,41.729219],[1.790961,41.729354],[1.789738,41.729745],[1.786446,41.731355],[1.781398,41.733922],[1.779764,41.73481],[1.776597,41.736262],[1.775544,41.736573],[1.774061,41.736738],[1.772845,41.736666],[1.771442,41.736281],[1.769694,41.73523],[1.766818,41.732225],[1.765731,41.731428],[1.764349,41.730864],[1.762701,41.730681],[1.75852,41.730872],[1.756675,41.731013],[1.753469,41.731727],[1.75226,41.7318],[1.751053,41.731696],[1.749565,41.731364],[1.747856,41.731291],[1.746788,41.731444],[1.743578,41.732486],[1.74233,41.732609],[1.740264,41.732606],[1.736968,41.732477],[1.736177,41.732323],[1.733824,41.731455],[1.731504,41.731068],[1.730507,41.731075],[1.728972,41.731309],[1.727722,41.731635],[1.726016,41.732267],[1.72484,41.732828],[1.717605,41.736631],[1.715483,41.737659],[1.712468,41.738615],[1.71003,41.738909],[1.708844,41.738899],[1.706319,41.738528],[1.704557,41.738142],[1.701912,41.737306],[1.699522,41.736244],[1.69696,41.734606],[1.694963,41.733962],[1.693722,41.733995],[1.691616,41.734444],[1.688644,41.73539],[1.686367,41.735534],[1.684959,41.735289],[1.681519,41.734493],[1.678317,41.733887],[1.677105,41.733499],[1.67511,41.732628],[1.673184,41.732115],[1.671625,41.732022],[1.670364,41.732182],[1.668483,41.732661],[1.667524,41.732759],[1.665697,41.732582],[1.660826,41.731236],[1.659874,41.731044],[1.658443,41.730978],[1.656274,41.731367],[1.653149,41.73243],[1.651775,41.732574],[1.649827,41.732327],[1.647741,41.731642],[1.645489,41.731479],[1.643791,41.731831],[1.642213,41.732469],[1.639966,41.733126],[1.638749,41.733738],[1.637325,41.735038],[1.635927,41.735921],[1.633497,41.73698],[1.631638,41.737554],[1.62986,41.737674],[1.625996,41.737092],[1.624627,41.737061],[1.622552,41.737488],[1.618553,41.739102],[1.61678,41.73935],[1.616246,41.739117],[1.613721,41.739443],[1.611603,41.739452],[1.608944,41.739271],[1.607337,41.739612],[1.604705,41.739634],[1.603466,41.739758],[1.601128,41.740489],[1.600057,41.740718],[1.597647,41.741734],[1.59353,41.743023],[1.592027,41.743597],[1.590228,41.744765],[1.588336,41.745806],[1.58608,41.746236],[1.585007,41.746192],[1.582236,41.745683],[1.580191,41.745518],[1.57861,41.74552],[1.577451,41.745345],[1.575658,41.744705],[1.573344,41.742771],[1.570393,41.740641],[1.567996,41.738476],[1.564818,41.736812],[1.563775,41.735966],[1.562544,41.733913],[1.561626,41.732962],[1.559731,41.732039],[1.558292,41.731777],[1.557177,41.731762],[1.555143,41.73202],[1.553076,41.731902],[1.551343,41.731336],[1.549904,41.730464],[1.548761,41.730094],[1.546667,41.729874],[1.544953,41.730236],[1.543367,41.73101],[1.541986,41.731976],[1.540562,41.732577],[1.538447,41.733146],[1.536937,41.733818],[1.535175,41.735147],[1.533747,41.735969],[1.532646,41.736325],[1.530147,41.73667],[1.526614,41.736789],[1.52423,41.737155],[1.522661,41.737771],[1.520388,41.739077],[1.519372,41.739478],[1.51744,41.739896],[1.51628,41.739963],[1.510483,41.739405],[1.508076,41.739129],[1.507019,41.738907],[1.505503,41.738372],[1.504145,41.73774],[1.502374,41.736515],[1.50137,41.736823],[1.499738,41.738174],[1.498661,41.738494],[1.496697,41.738744],[1.495676,41.738743],[1.492105,41.738192],[1.490775,41.737803],[1.4898,41.737244],[1.488966,41.736989],[1.487456,41.737002],[1.48515,41.737572],[1.482215,41.737945],[1.48116,41.738229],[1.480439,41.738632],[1.479741,41.739544],[1.479675,41.740619],[1.480537,41.742426],[1.480698,41.743245],[1.480082,41.745095],[1.478256,41.746389],[1.475809,41.747732],[1.47498,41.748287],[1.474851,41.749271],[1.474332,41.750758],[1.473004,41.752209],[1.472175,41.754161],[1.470674,41.754999],[1.469764,41.756138],[1.468714,41.756778],[1.467075,41.757057],[1.465554,41.757687],[1.464734,41.75869],[1.46433,41.76005],[1.463536,41.76083],[1.46169,41.761893],[1.45984,41.765062],[1.459581,41.766644],[1.458677,41.769031],[1.458148,41.769705],[1.457341,41.770281],[1.45656,41.771262],[1.455859,41.772443],[1.454334,41.773742],[1.452841,41.774323],[1.448876,41.775386],[1.445538,41.776439],[1.443843,41.777361],[1.442832,41.777622],[1.441198,41.77766],[1.43888,41.778103],[1.436527,41.779077],[1.434786,41.779953],[1.43338,41.780845],[1.429334,41.784243],[1.427275,41.786324],[1.425229,41.788977],[1.422706,41.792147],[1.419771,41.796017],[1.41943,41.796384],[1.41733,41.797445],[1.4125,41.800723],[1.41094,41.801722],[1.409524,41.802409],[1.406901,41.803336],[1.404624,41.805201],[1.404156,41.806001],[1.403068,41.809587],[1.402047,41.811013],[1.40141,41.811499],[1.400579,41.81253],[1.399512,41.813359],[1.396214,41.814976],[1.395464,41.815438],[1.39196,41.817009],[1.387543,41.818123],[1.386183,41.818532],[1.381602,41.819705],[1.380822,41.81997],[1.369314,41.825209],[1.368193,41.825876],[1.366926,41.826844],[1.360445,41.832816],[1.35946,41.833919],[1.358992,41.83473],[1.358647,41.835775],[1.358138,41.838097],[1.357832,41.838718],[1.356989,41.839281],[1.347611,41.842531],[1.346518,41.843098],[1.336597,41.849518],[1.33518,41.850302],[1.330951,41.851997],[1.326572,41.853701],[1.324887,41.854702],[1.318611,41.861287],[1.312859,41.867383],[1.310495,41.869849],[1.309618,41.870581],[1.308349,41.871075],[1.302108,41.871719],[1.292328,41.872795],[1.285245,41.873526],[1.27993,41.874104],[1.277911,41.874577],[1.272486,41.876464],[1.270549,41.877487],[1.268311,41.879201],[1.264103,41.881103],[1.251165,41.889098],[1.249505,41.889816],[1.247262,41.890022],[1.238047,41.889399],[1.236059,41.889383],[1.232335,41.890038],[1.230875,41.890095],[1.228213,41.88995],[1.226474,41.889628],[1.219938,41.887768],[1.215636,41.886478],[1.214497,41.886253],[1.212828,41.88625],[1.211832,41.886478],[1.210498,41.887026],[1.209874,41.887471],[1.20915,41.888523],[1.206926,41.892583],[1.205599,41.894785],[1.204249,41.896031],[1.203592,41.89705],[1.203911,41.899026],[1.203752,41.899984],[1.202529,41.900923],[1.200448,41.902107],[1.197524,41.904331],[1.19418,41.907498],[1.192756,41.908948],[1.18984,41.910863],[1.188977,41.912301],[1.187398,41.913775],[1.185147,41.915214],[1.186368,41.917143],[1.187498,41.917921],[1.189559,41.919059],[1.192234,41.921198],[1.192947,41.922253],[1.192826,41.922824],[1.193692,41.923413],[1.19598,41.92432],[1.19761,41.925587],[1.1978,41.925967],[1.200226,41.927609],[1.200461,41.927979],[1.19867,41.92878],[1.198484,41.929177],[1.198711,41.930062],[1.198721,41.932629],[1.19853,41.933122],[1.19769,41.93336],[1.196516,41.93306],[1.194642,41.93227],[1.192516,41.931895],[1.190811,41.93144],[1.19015,41.931474],[1.189648,41.932258],[1.190489,41.934511],[1.192558,41.935914],[1.192817,41.936416],[1.192499,41.936904],[1.189927,41.938003],[1.188976,41.937749],[1.18842,41.937088],[1.186377,41.936151],[1.184257,41.934489],[1.183688,41.933262],[1.182933,41.932415],[1.18028,41.931853],[1.17842,41.93223],[1.178096,41.932864],[1.178906,41.933576],[1.179829,41.933494],[1.180876,41.932875],[1.181454,41.93302],[1.182332,41.933794],[1.18391,41.936448],[1.184517,41.937107],[1.184617,41.937641],[1.183799,41.938964],[1.183104,41.939516],[1.183017,41.94072],[1.180951,41.941798],[1.180258,41.942008],[1.179792,41.943013],[1.178954,41.943464],[1.177496,41.9436],[1.176935,41.943896],[1.176138,41.945133],[1.17594,41.947016],[1.175359,41.948203],[1.175452,41.94957],[1.174811,41.950591],[1.174653,41.951182],[1.175833,41.954314],[1.17459,41.955645],[1.174372,41.956159],[1.174555,41.957129],[1.177438,41.959279],[1.177855,41.959845],[1.178069,41.961936],[1.178532,41.962584],[1.179293,41.962939],[1.179368,41.963808],[1.178924,41.96581],[1.178299,41.967593],[1.178546,41.969582],[1.17824,41.971202],[1.17731,41.973501],[1.177409,41.974527],[1.178541,41.976097],[1.17869,41.977129],[1.177917,41.977791],[1.177618,41.97899],[1.17805,41.979877],[1.179913,41.982819],[1.180377,41.983422],[1.181717,41.984238],[1.181873,41.984735],[1.181153,41.985916],[1.180948,41.986536],[1.180994,41.988915],[1.180912,41.989458],[1.180212,41.991029],[1.180389,41.991965],[1.180247,41.993269],[1.181175,41.994839],[1.182081,41.99569],[1.183078,41.996225],[1.183348,41.996876],[1.183004,41.997822],[1.182162,41.998788],[1.180888,41.999937],[1.179839,42.001673],[1.179576,42.002946],[1.179996,42.004821],[1.180426,42.00582],[1.179781,42.006811],[1.179588,42.007841],[1.177772,42.00874],[1.176678,42.010281],[1.176478,42.011639],[1.175914,42.013417],[1.17544,42.013945],[1.173598,42.01469],[1.172686,42.014803],[1.171403,42.014682],[1.169805,42.014341],[1.16858,42.014487],[1.168052,42.014942],[1.167517,42.016438],[1.166402,42.017192],[1.164729,42.01763],[1.163786,42.017703],[1.16254,42.017501],[1.161794,42.017556],[1.161187,42.017971],[1.160634,42.018743],[1.159941,42.019163],[1.159117,42.019158],[1.158117,42.018105],[1.158206,42.017118],[1.157788,42.015969],[1.156347,42.014155],[1.155337,42.013057],[1.154325,42.012618],[1.153207,42.012532],[1.151782,42.012699],[1.150606,42.012314],[1.150309,42.011561],[1.150355,42.010484],[1.150128,42.009886],[1.149297,42.009012],[1.147689,42.00924],[1.14552,42.008443],[1.141926,42.007394],[1.140043,42.007029],[1.138522,42.007432],[1.136731,42.009093],[1.134655,42.00994],[1.133346,42.010771],[1.132763,42.011678],[1.132591,42.012565],[1.131969,42.013239],[1.130624,42.013383],[1.128462,42.01316],[1.126148,42.013138],[1.124924,42.013259],[1.120248,42.013935],[1.117346,42.014476],[1.116322,42.014341],[1.11488,42.013802],[1.114072,42.014326],[1.114794,42.018624],[1.114713,42.019385],[1.114332,42.020268],[1.115118,42.021559],[1.114462,42.021956],[1.112814,42.022122],[1.112403,42.021838],[1.11183,42.020647],[1.110867,42.020312],[1.110368,42.020494],[1.109685,42.021457],[1.109914,42.022079],[1.110873,42.023377],[1.1108,42.024498],[1.109854,42.02632],[1.109114,42.029009],[1.109387,42.029347],[1.110145,42.029316],[1.111265,42.028544],[1.112308,42.028656],[1.113446,42.029452],[1.113825,42.029978],[1.113534,42.030355],[1.112744,42.030301],[1.111909,42.029479],[1.111345,42.029622],[1.110154,42.030413],[1.109438,42.031094],[1.108148,42.031169],[1.106617,42.031721],[1.105847,42.030891],[1.104953,42.030256],[1.104237,42.030491],[1.104039,42.031592],[1.104341,42.032755],[1.105743,42.034592],[1.105673,42.036343],[1.104815,42.037808],[1.104775,42.038591],[1.105001,42.039869],[1.104079,42.041373],[1.103622,42.041801],[1.101699,42.042719],[1.101204,42.043177],[1.100562,42.045631],[1.099986,42.046507],[1.099304,42.046893],[1.098122,42.047065],[1.09694,42.046877],[1.09616,42.046957],[1.095527,42.047685],[1.09531,42.049224],[1.095279,42.051013],[1.094821,42.051761],[1.091469,42.053318],[1.090502,42.054103],[1.089931,42.055117],[1.09005,42.056044],[1.091127,42.057846],[1.091841,42.058599],[1.09225,42.060084],[1.092942,42.061198],[1.093216,42.062373],[1.094705,42.063801],[1.095808,42.065113],[1.096376,42.065605],[1.096847,42.06651],[1.096678,42.06721],[1.095969,42.068572],[1.095501,42.069977],[1.09594,42.072091],[1.096068,42.073585],[1.09695,42.074283],[1.097136,42.075621],[1.096188,42.077385],[1.095164,42.078792],[1.092722,42.082419],[1.092491,42.083027],[1.092781,42.084836],[1.093237,42.085147],[1.094548,42.085313],[1.095093,42.085744],[1.095161,42.086367],[1.094891,42.087672],[1.095007,42.088304],[1.096369,42.089826],[1.096484,42.090673],[1.095389,42.091967],[1.095138,42.093061],[1.09465,42.096055],[1.09437,42.09702],[1.093205,42.098824],[1.092595,42.09929],[1.090005,42.099802],[1.087764,42.100607],[1.087082,42.100671],[1.085802,42.10006],[1.084808,42.099949],[1.084409,42.100336],[1.084112,42.101386],[1.082472,42.102589],[1.082316,42.10302],[1.08278,42.103355],[1.085574,42.103518],[1.085865,42.103993],[1.083242,42.105463],[1.081411,42.107248],[1.080532,42.107851],[1.079638,42.108216],[1.077107,42.108921],[1.074787,42.109296],[1.073067,42.109445],[1.072111,42.109707],[1.071255,42.11036],[1.070866,42.111227],[1.07105,42.112099],[1.071655,42.113103],[1.07174,42.114248],[1.071279,42.114931],[1.070011,42.115632],[1.068864,42.115745],[1.068068,42.115599],[1.066317,42.114946],[1.065202,42.11467],[1.06283,42.11444],[1.061019,42.114376],[1.057925,42.114439],[1.055511,42.114669],[1.051324,42.115493],[1.049833,42.115675],[1.047292,42.115491],[1.045586,42.114939],[1.043001,42.11372],[1.041535,42.113333],[1.039753,42.113165],[1.036123,42.113159],[1.034691,42.112945],[1.033636,42.112512],[1.033012,42.112047],[1.02986,42.109116],[1.028076,42.108307],[1.026887,42.108161],[1.025695,42.108252],[1.024104,42.108825],[1.020717,42.110792],[1.018148,42.112351],[1.016856,42.11284],[1.015731,42.11297],[1.013768,42.113011],[1.012061,42.113331],[1.008461,42.114889],[1.006899,42.115507],[1.001781,42.116718],[1.000558,42.116833],[0.998173,42.116721],[0.996373,42.117187],[0.995761,42.117579],[0.994824,42.118525],[0.994488,42.119303],[0.994383,42.120933],[0.99402,42.121755],[0.991696,42.124412],[0.991317,42.125662],[0.991432,42.127592],[0.990788,42.128653],[0.987932,42.131331],[0.986748,42.131927],[0.98525,42.132283],[0.981971,42.132638],[0.980276,42.132624],[0.97473,42.132],[0.972394,42.131629],[0.966718,42.13026],[0.96289,42.129298],[0.961347,42.129079],[0.956199,42.128983],[0.954301,42.129318],[0.953397,42.129812],[0.952618,42.130707],[0.951351,42.133032],[0.950734,42.133987],[0.949783,42.134691],[0.946569,42.136368],[0.943668,42.138273],[0.941816,42.139049],[0.938029,42.14018],[0.932259,42.141705],[0.929888,42.142499],[0.925051,42.144315],[0.923717,42.144632],[0.922571,42.14465],[0.920989,42.144464],[0.919397,42.145004],[0.917915,42.146322],[0.917585,42.146826],[0.916463,42.149799],[0.915022,42.154114],[0.914681,42.155633],[0.914503,42.157417],[0.913589,42.15837],[0.911597,42.159589],[0.910208,42.160208],[0.909342,42.16103],[0.907615,42.163449],[0.907432,42.164388],[0.907514,42.166533],[0.907452,42.16792],[0.90699,42.168164],[0.904373,42.168278],[0.9037,42.168036],[0.902323,42.166495],[0.900294,42.164017],[0.899162,42.163544],[0.896679,42.163579],[0.894877,42.163879],[0.894747,42.16404],[0.895204,42.165526],[0.896026,42.166616],[0.896311,42.167419],[0.894992,42.168476],[0.894943,42.168894],[0.895499,42.171878],[0.897424,42.17507],[0.897421,42.175432],[0.896651,42.176247],[0.896721,42.179155],[0.896922,42.180059],[0.897689,42.181282],[0.900394,42.183691],[0.901676,42.184237],[0.902632,42.185262],[0.902788,42.18646],[0.903302,42.187108],[0.903391,42.188374],[0.903762,42.188659],[0.90519,42.188217],[0.907387,42.186731],[0.909624,42.184978],[0.910902,42.184415],[0.911774,42.184252],[0.91496,42.184032],[0.916151,42.184179],[0.91743,42.184822],[0.918242,42.186132],[0.918444,42.187719],[0.919119,42.188417],[0.919744,42.188706],[0.920935,42.188924],[0.923613,42.188555],[0.924933,42.188765],[0.925928,42.189147],[0.927113,42.190148],[0.927548,42.191025],[0.927412,42.192563],[0.927516,42.194187],[0.928125,42.195106],[0.928839,42.195679],[0.930232,42.196215],[0.932016,42.197059],[0.932735,42.197898],[0.93407,42.201275],[0.934825,42.20239],[0.937173,42.204942],[0.93759,42.205676],[0.938268,42.207382],[0.938831,42.20828],[0.940028,42.20907],[0.942938,42.209833],[0.945365,42.210154],[0.950627,42.212505],[0.951488,42.21304],[0.955756,42.217001],[0.956393,42.217484],[0.96003,42.219289],[0.960784,42.219939],[0.96261,42.223346],[0.963125,42.224513],[0.963351,42.22579],[0.963376,42.227503],[0.963585,42.228381],[0.965137,42.232581],[0.965289,42.233435],[0.964803,42.235301],[0.964765,42.236079],[0.965502,42.237931],[0.9656,42.239253],[0.965566,42.242227],[0.965366,42.244473],[0.965164,42.245271],[0.964373,42.245772],[0.963692,42.246564],[0.962312,42.247429],[0.961619,42.248028],[0.960765,42.249465],[0.959484,42.250721],[0.957844,42.251863],[0.957049,42.25304],[0.953136,42.255928],[0.951787,42.257112],[0.950276,42.25894],[0.945946,42.264713],[0.945462,42.266021],[0.944961,42.269673],[0.944346,42.271288],[0.943316,42.272451],[0.942322,42.273185],[0.939952,42.27433],[0.938814,42.275283],[0.938383,42.276043],[0.937879,42.278789],[0.936646,42.281886],[0.936344,42.283314],[0.936119,42.286084],[0.935909,42.287559],[0.936154,42.293147],[0.936271,42.293753],[0.935801,42.295442],[0.935764,42.296781],[0.936222,42.301741],[0.93627,42.303701],[0.935746,42.305292],[0.934433,42.308061],[0.93428,42.311272],[0.934362,42.313631],[0.93511,42.315359],[0.935314,42.316173],[0.935373,42.318201],[0.935972,42.320747],[0.936697,42.322322],[0.936807,42.324468],[0.937993,42.324994],[0.93906,42.325717],[0.93986,42.327144],[0.93898,42.328458],[0.939885,42.326772],[0.9389,42.325528],[0.937532,42.324728],[0.936476,42.324446],[0.936359,42.325038],[0.937073,42.325814],[0.936231,42.32674],[0.934504,42.327533],[0.933341,42.328715],[0.932839,42.330974],[0.932422,42.331892],[0.931858,42.332438],[0.929732,42.333473],[0.928089,42.334627],[0.927302,42.334974],[0.925632,42.335354],[0.924382,42.335893],[0.923671,42.336373],[0.923017,42.337132],[0.922239,42.338897],[0.921404,42.33969],[0.92037,42.340277],[0.918205,42.341162],[0.917243,42.341702],[0.915749,42.342821],[0.91411,42.343687],[0.912487,42.344269],[0.908256,42.345133],[0.906936,42.345597],[0.90571,42.346277],[0.904926,42.346883],[0.901935,42.349735],[0.899696,42.352526],[0.898026,42.354059],[0.896372,42.355384],[0.89512,42.356085],[0.892732,42.356988],[0.891375,42.358262],[0.890599,42.358801],[0.889428,42.359282],[0.88827,42.359484],[0.886604,42.359408],[0.882341,42.358199],[0.880373,42.358213],[0.879087,42.358512],[0.877459,42.359352],[0.873981,42.360356],[0.872668,42.361198],[0.871339,42.362504],[0.86996,42.363449],[0.868301,42.363947],[0.867913,42.36427],[0.867974,42.363685],[0.867502,42.364241],[0.866282,42.364567],[0.865121,42.365106],[0.864672,42.365777],[0.863217,42.366653],[0.862391,42.366632],[0.860133,42.365987],[0.862347,42.367144],[0.861726,42.367516],[0.860604,42.367714],[0.861161,42.367168],[0.860247,42.367182],[0.85957,42.367553],[0.85889,42.366677],[0.85711,42.366052],[0.857829,42.366529],[0.857924,42.366911],[0.856863,42.366448],[0.856143,42.365916],[0.854946,42.365587],[0.85386,42.364661],[0.852062,42.363906],[0.851113,42.363748],[0.850179,42.363037],[0.850195,42.362812],[0.851227,42.362598],[0.850613,42.362493],[0.849017,42.362571],[0.848971,42.362989],[0.849884,42.363856],[0.8529,42.365795],[0.852568,42.366094],[0.851911,42.366025],[0.84972,42.364658],[0.848381,42.364744],[0.847881,42.364507],[0.847208,42.365177],[0.847168,42.363906],[0.846697,42.363416],[0.846501,42.362595],[0.846031,42.362322],[0.84485,42.362146],[0.842295,42.361298],[0.841715,42.360241],[0.842391,42.35848],[0.841813,42.357605],[0.839453,42.357173],[0.83799,42.357255],[0.836628,42.357717],[0.836066,42.357741],[0.835431,42.357243],[0.833879,42.357031],[0.833052,42.35721],[0.832657,42.357016],[0.832427,42.356325],[0.831494,42.3551],[0.831467,42.35449],[0.830507,42.353649],[0.828269,42.353032],[0.827402,42.353317],[0.826621,42.353844],[0.825101,42.35459],[0.824422,42.355504],[0.823755,42.356802],[0.823643,42.357495],[0.822905,42.358247],[0.821956,42.357738],[0.821451,42.357748],[0.819025,42.358655],[0.817946,42.360123],[0.817569,42.360846],[0.81747,42.361799],[0.816648,42.362841],[0.816022,42.363388],[0.815047,42.363657],[0.814215,42.363649],[0.813168,42.363983],[0.812669,42.364623],[0.812324,42.36556],[0.811431,42.366406],[0.809872,42.366979],[0.810236,42.367862],[0.809913,42.368299],[0.809942,42.369673],[0.80905,42.370808],[0.80744,42.371146],[0.805493,42.372012],[0.80494,42.372934],[0.80342,42.373648],[0.801274,42.373623],[0.800079,42.372979],[0.799121,42.373656],[0.798346,42.373835],[0.797668,42.374511],[0.796668,42.375177],[0.794014,42.376511],[0.793444,42.377126],[0.792417,42.377235],[0.792279,42.377518],[0.793886,42.378322],[0.793806,42.378752],[0.79295,42.379345],[0.792703,42.379779],[0.791052,42.380827],[0.791087,42.382065],[0.790224,42.38326],[0.789357,42.383581],[0.789782,42.384548],[0.789245,42.384855],[0.788714,42.385863],[0.788003,42.386443],[0.787291,42.387912],[0.786749,42.388469],[0.78689,42.388803],[0.787752,42.387725],[0.788732,42.386778],[0.789361,42.386765],[0.78868,42.387294],[0.788188,42.388065],[0.788311,42.388809],[0.787544,42.389641],[0.787573,42.390442],[0.786946,42.391243],[0.785691,42.391938],[0.785482,42.3924],[0.785476,42.393658],[0.785096,42.39395],[0.783518,42.394184],[0.782333,42.394681],[0.779195,42.394602],[0.777848,42.394697],[0.777004,42.39501],[0.775466,42.394704],[0.774775,42.394367],[0.773613,42.394757],[0.772417,42.394548],[0.771372,42.394182],[0.770319,42.394098],[0.769776,42.393788],[0.768136,42.394028],[0.767424,42.393656],[0.765487,42.393647],[0.764379,42.394272],[0.763179,42.394652],[0.762627,42.394568],[0.761382,42.393811],[0.760104,42.393655],[0.758619,42.393132],[0.758065,42.392488],[0.756296,42.391565],[0.755925,42.390962],[0.756221,42.390108],[0.755882,42.38987],[0.754768,42.390237],[0.754237,42.390719],[0.752997,42.390671],[0.752437,42.389944],[0.751705,42.389637],[0.750051,42.390002],[0.749474,42.389895],[0.74868,42.389181],[0.748192,42.389037],[0.746427,42.3892],[0.745773,42.390339],[0.746121,42.391552],[0.74669,42.392406],[0.74689,42.394642],[0.746182,42.395827],[0.743793,42.398242],[0.743482,42.398739],[0.742398,42.401462],[0.742171,42.403695],[0.742394,42.40481],[0.742204,42.405938],[0.742718,42.407485],[0.740672,42.409709],[0.740022,42.412615],[0.739609,42.412965],[0.7384,42.41327],[0.737977,42.41365],[0.737452,42.414942],[0.736687,42.415966],[0.735575,42.417902],[0.735631,42.419052],[0.735087,42.420229],[0.733912,42.422288],[0.732781,42.424017],[0.732391,42.425062],[0.73249,42.425437],[0.733881,42.426195],[0.737014,42.429166],[0.738464,42.430958],[0.739482,42.431817],[0.741951,42.433039],[0.742381,42.4334],[0.743401,42.435502],[0.743811,42.435936],[0.74613,42.437691],[0.746586,42.438361],[0.745537,42.439834],[0.745778,42.440384],[0.746959,42.441451],[0.749999,42.444757],[0.750558,42.445828],[0.751548,42.446659],[0.751901,42.448021],[0.751409,42.449598],[0.752496,42.451347],[0.754005,42.452811],[0.754636,42.453181],[0.758385,42.454832],[0.760219,42.456234],[0.760698,42.457359],[0.761913,42.457812],[0.76291,42.458678],[0.76366,42.459937],[0.764614,42.460316],[0.766453,42.460559],[0.767361,42.461007],[0.769314,42.461677],[0.769513,42.463108],[0.770693,42.464585],[0.770936,42.46527],[0.771837,42.466004],[0.777044,42.468023],[0.777698,42.468912],[0.777915,42.470871],[0.777862,42.471958],[0.77701,42.473467],[0.776981,42.474066],[0.77776,42.476779],[0.778754,42.478928],[0.778744,42.481697],[0.778481,42.484146],[0.778715,42.485572],[0.779679,42.486756],[0.780064,42.487515],[0.780451,42.488859],[0.780422,42.490721],[0.780812,42.491436],[0.781906,42.492611],[0.782653,42.494287],[0.783504,42.494928],[0.785404,42.495388],[0.786485,42.495939],[0.786948,42.497048],[0.78747,42.49752],[0.789964,42.499197],[0.792373,42.500683],[0.795198,42.501814],[0.795846,42.502306],[0.79725,42.5038],[0.799017,42.504463],[0.800818,42.504447],[0.804003,42.504955],[0.804626,42.5052],[0.805931,42.506348],[0.807089,42.508038],[0.809113,42.509704],[0.810921,42.510504],[0.812548,42.51223],[0.814682,42.513685],[0.817001,42.514858],[0.818423,42.515926],[0.819362,42.516965],[0.820781,42.519411],[0.822206,42.520498],[0.824034,42.521247],[0.824983,42.52145],[0.827795,42.523108],[0.828512,42.523706],[0.828225,42.524379],[0.828477,42.526469],[0.829589,42.527345],[0.8297,42.527783],[0.831001,42.528281],[0.831735,42.530004],[0.831918,42.531118],[0.8331,42.531435],[0.833113,42.530801],[0.834002,42.529398],[0.833277,42.526421],[0.833354,42.525816],[0.833913,42.524737],[0.833924,42.523876],[0.834264,42.522411],[0.8353,42.521645],[0.835768,42.522417],[0.83579,42.523607],[0.836267,42.523633],[0.837554,42.521909],[0.838884,42.520952],[0.839718,42.520037],[0.840168,42.520125],[0.840745,42.520905],[0.840185,42.521624],[0.841718,42.520963],[0.842684,42.519981],[0.842839,42.52055],[0.842349,42.521374],[0.841486,42.522061],[0.843035,42.521481],[0.844829,42.520399],[0.845309,42.519991],[0.847188,42.519138],[0.848241,42.517895],[0.848098,42.51715],[0.848471,42.516778],[0.849185,42.516667],[0.84833,42.517288],[0.847834,42.518502],[0.843681,42.521049],[0.841387,42.522202],[0.842705,42.52077],[0.842764,42.519944],[0.842241,42.52052],[0.840019,42.521807],[0.840697,42.520764],[0.839943,42.519961],[0.839427,42.520479],[0.837712,42.521713],[0.836991,42.522815],[0.836253,42.523528],[0.835766,42.523582],[0.835709,42.522743],[0.835307,42.521649],[0.834469,42.522209],[0.83393,42.522237],[0.834182,42.522828],[0.832979,42.522569],[0.833272,42.522882],[0.834063,42.522987],[0.833897,42.524737],[0.833287,42.526204],[0.833634,42.527704],[0.833881,42.529782],[0.833124,42.530849],[0.833149,42.531498],[0.832082,42.531007],[0.831131,42.528898],[0.829972,42.527517],[0.828813,42.526564],[0.828469,42.525975],[0.828504,42.524782],[0.828346,42.523668],[0.827985,42.523116],[0.82735,42.522863],[0.82512,42.521628],[0.822663,42.520618],[0.820791,42.51942],[0.820156,42.518198],[0.818696,42.516132],[0.816019,42.514286],[0.814683,42.513666],[0.812644,42.512334],[0.810945,42.510664],[0.810221,42.510154],[0.808668,42.509551],[0.807196,42.508237],[0.805513,42.506084],[0.804101,42.504941],[0.800919,42.504402],[0.799523,42.504502],[0.798485,42.50437],[0.797515,42.503883],[0.795846,42.502344],[0.794771,42.501682],[0.792852,42.500908],[0.791421,42.500062],[0.787169,42.49724],[0.786625,42.496741],[0.78641,42.496148],[0.78575,42.495443],[0.783749,42.494796],[0.782917,42.494203],[0.782087,42.492484],[0.780537,42.490585],[0.780468,42.488444],[0.780078,42.487036],[0.778902,42.485504],[0.778666,42.484798],[0.778845,42.481354],[0.779033,42.479154],[0.778898,42.478547],[0.77818,42.477307],[0.77695,42.474128],[0.777068,42.473012],[0.777928,42.471517],[0.778027,42.470853],[0.777663,42.468692],[0.777304,42.468161],[0.771963,42.466176],[0.770828,42.465131],[0.770389,42.46389],[0.76973,42.463484],[0.769422,42.462872],[0.769522,42.461864],[0.769206,42.461548],[0.766656,42.46074],[0.764801,42.460519],[0.763451,42.459924],[0.762572,42.458264],[0.760642,42.457271],[0.760263,42.45634],[0.758729,42.455018],[0.757153,42.454402],[0.754645,42.45318],[0.753624,42.452528],[0.752493,42.451308],[0.751667,42.450177],[0.751381,42.44934],[0.751822,42.447585],[0.751313,42.446489],[0.750486,42.445862],[0.749931,42.444828],[0.74688,42.441223],[0.745799,42.440293],[0.745784,42.439328],[0.746722,42.438153],[0.745623,42.437396],[0.74386,42.435975],[0.743422,42.435491],[0.742297,42.433278],[0.73909,42.431617],[0.737776,42.429913],[0.736756,42.428831],[0.734409,42.426624],[0.733447,42.425828],[0.732569,42.425502],[0.732047,42.425667],[0.731095,42.426579],[0.728638,42.427208],[0.726848,42.427806],[0.725125,42.429023],[0.724534,42.430005],[0.723957,42.430478],[0.722955,42.430735],[0.719601,42.431805],[0.717874,42.432701],[0.715889,42.433335],[0.715269,42.433672],[0.714781,42.434453],[0.714634,42.435452],[0.71349,42.437173],[0.712832,42.438634],[0.711439,42.442745],[0.710167,42.445391],[0.710153,42.449321],[0.709506,42.451351],[0.708966,42.453541],[0.708796,42.454764],[0.708341,42.456566],[0.708611,42.45735],[0.709967,42.458946],[0.711619,42.461147],[0.711791,42.462506],[0.712084,42.463246],[0.713685,42.464589],[0.714247,42.467212],[0.714835,42.468341],[0.715839,42.470849],[0.715994,42.473165],[0.717251,42.47631],[0.71775,42.476868],[0.718707,42.478704],[0.719021,42.482941],[0.717833,42.486278],[0.718452,42.488061],[0.718601,42.489137],[0.718307,42.490846],[0.718295,42.492844],[0.717879,42.49435],[0.717731,42.497428],[0.717169,42.500356],[0.716658,42.501852],[0.716471,42.502903],[0.715726,42.504104],[0.715739,42.504607],[0.717239,42.505968],[0.718247,42.506378],[0.718545,42.51005],[0.71818,42.511525],[0.718314,42.512053],[0.71945,42.513109],[0.719662,42.513642],[0.719779,42.515045],[0.720146,42.515812],[0.721117,42.516528],[0.722929,42.518621],[0.722709,42.519998],[0.722308,42.521103],[0.719879,42.52545],[0.7199,42.526051],[0.720516,42.527027],[0.722086,42.530719],[0.723437,42.533685],[0.725141,42.534579],[0.725738,42.535294],[0.725753,42.536363],[0.726158,42.536904],[0.726899,42.537161],[0.727526,42.537999],[0.727387,42.538992],[0.728473,42.540519],[0.729365,42.542057],[0.729918,42.543719],[0.730602,42.544622],[0.732461,42.545893],[0.735372,42.546857],[0.736872,42.54664],[0.7392,42.546604],[0.741433,42.547651],[0.741816,42.548532],[0.742525,42.549009],[0.743947,42.549344],[0.745219,42.550578],[0.746069,42.550854],[0.747819,42.552271],[0.748563,42.553048],[0.748558,42.553716],[0.747624,42.555144],[0.747465,42.556793],[0.747626,42.558571],[0.748649,42.559743],[0.749156,42.56071],[0.749633,42.562187],[0.749537,42.563329],[0.74968,42.563953],[0.750986,42.566004],[0.75234,42.567311],[0.75314,42.567905],[0.754086,42.56901],[0.754447,42.569655],[0.754453,42.570317],[0.755951,42.573869],[0.756124,42.575823],[0.755929,42.576663],[0.756408,42.580016],[0.756061,42.58101],[0.756246,42.583276],[0.756636,42.584234],[0.757723,42.585043],[0.758141,42.585855],[0.75766,42.587388],[0.75812,42.589609],[0.757209,42.59137],[0.757091,42.591999],[0.757262,42.593033],[0.758038,42.595803],[0.758349,42.596364],[0.759007,42.596728],[0.760977,42.596969],[0.762515,42.597959],[0.76293,42.598408],[0.76348,42.599684],[0.763503,42.600817],[0.76374,42.601943],[0.764214,42.602779],[0.766047,42.60449],[0.766245,42.60585],[0.765882,42.607111],[0.76597,42.607591],[0.766754,42.609232],[0.766852,42.60992],[0.766642,42.611283],[0.766373,42.61167],[0.765698,42.614776],[0.764795,42.617183],[0.764799,42.618582],[0.765237,42.621781],[0.765173,42.622709],[0.764549,42.62515],[0.778412,42.671361],[0.778101,42.672096],[0.777266,42.672864],[0.775447,42.673826],[0.774483,42.674451],[0.77372,42.674693],[0.772452,42.674746],[0.771355,42.675175],[0.769511,42.675456],[0.769028,42.675941],[0.769399,42.676346],[0.772019,42.676404],[0.774057,42.676823],[0.77497,42.676843],[0.777874,42.676587],[0.780907,42.676562],[0.78323,42.677209],[0.785041,42.677972],[0.786396,42.678959],[0.786873,42.679508],[0.787718,42.681873],[0.787869,42.682638],[0.787829,42.684588],[0.787502,42.686241],[0.787827,42.687741],[0.786937,42.689649],[0.786983,42.690396],[0.787352,42.691061],[0.787547,42.692403],[0.787439,42.693219],[0.78828,42.695582],[0.788427,42.696801],[0.78894,42.697589],[0.788763,42.698399],[0.789147,42.699093],[0.788879,42.699703],[0.789361,42.700015],[0.790614,42.699314],[0.790813,42.698021],[0.79132,42.698031],[0.791628,42.699385],[0.790197,42.701525],[0.789478,42.702929],[0.789258,42.704875],[0.788957,42.705495],[0.789384,42.705746],[0.789661,42.70533],[0.790079,42.703379],[0.790608,42.703085],[0.792046,42.70184],[0.792855,42.701517],[0.793347,42.701616],[0.793067,42.702606],[0.793472,42.703222],[0.795475,42.705119],[0.795992,42.706589],[0.796819,42.710206],[0.796999,42.712076],[0.797286,42.713744],[0.796765,42.715589],[0.796588,42.71693],[0.795908,42.718045],[0.794987,42.71873],[0.794282,42.719991],[0.793773,42.720434],[0.791274,42.721132],[0.790503,42.721677],[0.790259,42.722975],[0.790004,42.723419],[0.788511,42.724072],[0.787459,42.724113],[0.786779,42.724362],[0.786091,42.724998],[0.784175,42.726242],[0.783505,42.727207],[0.781257,42.728833],[0.779684,42.72972],[0.778165,42.730134],[0.776085,42.731778],[0.775276,42.732653],[0.7738,42.733236],[0.769416,42.733717],[0.768123,42.73393],[0.76746,42.734235],[0.76674,42.734902],[0.764967,42.735963],[0.763698,42.736134],[0.761955,42.736144],[0.759872,42.736701],[0.758686,42.737506],[0.756458,42.737915],[0.753638,42.737595],[0.751067,42.738069],[0.749048,42.737717],[0.747495,42.737155],[0.746212,42.736848],[0.744455,42.736778],[0.739838,42.737442],[0.736862,42.737547],[0.734591,42.737867],[0.732324,42.738719],[0.731462,42.738681],[0.729766,42.738274],[0.727449,42.738342],[0.725159,42.738835],[0.723038,42.73886],[0.719457,42.739437],[0.718624,42.739764],[0.717111,42.7407],[0.715984,42.741191],[0.714767,42.74138],[0.712766,42.741321],[0.711511,42.741412],[0.71007,42.741814],[0.709234,42.742287],[0.705115,42.745873],[0.703412,42.746936],[0.702575,42.747682],[0.701233,42.748595],[0.700754,42.749157],[0.700256,42.750446],[0.699322,42.751254],[0.698215,42.752677],[0.697865,42.753337],[0.697529,42.754604],[0.69722,42.755162],[0.694707,42.757954],[0.692989,42.759004],[0.692179,42.759912],[0.69154,42.76157],[0.690172,42.762944],[0.687264,42.765295],[0.68652,42.766467],[0.684977,42.773515],[0.684879,42.77471],[0.685181,42.776382],[0.685862,42.777247],[0.686527,42.777658],[0.688903,42.778425],[0.689835,42.779353],[0.690385,42.781203],[0.691673,42.782872],[0.692494,42.784114],[0.692777,42.785273],[0.69399,42.787524],[0.695305,42.788805],[0.696359,42.789196],[0.696912,42.789758],[0.697303,42.790743],[0.698011,42.791613],[0.698134,42.792151],[0.698046,42.794274],[0.698585,42.795163],[0.700073,42.796837],[0.703144,42.801241],[0.7037,42.803736],[0.704925,42.805397],[0.705993,42.80647],[0.706842,42.808075],[0.707657,42.80883],[0.709332,42.809743],[0.709872,42.81039],[0.710225,42.815798],[0.711089,42.816464],[0.711435,42.817274],[0.713125,42.8201],[0.713524,42.820479],[0.715736,42.821671],[0.717251,42.822291],[0.7197,42.822976],[0.721522,42.82432],[0.722598,42.82474],[0.724202,42.82503],[0.725031,42.825661],[0.725572,42.826862],[0.725999,42.827395],[0.727062,42.828139],[0.727633,42.828825],[0.728071,42.829955],[0.729161,42.831078],[0.729604,42.831828],[0.729683,42.833134],[0.730258,42.834576],[0.730403,42.836361],[0.73164,42.838334],[0.73165,42.839466],[0.730682,42.841291],[0.731479,42.842962],[0.731685,42.843982],[0.732747,42.845185],[0.733805,42.846871],[0.735334,42.848249],[0.736196,42.849517],[0.735863,42.852775],[0.735862,42.854705],[0.736652,42.856069],[0.737371,42.856438],[0.738568,42.856461],[0.742496,42.856975],[0.74363,42.857301],[0.7449,42.857861],[0.747105,42.858999],[0.747937,42.859724],[0.748203,42.860362],[0.748111,42.862163],[0.748645,42.863266],[0.749684,42.864227],[0.750122,42.865237],[0.750078,42.865629],[0.749389,42.866125],[0.7484,42.866124],[0.74528,42.866987],[0.742946,42.867332],[0.741538,42.867371],[0.739688,42.867715],[0.737342,42.868718],[0.729696,42.872245],[0.728049,42.873316],[0.725779,42.875094],[0.721746,42.878354],[0.716725,42.882344],[0.714835,42.883898],[0.713535,42.884803],[0.706502,42.888679],[0.703327,42.891776],[0.70297,42.89227],[0.699599,42.896175],[0.699318,42.896664],[0.698817,42.898671],[0.698467,42.899588],[0.696473,42.901923],[0.696021,42.902245],[0.693589,42.903228],[0.69222,42.904091],[0.691858,42.904483],[0.691578,42.90544],[0.69017,42.907948],[0.690088,42.908427],[0.690443,42.90972],[0.691938,42.912601],[0.6928,42.913349],[0.693091,42.914159],[0.692679,42.914888],[0.692044,42.915274],[0.691942,42.91567],[0.690513,42.916865],[0.690397,42.917598],[0.689679,42.918816],[0.688918,42.919662],[0.688197,42.920958],[0.68711,42.921789],[0.685452,42.922344],[0.684433,42.922208],[0.6839,42.922389],[0.684087,42.92319],[0.682719,42.923553],[0.678828,42.925694],[0.676826,42.926396],[0.674428,42.926829],[0.663939,42.928456],[0.662655,42.928381],[0.658234,42.927655],[0.656245,42.927473],[0.655317,42.927643],[0.654074,42.928238],[0.653329,42.929003],[0.649571,42.936042],[0.649029,42.937484],[0.648852,42.938937],[0.647987,42.939836],[0.646112,42.944779],[0.64582,42.946112],[0.645114,42.947363],[0.643951,42.948445],[0.643101,42.949437],[0.642667,42.950606],[0.642598,42.951397],[0.642776,42.952368],[0.643901,42.955646],[0.644521,42.956777],[0.646384,42.958973],[0.646798,42.959715],[0.647626,42.962393],[0.647676,42.96329],[0.647294,42.965328],[0.647059,42.968938],[0.647093,42.973334],[0.646596,42.974602],[0.645707,42.975691],[0.645246,42.977056],[0.644166,42.978197],[0.641985,42.979217],[0.641028,42.979884],[0.639905,42.981734],[0.63832,42.983142],[0.637323,42.98454],[0.635946,42.985672],[0.632088,42.987896],[0.630916,42.988808],[0.630462,42.989915],[0.630124,42.992028],[0.630204,42.992526],[0.63094,42.993722],[0.630934,42.994287],[0.629922,42.996402],[0.627929,42.99994],[0.626853,43.0013],[0.625657,43.002252],[0.625169,43.003669],[0.62331,43.006753],[0.622442,43.00761],[0.620355,43.009014],[0.6181,43.010636],[0.617315,43.011566],[0.616713,43.013896],[0.61678,43.015102],[0.617154,43.015728],[0.619734,43.018512],[0.619747,43.019029],[0.618262,43.020218],[0.617172,43.021273],[0.616013,43.022758],[0.612716,43.025735],[0.611306,43.027667],[0.611062,43.028315],[0.61049,43.028804],[0.609873,43.02969],[0.609418,43.030879],[0.608952,43.03372],[0.608705,43.034429],[0.607521,43.036071],[0.605834,43.037196],[0.604501,43.037705],[0.600631,43.038869],[0.598697,43.039879],[0.59614,43.041599],[0.594615,43.042877],[0.592066,43.044572],[0.591256,43.045798],[0.591217,43.046302],[0.592001,43.05019],[0.591379,43.055832],[0.591534,43.057254],[0.592606,43.059146],[0.593159,43.05952],[0.59269,43.059933],[0.59243,43.059585],[0.592924,43.059391],[0.593175,43.060002],[0.593887,43.060765],[0.595418,43.061649],[0.603873,43.064936],[0.605037,43.065492],[0.606547,43.066479],[0.60746,43.067325],[0.608491,43.068664],[0.609028,43.069701],[0.609401,43.071007],[0.609477,43.072345],[0.609055,43.074349],[0.608248,43.075809],[0.603812,43.081144],[0.601234,43.084191],[0.600001,43.08575],[0.598854,43.087833],[0.598207,43.089777],[0.595808,43.098671],[0.594874,43.102342],[0.594922,43.102897],[0.595493,43.103632],[0.596205,43.103962],[0.598594,43.104599],[0.60414,43.105891],[0.607447,43.106761],[0.613792,43.108659],[0.615853,43.109185],[0.616786,43.109286],[0.61837,43.108844],[0.618837,43.109529],[0.618067,43.111061],[0.617043,43.111512],[0.614992,43.111519],[0.614531,43.111299],[0.614127,43.110206],[0.615131,43.109909],[0.617796,43.110632],[0.618314,43.110459],[0.618733,43.109538],[0.618681,43.109087],[0.618125,43.108884],[0.617676,43.109178],[0.61823,43.10977],[0.620812,43.110421],[0.630262,43.112413],[0.63281,43.112864],[0.638084,43.113912],[0.641556,43.114487],[0.644867,43.114854],[0.649856,43.115102],[0.654677,43.114933],[0.659323,43.114618],[0.666474,43.114052],[0.668563,43.113976],[0.671895,43.114043],[0.673976,43.114169],[0.677446,43.114573],[0.685046,43.115566],[0.687915,43.11601],[0.691628,43.116864],[0.69713,43.118624],[0.699878,43.119554],[0.702666,43.120344],[0.705575,43.120974],[0.711251,43.122035],[0.713907,43.122652],[0.717925,43.123681],[0.719871,43.124059],[0.723488,43.124492],[0.725674,43.124556],[0.727631,43.12449],[0.730139,43.124197],[0.733607,43.123587],[0.736706,43.123247],[0.738941,43.123197],[0.740551,43.123256],[0.743967,43.123673],[0.749647,43.124572],[0.752386,43.124823],[0.756692,43.124995],[0.761259,43.125084],[0.766433,43.125055],[0.769441,43.125101],[0.773796,43.125261],[0.78019,43.125669],[0.784229,43.125767],[0.788417,43.125781],[0.79322,43.125641],[0.799631,43.125548],[0.80229,43.125704],[0.80435,43.125976],[0.806009,43.126295],[0.808389,43.126887],[0.812772,43.12823],[0.816962,43.129617],[0.818516,43.130065],[0.82612,43.132528],[0.828447,43.133089],[0.83127,43.133423],[0.834442,43.133354],[0.837576,43.132854],[0.839826,43.132386],[0.844269,43.131581],[0.847604,43.130917],[0.851925,43.129897],[0.855438,43.129009],[0.863406,43.126871],[0.868665,43.125416],[0.870962,43.124949],[0.873302,43.124658],[0.875109,43.124536],[0.882246,43.124479],[0.884548,43.124337],[0.885989,43.124133],[0.888832,43.12349],[0.891051,43.122753],[0.893893,43.121083],[0.89532,43.120062],[0.898219,43.119067],[0.901552,43.117842],[0.904333,43.117107],[0.908425,43.116326],[0.910683,43.116066],[0.913943,43.116119],[0.916518,43.116532],[0.918413,43.117052],[0.920672,43.117973],[0.922763,43.119118],[0.929272,43.122954],[0.931919,43.12431],[0.933708,43.125074],[0.936921,43.126302],[0.941365,43.128164],[0.942886,43.128893],[0.945821,43.130454],[0.949019,43.132469],[0.951515,43.134321],[0.954408,43.136812],[0.95725,43.139863],[0.959247,43.142456],[0.960386,43.144238],[0.961757,43.146728],[0.963412,43.150321],[0.964281,43.152376],[0.967601,43.159832],[0.968709,43.161559],[0.970645,43.163739],[0.9719,43.165715],[0.972405,43.166962],[0.973236,43.169918],[0.97403,43.171497],[0.974728,43.172417],[0.977435,43.175456],[0.978416,43.177043],[0.979211,43.179298],[0.979719,43.182339],[0.979967,43.184459],[0.980633,43.186513],[0.981563,43.188051],[0.982899,43.189421],[0.984598,43.190892],[0.985678,43.191654],[0.987914,43.192827],[0.994121,43.195756],[0.995823,43.196593],[1.005205,43.201036],[1.015538,43.205871],[1.017057,43.206476],[1.018967,43.207022],[1.023591,43.207859],[1.025592,43.208357],[1.02691,43.20885],[1.028692,43.209705],[1.050644,43.222523],[1.057698,43.226585],[1.060014,43.227991],[1.070535,43.234118],[1.08167,43.240672],[1.08946,43.245151],[1.094906,43.24837],[1.101244,43.252072],[1.106878,43.255323],[1.114267,43.259686],[1.116168,43.260745],[1.120622,43.263374],[1.124743,43.265743],[1.130324,43.269039],[1.131646,43.269759],[1.140051,43.274738],[1.141972,43.275805],[1.145267,43.277754],[1.153647,43.282583],[1.155596,43.283591],[1.164151,43.288568],[1.164823,43.289002],[1.169468,43.291698],[1.171716,43.293116],[1.177182,43.2964],[1.178883,43.297349],[1.18575,43.301391],[1.18925,43.303416],[1.19659,43.307595],[1.199106,43.309135],[1.202869,43.311342],[1.206677,43.313461],[1.211534,43.316357],[1.216862,43.319406],[1.218213,43.320247],[1.225322,43.324365],[1.22798,43.325809],[1.232375,43.328467],[1.235366,43.330224],[1.237425,43.331349],[1.24093,43.333481],[1.24565,43.336041],[1.246815,43.336756],[1.251603,43.339473],[1.260238,43.344615],[1.262349,43.345847],[1.263938,43.346952],[1.265274,43.348201],[1.26707,43.3505],[1.267979,43.352417],[1.27001,43.357715],[1.271344,43.361304],[1.272101,43.362883],[1.272984,43.365059],[1.275654,43.370382],[1.27751,43.373793],[1.278916,43.376538],[1.280668,43.380377],[1.282295,43.383544],[1.283524,43.386286],[1.287194,43.393907],[1.287631,43.394612],[1.288248,43.396302],[1.289324,43.398744],[1.291101,43.402258],[1.291586,43.403409],[1.292434,43.404886],[1.293779,43.408034],[1.295149,43.410613],[1.297422,43.413942],[1.298529,43.415754],[1.300353,43.419098],[1.303094,43.423458],[1.304352,43.425543],[1.307658,43.430781],[1.309075,43.4332],[1.309513,43.434524],[1.309728,43.436059],[1.309482,43.437998],[1.308648,43.44083],[1.308165,43.442716],[1.306505,43.448436],[1.305666,43.451667],[1.305601,43.453216],[1.305948,43.454698],[1.306591,43.455936],[1.307174,43.456692],[1.311078,43.460798],[1.31266,43.462864],[1.314259,43.46547],[1.319009,43.473655],[1.320255,43.475403],[1.320924,43.476138],[1.325361,43.480384],[1.326591,43.481936],[1.327592,43.483494],[1.330929,43.489644],[1.333003,43.492609],[1.334673,43.494504],[1.336315,43.49608],[1.338071,43.497478],[1.34044,43.499143],[1.343848,43.501161],[1.348978,43.50375],[1.350337,43.504232],[1.351888,43.504951],[1.35758,43.508262],[1.368811,43.514045],[1.370932,43.515365],[1.373372,43.517029],[1.374424,43.517874],[1.377624,43.520667],[1.379202,43.522232],[1.38442,43.527951],[1.387277,43.530812],[1.389462,43.533082],[1.393287,43.537279],[1.395742,43.539857],[1.398363,43.542387],[1.400489,43.544264],[1.404117,43.547829],[1.407842,43.551743],[1.411016,43.55547],[1.414931,43.55952],[1.417093,43.561594],[1.417897,43.562481],[1.41862,43.563581],[1.419046,43.564792],[1.419666,43.567047],[1.419567,43.568481],[1.418844,43.569258],[1.418101,43.569524],[1.417248,43.569528],[1.415604,43.569152],[1.414795,43.569299],[1.413264,43.569968],[1.412423,43.570609],[1.410686,43.57271],[1.408443,43.576155],[1.407203,43.578226],[1.404168,43.582963],[1.403118,43.584486],[1.400585,43.588491],[1.399729,43.590134],[1.397888,43.594013],[1.397331,43.595722],[1.397192,43.597706],[1.39769,43.599632],[1.398081,43.60047],[1.399342,43.602194],[1.400625,43.603368],[1.401461,43.603961],[1.404614,43.605696],[1.406345,43.606501],[1.41104,43.608493],[1.414838,43.610283],[1.415993,43.611127],[1.417678,43.612883],[1.418092,43.613678],[1.418482,43.615131],[1.418989,43.618199],[1.418859,43.619483],[1.417865,43.621818],[1.417874,43.62338],[1.418463,43.624862],[1.419641,43.626416],[1.420168,43.627656],[1.420363,43.629608],[1.421055,43.63525],[1.421855,43.640589],[1.421923,43.641627],[1.421795,43.644136],[1.42179,43.64813],[1.422131,43.649778],[1.422975,43.651032],[1.424471,43.65248],[1.425571,43.653284],[1.426686,43.653619],[1.428327,43.653659],[1.429683,43.654084],[1.430107,43.654567],[1.430095,43.655404],[1.429246,43.65639],[1.427978,43.658559],[1.427641,43.65887],[1.425997,43.659711],[1.425019,43.660578],[1.424327,43.661731],[1.422367,43.665515],[1.420888,43.667882],[1.418414,43.671368],[1.416416,43.674799],[1.415306,43.677336],[1.414633,43.679244],[1.413938,43.681839],[1.411806,43.688885],[1.410604,43.692078],[1.408991,43.695662],[1.408427,43.697173],[1.407438,43.700382],[1.405747,43.704718],[1.405252,43.706172],[1.402999,43.713826],[1.398584,43.728415],[1.397854,43.730474],[1.39653,43.733387],[1.394765,43.736321],[1.390494,43.742378],[1.389655,43.743741],[1.388606,43.745718],[1.387364,43.748654],[1.386477,43.751576],[1.38601,43.753945],[1.3858,43.755892],[1.385718,43.757613],[1.385741,43.764089],[1.385521,43.766604],[1.38506,43.769092],[1.384271,43.772539],[1.383675,43.776247],[1.383456,43.779638],[1.383389,43.782278],[1.383142,43.784546],[1.38275,43.78621],[1.382183,43.787736],[1.381226,43.789641],[1.380021,43.791442],[1.379138,43.792504],[1.376887,43.794593],[1.374592,43.796423],[1.371743,43.799039],[1.370244,43.800783],[1.369305,43.802109],[1.367698,43.804671],[1.366563,43.806336],[1.365328,43.807913],[1.363367,43.810156],[1.362431,43.811425],[1.362944,43.81183],[1.362904,43.812445],[1.363363,43.812434],[1.363837,43.811748],[1.364081,43.810522],[1.364417,43.810799],[1.363896,43.812464],[1.363371,43.812504],[1.363325,43.811543],[1.363529,43.810963],[1.364092,43.810515],[1.364477,43.810715],[1.363753,43.812911],[1.362742,43.812942],[1.36056,43.813862],[1.360458,43.813099],[1.360887,43.813576],[1.362246,43.813129],[1.362696,43.812494],[1.36325,43.812401],[1.363509,43.810915],[1.36413,43.810482],[1.364399,43.810751],[1.363749,43.812783],[1.362507,43.813051],[1.362806,43.811792],[1.361574,43.81181],[1.359654,43.812937],[1.356072,43.815169],[1.352117,43.81793],[1.349453,43.820254],[1.347612,43.822227],[1.346342,43.824098],[1.342888,43.828772],[1.34058,43.831553],[1.33828,43.833861],[1.335942,43.835899],[1.334926,43.836697],[1.331263,43.83932],[1.32771,43.841769],[1.325303,43.843667],[1.323826,43.8451],[1.322223,43.847003],[1.320802,43.849111],[1.319694,43.851312],[1.319116,43.852963],[1.318712,43.854687],[1.318412,43.857126],[1.318436,43.858917],[1.318809,43.863181],[1.318787,43.866566],[1.318525,43.869065],[1.318155,43.871252],[1.317405,43.874949],[1.317148,43.876492],[1.316954,43.878943],[1.316972,43.882084],[1.317515,43.888424],[1.317519,43.891096],[1.317256,43.893456],[1.316574,43.897325],[1.316328,43.89934],[1.316327,43.900917],[1.316574,43.902664],[1.316895,43.903975],[1.317432,43.905471],[1.318783,43.908824],[1.319249,43.910763],[1.319392,43.913192],[1.319267,43.914528],[1.318717,43.916951],[1.317791,43.919097],[1.31652,43.921133],[1.315289,43.922652],[1.313712,43.924233],[1.311243,43.92641],[1.311011,43.927499],[1.311911,43.928255],[1.313922,43.928496],[1.316518,43.928909],[1.319275,43.929139],[1.319974,43.929301],[1.320247,43.929788],[1.3194,43.930972],[1.319265,43.931903],[1.323163,43.944366],[1.32429,43.947822],[1.325355,43.951282],[1.326677,43.954748],[1.32752,43.957158],[1.328437,43.960245],[1.329991,43.964934],[1.331394,43.968962],[1.33305,43.974416],[1.333811,43.97754],[1.334965,43.981545],[1.335671,43.984891],[1.335653,43.988108],[1.335965,43.988936],[1.336534,43.989723],[1.337568,43.990498],[1.339129,43.991121],[1.343391,43.992179],[1.347295,43.992738],[1.348994,43.993193],[1.350944,43.994123],[1.353301,43.995782],[1.355036,43.9967],[1.356802,43.997232],[1.361243,43.997785],[1.362293,43.99813],[1.366537,44.00032],[1.368712,44.000887],[1.371933,44.001172],[1.373812,44.001412],[1.375923,44.001868],[1.377491,44.002397],[1.381175,44.004082],[1.382654,44.005499],[1.383239,44.006261],[1.385748,44.010595],[1.38654,44.012074],[1.387075,44.013614],[1.387698,44.016449],[1.387786,44.018678],[1.38764,44.020645],[1.38758,44.023863],[1.387745,44.025432],[1.387808,44.028085],[1.387773,44.030463],[1.387833,44.032635],[1.388098,44.03671],[1.388589,44.039342],[1.389526,44.041341],[1.39016,44.042327],[1.39113,44.043434],[1.393135,44.045074],[1.395499,44.04642],[1.398358,44.047616],[1.407548,44.051068],[1.40799,44.051355],[1.410631,44.052421],[1.414745,44.053941],[1.415975,44.054563],[1.417988,44.055906],[1.419312,44.057053],[1.420507,44.058329],[1.421708,44.059986],[1.422477,44.061679],[1.422999,44.063648],[1.423064,44.066309],[1.422718,44.068284],[1.422574,44.068443],[1.421892,44.070682],[1.419906,44.075218],[1.419518,44.078813],[1.419669,44.080566],[1.419961,44.082087],[1.42044,44.083578],[1.420921,44.084617],[1.421988,44.086439],[1.423984,44.088888],[1.425263,44.090112],[1.427326,44.091725],[1.429174,44.092862],[1.432443,44.094447],[1.43929,44.097239],[1.451742,44.102272],[1.455671,44.10406],[1.458174,44.105376],[1.461736,44.107498],[1.463532,44.108665],[1.466325,44.110732],[1.468134,44.112235],[1.470906,44.114729],[1.473912,44.117979],[1.475918,44.120627],[1.477718,44.12342],[1.479721,44.126148],[1.482553,44.129119],[1.483365,44.129802],[1.485491,44.131204],[1.489272,44.134024],[1.489952,44.134458],[1.493391,44.137022],[1.498184,44.140392],[1.498962,44.141032],[1.500807,44.142248],[1.505797,44.145784],[1.507852,44.147394],[1.510608,44.149802],[1.513278,44.152513],[1.515214,44.154781],[1.516663,44.156737],[1.518377,44.159316],[1.520309,44.162094],[1.521425,44.163444],[1.525923,44.16849],[1.525924,44.168727],[1.526987,44.170227],[1.529793,44.173607],[1.531337,44.176352],[1.533445,44.180982],[1.534115,44.182873],[1.534591,44.184581],[1.536195,44.191331],[1.537452,44.194951],[1.53811,44.196623],[1.540135,44.201138],[1.541296,44.204067],[1.541702,44.205543],[1.54203,44.207731],[1.542009,44.20929],[1.54182,44.210637],[1.541347,44.21264],[1.540671,44.214782],[1.539642,44.217725],[1.538078,44.221559],[1.536784,44.224039],[1.535902,44.225462],[1.53439,44.227655],[1.532888,44.229551],[1.532336,44.230583],[1.531317,44.231441],[1.529131,44.233832],[1.526409,44.236544],[1.523549,44.239144],[1.520562,44.241623],[1.515184,44.245769],[1.51377,44.247054],[1.512502,44.248396],[1.511264,44.250068],[1.509955,44.252477],[1.509256,44.254549],[1.506654,44.263044],[1.506245,44.265047],[1.505823,44.268185],[1.505709,44.270945],[1.505314,44.274123],[1.504698,44.278016],[1.504568,44.280392],[1.504692,44.282624],[1.505103,44.284138],[1.507018,44.288583],[1.507828,44.290736],[1.508754,44.294436],[1.509772,44.302027],[1.510113,44.303678],[1.511576,44.308372],[1.512009,44.310804],[1.511865,44.313675],[1.511272,44.315742],[1.510007,44.318233],[1.506381,44.323839],[1.503908,44.32774],[1.502145,44.331239],[1.501012,44.335131],[1.49997,44.343915],[1.499397,44.348202],[1.499192,44.349339],[1.498652,44.351136],[1.497234,44.354414],[1.496667,44.355913],[1.496098,44.358246],[1.495985,44.360966],[1.496061,44.36212],[1.496515,44.364332],[1.497171,44.366081],[1.498341,44.368209],[1.499047,44.369238],[1.500374,44.370826],[1.501493,44.371962],[1.50342,44.37357],[1.506246,44.375621],[1.50929,44.378007],[1.511009,44.379711],[1.512079,44.380917],[1.513575,44.382945],[1.514993,44.385783],[1.515674,44.387341],[1.516244,44.389353],[1.516925,44.392836],[1.517407,44.394615],[1.518439,44.396805],[1.519584,44.39836],[1.520942,44.399881],[1.522333,44.401255],[1.523102,44.402279],[1.523887,44.403952],[1.524175,44.405302],[1.524215,44.406421],[1.523974,44.407946],[1.523234,44.409648],[1.522168,44.411051],[1.521224,44.411969],[1.518886,44.413517],[1.515885,44.415088],[1.514925,44.41566],[1.513616,44.416652],[1.512713,44.417586],[1.511423,44.419604],[1.510938,44.421027],[1.510499,44.422962],[1.510045,44.424258],[1.50927,44.425621],[1.508352,44.426743],[1.506095,44.428926],[1.504843,44.430544],[1.504278,44.431624],[1.503905,44.432749],[1.50369,44.434146],[1.503628,44.435979],[1.504078,44.438327],[1.505438,44.443336],[1.505918,44.446043],[1.50608,44.447617],[1.506113,44.450879],[1.505796,44.452587],[1.505434,44.453642],[1.50346,44.457503],[1.502904,44.458741],[1.502331,44.460616],[1.502115,44.461916],[1.502015,44.463621],[1.502135,44.465003],[1.502469,44.466351],[1.50323,44.468449],[1.504274,44.470836],[1.504968,44.472973],[1.505247,44.475217],[1.505131,44.476841],[1.504776,44.478254],[1.503726,44.480353],[1.503145,44.481252],[1.501683,44.482894],[1.499429,44.485004],[1.497434,44.487048],[1.496089,44.488915],[1.495159,44.490644],[1.494337,44.492959],[1.494038,44.494804],[1.493961,44.495956],[1.494062,44.497713],[1.494367,44.499353],[1.495778,44.502779],[1.496824,44.504568],[1.498509,44.506758],[1.502325,44.510912],[1.505353,44.514527],[1.507534,44.517609],[1.509184,44.520466],[1.510127,44.522375],[1.511463,44.525838],[1.512025,44.527785],[1.512606,44.530388],[1.512934,44.532969],[1.513385,44.535783],[1.514225,44.539494],[1.51592,44.545545],[1.51708,44.549818],[1.5173,44.550929],[1.517359,44.552941],[1.517186,44.554436],[1.516633,44.556522],[1.516128,44.557715],[1.513974,44.562007],[1.513284,44.56383],[1.512537,44.567159],[1.512316,44.569908],[1.512317,44.571353],[1.51278,44.574509],[1.513253,44.576252],[1.514977,44.580815],[1.515494,44.582795],[1.515754,44.585394],[1.515529,44.587221],[1.514852,44.589553],[1.514161,44.591044],[1.513456,44.592216],[1.512564,44.593404],[1.511099,44.594978],[1.507677,44.598212],[1.504731,44.601511],[1.502773,44.604437],[1.501791,44.606408],[1.501025,44.608555],[1.500285,44.611521],[1.500144,44.613223],[1.500359,44.615212],[1.500934,44.616928],[1.5018,44.618607],[1.503289,44.620549],[1.504617,44.621789],[1.505686,44.622597],[1.507322,44.623634],[1.509745,44.62475],[1.514829,44.626848],[1.517254,44.628084],[1.519546,44.629585],[1.523267,44.632821],[1.525381,44.634442],[1.52833,44.636136],[1.529693,44.636727],[1.532254,44.637677],[1.53921,44.639837],[1.548594,44.642277],[1.550622,44.642949],[1.553293,44.644119],[1.555482,44.645394],[1.55705,44.64654],[1.558613,44.647941],[1.55981,44.649241],[1.563703,44.654355],[1.565886,44.657755],[1.566811,44.659439],[1.567929,44.661804],[1.569939,44.667194],[1.570594,44.669708],[1.571115,44.672213],[1.571483,44.67499],[1.571675,44.677309],[1.571656,44.681212],[1.571474,44.68528],[1.571541,44.687169],[1.571772,44.689252],[1.57315,44.696417],[1.573347,44.697993],[1.573406,44.700337],[1.57295,44.704277],[1.572705,44.70561],[1.572083,44.707559],[1.57005,44.712627],[1.567787,44.716051],[1.566759,44.717447],[1.565124,44.719364],[1.561702,44.722785],[1.559505,44.725059],[1.558569,44.726259],[1.557368,44.728277],[1.556458,44.730666],[1.556058,44.732704],[1.556041,44.733793],[1.555576,44.736664],[1.554797,44.73859],[1.55364,44.740493],[1.553012,44.741263],[1.551488,44.742713],[1.55,44.743893],[1.547668,44.74537],[1.546345,44.746324],[1.544185,44.74815],[1.542834,44.749601],[1.541644,44.751309],[1.540772,44.752947],[1.540322,44.754026],[1.539804,44.75597],[1.539601,44.757761],[1.539648,44.759528],[1.540003,44.763709],[1.539964,44.766352],[1.539839,44.767427],[1.53905,44.770508],[1.537611,44.77341],[1.536354,44.775395],[1.533056,44.778936],[1.531532,44.780836],[1.530744,44.782552],[1.530331,44.784422],[1.528305,44.787748],[1.527434,44.788714],[1.526064,44.789955],[1.524282,44.791341],[1.523764,44.791499],[1.522038,44.792445],[1.515749,44.795367],[1.512546,44.797083],[1.510231,44.798916],[1.509127,44.800001],[1.507227,44.802353],[1.505503,44.805733],[1.50445,44.808001],[1.504339,44.808981],[1.503062,44.811743],[1.50094,44.815906],[1.499726,44.817975],[1.496982,44.822318],[1.496076,44.82426],[1.495567,44.826475],[1.495436,44.828456],[1.496201,44.833066],[1.495924,44.83563],[1.495432,44.837145],[1.4944,44.839001],[1.492234,44.841702],[1.491677,44.842742],[1.491251,44.844478],[1.491273,44.846252],[1.49172,44.847833],[1.492134,44.848707],[1.493333,44.850318],[1.494511,44.851434],[1.496675,44.853197],[1.498239,44.854639],[1.500133,44.856958],[1.50091,44.858216],[1.501672,44.859713],[1.503197,44.864442],[1.503791,44.865656],[1.505678,44.868662],[1.506731,44.870889],[1.507261,44.872894],[1.507397,44.874491],[1.507123,44.877138],[1.506618,44.878939],[1.505399,44.882391],[1.505011,44.88327],[1.503542,44.887444],[1.50211,44.892959],[1.501577,44.896184],[1.500649,44.902333],[1.499847,44.908748],[1.499203,44.913594],[1.498772,44.916398],[1.498547,44.91865],[1.498535,44.921228],[1.498999,44.923438],[1.499419,44.924724],[1.500412,44.92713],[1.501878,44.930137],[1.502913,44.932481],[1.503237,44.933901],[1.503464,44.936345],[1.503116,44.938325],[1.502184,44.942078],[1.501681,44.944378],[1.501433,44.946587],[1.501436,44.948588],[1.501716,44.950641],[1.502345,44.952776],[1.503087,44.954571],[1.504371,44.956826],[1.505561,44.958419],[1.506791,44.959781],[1.508511,44.961344],[1.511134,44.963366],[1.515737,44.966373],[1.518363,44.968513],[1.519626,44.969843],[1.521452,44.972292],[1.522343,44.974013],[1.522931,44.975916],[1.523794,44.97938],[1.524627,44.983027],[1.524854,44.983761],[1.525803,44.987989],[1.526479,44.989415],[1.527077,44.991048],[1.527508,44.993423],[1.528031,44.995131],[1.529597,44.99912],[1.531235,45.002755],[1.532975,45.006145],[1.533402,45.007249],[1.534561,45.009671],[1.535493,45.01188],[1.535823,45.013004],[1.536065,45.015013],[1.536014,45.016827],[1.535841,45.017969],[1.535405,45.019551],[1.534151,45.02218],[1.533137,45.023597],[1.530002,45.02721],[1.528579,45.029277],[1.527518,45.031175],[1.526564,45.033531],[1.524957,45.036708],[1.523528,45.039158],[1.522004,45.041295],[1.51996,45.043697],[1.518629,45.045112],[1.516219,45.047491],[1.513583,45.050005],[1.511409,45.052218],[1.509871,45.054009],[1.509153,45.055],[1.507978,45.057107],[1.507227,45.058835],[1.506638,45.060637],[1.506313,45.062234],[1.506214,45.064032],[1.506397,45.065632],[1.506757,45.066973],[1.507444,45.068475],[1.508845,45.070922],[1.509465,45.071761],[1.51073,45.073066],[1.511762,45.074517],[1.513975,45.07927],[1.51412,45.080136],[1.513997,45.08232],[1.514553,45.083659],[1.515748,45.084823],[1.518105,45.086394],[1.518887,45.087374],[1.519287,45.088254],[1.519787,45.09247],[1.520221,45.097617],[1.520106,45.098606],[1.518764,45.101698],[1.517779,45.104268],[1.516008,45.106354],[1.51428,45.107233],[1.513115,45.107439],[1.510629,45.107475],[1.509132,45.107673],[1.507597,45.108443],[1.505914,45.109765],[1.505182,45.110167],[1.502724,45.110943],[1.501089,45.111685],[1.500562,45.112131],[1.499896,45.113259],[1.499951,45.114176],[1.501029,45.117961],[1.501159,45.119225],[1.500969,45.120064],[1.500201,45.121466],[1.499539,45.122205],[1.496829,45.124236],[1.494368,45.126159],[1.493207,45.127433],[1.492634,45.128355],[1.492002,45.130258],[1.491896,45.131777],[1.492043,45.13278],[1.492178,45.135126],[1.491932,45.136369],[1.491437,45.137406],[1.490349,45.138734],[1.487906,45.140838],[1.487282,45.141537],[1.486628,45.142719],[1.484134,45.151962],[1.48302,45.156246],[1.482023,45.157972],[1.479886,45.160749],[1.479256,45.162361],[1.479223,45.163401],[1.479432,45.164232],[1.480193,45.16562],[1.482711,45.168318],[1.488419,45.17413],[1.490134,45.17656],[1.490884,45.17842],[1.491291,45.180169],[1.491868,45.183989],[1.491969,45.185034],[1.492394,45.18716],[1.492764,45.188456],[1.49329,45.189501],[1.494436,45.191022],[1.495808,45.19224],[1.50154,45.19609],[1.505418,45.198772],[1.511923,45.202547],[1.513199,45.203456],[1.514728,45.205059],[1.515446,45.206241],[1.516032,45.207741],[1.516231,45.209061],[1.516189,45.210129],[1.515756,45.211855],[1.514136,45.215896],[1.513742,45.217053],[1.511353,45.222789],[1.51115,45.223937],[1.511195,45.225417],[1.512021,45.228503],[1.512567,45.229908],[1.513568,45.233019],[1.513657,45.2336],[1.513468,45.23537],[1.512933,45.237434],[1.512846,45.241908],[1.513022,45.242792],[1.51345,45.243674],[1.514123,45.244485],[1.515319,45.245389],[1.516479,45.245948],[1.517804,45.246332],[1.519983,45.246536],[1.522872,45.246366],[1.52524,45.24646],[1.526926,45.246795],[1.530374,45.248012],[1.533856,45.249333],[1.538625,45.251061],[1.540461,45.252143],[1.541789,45.253652],[1.544506,45.260039],[1.545579,45.261862],[1.54667,45.263],[1.551203,45.266445],[1.553267,45.268357],[1.557288,45.27365],[1.558802,45.275524],[1.559946,45.276737],[1.561864,45.27859],[1.563881,45.280271],[1.568475,45.283756],[1.569953,45.285086],[1.571108,45.286371],[1.572346,45.288113],[1.573234,45.289712],[1.573808,45.291322],[1.574216,45.294066],[1.574091,45.296183],[1.573636,45.298844],[1.573573,45.300271],[1.57382,45.302194],[1.574285,45.30385],[1.574989,45.305587],[1.575366,45.306189],[1.576266,45.30698],[1.5771,45.307316],[1.578044,45.307432],[1.578999,45.307322],[1.580734,45.30668],[1.582466,45.30586],[1.584855,45.304433],[1.586287,45.303381],[1.588538,45.301352],[1.590407,45.299433],[1.596045,45.293914],[1.597424,45.292679],[1.600018,45.290805],[1.602428,45.28919],[1.604969,45.287371],[1.610354,45.283662],[1.610867,45.282596],[1.610896,45.281117],[1.611449,45.280457],[1.612118,45.280198],[1.613314,45.280177],[1.614342,45.28067],[1.617412,45.283749],[1.619416,45.285859],[1.620697,45.286748],[1.622521,45.287749],[1.623882,45.288355],[1.627186,45.289368],[1.629206,45.289795],[1.633067,45.290456],[1.635285,45.290961],[1.638243,45.291956],[1.639709,45.292617],[1.642243,45.293997],[1.642836,45.294523],[1.645691,45.296644],[1.648896,45.299318],[1.651592,45.301195],[1.655154,45.303156],[1.655957,45.30345],[1.658025,45.304479],[1.662311,45.305877],[1.664185,45.306374],[1.669031,45.307294],[1.670792,45.307399],[1.674783,45.307445],[1.676808,45.307279],[1.679709,45.306932],[1.681548,45.306828],[1.685136,45.306865],[1.688277,45.307187],[1.691726,45.30792],[1.693435,45.308375],[1.697275,45.309034],[1.699953,45.309326],[1.705123,45.309759],[1.708699,45.310491],[1.710156,45.310928],[1.712634,45.311884],[1.717705,45.314442],[1.719604,45.315228],[1.722841,45.316073],[1.725593,45.316403],[1.728924,45.316341],[1.73271,45.31594],[1.734503,45.315846],[1.736721,45.315923],[1.738076,45.316123],[1.740129,45.316649],[1.741351,45.317085],[1.743917,45.318475],[1.744844,45.31919],[1.747665,45.321817],[1.748852,45.322837],[1.751112,45.324393],[1.7525,45.325236],[1.754446,45.326247],[1.756673,45.326973],[1.757391,45.326932],[1.75873,45.326572],[1.759266,45.327158],[1.759159,45.328698],[1.759393,45.329593],[1.759856,45.33009],[1.760625,45.330217],[1.76301,45.329306],[1.767712,45.327607],[1.768531,45.327569],[1.768759,45.327227],[1.768925,45.324215],[1.768706,45.323068],[1.769087,45.322627],[1.769262,45.323066],[1.768973,45.324187],[1.768875,45.327419],[1.769123,45.327801],[1.764318,45.330272],[1.76261,45.331447],[1.761019,45.333244],[1.759495,45.333894],[1.757268,45.334259],[1.754661,45.334085],[1.754543,45.333708],[1.755262,45.333415],[1.756372,45.333521],[1.757157,45.334114],[1.759615,45.333793],[1.761011,45.333138],[1.762399,45.331502],[1.763238,45.330782],[1.765386,45.329602],[1.767998,45.328309],[1.768452,45.327998],[1.768326,45.327613],[1.767769,45.327617],[1.766045,45.328251],[1.764475,45.328947],[1.761078,45.330142],[1.760301,45.330164],[1.75963,45.329849],[1.759108,45.329041],[1.759158,45.326902],[1.758494,45.326472],[1.758002,45.327039],[1.758427,45.32738],[1.760322,45.327777],[1.763167,45.327875],[1.764555,45.32778],[1.766864,45.327394],[1.769908,45.326459],[1.773231,45.324875],[1.774298,45.324461],[1.776294,45.323894],[1.779747,45.323293],[1.782471,45.322284],[1.784126,45.321299],[1.785312,45.320276],[1.788104,45.317321],[1.790526,45.315616],[1.792943,45.314482],[1.794127,45.314038],[1.796298,45.31342],[1.797594,45.313173],[1.79983,45.31291],[1.801598,45.312854],[1.80476,45.31296],[1.807008,45.312817],[1.808918,45.312474],[1.810258,45.312065],[1.811875,45.311336],[1.813133,45.31056],[1.816222,45.308021],[1.818961,45.306683],[1.820367,45.306241],[1.822169,45.305894],[1.824345,45.305688],[1.825726,45.305667],[1.827385,45.305809],[1.830468,45.306504],[1.83201,45.307138],[1.836101,45.30925],[1.838767,45.31032],[1.841112,45.310934],[1.843281,45.311298],[1.847489,45.31165],[1.85106,45.312063],[1.85234,45.31229],[1.855262,45.313022],[1.859439,45.314303],[1.862353,45.314998],[1.86587,45.315435],[1.869833,45.315662],[1.872367,45.315865],[1.874502,45.316149],[1.877338,45.316748],[1.880083,45.317592],[1.882773,45.318831],[1.884456,45.319852],[1.886261,45.321166],[1.88811,45.322865],[1.889102,45.324006],[1.890582,45.326309],[1.89221,45.329707],[1.893592,45.332041],[1.894692,45.333411],[1.896175,45.334867],[1.897659,45.336087],[1.900383,45.338022],[1.902129,45.339388],[1.903493,45.340641],[1.904685,45.34199],[1.906749,45.344559],[1.90837,45.346235],[1.910185,45.347556],[1.911486,45.348292],[1.912898,45.348927],[1.91468,45.349563],[1.918641,45.350752],[1.921029,45.351569],[1.922681,45.35226],[1.925471,45.353808],[1.927113,45.354938],[1.930767,45.358116],[1.932605,45.359454],[1.934617,45.360538],[1.935985,45.36112],[1.938092,45.361764],[1.940357,45.362211],[1.942587,45.36243],[1.945439,45.362619],[1.948837,45.363101],[1.951576,45.364011],[1.953276,45.364936],[1.95533,45.366525],[1.957993,45.368905],[1.959817,45.370093],[1.963067,45.371829],[1.964456,45.372722],[1.965904,45.373869],[1.967737,45.375915],[1.96998,45.378967],[1.971427,45.38047],[1.973524,45.382046],[1.976521,45.383941],[1.97748,45.384692],[1.979164,45.386466],[1.979852,45.387556],[1.980454,45.38896],[1.980771,45.390485],[1.98109,45.392823],[1.981333,45.393765],[1.982219,45.39537],[1.983507,45.396696],[1.984888,45.397632],[1.987073,45.398569],[1.989729,45.399119],[1.995271,45.399558],[1.998693,45.400172],[2.000675,45.400802],[2.002291,45.401515],[2.003843,45.402389],[2.00577,45.403808],[2.008898,45.406507],[2.010195,45.407545],[2.012074,45.408734],[2.01386,45.409671],[2.015721,45.410497],[2.018874,45.411537],[2.026028,45.413402],[2.028235,45.414031],[2.030509,45.414797],[2.033595,45.416105],[2.036029,45.41766],[2.037995,45.419581],[2.039213,45.421352],[2.039919,45.422845],[2.040698,45.426197],[2.04169,45.428285],[2.043319,45.430376],[2.044372,45.432194],[2.044996,45.433971],[2.045593,45.435075],[2.046665,45.436207],[2.047769,45.437033],[2.049304,45.437826],[2.050735,45.438309],[2.051942,45.438563],[2.056984,45.439092],[2.059325,45.439527],[2.060892,45.44001],[2.062661,45.440794],[2.06364,45.441363],[2.065252,45.442533],[2.066212,45.443427],[2.067169,45.444609],[2.067796,45.445759],[2.068337,45.447402],[2.069019,45.451135],[2.0695,45.452201],[2.070347,45.453435],[2.072086,45.455034],[2.073538,45.455915],[2.075739,45.456775],[2.077619,45.457194],[2.081392,45.457752],[2.082882,45.458199],[2.08423,45.458819],[2.087387,45.460762],[2.089321,45.461569],[2.090521,45.461853],[2.092721,45.46201],[2.095155,45.46174],[2.097516,45.461176],[2.099202,45.460882],[2.100584,45.460786],[2.102403,45.460863],[2.103759,45.461071],[2.105488,45.461683],[2.106539,45.46221],[2.107669,45.462985],[2.110196,45.465038],[2.111507,45.465833],[2.113025,45.466592],[2.116013,45.467903],[2.117327,45.468559],[2.119293,45.469763],[2.122255,45.471922],[2.124121,45.473139],[2.126763,45.474466],[2.128978,45.475305],[2.131578,45.476045],[2.133104,45.476365],[2.135928,45.476752],[2.138477,45.476925],[2.142833,45.477072],[2.146269,45.477388],[2.148368,45.477736],[2.151484,45.478534],[2.153377,45.479201],[2.155343,45.480075],[2.156968,45.480953],[2.158666,45.482053],[2.16268,45.485238],[2.16402,45.486205],[2.16629,45.487483],[2.169062,45.48859],[2.171116,45.489178],[2.173236,45.489582],[2.179545,45.490397],[2.182999,45.491198],[2.184856,45.491805],[2.186594,45.492536],[2.188448,45.493457],[2.190534,45.494753],[2.192678,45.496417],[2.194779,45.498829],[2.197541,45.502847],[2.198394,45.50398],[2.199438,45.505099],[2.200876,45.506363],[2.203224,45.507909],[2.205037,45.508843],[2.206724,45.509512],[2.209699,45.510391],[2.211863,45.510802],[2.213466,45.510986],[2.216091,45.511121],[2.220069,45.511197],[2.222001,45.511317],[2.224903,45.511796],[2.227674,45.512645],[2.230971,45.513813],[2.232815,45.514313],[2.235678,45.514778],[2.238724,45.515057],[2.241203,45.515434],[2.245304,45.516393],[2.248272,45.516938],[2.25143,45.51726],[2.253133,45.517293],[2.255943,45.517214],[2.25757,45.517071],[2.260101,45.516691],[2.261621,45.516376],[2.263719,45.515785],[2.266981,45.514752],[2.270196,45.513848],[2.273974,45.513255],[2.276837,45.513116],[2.278768,45.513165],[2.281377,45.513486],[2.284927,45.514209],[2.288371,45.515162],[2.29154,45.515752],[2.294014,45.515857],[2.295519,45.515783],[2.298447,45.515391],[2.300426,45.514913],[2.305236,45.513543],[2.306771,45.513281],[2.309334,45.513069],[2.311881,45.513191],[2.314969,45.513703],[2.317121,45.514355],[2.317789,45.514393],[2.319167,45.513843],[2.318877,45.513613],[2.317745,45.513921],[2.316612,45.513858],[2.316774,45.513438],[2.318258,45.513443],[2.318049,45.513905],[2.316512,45.51379],[2.316931,45.513409],[2.31834,45.513489],[2.318144,45.513855],[2.316605,45.513804],[2.316664,45.51344],[2.318353,45.513443],[2.317932,45.513892],[2.316715,45.513856],[2.316439,45.51355],[2.317048,45.513379],[2.318476,45.513489],[2.318023,45.513884],[2.316563,45.513856],[2.316834,45.513392],[2.318767,45.5135],[2.319332,45.513637],[2.319274,45.514011],[2.318383,45.514606],[2.318617,45.515038],[2.320504,45.516358],[2.321609,45.517252],[2.325031,45.521343],[2.326583,45.522803],[2.327793,45.523704],[2.329199,45.52453],[2.33067,45.525202],[2.33232,45.525793],[2.33544,45.526528],[2.339578,45.527195],[2.342361,45.527794],[2.344445,45.528433],[2.346055,45.529031],[2.347634,45.52975],[2.349737,45.531062],[2.35146,45.532441],[2.352516,45.53341],[2.354771,45.535969],[2.355507,45.536936],[2.356904,45.539087],[2.357864,45.54086],[2.359948,45.544362],[2.362036,45.547141],[2.363915,45.549153],[2.366818,45.552035],[2.369038,45.55462],[2.370591,45.556903],[2.371569,45.558869],[2.372044,45.560051],[2.373669,45.565607],[2.37486,45.568185],[2.376032,45.56993],[2.377644,45.571812],[2.379078,45.573132],[2.380812,45.574495],[2.382977,45.575774],[2.384883,45.576702],[2.386916,45.577518],[2.388749,45.578149],[2.392118,45.578991],[2.398548,45.58012],[2.404637,45.581105],[2.407196,45.581585],[2.410896,45.582515],[2.413989,45.583501],[2.416112,45.584337],[2.419416,45.585913],[2.421961,45.58737],[2.424688,45.589257],[2.426962,45.591185],[2.428272,45.592549],[2.429408,45.594032],[2.430067,45.595147],[2.431523,45.59861],[2.432209,45.600559],[2.433636,45.604065],[2.434608,45.605908],[2.435402,45.607032],[2.437092,45.608753],[2.438462,45.609768],[2.439836,45.610567],[2.441864,45.611571],[2.445948,45.613448],[2.451724,45.616249],[2.456467,45.618598],[2.45807,45.619315],[2.460729,45.620652],[2.463751,45.621932],[2.466652,45.622858],[2.470555,45.623454],[2.47299,45.623676],[2.47835,45.623829],[2.484393,45.62393],[2.487409,45.624126],[2.489203,45.624343],[2.491658,45.624809],[2.494313,45.625518],[2.501874,45.62841],[2.50327,45.628864],[2.506153,45.629553],[2.509321,45.630017],[2.512833,45.630152],[2.517135,45.629969],[2.518357,45.62983],[2.522064,45.629592],[2.526391,45.629455],[2.530809,45.62974],[2.532385,45.629942],[2.536157,45.630636],[2.538326,45.631205],[2.545509,45.633421],[2.548592,45.634261],[2.551166,45.634803],[2.558468,45.635979],[2.563067,45.636849],[2.565624,45.637512],[2.570245,45.638918],[2.574186,45.639943],[2.576677,45.640409],[2.579812,45.640857],[2.587343,45.641634],[2.592812,45.642291],[2.596258,45.642911],[2.599038,45.643667],[2.603586,45.645193],[2.605819,45.646151],[2.609673,45.648013],[2.611424,45.648749],[2.61242,45.64902],[2.613525,45.649556],[2.615614,45.650309],[2.617971,45.651036],[2.619265,45.651525],[2.619712,45.65149],[2.622678,45.652353],[2.624157,45.652582],[2.624901,45.652926],[2.627374,45.653708],[2.629767,45.654571],[2.631744,45.65537],[2.632214,45.655412],[2.633948,45.656105],[2.635447,45.656508],[2.640361,45.65756],[2.646488,45.65856],[2.649442,45.659144],[2.651402,45.659711],[2.655097,45.661047],[2.657589,45.662516],[2.661064,45.665084],[2.662713,45.666186],[2.665542,45.667786],[2.668501,45.668995],[2.670085,45.669401],[2.671024,45.669842],[2.673878,45.670437],[2.678549,45.671312],[2.68091,45.671819],[2.682838,45.672331],[2.685426,45.673242],[2.688893,45.67511],[2.691552,45.67705],[2.693148,45.678718],[2.69432,45.680238],[2.695439,45.682287],[2.696186,45.684436],[2.696372,45.685327],[2.696497,45.687059],[2.696233,45.689651],[2.695647,45.691906],[2.69471,45.695072],[2.69441,45.696934],[2.694516,45.699019],[2.695217,45.701649],[2.695854,45.703295],[2.696335,45.705014],[2.696582,45.706775],[2.696287,45.708764],[2.69631,45.709593],[2.695793,45.711569],[2.694759,45.713693],[2.693915,45.715708],[2.693492,45.717218],[2.693275,45.71986],[2.693413,45.721695],[2.694452,45.724551],[2.695546,45.726416],[2.697532,45.728764],[2.698933,45.730081],[2.70291,45.732843],[2.703989,45.73365],[2.70543,45.734947],[2.706043,45.735353],[2.707287,45.736847],[2.707962,45.737436],[2.709274,45.739109],[2.712446,45.744236],[2.713387,45.745589],[2.714917,45.747343],[2.717159,45.749394],[2.718837,45.750613],[2.72235,45.753014],[2.725458,45.755402],[2.727495,45.757886],[2.729159,45.760904],[2.730006,45.764111],[2.730203,45.765243],[2.730968,45.767196],[2.731634,45.768632],[2.732151,45.769438],[2.734166,45.771705],[2.736424,45.773713],[2.737981,45.774776],[2.739086,45.77597],[2.740389,45.776982],[2.741149,45.778074],[2.742652,45.779949],[2.744604,45.782552],[2.745795,45.783842],[2.747442,45.785265],[2.748713,45.786228],[2.750403,45.78725],[2.751988,45.788067],[2.756091,45.789749],[2.759541,45.791445],[2.760799,45.79225],[2.762483,45.793521],[2.7639,45.794845],[2.76522,45.796533],[2.766313,45.79824],[2.766805,45.799262],[2.767333,45.800773],[2.767584,45.801891],[2.767828,45.803907],[2.767918,45.805903],[2.768173,45.8081],[2.768906,45.810582],[2.769561,45.812094],[2.77058,45.813714],[2.77134,45.81469],[2.773315,45.816682],[2.774898,45.817994],[2.776672,45.819211],[2.780281,45.821095],[2.783636,45.822433],[2.785106,45.822829],[2.78666,45.823006],[2.789572,45.823495],[2.792784,45.823909],[2.796395,45.82456],[2.798251,45.825043],[2.800304,45.825744],[2.802756,45.826858],[2.805142,45.828209],[2.806727,45.829307],[2.809246,45.830729],[2.811952,45.83202],[2.818581,45.834179],[2.820305,45.834791],[2.822967,45.83604],[2.825208,45.837379],[2.826847,45.838515],[2.829139,45.840876],[2.83082,45.843329],[2.832234,45.846009],[2.832967,45.847011],[2.834951,45.84897],[2.836377,45.849983],[2.838973,45.851302],[2.841807,45.852228],[2.843766,45.852642],[2.845558,45.852854],[2.848359,45.853049],[2.851952,45.853085],[2.854081,45.853388],[2.856766,45.853942],[2.858776,45.854488],[2.861291,45.855303],[2.863159,45.85628],[2.866364,45.857801],[2.867975,45.858462],[2.869663,45.859014],[2.872889,45.85977],[2.878405,45.860507],[2.8811,45.861099],[2.884413,45.862187],[2.886857,45.863273],[2.889172,45.864636],[2.893234,45.867421],[2.895259,45.868477],[2.899772,45.870556],[2.901608,45.871484],[2.904169,45.873312],[2.907197,45.876142],[2.909361,45.87798],[2.912125,45.879749],[2.914577,45.880961],[2.91572,45.881439],[2.919745,45.882768],[2.923239,45.884061],[2.924876,45.884807],[2.926877,45.885958],[2.928672,45.887253],[2.929889,45.888263],[2.931646,45.890083],[2.933203,45.892034],[2.93506,45.894794],[2.936073,45.896165],[2.937563,45.897846],[2.938821,45.899104],[2.941246,45.901262],[2.943165,45.902439],[2.945707,45.904142],[2.949033,45.906241],[2.949383,45.906281],[2.951944,45.907927],[2.95436,45.910239],[2.956048,45.912159],[2.956961,45.913374],[2.958043,45.915105],[2.95872,45.916451],[2.959676,45.918772],[2.960209,45.920995],[2.960476,45.924249],[2.960247,45.927502],[2.960211,45.931011],[2.961025,45.933921],[2.962127,45.936144],[2.963658,45.93812],[2.96536,45.939768],[2.967857,45.941631],[2.969666,45.942622],[2.974979,45.944986],[2.977799,45.946465],[2.979954,45.947872],[2.979994,45.948087],[2.981218,45.949194],[2.982852,45.950213],[2.985792,45.952752],[2.986461,45.953476],[2.988454,45.954906],[2.98912,45.955137],[2.990764,45.956211],[2.99316,45.957161],[2.994943,45.957997],[2.997329,45.958528],[3.001261,45.958976],[3.004014,45.959088],[3.010245,45.959026],[3.01302,45.959132],[3.017189,45.95977],[3.018443,45.960039],[3.020649,45.960745],[3.024579,45.962473],[3.028115,45.96389],[3.032957,45.965194],[3.03364,45.965235],[3.036012,45.965745],[3.038414,45.966021],[3.041423,45.966235],[3.045654,45.966153],[3.051905,45.965718],[3.05345,45.965664],[3.05699,45.965829],[3.060375,45.966438],[3.063649,45.967361],[3.06515,45.9679],[3.068275,45.969315],[3.070995,45.970774],[3.07409,45.971727],[3.078695,45.972817],[3.080808,45.973583],[3.082496,45.974341],[3.083935,45.974739],[3.087336,45.975077],[3.088506,45.975067],[3.091758,45.974685],[3.095772,45.973655],[3.099039,45.972705],[3.101007,45.972666],[3.102915,45.973386],[3.102964,45.974146],[3.10275,45.975434],[3.102287,45.976345],[3.102338,45.977316],[3.103176,45.979009],[3.104349,45.980618],[3.106717,45.983539],[3.107683,45.984574],[3.109042,45.9868],[3.109675,45.988287],[3.109792,45.989886],[3.10957,45.992643],[3.109259,45.994666],[3.10914,45.996193],[3.109154,45.998367],[3.109475,46.000867],[3.109916,46.00249],[3.110898,46.00473],[3.112284,46.00731],[3.114736,46.010788],[3.11588,46.012013],[3.117385,46.014005],[3.118062,46.0151],[3.11877,46.016775],[3.119112,46.018034],[3.119302,46.019435],[3.119295,46.020471],[3.119087,46.021993],[3.118727,46.02332],[3.118026,46.025297],[3.116869,46.027986],[3.115722,46.030951],[3.115169,46.032183],[3.114052,46.0353],[3.113347,46.038251],[3.112646,46.042403],[3.112405,46.046843],[3.112479,46.049293],[3.112645,46.050884],[3.113193,46.054673],[3.113941,46.057796],[3.114605,46.059922],[3.115768,46.062541],[3.11653,46.064025],[3.118738,46.067455],[3.11945,46.068891],[3.119813,46.069929],[3.120076,46.072136],[3.120167,46.074449],[3.120595,46.076263],[3.121259,46.077626],[3.122451,46.079132],[3.123189,46.079789],[3.127594,46.08291],[3.129297,46.084202],[3.131287,46.085965],[3.132705,46.087446],[3.133806,46.088758],[3.135739,46.091682],[3.137529,46.095035],[3.138633,46.097497],[3.139669,46.100019],[3.140363,46.102195],[3.140507,46.10414],[3.140359,46.105238],[3.139656,46.106979],[3.138807,46.10817],[3.137561,46.109613],[3.136176,46.110497],[3.130858,46.113334],[3.128773,46.114641],[3.127087,46.115859],[3.125145,46.117477],[3.119547,46.122978],[3.117685,46.125211],[3.116594,46.12669],[3.115591,46.128267],[3.114035,46.131378],[3.113105,46.134505],[3.112786,46.136651],[3.11271,46.138518],[3.112922,46.141471],[3.113507,46.143948],[3.114051,46.145618],[3.11507,46.147796],[3.116856,46.150685],[3.118024,46.152138],[3.120143,46.154342],[3.125544,46.159006],[3.127451,46.161089],[3.128928,46.163091],[3.129899,46.164868],[3.130705,46.166953],[3.130852,46.168251],[3.130741,46.169772],[3.129941,46.17186],[3.128721,46.173741],[3.127039,46.175536],[3.124423,46.177824],[3.120636,46.180637],[3.117262,46.182939],[3.114921,46.184751],[3.113319,46.186263],[3.111631,46.188069],[3.110727,46.189185],[3.107776,46.193812],[3.105258,46.19723],[3.103715,46.199068],[3.101865,46.201013],[3.100437,46.202647],[3.099356,46.204193],[3.098794,46.205192],[3.097816,46.207402],[3.097254,46.210153],[3.097201,46.211462],[3.097369,46.213401],[3.098386,46.217225],[3.098663,46.217991],[3.099716,46.221946],[3.100072,46.223832],[3.100268,46.226115],[3.100179,46.227796],[3.099928,46.229675],[3.099156,46.232463],[3.098575,46.234115],[3.097728,46.235902],[3.09595,46.238619],[3.09413,46.241084],[3.092521,46.242957],[3.089888,46.245688],[3.085837,46.24946],[3.082625,46.252211],[3.080902,46.253583],[3.078216,46.255587],[3.074796,46.257855],[3.071805,46.259739],[3.068736,46.261788],[3.065939,46.263898],[3.063183,46.266265],[3.060333,46.268923],[3.057193,46.272148],[3.054218,46.275556],[3.051174,46.279274],[3.05051,46.279973],[3.048215,46.282696],[3.046141,46.285335],[3.043132,46.288534],[3.04105,46.290276],[3.038974,46.291768],[3.036441,46.293371],[3.033866,46.294702],[3.028206,46.297238],[3.024578,46.298916],[3.022846,46.299802],[3.018807,46.302051],[3.013235,46.305238],[3.011118,46.306344],[3.008607,46.307518],[3.006281,46.308421],[3.002162,46.309809],[2.9987,46.31113],[2.996482,46.312123],[2.99314,46.313964],[2.992026,46.314674],[2.98889,46.317009],[2.986415,46.319531],[2.985598,46.320234],[2.982415,46.323686],[2.980584,46.325117],[2.977379,46.326852],[2.975444,46.327736],[2.971613,46.329034],[2.970701,46.329213],[2.96928,46.329975],[2.968718,46.330702],[2.968149,46.330989],[2.967394,46.331005],[2.9663,46.327622],[2.96668,46.326384],[2.967379,46.325436],[2.968009,46.325358],[2.968503,46.325879],[2.96808,46.326206],[2.968223,46.326599],[2.969204,46.327076],[2.969843,46.327862],[2.971213,46.329211],[2.973561,46.330961],[2.973681,46.33126],[2.97534,46.332778],[2.977631,46.334432],[2.978518,46.335243],[2.981489,46.337474],[2.983007,46.338901],[2.98429,46.340395],[2.985727,46.341743],[2.987003,46.342666],[2.992022,46.346659],[2.992772,46.347374],[2.995302,46.349374],[2.995864,46.349945],[3.000526,46.353192],[3.002952,46.355186],[3.007115,46.358485],[3.008822,46.359466],[3.010768,46.360083],[3.017714,46.361596],[3.020631,46.362357],[3.021624,46.363381],[3.023914,46.36518],[3.024999,46.366153],[3.026151,46.367495],[3.026977,46.368817],[3.027693,46.370667],[3.028833,46.374495],[3.033499,46.390546],[3.034083,46.39196],[3.035416,46.394],[3.036681,46.395312],[3.037788,46.396208],[3.039263,46.397159],[3.042268,46.398552],[3.044439,46.399196],[3.046465,46.399603],[3.048828,46.399858],[3.054677,46.399869],[3.056247,46.399972],[3.059085,46.400327],[3.062555,46.401039],[3.066113,46.402192],[3.068041,46.403003],[3.07029,46.404072],[3.073035,46.405188],[3.075618,46.406026],[3.078632,46.40681],[3.085336,46.408665],[3.094254,46.411274],[3.09601,46.411756],[3.098261,46.412547],[3.100152,46.41335],[3.102649,46.41464],[3.108197,46.417874],[3.109508,46.418573],[3.117037,46.422899],[3.121973,46.425766],[3.123892,46.426824],[3.130936,46.430885],[3.133938,46.43246],[3.13787,46.434445],[3.140826,46.436142],[3.144261,46.438445],[3.145973,46.439427],[3.147853,46.440246],[3.14931,46.440724],[3.151395,46.441227],[3.153592,46.441487],[3.156164,46.441542],[3.163293,46.441046],[3.184435,46.439405],[3.188815,46.439115],[3.191705,46.439105],[3.193573,46.439242],[3.195926,46.439568],[3.198005,46.440038],[3.200025,46.440659],[3.203073,46.441763],[3.206359,46.443074],[3.211722,46.44507],[3.213932,46.445955],[3.218438,46.447652],[3.221702,46.448818],[3.228735,46.451519],[3.23158,46.452563],[3.233409,46.45333],[3.237898,46.455775],[3.23938,46.456412],[3.241954,46.457286],[3.244169,46.45783],[3.247028,46.458226],[3.250897,46.458318],[3.258249,46.458157],[3.260191,46.458153],[3.266788,46.45803],[3.26842,46.458076],[3.27105,46.458361],[3.274494,46.459162],[3.276192,46.459732],[3.278291,46.460609],[3.288739,46.465478],[3.292073,46.467058],[3.300913,46.471161],[3.302284,46.471945],[3.304506,46.473412],[3.305989,46.474257],[3.307289,46.474784],[3.310538,46.475574],[3.312721,46.475764],[3.317109,46.475931],[3.318925,46.476161],[3.32073,46.476502],[3.322638,46.476997],[3.325426,46.478022],[3.327141,46.478836],[3.33248,46.481624],[3.341548,46.486402],[3.346532,46.488961],[3.352831,46.491792],[3.35586,46.492955],[3.360254,46.494523],[3.364818,46.495976],[3.369401,46.497271],[3.373027,46.498041],[3.375425,46.498409],[3.377592,46.498625],[3.380592,46.498742],[3.384304,46.498643],[3.388142,46.498389],[3.391927,46.498314],[3.394671,46.498495],[3.397616,46.498864],[3.407958,46.500874],[3.41376,46.50193],[3.426233,46.504338],[3.433962,46.505976],[3.440277,46.507528],[3.448561,46.509822],[3.455334,46.511917],[3.464727,46.514962],[3.471434,46.517088],[3.480543,46.520022],[3.485542,46.521677],[3.490858,46.523725],[3.493518,46.524894],[3.497251,46.526739],[3.500174,46.528262],[3.502866,46.529356],[3.504915,46.529935],[3.507708,46.530457],[3.515064,46.531376],[3.52116,46.53204],[3.52416,46.532496],[3.526812,46.533127],[3.530339,46.534277],[3.535049,46.535611],[3.53703,46.536023],[3.539704,46.536454],[3.543666,46.536877],[3.547902,46.537154],[3.551408,46.537045],[3.562224,46.536021],[3.569862,46.535278],[3.575707,46.534896],[3.581687,46.534627],[3.5843,46.534565],[3.58997,46.534532],[3.594973,46.534355],[3.606181,46.533479],[3.609756,46.533157],[3.610316,46.533043],[3.617139,46.532045],[3.620571,46.53149],[3.623221,46.531253],[3.626641,46.53128],[3.628786,46.531471],[3.631449,46.531912],[3.634003,46.532585],[3.63795,46.533773],[3.640092,46.53451],[3.645226,46.536086],[3.651117,46.537934],[3.652783,46.53842],[3.654551,46.53911],[3.658298,46.540009],[3.661498,46.540386],[3.674314,46.540981],[3.676407,46.54095],[3.679086,46.540688],[3.699391,46.536977],[3.704313,46.536156],[3.706745,46.535603],[3.708493,46.53499],[3.709949,46.53435],[3.714672,46.532051],[3.717577,46.530536],[3.718156,46.530306],[3.723355,46.52774],[3.728143,46.525473],[3.728891,46.525063],[3.737627,46.51907],[3.739161,46.518178],[3.741165,46.517296],[3.74355,46.516401],[3.752279,46.513554],[3.753315,46.513063],[3.758416,46.510849],[3.763335,46.508864],[3.767369,46.507736],[3.768586,46.507478],[3.778568,46.504854],[3.781243,46.503817],[3.784308,46.502395],[3.787863,46.500669],[3.79513,46.497203],[3.80131,46.494295],[3.804069,46.493377],[3.809872,46.491757],[3.811292,46.49145],[3.812246,46.491042],[3.817002,46.489684],[3.818787,46.488987],[3.819938,46.488414],[3.82181,46.487229],[3.826899,46.483105],[3.829315,46.481193],[3.830847,46.479856],[3.832057,46.478951],[3.834375,46.477619],[3.835803,46.477019],[3.845293,46.473733],[3.846772,46.473313],[3.848915,46.472918],[3.852145,46.472668],[3.858737,46.472684],[3.865491,46.472573],[3.867603,46.47227],[3.869651,46.471803],[3.871371,46.471269],[3.87612,46.469084],[3.879864,46.46718],[3.882248,46.466063],[3.883588,46.465337],[3.886179,46.463621],[3.887395,46.46294],[3.890563,46.460777],[3.893472,46.458918],[3.895359,46.458003],[3.897065,46.457424],[3.899977,46.456731],[3.903043,46.456358],[3.904198,46.456359],[3.917437,46.456018],[3.923108,46.455905],[3.926347,46.456155],[3.92776,46.456408],[3.935355,46.458231],[3.942067,46.459798],[3.943882,46.460096],[3.945664,46.460264],[3.95041,46.460411],[3.953217,46.460551],[3.959056,46.460719],[3.962428,46.460852],[3.963951,46.460997],[3.968816,46.461798],[3.971729,46.46219],[3.976942,46.463107],[3.985566,46.464897],[3.99636,46.467105],[4.005064,46.468849],[4.00938,46.469747],[4.012176,46.470233],[4.017572,46.470774],[4.020866,46.470877],[4.023913,46.470909],[4.026322,46.470791],[4.030881,46.470238],[4.033367,46.469843],[4.040921,46.468274],[4.044154,46.467708],[4.049534,46.46687],[4.051497,46.466616],[4.056066,46.465907],[4.057266,46.465786],[4.0667,46.465443],[4.068975,46.465429],[4.071525,46.465243],[4.074282,46.464727],[4.076947,46.464153],[4.078703,46.46392],[4.0818,46.463953],[4.083874,46.464294],[4.085283,46.464674],[4.087096,46.465418],[4.090337,46.466944],[4.093058,46.467834],[4.095048,46.468287],[4.098727,46.468631],[4.100215,46.468516],[4.100459,46.468659],[4.103407,46.468582],[4.107082,46.468362],[4.10982,46.468343],[4.112122,46.468476],[4.115537,46.468934],[4.118658,46.469199],[4.121724,46.469732],[4.124805,46.470425],[4.128728,46.471515],[4.130986,46.472289],[4.134332,46.473624],[4.135701,46.474244],[4.140422,46.476649],[4.142009,46.47765],[4.144568,46.479653],[4.145904,46.480811],[4.148287,46.483111],[4.150876,46.485868],[4.153697,46.489464],[4.155289,46.49179],[4.155931,46.493044],[4.15772,46.496051],[4.159469,46.500187],[4.160666,46.50374],[4.161544,46.507571],[4.163135,46.516554],[4.163938,46.520347],[4.164685,46.523194],[4.165555,46.526003],[4.166876,46.529624],[4.167675,46.531533],[4.169675,46.535761],[4.170808,46.537884],[4.172707,46.541221],[4.175288,46.545261],[4.177479,46.548229],[4.180789,46.552301],[4.18343,46.555383],[4.188766,46.561307],[4.193342,46.566062],[4.195123,46.567764],[4.198009,46.570228],[4.200418,46.572003],[4.204113,46.57425],[4.209692,46.576942],[4.211135,46.577708],[4.213576,46.579229],[4.216792,46.581664],[4.218951,46.5836],[4.221896,46.586468],[4.224238,46.588389],[4.227433,46.59049],[4.228871,46.591315],[4.231829,46.592859],[4.234767,46.594495],[4.236102,46.595321],[4.237974,46.596646],[4.239693,46.597971],[4.242977,46.600682],[4.245447,46.602432],[4.247699,46.603808],[4.249784,46.604894],[4.251819,46.605833],[4.254932,46.607039],[4.261792,46.609275],[4.264658,46.610379],[4.266854,46.611399],[4.270135,46.613242],[4.272096,46.614475],[4.274838,46.616005],[4.277591,46.617191],[4.281136,46.618322],[4.283707,46.618919],[4.286509,46.619657],[4.288614,46.620303],[4.290632,46.621072],[4.295356,46.623269],[4.297727,46.624165],[4.301503,46.62534],[4.303568,46.626048],[4.305529,46.626866],[4.31081,46.629562],[4.312797,46.630372],[4.31781,46.632099],[4.31974,46.632922],[4.321695,46.634037],[4.32333,46.63512],[4.325406,46.636725],[4.326798,46.638105],[4.328054,46.639766],[4.329026,46.641729],[4.329418,46.643149],[4.329584,46.644548],[4.32962,46.646106],[4.329248,46.649705],[4.329464,46.65154],[4.330239,46.653716],[4.330546,46.65514],[4.330729,46.657027],[4.330972,46.658078],[4.331512,46.659284],[4.332472,46.660806],[4.333631,46.662181],[4.335174,46.663555],[4.336198,46.664249],[4.339638,46.666142],[4.340939,46.667233],[4.341697,46.668115],[4.343782,46.671274],[4.344631,46.672722],[4.345246,46.674438],[4.345515,46.675788],[4.345756,46.67786],[4.346272,46.679464],[4.346941,46.680656],[4.347747,46.681622],[4.349373,46.683007],[4.351358,46.684119],[4.354347,46.685317],[4.361371,46.687732],[4.362808,46.688179],[4.366348,46.689505],[4.372349,46.69156],[4.374088,46.691957],[4.376297,46.692016],[4.378886,46.691755],[4.380049,46.691796],[4.382142,46.692412],[4.383377,46.693237],[4.384012,46.694043],[4.38485,46.696089],[4.385249,46.69678],[4.386539,46.697964],[4.387145,46.698318],[4.391233,46.700286],[4.393539,46.70093],[4.395264,46.701056],[4.399959,46.700522],[4.402023,46.700204],[4.403538,46.700085],[4.405392,46.700108],[4.406886,46.700289],[4.408916,46.700711],[4.410275,46.701129],[4.411771,46.701781],[4.425957,46.709643],[4.433642,46.713876],[4.435886,46.715332],[4.437392,46.716652],[4.442416,46.721267],[4.443473,46.722027],[4.445678,46.723126],[4.450472,46.724813],[4.451789,46.725222],[4.468191,46.730837],[4.469234,46.7313],[4.478497,46.736001],[4.481361,46.737499],[4.482937,46.738507],[4.484185,46.739703],[4.487381,46.743319],[4.491459,46.747838],[4.492067,46.748272],[4.492962,46.748425],[4.494245,46.748915],[4.500931,46.749361],[4.502603,46.749441],[4.505411,46.74925],[4.506776,46.748996],[4.514969,46.747275],[4.521658,46.74593],[4.531143,46.744128],[4.531912,46.744068],[4.53995,46.743984],[4.544339,46.743869],[4.546154,46.743641],[4.548662,46.742858],[4.551585,46.741343],[4.553155,46.740722],[4.554841,46.740275],[4.560484,46.739046],[4.562095,46.738748],[4.564222,46.73852],[4.567125,46.738609],[4.569062,46.738964],[4.574482,46.740345],[4.575776,46.740471],[4.577678,46.740437],[4.579006,46.740232],[4.580551,46.739696],[4.582153,46.738775],[4.584166,46.737055],[4.585299,46.73621],[4.586989,46.735502],[4.588883,46.735233],[4.590555,46.73531],[4.591802,46.735564],[4.59734,46.73739],[4.599567,46.737822],[4.601538,46.737845],[4.610312,46.737227],[4.618366,46.736776],[4.620771,46.736922],[4.622102,46.737155],[4.627149,46.738804],[4.634069,46.741196],[4.636256,46.742054],[4.63772,46.742511],[4.642124,46.744245],[4.643173,46.744409],[4.644402,46.744398],[4.642481,46.744079],[4.641837,46.74345],[4.641546,46.742694],[4.64259,46.742592],[4.643459,46.742776],[4.644241,46.743412],[4.644457,46.744038],[4.645129,46.744227],[4.644774,46.744848],[4.645586,46.745574],[4.649144,46.747013],[4.65234,46.748214],[4.654694,46.749202],[4.65913,46.751651],[4.660862,46.752361],[4.662687,46.752897],[4.664014,46.753151],[4.665643,46.753304],[4.677105,46.754057],[4.679614,46.75418],[4.690652,46.75491],[4.692192,46.75504],[4.694064,46.755379],[4.697041,46.756185],[4.698602,46.756444],[4.701751,46.756708],[4.703647,46.756797],[4.709246,46.756726],[4.711798,46.756767],[4.714002,46.756933],[4.718265,46.757351],[4.724425,46.758024],[4.732697,46.758857],[4.74485,46.76014],[4.746749,46.760308],[4.748991,46.760293],[4.762538,46.758868],[4.768551,46.758388],[4.7842,46.757093],[4.793981,46.75652],[4.800562,46.756107],[4.804463,46.755819],[4.809611,46.755535],[4.824898,46.755304],[4.825388,46.75517],[4.826228,46.755561],[4.828884,46.756272],[4.830454,46.756602],[4.831059,46.756478],[4.831512,46.755796],[4.832946,46.755138],[4.833102,46.752415],[4.832322,46.752058],[4.831916,46.752306],[4.830759,46.754812],[4.829605,46.757059],[4.828265,46.759325],[4.82078,46.771089],[4.82022,46.772068],[4.819708,46.773498],[4.819525,46.775179],[4.820113,46.787264],[4.820245,46.788388],[4.820551,46.789458],[4.821702,46.792217],[4.823096,46.795756],[4.823876,46.797557],[4.824747,46.799992],[4.825599,46.803351],[4.826827,46.809147],[4.827465,46.811791],[4.82866,46.816396],[4.830748,46.824775],[4.831608,46.828531],[4.831841,46.829901],[4.832225,46.833313],[4.832319,46.835837],[4.832091,46.838811],[4.831383,46.842609],[4.830591,46.845272],[4.829929,46.847052],[4.828612,46.850106],[4.826544,46.854189],[4.824711,46.857619],[4.822537,46.86188],[4.82115,46.865105],[4.820146,46.868161],[4.819821,46.869412],[4.819253,46.872439],[4.818972,46.876116],[4.819003,46.877979],[4.819187,46.880495],[4.819423,46.882153],[4.820216,46.886164],[4.822168,46.893613],[4.822633,46.896243],[4.82271,46.899045],[4.822285,46.902349],[4.82158,46.905345],[4.820629,46.908938],[4.819694,46.913125],[4.819379,46.915243],[4.819168,46.917393],[4.819099,46.920126],[4.819269,46.922601],[4.819597,46.925123],[4.81984,46.926373],[4.820752,46.929627],[4.821598,46.931818],[4.823061,46.935028],[4.825107,46.938974],[4.828161,46.944564],[4.828954,46.946135],[4.831569,46.950936],[4.834783,46.956927],[4.836256,46.960376],[4.838512,46.966854],[4.839672,46.969755],[4.841332,46.972982],[4.84277,46.975298],[4.8456,46.979262],[4.849148,46.98394],[4.852917,46.989047],[4.854665,46.991546],[4.856323,46.994089],[4.858123,46.997145],[4.859943,47.000469],[4.860481,47.001599],[4.862812,47.005829],[4.866365,47.012643],[4.867908,47.015454],[4.869816,47.019151],[4.871334,47.021942],[4.872938,47.024733],[4.874152,47.02663],[4.876224,47.029642],[4.879105,47.03341],[4.882416,47.036981],[4.885396,47.039908],[4.888607,47.042735],[4.891819,47.045319],[4.89745,47.049503],[4.900032,47.051339],[4.903527,47.053919],[4.906365,47.056159],[4.909706,47.058919],[4.91161,47.060679],[4.913745,47.062544],[4.91687,47.065633],[4.91914,47.068096],[4.922284,47.071822],[4.925421,47.075741],[4.92954,47.080984],[4.93216,47.084131],[4.93479,47.087048],[4.937795,47.090146],[4.939338,47.091634],[4.942717,47.094739],[4.944396,47.096156],[4.947465,47.098888],[4.950946,47.101905],[4.953143,47.103902],[4.955819,47.10669],[4.958826,47.110248],[4.960619,47.112726],[4.962354,47.115432],[4.966061,47.121802],[4.968591,47.125654],[4.970615,47.128233],[4.972412,47.130175],[4.975013,47.1327],[4.979255,47.136564],[4.981303,47.138356],[4.986708,47.143292],[4.98934,47.145891],[4.991145,47.147893],[4.993611,47.151053],[4.994926,47.152965],[4.996475,47.155452],[4.998299,47.159226],[4.99923,47.161658],[4.999889,47.163691],[5.000486,47.16614],[5.001034,47.170293],[5.001162,47.172785],[5.00093,47.176819],[5.000639,47.179108],[5.000063,47.181767],[4.999456,47.183925],[4.998314,47.187417],[4.997207,47.191391],[4.996713,47.194634],[4.996552,47.196867],[4.996567,47.198407],[4.996842,47.201677],[4.997233,47.203838],[4.99774,47.205782],[4.998344,47.207665],[4.999683,47.210838],[5.000307,47.212057],[5.001776,47.214491],[5.002757,47.2159],[5.005248,47.218971],[5.007161,47.220967],[5.009008,47.222728],[5.011211,47.224658],[5.01562,47.228399],[5.01901,47.23142],[5.020953,47.233476],[5.022606,47.235833],[5.023869,47.23811],[5.024823,47.239266],[5.026189,47.240471],[5.028079,47.241608],[5.029409,47.242206],[5.031429,47.242836],[5.033272,47.243189],[5.039231,47.243646],[5.040799,47.243849],[5.04329,47.244375],[5.045043,47.244854],[5.047893,47.245803],[5.051548,47.247227],[5.05301,47.247683],[5.054512,47.247988],[5.056392,47.248218],[5.059509,47.248187],[5.060702,47.248025],[5.062782,47.247563],[5.064743,47.246933],[5.067891,47.245598],[5.071015,47.244427],[5.073987,47.243573],[5.077986,47.242914],[5.080854,47.242752],[5.083701,47.242827],[5.088366,47.243262],[5.092315,47.243726],[5.095956,47.244209],[5.098347,47.244602],[5.101243,47.245263],[5.10323,47.245829],[5.105728,47.246742],[5.107832,47.247718],[5.110319,47.249064],[5.11171,47.249963],[5.114329,47.25188],[5.116751,47.253881],[5.120173,47.257024],[5.125664,47.26233],[5.12828,47.264679],[5.130749,47.26664],[5.133104,47.268171],[5.13457,47.269032],[5.13709,47.270317],[5.141406,47.272361],[5.143866,47.273655],[5.145761,47.274791],[5.147806,47.276209],[5.149697,47.277702],[5.151766,47.279633],[5.153461,47.281489],[5.154851,47.283252],[5.156671,47.285791],[5.158907,47.288638],[5.160271,47.290126],[5.16333,47.293028],[5.16602,47.295203],[5.167688,47.296656],[5.169432,47.298516],[5.17106,47.300757],[5.171977,47.302471],[5.172897,47.305081],[5.173207,47.306639],[5.173334,47.308644],[5.173252,47.309981],[5.172931,47.311975],[5.171493,47.318337],[5.17079,47.321833],[5.169788,47.327634],[5.168809,47.331363],[5.168189,47.333098],[5.16621,47.337308],[5.165395,47.339253],[5.164737,47.341473],[5.164338,47.343255],[5.163588,47.348161],[5.162892,47.351337],[5.162686,47.352705],[5.16253,47.354987],[5.162619,47.357924],[5.163176,47.361269],[5.164383,47.365708],[5.164934,47.368383],[5.165482,47.372018],[5.165793,47.373366],[5.166479,47.375586],[5.167291,47.377552],[5.169675,47.382432],[5.170879,47.384732],[5.172796,47.387525],[5.17412,47.388997],[5.17623,47.390974],[5.178697,47.393],[5.180065,47.394265],[5.180928,47.395239],[5.18191,47.396647],[5.182685,47.398317],[5.183006,47.399415],[5.183244,47.401188],[5.183009,47.403219],[5.182441,47.404982],[5.181304,47.407026],[5.178333,47.411271],[5.177563,47.412521],[5.176485,47.414662],[5.175074,47.41811],[5.174001,47.420451],[5.173189,47.421924],[5.170355,47.426518],[5.169323,47.428534],[5.168285,47.431038],[5.167477,47.434072],[5.167152,47.436266],[5.167065,47.43781],[5.167146,47.440156],[5.167745,47.443278],[5.168128,47.444515],[5.169245,47.447112],[5.170646,47.449698],[5.173179,47.453778],[5.175733,47.457507],[5.177624,47.46012],[5.179758,47.46269],[5.183467,47.466471],[5.185201,47.468338],[5.186583,47.470067],[5.187359,47.471249],[5.188348,47.473119],[5.189274,47.475619],[5.189729,47.477496],[5.189902,47.480265],[5.189687,47.482576],[5.189055,47.486133],[5.188606,47.489492],[5.188573,47.491579],[5.188691,47.493671],[5.18888,47.494933],[5.189334,47.496837],[5.190472,47.499947],[5.192507,47.503949],[5.193286,47.505653],[5.194964,47.50964],[5.196412,47.513702],[5.197597,47.51794],[5.198295,47.521269],[5.198807,47.524608],[5.199146,47.527782],[5.199317,47.530928],[5.199269,47.534619],[5.199039,47.538288],[5.198241,47.545384],[5.197834,47.549542],[5.197747,47.553255],[5.19789,47.555262],[5.19829,47.557612],[5.199016,47.559917],[5.199528,47.561083],[5.200439,47.562704],[5.202375,47.565201],[5.205149,47.568257],[5.206422,47.569864],[5.207765,47.571913],[5.208811,47.573857],[5.209577,47.575808],[5.210017,47.57731],[5.210378,47.579037],[5.210612,47.582062],[5.210514,47.584027],[5.210045,47.586825],[5.209394,47.589132],[5.208805,47.590747],[5.2081,47.592323],[5.206609,47.595082],[5.205364,47.59696],[5.203773,47.598981],[5.202597,47.600301],[5.200796,47.602117],[5.198505,47.604154],[5.195802,47.606206],[5.193279,47.607863],[5.188337,47.610669],[5.186309,47.61197],[5.184781,47.613161],[5.183643,47.614202],[5.182322,47.615625],[5.180748,47.617911],[5.180002,47.619351],[5.179459,47.620909],[5.179096,47.622707],[5.179002,47.624915],[5.179353,47.627513],[5.180201,47.631795],[5.180477,47.634309],[5.180474,47.637662],[5.180186,47.640793],[5.179791,47.642895],[5.179096,47.645647],[5.178112,47.649163],[5.176542,47.654558],[5.175619,47.657932],[5.175126,47.660317],[5.174791,47.662709],[5.174672,47.665947],[5.174794,47.668262],[5.175081,47.670553],[5.175594,47.673028],[5.176637,47.676482],[5.177457,47.678477],[5.178954,47.681487],[5.182086,47.686664],[5.183172,47.688537],[5.184682,47.691792],[5.185628,47.694426],[5.186373,47.697326],[5.186738,47.699419],[5.187828,47.708325],[5.188259,47.71065],[5.189261,47.714766],[5.189815,47.716523],[5.191569,47.721541],[5.192259,47.72369],[5.193378,47.727825],[5.194324,47.732727],[5.194735,47.73646],[5.194962,47.740984],[5.194858,47.744291],[5.19445,47.746706],[5.19364,47.749387],[5.192162,47.752403],[5.19106,47.754187],[5.189214,47.756908],[5.18862,47.757942],[5.188,47.759451],[5.187801,47.760535],[5.187987,47.762676],[5.188675,47.764351],[5.190023,47.766103],[5.191466,47.76731],[5.193643,47.768559],[5.195868,47.769434],[5.201346,47.77123],[5.203371,47.771996],[5.206565,47.773509],[5.208551,47.774675],[5.212063,47.777106],[5.214728,47.7791],[5.216922,47.781035],[5.218044,47.782185],[5.219699,47.78418],[5.220837,47.785822],[5.221818,47.787485],[5.222821,47.789641],[5.223768,47.792522],[5.224413,47.795257],[5.224714,47.797245],[5.224846,47.798817],[5.224889,47.802025],[5.224713,47.804285],[5.22417,47.808649],[5.223972,47.81114],[5.223906,47.814081],[5.224094,47.816805],[5.224343,47.818395],[5.224827,47.820671],[5.225548,47.823379],[5.226756,47.827474],[5.22753,47.829693],[5.228956,47.833047],[5.230684,47.836759],[5.231478,47.838738],[5.231865,47.840068],[5.23211,47.841609],[5.232117,47.843828],[5.231576,47.846472],[5.230218,47.849673],[5.228584,47.85282],[5.221336,47.867346],[5.220617,47.869041],[5.220019,47.871142],[5.219696,47.873635],[5.219722,47.87537],[5.219935,47.877121],[5.220417,47.879057],[5.221202,47.881238],[5.22404,47.891598],[5.224192,47.893937],[5.224197,47.895952],[5.224014,47.898632],[5.223151,47.907142],[5.222485,47.912111],[5.222587,47.913733],[5.223038,47.914855],[5.223516,47.915568],[5.224821,47.91682],[5.226346,47.917734],[5.228631,47.918502],[5.231383,47.918828],[5.23755,47.919035],[5.243357,47.919264],[5.255273,47.91967],[5.258282,47.919746],[5.261216,47.919932],[5.263504,47.920159],[5.267395,47.920781],[5.269631,47.921282],[5.272104,47.921947],[5.275446,47.923089],[5.277261,47.923812],[5.279545,47.924911],[5.282149,47.926393],[5.284536,47.928023],[5.286284,47.929416],[5.287716,47.930691],[5.289808,47.932786],[5.29515,47.938363],[5.29634,47.939507],[5.299049,47.94164],[5.301531,47.943228],[5.304795,47.944869],[5.30735,47.94588],[5.311499,47.947154],[5.315209,47.947926],[5.318278,47.94833],[5.320315,47.948496],[5.324562,47.948552],[5.327285,47.948371],[5.331666,47.947871],[5.335068,47.947566],[5.337262,47.947518],[5.340343,47.947684],[5.343408,47.948144],[5.346902,47.949003],[5.349085,47.949761],[5.352341,47.951025],[5.354308,47.951699],[5.357211,47.952501],[5.358962,47.952894],[5.362343,47.953459],[5.365444,47.953747],[5.369778,47.954051],[5.37318,47.954496],[5.376785,47.955245],[5.38059,47.956269],[5.385463,47.957388],[5.38917,47.957936],[5.392222,47.958205],[5.394002,47.958293],[5.397661,47.958302],[5.400816,47.958156],[5.404497,47.95783],[5.407286,47.957449],[5.410564,47.956859],[5.412861,47.956337],[5.416209,47.955428],[5.421641,47.953681],[5.423555,47.953128],[5.426144,47.952607],[5.428302,47.952372],[5.431426,47.952346],[5.433038,47.952469],[5.435268,47.952803],[5.438594,47.953676],[5.440842,47.954563],[5.442147,47.955231],[5.445359,47.957113],[5.446685,47.957777],[5.449026,47.958621],[5.45186,47.959211],[5.453168,47.959338],[5.4576,47.959514],[5.459577,47.959744],[5.461398,47.960127],[5.462822,47.960545],[5.464539,47.961218],[5.468614,47.963103],[5.470462,47.963812],[5.472549,47.964471],[5.475731,47.965196],[5.477234,47.965451],[5.481548,47.965984],[5.483695,47.966322],[5.486065,47.966865],[5.487776,47.967396],[5.489673,47.968163],[5.491422,47.969067],[5.492981,47.970088],[5.495095,47.971884],[5.496978,47.973952],[5.498428,47.97493],[5.498428,47.975293],[5.499034,47.975665],[5.498854,47.9761],[5.499273,47.97713],[5.5,47.978107],[5.501248,47.979485],[5.504346,47.982378],[5.506901,47.984894],[5.508524,47.986722],[5.510876,47.989963],[5.512338,47.992502],[5.513578,47.99526],[5.515193,47.999824],[5.516614,48.004005],[5.517585,48.006463],[5.51901,48.009189],[5.519785,48.010404],[5.521366,48.012551],[5.523242,48.014602],[5.526329,48.017369],[5.529599,48.019631],[5.531428,48.02075],[5.534552,48.022419],[5.537542,48.023895],[5.540468,48.025413],[5.542137,48.026374],[5.544645,48.027985],[5.546794,48.029521],[5.550142,48.032227],[5.553636,48.034853],[5.557068,48.037026],[5.564742,48.041357],[5.56794,48.043383],[5.570236,48.045033],[5.572428,48.046766],[5.575209,48.049262],[5.578164,48.052362],[5.582724,48.057938],[5.584332,48.059781],[5.586362,48.061963],[5.590627,48.066214],[5.593917,48.069189],[5.596452,48.071341],[5.597995,48.072555],[5.600151,48.074023],[5.602457,48.075406],[5.605731,48.077005],[5.607471,48.077744],[5.610799,48.078982],[5.614869,48.080134],[5.622548,48.081871],[5.626153,48.082889],[5.628405,48.083715],[5.630357,48.084588],[5.631707,48.085304],[5.633671,48.086535],[5.636068,48.08852],[5.637645,48.09014],[5.63931,48.092345],[5.640766,48.094876],[5.642543,48.097632],[5.643957,48.099337],[5.645141,48.10055],[5.646843,48.102085],[5.648234,48.103182],[5.652009,48.105988],[5.653163,48.106925],[5.655296,48.108832],[5.657602,48.111233],[5.658968,48.112955],[5.660285,48.114907],[5.661403,48.116915],[5.662736,48.119613],[5.664122,48.122575],[5.665263,48.124621],[5.666307,48.12617],[5.667741,48.128096],[5.670097,48.130773],[5.671329,48.131994],[5.673313,48.133744],[5.674934,48.135025],[5.680703,48.139201],[5.682736,48.140847],[5.684233,48.142178],[5.686831,48.144868],[5.687821,48.146085],[5.692653,48.152514],[5.694333,48.154395],[5.695914,48.155954],[5.698358,48.158133],[5.700537,48.159795],[5.704197,48.162128],[5.708735,48.164729],[5.715185,48.168487],[5.721878,48.172299],[5.723738,48.173316],[5.725935,48.174368],[5.728865,48.175592],[5.731897,48.176712],[5.734632,48.177609],[5.741299,48.179522],[5.744092,48.180428],[5.74676,48.181444],[5.750225,48.183004],[5.752699,48.184359],[5.75592,48.18621],[5.757837,48.187246],[5.760669,48.188598],[5.76432,48.190052],[5.766456,48.190769],[5.770718,48.191892],[5.77586,48.193172],[5.778677,48.194023],[5.782298,48.195364],[5.78517,48.196648],[5.787803,48.198068],[5.793883,48.201702],[5.795876,48.202775],[5.798579,48.204023],[5.803003,48.205653],[5.80996,48.207558],[5.812176,48.208328],[5.81569,48.209839],[5.818638,48.21159],[5.821857,48.213889],[5.824235,48.215315],[5.825943,48.216146],[5.828004,48.217005],[5.838275,48.220715],[5.851132,48.225386],[5.852949,48.226025],[5.855478,48.2271],[5.85729,48.228207],[5.859021,48.229675],[5.860497,48.231576],[5.861193,48.233087],[5.861479,48.233998],[5.861645,48.235607],[5.861591,48.236554],[5.861089,48.239958],[5.861152,48.241844],[5.86145,48.243505],[5.861863,48.244887],[5.863688,48.249102],[5.864293,48.25066],[5.865027,48.253348],[5.865262,48.256033],[5.865219,48.258553],[5.86494,48.26057],[5.864583,48.262124],[5.864023,48.26387],[5.86316,48.265838],[5.861414,48.268909],[5.859239,48.271999],[5.857841,48.274351],[5.857091,48.275914],[5.856096,48.278859],[5.855453,48.2827],[5.855415,48.28361],[5.855541,48.286342],[5.855851,48.288181],[5.857132,48.293238],[5.857411,48.294618],[5.857715,48.297155],[5.857717,48.298689],[5.857449,48.301627],[5.857073,48.30342],[5.855486,48.309173],[5.854819,48.312338],[5.854585,48.315051],[5.85472,48.317493],[5.855131,48.319968],[5.85633,48.324608],[5.856596,48.326142],[5.856713,48.328161],[5.856595,48.329543],[5.856226,48.331073],[5.855475,48.333184],[5.854819,48.334613],[5.853943,48.336857],[5.85365,48.338178],[5.853428,48.340165],[5.853468,48.34152],[5.853969,48.343981],[5.854577,48.345555],[5.855701,48.347517],[5.857321,48.349554],[5.85864,48.35086],[5.861887,48.353444],[5.863323,48.354723],[5.86465,48.356315],[5.865752,48.358232],[5.866318,48.359783],[5.866878,48.362439],[5.867204,48.363511],[5.868044,48.365354],[5.868853,48.366494],[5.869991,48.367795],[5.871577,48.369239],[5.873268,48.370441],[5.876766,48.372569],[5.877908,48.373427],[5.879622,48.375007],[5.88065,48.376304],[5.881753,48.378503],[5.882214,48.380615],[5.882183,48.382626],[5.88172,48.38449],[5.880856,48.386555],[5.880206,48.388518],[5.879929,48.390038],[5.879858,48.391823],[5.879992,48.393412],[5.880997,48.397456],[5.881094,48.398777],[5.880953,48.399917],[5.880421,48.401432],[5.879307,48.403128],[5.87813,48.404299],[5.876137,48.405632],[5.872339,48.407393],[5.870414,48.408442],[5.869159,48.409283],[5.867639,48.410569],[5.866362,48.411959],[5.865556,48.413049],[5.863677,48.416872],[5.861013,48.422802],[5.860316,48.425116],[5.860067,48.426534],[5.859959,48.428967],[5.860158,48.430865],[5.860809,48.433401],[5.861548,48.435191],[5.862216,48.436469],[5.864328,48.439932],[5.865845,48.442847],[5.866762,48.445319],[5.867456,48.448088],[5.86795,48.451101],[5.868428,48.454827],[5.869028,48.457197],[5.869819,48.459288],[5.87142,48.462391],[5.873309,48.465112],[5.874475,48.46652],[5.875845,48.467977],[5.877616,48.469615],[5.879038,48.470804],[5.881411,48.472555],[5.883731,48.474035],[5.886929,48.475905],[5.889696,48.477405],[5.891721,48.478623],[5.894557,48.480492],[5.895928,48.481518],[5.898544,48.48386],[5.901015,48.486426],[5.902502,48.48821],[5.904699,48.491141],[5.906276,48.493671],[5.908055,48.496944],[5.910473,48.501957],[5.911339,48.503986],[5.912167,48.506159],[5.913019,48.508962],[5.914004,48.512481],[5.915099,48.516111],[5.915542,48.518433],[5.915658,48.519828],[5.915607,48.521673],[5.915378,48.52324],[5.914827,48.52533],[5.914183,48.526906],[5.912877,48.529333],[5.912059,48.530586],[5.909846,48.533412],[5.908234,48.535189],[5.906784,48.536469],[5.904269,48.538545],[5.900513,48.54179],[5.897746,48.544695],[5.896092,48.546727],[5.895135,48.548164],[5.893966,48.550288],[5.892753,48.553045],[5.891792,48.556199],[5.891106,48.559366],[5.890162,48.562512],[5.888127,48.567293],[5.88708,48.570215],[5.886566,48.572436],[5.886324,48.574785],[5.886468,48.578076],[5.886754,48.580109],[5.887881,48.585279],[5.888073,48.586627],[5.888179,48.589175],[5.888128,48.590806],[5.887797,48.593052],[5.886517,48.598127],[5.885974,48.601084],[5.885758,48.603542],[5.885823,48.606355],[5.886667,48.612389],[5.886887,48.615343],[5.886755,48.617375],[5.886425,48.619583],[5.885749,48.622042],[5.884299,48.626507],[5.883891,48.629345],[5.883625,48.63012],[5.882186,48.632935],[5.881584,48.634771],[5.880789,48.63809],[5.880538,48.639906],[5.880341,48.643884],[5.880345,48.646534],[5.88024,48.648867],[5.880342,48.649855],[5.881205,48.651293],[5.8819,48.651929],[5.88302,48.652626],[5.884917,48.653473],[5.888802,48.655045],[5.890384,48.655516],[5.893452,48.655955],[5.89829,48.656194],[5.900954,48.656496],[5.902841,48.656907],[5.905693,48.657885],[5.907576,48.658773],[5.909636,48.660109],[5.911321,48.661749],[5.915273,48.667416],[5.917996,48.670647],[5.919236,48.67199],[5.919957,48.673003],[5.921339,48.675334],[5.922328,48.676466],[5.923246,48.677162],[5.924783,48.678078],[5.927053,48.678953],[5.929904,48.67957],[5.938452,48.680361],[5.939964,48.680668],[5.941384,48.681144],[5.946887,48.683169],[5.951562,48.684778],[5.955346,48.685886],[5.960478,48.687145],[5.963147,48.687667],[5.966236,48.688143],[5.970836,48.688714],[5.97309,48.688934],[5.976367,48.689115],[5.979373,48.689217],[5.983709,48.689221],[5.988284,48.689015],[5.994217,48.688586],[6.001645,48.688262],[6.005733,48.688301],[6.01009,48.688472],[6.019942,48.689116],[6.025114,48.68969],[6.032846,48.690497],[6.033424,48.690624],[6.03954,48.691281],[6.041405,48.691441],[6.04502,48.691642],[6.053113,48.691934],[6.055826,48.692066],[6.062482,48.692259],[6.068519,48.692532],[6.071747,48.692825],[6.074829,48.693191],[6.07945,48.693529],[6.094658,48.693965],[6.09919,48.694154],[6.11081,48.694521],[6.114233,48.694009],[6.115212,48.693967],[6.11659,48.694177],[6.118282,48.695107],[6.118954,48.69601],[6.119731,48.697546],[6.120929,48.698591],[6.123402,48.700007],[6.126452,48.701385],[6.130102,48.702719],[6.135808,48.704642],[6.137866,48.705407],[6.139666,48.706383],[6.142252,48.708102],[6.147309,48.71171],[6.149421,48.713033],[6.151647,48.713761],[6.154552,48.713978],[6.157715,48.714045],[6.159618,48.714414],[6.1611,48.715016],[6.162723,48.716234],[6.165142,48.718563],[6.167459,48.720309],[6.168779,48.721582],[6.169354,48.722566],[6.169649,48.723933],[6.16946,48.725041],[6.169032,48.72591],[6.167434,48.727402],[6.166662,48.727871],[6.165213,48.728471],[6.162482,48.72939],[6.161356,48.729886],[6.159825,48.730978],[6.158566,48.732574],[6.157343,48.735608],[6.15627,48.737374],[6.153911,48.740394],[6.153087,48.742247],[6.15305,48.743343],[6.153224,48.744213],[6.153954,48.7456],[6.156127,48.748208],[6.156834,48.749547],[6.157111,48.750672],[6.157133,48.751573],[6.156642,48.753136],[6.155813,48.754375],[6.153918,48.756218],[6.146559,48.762825],[6.145469,48.763961],[6.144511,48.765695],[6.144117,48.767118],[6.143687,48.769681],[6.143667,48.772056],[6.14377,48.773259],[6.144914,48.778179],[6.145066,48.779328],[6.144946,48.78096],[6.14373,48.785],[6.14277,48.787614],[6.142037,48.788859],[6.140604,48.79014],[6.138535,48.791266],[6.137005,48.791743],[6.135667,48.791994],[6.134323,48.792088],[6.132229,48.792017],[6.128504,48.791438],[6.126795,48.791291],[6.12404,48.791382],[6.121376,48.791948],[6.119872,48.792543],[6.117638,48.793938],[6.11673,48.794871],[6.115803,48.796324],[6.114366,48.799561],[6.113505,48.802597],[6.1134,48.804967],[6.113506,48.80621],[6.1141,48.809375],[6.114058,48.810837],[6.113695,48.812331],[6.112918,48.813603],[6.112,48.814604],[6.106497,48.820051],[6.103934,48.822387],[6.101397,48.824382],[6.096897,48.828041],[6.096064,48.828797],[6.094384,48.830613],[6.093471,48.831914],[6.092507,48.833715],[6.092021,48.834911],[6.091539,48.837022],[6.090161,48.845772],[6.089343,48.851743],[6.089368,48.853822],[6.089815,48.857024],[6.09028,48.858688],[6.091095,48.860737],[6.094217,48.86935],[6.095568,48.872836],[6.096127,48.874465],[6.096526,48.876993],[6.096664,48.880533],[6.096862,48.882414],[6.097463,48.88499],[6.098022,48.886593],[6.09865,48.88801],[6.099673,48.889911],[6.103996,48.89689],[6.104962,48.898611],[6.106231,48.901267],[6.107433,48.904172],[6.108128,48.906166],[6.108983,48.909062],[6.109557,48.912519],[6.109899,48.915299],[6.11009,48.919335],[6.110123,48.922792],[6.110524,48.926247],[6.111807,48.932666],[6.112368,48.936097],[6.11259,48.938604],[6.112748,48.942117],[6.112462,48.9454],[6.11192,48.949096],[6.111086,48.952946],[6.110509,48.954885],[6.10964,48.95726],[6.107669,48.961896],[6.106703,48.964485],[6.105845,48.967063],[6.105064,48.969758],[6.104534,48.973735],[6.104343,48.976674],[6.104376,48.980684],[6.105196,48.986089],[6.105132,48.986957],[6.105132,48.990259],[6.104858,48.994576],[6.104942,48.996541],[6.105347,48.998408],[6.105794,48.999775],[6.106546,49.001283],[6.107593,49.002962],[6.110386,49.006804],[6.112415,49.009684],[6.113323,49.011103],[6.114156,49.012715],[6.114861,49.014362],[6.115525,49.016456],[6.11598,49.018966],[6.116019,49.021902],[6.115924,49.022915],[6.115466,49.025576],[6.113141,49.03604],[6.112504,49.039185],[6.111968,49.041455],[6.111845,49.044282],[6.11212,49.046894],[6.112885,49.050193],[6.113057,49.052359],[6.112857,49.054046],[6.111658,49.05778],[6.11138,49.058971],[6.111346,49.060418],[6.111496,49.061595],[6.111918,49.063186],[6.112783,49.065898],[6.112886,49.068541],[6.112554,49.070634],[6.111487,49.073696],[6.111176,49.074821],[6.110297,49.076859],[6.107509,49.080756],[6.106543,49.082426],[6.105983,49.084258],[6.105927,49.085066],[6.106095,49.086479],[6.106484,49.087732],[6.107312,49.089366],[6.108369,49.090777],[6.109649,49.092028],[6.111492,49.0934],[6.114609,49.095114],[6.116592,49.096],[6.11961,49.097035],[6.123959,49.098232],[6.127027,49.099217],[6.135011,49.102181],[6.142223,49.104367],[6.145058,49.105553],[6.149046,49.107726],[6.152429,49.109149],[6.157756,49.11089],[6.159238,49.11165],[6.160321,49.112714],[6.160866,49.113696],[6.161044,49.114512],[6.160803,49.116823],[6.160451,49.119159],[6.159969,49.122957],[6.159993,49.124],[6.160491,49.125427],[6.162687,49.128315],[6.16363,49.129145],[6.164612,49.129646],[6.167533,49.13049],[6.168638,49.130897],[6.170078,49.131689],[6.171162,49.132125],[6.173855,49.132804],[6.174903,49.133309],[6.176059,49.134578],[6.176529,49.135992],[6.177325,49.137384],[6.178531,49.138448],[6.182019,49.140434],[6.183634,49.141816],[6.184381,49.142817],[6.184882,49.143885],[6.185054,49.145395],[6.184962,49.146308],[6.183007,49.155365],[6.181963,49.162606],[6.181252,49.167051],[6.180805,49.168912],[6.17976,49.172419],[6.179123,49.174804],[6.177983,49.178593],[6.176936,49.182833],[6.176522,49.185737],[6.176382,49.188639],[6.176161,49.191587],[6.175777,49.194096],[6.175586,49.19639],[6.17546,49.199536],[6.17549,49.20155],[6.175183,49.205823],[6.174647,49.21603],[6.174755,49.217189],[6.175391,49.219855],[6.176263,49.221751],[6.177656,49.22416],[6.178252,49.225398],[6.178968,49.227509],[6.179244,49.229028],[6.179599,49.232886],[6.179948,49.234152],[6.180775,49.236338],[6.181159,49.23877],[6.180983,49.240097],[6.180602,49.241388],[6.180106,49.242423],[6.177589,49.246213],[6.176701,49.248319],[6.176387,49.24959],[6.176281,49.250676],[6.176398,49.252392],[6.177531,49.260248],[6.177491,49.262424],[6.177134,49.264267],[6.176071,49.267085],[6.175299,49.26957],[6.173667,49.276192],[6.17275,49.282457],[6.172933,49.283993],[6.174344,49.287534],[6.175886,49.291027],[6.177368,49.292673],[6.180649,49.295092],[6.181613,49.295912],[6.182458,49.296845],[6.183354,49.298206],[6.183712,49.299],[6.184116,49.300507],[6.18414,49.302248],[6.182891,49.308915],[6.18255,49.312175],[6.182531,49.314982],[6.182742,49.317107],[6.183048,49.319076],[6.18362,49.321528],[6.184593,49.324488],[6.185569,49.327982],[6.185724,49.329298],[6.185787,49.331636],[6.185593,49.333395],[6.185107,49.335316],[6.184479,49.337024],[6.183723,49.338527],[6.182552,49.340399],[6.181311,49.341969],[6.179823,49.343472],[6.178463,49.344552],[6.176614,49.345715],[6.174562,49.346597],[6.171031,49.347498],[6.167924,49.347946],[6.165539,49.348097],[6.160577,49.348532],[6.157322,49.34876],[6.155447,49.348996],[6.146918,49.350511],[6.143743,49.350923],[6.141479,49.351025],[6.136218,49.350747],[6.133435,49.350448],[6.130471,49.349946],[6.128704,49.349527],[6.126987,49.348992],[6.120855,49.346404],[6.119043,49.345961],[6.116873,49.345808],[6.114642,49.346047],[6.113073,49.346477],[6.111069,49.347551],[6.109919,49.348654],[6.107023,49.353135],[6.106499,49.354168],[6.106019,49.356065],[6.105954,49.357285],[6.106276,49.359204],[6.106686,49.360647],[6.107023,49.362404],[6.107026,49.364178],[6.106864,49.369277],[6.106696,49.370972],[6.106143,49.374608],[6.106029,49.377163],[6.106375,49.380378],[6.106982,49.382938],[6.10802,49.386051],[6.110499,49.393061],[6.111148,49.395872],[6.11139,49.397667],[6.111502,49.399624],[6.112078,49.404416],[6.112149,49.406514],[6.112005,49.409051],[6.111837,49.410541],[6.110727,49.415724],[6.110507,49.417973],[6.110681,49.421325],[6.11097,49.422979],[6.111822,49.425912],[6.113251,49.428944],[6.115796,49.433635],[6.116695,49.435595],[6.118288,49.440645],[6.118524,49.442193],[6.119028,49.444324],[6.120686,49.451855],[6.121206,49.454789],[6.121684,49.459855],[6.121818,49.464858],[6.121689,49.468955],[6.121767,49.469957],[6.121519,49.474249],[6.121262,49.476753],[6.120984,49.478016],[6.120098,49.480248],[6.118253,49.484055],[6.117729,49.485632],[6.117385,49.48722],[6.11721,49.490515],[6.117301,49.495002],[6.117149,49.496993],[6.11675,49.499215],[6.116301,49.501013],[6.115166,49.504302],[6.114641,49.506431],[6.114548,49.508298],[6.114809,49.510635],[6.115319,49.512474],[6.116078,49.514705],[6.116616,49.516924],[6.116813,49.518778],[6.116512,49.521224],[6.115892,49.523334],[6.11457,49.526176],[6.11385,49.528229],[6.113415,49.530168],[6.113337,49.532203],[6.113517,49.533745],[6.113881,49.535183],[6.114526,49.53684],[6.115131,49.538004],[6.116105,49.539473],[6.116995,49.540572],[6.119093,49.542682],[6.12445,49.547416],[6.125722,49.548755],[6.126697,49.549971],[6.128017,49.551976],[6.129246,49.554656],[6.129753,49.556483],[6.130002,49.558004],[6.129988,49.560662],[6.129672,49.562661],[6.129137,49.564534],[6.128124,49.566906],[6.126158,49.570158],[6.12532,49.571995],[6.125228,49.573341],[6.125539,49.573955],[6.12712,49.575173],[6.128855,49.575557],[6.129795,49.575545],[6.13394,49.574969],[6.137249,49.574896],[6.139814,49.575003],[6.141739,49.575235],[6.143943,49.575662],[6.146727,49.576367],[6.152173,49.578621],[6.154318,49.57996],[6.1562,49.581581],[6.157797,49.583256],[6.160801,49.586898],[6.162178,49.588392],[6.163466,49.589625],[6.16875,49.594013],[6.169695,49.594878],[6.171722,49.597135],[6.173031,49.599519],[6.17353,49.601449],[6.173663,49.602749],[6.173472,49.605125],[6.173476,49.606438],[6.17384,49.607878],[6.174399,49.60906],[6.17524,49.610236],[6.177237,49.612212],[6.178157,49.613337],[6.179036,49.615218],[6.179241,49.616131],[6.179227,49.617415],[6.179008,49.620123],[6.179647,49.622617],[6.181182,49.625259],[6.181894,49.626856],[6.182252,49.628627],[6.182218,49.629605],[6.181798,49.632807],[6.182039,49.634751],[6.182796,49.636285],[6.183759,49.637374],[6.184987,49.638396],[6.187129,49.639451],[6.189405,49.640225],[6.191939,49.640799],[6.19613,49.641493],[6.201109,49.641995],[6.208662,49.642622],[6.211906,49.642766],[6.214836,49.642697],[6.218098,49.642492],[6.22134,49.642084],[6.225796,49.641222],[6.228251,49.640597],[6.230376,49.639952],[6.234128,49.638534],[6.236183,49.637813],[6.237785,49.637398],[6.241115,49.636816],[6.243119,49.636711],[6.246402,49.636832],[6.249744,49.6373],[6.253989,49.638065],[6.257091,49.638757],[6.260616,49.639655],[6.263657,49.640345],[6.267351,49.641064],[6.268067,49.641102],[6.268898,49.640751],[6.268996,49.640358],[6.268527,49.639838],[6.267591,49.639532],[6.267104,49.639752],[6.26482,49.64201],[6.263702,49.643406],[6.263711,49.643161],[6.265374,49.641278],[6.267249,49.639381],[6.268441,49.639663],[6.268933,49.640035],[6.269878,49.641201],[6.271426,49.641718],[6.2773,49.642456],[6.2812,49.642795],[6.284467,49.643011],[6.286395,49.643075],[6.291092,49.643114],[6.295066,49.64308],[6.303241,49.642742],[6.308188,49.642477],[6.311487,49.642476],[6.313616,49.642565],[6.316896,49.642965],[6.320315,49.643682],[6.322498,49.644351],[6.32456,49.645134],[6.326791,49.646192],[6.330724,49.648626],[6.334272,49.65119],[6.338949,49.654389],[6.343078,49.656961],[6.346868,49.65915],[6.350301,49.660894],[6.353088,49.662125],[6.356005,49.663156],[6.359776,49.664062],[6.368439,49.665368],[6.370744,49.665849],[6.372739,49.666354],[6.375857,49.667383],[6.378481,49.668531],[6.381553,49.67018],[6.386308,49.672945],[6.390044,49.674939],[6.3928,49.676231],[6.39643,49.677821],[6.400935,49.68007],[6.403212,49.681098],[6.405014,49.681794],[6.408493,49.682799],[6.410605,49.683233],[6.413985,49.68372],[6.420316,49.684098],[6.422484,49.684336],[6.425038,49.68484],[6.427702,49.6858],[6.432899,49.688335],[6.434387,49.688896],[6.438727,49.690231],[6.441742,49.691207],[6.44489,49.692361],[6.447937,49.693638],[6.449109,49.694049],[6.451824,49.69471],[6.456126,49.695245],[6.457644,49.695507],[6.460144,49.696229],[6.463163,49.697537],[6.464398,49.698306],[6.466102,49.699692],[6.468545,49.702317],[6.46937,49.7031],[6.47167,49.70477],[6.473728,49.705888],[6.475103,49.70652],[6.478622,49.707913],[6.481074,49.709037],[6.482321,49.709801],[6.484419,49.71145],[6.485781,49.712871],[6.486904,49.714414],[6.487435,49.715384],[6.488114,49.717387],[6.488321,49.718887],[6.488316,49.72078],[6.488555,49.722997],[6.488907,49.724195],[6.489659,49.725598],[6.491044,49.727304],[6.493804,49.729535],[6.496849,49.731174],[6.499983,49.732472],[6.503155,49.733447],[6.506133,49.734106],[6.508009,49.734396],[6.510477,49.734637],[6.514177,49.73476],[6.519099,49.734817],[6.5241,49.735122],[6.528064,49.735575],[6.531525,49.736118],[6.533813,49.736561],[6.537857,49.737457],[6.540368,49.73812],[6.54409,49.739251],[6.548588,49.7409],[6.552476,49.742604],[6.554642,49.743684],[6.558072,49.74565],[6.559761,49.746701],[6.56208,49.748302],[6.565059,49.750597],[6.56766,49.752805],[6.571383,49.755857],[6.573563,49.757519],[6.576211,49.759423],[6.578733,49.76112],[6.580414,49.762169],[6.583927,49.764232],[6.587559,49.766199],[6.590299,49.767553],[6.595166,49.769749],[6.597895,49.770858],[6.602472,49.772587],[6.605,49.7734],[6.605719,49.773395],[6.606263,49.773043],[6.606342,49.772571],[6.605975,49.772169],[6.604611,49.772065],[6.600979,49.772587],[6.599994,49.772802],[6.592912,49.77404],[6.591525,49.774363],[6.589148,49.775212],[6.587015,49.776292],[6.584809,49.777564],[6.579451,49.779701],[6.578338,49.78036],[6.577202,49.782008],[6.576371,49.782664],[6.5751,49.783285],[6.574163,49.784119],[6.573845,49.784919],[6.574217,49.787045],[6.574188,49.788049],[6.572903,49.790126],[6.572275,49.791548],[6.572189,49.792625],[6.572397,49.795175],[6.571222,49.799385],[6.571088,49.800743],[6.571287,49.801803],[6.571871,49.803111],[6.575089,49.809298],[6.575482,49.810407],[6.575542,49.811561],[6.575174,49.812734],[6.574323,49.814372],[6.571301,49.820494],[6.569183,49.824633],[6.568437,49.825685],[6.566659,49.827074],[6.561702,49.83009],[6.559934,49.831278],[6.558404,49.832628],[6.557093,49.834387],[6.556035,49.836337],[6.555162,49.837725],[6.552253,49.841448],[6.550752,49.843974],[6.54908,49.848053],[6.547068,49.852563],[6.546136,49.8537],[6.545206,49.854304],[6.543251,49.855145],[6.542042,49.855897],[6.54139,49.856647],[6.540983,49.857663],[6.541015,49.858488],[6.54133,49.859286],[6.542112,49.860192],[6.543824,49.861422],[6.544738,49.862729],[6.54488,49.863569],[6.54484,49.870834],[6.544868,49.875201],[6.54483,49.880544],[6.544915,49.882395],[6.544916,49.885106],[6.545266,49.888985],[6.545712,49.891782],[6.545853,49.893579],[6.545781,49.89429],[6.54355,49.900856],[6.542477,49.903469],[6.540986,49.907395],[6.539277,49.913051],[6.538559,49.915943],[6.536646,49.923975],[6.53541,49.928263],[6.534259,49.933365],[6.533352,49.936301],[6.532264,49.939267],[6.531287,49.941435],[6.529308,49.946393],[6.527564,49.950234],[6.526415,49.951877],[6.524946,49.953131],[6.523677,49.953918],[6.51987,49.955494],[6.518758,49.956186],[6.517226,49.957749],[6.51601,49.959421],[6.514954,49.961502],[6.514314,49.963324],[6.514024,49.965315],[6.514,49.967503],[6.513794,49.969659],[6.513298,49.972262],[6.513193,49.973543],[6.51324,49.975198],[6.513456,49.976799],[6.513906,49.979052],[6.5145,49.981355],[6.515413,49.983675],[6.516152,49.984969],[6.517188,49.98643],[6.518554,49.987968],[6.519477,49.988831],[6.521253,49.9902],[6.522795,49.991227],[6.525267,49.992553],[6.52906,49.99424],[6.531127,49.995233],[6.533025,49.99644],[6.534641,49.997855],[6.535667,49.99902],[6.536624,50.000654],[6.537667,50.00337],[6.538097,50.006421],[6.538105,50.008027],[6.537783,50.010245],[6.537443,50.011543],[6.536898,50.013026],[6.535509,50.0157],[6.534417,50.017317],[6.532156,50.01981],[6.529434,50.022456],[6.528531,50.023421],[6.527175,50.025311],[6.526206,50.02749],[6.525833,50.029075],[6.525848,50.031525],[6.526425,50.034382],[6.527207,50.037048],[6.527972,50.040128],[6.528916,50.040345],[6.529347,50.040008],[6.52917,50.039014],[6.528332,50.038677],[6.525619,50.038883],[6.517884,50.039361],[6.515523,50.039668],[6.512845,50.040161],[6.509856,50.040842],[6.506256,50.041848],[6.50412,50.042599],[6.499926,50.044405],[6.498312,50.045308],[6.49512,50.047534],[6.494437,50.048507],[6.492239,50.050293],[6.489792,50.051662],[6.488556,50.052713],[6.483212,50.058349],[6.482478,50.058927],[6.481456,50.060159],[6.480448,50.06111],[6.47835,50.063316],[6.474162,50.067595],[6.472087,50.069846],[6.470243,50.071724],[6.467726,50.074655],[6.46442,50.07871],[6.462371,50.081712],[6.460541,50.084271],[6.458845,50.086313],[6.457077,50.087971],[6.455784,50.088946],[6.453559,50.090349],[6.4496,50.092948],[6.448032,50.094277],[6.447189,50.095325],[6.446252,50.09735],[6.445748,50.099641],[6.444984,50.101817],[6.444285,50.102793],[6.44102,50.106291],[6.439837,50.107852],[6.438609,50.11014],[6.437438,50.113478],[6.436849,50.115428],[6.435992,50.117283],[6.43523,50.118571],[6.433343,50.121172],[6.43058,50.124017],[6.428647,50.125628],[6.426071,50.127494],[6.421311,50.130149],[6.416284,50.132399],[6.41366,50.133741],[6.412194,50.134647],[6.410807,50.135645],[6.408765,50.137462],[6.407305,50.139153],[6.406618,50.140166],[6.405276,50.142697],[6.404715,50.144446],[6.404428,50.146014],[6.403953,50.147799],[6.402946,50.150268],[6.401639,50.152314],[6.400176,50.154],[6.397997,50.156338],[6.395851,50.159083],[6.395117,50.159805],[6.393291,50.163118],[6.392143,50.165524],[6.391599,50.166925],[6.390594,50.171225],[6.390351,50.173023],[6.390441,50.173496],[6.391379,50.17409],[6.391963,50.174968],[6.396807,50.1748],[6.399173,50.174661],[6.401598,50.174647],[6.403503,50.174789],[6.406398,50.175201],[6.407613,50.175467],[6.409426,50.176073],[6.41213,50.177313],[6.413792,50.178362],[6.415646,50.179845],[6.416433,50.180725],[6.418091,50.183524],[6.420459,50.186014],[6.422211,50.18728],[6.42442,50.18853],[6.426205,50.189674],[6.427286,50.190538],[6.428293,50.191643],[6.429697,50.193742],[6.431789,50.196557],[6.4326,50.197872],[6.43305,50.199282],[6.433123,50.200651],[6.43271,50.20313],[6.432658,50.20437],[6.433625,50.206307],[6.43455,50.20726],[6.436964,50.208705],[6.439266,50.20971],[6.44061,50.210153],[6.442629,50.211032],[6.445966,50.212349],[6.451017,50.214554],[6.453578,50.215293],[6.455054,50.214618],[6.455412,50.214676],[6.455709,50.215424],[6.454554,50.216585],[6.45394,50.216987],[6.453487,50.21815],[6.452577,50.219242],[6.450888,50.220335],[6.449771,50.22088],[6.449271,50.221337],[6.448528,50.223231],[6.448538,50.225606],[6.449077,50.226953],[6.449654,50.227851],[6.451001,50.229014],[6.452628,50.23007],[6.454095,50.231265],[6.45494,50.232297],[6.455356,50.233068],[6.456137,50.235391],[6.45669,50.236741],[6.457423,50.237808],[6.459122,50.239526],[6.460898,50.240759],[6.462682,50.241746],[6.465198,50.24296],[6.466377,50.243702],[6.467728,50.244971],[6.468358,50.245978],[6.468825,50.247478],[6.468859,50.248342],[6.468388,50.250073],[6.467388,50.251493],[6.465694,50.252893],[6.461342,50.255145],[6.459134,50.256588],[6.457315,50.258209],[6.455561,50.260598],[6.454909,50.262002],[6.454535,50.263932],[6.454629,50.265203],[6.455211,50.26679],[6.457879,50.271009],[6.458671,50.272888],[6.459154,50.274998],[6.459369,50.278056],[6.459746,50.279283],[6.460999,50.281226],[6.462084,50.282319],[6.464128,50.283727],[6.466963,50.285273],[6.470975,50.287041],[6.474638,50.288797],[6.47655,50.290062],[6.477988,50.291592],[6.478522,50.29258],[6.478828,50.294237],[6.478606,50.295511],[6.477979,50.297759],[6.478085,50.299099],[6.478663,50.300449],[6.479616,50.30154],[6.481143,50.302624],[6.482553,50.303253],[6.485781,50.304408],[6.486909,50.305021],[6.487855,50.305754],[6.489509,50.307503],[6.490381,50.308198],[6.49672,50.312364],[6.497456,50.313144],[6.499832,50.316962],[6.501996,50.320578],[6.502707,50.321606],[6.503357,50.322121],[6.507254,50.324313],[6.508662,50.325627],[6.511002,50.328231],[6.514558,50.332076],[6.515196,50.333636],[6.515126,50.335297],[6.514896,50.336912],[6.514988,50.337614],[6.515456,50.33874],[6.517311,50.341304],[6.518098,50.342615],[6.518428,50.343998],[6.517967,50.345864],[6.517363,50.346991],[6.513807,50.352702],[6.511657,50.35625],[6.511057,50.357622],[6.510773,50.359266],[6.510777,50.360902],[6.510633,50.362348],[6.510024,50.36421],[6.50987,50.365389],[6.510467,50.368204],[6.51038,50.368886],[6.509761,50.37115],[6.509544,50.372513],[6.509569,50.373385],[6.510042,50.374632],[6.5106,50.375378],[6.511664,50.376349],[6.520587,50.382876],[6.523816,50.385172],[6.525113,50.385958],[6.527512,50.387071],[6.532651,50.389299],[6.534545,50.390034],[6.536285,50.390582],[6.541489,50.391832],[6.54298,50.392282],[6.545472,50.393232],[6.552502,50.396147],[6.55433,50.396962],[6.557113,50.398466],[6.560175,50.400724],[6.562011,50.401875],[6.564723,50.403259],[6.567272,50.40477],[6.568695,50.405854],[6.570949,50.407823],[6.578096,50.413261],[6.579443,50.414127],[6.581475,50.415119],[6.585742,50.416917],[6.587662,50.417862],[6.594913,50.421986],[6.597963,50.423827],[6.599315,50.424534],[6.6032,50.42683],[6.604414,50.427647],[6.606178,50.429058],[6.607204,50.430041],[6.608248,50.431335],[6.609834,50.434017],[6.610155,50.434934],[6.611625,50.440183],[6.61259,50.442173],[6.613642,50.443563],[6.615011,50.444811],[6.616441,50.445867],[6.61762,50.446567],[6.619367,50.447367],[6.621274,50.448118],[6.623025,50.448559],[6.626904,50.449154],[6.629201,50.449225],[6.632128,50.449136],[6.639165,50.448729],[6.644501,50.448554],[6.647448,50.448635],[6.649546,50.448824],[6.652856,50.449402],[6.656497,50.450198],[6.659152,50.450697],[6.661114,50.450919],[6.666952,50.451178],[6.669572,50.451442],[6.672241,50.452033],[6.673884,50.45259],[6.675872,50.453395],[6.681738,50.455935],[6.683497,50.456533],[6.68806,50.457881],[6.68987,50.458559],[6.692182,50.459887],[6.69315,50.460752],[6.695321,50.462901],[6.69631,50.463491],[6.699618,50.464953],[6.700182,50.465121],[6.699048,50.465857],[6.697219,50.466313],[6.696699,50.466806],[6.693461,50.47118],[6.691557,50.473513],[6.689887,50.475406],[6.686521,50.478705],[6.685364,50.479757],[6.680754,50.483728],[6.676676,50.487139],[6.673148,50.490337],[6.670828,50.492813],[6.668671,50.495385],[6.667492,50.496999],[6.665821,50.499877],[6.664692,50.502592],[6.66418,50.50428],[6.663734,50.506423],[6.663498,50.508885],[6.663542,50.510461],[6.66396,50.513551],[6.664232,50.514659],[6.665428,50.518275],[6.666233,50.52027],[6.667546,50.522912],[6.672779,50.531874],[6.67464,50.535277],[6.675727,50.53764],[6.676645,50.540047],[6.677716,50.543566],[6.678278,50.546006],[6.67892,50.549549],[6.680073,50.557399],[6.680727,50.560512],[6.681251,50.562493],[6.681933,50.564679],[6.683093,50.567729],[6.683983,50.56967],[6.687208,50.575476],[6.688689,50.57792],[6.690622,50.580877],[6.693775,50.585297],[6.694619,50.586336],[6.697346,50.590073],[6.69982,50.593563],[6.710643,50.60796],[6.712299,50.610461],[6.714222,50.613863],[6.715286,50.616223],[6.71592,50.617994],[6.716349,50.619533],[6.716706,50.621473],[6.716878,50.623012],[6.717072,50.626369],[6.717329,50.629099],[6.717892,50.631575],[6.718496,50.633084],[6.720303,50.636755],[6.721096,50.638506],[6.72162,50.640085],[6.722019,50.641883],[6.722313,50.645185],[6.722263,50.649671],[6.722379,50.652137],[6.722771,50.654817],[6.723169,50.65657],[6.72364,50.658057],[6.724888,50.661084],[6.726156,50.663321],[6.72753,50.665345],[6.729054,50.667328],[6.731379,50.669769],[6.732971,50.671223],[6.734887,50.672825],[6.736989,50.674383],[6.738928,50.675703],[6.741254,50.677078],[6.745332,50.679219],[6.751506,50.682281],[6.75394,50.683608],[6.757206,50.685683],[6.759841,50.687546],[6.761884,50.689324],[6.764344,50.691718],[6.765637,50.69317],[6.767173,50.695118],[6.768796,50.697513],[6.771537,50.702384],[6.774363,50.708421],[6.775231,50.710557],[6.777719,50.715827],[6.778892,50.718007],[6.780306,50.720386],[6.781422,50.722094],[6.783345,50.72484],[6.785621,50.727732],[6.787728,50.730146],[6.790387,50.732877],[6.791944,50.734389],[6.794404,50.736643],[6.79698,50.738869],[6.80242,50.743387],[6.805611,50.746075],[6.807498,50.747734],[6.80975,50.749832],[6.812671,50.75295],[6.815446,50.756414],[6.81792,50.759962],[6.820476,50.763896],[6.821423,50.765595],[6.822181,50.767776],[6.822365,50.769053],[6.822284,50.770777],[6.821866,50.772],[6.821472,50.772581],[6.820273,50.773633],[6.819255,50.774222],[6.817294,50.775128],[6.816348,50.775828],[6.814648,50.777392],[6.813704,50.778423],[6.811711,50.780973],[6.809076,50.784833],[6.804055,50.791996],[6.798593,50.799971],[6.79462,50.805537],[6.793181,50.807397],[6.790417,50.810808],[6.788094,50.813599],[6.786485,50.816204],[6.785723,50.818193],[6.785287,50.819971],[6.785212,50.822704],[6.785524,50.824613],[6.786395,50.826974],[6.787016,50.828078],[6.788137,50.829592],[6.789425,50.831015],[6.79451,50.835599],[6.797736,50.838732],[6.799362,50.840739],[6.800921,50.843254],[6.802195,50.845831],[6.802995,50.84773],[6.803811,50.850095],[6.804565,50.852729],[6.805274,50.856268],[6.805562,50.859557],[6.805587,50.861129],[6.805381,50.863825],[6.805037,50.865407],[6.804514,50.866983],[6.802395,50.872484],[6.801944,50.874113],[6.801767,50.876008],[6.801877,50.877212],[6.802565,50.879541],[6.803428,50.88116],[6.805016,50.883083],[6.807254,50.884933],[6.809087,50.886059],[6.811111,50.88706],[6.814512,50.888479],[6.819468,50.890357],[6.820602,50.890899],[6.826487,50.894181],[6.830214,50.896042],[6.832849,50.897124],[6.836174,50.898308],[6.838296,50.899144],[6.840858,50.900365],[6.843139,50.901774],[6.844795,50.903215],[6.845923,50.904565],[6.846747,50.906004],[6.847344,50.907934],[6.847477,50.909455],[6.847377,50.910547],[6.846833,50.9124],[6.845996,50.913979],[6.843657,50.917377],[6.843086,50.918832],[6.842937,50.919977],[6.843026,50.921502],[6.843266,50.922334],[6.844105,50.923897],[6.848001,50.929843],[6.848689,50.931164],[6.849204,50.933131],[6.849546,50.936634],[6.849489,50.938569],[6.849672,50.941863],[6.849736,50.944576],[6.849637,50.945431],[6.849688,50.948049],[6.849855,50.950537],[6.850619,50.957379],[6.850803,50.959498],[6.850816,50.963307],[6.850703,50.965891],[6.850243,50.970589],[6.850174,50.971999],[6.850331,50.974884],[6.850693,50.976438],[6.851633,50.97865],[6.852889,50.980757],[6.854507,50.982598],[6.856107,50.984056],[6.85884,50.985984],[6.860523,50.986957],[6.863491,50.988342],[6.866685,50.989458],[6.87207,50.991095],[6.875235,50.992112],[6.87952,50.99341],[6.880231,50.993578],[6.889683,50.99647],[6.892357,50.997244],[6.893029,50.997269],[6.893555,50.996656],[6.89318,50.996329],[6.892015,50.996515],[6.88794,50.999423],[6.883638,51.002757],[6.876972,51.007874],[6.873326,51.010577],[6.870649,51.012489],[6.866816,51.015105],[6.862469,51.017931],[6.853668,51.023354],[6.850922,51.025148],[6.849113,51.026415],[6.846611,51.028369],[6.844496,51.03022],[6.842688,51.032085],[6.840919,51.034139],[6.8398,51.035698],[6.838532,51.037682],[6.837154,51.040323],[6.836361,51.042171],[6.83585,51.043634],[6.835198,51.046183],[6.834707,51.049131],[6.834046,51.054878],[6.833636,51.057901],[6.832891,51.0616],[6.832247,51.063762],[6.831606,51.065487],[6.830726,51.067387],[6.829925,51.068821],[6.828441,51.071057],[6.826578,51.073427],[6.824046,51.076096],[6.819981,51.079704],[6.81193,51.086442],[6.809728,51.088413],[6.80746,51.090617],[6.80596,51.092249],[6.805044,51.093388],[6.803653,51.095441],[6.802139,51.098269],[6.801224,51.100722],[6.800597,51.103113],[6.800258,51.10581],[6.800284,51.109568],[6.800227,51.113904],[6.799988,51.116165],[6.799146,51.119103],[6.798123,51.121346],[6.797194,51.123079],[6.796181,51.124671],[6.794261,51.127108],[6.792868,51.128655],[6.791347,51.130139],[6.788584,51.132413],[6.78699,51.133581],[6.785034,51.134829],[6.781498,51.136855],[6.779147,51.138032],[6.771802,51.141585],[6.767843,51.143647],[6.764058,51.145811],[6.762366,51.146857],[6.759918,51.148534],[6.757497,51.15028],[6.754816,51.152426],[6.753102,51.153888],[6.751113,51.155719],[6.747291,51.159386],[6.74378,51.162968],[6.741035,51.165498],[6.738235,51.167582],[6.73609,51.168769],[6.733497,51.169943],[6.73129,51.170676],[6.72756,51.171579],[6.720812,51.172731],[6.718894,51.173165],[6.716577,51.173912],[6.715202,51.174508],[6.713471,51.175487],[6.711674,51.176678],[6.710041,51.177637],[6.709301,51.178415],[6.709033,51.179367],[6.709458,51.180528],[6.711429,51.182855],[6.712698,51.184698],[6.714179,51.18759],[6.715613,51.191633],[6.717697,51.197209],[6.718256,51.19792],[6.71975,51.198663],[6.720979,51.198882],[6.72353,51.199035],[6.72536,51.19898],[6.733697,51.19851],[6.737977,51.198233],[6.742456,51.198518],[6.745464,51.198995],[6.749736,51.20013],[6.752417,51.200721],[6.754875,51.200854],[6.755471,51.200984],[6.755752,51.201438],[6.756644,51.204788],[6.757599,51.208133],[6.758174,51.209132],[6.758813,51.210909],[6.759308,51.211957],[6.760693,51.213931],[6.761358,51.215673],[6.771573,51.230428],[6.771805,51.231832],[6.771739,51.235923],[6.772163,51.236979],[6.772097,51.238206],[6.771679,51.239507],[6.77079,51.241786],[6.771251,51.24254],[6.772432,51.243877],[6.772221,51.246641],[6.771926,51.248297],[6.771707,51.250645],[6.771885,51.252361],[6.771533,51.253108],[6.770999,51.253563],[6.767304,51.25525],[6.764397,51.256306],[6.762935,51.257229],[6.762334,51.258032],[6.76205,51.258904],[6.761855,51.260407],[6.761092,51.261598],[6.760097,51.262426],[6.758728,51.263299],[6.755535,51.264988],[6.75397,51.266053],[6.75305,51.267195],[6.751392,51.27051],[6.751331,51.271163],[6.75234,51.271361],[6.75408,51.271498],[6.755657,51.271481],[6.760924,51.271261],[6.762572,51.271257],[6.775313,51.276546],[6.77709,51.278271],[6.782725,51.284917],[6.783901,51.286268],[6.785518,51.287889],[6.787332,51.2892],[6.788981,51.289999],[6.790486,51.290496],[6.793133,51.290899],[6.795544,51.290829],[6.7976,51.290419],[6.799622,51.289184],[6.801132,51.289203],[6.801877,51.289662],[6.802143,51.290327],[6.802149,51.291424],[6.802533,51.292497],[6.803732,51.293789],[6.805527,51.295144],[6.806388,51.296006],[6.806924,51.29679],[6.807404,51.298094],[6.808259,51.302265],[6.808855,51.303681],[6.809414,51.30448],[6.811185,51.306152],[6.814524,51.308577],[6.816027,51.309927],[6.817621,51.311779],[6.820246,51.315298],[6.822356,51.317823],[6.823728,51.319232],[6.825126,51.320339],[6.826655,51.321332],[6.833768,51.324972],[6.837402,51.32689],[6.839197,51.327954],[6.841083,51.329276],[6.843436,51.33133],[6.844417,51.332491],[6.845699,51.33436],[6.846634,51.336051],[6.848431,51.340609],[6.849465,51.342182],[6.851266,51.344134],[6.85457,51.346893],[6.859485,51.351133],[6.862133,51.353329],[6.864834,51.355259],[6.868906,51.357541],[6.874289,51.360093],[6.877611,51.361982],[6.879698,51.36338],[6.882041,51.365217],[6.887921,51.370345],[6.889092,51.371447],[6.891334,51.373344],[6.89409,51.375316],[6.895557,51.376247],[6.898129,51.377676],[6.900054,51.378619],[6.903301,51.379944],[6.907626,51.381346],[6.911912,51.382402],[6.913538,51.382701],[6.917545,51.383295],[6.921218,51.383892],[6.92378,51.384438],[6.925682,51.384926],[6.927555,51.385518],[6.930131,51.386541],[6.932794,51.387874],[6.934843,51.389043],[6.938154,51.391246],[6.945682,51.396454],[6.949991,51.399079],[6.954292,51.40124],[6.955336,51.401331],[6.956089,51.400817],[6.955886,51.400429],[6.954454,51.399802],[6.954151,51.399813],[6.951534,51.400726],[6.950814,51.401321],[6.950544,51.402284],[6.950997,51.404074],[6.950705,51.405423],[6.95041,51.405952],[6.949393,51.407071],[6.948516,51.407671],[6.948938,51.408025],[6.950268,51.408517],[6.951617,51.409243],[6.952321,51.409826],[6.952631,51.410383],[6.952676,51.411558],[6.953266,51.413218],[6.955156,51.415504],[6.957943,51.418396],[6.959552,51.420463],[6.960688,51.42207],[6.961653,51.423235],[6.962537,51.42462],[6.963457,51.427039],[6.963835,51.427789],[6.964083,51.429169],[6.964026,51.429867],[6.964905,51.434655],[6.965198,51.43534],[6.965439,51.436991],[6.966002,51.438824],[6.967879,51.440778],[6.96904,51.443056],[6.969929,51.443672],[6.973423,51.445291],[6.971847,51.444631],[6.969606,51.443533],[6.968916,51.443087],[6.968567,51.442162],[6.969922,51.442291],[6.973836,51.442948],[6.979274,51.443722],[6.983227,51.444334],[6.988227,51.444931],[6.994661,51.445911],[6.996292,51.446195],[7.00074,51.446751],[7.01503,51.449905],[7.015996,51.449842],[7.018425,51.449945],[7.019822,51.450146],[7.023449,51.450994],[7.028625,51.451571],[7.029796,51.451783],[7.033275,51.452965],[7.034671,51.453295],[7.040546,51.45426],[7.042532,51.454642],[7.04386,51.455064],[7.049216,51.457962],[7.050689,51.458651],[7.052952,51.459507],[7.056911,51.460776],[7.059624,51.461779],[7.063036,51.463151],[7.065453,51.463924],[7.067603,51.464073],[7.071416,51.464148],[7.074606,51.464278],[7.081034,51.464746],[7.086123,51.465352],[7.087514,51.465582],[7.089349,51.466159],[7.09734,51.470853],[7.098527,51.471383],[7.100887,51.472004],[7.102345,51.472162],[7.104607,51.472088],[7.10763,51.471638],[7.109958,51.471389],[7.11159,51.471367],[7.113952,51.471547],[7.115863,51.471835],[7.121244,51.473082],[7.123738,51.473602],[7.126665,51.474026],[7.131193,51.474352],[7.133882,51.474376],[7.140437,51.474242],[7.143439,51.474371],[7.146506,51.474611],[7.152314,51.475379],[7.156135,51.476026],[7.158798,51.476623],[7.161022,51.477244],[7.164749,51.478431],[7.166282,51.478808],[7.170594,51.479474],[7.17368,51.480088],[7.175166,51.480507],[7.177616,51.481429],[7.17978,51.482555],[7.18166,51.483817],[7.182771,51.484823],[7.184038,51.486324],[7.184567,51.487225],[7.185174,51.48911],[7.185285,51.490264],[7.184965,51.492191],[7.185196,51.493537],[7.185939,51.494398],[7.186986,51.49516],[7.187954,51.495565],[7.189621,51.495943],[7.191465,51.496125],[7.192967,51.496137],[7.197222,51.496411],[7.199058,51.496579],[7.206397,51.49749],[7.210735,51.497925],[7.214975,51.498236],[7.218617,51.498432],[7.222122,51.498267],[7.224743,51.497925],[7.22605,51.497665],[7.2288,51.496706],[7.230836,51.495544],[7.233042,51.494645],[7.23428,51.49435],[7.235867,51.494171],[7.237112,51.494232],[7.242763,51.495246],[7.245612,51.495129],[7.250745,51.494528],[7.253949,51.494445],[7.257351,51.4946],[7.259922,51.494885],[7.266327,51.496051],[7.269665,51.496517],[7.273748,51.496834],[7.276159,51.496934],[7.280007,51.496902],[7.283967,51.496793],[7.290575,51.496701],[7.295479,51.496578],[7.304048,51.496453],[7.31231,51.496039],[7.317806,51.496003],[7.324098,51.496271],[7.327893,51.496609],[7.32932,51.496814],[7.331487,51.496866],[7.334337,51.496427],[7.337315,51.495345],[7.34088,51.494386],[7.343964,51.493698],[7.346187,51.49331],[7.350013,51.492795],[7.353474,51.492509],[7.355453,51.492498],[7.35815,51.492738],[7.361175,51.493465],[7.362917,51.494109],[7.366234,51.49548],[7.367875,51.49607],[7.370942,51.496913],[7.374225,51.497451],[7.375701,51.497607],[7.379106,51.497805],[7.383326,51.497754],[7.387497,51.497402],[7.390797,51.496926],[7.393409,51.496697],[7.402239,51.495577],[7.403358,51.495463],[7.406498,51.495444],[7.409659,51.495757],[7.415353,51.496563],[7.419005,51.496986],[7.423054,51.49753],[7.426274,51.497779],[7.429487,51.4978],[7.441939,51.497391],[7.445355,51.497355],[7.45054,51.497533],[7.457432,51.497845],[7.4647,51.498393],[7.466831,51.49862],[7.472499,51.49896],[7.478348,51.499782],[7.483931,51.500705],[7.485572,51.501188],[7.487522,51.501545],[7.490945,51.502415],[7.492762,51.502782],[7.499016,51.503635],[7.501332,51.503709],[7.505887,51.503654],[7.510629,51.503751],[7.513592,51.503707],[7.515554,51.503782],[7.519778,51.504609],[7.521658,51.504891],[7.523911,51.505411],[7.529798,51.506532],[7.53521,51.507304],[7.539789,51.508009],[7.543462,51.50862],[7.5445,51.50873],[7.546797,51.509201],[7.55137,51.50965],[7.553404,51.509689],[7.556478,51.509456],[7.560423,51.508816],[7.564426,51.508015],[7.573787,51.506488],[7.577749,51.505945],[7.58116,51.505637],[7.58331,51.505591],[7.587275,51.505632],[7.592223,51.505968],[7.59504,51.506377],[7.602984,51.50794],[7.60572,51.508576],[7.610112,51.509748],[7.614601,51.511004],[7.619476,51.512516],[7.625753,51.514625],[7.632845,51.517459],[7.637146,51.51905],[7.639297,51.519767],[7.642247,51.520593],[7.644819,51.521174],[7.646993,51.52157],[7.651829,51.522079],[7.655892,51.522115],[7.658412,51.52205],[7.659441,51.521861],[7.65971,51.521527],[7.658923,51.521028],[7.658371,51.52122],[7.658264,51.521874],[7.658561,51.522646],[7.659579,51.527129],[7.660631,51.532621],[7.66141,51.535995],[7.661901,51.538413],[7.66285,51.542602],[7.663483,51.546038],[7.663853,51.549252],[7.66431,51.554503],[7.664949,51.560311],[7.665396,51.564896],[7.665844,51.566945],[7.66621,51.568107],[7.667035,51.570039],[7.668301,51.57229],[7.669785,51.574357],[7.671498,51.576269],[7.673267,51.57795],[7.676974,51.580812],[7.67919,51.582876],[7.681196,51.58511],[7.68292,51.587271],[7.684354,51.589564],[7.685262,51.591994],[7.685927,51.594636],[7.686447,51.595994],[7.686878,51.597732],[7.687624,51.598619],[7.690807,51.600324],[7.692163,51.600705],[7.694901,51.600714],[7.698334,51.600852],[7.702463,51.600789],[7.706399,51.600828],[7.708724,51.600985],[7.710995,51.601267],[7.713118,51.601638],[7.716791,51.602427],[7.725546,51.604523],[7.730981,51.605798],[7.732108,51.606164],[7.736759,51.607134],[7.748195,51.609901],[7.754184,51.611285],[7.758809,51.612273],[7.767469,51.614004],[7.773786,51.615348],[7.775621,51.615693],[7.781542,51.616941],[7.788608,51.618292],[7.797195,51.619783],[7.80352,51.620931],[7.808468,51.621717],[7.810291,51.622067],[7.81641,51.622973],[7.821777,51.623471],[7.824529,51.623651],[7.831724,51.624001],[7.835737,51.62424],[7.837488,51.624294],[7.849061,51.624859],[7.853897,51.625178],[7.857344,51.625675],[7.85998,51.626287],[7.862148,51.626943],[7.864614,51.627878],[7.876197,51.63189],[7.878752,51.632867],[7.885481,51.635301],[7.892176,51.637655],[7.895745,51.639003],[7.89997,51.640667],[7.908335,51.643886],[7.910677,51.644856],[7.914009,51.646651],[7.915117,51.647377],[7.917141,51.648952],[7.919603,51.651503],[7.923272,51.656431],[7.924456,51.657922],[7.929575,51.664913],[7.931289,51.6669],[7.933779,51.669018],[7.935911,51.670428],[7.937381,51.671219],[7.941759,51.673326],[7.946693,51.675873],[7.948877,51.677213],[7.950593,51.678517],[7.952431,51.680175],[7.959017,51.685903],[7.96515,51.691134],[7.97087,51.696132],[7.972531,51.697548],[7.974324,51.699256],[7.97618,51.70135],[7.977434,51.703221],[7.97824,51.705159],[7.978641,51.70689],[7.979062,51.71147],[7.97923,51.715655],[7.979502,51.7169],[7.979394,51.718598],[7.979862,51.722335],[7.98038,51.72398],[7.981086,51.725507],[7.983693,51.729863],[7.986203,51.734179],[7.991248,51.742492],[7.993849,51.746853],[7.995026,51.748712],[7.998708,51.754953],[8.002499,51.761157],[8.003863,51.763465],[8.004604,51.76452],[8.006526,51.767789],[8.007985,51.769619],[8.009332,51.770944],[8.01072,51.772093],[8.012916,51.773498],[8.015368,51.774723],[8.01701,51.775392],[8.019095,51.776093],[8.023133,51.777126],[8.032457,51.779211],[8.035227,51.77988],[8.046143,51.782372],[8.049645,51.783377],[8.059007,51.78657],[8.059698,51.786837],[8.06652,51.78918],[8.071138,51.790704],[8.077844,51.79308],[8.084284,51.795221],[8.091288,51.797669],[8.093545,51.798401],[8.097705,51.799585],[8.101425,51.800555],[8.113294,51.803353],[8.116995,51.804114],[8.128484,51.80621],[8.131461,51.80685],[8.133954,51.807581],[8.136284,51.808474],[8.137887,51.809183],[8.143302,51.811449],[8.145311,51.812158],[8.151424,51.813779],[8.161975,51.8164],[8.164044,51.817034],[8.169356,51.818476],[8.173195,51.819647],[8.180467,51.821723],[8.183733,51.822549],[8.187515,51.823626],[8.19095,51.824447],[8.193827,51.825063],[8.197199,51.825667],[8.212251,51.82779],[8.221791,51.829103],[8.22961,51.830229],[8.236985,51.831342],[8.242666,51.83211],[8.246035,51.832645],[8.249559,51.833129],[8.251581,51.833469],[8.258609,51.834442],[8.264103,51.8353],[8.26648,51.835849],[8.268424,51.836394],[8.272123,51.837691],[8.272806,51.83799],[8.283367,51.841856],[8.288116,51.843413],[8.30293,51.847383],[8.306321,51.848261],[8.313039,51.85009],[8.315884,51.851092],[8.318654,51.852272],[8.327314,51.856274],[8.33047,51.857432],[8.332498,51.858039],[8.335742,51.858754],[8.343742,51.859929],[8.35169,51.861057],[8.353647,51.861383],[8.356358,51.861966],[8.360364,51.863158],[8.36604,51.864675],[8.367482,51.864976],[8.367724,51.865177],[8.38018,51.868642],[8.38413,51.869438],[8.387223,51.86984],[8.391626,51.870324],[8.394058,51.870658],[8.406871,51.872256],[8.40963,51.872804],[8.412309,51.873438],[8.415823,51.874619],[8.417157,51.875186],[8.426549,51.879767],[8.432547,51.882612],[8.43791,51.885282],[8.440719,51.886931],[8.445899,51.890266],[8.449831,51.892393],[8.453983,51.894283],[8.458617,51.896076],[8.462213,51.897205],[8.464055,51.897694],[8.469026,51.89881],[8.471375,51.899183],[8.481329,51.900971],[8.483211,51.901204],[8.486611,51.90187],[8.493137,51.903269],[8.49844,51.904443],[8.500802,51.905032],[8.503489,51.90588],[8.506521,51.907159],[8.508341,51.90817],[8.510888,51.909836],[8.512609,51.91124],[8.514854,51.913261],[8.518646,51.916769],[8.521776,51.919583],[8.524844,51.922447],[8.525559,51.923018],[8.528089,51.925445],[8.52948,51.926886],[8.530858,51.928608],[8.531929,51.930182],[8.534403,51.934913],[8.535352,51.936517],[8.536577,51.938177],[8.538861,51.940471],[8.541009,51.942105],[8.54372,51.943609],[8.546038,51.944675],[8.547455,51.945229],[8.55266,51.94707],[8.555988,51.948365],[8.557466,51.948846],[8.563336,51.950959],[8.56525,51.951756],[8.568225,51.953363],[8.570592,51.954867],[8.575829,51.958022],[8.578088,51.959175],[8.580826,51.960273],[8.58335,51.96121],[8.586336,51.962129],[8.591476,51.963627],[8.595036,51.964619],[8.601045,51.966403],[8.602394,51.966849],[8.605621,51.968134],[8.610397,51.970212],[8.611888,51.971057],[8.61371,51.972512],[8.614423,51.973422],[8.615059,51.974769],[8.615304,51.975767],[8.616037,51.981168],[8.615887,51.982845],[8.61522,51.985428],[8.615233,51.987113],[8.615532,51.988075],[8.617205,51.991937],[8.619906,51.998411],[8.62058,51.999834],[8.621533,52.001497],[8.622235,52.002438],[8.624787,52.005485],[8.627782,52.008976],[8.630154,52.011984],[8.631605,52.014298],[8.632644,52.016178],[8.633399,52.017808],[8.63576,52.024014],[8.63759,52.02898],[8.638804,52.031705],[8.639922,52.033518],[8.641828,52.035645],[8.643622,52.037233],[8.647245,52.039709],[8.649334,52.041296],[8.650534,52.042409],[8.65179,52.043824],[8.655828,52.050304],[8.65739,52.052978],[8.658047,52.05432],[8.659036,52.056754],[8.66054,52.061975],[8.661297,52.064449],[8.662562,52.067062],[8.663366,52.068294],[8.665293,52.070686],[8.666571,52.071991],[8.668383,52.073615],[8.669716,52.074644],[8.672594,52.07653],[8.674786,52.077751],[8.677527,52.079026],[8.679153,52.079703],[8.687662,52.082976],[8.689673,52.083806],[8.692177,52.085059],[8.69364,52.085981],[8.69574,52.087782],[8.697451,52.089502],[8.698824,52.090746],[8.701828,52.09305],[8.703449,52.094117],[8.705783,52.095481],[8.708248,52.096683],[8.714346,52.099497],[8.721036,52.102637],[8.724511,52.104607],[8.727074,52.106297],[8.73168,52.109239],[8.734043,52.110796],[8.735291,52.111793],[8.736061,52.112589],[8.737148,52.114168],[8.737652,52.115474],[8.738005,52.117589],[8.736487,52.124583],[8.736238,52.126038],[8.736251,52.127934],[8.736525,52.129146],[8.73717,52.13047],[8.738267,52.132085],[8.739668,52.13343],[8.742,52.135052],[8.743109,52.13564],[8.745597,52.136666],[8.747283,52.137182],[8.748997,52.137548],[8.757103,52.138852],[8.759817,52.139154],[8.767375,52.139762],[8.770289,52.140087],[8.77457,52.140878],[8.778647,52.141939],[8.783359,52.143111],[8.78875,52.144499],[8.791084,52.145224],[8.794395,52.146505],[8.801078,52.148967],[8.803015,52.149814],[8.804884,52.150984],[8.806486,52.152496],[8.809222,52.155714],[8.811414,52.158217],[8.812029,52.159306],[8.813354,52.164039],[8.815369,52.170995],[8.816169,52.172451],[8.820666,52.178133],[8.823045,52.180967],[8.824497,52.18284],[8.824843,52.183479],[8.82534,52.18558],[8.825364,52.187131],[8.825565,52.188866],[8.825855,52.190167],[8.826435,52.191696],[8.827181,52.193199],[8.829049,52.195999],[8.829702,52.196754],[8.832077,52.200428],[8.834168,52.202095],[8.836645,52.203428],[8.838086,52.203961],[8.840003,52.204472],[8.845105,52.205496],[8.848142,52.206192],[8.849603,52.206597],[8.853086,52.207763],[8.859859,52.210173],[8.862808,52.210856],[8.865582,52.211143],[8.871161,52.211289],[8.873833,52.21127],[8.880001,52.211013],[8.882842,52.210998],[8.887487,52.211241],[8.891074,52.211306],[8.892894,52.211173],[8.897558,52.210391],[8.90025,52.209993],[8.90265,52.209733],[8.905158,52.209582],[8.907313,52.209611],[8.912625,52.209569],[8.922536,52.209633],[8.92451,52.209718],[8.926839,52.209925],[8.930802,52.210557],[8.937857,52.21226],[8.940694,52.21282],[8.942574,52.21306],[8.947581,52.213533],[8.951034,52.214083],[8.958342,52.215912],[8.960982,52.216426],[8.964,52.216809],[8.966251,52.216975],[8.978059,52.216926],[8.982328,52.216836],[8.987981,52.216782],[8.990785,52.216845],[8.992877,52.21709],[8.994514,52.217435],[8.998495,52.218583],[9.001015,52.219174],[9.002974,52.219439],[9.008373,52.219878],[9.010755,52.220292],[9.016035,52.221584],[9.018648,52.222012],[9.02186,52.222153],[9.032534,52.221267],[9.035521,52.220833],[9.038131,52.220283],[9.041758,52.219598],[9.045923,52.218747],[9.048861,52.218251],[9.050745,52.218093],[9.052298,52.21811],[9.054405,52.218356],[9.057348,52.219044],[9.062714,52.220819],[9.065258,52.221304],[9.067828,52.221489],[9.071817,52.221348],[9.080918,52.220641],[9.087256,52.220194],[9.089252,52.220171],[9.092066,52.220301],[9.096689,52.220817],[9.101833,52.221534],[9.104668,52.221761],[9.10773,52.221674],[9.109868,52.221384],[9.113204,52.220615],[9.11682,52.219994],[9.119324,52.219864],[9.121447,52.219978],[9.125659,52.220507],[9.128477,52.220686],[9.132827,52.220394],[9.137858,52.219832],[9.143135,52.219636],[9.1469,52.21956],[9.150722,52.219211],[9.155307,52.218685],[9.159051,52.218138],[9.162157,52.217455],[9.165816,52.216405],[9.167322,52.216059],[9.169245,52.215814],[9.177139,52.21561],[9.179775,52.215423],[9.181299,52.215407],[9.183198,52.215527],[9.186256,52.216051],[9.189951,52.217075],[9.195449,52.218509],[9.19909,52.21951],[9.205375,52.221146],[9.208081,52.221726],[9.211274,52.22201],[9.216815,52.221795],[9.219162,52.221918],[9.220713,52.222131],[9.222593,52.22256],[9.223999,52.223],[9.226536,52.224105],[9.22955,52.225923],[9.230909,52.226819],[9.235364,52.229532],[9.236916,52.230331],[9.238566,52.230992],[9.241376,52.231731],[9.247641,52.232674],[9.254565,52.233524],[9.260411,52.234349],[9.26357,52.234709],[9.268283,52.235397],[9.27101,52.23596],[9.273776,52.236736],[9.276354,52.237677],[9.278818,52.238795],[9.281883,52.240611],[9.284452,52.242718],[9.287661,52.245756],[9.290461,52.248234],[9.292049,52.249434],[9.293262,52.250132],[9.297825,52.252259],[9.301161,52.253732],[9.305029,52.25551],[9.306825,52.25646],[9.309225,52.258038],[9.311038,52.259609],[9.312275,52.260816],[9.314908,52.263706],[9.317251,52.265928],[9.319419,52.267611],[9.32217,52.269234],[9.325225,52.270672],[9.32783,52.271817],[9.335953,52.275614],[9.342024,52.278389],[9.343897,52.279387],[9.346147,52.280785],[9.347992,52.28205],[9.353184,52.28541],[9.356663,52.287705],[9.358421,52.288973],[9.360393,52.29077],[9.363117,52.293775],[9.365751,52.296758],[9.368969,52.300284],[9.376254,52.308438],[9.379526,52.312188],[9.382239,52.315177],[9.385413,52.318757],[9.38752,52.320932],[9.389881,52.322928],[9.39082,52.323636],[9.393367,52.325275],[9.395269,52.326359],[9.398706,52.328057],[9.402311,52.330095],[9.406112,52.33251],[9.408977,52.334455],[9.413418,52.337296],[9.415571,52.338796],[9.417276,52.340211],[9.418354,52.341244],[9.419441,52.342572],[9.422043,52.346933],[9.423109,52.348508],[9.424389,52.350053],[9.428746,52.354803],[9.431579,52.3578],[9.433354,52.359419],[9.439902,52.364613],[9.442876,52.366889],[9.446669,52.369588],[9.449628,52.371456],[9.451005,52.372209],[9.456004,52.375155],[9.461581,52.378341],[9.465263,52.380493],[9.467704,52.382005],[9.472295,52.385262],[9.472839,52.385599],[9.477102,52.388782],[9.479607,52.390577],[9.484869,52.394539],[9.487799,52.396583],[9.489199,52.397444],[9.501661,52.40457],[9.503865,52.405799],[9.510453,52.409573],[9.517236,52.413337],[9.520564,52.41509],[9.52379,52.41654],[9.526548,52.417604],[9.530024,52.418703],[9.532809,52.419407],[9.536346,52.42011],[9.539625,52.420588],[9.542196,52.420853],[9.546705,52.421158],[9.551683,52.421324],[9.556052,52.421415],[9.559044,52.421526],[9.561273,52.42168],[9.563935,52.42156],[9.564183,52.421255],[9.56671,52.421573],[9.566875,52.421972],[9.572318,52.422735],[9.573835,52.422826],[9.578977,52.423311],[9.582658,52.423528],[9.588945,52.423658],[9.590566,52.423505],[9.594432,52.423392],[9.597143,52.423187],[9.599784,52.422913],[9.600549,52.423032],[9.601651,52.422861],[9.604705,52.422646],[9.607077,52.422312],[9.615217,52.421629],[9.62095,52.421018],[9.625879,52.420836],[9.630057,52.420956],[9.632568,52.421167],[9.635463,52.421527],[9.637821,52.421909],[9.644358,52.423156],[9.648307,52.423961],[9.653793,52.424953],[9.660296,52.426243],[9.667806,52.427647],[9.67025,52.428192],[9.674693,52.428788],[9.677669,52.429032],[9.683022,52.429396],[9.691212,52.430141],[9.697698,52.430485],[9.700268,52.430477],[9.703106,52.430334],[9.70637,52.430038],[9.711215,52.42939],[9.717505,52.428447],[9.720106,52.428169],[9.724613,52.427555],[9.728669,52.427391],[9.729426,52.427449],[9.735357,52.427316],[9.737827,52.427338],[9.745511,52.427306],[9.750028,52.427179],[9.757123,52.427084],[9.762147,52.427058],[9.765941,52.42691],[9.769282,52.426966],[9.772387,52.42718],[9.778101,52.427711],[9.780884,52.428094],[9.783022,52.428463],[9.78534,52.428996],[9.791246,52.430174],[9.793308,52.430515],[9.795955,52.430822],[9.79808,52.430987],[9.801924,52.431023],[9.805747,52.430747],[9.808803,52.43028],[9.810845,52.429862],[9.814474,52.428884],[9.819088,52.427449],[9.822354,52.42633],[9.827024,52.42449],[9.830486,52.422831],[9.832852,52.421556],[9.839634,52.41751],[9.843604,52.414979],[9.845278,52.413854],[9.848263,52.412085],[9.852215,52.41017],[9.858649,52.407177],[9.859598,52.406798],[9.865354,52.404156],[9.866824,52.403429],[9.869818,52.402134],[9.872333,52.401256],[9.876346,52.40016],[9.878763,52.399589],[9.88173,52.399001],[9.885166,52.39863],[9.886914,52.398329],[9.887983,52.398368],[9.891619,52.398],[9.895289,52.39754],[9.898968,52.397143],[9.900174,52.396933],[9.902938,52.39663],[9.905153,52.396476],[9.913308,52.395608],[9.915689,52.395298],[9.919955,52.394834],[9.92619,52.394234],[9.936276,52.392941],[9.95016,52.391226],[9.953218,52.390897],[9.959778,52.390259],[9.964741,52.389971],[9.967256,52.389872],[9.977282,52.389328],[9.982727,52.389129],[9.987469,52.388856],[9.99351,52.388325],[9.99596,52.388004],[9.999285,52.387338],[10.010403,52.384762],[10.020804,52.382278],[10.029984,52.379709],[10.039193,52.377082],[10.040438,52.376782],[10.044018,52.375686],[10.048622,52.374344],[10.059479,52.371295],[10.062869,52.370255],[10.070127,52.368197],[10.072841,52.367534],[10.07724,52.366722],[10.082478,52.366091],[10.084942,52.365919],[10.090413,52.365412],[10.09758,52.36461],[10.101016,52.36431],[10.10479,52.36392],[10.107678,52.363704],[10.11098,52.363582],[10.123799,52.363469],[10.126901,52.363365],[10.13089,52.363119],[10.134193,52.362836],[10.136584,52.36254],[10.144177,52.361716],[10.149768,52.361198],[10.155802,52.360525],[10.160647,52.360076],[10.167655,52.359334],[10.174922,52.358638],[10.180228,52.357824],[10.183733,52.357049],[10.186413,52.356299],[10.189056,52.35543],[10.193089,52.353759],[10.200735,52.350114],[10.20496,52.348056],[10.209525,52.345997],[10.210426,52.345651],[10.214136,52.343991],[10.218592,52.342134],[10.223009,52.340364],[10.227046,52.339023],[10.231879,52.337777],[10.235438,52.337172],[10.237414,52.33691],[10.242028,52.336551],[10.243725,52.336472],[10.248964,52.336455],[10.256442,52.336592],[10.260369,52.336564],[10.264722,52.336433],[10.26645,52.336284],[10.268974,52.336204],[10.275415,52.335788],[10.280203,52.335536],[10.28847,52.335036],[10.291029,52.334993],[10.295396,52.335053],[10.298894,52.335287],[10.316701,52.337313],[10.320107,52.337736],[10.326219,52.338433],[10.333019,52.339242],[10.336951,52.339655],[10.340243,52.339899],[10.344498,52.340031],[10.347852,52.339981],[10.349524,52.339888],[10.358129,52.339626],[10.374958,52.339089],[10.388249,52.338022],[10.392194,52.337643],[10.397344,52.337253],[10.402151,52.336826],[10.405293,52.336616],[10.40987,52.336185],[10.412678,52.336],[10.416949,52.335512],[10.423298,52.334636],[10.431743,52.333218],[10.43533,52.33256],[10.438975,52.331826],[10.44504,52.330792],[10.449756,52.330027],[10.452261,52.329728],[10.454704,52.329317],[10.458329,52.328541],[10.469388,52.325925],[10.472968,52.325017],[10.477862,52.323879],[10.483805,52.322368],[10.488438,52.321324],[10.497659,52.319037],[10.507951,52.316603],[10.51239,52.315498],[10.516197,52.314683],[10.519414,52.314114],[10.52379,52.31352],[10.529052,52.313146],[10.534278,52.313151],[10.536196,52.313278],[10.55305,52.313092],[10.556366,52.313099],[10.564739,52.312992],[10.568754,52.312888],[10.574702,52.312624],[10.583386,52.311856],[10.59767,52.310704],[10.603339,52.310178],[10.605939,52.309974],[10.610487,52.309757],[10.615021,52.30972],[10.619521,52.309814],[10.62764,52.309775],[10.629627,52.309802],[10.634442,52.30975],[10.636315,52.309862],[10.641186,52.309773],[10.649185,52.30978],[10.654291,52.309755],[10.658345,52.309682],[10.6643,52.30947],[10.67019,52.309318],[10.680909,52.308911],[10.687348,52.308689],[10.693417,52.308519],[10.698303,52.308326],[10.704419,52.308147],[10.710938,52.308082],[10.722719,52.308306],[10.724878,52.30837],[10.729419,52.308662],[10.750038,52.310861],[10.758514,52.311789],[10.762114,52.312293],[10.765073,52.312647],[10.774582,52.313664],[10.7785,52.313881],[10.783339,52.313861],[10.787899,52.313588],[10.7927,52.31317],[10.794172,52.312914],[10.796777,52.312629],[10.80043,52.312331],[10.80846,52.311618],[10.811519,52.311416],[10.822317,52.310494],[10.826079,52.310066],[10.83036,52.309282],[10.834636,52.308232],[10.850041,52.303389],[10.853774,52.302191],[10.861295,52.299875],[10.865398,52.298336],[10.870016,52.296356],[10.874654,52.294446],[10.878993,52.292601],[10.880629,52.291986],[10.887026,52.289168],[10.887337,52.289091],[10.894309,52.286217],[10.897733,52.285073],[10.90004,52.284441],[10.903045,52.283725],[10.905684,52.283233],[10.909834,52.282667],[10.913717,52.282291],[10.921658,52.281453],[10.924222,52.281138],[10.926286,52.280791],[10.929655,52.280051],[10.932574,52.279227],[10.934358,52.278612],[10.941627,52.275542],[10.945805,52.273636],[10.949226,52.272143],[10.951032,52.271435],[10.953832,52.270521],[10.957941,52.269524],[10.960244,52.269142],[10.967052,52.268362],[10.970814,52.267663],[10.973604,52.266952],[10.976588,52.266005],[10.980643,52.264649],[10.983572,52.26355],[10.986301,52.262228],[10.989094,52.26053],[10.991077,52.259026],[10.992687,52.257574],[10.995871,52.254852],[10.998507,52.252105],[11.000151,52.250271],[11.002115,52.248379],[11.003789,52.246595],[11.005748,52.244965],[11.008258,52.243298],[11.008694,52.242842],[11.008858,52.242175],[11.009394,52.241551],[11.010313,52.240926],[11.010788,52.240383],[11.010663,52.239936],[11.009487,52.237499],[11.008903,52.236076],[11.008033,52.234797],[11.009877,52.23474],[11.011563,52.235412],[11.011622,52.235148],[11.010643,52.235062],[11.009756,52.234764],[11.007758,52.234755],[11.007054,52.235183],[11.003339,52.238226],[11.003024,52.238303],[11.001239,52.237362],[11.001003,52.236778],[10.99926,52.233968],[10.998834,52.232899],[10.999189,52.232846],[11.001134,52.231703],[11.001968,52.231485],[11.003617,52.231916],[11.004251,52.231903],[11.00503,52.231313],[11.006579,52.232861],[11.007785,52.233597],[11.007889,52.23426],[11.009081,52.236042],[11.010364,52.239247],[11.010829,52.240588],[11.009131,52.241709],[11.009083,52.242194],[11.010269,52.24225],[11.01291,52.241075],[11.014573,52.240246],[11.01675,52.238969],[11.019535,52.236806],[11.022053,52.234678],[11.023335,52.233717],[11.025314,52.232533],[11.027566,52.23145],[11.037256,52.22713],[11.041429,52.225415],[11.048858,52.222598],[11.050637,52.22186],[11.05138,52.221413],[11.053437,52.220643],[11.054106,52.220225],[11.055074,52.220094],[11.057064,52.219331],[11.059863,52.218493],[11.063718,52.217637],[11.066439,52.217238],[11.070202,52.216926],[11.077581,52.216543],[11.08546,52.215961],[11.08865,52.215445],[11.091786,52.214733],[11.093333,52.214277],[11.099046,52.212268],[11.101852,52.211447],[11.108648,52.209676],[11.112574,52.208834],[11.117007,52.208206],[11.121102,52.207905],[11.129634,52.20733],[11.133885,52.207107],[11.135878,52.207119],[11.143782,52.207712],[11.149722,52.208238],[11.15378,52.20846],[11.156296,52.208454],[11.159141,52.208329],[11.16109,52.208169],[11.165696,52.207611],[11.168437,52.207128],[11.171231,52.206498],[11.175482,52.205419],[11.181723,52.203933],[11.184136,52.203417],[11.188849,52.202678],[11.193244,52.202309],[11.202462,52.201836],[11.204107,52.201715],[11.209972,52.201457],[11.214207,52.201225],[11.21701,52.201146],[11.220175,52.200965],[11.22264,52.200894],[11.227524,52.200582],[11.232041,52.200441],[11.235587,52.200209],[11.242353,52.199502],[11.247715,52.198798],[11.253631,52.197979],[11.261899,52.196947],[11.266255,52.196341],[11.27656,52.194995],[11.291722,52.19295],[11.296281,52.192266],[11.30239,52.191534],[11.31322,52.190614],[11.322125,52.189751],[11.329981,52.189065],[11.338725,52.188268],[11.346816,52.187629],[11.348254,52.187461],[11.352031,52.187162],[11.355987,52.187002],[11.358346,52.186959],[11.364278,52.187024],[11.369828,52.187017],[11.380866,52.187082],[11.38803,52.187051],[11.395214,52.18718],[11.409711,52.187636],[11.41171,52.187737],[11.418722,52.187904],[11.424538,52.188099],[11.430368,52.188337],[11.434195,52.188236],[11.437102,52.187933],[11.439489,52.187595],[11.443464,52.186663],[11.445497,52.186104],[11.456906,52.18281],[11.462376,52.181306],[11.467006,52.179938],[11.47847,52.176695],[11.480423,52.176105],[11.482635,52.175306],[11.487467,52.173243],[11.500882,52.167716],[11.502828,52.167011],[11.505156,52.166272],[11.507624,52.165652],[11.509835,52.16523],[11.511736,52.164979],[11.514623,52.164718],[11.517316,52.164646],[11.520248,52.164737],[11.523188,52.165012],[11.528311,52.165731],[11.532546,52.166365],[11.534115,52.166548],[11.546606,52.168342],[11.547426,52.168232],[11.547731,52.167815],[11.546653,52.166844],[11.54595,52.166889],[11.545499,52.167506],[11.546132,52.173728],[11.546564,52.177076],[11.547265,52.179518],[11.54822,52.18178],[11.549996,52.185258],[11.550778,52.187016],[11.551215,52.188331],[11.551584,52.190185],[11.5517,52.192804],[11.551327,52.195467],[11.550553,52.197848],[11.549955,52.199152],[11.549887,52.199788],[11.550421,52.200552],[11.549996,52.201737],[11.557731,52.205885],[11.560923,52.207978],[11.562647,52.208637],[11.564387,52.209025],[11.567143,52.210721],[11.576715,52.214879],[11.579132,52.215831],[11.585781,52.218072],[11.58818,52.218686],[11.59079,52.218815],[11.602594,52.218295],[11.604614,52.218307],[11.604702,52.218741],[11.60529,52.219283],[11.606026,52.219267],[11.606495,52.218918],[11.606596,52.217867],[11.606587,52.213831],[11.606645,52.212222],[11.606589,52.209993],[11.60674,52.204226],[11.606718,52.20056],[11.606758,52.198041],[11.606864,52.196879],[11.607245,52.195477],[11.608058,52.193973],[11.608968,52.192826],[11.610183,52.19163],[11.611165,52.190868],[11.616601,52.187044],[11.618729,52.185493],[11.61884,52.184936],[11.618238,52.184711],[11.616742,52.184767],[11.61594,52.185322],[11.616295,52.185655],[11.6215,52.187103],[11.62415,52.188044],[11.626379,52.189023],[11.629381,52.190606],[11.631759,52.192053],[11.634388,52.193528],[11.6373,52.195309],[11.639861,52.196703],[11.643623,52.19896],[11.649352,52.202157],[11.658443,52.207366],[11.66609,52.211817],[11.670762,52.214452],[11.674109,52.216124],[11.677387,52.217376],[11.68086,52.218372],[11.683288,52.218868],[11.68622,52.219287],[11.697949,52.220321],[11.70927,52.221406],[11.712582,52.221762],[11.722653,52.222667],[11.726391,52.223054],[11.732966,52.223679],[11.73455,52.223893],[11.739473,52.224772],[11.745261,52.225896],[11.758377,52.228262],[11.761492,52.228738],[11.764496,52.229039],[11.768455,52.229096],[11.771533,52.228946],[11.778918,52.228434],[11.782011,52.228296],[11.7875,52.227901],[11.794935,52.227407],[11.805344,52.226758],[11.811627,52.226398],[11.823842,52.225581],[11.829809,52.225335],[11.83172,52.225413],[11.842907,52.226592],[11.848135,52.227286],[11.85374,52.227935],[11.859711,52.228663],[11.867682,52.229596],[11.871395,52.229932],[11.873429,52.230246],[11.875502,52.230465],[11.879195,52.230963],[11.886762,52.231892],[11.890313,52.232265],[11.895425,52.232887],[11.899133,52.233243],[11.903273,52.233584],[11.904559,52.233563],[11.90688,52.233865],[11.907719,52.233759],[11.909481,52.233935],[11.913812,52.234021],[11.915314,52.23412],[11.920511,52.234196],[11.924228,52.234354],[11.932956,52.234524],[11.934585,52.234612],[11.937852,52.234636],[11.945547,52.234869],[11.953239,52.235046],[11.956442,52.235207],[11.960912,52.235329],[11.962113,52.235289],[11.976106,52.235692],[11.980951,52.235769],[11.988189,52.235437],[11.995881,52.235163],[12.001797,52.234843],[12.008872,52.234545],[12.011982,52.234375],[12.013511,52.234371],[12.020879,52.233946],[12.025323,52.233725],[12.027293,52.233734],[12.032735,52.233381],[12.037071,52.233255],[12.041808,52.233059],[12.046048,52.232838],[12.052648,52.232542],[12.057244,52.232651],[12.061429,52.233082],[12.063429,52.233375],[12.077124,52.23512],[12.082429,52.235877],[12.08739,52.236546],[12.090774,52.236901],[12.0967,52.237652],[12.098422,52.237823],[12.102724,52.238384],[12.1058,52.238721],[12.109203,52.23924],[12.115241,52.239982],[12.116548,52.240184],[12.119582,52.240496],[12.120843,52.240727],[12.124286,52.241141],[12.133377,52.242312],[12.135469,52.242533],[12.148171,52.244172],[12.152031,52.244616],[12.154136,52.244953],[12.160512,52.245736],[12.161775,52.24594],[12.170374,52.246998],[12.173366,52.247462],[12.184143,52.248801],[12.188865,52.249284],[12.192312,52.249698],[12.194038,52.249992],[12.199796,52.250754],[12.201383,52.250898],[12.204129,52.251353],[12.211698,52.252229],[12.215642,52.252387],[12.218005,52.252386],[12.22077,52.252188],[12.228486,52.251466],[12.235884,52.250881],[12.240936,52.250398],[12.247681,52.249819],[12.271387,52.247726],[12.278052,52.247245],[12.28797,52.246633],[12.291002,52.246673],[12.293637,52.246888],[12.29578,52.247177],[12.298671,52.247729],[12.300996,52.24832],[12.303842,52.249299],[12.306682,52.250459],[12.314027,52.253548],[12.315523,52.254118],[12.323898,52.257636],[12.327526,52.259265],[12.331543,52.260903],[12.335558,52.262602],[12.338899,52.263886],[12.342984,52.264927],[12.345502,52.265357],[12.355824,52.266686],[12.3618,52.26754],[12.36481,52.26802],[12.367395,52.268341],[12.376277,52.269524],[12.386497,52.271032],[12.403699,52.273312],[12.404947,52.273426],[12.407373,52.273852],[12.418255,52.275256],[12.424134,52.276136],[12.434253,52.277484],[12.437144,52.27815],[12.439857,52.278966],[12.442138,52.279802],[12.443547,52.280416],[12.446234,52.281793],[12.447145,52.282403],[12.450927,52.284623],[12.455555,52.28745],[12.457938,52.28907],[12.460471,52.290939],[12.464158,52.294056],[12.470234,52.299381],[12.471281,52.300233],[12.475091,52.303621],[12.480651,52.308407],[12.484701,52.311945],[12.486404,52.313582],[12.489599,52.31689],[12.492719,52.32049],[12.496576,52.324746],[12.501664,52.330467],[12.503449,52.332358],[12.504418,52.33356],[12.506128,52.33543],[12.508527,52.337664],[12.51073,52.338982],[12.513686,52.340545],[12.51511,52.341162],[12.530552,52.346715],[12.535914,52.348497],[12.537465,52.348958],[12.542174,52.35],[12.545258,52.3505],[12.548395,52.350857],[12.552195,52.351098],[12.555845,52.351173],[12.569153,52.350958],[12.575731,52.350941],[12.577813,52.350967],[12.584994,52.350815],[12.587393,52.350818],[12.589107,52.350736],[12.593242,52.350713],[12.598431,52.35052],[12.603324,52.349955],[12.606847,52.349201],[12.609237,52.348835],[12.615312,52.347137],[12.61757,52.346383],[12.621069,52.345358],[12.625902,52.344111],[12.631583,52.342472],[12.640949,52.339916],[12.647262,52.338146],[12.652083,52.33676],[12.655939,52.335899],[12.65986,52.335405],[12.663294,52.335255],[12.667014,52.335355],[12.67216,52.335832],[12.673017,52.335838],[12.6762,52.336111],[12.681892,52.336694],[12.683765,52.336952],[12.690433,52.337628],[12.692411,52.337722],[12.693224,52.337923],[12.697066,52.338389],[12.697807,52.338397],[12.702054,52.338947],[12.709612,52.339701],[12.713599,52.340146],[12.717236,52.34026],[12.719666,52.340148],[12.72401,52.339811],[12.72766,52.339763],[12.734477,52.339553],[12.73845,52.339748],[12.740525,52.339934],[12.745863,52.340259],[12.753403,52.340831],[12.75884,52.341177],[12.761298,52.341282],[12.76415,52.341198],[12.767028,52.340954],[12.783684,52.339344],[12.788518,52.338945],[12.794461,52.338569],[12.799407,52.338222],[12.805366,52.337882],[12.807576,52.337677],[12.810408,52.337016],[12.812626,52.336087],[12.814185,52.335055],[12.816229,52.332775],[12.817551,52.331615],[12.819498,52.330487],[12.820857,52.329954],[12.823025,52.329299],[12.832046,52.326733],[12.843101,52.323494],[12.849481,52.321676],[12.856327,52.319661],[12.858769,52.31873],[12.863226,52.316587],[12.8673,52.314505],[12.868901,52.313769],[12.871044,52.312621],[12.872796,52.312001],[12.873952,52.311334],[12.87979,52.308313],[12.883066,52.306797],[12.884143,52.306372],[12.885727,52.305462],[12.887606,52.304535],[12.888709,52.303727],[12.889893,52.303077],[12.890886,52.302838],[12.891451,52.302485],[12.896097,52.300142],[12.899697,52.298494],[12.900114,52.298165],[12.904927,52.295867],[12.909353,52.2936],[12.910686,52.293076],[12.91129,52.292639],[12.914013,52.291329],[12.915669,52.290798],[12.917163,52.290522],[12.918733,52.290383],[12.920003,52.290431],[12.92262,52.290871],[12.925401,52.291872],[12.926736,52.292274],[12.931996,52.293534],[12.932345,52.29355],[12.938382,52.294955],[12.943028,52.29607],[12.947164,52.296903],[12.94941,52.297414],[12.950535,52.29778],[12.952881,52.298224],[12.959333,52.299807],[12.963889,52.300749],[12.971722,52.30258],[12.974618,52.303216],[12.975969,52.303437],[12.978271,52.303612],[12.980972,52.303618],[12.986637,52.3035],[12.988386,52.30353],[12.995892,52.303409],[12.999129,52.303405],[13.004431,52.30331],[13.011462,52.303283],[13.014435,52.302949],[13.016048,52.302614],[13.027411,52.299354],[13.03017,52.298606],[13.031442,52.298359],[13.03376,52.298161],[13.036903,52.298286],[13.038766,52.298656],[13.04024,52.299115],[13.044042,52.300478],[13.045346,52.300803],[13.046968,52.301047],[13.049098,52.301118],[13.056926,52.300861],[13.05959,52.300682],[13.065117,52.300527],[13.066858,52.300416],[13.07163,52.300273],[13.074071,52.300036],[13.077104,52.299482],[13.079451,52.299458],[13.081146,52.299726],[13.082411,52.300129],[13.083872,52.300901],[13.084814,52.301673],[13.088503,52.30716],[13.093963,52.315611],[13.094489,52.316289],[13.105649,52.326941],[13.106939,52.32799],[13.108106,52.328724],[13.11041,52.329768],[13.114753,52.331066],[13.117295,52.331763],[13.120502,52.332745],[13.122665,52.333337],[13.127895,52.334931],[13.131518,52.335865],[13.134847,52.337005],[13.136207,52.33773],[13.138131,52.339148],[13.139479,52.340478],[13.140446,52.342039],[13.141024,52.343357],[13.141173,52.344194],[13.140921,52.35256],[13.140922,52.354234],[13.1407,52.358554],[13.140782,52.360403],[13.141354,52.36193],[13.141869,52.362702],[13.143046,52.36384],[13.144263,52.364649],[13.147176,52.366287],[13.148958,52.367796],[13.149893,52.369334],[13.150275,52.371179],[13.150119,52.377472],[13.150175,52.379296],[13.150377,52.380308],[13.150802,52.38133],[13.152409,52.383789],[13.153781,52.386036],[13.15526,52.387915],[13.157533,52.389596],[13.158962,52.390255],[13.160848,52.390852],[13.162813,52.39136],[13.17506,52.394292],[13.179182,52.395638],[13.18142,52.396941],[13.182802,52.397966],[13.185998,52.400777],[13.187297,52.402078],[13.191473,52.405796],[13.194208,52.408301],[13.196107,52.409964],[13.196996,52.411104],[13.197443,52.412116],[13.197624,52.413905],[13.1969,52.416932],[13.19567,52.422399],[13.195311,52.423382],[13.194464,52.424267],[13.192809,52.425333],[13.19199,52.425986],[13.191436,52.426752],[13.191132,52.427758],[13.191806,52.429982],[13.192308,52.432236],[13.192799,52.433832],[13.193303,52.434628],[13.194373,52.435641],[13.196513,52.437255],[13.19878,52.439103],[13.201615,52.441294],[13.206749,52.445413],[13.20855,52.446792],[13.210583,52.448488],[13.224052,52.459126],[13.225359,52.460219],[13.230887,52.46452],[13.231987,52.465456],[13.240511,52.472096],[13.24662,52.477411],[13.248946,52.479551],[13.252156,52.482398],[13.254046,52.48384],[13.258123,52.487122],[13.262838,52.49084],[13.266995,52.494175],[13.269403,52.495991],[13.275735,52.501043],[13.277292,52.502033],[13.278356,52.502064],[13.279258,52.501816],[13.279746,52.501234],[13.279816,52.500591],[13.280348,52.499728],[13.281821,52.498133],[13.283338,52.496807],[13.284162,52.495555],[13.286055,52.495356],[13.286668,52.49465],[13.287382,52.494286],[13.290433,52.49385],[13.291303,52.493467],[13.294333,52.491773],[13.296278,52.490589],[13.298722,52.48886],[13.300674,52.487352],[13.303535,52.485338],[13.306003,52.483372],[13.306939,52.482813],[13.309863,52.48183],[13.312378,52.48021],[13.314225,52.479288],[13.316673,52.478503],[13.319292,52.478018],[13.321291,52.477888],[13.326583,52.47787],[13.330791,52.477814],[13.333799,52.478025],[13.337664,52.478508],[13.341244,52.478641],[13.34236,52.478618],[13.345759,52.477692],[13.347482,52.476113],[13.349774,52.474684],[13.351199,52.474092],[13.353105,52.473668],[13.354873,52.473545],[13.356379,52.473681],[13.358887,52.474104],[13.360457,52.474214],[13.362303,52.473986],[13.365123,52.472968],[13.367603,52.471818],[13.369349,52.471135],[13.374051,52.470268],[13.376943,52.470037],[13.380098,52.469891],[13.384976,52.469732],[13.387328,52.469562],[13.389589,52.469169],[13.391407,52.468618],[13.395338,52.46692],[13.398087,52.465989],[13.399947,52.465443],[13.401984,52.464606],[13.403215,52.463466],[13.403842,52.463351],[13.405925,52.463714],[13.417126,52.46477],[13.417907,52.464792],[13.421601,52.465195],[13.421443,52.465381],[13.421055,52.467289],[13.421365,52.467429],[13.424847,52.467801],[13.425319,52.467171],[13.427854,52.467522],[13.427883,52.468141],[13.43058,52.468446],[13.430787,52.468588],[13.429646,52.470834],[13.429206,52.471048],[13.429239,52.471628],[13.427187,52.475289],[13.425776,52.478635],[13.425748,52.479286],[13.425285,52.480561],[13.426075,52.480924],[13.433195,52.481746],[13.435859,52.483778],[13.437976,52.482691],[13.438575,52.483067]],[[13.438575,52.483067],[13.438575,52.483067]]]}}"

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(2);
	
	var _windowDimensions = __webpack_require__(6);
	
	var _windowDimensions2 = _interopRequireDefault(_windowDimensions);
	
	var _elements = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuHeight = _elements.articles[0].fixed.getElementsByClassName('language-switch')[0].getBoundingClientRect().bottom;
	
	var menuShortened = false;
	
	init();
	_windowDimensions2.default.onResize(init);
	
	function init() {
	    var shouldShorten = menuHeight > _windowDimensions2.default.height;
	
	    if (shouldShorten === menuShortened) {
	        return;
	    }
	
	    (0, _lodash.forEach)(_elements.articles, function (article) {
	        article.fixed.classList.toggle('is-short-menu', shouldShorten);
	    });
	
	    menuShortened = shouldShorten;
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';
	
	var leftButton = document.getElementsByClassName('mode-switch-bar-left')[0];
	var rightButton = document.getElementsByClassName('mode-switch-bar-right')[0];
	
	var nav = false;
	var map = false;
	
	window.addEventListener('hashchange', reset);
	
	rightButton.addEventListener('click', function () {
	    if (nav) {
	        return reset();
	    }
	
	    toggleMap(true);
	});
	
	leftButton.addEventListener('click', function () {
	    if (map) {
	        return reset();
	    }
	
	    toggleNav(true);
	});
	
	function reset() {
	    toggleMap(false);
	    toggleNav(false);
	}
	
	function toggleMap(toggle) {
	    map = toggle;
	    document.body.classList.toggle('is-showing-map', toggle);
	}
	
	function toggleNav(toggle) {
	    nav = toggle;
	    document.body.classList.toggle('is-showing-nav', toggle);
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** app.js
 **/